export interface LocaleEntry {
  id: string;
  en: string;
  fr: string;
  es: string;
  de: string;
  pt: string;
  it: string;
  tr: string;
  pl: string;
  ru: string;
  uk: string;
  ko: string;
  zh: string;
  ja: string;
}

export interface LocaleData {
  type: string;
  entries: LocaleEntry[];
}

export const localeData: LocaleData[] =
  [
    {
      "type": "items",
      "entries": [
        {
          "id": "AxeItem",
          "en": "Axe",
          "fr": "Hache",
          "es": "Hacha",
          "de": "Axt",
          "pt": "Machado",
          "it": "Ascia",
          "tr": "Balta",
          "pl": "Siekiera",
          "ru": "Топор",
          "uk": "Сокира",
          "ko": "도끼",
          "zh": "斧",
          "ja": "オノ"
        },
        {
          "id": "PickaxeItem",
          "en": "Pickaxe",
          "fr": "Pioche",
          "es": "Pico",
          "de": "Spitzhacke",
          "pt": "Picareta",
          "it": "Piccone",
          "tr": "Kazma",
          "pl": "Kilof",
          "ru": "Кирка",
          "uk": "Кайло",
          "ko": "곡괭이",
          "zh": "镐",
          "ja": "ツルハシ"
        },
        {
          "id": "ShovelItem",
          "en": "Shovel",
          "fr": "Pelle",
          "es": "Pala",
          "de": "Schaufel",
          "pt": "Pá",
          "it": "Pala",
          "tr": "Kürek",
          "pl": "Łopata",
          "ru": "Лопата",
          "uk": "Лопата",
          "ko": "삽",
          "zh": "铲",
          "ja": "シャベル"
        },
        {
          "id": "IronAxeItem",
          "en": "Iron Axe",
          "fr": "Hache en fer",
          "es": "Hacha de Hierro",
          "de": "Eisenaxt",
          "pt": "Machado de Ferro",
          "it": "Ascia di ferro",
          "tr": "Demir Balta",
          "pl": "Żelazna siekiera",
          "ru": "Железный топор",
          "uk": "Залізна сокира",
          "ko": "철 도끼",
          "zh": "铁斧",
          "ja": "鉄のオノ"
        },
        {
          "id": "IronHammerItem",
          "en": "Iron Hammer",
          "fr": "Marteau en fer",
          "es": "Martillo de Hierro",
          "de": "Eisenhammer",
          "pt": "Martelo de Ferro",
          "it": "Martello di ferro",
          "tr": "Demir Çekiç",
          "pl": "Żelazny młotek",
          "ru": "Железный молоток",
          "uk": "Залізний молоток",
          "ko": "철 망치",
          "zh": "铁锤",
          "ja": "鉄のハンマー"
        },
        {
          "id": "IronHoeItem",
          "en": "Iron Hoe",
          "fr": "Binette en fer",
          "es": "Azada de Hierro",
          "de": "Eisenhacke",
          "pt": "Enxada de Ferro",
          "it": "Zappa di ferro",
          "tr": "Demir Çapa",
          "pl": "Żelazna motyka",
          "ru": "Железная тяпка",
          "uk": "Залізна мотика",
          "ko": "철 괭이",
          "zh": "铁锄",
          "ja": "鉄のクワ"
        },
        {
          "id": "IronPickaxeItem",
          "en": "Iron Pickaxe",
          "fr": "Pioche en fer",
          "es": "Pico de Hierro",
          "de": "Eisenspitzhacke",
          "pt": "Picareta de Ferro",
          "it": "Piccone di ferro",
          "tr": "Demir Kazma",
          "pl": "Żelazny kilof",
          "ru": "Железная кирка",
          "uk": "Залізне кайло",
          "ko": "철 곡괭이",
          "zh": "铁镐",
          "ja": "鉄のツルハシ"
        },
        {
          "id": "IronShovelItem",
          "en": "Iron Shovel",
          "fr": "Pelle en fer",
          "es": "Pala de Hierro",
          "de": "Eisenschaufel",
          "pt": "Pá de Ferro",
          "it": "Pala di ferro",
          "tr": "Demir Kürek",
          "pl": "Żelazna łopata",
          "ru": "Железная лопата",
          "uk": "Залізна лопата",
          "ko": "철 삽",
          "zh": "铁铲",
          "ja": "鉄のシャベル"
        },
        {
          "id": "ModernAxeItem",
          "en": "Modern Axe",
          "fr": "Hache moderne",
          "es": "Hacha moderna",
          "de": "Moderne Axt",
          "pt": "Machado Moderno",
          "it": "Ascia moderna",
          "tr": "Modern Balta",
          "pl": "Nowoczesna Siekiera",
          "ru": "Современный топор",
          "uk": "Сучасна сокира",
          "ko": "현대식 도끼",
          "zh": "现代斧",
          "ja": "近代的なオノ"
        },
        {
          "id": "ModernHammerItem",
          "en": "Modern Hammer",
          "fr": "Marteau moderne",
          "es": "Martillo Moderno",
          "de": "Moderner Hammer",
          "pt": "Martelo Moderno",
          "it": "Martello moderno",
          "tr": "Modern Çekiç",
          "pl": "Nowoczesny Młotek",
          "ru": "Современный молоток",
          "uk": "Сучасний молоток",
          "ko": "현대식 망치",
          "zh": "现代锤",
          "ja": "近代的なハンマー"
        },
        {
          "id": "ModernHoeItem",
          "en": "Modern Hoe",
          "fr": "Binette moderne",
          "es": "Azada Moderna",
          "de": "Moderne Hacke",
          "pt": "Enxada Moderna",
          "it": "Zappa moderna",
          "tr": "Modern Çapa",
          "pl": "Nowoczesna Motyka",
          "ru": "Современная тяпка",
          "uk": "Сучасна мотика",
          "ko": "현대식 괭이",
          "zh": "现代锄",
          "ja": "近代的なクワ"
        },
        {
          "id": "ModernPickaxeItem",
          "en": "Modern Pickaxe",
          "fr": "Pioche moderne",
          "es": "Pico Moderno",
          "de": "Moderne Spitzhacke",
          "pt": "Picareta Moderna",
          "it": "Piccone moderno",
          "tr": "Modern Kazma",
          "pl": "Nowoczesny Kilof",
          "ru": "Современная кирка",
          "uk": "Сучасне кайло",
          "ko": "현대식 곡괭이",
          "zh": "现代镐",
          "ja": "近代的なツルハシ"
        },
        {
          "id": "ModernScytheItem",
          "en": "Modern Scythe",
          "fr": "Faucille moderne",
          "es": "Guadaña moderna",
          "de": "Moderne Sense",
          "pt": "Foice Moderna",
          "it": "Falce moderna",
          "tr": "Modern Tırpan",
          "pl": "Nowoczesna Kosa",
          "ru": "Современная коса",
          "uk": "Сучасна коса",
          "ko": "현대식 낫",
          "zh": "现代镰刀",
          "ja": "近代的なカマ"
        },
        {
          "id": "ModernShovelItem",
          "en": "Modern Shovel",
          "fr": "Pelle moderne",
          "es": "Pala Moderna",
          "de": "Moderne Schaufel",
          "pt": "Pá Moderna",
          "it": "Pala moderna",
          "tr": "Modern Kürek",
          "pl": "Nowoczesna Łopata",
          "ru": "Современная лопата",
          "uk": "Сучасна лопата",
          "ko": "현대식 삽",
          "zh": "现代铲",
          "ja": "近代的なシャベル"
        },
        {
          "id": "SteelAxeItem",
          "en": "Steel Axe",
          "fr": "Hache en acier",
          "es": "Hacha de Acero",
          "de": "Stahlaxt",
          "pt": "Machado de Aço",
          "it": "Ascia d\u0027acciaio",
          "tr": "Çelik Balta",
          "pl": "Stalowa siekiera",
          "ru": "Стальной топор",
          "uk": "Сталева сокира",
          "ko": "강철 도끼",
          "zh": "钢斧",
          "ja": "鋼のオノ"
        },
        {
          "id": "SteelHammerItem",
          "en": "Steel Hammer",
          "fr": "Marteau en acier",
          "es": "Martillo de Acero",
          "de": "Stahlhammer",
          "pt": "Martelo de Aço",
          "it": "Martello d\u0027acciaio",
          "tr": "Çelik Çekiç",
          "pl": "Stalowy młotek",
          "ru": "Стальной молоток",
          "uk": "Сталевий молоток",
          "ko": "강철 망치",
          "zh": "钢锤",
          "ja": "鋼のハンマー"
        },
        {
          "id": "SteelHoeItem",
          "en": "Steel Hoe",
          "fr": "Binette en acier",
          "es": "Azada de Acero",
          "de": "Stahlhacke",
          "pt": "Enxada de Aço",
          "it": "Zappa d\u0027acciaio",
          "tr": "Çelik Çapa",
          "pl": "Stalowa motyka",
          "ru": "Стальная тяпка",
          "uk": "Сталева мотика",
          "ko": "강철 괭이",
          "zh": "钢锄",
          "ja": "鋼のクワ"
        },
        {
          "id": "SteelPickaxeItem",
          "en": "Steel Pickaxe",
          "fr": "Pioche en acier",
          "es": "Pico de Acero",
          "de": "Stahlspitzhacke",
          "pt": "Picareta de Aço",
          "it": "Piccone d\u0027acciaio",
          "tr": "Çelik Kazma",
          "pl": "Stalowy kilof",
          "ru": "Стальная кирка",
          "uk": "Сталеве кайло",
          "ko": "강철 곡괭이",
          "zh": "钢镐",
          "ja": "鋼のツルハシ"
        },
        {
          "id": "SteelShovelItem",
          "en": "Steel Shovel",
          "fr": "Pelle en acier",
          "es": "Pala de Acero",
          "de": "Stahlschaufel",
          "pt": "Pá de Aço",
          "it": "Pala d\u0027acciaio",
          "tr": "Çelik Kürek",
          "pl": "Stalowa łopata",
          "ru": "Стальная лопата",
          "uk": "Сталева лопата",
          "ko": "강철 삽",
          "zh": "钢铲",
          "ja": "鋼のシャベル"
        },
        {
          "id": "StoneAxeItem",
          "en": "Stone Axe",
          "fr": "Hache en pierre",
          "es": "Hacha de piedra",
          "de": "Steinaxt",
          "pt": "Machado de Pedra",
          "it": "Ascia di pietra",
          "tr": "Taş Balta",
          "pl": "Kamienna siekiera",
          "ru": "Каменный топор",
          "uk": "Кам’яна сокира",
          "ko": "돌 도끼",
          "zh": "石斧",
          "ja": "石のオノ"
        },
        {
          "id": "StoneHammerItem",
          "en": "Stone Hammer",
          "fr": "Marteau en pierre",
          "es": "Martillo de Piedra",
          "de": "Steinhammer",
          "pt": "Martelo de Pedra",
          "it": "Martello di pietra",
          "tr": "Taş Çekiç",
          "pl": "Kamienny młotek",
          "ru": "Каменный молоток",
          "uk": "Кам’яний молоток",
          "ko": "돌 망치",
          "zh": "石锤",
          "ja": "石のハンマー"
        },
        {
          "id": "StonePickaxeItem",
          "en": "Stone Pickaxe",
          "fr": "Pioche en pierre",
          "es": "Pico de piedra",
          "de": "Steinspitzhacke",
          "pt": "Picareta de Pedra",
          "it": "Piccone di pietra",
          "tr": "Taş Kazma",
          "pl": "Kamienny kilof",
          "ru": "Каменная кирка",
          "uk": "Кам’яне кайло",
          "ko": "돌 곡괭이",
          "zh": "石镐",
          "ja": "石のツルハシ"
        },
        {
          "id": "WoodenHoeItem",
          "en": "Wooden Hoe",
          "fr": "Binette en bois",
          "es": "Azada de Madera",
          "de": "Holzhacke",
          "pt": "Enxada de Madeira",
          "it": "Zappa di legno",
          "tr": "Ahşap Çapa",
          "pl": "Drewniana motyka",
          "ru": "Деревянная тяпка",
          "uk": "Дерев’яна мотика",
          "ko": "나무 괭이",
          "zh": "木锄",
          "ja": "木のクワ"
        },
        {
          "id": "WoodenShovelItem",
          "en": "Wooden Shovel",
          "fr": "Pelle en bois",
          "es": "Pala de Madera",
          "de": "Holzschaufel",
          "pt": "Pá de Madeira",
          "it": "Pala di legno",
          "tr": "Ahşap Kürek",
          "pl": "Drewniana łopata",
          "ru": "Деревянная лопата",
          "uk": "Дерев’яна лопата",
          "ko": "나무 삽",
          "zh": "木铲",
          "ja": "木のシャベル"
        },
        {
          "id": "BowItem",
          "en": "Bow",
          "fr": "S\u0027incliner",
          "es": "Arco",
          "de": "Bogen",
          "pt": "Arco",
          "it": "Arco",
          "tr": "Yay",
          "pl": "Łuk",
          "ru": "Лук",
          "uk": "Лук",
          "ko": "활",
          "zh": "弓",
          "ja": "弓"
        },
        {
          "id": "AmanitaMushroomsItem",
          "en": "Amanita Mushrooms",
          "fr": "Amanites tue-mouches",
          "es": "Amanita Muscaria",
          "de": "Fliegenpilze",
          "pt": "Cogumelos amanita",
          "it": "Ovoli Malefici",
          "tr": "Amanita Mantarı",
          "pl": "Muchomor czerwony",
          "ru": "Мухоморы",
          "uk": "Мухомори",
          "ko": "광대버섯",
          "zh": "鹅膏菌",
          "ja": "ベニテングダケ"
        },
        {
          "id": "BeetItem",
          "en": "Beet",
          "fr": "Betterave",
          "es": "Remolacha",
          "de": "Rübe",
          "pt": "Beterraba",
          "it": "Barbabietola",
          "tr": "Pancar",
          "pl": "Burak",
          "ru": "Свёкла",
          "uk": "Буряк",
          "ko": "사탕무",
          "zh": "甜菜",
          "ja": "ビート"
        },
        {
          "id": "CornItem",
          "en": "Corn",
          "fr": "Maïs",
          "es": "Maíz",
          "de": "Mais",
          "pt": "Milho",
          "it": "Mais",
          "tr": "Mısır",
          "pl": "Kukurydza",
          "ru": "Кукуруза",
          "uk": "Кукурудза",
          "ko": "옥수수",
          "zh": "玉米",
          "ja": "トウモロコシ"
        },
        {
          "id": "CriminiMushroomsItem",
          "en": "Crimini Mushrooms",
          "fr": "Champignons de Paris",
          "es": "Champiñón Común",
          "de": "Champignons",
          "pt": "Cogumelos champignon",
          "it": "Funghi Champignon",
          "tr": "Krimini Mantarı",
          "pl": "Pieczarki",
          "ru": "Шампиньоны",
          "uk": "Печериці",
          "ko": "양송이버섯",
          "zh": "香啡菇",
          "ja": "マッシュルーム"
        },
        {
          "id": "FiddleheadsItem",
          "en": "Fiddleheads",
          "fr": "Crosses de fougère",
          "es": "Brotes de helecho",
          "de": "Farnspitzen",
          "pt": "Broto de samambaia",
          "it": "Fiddleheads",
          "tr": "Eğrelti Otları",
          "pl": "Pędy Paproci",
          "ru": "Побеги папоротника",
          "uk": "Папороть",
          "ko": "고사리",
          "zh": "蕨菜",
          "ja": "ワラビ"
        },
        {
          "id": "FireweedShootsItem",
          "en": "Fireweed Shoots",
          "fr": "Pousses d\u0027épilobe",
          "es": "Brotes de Epilobio",
          "de": "Weidenröschenwurzel",
          "pt": "Botão de fireweed",
          "it": "Germogli di Camenerio",
          "tr": "Yakı Otu Filizleri",
          "pl": "Pędy Wierzbówki",
          "ru": "Побеги Иван-чая",
          "uk": "Пагони дикого льону",
          "ko": "분홍바늘꽃 순",
          "zh": "柳兰芽",
          "ja": "ヤナギランの新芽"
        },
        {
          "id": "GiantCactusFruitItem",
          "en": "Giant Cactus Fruit",
          "fr": "Fruit de saguaro",
          "es": "Fruta de cactus gigante",
          "de": "Riesige Kaktusfrucht",
          "pt": "Fruto de cacto gigante",
          "it": "Frutti del cactus gigante",
          "tr": "Dev Kaktüs Meyvesi",
          "pl": "Owoc Saguaro",
          "ru": "Плод сагуаро",
          "uk": "Плід сагуаро",
          "ko": "백년초",
          "zh": "巨型仙人掌果实",
          "ja": "巨大サボテンの実"
        },
        {
          "id": "HuckleberriesItem",
          "en": "Huckleberries",
          "fr": "Myrtilles",
          "es": "Arándanos",
          "de": "Heidelbeeren",
          "pt": "Mirtilos",
          "it": "Mirtilli",
          "tr": "Yabanmersinleri",
          "pl": "Czarna Jagoda",
          "ru": "Черника",
          "uk": "Чорниці",
          "ko": "월귤",
          "zh": "越橘",
          "ja": "ハックルベリー"
        },
        {
          "id": "PricklyPearFruitItem",
          "en": "Prickly Pear Fruit",
          "fr": "Figue de Barbarie",
          "es": "Fruta de higo chumbo",
          "de": "Kaktusfeige",
          "pt": "Fruta de pera espinhosa",
          "it": "Frutto di fico",
          "tr": "Firavuninciri Mevyesi",
          "pl": "Owoc opuncji",
          "ru": "Плод опунции",
          "uk": "Плід опунції",
          "ko": "천년초 열매",
          "zh": "仙人球果实",
          "ja": "ウチワサボテンの果実"
        },
        {
          "id": "TomatoItem",
          "en": "Tomato",
          "fr": "Tomate",
          "es": "Tomate",
          "de": "Tomate",
          "pt": "Tomate",
          "it": "Pomodoro",
          "tr": "Domates",
          "pl": "Pomidor",
          "ru": "Помидор",
          "uk": "Помідор",
          "ko": "토마토",
          "zh": "番茄",
          "ja": "トマト"
        },
        {
          "id": "WheatItem",
          "en": "Wheat",
          "fr": "Blé",
          "es": "Trigo",
          "de": "Weizen",
          "pt": "Trigo",
          "it": "Grano",
          "tr": "Buğday",
          "pl": "Pszenica",
          "ru": "Пшеница",
          "uk": "Пшениця",
          "ko": "밀",
          "zh": "小麦",
          "ja": "小麦"
        },
        {
          "id": "PlantFibersItem",
          "en": "Plant Fibers",
          "fr": "Fibres végétales",
          "es": "Fibras vegetales",
          "de": "Pflanzenfasern",
          "pt": "Fibras de Plantas",
          "it": "Fibra Vegetale",
          "tr": "Bitki Lifi",
          "pl": "Włókna roślinne",
          "ru": "Растительные волокна",
          "uk": "Рослинні волокна",
          "ko": "식물 섬유",
          "zh": "植物纤维",
          "ja": "植物繊維"
        },
        {
          "id": "AcornItem",
          "en": "Acorn",
          "fr": "Gland",
          "es": "Bellota",
          "de": "Eichel",
          "pt": "Bolota",
          "it": "Ghianda",
          "tr": "Palamut",
          "pl": "Żołądź",
          "ru": "Жёлудь",
          "uk": "Жолудь",
          "ko": "도토리",
          "zh": "橡子",
          "ja": "ドングリ"
        },
        {
          "id": "BeansItem",
          "en": "Beans",
          "fr": "Haricots",
          "es": "Frijoles",
          "de": "Bohnen",
          "pt": "Feijões",
          "it": "Fagioli",
          "tr": "Fasulye",
          "pl": "Fasola",
          "ru": "Бобы",
          "uk": "Квасоля",
          "ko": "콩",
          "zh": "豆",
          "ja": "豆"
        },
        {
          "id": "BeetSeedItem",
          "en": "Beet Seed",
          "fr": "Graine de betterave",
          "es": "Semilla de remolacha",
          "de": "Samen (Rote Bete)",
          "pt": "Semente de Beterraba",
          "it": "Seme di barbabietola",
          "tr": "Pancar Tohumu",
          "pl": "Nasiona buraka",
          "ru": "Семечко свёклы",
          "uk": "Насіння буряка",
          "ko": "사탕무 씨앗",
          "zh": "甜菜种子",
          "ja": "ビートの種"
        },
        {
          "id": "BirchSeedItem",
          "en": "Birch Seed",
          "fr": "Graine de bouleau",
          "es": "Semilla de abedul",
          "de": "Samen (Birke)",
          "pt": "Semente de Bétula",
          "it": "Seme di betulla",
          "tr": "Huş Ağacı Tohumu",
          "pl": "Nasiona Brzozy",
          "ru": "Семечко берёзы",
          "uk": "Насіння берези",
          "ko": "자작나무 씨앗",
          "zh": "桦树种子",
          "ja": "白樺の種"
        },
        {
          "id": "BunchgrassSeedItem",
          "en": "Bunchgrass Seed",
          "fr": "Graine de graminée",
          "es": "Semilla de tussok",
          "de": "Samen (Büschelgras)",
          "pt": "Semente de Capim",
          "it": "Seme di Erbaccia",
          "tr": "Çimen Topağı Tohumu",
          "pl": "Nasiona Trawy kępiastej",
          "ru": "Семечко осоки",
          "uk": "Насіння купчастої трави",
          "ko": "다발풀 씨앗",
          "zh": "丛生禾草种子",
          "ja": "カヤツリグサの種"
        },
        {
          "id": "CamasBulbItem",
          "en": "Camas Bulb",
          "fr": "Bulbe de camassia",
          "es": "Bulbo de camasia",
          "de": "Prärielilienzwiebel",
          "pt": "Bulbo de Camassia",
          "it": "Bulbo di Camassia",
          "tr": "Camas Soğanı",
          "pl": "Bulwa Kamasji",
          "ru": "Луковица камассии",
          "uk": "Цибулина камасії",
          "ko": "카마스 구근",
          "zh": "卡马斯球茎",
          "ja": "カマシアの球根"
        },
        {
          "id": "CedarSeedItem",
          "en": "Cedar Seed",
          "fr": "Graine de cèdre",
          "es": "Semilla de Cedro",
          "de": "Samen (Zeder)",
          "pt": "Semente de Cedro",
          "it": "Seme di cedro",
          "tr": "Sedir Tohumu",
          "pl": "Nasiona Cedru",
          "ru": "Семечко кедра",
          "uk": "Кeдрове насіння",
          "ko": "삼나무 씨앗",
          "zh": "雪松种子",
          "ja": "杉の種"
        },
        {
          "id": "CornSeedItem",
          "en": "Corn Seed",
          "fr": "Graine de maïs",
          "es": "Semilla de Maíz",
          "de": "Samen (Mais)",
          "pt": "Semente de Milho",
          "it": "Semi di Mais",
          "tr": "Mısır Tohumu",
          "pl": "Nasiona Kukurydzy",
          "ru": "Семечко кукурузы",
          "uk": "Насіння кукурудзи",
          "ko": "옥수수 씨앗",
          "zh": "玉米种子",
          "ja": "トウモロコシの種"
        },
        {
          "id": "CreosoteBushSeedItem",
          "en": "Creosote Bush Seed",
          "fr": "Graine de créosotier",
          "es": "Semilla de planta gobernadora",
          "de": "Samen (Kreosotbusch)",
          "pt": "Semente de Arbusto de Creosoto",
          "it": "Seme di Cespuglio di Creosoto",
          "tr": "Katran Ruhu Çalısı Tohumu",
          "pl": "Nasiona Trójnika Pustynnego",
          "ru": "Семечко ларреи",
          "uk": "Насіння креозотового куща",
          "ko": "크레오소트 덤불 씨앗",
          "zh": "灌木种子",
          "ja": "クレオソートブッシュの種"
        },
        {
          "id": "CriminiMushroomSporesItem",
          "en": "Crimini Mushroom Spores",
          "fr": "Spores de champignon de Paris",
          "es": "Esporas de Champiñón Común",
          "de": "Sporen (Champignon)",
          "pt": "Esporos de Cogumelo Champignon",
          "it": "Spore di champignon",
          "tr": "Crimini Mantarı Sporları",
          "pl": "Zarodniki Pieczarki",
          "ru": "Споры шампиньонов",
          "uk": "Спори печериць",
          "ko": "양송이버섯 포자",
          "zh": "香啡菇孢子",
          "ja": "マッシュルームの胞子"
        },
        {
          "id": "FernSporeItem",
          "en": "Fern Spore",
          "fr": "Spores de fougère",
          "es": "Espora de Helecho",
          "de": "Sporen (Farn)",
          "pt": "Esporos de Samambaia",
          "it": "Spora di felce",
          "tr": "Füjer Sporu",
          "pl": "Zarodniki Paproci",
          "ru": "Спора папоротника",
          "uk": "Спори папороті",
          "ko": "고사리 포자",
          "zh": "蕨类孢子",
          "ja": "シダの胞子"
        },
        {
          "id": "FireweedSeedItem",
          "en": "Fireweed Seed",
          "fr": "Graine d\u0027épilobe",
          "es": "Semilla de Epilobio",
          "de": "Samen (Weidenröschen)",
          "pt": "Semente de Fireweed",
          "it": "Seme di Camenerio",
          "tr": "Yakı Otu Tohumu",
          "pl": "Nasiona Wierzbówki",
          "ru": "Семечко иван-чая",
          "uk": "Насіння дикого льону",
          "ko": "분홍바늘꽃 씨앗",
          "zh": "柳兰种子",
          "ja": "ヤナギランの種"
        },
        {
          "id": "FirSeedItem",
          "en": "Fir Seed",
          "fr": "Graine de sapin",
          "es": "Semilla de Abeto",
          "de": "Samen (Tanne)",
          "pt": "Semente de Abeto",
          "it": "Seme di abete",
          "tr": "Köknar Tohumu",
          "pl": "Nasiona Jodły",
          "ru": "Семечко пихты",
          "uk": "Насіння ялиці",
          "ko": "전나무 씨앗",
          "zh": "杉树种子",
          "ja": "モミの種"
        },
        {
          "id": "GrassSeedItem",
          "en": "Grass Seed",
          "fr": "Graine d\u0027herbe commune",
          "es": "Semilla de Pasto",
          "de": "Samen (Gras)",
          "pt": "Semente de Grama",
          "it": "Seme di Erba",
          "tr": "Çim Tohumu",
          "pl": "Nasiona Trawy",
          "ru": "Семечко травы",
          "uk": "Насіння трави",
          "ko": "잔디 씨앗",
          "zh": "草种子",
          "ja": "雑草の種"
        },
        {
          "id": "HuckleberrySeedItem",
          "en": "Huckleberry Seed",
          "fr": "Graine de myrtille",
          "es": "Semilla de Arándano",
          "de": "Samen (Heidelbeere)",
          "pt": "Semente de Mirtilo",
          "it": "Seme di Mirtillo",
          "tr": "Yabanmersini Tohumu",
          "pl": "Nasiona Jagody",
          "ru": "Семечко черники",
          "uk": "Насіння чорниць",
          "ko": "월귤 씨앗",
          "zh": "越橘种子",
          "ja": "ハックルベリーの種"
        },
        {
          "id": "PricklyPearSeedItem",
          "en": "Prickly Pear Seed",
          "fr": "Graine de figue de Barbarie",
          "es": "Semilla de higo chumbo",
          "de": "Samen (Kaktusfeigen)",
          "pt": "Semente de Pera Espinhosa",
          "it": "Seme di fico",
          "tr": "Firavuninciri Tohumu",
          "pl": "Nasiona opuncji",
          "ru": "Семечко опунции",
          "uk": "Насіння опунції",
          "ko": "천년초 씨앗",
          "zh": "仙人球种子",
          "ja": "ウチワサボテンの種"
        },
        {
          "id": "RiceItem",
          "en": "Rice",
          "fr": "Riz",
          "es": "Arroz",
          "de": "Reis",
          "pt": "Arroz",
          "it": "Riso",
          "tr": "Pirinç",
          "pl": "Ryż",
          "ru": "Рис",
          "uk": "Рис",
          "ko": "쌀",
          "zh": "米",
          "ja": "米"
        },
        {
          "id": "TomatoSeedItem",
          "en": "Tomato Seed",
          "fr": "Graine de tomate",
          "es": "Semilla de tomate",
          "de": "Samen (Tomaten)",
          "pt": "Semente de Tomate",
          "it": "Semi di Pomodori",
          "tr": "Domates Tohumu",
          "pl": "Nasiona Pomidora",
          "ru": "Семечко помидора",
          "uk": "Насіння помідору",
          "ko": "토마토 씨앗",
          "zh": "番茄种子",
          "ja": "トマトの種"
        },
        {
          "id": "WheatSeedItem",
          "en": "Wheat Seed",
          "fr": "Graine de blé",
          "es": "Semilla de Trigo",
          "de": "Samen (Weizen)",
          "pt": "Semente de Trigo",
          "it": "Seme di grano",
          "tr": "Buğday Tohumu",
          "pl": "Nasiona Pszenicy",
          "ru": "Семечко пшеницы",
          "uk": "Насіння пшениці",
          "ko": "밀 씨앗",
          "zh": "小麦种子",
          "ja": "小麦の種"
        },
        {
          "id": "LeatherHideItem",
          "en": "Leather Hide",
          "fr": "Cuir",
          "es": "Cuero",
          "de": "Leder",
          "pt": "Pele de Couro",
          "it": "Cuoio",
          "tr": "Deri Post",
          "pl": "Skóra",
          "ru": "Кожа",
          "uk": "Шкіра",
          "ko": "가죽",
          "zh": "皮革",
          "ja": "皮革"
        },
        {
          "id": "ClothItem",
          "en": "Cloth",
          "fr": "Tissu",
          "es": "Tela",
          "de": "Stoff",
          "pt": "Tecido",
          "it": "Stoffa",
          "tr": "Kumaş",
          "pl": "Tkanina",
          "ru": "Ткань",
          "uk": "Тканина",
          "ko": "천",
          "zh": "布料",
          "ja": "布"
        },
        {
          "id": "CelluloseFiberItem",
          "en": "Cellulose Fiber",
          "fr": "Fibres de cellulose",
          "es": "Fibra de celulosa",
          "de": "Zellulosefaser",
          "pt": "Fibra de Celulose",
          "it": "Fibra di Cellulosa",
          "tr": "Selüloz Lifi",
          "pl": "Włókna celulozowe",
          "ru": "Целлюлозное волокно",
          "uk": "Клітковина",
          "ko": "셀룰로오스 섬유",
          "zh": "人造纤维",
          "ja": "セルロース繊維"
        },
        {
          "id": "FurPeltItem",
          "en": "Fur Pelt",
          "fr": "Fourrure",
          "es": "Pelaje",
          "de": "Fellpelz",
          "pt": "Peles Felpudas",
          "it": "Pelliccia",
          "tr": "Deri Kürk",
          "pl": "Futro",
          "ru": "Мех",
          "uk": "Хутро",
          "ko": "모피",
          "zh": "毛皮",
          "ja": "毛皮"
        },
        {
          "id": "CompositeFillerItem",
          "en": "Composite Filler",
          "fr": "Charge renforçante composite",
          "es": "Relleno de Compuesto",
          "de": "Füller aus Verbundstoffen",
          "pt": "Enchimento Composto",
          "it": "Riempitivo Misto",
          "tr": "Karma Gübre",
          "pl": "Wypełniacz kompozytowy",
          "ru": "Композитный наполнитель",
          "uk": "Композитний наповнювач",
          "ko": "합성 보충제",
          "zh": "复合填料",
          "ja": "複合フィラー"
        },
        {
          "id": "HuckleberryExtractItem",
          "en": "Huckleberry Extract",
          "fr": "Extrait de myrtilles",
          "es": "Extracto de Arándano",
          "de": "Heidelbeerextrakt",
          "pt": "Extrato de mirtilo",
          "it": "Estratto di Mirtillo",
          "tr": "Yabanmersini Özü",
          "pl": "Ekstrakt z Czarnej Jagody",
          "ru": "Экстракт черники",
          "uk": "Екстракт чорниці",
          "ko": "월귤 추출물",
          "zh": "越橘汁",
          "ja": "ハックルベリーエキス"
        },
        {
          "id": "BerryExtractFertilizerItem",
          "en": "Berry Extract Fertilizer",
          "fr": "Engrais à l\u0027extrait de baies",
          "es": "Fertilizante de Extracto de Baya",
          "de": "Dünger aus Beerenextrakt",
          "pt": "Fertilizante de Extrato de Baga",
          "it": "Fertilizzante all’estratto di bacca",
          "tr": "Dut Özü Gübresi",
          "pl": "Nawóz z ekstraktu jagodowego",
          "ru": "Удобрение из ягодного экстракта",
          "uk": "Добриво з ягідного екстракту",
          "ko": "월귤 추출물 비료",
          "zh": "浆果萃取化肥",
          "ja": "ハックルベリーエキスの肥料"
        },
        {
          "id": "PulpFillerItem",
          "en": "Pulp Filler",
          "fr": "Charge renforçante boisée",
          "es": "Relleno de Pulpa",
          "de": "Füller aus Holzspähnen",
          "pt": "Enchimento de Polpa",
          "it": "Polpa Riempitiva",
          "tr": "Odun Hamuru Gübresi",
          "pl": "Wypełniacz z miazgi",
          "ru": "Древесный наполнитель",
          "uk": "Наповнювач із деревини",
          "ko": "펄프 보충제",
          "zh": "纸浆填料",
          "ja": "パルプフィラー"
        },
        {
          "id": "ScrapMeatItem",
          "en": "Scrap Meat",
          "fr": "Restes de viande",
          "es": "Carne de desechos",
          "de": "Fleischreste",
          "pt": "Sobras de carne",
          "it": "Carne di scarto",
          "tr": "Parça Et",
          "pl": "Ochłapy Mięsa",
          "ru": "Мясные обрезки",
          "uk": "Обрізки м’яса",
          "ko": "고기 조각",
          "zh": "碎肉",
          "ja": "くず肉"
        },
        {
          "id": "BloodMealFertilizerItem",
          "en": "Blood Meal Fertilizer",
          "fr": "Engrais à base de farine de sang",
          "es": "Fertilizante de Harina de Sangre",
          "de": "Dünger aus Blutmahl",
          "pt": "Fertilizante de Sangue em Pó",
          "it": "Fertilizzante alla farina di sangue",
          "tr": "Kan Unu Gübresi",
          "pl": "Nawóz z mączki krwistej",
          "ru": "Удобрение из кровяной муки",
          "uk": "Добриво з кров’яного борошна",
          "ko": "혈분비료",
          "zh": "血粉化肥",
          "ja": "血粉の肥料"
        },
        {
          "id": "FiberFillerItem",
          "en": "Fiber Filler",
          "fr": "Charge renforçante fibreuse",
          "es": "Relleno de Fibra",
          "de": "Füller aus Fasern",
          "pt": "Enchimento de Fibra",
          "it": "Fibra Riempitiva",
          "tr": "Lif Tütünü",
          "pl": "Wypełniacz włóknowy",
          "ru": "Волоконный наполнитель",
          "uk": "Наповнювач із волокна",
          "ko": "식물섬유 보충제",
          "zh": "纤维填料",
          "ja": "繊維フィラー"
        },
        {
          "id": "CharredCamasBulbItem",
          "en": "Charred Camas Bulb",
          "fr": "Bulbe de camassia carbonisé",
          "es": "Bulbo de camasia carbonizado",
          "de": "Gegrillte Prärielilienzwiebel",
          "pt": "Bulbo de camassia tostado",
          "it": "Bulbo di Camassia Carbonizzato",
          "tr": "Pişmiş Camas Soğanı",
          "pl": "Opiekana Bulwa Kamasji",
          "ru": "Обжаренная луковица камассии",
          "uk": "Обвуглена цибулина камасії",
          "ko": "그슬린 카마스 구근",
          "zh": "烧焦的卡马斯球茎",
          "ja": "焦げたカマシアの球根"
        },
        {
          "id": "CamasAshFertilizerItem",
          "en": "Camas Ash Fertilizer",
          "fr": "Engrais à la cendre de camassia",
          "es": "Fertilizante de cenizas de camasia",
          "de": "Dünger aus Prärielilienasche",
          "pt": "Fertilizante de Cinzas de Camassia",
          "it": "Fertilizzante di Polvere di Camassia",
          "tr": "Camas Karbonatlı Gübre",
          "pl": "Nawóz z popiołu Kamasji",
          "ru": "Удобрение из пепла камассии",
          "uk": "Добриво з попелу камасії",
          "ko": "카마스 재 비료",
          "zh": "卡马斯灰化肥",
          "ja": "カマシア灰の肥料"
        },
        {
          "id": "DirtItem",
          "en": "Dirt",
          "fr": "Terre",
          "es": "Tierra",
          "de": "Erde",
          "pt": "Terra",
          "it": "Terra",
          "tr": "Toprak",
          "pl": "Ziemia",
          "ru": "Земля",
          "uk": "Земля",
          "ko": "흙",
          "zh": "泥土",
          "ja": "土"
        },
        {
          "id": "HideAshFertilizerItem",
          "en": "Hide Ash Fertilizer",
          "fr": "Engrais à base de cendres de peaux",
          "es": "Fertilizante de Ceniza de Cuero",
          "de": "Dünger aus Lederasche",
          "pt": "Fertilizante de Cinzas de Couro",
          "it": "Nascondi Cenere Fertilizzante",
          "tr": "Karbonatlı Post Gübresi",
          "pl": "Nawóz z popiołu skórzanego",
          "ru": "Зольное удобрение из шкуры",
          "uk": "Добриво з попелу від згорілої шкіри",
          "ko": "가죽 재 비료",
          "zh": "皮灰化肥",
          "ja": "皮灰の肥料"
        },
        {
          "id": "PeltFertilizerItem",
          "en": "Pelt Fertilizer",
          "fr": "Engrais à base de fourrures",
          "es": "Fertilizante de Pieles",
          "de": "Dünger aus Pelz",
          "pt": "Fertilizante de Pele",
          "it": "Fertilizzante per Pelle",
          "tr": "Deri Gübresi",
          "pl": "Nawóz z futer",
          "ru": "Удобрение из меха",
          "uk": "Добриво з хутра",
          "ko": "모피 비료",
          "zh": "毛皮化肥",
          "ja": "毛皮の肥料"
        },
        {
          "id": "StoneItem",
          "en": "Stone",
          "fr": "Pierre",
          "es": "Piedra",
          "de": "Stein",
          "pt": "Pedra",
          "it": "Pietra",
          "tr": "Taş",
          "pl": "Kamień",
          "ru": "Камень",
          "uk": "Камінь",
          "ko": "돌",
          "zh": "石头",
          "ja": "石"
        },
        {
          "id": "PhosphateFertilizerItem",
          "en": "Phosphate Fertilizer",
          "fr": "Engrais à base de phosphate",
          "es": "Fertilizante de Fosfato",
          "de": "Dünger mit Phosphat",
          "pt": "Fertilizante de Fosfato",
          "it": "Fertilizzante di Fosfato",
          "tr": "Fosfatlı Gübre",
          "pl": "Nawóz fosforowy",
          "ru": "Фосфорное удобрение",
          "uk": "Фосфорні добрива",
          "ko": "인산염 비료",
          "zh": "磷肥",
          "ja": "リン酸肥料"
        },
        {
          "id": "WoodPulpItem",
          "en": "Wood Pulp",
          "fr": "Copeaux de bois",
          "es": "Pulpa de madera",
          "de": "Holzspan",
          "pt": "Polpa de Madeira",
          "it": "Truciolo di Legno",
          "tr": "Odun Hamuru",
          "pl": "Ścier drzewny",
          "ru": "Древесная масса",
          "uk": "Деревина",
          "ko": "목재 펄프",
          "zh": "木浆",
          "ja": "小枝"
        },
        {
          "id": "AcornPowderItem",
          "en": "Acorn Powder",
          "fr": "Poudre de gland",
          "es": "Polvo de Bellota",
          "de": "Eichelpulver",
          "pt": "Pó de bolota",
          "it": "Polvere di ghianda",
          "tr": "Palamut Tozu",
          "pl": "Mączka z żołędzi",
          "ru": "Мука из желудей",
          "uk": "Порошок із жолудів",
          "ko": "도토리 분말",
          "zh": "橡子粉",
          "ja": "ドングリの粉"
        },
        {
          "id": "RawMeatItem",
          "en": "Raw Meat",
          "fr": "Viande crue",
          "es": "Carne Cruda",
          "de": "Rohes Fleisch",
          "pt": "Carne crua",
          "it": "Carne Cruda",
          "tr": "Çiğ Et",
          "pl": "Surowe mięso",
          "ru": "Сырое мясо",
          "uk": "Сире м’ясо",
          "ko": "생고기",
          "zh": "生肉",
          "ja": "生肉"
        },
        {
          "id": "BakedMeatItem",
          "en": "Baked Meat",
          "fr": "Viande au four",
          "es": "Carne Horneada",
          "de": "Gebackenes Fleisch",
          "pt": "Carne assada",
          "it": "Carne al forno",
          "tr": "Kavrulmuş Et",
          "pl": "Pieczone mięso",
          "ru": "Запечённое мясо",
          "uk": "Запечене м’ясо",
          "ko": "구운 고기",
          "zh": "熟肉",
          "ja": "焼いた肉"
        },
        {
          "id": "RawRoastItem",
          "en": "Raw Roast",
          "fr": "Rôti cru",
          "es": "Asado Crudo",
          "de": "Roher Braten",
          "pt": "Copa crua",
          "it": "Arrosto Crudo",
          "tr": "Çiğ Et Parçası",
          "pl": "Surowa pieczeń",
          "ru": "Мясо для жаркого",
          "uk": "Сира печеня",
          "ko": "안 익은 구이용 고기",
          "zh": "未烤肉",
          "ja": "生のロースト"
        },
        {
          "id": "BakedRoastItem",
          "en": "Baked Roast",
          "fr": "Rôti au four",
          "es": "Asado Horneado",
          "de": "Gebackener Braten",
          "pt": "Copa assada",
          "it": "Arrosto al forno",
          "tr": "Kavrulmuş Rosto",
          "pl": "Zapiekana pieczeń",
          "ru": "Запечённое жаркое",
          "uk": "Запечена печеня",
          "ko": "구운 구이용 고기",
          "zh": "熟烤肉",
          "ja": "焼きたてのロースト"
        },
        {
          "id": "TallowItem",
          "en": "Tallow",
          "fr": "Suif",
          "es": "Sebo",
          "de": "Talg",
          "pt": "Sebo",
          "it": "Sego",
          "tr": "Don Yağı",
          "pl": "Łój",
          "ru": "Сало",
          "uk": "Сало",
          "ko": "동물성 수지",
          "zh": "脂油",
          "ja": "獣脂"
        },
        {
          "id": "BannockItem",
          "en": "Bannock",
          "fr": "Bannique",
          "es": "Bannock",
          "de": "Lagerfeuerbrot",
          "pt": "Bannock",
          "it": "Pagnotta",
          "tr": "Pide",
          "pl": "Placek pszenny",
          "ru": "Пресная лепёшка",
          "uk": "Коржик",
          "ko": "과자빵",
          "zh": "麦饼",
          "ja": "バノック"
        },
        {
          "id": "BeanPasteItem",
          "en": "Bean Paste",
          "fr": "Pâte de haricots",
          "es": "Pasta de Judías",
          "de": "Bohnenpaste",
          "pt": "Pasta de feijão",
          "it": "Pasta di fagioli",
          "tr": "Fasulye Macunu",
          "pl": "Pasta z fasoli",
          "ru": "Бобовая паста",
          "uk": "Паста з бобів",
          "ko": "갈린 콩",
          "zh": "豆浆",
          "ja": "ペースト状の豆"
        },
        {
          "id": "FlourItem",
          "en": "Flour",
          "fr": "Farine",
          "es": "Harina",
          "de": "Mehl",
          "pt": "Farinha",
          "it": "Farina",
          "tr": "Un",
          "pl": "Mąka",
          "ru": "Мука",
          "uk": "Борошно",
          "ko": "밀가루",
          "zh": "面粉",
          "ja": "小麦粉"
        },
        {
          "id": "SugarItem",
          "en": "Sugar",
          "fr": "Sucre",
          "es": "Azúcar",
          "de": "Zucker",
          "pt": "Açúcar",
          "it": "Zucchero",
          "tr": "Şeker",
          "pl": "Cukier",
          "ru": "Сахар",
          "uk": "Цукор",
          "ko": "설탕",
          "zh": "糖",
          "ja": "砂糖"
        },
        {
          "id": "YeastItem",
          "en": "Yeast",
          "fr": "Levure",
          "es": "Levadura",
          "de": "Hefe",
          "pt": "Fermento",
          "it": "Lievito",
          "tr": "Maya",
          "pl": "Drożdże",
          "ru": "Дрожжи",
          "uk": "Дріжджі",
          "ko": "효모",
          "zh": "酵母",
          "ja": "酵母"
        },
        {
          "id": "BearclawItem",
          "en": "Bearclaw",
          "fr": "Gâteau patte d\u0027ours",
          "es": "Pastel Garra de Oso",
          "de": "Bärenklaue",
          "pt": "Garra de urso",
          "it": "Artiglio d\u0027orso",
          "tr": "Ayı Pençesi Keki",
          "pl": "Niedźwiadka",
          "ru": "Пирог «Медвежий коготь»",
          "uk": "Пиріг «Ведмежий кіготь»",
          "ko": "곰 발톱 빵",
          "zh": "熊爪包",
          "ja": "ベアクロウ"
        },
        {
          "id": "PrimeCutItem",
          "en": "Prime Cut",
          "fr": "Morceau de choix",
          "es": "Corte Primo",
          "de": "Filet",
          "pt": "Carne de primeira",
          "it": "Carne di Prima Scelta",
          "tr": "Astar Kesim",
          "pl": "Mięso prima sort",
          "ru": "Вырезка",
          "uk": "М’ясо найвищого ґатунку",
          "ko": "최고급 고기",
          "zh": "特级肉块",
          "ja": "プライムカット"
        },
        {
          "id": "VegetableMedleyItem",
          "en": "Vegetable Medley",
          "fr": "Assortiment de légumes",
          "es": "Popurrí de Verduras",
          "de": "Gemüsesalat",
          "pt": "Mistura de vegetais",
          "it": "Medley di verdure",
          "tr": "Sebze Oturtma",
          "pl": "Mieszanka warzywna",
          "ru": "Овощная смесь",
          "uk": "Овочева суміш",
          "ko": "야채 모듬",
          "zh": "蔬菜拼盘",
          "ja": "野菜の盛り合わせ"
        },
        {
          "id": "MeatStockItem",
          "en": "Meat Stock",
          "fr": "Bouillon de viandes",
          "es": "Caldo de Carne",
          "de": "Brühe aus Fleisch",
          "pt": "Caldo de carne",
          "it": "Brodo di carne",
          "tr": "Et Stoğu",
          "pl": "Rosół",
          "ru": "Мясной бульон",
          "uk": "М’ясний бульйон",
          "ko": "고기 육수",
          "zh": "肉汤料",
          "ja": "肉のスープストック"
        },
        {
          "id": "InfusedOilItem",
          "en": "Infused Oil",
          "fr": "Huile infusée",
          "es": "Aceite Infusionado",
          "de": "Raffiniertes Öl",
          "pt": "Óleo infundido",
          "it": "Olio infuso",
          "tr": "Demlenmiş Sıvı Yağ",
          "pl": "Olej smakowy",
          "ru": "Масляный настой",
          "uk": "Насичена олія",
          "ko": "침출유",
          "zh": "浸泡油",
          "ja": "混合油"
        },
        {
          "id": "BearSUPREMEItem",
          "en": "Bear S U P R E M E",
          "fr": "Suprême d\u0027ours",
          "es": "Oso S U P R E M O",
          "de": "Bärensteak",
          "pt": "Urso S U P R E M O",
          "it": "Orso Supreme",
          "tr": "Y Ü C E Ayı",
          "pl": "Nedzwiedź S U P R E M E",
          "ru": "Блюдо «Матёрый медведь»",
          "uk": "Ведмежий стейк",
          "ko": "쩔어주는 곰기",
          "zh": "顶级熊肉",
          "ja": "Bear S U P R E M E"
        },
        {
          "id": "RawSausageItem",
          "en": "Raw Sausage",
          "fr": "Saucisse crue",
          "es": "Salchicha Cruda",
          "de": "Rohe Wurst",
          "pt": "Linguiça crua",
          "it": "Salsicia cruda",
          "tr": "Çiğ Sosis",
          "pl": "Surowa kiełbasa",
          "ru": "Сырая сарделька",
          "uk": "Сира сарделька",
          "ko": "생 소시지",
          "zh": "生香肠",
          "ja": "生のソーセージ"
        },
        {
          "id": "BoiledSausageItem",
          "en": "Boiled Sausage",
          "fr": "Saucisse bouillie",
          "es": "Salchicha Cocida",
          "de": "Gekochte Wurst",
          "pt": "Linguiça cozida",
          "it": "Salsiccia bollita",
          "tr": "Haşlanmış Sosis",
          "pl": "Gotowana kiełbasa",
          "ru": "Варёная сосиска",
          "uk": "Варена сарделька",
          "ko": "삶은 소시지",
          "zh": "煮香肠",
          "ja": "茹でたソーセージ"
        },
        {
          "id": "BreadItem",
          "en": "Bread",
          "fr": "Pain",
          "es": "Pan",
          "de": "Brot",
          "pt": "Pão",
          "it": "Pane",
          "tr": "Ekmek",
          "pl": "Chleb",
          "ru": "Хлеб",
          "uk": "Хліб",
          "ko": "빵",
          "zh": "面包",
          "ja": "パン"
        },
        {
          "id": "Bread",
          "en": "Bread",
          "fr": "Pain",
          "es": "Pan",
          "de": "Brot",
          "pt": "Pão",
          "it": "Pane",
          "tr": "Ekmek",
          "pl": "Chleb",
          "ru": "Хлеб",
          "uk": "Хліб",
          "ko": "빵",
          "zh": "面包",
          "ja": "パン"
        },
        {
          "id": "Bread",
          "en": "Bread",
          "fr": "Pain",
          "es": "Pan",
          "de": "Brot",
          "pt": "Pão",
          "it": "Pane",
          "tr": "Ekmek",
          "pl": "Chleb",
          "ru": "Хлеб",
          "uk": "Хліб",
          "ko": "빵",
          "zh": "面包",
          "ja": "パン"
        },
        {
          "id": "CamasPasteItem",
          "en": "Camas Paste",
          "fr": "Pâte de camassia",
          "es": "Pasta de camasia",
          "de": "Prärielilienpaste",
          "pt": "Pasta de camassia",
          "it": "Pasta di Camassia",
          "tr": "Camas Lapası",
          "pl": "Pasta z Kamasji",
          "ru": "Паста из камассии",
          "uk": "Паста з камасії",
          "ko": "갈린 카마스",
          "zh": "卡马斯浆",
          "ja": "ペースト状のカマシア"
        },
        {
          "id": "CamasBreadItem",
          "en": "Camas Bread",
          "fr": "Pain au camassia",
          "es": "Pan de camasia",
          "de": "Prärielilienbrot",
          "pt": "Pão de camassia",
          "it": "Pane di Camassia",
          "tr": "Camas Ekmeği",
          "pl": "Chleb Kamasjowy",
          "ru": "Хлеб с камассией",
          "uk": "Хліб з камасією",
          "ko": "카마스 빵",
          "zh": "卡马斯面包",
          "ja": "カマシアパン"
        },
        {
          "id": "CamasBulbBakeItem",
          "en": "Camas Bulb Bake",
          "fr": "Bulbe de camassia cuit",
          "es": "Bulbo de camasia horneado",
          "de": "Gebackene Prärielilienzwiebel",
          "pt": "Bulbo de camassia assado",
          "it": "Bulbo di Camassia cotto al forno",
          "tr": "Fırında Camas Soğanı",
          "pl": "Ciasto z bulw Kamasji",
          "ru": "Запечённая луковица камассии",
          "uk": "Запечена цибулина камасії",
          "ko": "구운 카마스 구근",
          "zh": "烤卡马斯球茎",
          "ja": "焼いたカマシアの球根"
        },
        {
          "id": "CampfireRoastItem",
          "en": "Campfire Roast",
          "fr": "Rôti cuit au feu de camp",
          "es": "Asado a la Fogata",
          "de": "Lagerfeuerbraten",
          "pt": "Copa feita na fogueira",
          "it": "Arosto di falò",
          "tr": "Güveçte Rosto",
          "pl": "Pieczeń z ogniska",
          "ru": "Жаркое на костре",
          "uk": "Печеня на багатті",
          "ko": "모닥불 구운 고기",
          "zh": "篝火烧肉",
          "ja": "野外調理のロースト"
        },
        {
          "id": "CampfireStewItem",
          "en": "Campfire Stew",
          "fr": "Ragoût cuit au feu de camp",
          "es": "Estofado a la Fogata",
          "de": "Lagerfeuer Eintopf",
          "pt": "Ensopado Feito na Fogueira",
          "it": "Stufato di falò",
          "tr": "Güveçte Yahni",
          "pl": "Gulasz z ogniska",
          "ru": "Рагу на костре",
          "uk": "Рагу на багатті",
          "ko": "모닥불 스튜",
          "zh": "篝火炖",
          "ja": "野外調理のシチュー"
        },
        {
          "id": "CharredBeetItem",
          "en": "Charred Beet",
          "fr": "Betterave carbonisée",
          "es": "Remolacha carbonizada",
          "de": "Gegrillte Rübe",
          "pt": "Beterraba tostada",
          "it": "Barbabietola carbonizzata",
          "tr": "Pişmiş Pancar",
          "pl": "Opiekany burak",
          "ru": "Свёкла на углях",
          "uk": "Обвуглений буряк",
          "ko": "그슬린 사탕무",
          "zh": "烧焦的甜菜",
          "ja": "焦げたビート"
        },
        {
          "id": "CharredCornItem",
          "en": "Charred Corn",
          "fr": "Maïs carbonisé",
          "es": "Maíz carbonizado",
          "de": "Gegrillter Mais",
          "pt": "Milho tostado",
          "it": "Cereali carbonizzati",
          "tr": "Pişmiş Mısır",
          "pl": "Opiekana Kukurydza",
          "ru": "Кукуруза на углях",
          "uk": "Обвуглений кукурудзяний качан",
          "ko": "그슬린 옥수수",
          "zh": "烧焦的玉米",
          "ja": "焦げたトウモロコシ"
        },
        {
          "id": "RawFishItem",
          "en": "Raw Fish",
          "fr": "Poisson cru",
          "es": "Pescado Crudo",
          "de": "Roher Fisch",
          "pt": "Peixe cru",
          "it": "Pesce crudo",
          "tr": "Çiğ Balık",
          "pl": "Surowa ryba",
          "ru": "Сырая рыба",
          "uk": "Сира риба",
          "ko": "날생선",
          "zh": "生鱼",
          "ja": "生魚"
        },
        {
          "id": "CharredFishItem",
          "en": "Charred Fish",
          "fr": "Poisson carbonisé",
          "es": "Pescado carbonizado",
          "de": "Gegrillter Fisch",
          "pt": "Peixe tostado",
          "it": "Pesce carbonizzato",
          "tr": "Pişmiş Balık",
          "pl": "Opiekana Ryba",
          "ru": "Жареная на костре рыба",
          "uk": "Обвуглена риба",
          "ko": "그슬린 생선",
          "zh": "烧焦的鱼",
          "ja": "焦げた魚"
        },
        {
          "id": "CharredMeatItem",
          "en": "Charred Meat",
          "fr": "Viande carbonisée",
          "es": "Carne carbonizada",
          "de": "Gegrilltes Fleisch",
          "pt": "Carne tostada",
          "it": "Carne carbonizzata",
          "tr": "Pişmiş Et",
          "pl": "Opiekane Mięso",
          "ru": "Жареное на костре мясо",
          "uk": "Обвуглене м’ясо",
          "ko": "그슬린 고기",
          "zh": "烧焦的肉",
          "ja": "焦げた肉"
        },
        {
          "id": "CharredSausageItem",
          "en": "Charred Sausage",
          "fr": "Saucisse carbonisée",
          "es": "Salchicha Carbonizada",
          "de": "Gegrillte Wurst",
          "pt": "Linguiça tostada",
          "it": "Salsiccia carbonizzata",
          "tr": "Pişmiş Sosis",
          "pl": "Opiekana Kiełbasa",
          "ru": "Сарделька на углях",
          "uk": "Обвуглена сарделька",
          "ko": "그슬린 소시지",
          "zh": "烧焦的香肠",
          "ja": "焦げたソーセージ"
        },
        {
          "id": "CharredTomatoItem",
          "en": "Charred Tomato",
          "fr": "Tomate carbonisée",
          "es": "Tomate Carbonizado",
          "de": "Gegrillte Tomate",
          "pt": "Tomate tostado",
          "it": "Pomodoro carbonizzato",
          "tr": "Pişmiş Domates",
          "pl": "Opiekany Pomidor",
          "ru": "Помидор на углях",
          "uk": "Обвуглений помідор",
          "ko": "그슬린 토마토",
          "zh": "烧焦的番茄",
          "ja": "焦げたトマト"
        },
        {
          "id": "CornmealItem",
          "en": "Cornmeal",
          "fr": "Farine de maïs",
          "es": "Harina de Maíz",
          "de": "Maismehl",
          "pt": "Farinha de milho",
          "it": "Farina di mais",
          "tr": "Mısır Unu",
          "pl": "Kasza kukurydziana",
          "ru": "Кукурузная мука",
          "uk": "Кукурудзянe борошно",
          "ko": "옥수수 가루",
          "zh": "玉米粉",
          "ja": "コーンミール"
        },
        {
          "id": "OilItem",
          "en": "Oil",
          "fr": "Huile",
          "es": "Aceite",
          "de": "Öl",
          "pt": "Óleo",
          "it": "Olio",
          "tr": "Yağ",
          "pl": "Olej",
          "ru": "Масло",
          "uk": "Олія",
          "ko": "식용유",
          "zh": "油",
          "ja": "オイル"
        },
        {
          "id": "CornFrittersItem",
          "en": "Corn Fritters",
          "fr": "Beignets de maïs",
          "es": "Buñuelos de maíz",
          "de": "Frittierter Mais",
          "pt": "Bolinho de milho",
          "it": "Frittelle di mais",
          "tr": "Mısır Parçası",
          "pl": "Kukurydza w cieście",
          "ru": "Кукурузные оладьи",
          "uk": "Кукурудзяні оладки",
          "ko": "옥수수튀김",
          "zh": "玉米煎饼",
          "ja": "トウモロコシのフリッター"
        },
        {
          "id": "CornStarchItem",
          "en": "Corn Starch",
          "fr": "Fécule de maïs",
          "es": "Almidón de maíz",
          "de": "Maisstärke",
          "pt": "Amido de milho",
          "it": "Amido di mais",
          "tr": "Mısır Nişastası",
          "pl": "Mąka kukurydziana",
          "ru": "Кукурузный крахмал",
          "uk": "Кукурудзяний крохмаль",
          "ko": "옥수수 녹말",
          "zh": "玉米淀粉",
          "ja": "コーンスターチ"
        },
        {
          "id": "BasicSaladItem",
          "en": "Basic Salad",
          "fr": "Salade basique",
          "es": "Ensalada Básica",
          "de": "Einfacher Salat",
          "pt": "Salada básica",
          "it": "Insalta di base",
          "tr": "Basit Salata",
          "pl": "Prosta sałatka",
          "ru": "Простой салат",
          "uk": "Простий салат",
          "ko": "평범한 샐러드",
          "zh": "简单沙拉",
          "ja": "普通のサラダ"
        },
        {
          "id": "CrimsonSaladItem",
          "en": "Crimson Salad",
          "fr": "Salade cramoisie",
          "es": "Ensalada Carmesí",
          "de": "Purpursalat",
          "pt": "Salada carmesim",
          "it": "Insalata Rossa",
          "tr": "Renkli Salata",
          "pl": "Karmazynowa sałatka",
          "ru": "Винегрет",
          "uk": "Вінегрет",
          "ko": "붉은 채소 샐러드",
          "zh": "深红沙拉",
          "ja": "クリムゾン サラダ"
        },
        {
          "id": "RawBaconItem",
          "en": "Raw Bacon",
          "fr": "Bacon cru",
          "es": "Tocino Crudo",
          "de": "Roher Speck",
          "pt": "Bacon cru",
          "it": "Pancetta cruda",
          "tr": "Çiğ Domuz Pastırma",
          "pl": "Surowy Boczek",
          "ru": "Сырой бекон",
          "uk": "Сирий бекон",
          "ko": "생 베이컨",
          "zh": "生培根",
          "ja": "生のベーコン"
        },
        {
          "id": "CrispyBaconItem",
          "en": "Crispy Bacon",
          "fr": "Bacon croustillant",
          "es": "Tocino Crujiente",
          "de": "Knuspriger Speck",
          "pt": "Bacon crocante",
          "it": "Pancetta croccante",
          "tr": "Çıtır Domuz Pastırması",
          "pl": "Chrupiący boczek",
          "ru": "Хрустящий бекон",
          "uk": "Хрусткий бекон",
          "ko": "바삭한 베이컨",
          "zh": "香脆培根",
          "ja": "カリカリに焼いたベーコン"
        },
        {
          "id": "TortillaItem",
          "en": "Tortilla",
          "fr": "Tortilla",
          "es": "Tortilla",
          "de": "Tortilla",
          "pt": "Tortilha",
          "it": "Tortilla",
          "tr": "Tortilla",
          "pl": "Tortilla",
          "ru": "Тортилья",
          "uk": "Тортилья",
          "ko": "토르티야",
          "zh": "玉米饼",
          "ja": "トルティーヤ"
        },
        {
          "id": "WildMixItem",
          "en": "Wild Mix",
          "fr": "Mélange sauvage",
          "es": "Mezcla Silvestre",
          "de": "Wildsalat",
          "pt": "Mistura selvagem",
          "it": "Mix selvaggio",
          "tr": "Yabani Karışım",
          "pl": "Bukiet surówek",
          "ru": "Смесь диких растений",
          "uk": "Суміш диких трав",
          "ko": "야채 샐러드",
          "zh": "蔬菜捞",
          "ja": "ワイルドミックス"
        },
        {
          "id": "ElkTacoItem",
          "en": "Elk Taco",
          "fr": "Taco de wapiti",
          "es": "Taco de alce",
          "de": "Elchtaco",
          "pt": "Taco de alce",
          "it": "Alci taco",
          "tr": "Geyik Etli Taco",
          "pl": "Taco z Jelenia",
          "ru": "Тако с олениной",
          "uk": "Лосяче тако",
          "ko": "엘크 고기 타코",
          "zh": "鹿肉玉米卷",
          "ja": "エルクのタコス"
        },
        {
          "id": "ElkWellingtonItem",
          "en": "Elk Wellington",
          "fr": "Rôti de wapiti façon Wellington",
          "es": "Wellington de alce",
          "de": "Wapitiwellington",
          "pt": "Bife Wellington de alce",
          "it": "Alce alla Wellington",
          "tr": "Dışı Yufkalı Geyik Eti",
          "pl": "Jeleń w Cieście",
          "ru": "Оленина «Веллингтон»",
          "uk": "Лосятина по-веллінгтонськи",
          "ko": "엘크 웰링턴",
          "zh": "惠灵顿鹿排",
          "ja": "エルクウェリントン"
        },
        {
          "id": "FlatbreadItem",
          "en": "Flatbread",
          "fr": "Pain plat",
          "es": "Pan Plano",
          "de": "Fladenbrot",
          "pt": "Pão achatado",
          "it": "Focaccia",
          "tr": "Bazlama",
          "pl": "Podpłomyk",
          "ru": "Лепёшка",
          "uk": "Корж",
          "ko": "무발효빵",
          "zh": "大饼",
          "ja": "Podpłomyk"
        },
        {
          "id": "PreparedMeatItem",
          "en": "Prepared Meat",
          "fr": "Viande préparée",
          "es": "Carne Preparada",
          "de": "Vorbereitetes Fleisch",
          "pt": "Carne preparada",
          "it": "Carne preparata",
          "tr": "Hazırlanmış Et",
          "pl": "Gotowe do przyrządzenia mięso",
          "ru": "Обработанное мясо",
          "uk": "Оброблене м’ясо",
          "ko": "손질된 고기",
          "zh": "预加工肉",
          "ja": "下ごしらえした肉"
        },
        {
          "id": "FriedHareHaunchesItem",
          "en": "Fried Hare Haunches",
          "fr": "Cuisses de lièvre frites",
          "es": "Ancas de Liebre Fritas",
          "de": "Frittierte Hasenkeule",
          "pt": "Coxas de lebre fritas",
          "it": "Cosce di lepre fritte",
          "tr": "Kızartılmış Yabani Tavşan Kalçası",
          "pl": "Smażony udziec z zająca",
          "ru": "Жаренное филе зайца",
          "uk": "Смажене заяче філе",
          "ko": "튀긴 토끼 뒷다리",
          "zh": "炸兔后腿",
          "ja": "野ウサギの唐揚げ"
        },
        {
          "id": "FriedTomatoesItem",
          "en": "Fried Tomatoes",
          "fr": "Tomates frites",
          "es": "Tomates fritos",
          "de": "Frittierte Tomaten",
          "pt": "Tomates fritos",
          "it": "Pomodori fritti",
          "tr": "Kızartılmış Domatesler",
          "pl": "Smażone pomidory",
          "ru": "Жареные помидоры",
          "uk": "Смажені помідори",
          "ko": "튀긴 토마토",
          "zh": "炸番茄",
          "ja": "フライドトマト"
        },
        {
          "id": "HuckleberryPieItem",
          "en": "Huckleberry Pie",
          "fr": "Tourte aux myrtilles",
          "es": "Tarta de Arándanos",
          "de": "Heidelbeerkuchen",
          "pt": "Torta de mirtilo",
          "it": "Torta di Mirtilli",
          "tr": "Yabanmersinli Turta",
          "pl": "Ciasto Jagodowe",
          "ru": "Черничный пирог",
          "uk": "Чорничний пиріг",
          "ko": "월귤 파이",
          "zh": "越橘馅饼",
          "ja": "ハックルベリーパイ"
        },
        {
          "id": "HydrocolloidsItem",
          "en": "Hydrocolloids",
          "fr": "Hydrocolloïdes",
          "es": "Hidrocoloides",
          "de": "Hydrokolloide",
          "pt": "Hidrocolóides",
          "it": "Idrocolloidi",
          "tr": "Hidrokoloid",
          "pl": "Hydrokoloidy",
          "ru": "Загуститель",
          "uk": "Гідроколоїди",
          "ko": "하이드로콜로이드",
          "zh": "亲水胶体",
          "ja": "ハイドロコロイド"
        },
        {
          "id": "LiquidNitrogenItem",
          "en": "Liquid Nitrogen",
          "fr": "Azote liquide",
          "es": "Nitrógeno Líquido",
          "de": "Flüssiger Stickstoff",
          "pt": "Nitrogênio líquido",
          "it": "Azoto liquido",
          "tr": "Likit Nitrojen",
          "pl": "Ciekły azot",
          "ru": "Жидкий азот",
          "uk": "Рідкий азот",
          "ko": "액체 질소",
          "zh": "液氮",
          "ja": "液体窒素"
        },
        {
          "id": "SimpleSyrupItem",
          "en": "Simple Syrup",
          "fr": "Sirop simple",
          "es": "Jarabe Simple",
          "de": "Zuckersirup",
          "pt": "Xarope simples",
          "it": "Sciroppo semplice",
          "tr": "Basit Şurup",
          "pl": "Prosty syrop",
          "ru": "Простой сироп",
          "uk": "Простий сироп",
          "ko": "간단한 시럽",
          "zh": "普通糖浆",
          "ja": "シンプルシロップ"
        },
        {
          "id": "MaltodextrinItem",
          "en": "Maltodextrin",
          "fr": "Maltodextrine",
          "es": "Maltodextrina",
          "de": "Maltodextrin",
          "pt": "Maltodextrina",
          "it": "Maltodestrina",
          "tr": "Maltodekstrin",
          "pl": "Maltodekstryna",
          "ru": "Патока",
          "uk": "Патока",
          "ko": "말토덱스트린",
          "zh": "麦芽糊精",
          "ja": "マルトデキストリン"
        },
        {
          "id": "MeatPieItem",
          "en": "Meat Pie",
          "fr": "Tourte à la viande",
          "es": "Tarta de Carne",
          "de": "Fleischpastete",
          "pt": "Torta de carne",
          "it": "Torta di carne",
          "tr": "Etli Börek",
          "pl": "Mięso w cieście",
          "ru": "Мясной пирог",
          "uk": "М’ясний пиріг",
          "ko": "고기 파이",
          "zh": "肉馅饼",
          "ja": "ミートパイ"
        },
        {
          "id": "CerealGermItem",
          "en": "Cereal Germ",
          "fr": "Germe de céréale",
          "es": "Germen de Cereal",
          "de": "Getreidekeim",
          "pt": "Gérmen de cereal",
          "it": "Germe dei cereali",
          "tr": "Tahıl Çekirdeği",
          "pl": "Kiełki zbóżowe",
          "ru": "Зародыш зерна",
          "uk": "Зерновий зародок",
          "ko": "곡실눈",
          "zh": "谷物胚芽",
          "ja": "胚芽"
        },
        {
          "id": "SearedMeatItem",
          "en": "Seared Meat",
          "fr": "Viande poêlée",
          "es": "Carne Chamuscada",
          "de": "Kurz angebratenes Fleisch",
          "pt": "Carne grelhada",
          "it": "Carne Cotta",
          "tr": "Kurutulmuş Et",
          "pl": "Obsmażone mięso",
          "ru": "Обжаренное мясо",
          "uk": "Обсмажене м’ясо",
          "ko": "직화 고기",
          "zh": "煎肉",
          "ja": "焼き目がついた肉"
        },
        {
          "id": "SimmeredMeatItem",
          "en": "Simmered Meat",
          "fr": "Viande mijotée",
          "es": "Carne Hervida",
          "de": "Geschmortes Fleisch",
          "pt": "Carne cozida",
          "it": "Carne bollita",
          "tr": "Kısık Ateşte Pişmiş Et",
          "pl": "Wolno gotowane mięso",
          "ru": "Тушёное мясо",
          "uk": "Тушковане м’ясо",
          "ko": "육즙을 가둔 고기",
          "zh": "炖肉",
          "ja": "煮込み肉"
        },
        {
          "id": "StuffedTurkeyItem",
          "en": "Stuffed Turkey",
          "fr": "Dinde farcie",
          "es": "Pavo Relleno",
          "de": "Gefüllter Truthahn",
          "pt": "Peru recheado",
          "it": "Tacchino Imbottito",
          "tr": "Hindi Dolması",
          "pl": "Indyk faszerowany",
          "ru": "Фаршированная индейка",
          "uk": "Фарширована індичка",
          "ko": "속을 채운 칠면조",
          "zh": "填馅火鸡",
          "ja": "七面鳥の丸焼き"
        },
        {
          "id": "FruitSaladItem",
          "en": "Fruit Salad",
          "fr": "Salade de fruits",
          "es": "Ensalada de Frutas",
          "de": "Obstsalat",
          "pt": "Salada de frutas",
          "it": "Insalata di Frutta",
          "tr": "Meyve Salatası",
          "pl": "Sałatka owocowa",
          "ru": "Фруктовый салат",
          "uk": "Фруктовий салат",
          "ko": "과일 샐러드",
          "zh": "水果沙拉",
          "ja": "フルーツサラダ"
        },
        {
          "id": "SweetSaladItem",
          "en": "Sweet Salad",
          "fr": "Salade douce",
          "es": "Ensalada Dulce",
          "de": "Süßer Salat",
          "pt": "Salada doce",
          "it": "Insalata Dolce",
          "tr": "Tatlı Salata",
          "pl": "Słodka sałatka",
          "ru": "Сладкий салат",
          "uk": "Солодкий салат",
          "ko": "달콤한 샐러드",
          "zh": "甜沙拉",
          "ja": "スウィートサラダ"
        },
        {
          "id": "TransglutaminaseItem",
          "en": "Transglutaminase",
          "fr": "Transglutaminase",
          "es": "Transglutaminasa",
          "de": "Transglutaminase",
          "pt": "Transglutaminase",
          "it": "Transglutaminasi",
          "tr": "Transglutaminaz",
          "pl": "Transglutaminaza",
          "ru": "Трансглютаминаза",
          "uk": "Трансглютаміназа",
          "ko": "글루타미나제",
          "zh": "转谷氨酰胺酶",
          "ja": "トランスグルタミナーゼ"
        },
        {
          "id": "VegetableStockItem",
          "en": "Vegetable Stock",
          "fr": "Bouillon de légumes",
          "es": "Caldo de Verduras",
          "de": "Brühe aus Gemüse",
          "pt": "Caldo de vegetais",
          "it": "Assortimento di Vegetali",
          "tr": "Sebze Stoğu",
          "pl": "Bulion warzywny",
          "ru": "Овощной бульон",
          "uk": "Овочевий бульйон",
          "ko": "야채 육수",
          "zh": "蔬菜汤料",
          "ja": "野菜のスープストック"
        },
        {
          "id": "VegetableSoupItem",
          "en": "Vegetable Soup",
          "fr": "Soupe de légumes",
          "es": "Sopa de Verduras",
          "de": "Suppe mit Gemüse",
          "pt": "Sopa de vegetais",
          "it": "Brodo Vegetale",
          "tr": "Sebze Çorbası",
          "pl": "Zupa jarzynowa",
          "ru": "Овощной суп",
          "uk": "Овочевий суп",
          "ko": "야채 스프",
          "zh": "蔬菜汤",
          "ja": "野菜スープ"
        },
        {
          "id": "WildStewItem",
          "en": "Wild Stew",
          "fr": "Ragoût sauvage",
          "es": "Estofado silvestre",
          "de": "Lagerfeuer Waldeintopf",
          "pt": "Ensopado selvagem",
          "it": "Stufato di selvaggina",
          "tr": "Yabani Yahni",
          "pl": "Gulasz z dzikich roślin",
          "ru": "Рагу из диких растений",
          "uk": "Рагу з диких трав",
          "ko": "야생 스튜",
          "zh": "蔬菜炖",
          "ja": "ワイルドシチュー"
        },
        {
          "id": "WiltedFiddleheadsItem",
          "en": "Wilted Fiddleheads",
          "fr": "Crosses de fougère flétries",
          "es": "Brotes de helecho marchitos",
          "de": "Farnspitzen getrocknet",
          "pt": "Brotos de samambaia murchos",
          "it": "Germogli di felce appassiti",
          "tr": "Solmuş Eğrelti Otları",
          "pl": "Blanszowane pędy paproci",
          "ru": "Увядшие побеги папоротника",
          "uk": "Зів’яла папороть",
          "ko": "살짝 익힌 고사리",
          "zh": "蕨菜干",
          "ja": "しおれたシダ"
        },
        {
          "id": "PistonItem",
          "en": "Piston",
          "fr": "Piston",
          "es": "Pistón",
          "de": "Kolben",
          "pt": "Pistão",
          "it": "Pistone",
          "tr": "Piston",
          "pl": "Tłok",
          "ru": "Поршень",
          "uk": "Поршень",
          "ko": "피스톤",
          "zh": "活塞",
          "ja": "ピストン"
        },
        {
          "id": "ValveItem",
          "en": "Valve",
          "fr": "Soupape",
          "es": "Válvula",
          "de": "Ventil",
          "pt": "Válvula",
          "it": "Valvola",
          "tr": "Vana",
          "pl": "Zawór",
          "ru": "Клапан",
          "uk": "Вентиль",
          "ko": "밸브",
          "zh": "阀门",
          "ja": "バルブ"
        },
        {
          "id": "ServoItem",
          "en": "Servo",
          "fr": "Servomoteur",
          "es": "Servomotor",
          "de": "Servomotor",
          "pt": "Servomotor",
          "it": "Servomotore",
          "tr": "Servo",
          "pl": "Serwomechanizm",
          "ru": "Сервопривод",
          "uk": "Сервопривід",
          "ko": "자동 제어 장치",
          "zh": "传动装置",
          "ja": "サーボ"
        },
        {
          "id": "AdvancedCombustionEngineItem",
          "en": "Advanced Combustion Engine",
          "fr": "Moteur avancé à combustion",
          "es": "Motor de Combustión Avanzado",
          "de": "Fortschrittlicher Verbrennungsmotor",
          "pt": "Motor de Combustão Avançado",
          "it": "Motore a Combustione Avanzato",
          "tr": "Geliştirilmiş Yanmalı Motor",
          "pl": "Zaawansowany silnik spalinowy",
          "ru": "Улучшенный двигатель внутреннего сгорания",
          "uk": "Удосконалений двигун внутрішнього згоряння",
          "ko": "고급 연소기관",
          "zh": "高级内燃机",
          "ja": "高度な内燃機関"
        },
        {
          "id": "LogItem",
          "en": "Log",
          "fr": "Bûche",
          "es": "Tronco",
          "de": "Baumstamm",
          "pt": "Tronco",
          "it": "Tronco",
          "tr": "Kütük",
          "pl": "branches",
          "ru": "Бревно",
          "uk": "Колода",
          "ko": "통나무",
          "zh": "原木",
          "ja": "丸太"
        },
        {
          "id": "ArrowItem",
          "en": "Arrow",
          "fr": "Flèche",
          "es": "Flecha",
          "de": "Pfeil",
          "pt": "Flecha",
          "it": "Freccia",
          "tr": "Ok",
          "pl": "Strzała",
          "ru": "Стрела",
          "uk": "Стріла",
          "ko": "화살",
          "zh": "箭",
          "ja": "矢"
        },
        {
          "id": "Concrete",
          "en": "Concrete",
          "fr": "Béton",
          "es": "Hormigón",
          "de": "Beton",
          "pt": "Concreto",
          "it": "Calcestruzzo",
          "tr": "Beton",
          "pl": "Beton",
          "ru": "Цемент",
          "uk": "Бетон",
          "ko": "콘크리트",
          "zh": "混凝土",
          "ja": "コンクリート"
        },
        {
          "id": "BarrelItem",
          "en": "Barrel",
          "fr": "Baril",
          "es": "Barril",
          "de": "Fass",
          "pt": "Barril",
          "it": "Barile",
          "tr": "Varil",
          "pl": "Beczka",
          "ru": "Бочка",
          "uk": "Діжка",
          "ko": "배럴통",
          "zh": "桶",
          "ja": "ドラム缶"
        },
        {
          "id": "BiodieselItem",
          "en": "Biodiesel",
          "fr": "Bio-gazole",
          "es": "Biodiésel",
          "de": "Biodiesel",
          "pt": "Biodiesel",
          "it": "Biodiesel",
          "tr": "Biyodizel",
          "pl": "Biodisel",
          "ru": "Биодизель",
          "uk": "Біодизель",
          "ko": "바이오디젤",
          "zh": "生物柴油",
          "ja": "バイオディーゼル"
        },
        {
          "id": "BoardItem",
          "en": "Board",
          "fr": "Planche",
          "es": "Tabla",
          "de": "Bretter",
          "pt": "Tábua",
          "it": "Tavola",
          "tr": "Tahta",
          "pl": "Deska",
          "ru": "Доска",
          "uk": "Дошка",
          "ko": "판자",
          "zh": "木板",
          "ja": "板"
        },
        {
          "id": "WoodBoard",
          "en": "Board",
          "fr": "Planche",
          "es": "Tabla",
          "de": "Bretter",
          "pt": "Tábua",
          "it": "Tavola",
          "tr": "Tahta",
          "pl": "Deska",
          "ru": "Доска",
          "uk": "Дошка",
          "ko": "판자",
          "zh": "木板",
          "ja": "板"
        },
        {
          "id": "BrickItem",
          "en": "Brick",
          "fr": "Brique",
          "es": "Ladrillo",
          "de": "Ziegel aus Lehm",
          "pt": "Tijolo",
          "it": "Mattone",
          "tr": "Tuğla",
          "pl": "Cegła",
          "ru": "Кирпич",
          "uk": "Цегла",
          "ko": "벽돌",
          "zh": "砖块",
          "ja": "レンガ"
        },
        {
          "id": "LumberItem",
          "en": "Lumber",
          "fr": "Bois d\u0027œuvre",
          "es": "Maderas",
          "de": "Bauholz",
          "pt": "Madeira serrada",
          "it": "Legname",
          "tr": "Kereste",
          "pl": "Tarcica",
          "ru": "Пиломатериал",
          "uk": "Пиломатеріали",
          "ko": "가공된 목재",
          "zh": "板材",
          "ja": "製材"
        },
        {
          "id": "Lumber",
          "en": "Lumber",
          "fr": "Bois d\u0027œuvre",
          "es": "Maderas",
          "de": "Bauholz",
          "pt": "Madeira serrada",
          "it": "Legname",
          "tr": "Kereste",
          "pl": "Tarcica",
          "ru": "Пиломатериал",
          "uk": "Пиломатеріали",
          "ko": "가공된 목재",
          "zh": "板材",
          "ja": "製材"
        },
        {
          "id": "Lumber",
          "en": "Lumber",
          "fr": "Bois d\u0027œuvre",
          "es": "Maderas",
          "de": "Bauholz",
          "pt": "Madeira serrada",
          "it": "Legname",
          "tr": "Kereste",
          "pl": "Tarcica",
          "ru": "Пиломатериал",
          "uk": "Пиломатеріали",
          "ko": "가공된 목재",
          "zh": "板材",
          "ja": "製材"
        },
        {
          "id": "CharcoalItem",
          "en": "Charcoal",
          "fr": "Charbon de bois",
          "es": "Carbón vegetal",
          "de": "Holzkohle",
          "pt": "Carvão Vegetal",
          "it": "Carbone Vegetale",
          "tr": "Odun Kömürü",
          "pl": "Węgiel drzewny",
          "ru": "Древесный уголь",
          "uk": "Вугілля з деревини",
          "ko": "숯",
          "zh": "木炭",
          "ja": "木炭"
        },
        {
          "id": "SubstrateItem",
          "en": "Substrate",
          "fr": "Substrat",
          "es": "Oblea",
          "de": "Substrat",
          "pt": "Substrato",
          "it": "Substrato",
          "tr": "Alt Katman",
          "pl": "Płytka podkładowa",
          "ru": "Подложка",
          "uk": "Підкладка",
          "ko": "기판",
          "zh": "基底",
          "ja": "基板"
        },
        {
          "id": "CopperWiringItem",
          "en": "Copper Wiring",
          "fr": "Fil de cuivre",
          "es": "Cableado de Cobre",
          "de": "Kupferkabel",
          "pt": "Fiação de Cobre",
          "it": "Cablaggio in rame",
          "tr": "Bakır Kablo",
          "pl": "Miedziane przewody",
          "ru": "Медный провод",
          "uk": "Мідний дріт",
          "ko": "구리선",
          "zh": "铜线",
          "ja": "銅線"
        },
        {
          "id": "GoldFlakesItem",
          "en": "Gold Flakes",
          "fr": "Paillettes d\u0027or",
          "es": "Copos de Oro",
          "de": "Blattgold",
          "pt": "Flocos de Ouro",
          "it": "Scaglie d\u0027oro",
          "tr": "Altın Pullar",
          "pl": "Płatki złota",
          "ru": "Чешуйки золота",
          "uk": "Золоті пластівці",
          "ko": "금조각",
          "zh": "金片",
          "ja": "金箔"
        },
        {
          "id": "GearboxItem",
          "en": "Gearbox",
          "fr": "Boîte de vitesses",
          "es": "Caja de Cambios",
          "de": "Getriebe",
          "pt": "Caixa de Transmissão",
          "it": "Scatola del Cambio di velocità",
          "tr": "Şanzıman Kutusu",
          "pl": "Skrzynia Biegów",
          "ru": "Коробка передач",
          "uk": "Коробка передач",
          "ko": "변속 장치",
          "zh": "齿轮箱",
          "ja": "ギアボックス"
        },
        {
          "id": "CombustionEngineItem",
          "en": "Combustion Engine",
          "fr": "Moteur à combustion",
          "es": "Motor de Combustión",
          "de": "Verbrennungsmotor",
          "pt": "Motor de Combustão",
          "it": "Motore a combustione",
          "tr": "Yanmalı Motor",
          "pl": "Silnik spalinowy",
          "ru": "Двигатель внутреннего сгорания",
          "uk": "Двигун внутрішнього згоряння",
          "ko": "연소기관",
          "zh": "内燃机",
          "ja": "内燃機関"
        },
        {
          "id": "CopperOreItem",
          "en": "Copper Ore",
          "fr": "Minerai de cuivre",
          "es": "Mineral de Cobre",
          "de": "Kupfererz",
          "pt": "Minério de Cobre",
          "it": "Minerale di rame",
          "tr": "Bakır Cevheri",
          "pl": "Ruda miedzi",
          "ru": "Медная руда",
          "uk": "Мідна руда",
          "ko": "구리광석",
          "zh": "铜矿",
          "ja": "銅鉱石"
        },
        {
          "id": "CopperPipeItem",
          "en": "Copper Pipe",
          "fr": "Tuyau en cuivre",
          "es": "Tubo de Cobre",
          "de": "Kupferrohr",
          "pt": "Tubo de cobre",
          "it": "Tubo di rame",
          "tr": "Bakır Boru",
          "pl": "Miedziana rura",
          "ru": "Медная труба",
          "uk": "Мідна труба",
          "ko": "구리 파이프",
          "zh": "铜管",
          "ja": "銅パイプ"
        },
        {
          "id": "CorrugatedSteelItem",
          "en": "Corrugated Steel",
          "fr": "Tôle d\u0027acier ondulée",
          "es": "Acero Corrugado",
          "de": "Wellblech",
          "pt": "Aço corrugado",
          "it": "Acciaio ondulato",
          "tr": "Oluklu Çelik",
          "pl": "Stal ryflowana",
          "ru": "Гофрированная сталь",
          "uk": "Гофрована сталь",
          "ko": "골강판",
          "zh": "波纹钢",
          "ja": "波形鋼"
        },
        {
          "id": "DirtRampItem",
          "en": "Dirt Ramp",
          "fr": "Rampe en terre",
          "es": "Rampa de Tierra",
          "de": "Erdrampe",
          "pt": "Rampa de terra",
          "it": "Rampa di Terra",
          "tr": "Toprak Rampa",
          "pl": "Podjazd ziemny",
          "ru": "Земляная рампа",
          "uk": "Земляний підйом",
          "ko": "흙 경사로",
          "zh": "泥土坡道",
          "ja": "土のランプ"
        },
        {
          "id": "ElectricMotorItem",
          "en": "Electric Motor",
          "fr": "Moteur électrique",
          "es": "Motor Eléctrico",
          "de": "Elektromotor",
          "pt": "Motor Elétrico",
          "it": "Motore elettrico",
          "tr": "Elektrik Motoru",
          "pl": "Silnik elektryczny",
          "ru": "Электродвигатель",
          "uk": "Електродвигун",
          "ko": "전기 모터",
          "zh": "电动机",
          "ja": "電気モーター"
        },
        {
          "id": "PetroleumItem",
          "en": "Petroleum",
          "fr": "Pétrole",
          "es": "Petróleo",
          "de": "Petroleum",
          "pt": "Petróleo",
          "it": "Petrolio",
          "tr": "Petrol",
          "pl": "Ropa naftowa",
          "ru": "Нефть",
          "uk": "Нафта",
          "ko": "석유",
          "zh": "石油",
          "ja": "石油"
        },
        {
          "id": "EpoxyItem",
          "en": "Epoxy",
          "fr": "Résine époxy",
          "es": "Resina Epoxi",
          "de": "Epoxidharz",
          "pt": "Epóxi",
          "it": "Resina epossidica",
          "tr": "Tutkal",
          "pl": "Żywica epoksydowa",
          "ru": "Эпоксидная смола",
          "uk": "Епоксидна смола",
          "ko": "에폭시 수지",
          "zh": "环氧树脂",
          "ja": "エポキシ樹脂"
        },
        {
          "id": "PlasticItem",
          "en": "Plastic",
          "fr": "Plastique",
          "es": "Plástico",
          "de": "Kunststoff",
          "pt": "Plástico",
          "it": "Plastica",
          "tr": "Plastik",
          "pl": "Plastik",
          "ru": "Пластик",
          "uk": "Пластик",
          "ko": "플라스틱",
          "zh": "塑料",
          "ja": "プラスチック"
        },
        {
          "id": "GlassItem",
          "en": "Glass",
          "fr": "Verre",
          "es": "Vidrio",
          "de": "Glas",
          "pt": "Vidro",
          "it": "Vetro",
          "tr": "Cam",
          "pl": "Szkło",
          "ru": "Стекло",
          "uk": "Скло",
          "ko": "유리",
          "zh": "玻璃",
          "ja": "ガラス"
        },
        {
          "id": "FiberglassItem",
          "en": "Fiberglass",
          "fr": "Fibre de verre",
          "es": "Fibra de Vidrio",
          "de": "Glasfaserverstärkter Kunststoff",
          "pt": "Fibra de Vidro",
          "it": "Fibra di vetro",
          "tr": "Fiberglas",
          "pl": "Włokno szklane",
          "ru": "Стекловолокно",
          "uk": "Скловолокно",
          "ko": "유리섬유",
          "zh": "玻璃钢",
          "ja": "ガラス繊維"
        },
        {
          "id": "FlatSteelItem",
          "en": "Flat Steel",
          "fr": "Tôle d\u0027acier lisse",
          "es": "Acero Plano",
          "de": "Flachstahl",
          "pt": "Aço plano",
          "it": "Piatto in acciaio",
          "tr": "Yassı Çelik",
          "pl": "Blacha stalowa",
          "ru": "Листовая сталь",
          "uk": "Листова сталь",
          "ko": "평철",
          "zh": "扁钢",
          "ja": "鋼板"
        },
        {
          "id": "FramedGlassItem",
          "en": "Framed Glass",
          "fr": "Verre encadré",
          "es": "Vidrio Enmarcado",
          "de": "Gerahmtes Glas",
          "pt": "Vidro emoldurado",
          "it": "Vetro Incorniciato",
          "tr": "Çerçeveli Cam",
          "pl": "Szyba oprawiona",
          "ru": "Обрамлённое стекло",
          "uk": "Рамкове скло",
          "ko": "유리 창틀",
          "zh": "框式玻璃",
          "ja": "ガラスの窓枠"
        },
        {
          "id": "GasolineItem",
          "en": "Gasoline",
          "fr": "Essence",
          "es": "Gasolina",
          "de": "Benzin",
          "pt": "Gasolina",
          "it": "Benzina",
          "tr": "Benzin",
          "pl": "Benzyna",
          "ru": "Бензин",
          "uk": "Бензин",
          "ko": "휘발유",
          "zh": "汽油",
          "ja": "ガソリン"
        },
        {
          "id": "SandItem",
          "en": "Sand",
          "fr": "Sable",
          "es": "Arena",
          "de": "Sand",
          "pt": "Areia",
          "it": "Sabbia",
          "tr": "Kum",
          "pl": "Piasek",
          "ru": "Песок",
          "uk": "Пісок",
          "ko": "모래",
          "zh": "沙子",
          "ja": "砂"
        },
        {
          "id": "GoldOreItem",
          "en": "Gold Ore",
          "fr": "Minerai d\u0027or",
          "es": "Mineral de Oro",
          "de": "Golderz",
          "pt": "Minério de Ouro",
          "it": "Minerale d\u0027oro",
          "tr": "Altın Cevheri",
          "pl": "Ruda złota",
          "ru": "Золотая руда",
          "uk": "Золота руда",
          "ko": "금광석",
          "zh": "金矿",
          "ja": "金鉱石"
        },
        {
          "id": "HewnLogItem",
          "en": "Hewn Log",
          "fr": "Rondin taillé",
          "es": "Tronco tallado",
          "de": "Massivholz",
          "pt": "Madeira cortada",
          "it": "Tronco Tagliato",
          "tr": "Yontulmuş Kütük",
          "pl": "Ociosana Kłoda",
          "ru": "Тёсаное бревно",
          "uk": "Обтесана колода",
          "ko": "다듬은 통나무",
          "zh": "粗凿原木",
          "ja": "丸太材"
        },
        {
          "id": "HewnLog",
          "en": "Hewn Log",
          "fr": "Rondin taillé",
          "es": "Tronco tallado",
          "de": "Massivholz",
          "pt": "Madeira cortada",
          "it": "Tronco Tagliato",
          "tr": "Yontulmuş Kütük",
          "pl": "Ociosana Kłoda",
          "ru": "Тёсаное бревно",
          "uk": "Обтесана колода",
          "ko": "다듬은 통나무",
          "zh": "粗凿原木",
          "ja": "丸太材"
        },
        {
          "id": "IronOreItem",
          "en": "Iron Ore",
          "fr": "Minerai de fer",
          "es": "Mineral de Hierro",
          "de": "Eisenerz",
          "pt": "Minério de Ferro",
          "it": "Minerale di ferro",
          "tr": "Demir Cevheri",
          "pl": "Ruda żelaza",
          "ru": "Железная руда",
          "uk": "Залізна руда",
          "ko": "철광석",
          "zh": "铁矿",
          "ja": "鉄鉱石"
        },
        {
          "id": "IronPipeItem",
          "en": "Iron Pipe",
          "fr": "Tuyau en fer",
          "es": "Tuberia de Hierro",
          "de": "Eisenrohr",
          "pt": "Tubo de ferro",
          "it": "Tubo di ferro",
          "tr": "Demir Boru",
          "pl": "Żelazna rura",
          "ru": "Железная труба",
          "uk": "Залізна труба",
          "ko": "쇠 파이프",
          "zh": "铁管",
          "ja": "鉄パイプ"
        },
        {
          "id": "MortaredStoneItem",
          "en": "Mortared Stone",
          "fr": "Pierre cimentée",
          "es": "Piedra con mortero",
          "de": "Ziegel aus Stein",
          "pt": "Pedra argamassada",
          "it": "Mortaio in Pietra",
          "tr": "Harçlı Taş",
          "pl": "Spojony zaprawą kamień",
          "ru": "Строительный камень",
          "uk": "Будівельне каміння",
          "ko": "모르타르 마감 석재",
          "zh": "浆砌石",
          "ja": "モルタルストーン"
        },
        {
          "id": "MortaredStone",
          "en": "Mortared Stone",
          "fr": "Pierre cimentée",
          "es": "Piedra con mortero",
          "de": "Ziegel aus Stein",
          "pt": "Pedra argamassada",
          "it": "Mortaio in Pietra",
          "tr": "Harçlı Taş",
          "pl": "Spojony zaprawą kamień",
          "ru": "Строительный камень",
          "uk": "Будівельне каміння",
          "ko": "모르타르 마감 석재",
          "zh": "浆砌石",
          "ja": "モルタルストーン"
        },
        {
          "id": "PaperItem",
          "en": "Paper",
          "fr": "Papier",
          "es": "Papel",
          "de": "Papier",
          "pt": "Papel",
          "it": "Carta",
          "tr": "Kağıt",
          "pl": "Papier",
          "ru": "Бумага",
          "uk": "Папір",
          "ko": "종이",
          "zh": "纸",
          "ja": "紙"
        },
        {
          "id": "RebarItem",
          "en": "Rebar",
          "fr": "Barre d\u0027armature",
          "es": "Barra corrugada",
          "de": "Bewehrungsstahl",
          "pt": "Vergalhão",
          "it": "Tondo per cemento armato",
          "tr": "Ribar",
          "pl": "Zbrojenie",
          "ru": "Арматура",
          "uk": "Арматура",
          "ko": "철근",
          "zh": "钢筋",
          "ja": "鉄筋"
        },
        {
          "id": "ReinforcedConcreteItem",
          "en": "Reinforced Concrete",
          "fr": "Béton armé",
          "es": "Hormigón reforzado",
          "de": "Stahlbeton",
          "pt": "Concreto reforçado",
          "it": "Cemento armato",
          "tr": "Güçlendirilmiş Beton",
          "pl": "Beton zbrojony",
          "ru": "Железобетон",
          "uk": "Вироби залізобетонні",
          "ko": "철근 콘크리트",
          "zh": "钢筋混凝土",
          "ja": "鉄筋コンクリート"
        },
        {
          "id": "RivetItem",
          "en": "Rivet",
          "fr": "Rivet",
          "es": "Remache",
          "de": "Niete",
          "pt": "Rebite",
          "it": "Rivetto",
          "tr": "Perçin",
          "pl": "Nit",
          "ru": "Заклёпка",
          "uk": "Заклепка",
          "ko": "대갈못",
          "zh": "铆钉",
          "ja": "鋲"
        },
        {
          "id": "SoilSamplerItem",
          "en": "Soil Sampler",
          "fr": "Analyseur de sol",
          "es": "Muestreador de suelo",
          "de": "Bodenprüfer",
          "pt": "Amostrador de Solo",
          "it": "Campionatore di terreno",
          "tr": "Zemin Örneği Toplayıcı",
          "pl": "Próbnik Gleby",
          "ru": "Анализатор почвы",
          "uk": "Аналізатор ґрунту",
          "ko": "토양 채취기",
          "zh": "土壤取样器",
          "ja": "ソイルサンプラー"
        },
        {
          "id": "SteelPipeItem",
          "en": "Steel Pipe",
          "fr": "Tuyau en acier",
          "es": "Tubo de Acero",
          "de": "Stahlrohr",
          "pt": "Tubo de aço",
          "it": "Tubo d\u0027acciaio",
          "tr": "Çelik Boru",
          "pl": "Stalowa Rura",
          "ru": "Стальная труба",
          "uk": "Сталева труба",
          "ko": "강철 파이프",
          "zh": "钢管",
          "ja": "鋼パイプ"
        },
        {
          "id": "StoneRampItem",
          "en": "Stone Ramp",
          "fr": "Rampe pavée",
          "es": "Rampa de piedra",
          "de": "Steinrampe",
          "pt": "Rampa de pedra",
          "it": "Rampa di pietra",
          "tr": "Taş Rampa",
          "pl": "Kamienny Podjazd",
          "ru": "Каменная рампа",
          "uk": "Кам’яний підйом",
          "ko": "돌 경사로",
          "zh": "石头坡道",
          "ja": "石のランプ"
        },
        {
          "id": "StoneRoadItem",
          "en": "Stone Road",
          "fr": "Route pavée",
          "es": "Camino de Piedra",
          "de": "Steinstraße",
          "pt": "Estrada de pedra",
          "it": "Strada di pietra",
          "tr": "Taş Yol",
          "pl": "Kamienna droga",
          "ru": "Каменная дорога",
          "uk": "Кам’яна дорога",
          "ko": "돌 길",
          "zh": "石质道路",
          "ja": "石の道路"
        },
        {
          "id": "TorchItem",
          "en": "Torch",
          "fr": "Torche",
          "es": "Antorcha",
          "de": "Fackel",
          "pt": "Tocha",
          "it": "Torcia",
          "tr": "Meşale",
          "pl": "Pochodnia",
          "ru": "Факел",
          "uk": "Факел",
          "ko": "횃불",
          "zh": "火把",
          "ja": "松明"
        },
        {
          "id": "BisonCarcassItem",
          "en": "Bison Carcass",
          "fr": "Cadavre de bison",
          "es": "Cadáver de bisonte",
          "de": "Bisonkadaver",
          "pt": "Carcaça de Bisão",
          "it": "Carcassa di bisonte",
          "tr": "Bufalo Cesedi",
          "pl": "Tusza Żubra",
          "ru": "Туша бизона",
          "uk": "Туша бізона",
          "ko": "들소 사체",
          "zh": "野牛遗骸",
          "ja": "バイソンの死体"
        },
        {
          "id": "ElkCarcassItem",
          "en": "Elk Carcass",
          "fr": "Cadavre de wapiti",
          "es": "Cadáver de alce",
          "de": "Elchkadaver",
          "pt": "Carcaça de Alce",
          "it": "Carcassa di alce",
          "tr": "Geyik Cesedi",
          "pl": "Tusza Jelenia",
          "ru": "Туша вапити",
          "uk": "Туша лося",
          "ko": "엘크 사체",
          "zh": "驼鹿遗骸",
          "ja": "エルクの死体"
        },
        {
          "id": "FoxCarcassItem",
          "en": "Fox Carcass",
          "fr": "Cadavre de renard",
          "es": "Cadáver de zorro",
          "de": "Fuchskadaver",
          "pt": "Carcaça de Raposa",
          "it": "Carcassa di volpe",
          "tr": "Tilki Cesedi",
          "pl": "Tuszka Lisa",
          "ru": "Туша лисы",
          "uk": "Туша лисиці",
          "ko": "여우 사체",
          "zh": "狐狸遗骸",
          "ja": "キツネの死体"
        },
        {
          "id": "HareCarcassItem",
          "en": "Hare Carcass",
          "fr": "Cadavre de lièvre",
          "es": "Cadáver de liebre",
          "de": "Hasenkadaver",
          "pt": "Carcaça de Lebre",
          "it": "Carcassa di lepre",
          "tr": "Tavşan Cesedi",
          "pl": "Padlina zająca",
          "ru": "Тушка зайца",
          "uk": "Туша зайця",
          "ko": "토끼 사체",
          "zh": "野兔遗骸",
          "ja": "野ウサギの死体"
        },
        {
          "id": "TurkeyCarcassItem",
          "en": "Turkey Carcass",
          "fr": "Cadavre de dinde",
          "es": "Cadáver de pavo",
          "de": "Truthahnkadaver",
          "pt": "Carcaça de Peru",
          "it": "Carcassa di Tacchino",
          "tr": "Hindi Cesedi",
          "pl": "Padlina indyka",
          "ru": "Туша индейки",
          "uk": "Туша індички",
          "ko": "칠면조 사체",
          "zh": "火鸡遗骸",
          "ja": "七面鳥の死体"
        },
        {
          "id": "WolfCarcassItem",
          "en": "Wolf Carcass",
          "fr": "Cadavre de loup",
          "es": "Cadáver de lobo",
          "de": "Wolfkadaver",
          "pt": "Carcaça de Lobo",
          "it": "Carcassa di lupo",
          "tr": "Kurt Cesedi",
          "pl": "Padlina wilka",
          "ru": "Туша волка",
          "uk": "Туша вовка",
          "ko": "늑대 사체",
          "zh": "狼遗骸",
          "ja": "オオカミの死体"
        },
        {
          "id": "SalmonItem",
          "en": "Salmon",
          "fr": "Saumon",
          "es": "Salmón",
          "de": "Lachs",
          "pt": "Salmão",
          "it": "Salmone",
          "tr": "Somon",
          "pl": "Losoś",
          "ru": "Лосось",
          "uk": "Лосось",
          "ko": "연어",
          "zh": "鲑鱼肉",
          "ja": "サケ"
        },
        {
          "id": "TroutItem",
          "en": "Trout",
          "fr": "Truite",
          "es": "Trucha",
          "de": "Forelle",
          "pt": "Truta",
          "it": "Trota",
          "tr": "Alabalık",
          "pl": "Pstrąg",
          "ru": "Форель",
          "uk": "Форель",
          "ko": "송어",
          "zh": "鳟鱼",
          "ja": "マス"
        },
        {
          "id": "TunaItem",
          "en": "Tuna",
          "fr": "Thon",
          "es": "Atún",
          "de": "Thunfisch",
          "pt": "Atum",
          "it": "Tonno",
          "tr": "Orkinos",
          "pl": "Tuńczyk",
          "ru": "Тунец",
          "uk": "Тунець",
          "ko": "참치",
          "zh": "金枪鱼",
          "ja": "マグロ"
        },
        {
          "id": "UrchinItem",
          "en": "Urchin",
          "fr": "Oursin",
          "es": "Erizo",
          "de": "Seeigel",
          "pt": "Ouriço-do-mar",
          "it": "Riccio di Mare",
          "tr": "Su Kirpisi",
          "pl": "Jeżowiec",
          "ru": "Морской ёж",
          "uk": "Морський їжак",
          "ko": "성게",
          "zh": "海胆",
          "ja": "ウニ"
        },
        {
          "id": "KelpItem",
          "en": "Kelp",
          "fr": "Varech",
          "es": "Alga",
          "de": "Seetang",
          "pt": "Alga",
          "it": "Alga",
          "tr": "Yosun",
          "pl": "Wodorosty",
          "ru": "Ламинария",
          "uk": "Ламінарія",
          "ko": "다시마",
          "zh": "海带",
          "ja": "海藻"
        },
        {
          "id": "ClamItem",
          "en": "Clam",
          "fr": "Palourde",
          "es": "Almeja",
          "de": "Muschel",
          "pt": "Amêijoa",
          "it": "Vongola",
          "tr": "Midye",
          "pl": "Małż",
          "ru": "Моллюск",
          "uk": "Молюск",
          "ko": "조개",
          "zh": "蚌",
          "ja": "貝"
        },
        {
          "id": "CoalItem",
          "en": "Coal",
          "fr": "Charbon",
          "es": "Carbón",
          "de": "Kohle",
          "pt": "Carvão",
          "it": "Carbone",
          "tr": "Kömür",
          "pl": "Węgiel",
          "ru": "Уголь",
          "uk": "Вугілля",
          "ko": "석탄",
          "zh": "煤",
          "ja": "石炭"
        },
        {
          "id": "Coal",
          "en": "Coal",
          "fr": "Charbon",
          "es": "Carbón",
          "de": "Kohle",
          "pt": "Carvão",
          "it": "Carbone",
          "tr": "Kömür",
          "pl": "Węgiel",
          "ru": "Уголь",
          "uk": "Вугілля",
          "ko": "석탄",
          "zh": "煤",
          "ja": "石炭"
        },
        {
          "id": "WaterwheelItem",
          "en": "Waterwheel",
          "fr": "Moulin à eau",
          "es": "Molino de agua",
          "de": "Wasserrad",
          "pt": "Roda D\u0027água",
          "it": "Ruota idrica",
          "tr": "Su Çarkı",
          "pl": "Koło Wodne",
          "ru": "Водяное колесо",
          "uk": "Водяне колесо",
          "ko": "물레방아",
          "zh": "水车",
          "ja": "水車"
        },
        {
          "id": "AnvilItem",
          "en": "Anvil",
          "fr": "Enclume",
          "es": "Yunque",
          "de": "Amboss",
          "pt": "Bigorna",
          "it": "Incudine",
          "tr": "Örs",
          "pl": "Kowadło",
          "ru": "Наковальня",
          "uk": "Ковадло",
          "ko": "모루",
          "zh": "铁砧",
          "ja": "金床"
        },
        {
          "id": "BakeryOvenItem",
          "en": "Bakery Oven",
          "fr": "Four à pain",
          "es": "Horno de Panadería",
          "de": "Bäckereiofen",
          "pt": "Forno de Padaria",
          "it": "Forno per panetteria",
          "tr": "Ekmek Fırını",
          "pl": "Piec piekarniczy",
          "ru": "Печь для выпечки",
          "uk": "Піч для випічки",
          "ko": "제빵 화덕",
          "zh": "烤炉",
          "ja": "ベーカリーオーブン"
        },
        {
          "id": "BlastFurnaceItem",
          "en": "Blast Furnace",
          "fr": "Haut fourneau",
          "es": "Alto Horno",
          "de": "Hochofen",
          "pt": "Alto-forno",
          "it": "Altoforno",
          "tr": "Maden Eritme Ocağı",
          "pl": "Piec hutniczy",
          "ru": "Доменная печь",
          "uk": "Домна",
          "ko": "용광로",
          "zh": "高炉",
          "ja": "高炉"
        },
        {
          "id": "BloomeryItem",
          "en": "Bloomery",
          "fr": "Bas fourneau",
          "es": "Horno de fundición",
          "de": "Schmelzofen",
          "pt": "Forja catalã",
          "it": "Forno per Metalli",
          "tr": "Demirci Ocağı",
          "pl": "Dymarka",
          "ru": "Сыродутная печь",
          "uk": "Сиродутне горно",
          "ko": "괴철로",
          "zh": "锻铁炉",
          "ja": "塊鉄炉"
        },
        {
          "id": "BookshelfItem",
          "en": "Bookshelf",
          "fr": "Bibliothèque",
          "es": "Librería",
          "de": "Bücherregal",
          "pt": "Estante de Livro",
          "it": "Scaffale dei libri",
          "tr": "Kitaplık",
          "pl": "Biblioteczka",
          "ru": "Книжный шкаф",
          "uk": "Книжкова полиця",
          "ko": "책장",
          "zh": "书架",
          "ja": "本棚"
        },
        {
          "id": "BrazierItem",
          "en": "Brazier",
          "fr": "Brasero en fer",
          "es": "Bracero",
          "de": "Feuerschale",
          "pt": "Braseiro",
          "it": "Braciere",
          "tr": "Mangal",
          "pl": "Koksownik",
          "ru": "Жаровня",
          "uk": "Жаровня",
          "ko": "화로",
          "zh": "火盆",
          "ja": "火鉢"
        },
        {
          "id": "ButcheryTableItem",
          "en": "Butchery Table",
          "fr": "Table de boucherie",
          "es": "Mesa de carnicería",
          "de": "Metzgertisch",
          "pt": "Mesa de Açougue",
          "it": "Tavolo da Macellaio",
          "tr": "Kasap Tezgahı",
          "pl": "Stół rzeźnicki",
          "ru": "Разделочный стол",
          "uk": "Різницький стіл",
          "ko": "도축 작업대",
          "zh": "肉加工工作台",
          "ja": "食肉加工台"
        },
        {
          "id": "CampfireItem",
          "en": "Campfire",
          "fr": "Feu de camp",
          "es": "Fogata",
          "de": "Lagerfeuer",
          "pt": "Fogueira",
          "it": "Falò",
          "tr": "Kamp Ateşi",
          "pl": "Ognisko",
          "ru": "Костёр",
          "uk": "Багаття",
          "ko": "모닥불",
          "zh": "篝火",
          "ja": "焚き火"
        },
        {
          "id": "CandleStandItem",
          "en": "Candle Stand",
          "fr": "Bougeoir",
          "es": "Soporte de Vela",
          "de": "Kerzenständer",
          "pt": "Suporte de Vela",
          "it": "Supporto per candele",
          "tr": "Mum Tutucu",
          "pl": "Stojak na świecę",
          "ru": "Подсвечник",
          "uk": "Підсвічник",
          "ko": "촛대",
          "zh": "烛台",
          "ja": "ろうそく立て"
        },
        {
          "id": "CarpentryTableItem",
          "en": "Carpentry Table",
          "fr": "Établi de menuiserie",
          "es": "Mesa de carpintería",
          "de": "Zimmermanntisch",
          "pt": "Mesa de carpintaria",
          "it": "Tavolo da carpentiere",
          "tr": "Marangoz Masası",
          "pl": "Stół Stolarski",
          "ru": "Плотницкий верстак",
          "uk": "Стіл теслі",
          "ko": "목공 작업대",
          "zh": "木工工作台",
          "ja": "木工作業台"
        },
        {
          "id": "CastIronStoveItem",
          "en": "Cast Iron Stove",
          "fr": "Poêle en fonte",
          "es": "Estufa de hierro fundido",
          "de": "Gusseiserner Ofen",
          "pt": "Fogão de Ferro Fundido",
          "it": "Stufa in ghisa",
          "tr": "Dökme Demir Ocak",
          "pl": "Żeliwna kuchnia",
          "ru": "Чугунная плита",
          "uk": "Чавунна піч",
          "ko": "철재 화덕",
          "zh": "铸铁火炉",
          "ja": "鋳鉄のストーブ"
        },
        {
          "id": "CeilingCandleItem",
          "en": "Ceiling Candle",
          "fr": "Lustre à monture en fer",
          "es": "Vela de Techo",
          "de": "Deckenlampe",
          "pt": "Vela de Teto",
          "it": "Candela da Soffitto",
          "tr": "Tavan Mumu",
          "pl": "Kandelabr",
          "ru": "Люстра со свечами",
          "uk": "Люстра зі свічками",
          "ko": "천장 촛대",
          "zh": "吊式烛灯",
          "ja": "吊り下げろうそく"
        },
        {
          "id": "CementKilnItem",
          "en": "Cement Kiln",
          "fr": "Four à ciment",
          "es": "Horno de Cemento",
          "de": "Zementbrennofen",
          "pt": "Forno de cimento",
          "it": "Forno da cemento",
          "tr": "Çimento Fırını",
          "pl": "Cementownia",
          "ru": "Барабанная печь",
          "uk": "Піч для цементу",
          "ko": "시멘트 가마",
          "zh": "水泥窑",
          "ja": "セメントのかまど"
        },
        {
          "id": "ChairItem",
          "en": "Chair",
          "fr": "Chaise",
          "es": "Silla",
          "de": "Stuhl",
          "pt": "Cadeira",
          "it": "Sedia",
          "tr": "Sandalye",
          "pl": "Krzesło",
          "ru": "Стул",
          "uk": "Стілець",
          "ko": "의자",
          "zh": "椅子",
          "ja": "椅子"
        },
        {
          "id": "CombustionGeneratorItem",
          "en": "Combustion Generator",
          "fr": "Générateur électrique à combustion",
          "es": "Generador de Combustión",
          "de": "Verbrennungsgenerator",
          "pt": "Gerador a Combustão",
          "it": "Generatore a combustione",
          "tr": "Yanmalı Jeneratör",
          "pl": "Generator Spalinowy",
          "ru": "Генератор внутреннего сгорания",
          "uk": "Генератор внутрішнього згоряння",
          "ko": "연소 발전기",
          "zh": "内燃发电机",
          "ja": "火力発電機"
        },
        {
          "id": "ComputerLabItem",
          "en": "Computer Lab",
          "fr": "Ordinateur de contrôle",
          "es": "Laboratorio de Computación",
          "de": "Computerlabor",
          "pt": "Laboratório de Computação",
          "it": "Laboratorio informatico",
          "tr": "Bilgisayar Lab",
          "pl": "Laboratorium komputerowe",
          "ru": "Компьютерная лаборатория",
          "uk": "Комп’ютерна лабораторія",
          "ko": "컴퓨터 연구대",
          "zh": "实验室电脑",
          "ja": "コンピューター・ラボ"
        },
        {
          "id": "ConstructionPostItem",
          "en": "Construction Post",
          "fr": "Piquet de construction",
          "es": "Poste de Construcción",
          "de": "Baupfosten",
          "pt": "Posto de Construção",
          "it": "Paletto per Costruzione",
          "tr": "İnşaat Binası",
          "pl": "Stanowisko Budowlane",
          "ru": "Строительный знак",
          "uk": "Будівельний знак",
          "ko": "건설계약 기둥",
          "zh": "建筑标识",
          "ja": "建設標識"
        },
        {
          "id": "ContractBoardItem",
          "en": "Contract Board",
          "fr": "Tableau de contrats",
          "es": "Tablero de Contratos",
          "de": "Anschlagbrett",
          "pt": "Quadro de contrato",
          "it": "Tabellone dei Contratti",
          "tr": "Kontrat Panosu",
          "pl": "Tablica Zleceń",
          "ru": "Доска объявлений",
          "uk": "Дошка договорів",
          "ko": "계약 게시판",
          "zh": "合同公告板",
          "ja": "契約掲示板"
        },
        {
          "id": "CouchItem",
          "en": "Couch",
          "fr": "Canapé",
          "es": "Sofá",
          "de": "Sofa",
          "pt": "Sofá",
          "it": "Divano",
          "tr": "Kanepe",
          "pl": "Kanapa",
          "ru": "Диван",
          "uk": "Диван",
          "ko": "소파",
          "zh": "沙发",
          "ja": "ソファ"
        },
        {
          "id": "CurrencyExchangeItem",
          "en": "Currency Exchange",
          "fr": "Bureau de change",
          "es": "Cambio de Divisas",
          "de": "Wechselstube",
          "pt": "Casa de câmbio",
          "it": "Cambio Valuta",
          "tr": "Para Birimi Değişimi",
          "pl": "Wymiana walut",
          "ru": "Пункт обмена валюты",
          "uk": "Обмін валют",
          "ko": "환전소",
          "zh": "货币兑换",
          "ja": "両替機"
        },
        {
          "id": "ElectricWallLampItem",
          "en": "Electric Wall Lamp",
          "fr": "Lampe murale électrique",
          "es": "Lámpara de Pared Eléctrica",
          "de": "Elektrische Wandleuchte",
          "pt": "Lâmpada Elétrica de Parede",
          "it": "Lampada da Muro Elettrica",
          "tr": "Elektrikli Duvar Lambası",
          "pl": "Elektryczna lampa ścienna",
          "ru": "Электрическая настенная лампа",
          "uk": "Електричний настінний світильник",
          "ko": "벽걸이형 전등",
          "zh": "电壁灯",
          "ja": "壁掛け電灯"
        },
        {
          "id": "ElectronicsAssemblyItem",
          "en": "Electronics Assembly",
          "fr": "Établi d\u0027assemblage électronique",
          "es": "Sección de ensamblaje electrónico",
          "de": "Elektronikfertigung",
          "pt": "Montagem eletrônica",
          "it": "Assemblaggi elettronici",
          "tr": "Elektronik Montaj",
          "pl": "Montaż Elektroniki",
          "ru": "Сборщик электроники",
          "uk": "Збирач електроніки",
          "ko": "전자 공학 작업대",
          "zh": "电子装配套装",
          "ja": "電子機器組立機"
        },
        {
          "id": "FarmersTableItem",
          "en": "Farmers Table",
          "fr": "Atelier d\u0027agriculture",
          "es": "Mesa de Agricultor",
          "de": "Landwirttisch",
          "pt": "Mesa de agricultor",
          "it": "Tavolo da Contadino",
          "tr": "Çiftçi Masası",
          "pl": "Stół rolniczy",
          "ru": "Фермерский стол",
          "uk": "Фермерський стіл",
          "ko": "농업 작업대",
          "zh": "农业工作台",
          "ja": "園芸作業台"
        },
        {
          "id": "FisheryItem",
          "en": "Fishery",
          "fr": "Atelier de pêche",
          "es": "Pesquería",
          "de": "Fischereitisch",
          "pt": "Mesa de pesca",
          "it": "Tavolo da Pescatore",
          "tr": "Balıkçılık",
          "pl": "Rybołóstwo",
          "ru": "Шкаф рыбака",
          "uk": "Шафка рибалки",
          "ko": "어업 작업대",
          "zh": "渔具",
          "ja": "釣り具作業台"
        },
        {
          "id": "FishTrapItem",
          "en": "Fish Trap",
          "fr": "Nasse à poissons",
          "es": "Trampa para Peces",
          "de": "Reuse",
          "pt": "Armadilha de Pesca",
          "it": "Trappola per pesci",
          "tr": "Balık Tuzağı",
          "pl": "Samołówka",
          "ru": "Верша",
          "uk": "Рибна пастка",
          "ko": "통발",
          "zh": "捕鱼器",
          "ja": "梁(やな）"
        },
        {
          "id": "IceboxItem",
          "en": "Icebox",
          "fr": "Glacière",
          "es": "Nevera",
          "de": "Eisschrank",
          "pt": "Caixa de Gelo",
          "it": "Ghiacciaia",
          "tr": "Soğutucu",
          "pl": "Lodówka",
          "ru": "Ледник",
          "uk": "Льодовник",
          "ko": "아이스 박스",
          "zh": "冷藏箱",
          "ja": "アイスボックス"
        },
        {
          "id": "KilnItem",
          "en": "Kiln",
          "fr": "Four à céramique",
          "es": "Horno",
          "de": "Brennofen",
          "pt": "Forno",
          "it": "Forno",
          "tr": "Fırın",
          "pl": "Piec do Wypalania",
          "ru": "Печь для обжига",
          "uk": "Промислова піч",
          "ko": "가마",
          "zh": "窑",
          "ja": "かまど"
        },
        {
          "id": "LaboratoryItem",
          "en": "Laboratory",
          "fr": "Laboratoire",
          "es": "Laboratorio",
          "de": "Laboratorium",
          "pt": "Laboratório",
          "it": "Laboratorio",
          "tr": "Laboratuvar",
          "pl": "Laboratorium",
          "ru": "Лаборатория",
          "uk": "Лабораторія",
          "ko": "연구대",
          "zh": "实验室",
          "ja": "研究所"
        },
        {
          "id": "LaserItem",
          "en": "Laser",
          "fr": "Laser",
          "es": "Láser",
          "de": "Laser",
          "pt": "Laser",
          "it": "Laser",
          "tr": "Lazer",
          "pl": "Laser",
          "ru": "Лазер",
          "uk": "Лазер",
          "ko": "레이저",
          "zh": "激光",
          "ja": "レーザー"
        },
        {
          "id": "LatrineItem",
          "en": "Wooden Latrine",
          "fr": "Latrines en bois",
          "es": "Letrina de madera",
          "de": "Holzlatrine",
          "pt": "Latrina de Madeira",
          "it": "Latrina in Legno",
          "tr": "Ahşap Tuvalet",
          "pl": "Drewniana Latryna",
          "ru": "Деревянный туалет",
          "uk": "Дерев’яний туалет",
          "ko": "나무 변소",
          "zh": "木质马桶",
          "ja": "木製トイレ"
        },
        {
          "id": "MasonryTableItem",
          "en": "Masonry Table",
          "fr": "Établi de maçonnerie",
          "es": "Mesa de mampostería",
          "de": "Steinmetztisch",
          "pt": "Mesa de alvenaria",
          "it": "Tavolo da Muratore",
          "tr": "Duvarcılık Masası",
          "pl": "Stół murarski",
          "ru": "Верстак каменщика",
          "uk": "Каменярський стіл",
          "ko": "석조 작업대",
          "zh": "石匠工作台",
          "ja": "石工作業台"
        },
        {
          "id": "MillItem",
          "en": "Mill",
          "fr": "Meule",
          "es": "Molino",
          "de": "Mahlwerk",
          "pt": "Moedor",
          "it": "Mulino",
          "tr": "Değirmen",
          "pl": "Młyn",
          "ru": "Мельница",
          "uk": "Млин",
          "ko": "맷돌",
          "zh": "磨坊",
          "ja": "製粉機"
        },
        {
          "id": "MintItem",
          "en": "Mint",
          "fr": "Hôtel de la monnaie",
          "es": "Ceca",
          "de": "Münzprägemaschine",
          "pt": "Prensa de cunhagem",
          "it": "Zecca",
          "tr": "Darphane",
          "pl": "Mennica",
          "ru": "Пресс для чеканки монет",
          "uk": "Карбувальний верстат",
          "ko": "조폐기",
          "zh": "铸币厂",
          "ja": "造幣機"
        },
        {
          "id": "OilRefineryItem",
          "en": "Oil Refinery",
          "fr": "Raffinerie de pétrole",
          "es": "Refinería de Petróleo",
          "de": "Raffinerie",
          "pt": "Refinaria de petróleo",
          "it": "Raffineria di petrolio",
          "tr": "Petrol Rafinerisi",
          "pl": "Rafineria",
          "ru": "Нефтеперерабатывающий завод",
          "uk": "Нафтопереробний завод",
          "ko": "정유소",
          "zh": "炼油厂",
          "ja": "石油精製所"
        },
        {
          "id": "PaddedChairItem",
          "en": "Padded Chair",
          "fr": "Fauteuil",
          "es": "Silla Acolchada",
          "de": "Gepolsterter Stuhl",
          "pt": "Poltrona Acolchoada",
          "it": "Sedia imbottita",
          "tr": "Yastıklı Sandalye",
          "pl": "Fotel tapicerowany",
          "ru": "Кресло",
          "uk": "М’яке крісло",
          "ko": "안락의자",
          "zh": "软垫椅",
          "ja": "パッド入りの椅子"
        },
        {
          "id": "PlanterPotRoundItem",
          "en": "Round Pot",
          "fr": "Pot rond",
          "es": "Maceta Redonda",
          "de": "Blumentopf (rund)",
          "pt": "Vaso Redondo",
          "it": "Vaso rotondo",
          "tr": "Yuvarlak Çömlek",
          "pl": "Okrągłą donica",
          "ru": "Круглый горшок",
          "uk": "Круглий горщик",
          "ko": "둥근 화분",
          "zh": "圆盆",
          "ja": "丸い植木鉢"
        },
        {
          "id": "PlanterPotSquareItem",
          "en": "Square Pot",
          "fr": "Pot carré",
          "es": "Maceta Cuadrada",
          "de": "Blumentopf (quadratisch)",
          "pt": "Vaso Quadrado",
          "it": "Vaso quadrato",
          "tr": "Kare Çömlek",
          "pl": "Kwadratowa donica",
          "ru": "Квадратный горшок",
          "uk": "Квадратний горщик",
          "ko": "각진 화분",
          "zh": "方盆",
          "ja": "四角い植木鉢"
        },
        {
          "id": "PumpJackItem",
          "en": "Pump Jack",
          "fr": "Chevalet de pompage",
          "es": "Unidad de Bombeo",
          "de": "Ölbohrturm",
          "pt": "Bomba petrolífera",
          "it": "Pompa Petrolifera",
          "tr": "Atbaşı Pompa",
          "pl": "Kiwak",
          "ru": "Нефтяная вышка",
          "uk": "Нафтовий насос",
          "ko": "석유 시추기",
          "zh": "油压机",
          "ja": "ポンプジャッキ"
        },
        {
          "id": "RefrigeratorItem",
          "en": "Refrigerator",
          "fr": "Réfrigérateur",
          "es": "Refrigerador",
          "de": "Kühlschrank",
          "pt": "Refrigerador",
          "it": "Frigorifero",
          "tr": "Buzdolabı",
          "pl": "Lodówka",
          "ru": "Холодильник",
          "uk": "Холодильник",
          "ko": "냉장고",
          "zh": "冰箱",
          "ja": "冷蔵庫"
        },
        {
          "id": "ResearchTableItem",
          "en": "Research Table",
          "fr": "Table de recherche",
          "es": "Mesa de investigación",
          "de": "Forschungstisch",
          "pt": "Mesa de pesquisa",
          "it": "Tabella di ricerca",
          "tr": "Araştırma Masası",
          "pl": "Stół badawczy",
          "ru": "Стол для исследований",
          "uk": "Дослідницький стіл",
          "ko": "연구 작업대",
          "zh": "研究工作台",
          "ja": "リサーチテーブル"
        },
        {
          "id": "RollingMillItem",
          "en": "Rolling Mill",
          "fr": "Laminoir",
          "es": "Molino de laminado",
          "de": "Walzwerk",
          "pt": "Rolo de laminação",
          "it": "Laminatoio",
          "tr": "Hadde Makinesi",
          "pl": "Walcownia",
          "ru": "Прокатный стан",
          "uk": "Стан прокатний",
          "ko": "압연기",
          "zh": "轧机",
          "ja": "圧延機"
        },
        {
          "id": "SaltBasketItem",
          "en": "Salt Basket",
          "fr": "Panier de sel",
          "es": "Cesta de Sal",
          "de": "Salzkorb",
          "pt": "Cesta de Sal",
          "it": "Cesto di sale",
          "tr": "Tuz Sepeti",
          "pl": "Kosz Soli",
          "ru": "Корзина с солью",
          "uk": "Кошик солі",
          "ko": "소금 바구니",
          "zh": "盐篓",
          "ja": "カゴに入った塩"
        },
        {
          "id": "SawmillItem",
          "en": "Sawmill",
          "fr": "Scierie",
          "es": "Aserradero",
          "de": "Sägewerk",
          "pt": "Serraria",
          "it": "Segheria",
          "tr": "Bıçkıhane",
          "pl": "Tartak",
          "ru": "Лесопилка",
          "uk": "Лісопилка",
          "ko": "제재대",
          "zh": "锯木台",
          "ja": "製材機"
        },
        {
          "id": "ShelfCabinetItem",
          "en": "Shelf Cabinet",
          "fr": "Étagères",
          "es": "Armario",
          "de": "Regalschrank",
          "pt": "Armário com Prateleira",
          "it": "Scaffale",
          "tr": "Raflı Dolap",
          "pl": "Szafa z półkami",
          "ru": "Сервант",
          "uk": "Сервант",
          "ko": "선반 보관장",
          "zh": "柜架",
          "ja": "飾りつけた棚"
        },
        {
          "id": "SolarGeneratorItem",
          "en": "Solar Generator",
          "fr": "Générateur électrique solaire",
          "es": "Generador Solar",
          "de": "Solargenerator",
          "pt": "Gerador Solar",
          "it": "Generatore Solare",
          "tr": "Güneş Jeneratörü",
          "pl": "Generator słoneczny",
          "ru": "Солнечный генератор",
          "uk": "Сонячний генератор",
          "ko": "태양열 발전기",
          "zh": "太阳能发电机",
          "ja": "太陽光発電機"
        },
        {
          "id": "StockpileItem",
          "en": "Stockpile",
          "fr": "Réserve",
          "es": "Pila de almacenamiento",
          "de": "Lager (Groß)",
          "pt": "Estoque em pilha",
          "it": "Scorta",
          "tr": "Stok Yeri",
          "pl": "Skład",
          "ru": "Склад",
          "uk": "Комора",
          "ko": "자재 창고",
          "zh": "料堆",
          "ja": "ストックパイル"
        },
        {
          "id": "StoneBrazierItem",
          "en": "Stone Brazier",
          "fr": "Brasero en pierre",
          "es": "Brasero de piedra",
          "de": "Feuerschale aus Stein",
          "pt": "Braseiro de Pedra",
          "it": "Braciere in pietra",
          "tr": "Taş Mangal",
          "pl": "Kamienny koksownik",
          "ru": "Каменная жаровня",
          "uk": "Кам’яна жаровня",
          "ko": "돌 화로",
          "zh": "石火盆",
          "ja": "石火鉢"
        },
        {
          "id": "StorageChestItem",
          "en": "Storage Chest",
          "fr": "Coffre",
          "es": "Cofre de almacenamiento",
          "de": "Truhe",
          "pt": "Baú de armazenamento",
          "it": "Cassa",
          "tr": "Eşya sandığı",
          "pl": "Skrzynia",
          "ru": "Сундук",
          "uk": "Скриня",
          "ko": "인벤토리",
          "zh": "储物箱",
          "ja": "ストレージチェスト"
        },
        {
          "id": "StoveItem",
          "en": "Stove",
          "fr": "Cuisinière",
          "es": "Estufa",
          "de": "Herd",
          "pt": "Fogão",
          "it": "Stufa",
          "tr": "Ocak",
          "pl": "Kuchnia",
          "ru": "Плита",
          "uk": "Плита",
          "ko": "화덕",
          "zh": "火炉",
          "ja": "ストーブ"
        },
        {
          "id": "StreetlampItem",
          "en": "Streetlamp",
          "fr": "Réverbère",
          "es": "Farola",
          "de": "Straßenlaterne",
          "pt": "Lâmpada de Rua",
          "it": "Lampione",
          "tr": "Sokak Lambası",
          "pl": "Lampa uliczna",
          "ru": "Уличный фонарь",
          "uk": "Вуличний ліхтар",
          "ko": "가로등",
          "zh": "街灯",
          "ja": "街灯"
        },
        {
          "id": "TailoringTableItem",
          "en": "Tailoring Table",
          "fr": "Atelier de couture",
          "es": "Mesa de sastrería",
          "de": "Schneidertisch",
          "pt": "Mesa de alfaiataria",
          "it": "Tavolo da Sarto",
          "tr": "Terzi Masası",
          "pl": "Stacja Krawiecka",
          "ru": "Стол портного",
          "uk": "Кравецький стіл",
          "ko": "재단 작업대",
          "zh": "裁缝工作台",
          "ja": "裁縫作業台"
        },
        {
          "id": "TallowCandleItem",
          "en": "Tallow Candle",
          "fr": "Bougie en suif",
          "es": "Vela de sebo",
          "de": "Talgkerze",
          "pt": "Vela de Sebo",
          "it": "Candela di sego",
          "tr": "Don Yağı Mumu",
          "pl": "Świeca łojowa",
          "ru": "Сальная свеча",
          "uk": "Сальна свічка",
          "ko": "수지 양초",
          "zh": "油脂蜡烛",
          "ja": "獣脂ろうそく"
        },
        {
          "id": "TallowLampItem",
          "en": "Tallow Lamp",
          "fr": "Lampe à suif",
          "es": "Lámpara de Sebo",
          "de": "Talglampe",
          "pt": "Lâmpada de Sebo",
          "it": "Lampada a sego",
          "tr": "Don Yağı Lambası",
          "pl": "Lampa łojowa",
          "ru": "Сальная лампа",
          "uk": "Сальний світильник",
          "ko": "수지 등",
          "zh": "油脂灯",
          "ja": "獣脂ランプ"
        },
        {
          "id": "TallowWallLampItem",
          "en": "Tallow Wall Lamp",
          "fr": "Lampe à suif murale",
          "es": "Lámpara de Pared de Sebo",
          "de": "Talgwandlampe",
          "pt": "Lâmpada de Parede de Sebo",
          "it": "Lampada a Sego da Muro",
          "tr": "Don Yağı Duvar Lambası",
          "pl": "Ścienna Lampa Łojowa",
          "ru": "Настенная сальная лампа",
          "uk": "Сальний настінний світильник",
          "ko": "벽걸이형 수지 등",
          "zh": "油脂壁灯",
          "ja": "壁掛け獣脂ろうそく"
        },
        {
          "id": "TorchStandItem",
          "en": "Torch Stand",
          "fr": "Support de torche",
          "es": "Soporte de antorcha",
          "de": "Fackelhalter",
          "pt": "Suporte para Tocha",
          "it": "Supporto per Torce",
          "tr": "Meşale Standı",
          "pl": "Stojak na pochodnię",
          "ru": "Стойка для факела",
          "uk": "Факельна стійка",
          "ko": "횃불 받침대",
          "zh": "火把架",
          "ja": "松明スタンド"
        },
        {
          "id": "TreasuryItem",
          "en": "Treasury",
          "fr": "Trésor public",
          "es": "Tesorería",
          "de": "Steuertresor",
          "pt": "Tesouraria",
          "it": "Tesoreria",
          "tr": "Hazine",
          "pl": "Skarbiec",
          "ru": "Казна",
          "uk": "Скарбниця",
          "ko": "정부 금고",
          "zh": "金库",
          "ja": "金庫"
        },
        {
          "id": "WainwrightTableItem",
          "en": "Wainwright Table",
          "fr": "Établi d\u0027ingénierie routière",
          "es": "Mesa de carretero",
          "de": "Wagenmachertisch",
          "pt": "Mesa reta",
          "it": "Tavolo dei Trasporti",
          "tr": "Vagon Tamircisi Masası",
          "pl": "Stół Powoźniczy",
          "ru": "Верстак колесника",
          "uk": "Стіл стельмаха",
          "ko": "짐수레 작업대",
          "zh": "车匠工作台",
          "ja": "荷車作業台"
        },
        {
          "id": "WallCandleItem",
          "en": "Wall Candle",
          "fr": "Bougeoir mural",
          "es": "Vela de Pared",
          "de": "Wandkerze",
          "pt": "Vela de Parede",
          "it": "Candela da Muro",
          "tr": "Duvar Mumu",
          "pl": "Świeca ścienna",
          "ru": "Настенная свеча",
          "uk": "Настінна свічка",
          "ko": "벽걸이형 양초",
          "zh": "挂壁烛灯",
          "ja": "壁掛けろうそく"
        },
        {
          "id": "WashboardItem",
          "en": "Washboard",
          "fr": "Planche à laver",
          "es": "Lavadero",
          "de": "Waschbrett",
          "pt": "Tábua de Lavar",
          "it": "Asse per lavare",
          "tr": "Yıkama Tahtası",
          "pl": "Tara",
          "ru": "Стиральная доска",
          "uk": "Пральна дошка",
          "ko": "빨래판",
          "zh": "搓衣板",
          "ja": "洗濯板"
        },
        {
          "id": "WashingMachineItem",
          "en": "Washing Machine",
          "fr": "Machine à laver",
          "es": "Lavadora",
          "de": "Waschmaschine",
          "pt": "Máquina de Lavar",
          "it": "Lavatrice",
          "tr": "Çamaşır Makinesi",
          "pl": "Pralka",
          "ru": "Стиральная машина",
          "uk": "Пральна машина",
          "ko": "세탁기",
          "zh": "洗衣机",
          "ja": "洗濯機"
        },
        {
          "id": "WindmillItem",
          "en": "Windmill",
          "fr": "Moulin à vent",
          "es": "Molino",
          "de": "Windmühle",
          "pt": "Moinho de Vento",
          "it": "Mulino a vento",
          "tr": "Rüzgâr Değirmeni",
          "pl": "Wiatrak",
          "ru": "Ветряная мельница",
          "uk": "Вітряк",
          "ko": "풍차",
          "zh": "风车",
          "ja": "風車"
        },
        {
          "id": "WindTurbineItem",
          "en": "Wind Turbine",
          "fr": "Éolienne",
          "es": "Turbina Eólica",
          "de": "Windrad",
          "pt": "Turbina Eólica",
          "it": "Turbina a vento",
          "tr": "Rüzgâr Türbini",
          "pl": "Turbina powietrzna",
          "ru": "Ветряная турбина",
          "uk": "Вітрова турбіна",
          "ko": "풍력 발전기",
          "zh": "风力涡轮机",
          "ja": "風力タービン"
        },
        {
          "id": "WoodenFabricBedItem",
          "en": "Wooden Fabric Bed",
          "fr": "Lit confortable en bois d\u0027œuvre",
          "es": "Cama de madera y tela",
          "de": "Hölzernes Stoffbett",
          "pt": "Cama de Madeira e Tecido",
          "it": "Letto in Legno",
          "tr": "Ahşap Dokuma Yatak",
          "pl": "Drewniane łóżko z materacem",
          "ru": "Деревянная кровать с матрасом",
          "uk": "Дерев’яне ліжко з матрацем",
          "ko": "목제 천 침대",
          "zh": "木质布料床",
          "ja": "木製の布ベッド"
        },
        {
          "id": "WoodenStrawBedItem",
          "en": "Wooden Straw Bed",
          "fr": "Lit de paille en bois",
          "es": "Cama de madera y paja",
          "de": "Hölzernes Strohbett",
          "pt": "Cama de Madeira e Palha",
          "it": "Letto in Paglia e Legno",
          "tr": "Ahşap Hazır Yatak",
          "pl": "Drewniane Łożko z Siennikiem",
          "ru": "Деревянная кровать с соломой",
          "uk": "Дерев\u0027яне ліжко з соломою",
          "ko": "목제 짚 침대",
          "zh": "木质稻草床",
          "ja": "木製の藁ベッド"
        },
        {
          "id": "WoodSignItem",
          "en": "Wood Sign",
          "fr": "Panneau en bois",
          "es": "Letrero de Madera",
          "de": "Schild aus Holz",
          "pt": "Placa de Madeira",
          "it": "Cartello di Legno",
          "tr": "Tahta Levha",
          "pl": "Drewniana Tablica",
          "ru": "Деревянная табличка",
          "uk": "Дерев’яний знак",
          "ko": "목재 간판",
          "zh": "木质标志",
          "ja": "木製の看板"
        },
        {
          "id": "WorkbenchItem",
          "en": "Workbench",
          "fr": "Établi de bricolage",
          "es": "Mesa de Trabajo",
          "de": "Werkbank",
          "pt": "Bancada de trabalho",
          "it": "Banco da lavoro",
          "tr": "Çalışma tezgahı",
          "pl": "Stół Roboczy",
          "ru": "Верстак",
          "uk": "Верстат",
          "ko": "작업대",
          "zh": "工作台",
          "ja": "作業台"
        },
        {
          "id": "CementItem",
          "en": "Cement",
          "fr": "Ciment",
          "es": "Cemento",
          "de": "Zement",
          "pt": "Cimento",
          "it": "Cemento",
          "tr": "Çimentolama",
          "pl": "Cement",
          "ru": "Цемент",
          "uk": "Цемент",
          "ko": "시멘트",
          "zh": "水泥",
          "ja": "セメント"
        },
        {
          "id": "BasicBackpackItem",
          "en": "Basic Backpack",
          "fr": "Sac à dos basique",
          "es": "Mochila básica",
          "de": "Einfacher Rucksack",
          "pt": "Mochila Básica",
          "it": "Zaino base",
          "tr": "Basit Sırt Çantası",
          "pl": "Zwykły Plecak",
          "ru": "Простой рюкзак",
          "uk": "Звичайний рюкзак",
          "ko": "기본 배낭",
          "zh": "基础背包",
          "ja": "ベーシックバックパック"
        },
        {
          "id": "BearpackItem",
          "en": "Bearpack",
          "fr": "Sac à d\u0027ours",
          "es": "Mochila de Oso",
          "de": "Bärenrucksack",
          "pt": "Mochila de Urso",
          "it": "Zaino per Orsi",
          "tr": "Ayı Çantası",
          "pl": "Plecak Olbrzymi",
          "ru": "Медвежий рюкзак",
          "uk": "Величезний наплічник",
          "ko": "곰낭",
          "zh": "熊背包",
          "ja": "巨大なバックパック"
        },
        {
          "id": "BigBackpackItem",
          "en": "Big Backpack",
          "fr": "Grand sac à dos",
          "es": "Mochila Grande",
          "de": "Großer Rucksack",
          "pt": "Mochila Grande",
          "it": "Zaino Grande",
          "tr": "Büyük Sırt Çantası",
          "pl": "Duży Plecak",
          "ru": "Большой рюкзак",
          "uk": "Великий рюкзак",
          "ko": "큰 배낭",
          "zh": "大背包",
          "ja": "大きなバックパック"
        },
        {
          "id": "CamoPantsItem",
          "en": "Camo Pants",
          "fr": "Pantalon de camouflage",
          "es": "Pantalones de Camuflaje",
          "de": "Tarnhose",
          "pt": "Calças Camufladas",
          "it": "Pantaloni Mimetici",
          "tr": "Kamuflaj Pantolonu",
          "pl": "Spodnie Moro",
          "ru": "Камуфляжные штаны",
          "uk": "Камуфляжні штани",
          "ko": "위장무늬 바지",
          "zh": "迷彩裤",
          "ja": "迷彩パンツ"
        },
        {
          "id": "CamoShirtItem",
          "en": "Camo Shirt",
          "fr": "Chemise de camouflage",
          "es": "Camiseta de Camuflaje",
          "de": "Tarnshirt",
          "pt": "Camisa Camuflada",
          "it": "Magliette Mimetiche",
          "tr": "Kamuflaj Gömleği",
          "pl": "Koszula Moro",
          "ru": "Камуфляжная рубашка",
          "uk": "Камуфляжна сорочка",
          "ko": "위장무늬 셔츠",
          "zh": "迷彩衬衫",
          "ja": "迷彩シャツ"
        },
        {
          "id": "CaprisItem",
          "en": "Capris",
          "fr": "Corsaire",
          "es": "Pantalones Caprí",
          "de": "Caprihose",
          "pt": "Calça Capri",
          "it": "Pantaloni alla Caprese",
          "tr": "Kapri",
          "pl": "Rybaczki",
          "ru": "Короткие брюки",
          "uk": "Капрі",
          "ko": "칠부 바지",
          "zh": "紧身裤",
          "ja": "カプリ"
        },
        {
          "id": "DerpyHatItem",
          "en": "Derpy Hat",
          "fr": "Chapeau ridicule",
          "es": "Sombrero Ridículo",
          "de": "Trotteliger Hut",
          "pt": "Chapéu de Bobo",
          "it": "Cappello Ridicolo",
          "tr": "Melon Şapka",
          "pl": "Durnowaty kapelusz",
          "ru": "Неуклюжая шляпа",
          "uk": "Недоладний капелюх",
          "ko": "이상한 모자",
          "zh": "德比帽",
          "ja": "おかしな帽子"
        },
        {
          "id": "GardenBootsItem",
          "en": "Garden Boots",
          "fr": "Bottes de jardinage",
          "es": "Botas de Jardín",
          "de": "Gartenschuhe",
          "pt": "Botas de Jardim",
          "it": "Stivali da giardino",
          "tr": "Bahçe Botları",
          "pl": "Buty ogrodnicze",
          "ru": "Садовые сапоги",
          "uk": "Садові чоботи",
          "ko": "정원 부츠",
          "zh": "花园靴",
          "ja": "ガーデンブーツ"
        },
        {
          "id": "GigotSleeveShirtItem",
          "en": "Gigot Sleeve Shirt",
          "fr": "Chemise à manches gigot",
          "es": "Camisa de manga gigot",
          "de": "Hülsenhemd",
          "pt": "Camisa de Manga Gigot",
          "it": "Camicia con maniche Gigot",
          "tr": "Büzülmüş Kollu Tişört",
          "pl": "Bufiasta Koszula",
          "ru": "Рубашка с пышными рукавами",
          "uk": "Сорочка з пишними рукавами",
          "ko": "지고 소매 셔츠",
          "zh": "羊腿袖衬衫",
          "ja": "ジゴスリーブシャツ"
        },
        {
          "id": "HardyBeardItem",
          "en": "Hardy Beard",
          "fr": "Barbe résistante",
          "es": "Barba Vigorosa",
          "de": "Vollbart",
          "pt": "Barba Densa",
          "it": "Barba Resistente",
          "tr": "Kaba Sakal",
          "pl": "Drwalska Broda",
          "ru": "Суровая борода",
          "uk": "Сувора борода",
          "ko": "덥수룩한 수염",
          "zh": "茂密的胡子",
          "ja": "大胆なヒゲ"
        },
        {
          "id": "HenleyItem",
          "en": "Henley",
          "fr": "Chemise Henley",
          "es": "Henley",
          "de": "Henleyshirt",
          "pt": "Camiseta Henley",
          "it": "Henley",
          "tr": "Henley",
          "pl": "Koszulka z Guzikami",
          "ru": "Хенли",
          "uk": "Хенлі",
          "ko": "헨리 셔츠",
          "zh": "亨利衫",
          "ja": "襟なしのシャツ"
        },
        {
          "id": "LightBackpackItem",
          "en": "Light Backpack",
          "fr": "Sac à dos léger",
          "es": "Mochila Ligera",
          "de": "Leichter Rucksack",
          "pt": "Mochila Leve",
          "it": "Zaino Piccolo",
          "tr": "Hafif Sırt Çantası",
          "pl": "Lekki Plecak",
          "ru": "Лёгкий рюкзак",
          "uk": "Легкий рюкзак",
          "ko": "가벼운 배낭",
          "zh": "轻便背包",
          "ja": "軽量バックパック"
        },
        {
          "id": "LowTopShoesItem",
          "en": "Low Top Shoes",
          "fr": "Chaussures basses",
          "es": "Zapatos Bajos",
          "de": "Halbschuhe",
          "pt": "Sapatos de Cano Baixo",
          "it": "Scarpe basse",
          "tr": "Kısa Topuklu Ayakkabı",
          "pl": "Trampki",
          "ru": "Кеды",
          "uk": "Кеди",
          "ko": "로우탑 운동화",
          "zh": "低帮鞋",
          "ja": "ロートップシューズ"
        },
        {
          "id": "NormalHairItem",
          "en": "Normal Hair",
          "fr": "Cheveux normaux",
          "es": "Pelo Normal",
          "de": "Normales Haar",
          "pt": "Cabelo Normal",
          "it": "Capelli normali",
          "tr": "Normal Saç",
          "pl": "Zwykłe włosy",
          "ru": "Обычные волосы",
          "uk": "Нормальне волосся",
          "ko": "기본 머리",
          "zh": "普通头发",
          "ja": "普通の髪の毛"
        },
        {
          "id": "PeasantHairItem",
          "en": "Peasant Hair",
          "fr": "Cheveux de paysan",
          "es": "Pelo de Campesino",
          "de": "Bauernhaar",
          "pt": "Cabelo de Camponês",
          "it": "Capello da contadino",
          "tr": "Çiftçi Saçı",
          "pl": "Chłopskie Włosy",
          "ru": "Косички",
          "uk": "Зачіска селянина",
          "ko": "평범한 머리",
          "zh": "平民头发",
          "ja": "編み込んだ髪"
        },
        {
          "id": "RunningShoesItem",
          "en": "Running Shoes",
          "fr": "Chaussures de course",
          "es": "Zapatos de Correr",
          "de": "Laufschuhe",
          "pt": "Tênis de Corrida",
          "it": "Scarpe da corsa",
          "tr": "Spor Ayakkabı",
          "pl": "Buty do biegania",
          "ru": "Беговые кеды",
          "uk": "Взуття для бігу",
          "ko": "운동화",
          "zh": "跑鞋",
          "ja": "ランニングシューズ"
        },
        {
          "id": "ScruffyHairItem",
          "en": "Scruffy Hair",
          "fr": "Cheveux négligés",
          "es": "Pelo Desaliñado",
          "de": "Schmuddeliges Haar",
          "pt": "Cabelo Desalinhado",
          "it": "Capello trasandato",
          "tr": "Dağınık Saç",
          "pl": "Potargane włosy",
          "ru": "Взлохмаченные волосы",
          "uk": "Скуйовджене волосся",
          "ko": "지저분한 머리",
          "zh": "邋遢头发",
          "ja": "ぼさぼさした髪"
        },
        {
          "id": "ShortBeardItem",
          "en": "Short Beard",
          "fr": "Barbe courte",
          "es": "Barba Corta",
          "de": "Kurzer Bart",
          "pt": "Barba Curta",
          "it": "Barba corta",
          "tr": "Kısa Sakal",
          "pl": "Krótka broda",
          "ru": "Короткая борода",
          "uk": "Коротка борода",
          "ko": "짧은 수염",
          "zh": "短胡子",
          "ja": "短いヒゲ"
        },
        {
          "id": "SquareBeltItem",
          "en": "Square Belt",
          "fr": "Ceinture carrée",
          "es": "Cinturón Cuadrado",
          "de": "Quadratgürtel",
          "pt": "Cinto Quadrado",
          "it": "Cintura Quadrata",
          "tr": "Kare Kemer",
          "pl": "Pas z kwadratową sprzączką",
          "ru": "Ремень с квадратной пряжкой",
          "uk": "Ремінь із квадратною пряжкою",
          "ko": "사각 벨트",
          "zh": "方皮带",
          "ja": "角ばったベルト"
        },
        {
          "id": "TallBootsItem",
          "en": "Tall Boots",
          "fr": "Bottes hautes",
          "es": "Botas altas",
          "de": "Hohe Stiefel",
          "pt": "Botas Altas",
          "it": "Stivali alti",
          "tr": "Uzun Botlar",
          "pl": "Wysokie Buty",
          "ru": "Сапоги",
          "uk": "Високі чоботи",
          "ko": "롱부츠",
          "zh": "高筒靴",
          "ja": "トールブーツ"
        },
        {
          "id": "TrousersItem",
          "en": "Trousers",
          "fr": "Pantalon",
          "es": "Pantalones",
          "de": "Hosen",
          "pt": "Calças",
          "it": "Pantaloni",
          "tr": "Pantolon",
          "pl": "Spodnie",
          "ru": "Брюки",
          "uk": "Брюки",
          "ko": "바지",
          "zh": "裤子",
          "ja": "ズボン"
        },
        {
          "id": "WorkBackpackItem",
          "en": "Work Backpack",
          "fr": "Sac à dos de travail",
          "es": "Mochila de Trabajo",
          "de": "Arbeitsrucksack",
          "pt": "Mochila de Trabalho",
          "it": "Zaino da Lavoro",
          "tr": "İş Sırt Çantası",
          "pl": "Plecak roboczy",
          "ru": "Рабочий рюкзак",
          "uk": "Робочий рюкзак",
          "ko": "작업 배낭",
          "zh": "工作背包",
          "ja": "作業バッグ"
        },
        {
          "id": "WorkBootsItem",
          "en": "Work Boots",
          "fr": "Bottes de travail",
          "es": "Botas de Trabajo",
          "de": "Arbeitsstiefel",
          "pt": "Botas de Trabalho",
          "it": "Stivali da lavoro",
          "tr": "İş Botu",
          "pl": "Buty Robocze",
          "ru": "Рабочие ботинки",
          "uk": "Робочі чоботи",
          "ko": "작업화",
          "zh": "工作靴",
          "ja": "作業靴"
        },
        {
          "id": "TailingsItem",
          "en": "Tailings",
          "fr": "Résidus",
          "es": "Relaves",
          "de": "Giftige Schlacke",
          "pt": "Rejeitos",
          "it": "Sterili",
          "tr": "Tortular",
          "pl": "Odpady hutnicze",
          "ru": "Хвосты",
          "uk": "Шлак",
          "ko": "광재",
          "zh": "残渣",
          "ja": "選鉱くず"
        },
        {
          "id": "TreeDebrisItem",
          "en": "Tree Debris",
          "fr": "Débris d\u0027arbre",
          "es": "Restos de árboles",
          "de": "Baumrückstände",
          "pt": "Detritos de árvores",
          "it": "Detriti di albero",
          "tr": "Ağaç Yığını",
          "pl": "Pozostałości Drzewa",
          "ru": "Обломки дерева",
          "uk": "Залишки дерев",
          "ko": "나무 파편",
          "zh": "树木残枝",
          "ja": "木くず"
        },
        {
          "id": "EcoylentItem",
          "en": "Ecoylent",
          "fr": "Ecoylent",
          "es": "Ecolixir",
          "de": "Ecoylent",
          "pt": "Tônico Eco",
          "it": "Ecoylente",
          "tr": "Ecoylent",
          "pl": "Eco Kokta",
          "ru": "Эколиксир",
          "uk": "Еколіксир",
          "ko": "에코일렌트",
          "zh": "Ecoylent",
          "ja": "イコレント"
        },
        {
          "id": "KelpSeedItem",
          "en": "Kelp Seed",
          "fr": "Graine de varech",
          "es": "Semilla de Alga",
          "de": "Samen (Seetang)",
          "pt": "Semente de Alga",
          "it": "Seme di Alga",
          "tr": "Yosun Tohumu",
          "pl": "Nasiona Listownicy",
          "ru": "Семя бурой водоросли",
          "uk": "Насіння ламінарії",
          "ko": "다시마 씨앗",
          "zh": "海带种子",
          "ja": "海藻の種"
        },
        {
          "id": "MilkItem",
          "en": "Milk",
          "fr": "Lait",
          "es": "Leche",
          "de": "Milch",
          "pt": "Leite",
          "it": "Latte",
          "tr": "Süt",
          "pl": "Mleko",
          "ru": "Молоко",
          "uk": "Молоко",
          "ko": "우유",
          "zh": "奶",
          "ja": "ミルク"
        },
        {
          "id": "SugarcaneItem",
          "en": "Sugarcane",
          "fr": "Canne à sucre",
          "es": "Caña de Azúcar",
          "de": "Zuckerrohr",
          "pt": "Cana-de-açúcar",
          "it": "Canna da zucchero",
          "tr": "Şekerkamışı",
          "pl": "Trzcina Cukrowa",
          "ru": "Сахарный тростник",
          "uk": "Цукрова тростина",
          "ko": "사탕수수",
          "zh": "甘蔗",
          "ja": "サトウキビ"
        },
        {
          "id": "WaterweedSeedItem",
          "en": "Waterweed Seed",
          "fr": "Graine d\u0027élodée",
          "es": "Semilla de Alga",
          "de": "Samen (Wasserpest)",
          "pt": "Alga de Água Doce",
          "it": "Seme di erba acquatica",
          "tr": "Su Otu Tohumu",
          "pl": "Nasiona Moczarki",
          "ru": "Семечко элодеи",
          "uk": "Насіння елодеї",
          "ko": "수초 씨앗",
          "zh": "伊乐藻种子",
          "ja": "水草の種"
        },
        {
          "id": "NuclearFuelItem",
          "en": "Nuclear Fuel",
          "fr": "Combustible nucléaire",
          "es": "Combustible Nuclear",
          "de": "Kernbrennstoff",
          "pt": "Combustível Nuclear",
          "it": "Combustibile Nucleare",
          "tr": "Nükleer Yakıt",
          "pl": "Paliwo nuklearne",
          "ru": "Ядерное топливо",
          "uk": "Ядерне паливо",
          "ko": "핵 연료",
          "zh": "核燃料",
          "ja": "核燃料"
        },
        {
          "id": "StrangeFuelItem",
          "en": "Strange Fuel",
          "fr": "Carburant étrange",
          "es": "Combustible Extraño",
          "de": "Seltsamer Kraftstoff",
          "pt": "Combustível Estranho",
          "it": "Carburante Strano",
          "tr": "Tuhaf Yakıt",
          "pl": "Dziwne Paliwo",
          "ru": "Странное топливо",
          "uk": "Дивне паливо",
          "ko": "이상한 연료",
          "zh": "奇怪的燃料",
          "ja": "奇妙な燃料"
        },
        {
          "id": "EckoTheDolphinItem",
          "en": "Ecko The Dolphin",
          "fr": "Ecko le dauphin",
          "es": "Ecko El Delfín",
          "de": "Ecko der Delphin",
          "pt": "Ecko",
          "it": "Дельфин Эcко",
          "tr": "إيكو الدلفين",
          "pl": "Ecko The Dolphin",
          "ru": "海豚埃克",
          "uk": " delfín",
          "ko": "Ecko 돌고래",
          "zh": " O Golfinho",
          "ja": "Ecko a delfin"
        },
        {
          "id": "CarvedPumpkinItem",
          "en": "Carved Pumpkin",
          "fr": "Citrouille sculptée",
          "es": "Calabaza tallada",
          "de": "Geschnitzter Kürbis",
          "pt": "Abóbora Esculpida",
          "it": "Zucca Scavata",
          "tr": "Oyulmuş Balkabağı",
          "pl": "Wydrążona dynia",
          "ru": "Резная тыква",
          "uk": "Різьблений гарбуз",
          "ko": "조각된 호박",
          "zh": "南瓜灯",
          "ja": "切り分けられたカボチャ"
        },
        {
          "id": "DoorItem",
          "en": "Door",
          "fr": "Porte",
          "es": "Puerta",
          "de": "Tür",
          "pt": "Porta",
          "it": "Porta",
          "tr": "Kapı",
          "pl": "Drzwi",
          "ru": "Дверь",
          "uk": "Двері",
          "ko": "문",
          "zh": "门",
          "ja": "ドア"
        },
        {
          "id": "EckoStatueItem",
          "en": "Ecko Statue",
          "fr": "Statue d\u0027Ecko",
          "es": "Estatua de Ecko",
          "de": "Ecko Statue",
          "pt": "Estátua de Golfinho",
          "it": "Statua di Ecko",
          "tr": "Ecko Heykeli",
          "pl": "Statua Ecko",
          "ru": "Статуя Эcко",
          "uk": "Статуя Еко",
          "ko": "Ecko 동상",
          "zh": "埃克雕像",
          "ja": "Ecko の像"
        },
        {
          "id": "ExcavatorItem",
          "en": "Excavator",
          "fr": "Pelleteuse",
          "es": "Excavadora",
          "de": "Bagger",
          "pt": "Escavadeira",
          "it": "Escavatore",
          "tr": "Kazı Makinesi",
          "pl": "Koparka",
          "ru": "Экскаватор",
          "uk": "Екскаватор",
          "ko": "굴착기",
          "zh": "挖掘机",
          "ja": "ショベルカー"
        },
        {
          "id": "PoweredCartItem",
          "en": "Powered Cart",
          "fr": "Chariot motorisé",
          "es": "Carro Motorizado",
          "de": "Dampfbetriebener Wagen",
          "pt": "Carrinho Motorizado",
          "it": "Carrello Motorizzato",
          "tr": "Motorlu Yük Arabası",
          "pl": "Wózek z Napędem",
          "ru": "Повозка с мотором",
          "uk": "Возик із мотором",
          "ko": "전동 수레",
          "zh": "动力推车",
          "ja": "動力付カート"
        },
        {
          "id": "SmallWoodCartItem",
          "en": "Small Wood Cart",
          "fr": "Petit chariot en bois",
          "es": "Carro de Madera Pequeño",
          "de": "Kleiner Holzkarren",
          "pt": "Carrinho de Madeira Pequeno",
          "it": "Piccolo Carrello di Legno",
          "tr": "Ufak Ahşap Vagon",
          "pl": "Mały drewniany wózek",
          "ru": "Маленькая деревянная телега",
          "uk": "Малий дерев’яний віз",
          "ko": "작은 목재 수레",
          "zh": "小木质拖车",
          "ja": "小さい木製カート"
        },
        {
          "id": "TransmissionPoleItem",
          "en": "Transmission Pole",
          "fr": "Poteau électrique",
          "es": "Poste de Transmisión",
          "de": "Übertragungsmast",
          "pt": "Poste de Transmissão",
          "it": "Palo di trasmissione",
          "tr": "Vites Direği",
          "pl": "Słup elektryczny",
          "ru": "Опора линии электропередач",
          "uk": "Опора ЛЕП",
          "ko": "전봇대",
          "zh": "传动杆",
          "ja": "電柱"
        },
        {
          "id": "WoodCartItem",
          "en": "Wood Cart",
          "fr": "Chariot en bois",
          "es": "Carro de Madera",
          "de": "Großer Holzkarren",
          "pt": "Carrinho de Madeira",
          "it": "Carrello di Legno",
          "tr": "Ahşap Yük Arabası",
          "pl": "Drewniany wózek",
          "ru": "Деревянная тележка",
          "uk": "Дерев’яний віз",
          "ko": "목재 수레",
          "zh": "木质拖车",
          "ja": "木製カート"
        },
        {
          "id": "MilkItem",
          "en": "Milk",
          "fr": "",
          "es": "Lait",
          "de": " qui n\u0027est peut-être pas d\u0027origine animale.",
          "pt": " aunque quizás no de un animal.",
          "it": "우유",
          "tr": "ミルク、おそらく動物由来ではありません。",
          "pl": "Молоко",
          "ru": " aber vielleicht nicht von einem Tier.",
          "uk": "Milk",
          "ko": "Leche",
          "zh": "Milch",
          "ja": " provavelmente não de um animal."
        },
        {
          "id": "Housing",
          "en": "Housing",
          "fr": "Résidence",
          "es": "Vivienda",
          "de": "Haus",
          "pt": "Habitação",
          "it": "Abitazione",
          "tr": "Yerleştirme",
          "pl": "Izba",
          "ru": "Жилье",
          "uk": "Житло",
          "ko": "하우징",
          "zh": "房屋",
          "ja": "ハウジング"
        },
        {
          "id": "CameraItem",
          "en": "Camera",
          "fr": "Caméra",
          "es": "Cámara",
          "de": "Kamera",
          "pt": "Câmera",
          "it": "Camera",
          "tr": "Kamera",
          "pl": "Kamera",
          "ru": "Камера",
          "uk": "Камера",
          "ko": "카메라",
          "zh": "相机",
          "ja": "カメラ"
        },
        {
          "id": "Food",
          "en": "Food",
          "fr": "Nourriture",
          "es": "Comida",
          "de": "Nahrung",
          "pt": "Comida",
          "it": "Cibo",
          "tr": "Yiyecek",
          "pl": "Żywność",
          "ru": "Еда",
          "uk": "Їжа",
          "ko": "음식",
          "zh": "食物",
          "ja": "食料"
        },
        {
          "id": "BoilerItem",
          "en": "Boiler",
          "fr": "Chaudière",
          "es": "Caldera",
          "de": "Heizkessel",
          "pt": "Caldeira",
          "it": "Caldaia",
          "tr": "Kazan",
          "pl": "Bojler",
          "ru": "Котёл",
          "uk": "Котел",
          "ko": "보일러",
          "zh": "锅炉",
          "ja": "ボイラー"
        },
        {
          "id": "CopperBarItem",
          "en": "Copper Bar",
          "fr": "Lingot de cuivre",
          "es": "Lingote de cobre",
          "de": "Kupferbarren",
          "pt": "Barra de cobre",
          "it": "Lingotto di Rame",
          "tr": "Bakır Bar",
          "pl": "Sztabka miedzi",
          "ru": "Медный брусок",
          "uk": "Мідний брусок",
          "ko": "구리괴",
          "zh": "铜条",
          "ja": "銅インゴット"
        },
        {
          "id": "IronGearItem",
          "en": "Iron Gear",
          "fr": "Engrenage en fer",
          "es": "Engranaje de hierro",
          "de": "Eisenzahnrad",
          "pt": "Engrenagem de Ferro",
          "it": "Ingranaggio di Ferro",
          "tr": "Demir Dişli",
          "pl": "Żelazne koło zębate",
          "ru": "Железная шестерня",
          "uk": "Залізна шестірня",
          "ko": "철제 톱니바퀴",
          "zh": "铁质齿轮",
          "ja": "鉄のギア"
        },
        {
          "id": "GoldBarItem",
          "en": "Gold Bar",
          "fr": "Lingot d\u0027or",
          "es": "Lingote de oro",
          "de": "Goldbarren",
          "pt": "Barra de ouro",
          "it": "Lingotto d\u0027Oro",
          "tr": "Altın Bar",
          "pl": "Sztabka złota",
          "ru": "Золотой брусок",
          "uk": "Золотий брусок",
          "ko": "금괴",
          "zh": "金条",
          "ja": "金のインゴット"
        },
        {
          "id": "HeatSinkItem",
          "en": "Heat Sink",
          "fr": "Dissipateur thermique",
          "es": "Disipador de calor",
          "de": "Kühlkörper",
          "pt": "Dissipador de Calor",
          "it": "Radiatore",
          "tr": "Soğutucu Bloğu",
          "pl": "Radiator",
          "ru": "Теплообменник",
          "uk": "Розсіювач тепла",
          "ko": "방열판",
          "zh": "散热片",
          "ja": "ヒートシンク"
        },
        {
          "id": "IronAxleItem",
          "en": "Iron Axle",
          "fr": "Essieu en fer",
          "es": "Eje de hierro",
          "de": "Eisenachse",
          "pt": "Eixo de Ferro",
          "it": "Ascia di Ferro",
          "tr": "Demir Dingil",
          "pl": "Żelazna oś",
          "ru": "Железная ось",
          "uk": "Залізна вісь",
          "ko": "철제 차축",
          "zh": "铁质车轴",
          "ja": "鉄の車軸"
        },
        {
          "id": "IronBarItem",
          "en": "Iron Bar",
          "fr": "Lingot de fer",
          "es": "Lingote de hierro",
          "de": "Eisenbarren",
          "pt": "Barra de ferro",
          "it": "Lingotto di Ferro",
          "tr": "Demir Bar",
          "pl": "Sztabka żelaza",
          "ru": "Железный брусок",
          "uk": "Залізний брусок",
          "ko": "철괴",
          "zh": "铁锭",
          "ja": "鉄のインゴット"
        },
        {
          "id": "IronPlateItem",
          "en": "Iron Plate",
          "fr": "Plaque de fer",
          "es": "Placa de hierro",
          "de": "Eisenplatte",
          "pt": "Chapa de Ferro",
          "it": "Lastra di Ferro",
          "tr": "Demir Plaka",
          "pl": "Żelazna płyta",
          "ru": "Железная пластина",
          "uk": "Залізна пластина",
          "ko": "철판",
          "zh": "铁板",
          "ja": "鉄板"
        },
        {
          "id": "IronWheelItem",
          "en": "Iron Wheel",
          "fr": "Roue en fer",
          "es": "Rueda de hierro",
          "de": "Rad aus Eisen",
          "pt": "Roda de Ferro",
          "it": "Ruota di Ferro",
          "tr": "Demir Tekerlek",
          "pl": "Żelazne koło",
          "ru": "Железное колесо",
          "uk": "Залізне колесо",
          "ko": "철제 바퀴",
          "zh": "铁轮",
          "ja": "鉄の車輪"
        },
        {
          "id": "LightBulbItem",
          "en": "Light Bulb",
          "fr": "Ampoule",
          "es": "Bombilla",
          "de": "Glühbirne",
          "pt": "Lâmpada",
          "it": "Lampadina",
          "tr": "Ampul",
          "pl": "Żarówka",
          "ru": "Лампочка",
          "uk": "Лампочка",
          "ko": "전구",
          "zh": "灯泡",
          "ja": "電球"
        },
        {
          "id": "PortableSteamEngineItem",
          "en": "Portable Steam Engine",
          "fr": "Moteur à vapeur portable",
          "es": "Motor a vapor portátil",
          "de": "Tragbarer Dampf-Stromgenerator",
          "pt": "Motor à Vapor Portátil",
          "it": "Motore a Vapore Portatile",
          "tr": "Taşınabilir Buhar Motoru",
          "pl": "Przenośny Silnik Parowy",
          "ru": "Портативный паровой двигатель",
          "uk": "Портативний паровий двигун",
          "ko": "이동식 증기기관",
          "zh": "便携式蒸汽机",
          "ja": "携帯型蒸気エンジン"
        },
        {
          "id": "LandClaimStakeItem",
          "en": "Land Claim Stake",
          "fr": "Piquet de revendication territoriale",
          "es": "Poste para reclamo de tierras",
          "de": "Grundstück-Absteckpflock",
          "pt": "Estaca de Reivindicação de Terreno",
          "it": "Paletto di Rivendicazione Terreno",
          "tr": "Arazi Talep Hissesi",
          "pl": "Słupek Oznaczenia Ziemi",
          "ru": "Колышек землемера",
          "uk": "Кілок підтвердження права на власність",
          "ko": "부지 소유 말뚝",
          "zh": "领地界桩",
          "ja": "土地請求用の杭"
        },
        {
          "id": "RadiatorItem",
          "en": "Radiator",
          "fr": "Radiateur",
          "es": "Radiador",
          "de": "Kühler",
          "pt": "Radiador",
          "it": "Radiatore",
          "tr": "Radyatör",
          "pl": "Chłodnica",
          "ru": "Радиатор",
          "uk": "Радіатор",
          "ko": "방열기",
          "zh": "散热器",
          "ja": "ラジエーター"
        },
        {
          "id": "RubberWheelItem",
          "en": "Rubber Wheel",
          "fr": "Roue en caoutchouc",
          "es": "Rueda de caucho",
          "de": "Gummirad",
          "pt": "Roda de Borracha",
          "it": "Ruota Gommata",
          "tr": "Lastik Tekerlek",
          "pl": "Gumowe Koło",
          "ru": "Резиновое колесо",
          "uk": "Гумове колесо",
          "ko": "고무 바퀴",
          "zh": "橡胶轮",
          "ja": "ゴム製ホイール"
        },
        {
          "id": "ScrewsItem",
          "en": "Screws",
          "fr": "Vis",
          "es": "Tornillos",
          "de": "Schrauben",
          "pt": "Parafusos",
          "it": "Viti",
          "tr": "Vida",
          "pl": "Śruby",
          "ru": "Винты",
          "uk": "Гвинти",
          "ko": "나사",
          "zh": "螺钉",
          "ja": "ネジ"
        },
        {
          "id": "SteamTractorHarvesterItem",
          "en": "Steam Tractor Harvester",
          "fr": "Moissonneuse pour tracteur à vapeur",
          "es": "Cosechadora a vapor",
          "de": "Dampftraktor-Erntemaschine",
          "pt": "Trator Colheitadeira à Vapor",
          "it": "Raccoglitore del Trattore a Vapore",
          "tr": "Buharlı Traktör Biçerdöveri",
          "pl": "Kombajn Parowy",
          "ru": "Жатка парового трактора",
          "uk": "Збирач для парового трактора",
          "ko": "증기기관 트랙터용 수확기",
          "zh": "蒸汽拖拉机式收割机",
          "ja": "蒸気トラクター式収穫機"
        },
        {
          "id": "SteamTractorSowerItem",
          "en": "Steam Tractor Sower",
          "fr": "Semoir pour tracteur à vapeur",
          "es": "Sembradora para el Tractor de Vapor",
          "de": "Dampftraktor-Sämaschine",
          "pt": "Trator Semeador à Vapor",
          "it": "Seminatrice del Trattore a Vapore",
          "tr": "Buharlı Traktör Tohum Ekme Aracı",
          "pl": "Siewnik Parowy",
          "ru": "Сеялка парового трактора",
          "uk": "Сіялка парового трактора",
          "ko": "증기기관 트랙터용 파종기",
          "zh": "蒸汽拖拉机用播种机",
          "ja": "蒸気トラクター用播種機"
        },
        {
          "id": "SteelAxleItem",
          "en": "Steel Axle",
          "fr": "Essieu en acier",
          "es": "Hacha de Acero",
          "de": "Stahlachse",
          "pt": "Eixo de Aço",
          "it": "Ascia d\u0027Acciaio",
          "tr": "Çelik Dingil",
          "pl": "Oś stalowa",
          "ru": "Стальная ось",
          "uk": "Сталева вісь",
          "ko": "강철 차축",
          "zh": "钢质车轴",
          "ja": "鋼の車軸"
        },
        {
          "id": "SteelGearItem",
          "en": "Steel Gear",
          "fr": "Engrenage en acier",
          "es": "Engranaje de acero",
          "de": "Stahlzahnrad",
          "pt": "Engrenagem de Aço",
          "it": "Ingranaggio d\u0027Acciaio",
          "tr": "Çelik Dişli",
          "pl": "Stalowy bieg",
          "ru": "Стальная шестерня",
          "uk": "Сталева шестірня",
          "ko": "강철 기어",
          "zh": "钢质齿轮",
          "ja": "鋼のギア"
        },
        {
          "id": "SteelPlateItem",
          "en": "Steel Plate",
          "fr": "Plaque d’acier",
          "es": "Placa de acero",
          "de": "Stahlplatte",
          "pt": "Chapa de Aço",
          "it": "Lastra d\u0027Acciaio",
          "tr": "Çelik Plaka",
          "pl": "Blacha Stalowa",
          "ru": "Стальная пластина",
          "uk": "Сталева пластина",
          "ko": "강철판",
          "zh": "钢板",
          "ja": "鋼板"
        },
        {
          "id": "SyntheticRubberItem",
          "en": "Synthetic Rubber",
          "fr": "Caoutchouc synthétique",
          "es": "Caucho Sintético",
          "de": "Synthetischer Gummi",
          "pt": "Borracha Sintética",
          "it": "Gomma Sintetica",
          "tr": "Sentetik Kauçuk",
          "pl": "Kauczuk Syntetyczny",
          "ru": "Синтетическая резина",
          "uk": "Синтетична гума",
          "ko": "합성 고무",
          "zh": "合成橡胶",
          "ja": "合成ゴム"
        },
        {
          "id": "WoodenWheelItem",
          "en": "Wooden Wheel",
          "fr": "Roue en bois",
          "es": "Rueda de madera",
          "de": "Rad aus Holz",
          "pt": "Roda de Madeira",
          "it": "Ruota in Legno",
          "tr": "Ahşap Tekerlek",
          "pl": "Drewniane Koło",
          "ru": "Деревянное колесо",
          "uk": "Дерев’яне колесо",
          "ko": "목제 바퀴",
          "zh": "木轮",
          "ja": "木の車輪"
        },
        {
          "id": "ChainsawItem",
          "en": "Chainsaw",
          "fr": "Tronçonneuse",
          "es": "Motosierra",
          "de": "Kettensäge",
          "pt": "Serra Elétrica",
          "it": "Motosega",
          "tr": "Motorlu Testere",
          "pl": "Piła Łańcuchowa",
          "ru": "Бензопила",
          "uk": "Бензопила",
          "ko": "전기톱",
          "zh": "链锯",
          "ja": "チェーンソー"
        },
        {
          "id": "CraneItem",
          "en": "Crane",
          "fr": "Grue",
          "es": "Grúa",
          "de": "Kran",
          "pt": "Guindaste",
          "it": "Gru",
          "tr": "Vinç",
          "pl": "Dźwig",
          "ru": "Кран",
          "uk": "Кран",
          "ko": "크레인",
          "zh": "起重机",
          "ja": "クレーン"
        },
        {
          "id": "SkidSteerItem",
          "en": "Skid Steer",
          "fr": "Bulldozer",
          "es": "Minicargador",
          "de": "Kompaktlader",
          "pt": "Mini-carregadeira",
          "it": "Minipala",
          "tr": "Dozer",
          "pl": "Miniładowarka",
          "ru": "Погрузчик",
          "uk": "Міні-навантажувач",
          "ko": "스키드 스티어",
          "zh": "滑移装载机",
          "ja": "スキッドステア"
        },
        {
          "id": "TruckItem",
          "en": "Truck",
          "fr": "Camion",
          "es": "Camión",
          "de": "LKW",
          "pt": "Caminhão",
          "it": "Camion",
          "tr": "Kamyon",
          "pl": "Ciężarówka",
          "ru": "Грузовик",
          "uk": "Вантажівка",
          "ko": "트럭",
          "zh": "卡车",
          "ja": "トラック"
        },
        {
          "id": "WheelbarrowItem",
          "en": "Wheelbarrow",
          "fr": "Brouette",
          "es": "Carretilla",
          "de": "Schubkarre",
          "pt": "Carrinho de Mão",
          "it": "Carriola",
          "tr": "El Arabası",
          "pl": "Taczka",
          "ru": "Тачка",
          "uk": "Візок",
          "ko": "외바퀴 손수레",
          "zh": "独轮手推车",
          "ja": "手押し車"
        },
        {
          "id": "WoodenElevatorItem",
          "en": "Wooden Elevator",
          "fr": "Ascenseur en bois",
          "es": "Ascensor de Madera",
          "de": "Hölzerner Aufzug",
          "pt": "Elevador de Madeira",
          "it": "Ascensore in Legno",
          "tr": "Ahşap Asansör",
          "pl": "Winda drewniana",
          "ru": "Деревянный лифт",
          "uk": "Дерев’яний ліфт",
          "ko": "목제 승강기",
          "zh": "木制升降机",
          "ja": "木製エレベーター"
        },
        {
          "id": "AssemblyLineItem",
          "en": "Assembly Line",
          "fr": "Ligne de montage",
          "es": "Línea de Ensamblaje",
          "de": "Mechanische Fertigungsstraße",
          "pt": "Linha de montagem",
          "it": "Catena di montaggio",
          "tr": "Seri Üretim Hattı",
          "pl": "Linia Produkcyjna",
          "ru": "Сборочная линия",
          "uk": "Лінія для збору",
          "ko": "조립 라인",
          "zh": "装配线",
          "ja": "組立ライン"
        },
        {
          "id": "BisonMountItem",
          "en": "Bison Mount",
          "fr": "Trophée de bison",
          "es": "Soporte para bisonte",
          "de": "Ausgestopfter Bison",
          "pt": "Cabeça de Bisão",
          "it": "Bisonte",
          "tr": "Doldurulmuş Bufalo",
          "pl": "Żubr Górski",
          "ru": "Голова бизона",
          "uk": "Голова бізона",
          "ko": "박제된 들소 벽걸이",
          "zh": "野牛头壁挂",
          "ja": "バイソンマウント"
        },
        {
          "id": "CampsiteItem",
          "en": "Campsite",
          "fr": "Camping",
          "es": "Campamento",
          "de": "Campingplatz",
          "pt": "Acampamento",
          "it": "Campo",
          "tr": "Kamp alanı",
          "pl": "Obóz",
          "ru": "Палатка",
          "uk": "Кемпінг",
          "ko": "야영지",
          "zh": "营地",
          "ja": "キャンプサイト"
        },
        {
          "id": "DistributionStationItem",
          "en": "Distribution Station",
          "fr": "Station de distribution",
          "es": "Estación de Distribución",
          "de": "Verteilungsstation",
          "pt": "Estação de Distribuição",
          "it": "Stazione di Distribuzione",
          "tr": "Dağıtım Terminali",
          "pl": "Stacja Dystrybucyjna",
          "ru": "Станция распределения",
          "uk": "Станція розподілу",
          "ko": "물자 배급소",
          "zh": "分发站",
          "ja": "集配ステーション"
        },
        {
          "id": "ElectricLatheItem",
          "en": "Electric Lathe",
          "fr": "Tour électrique",
          "es": "Torno eléctrico",
          "de": "Elektrische Drehmaschine",
          "pt": "Torno elétrico",
          "it": "Tornio Elettrico",
          "tr": "Elektrikli Torna Tezgahı",
          "pl": "Tokarka Elektryczna",
          "ru": "Электрический токарный станок",
          "uk": "Електричний токарний верстат",
          "ko": "전동식 선반",
          "zh": "电动车床",
          "ja": "電気旋盤"
        },
        {
          "id": "ElectricMachinistTableItem",
          "en": "Electric Machinist Table",
          "fr": "Établi électrique",
          "es": "Mesa eléctrica de maquinista",
          "de": "Elektrischer Montagetisch",
          "pt": "Mesa elétrica de maquinista",
          "it": "Banco Elettrico da Macchinista",
          "tr": "Elektrik Ustası Tezgahı",
          "pl": "Elektryczny Stół Maszynowy",
          "ru": "Электрический слесарный верстак",
          "uk": "Стіл електромашиніста",
          "ko": "전동식 기계 정비공 작업대",
          "zh": "电动机械师工作台",
          "ja": "電気工作機械台"
        },
        {
          "id": "ElectricPlanerItem",
          "en": "Electric Planer",
          "fr": "Fraiseuse électrique",
          "es": "Cepilladora eléctrica",
          "de": "Elektrische Hobelmaschine",
          "pt": "Plaina elétrica",
          "it": "Pialla Elettrica",
          "tr": "Elektrikli Rendeleme Tezgahı",
          "pl": "Strug Elektryczny",
          "ru": "Электрический строгальный станок",
          "uk": "Електричний стругальний верстат",
          "ko": "전동식 대패",
          "zh": "电动刨床",
          "ja": "電気かんな盤"
        },
        {
          "id": "ElectricStampingPressItem",
          "en": "Electric Stamping Press",
          "fr": "Presse électrique",
          "es": "Prensa de Estampado Hidráulica",
          "de": "Elektrische Stanzpresse",
          "pt": "Prensa de estampagem elétrica",
          "it": "Pressa per Stampaggio Elettrica",
          "tr": "Elektrikli Çelik İşleme Aleti",
          "pl": "Elektryczna prasa do tłoczenia",
          "ru": "Электрический пресс",
          "uk": "Електричний прес",
          "ko": "전동식 금속 가공기",
          "zh": "电动冲床",
          "ja": "電気スタンピングプレス機"
        },
        {
          "id": "ElkMountItem",
          "en": "Elk Mount",
          "fr": "Trophée de wapiti",
          "es": "Montura de alce",
          "de": "Ausgestopfter Wapiti",
          "pt": "Cabeça de Alce",
          "it": "Alce",
          "tr": "Doldurulmuş Geyik",
          "pl": "Łoś wierzchowiec",
          "ru": "Голова вапити",
          "uk": "Голова оленя",
          "ko": "박제된 엘크 벽걸이",
          "zh": "驼鹿壁挂",
          "ja": "エルクマウント"
        },
        {
          "id": "FramedGlassDoorItem",
          "en": "Framed Glass Door",
          "fr": "Porte en verre encadré",
          "es": "Puerta de cristal enmarcado",
          "de": "Gerahmte Glastür",
          "pt": "Porta de Vidro Moldado",
          "it": "Porta a Vetri con Cornice",
          "tr": "Çerçeveli Cam Kapı",
          "pl": "Oprawione Szklane Drzwi",
          "ru": "Стеклянная дверь",
          "uk": "Скляні двері",
          "ko": "유리창틀 문",
          "zh": "带框架的玻璃门",
          "ja": "枠付きのガラス戸"
        },
        {
          "id": "KitchenItem",
          "en": "Kitchen",
          "fr": "Cuisine",
          "es": "Cocina",
          "de": "Küche",
          "pt": "Cozinha",
          "it": "Cucina",
          "tr": "Mutfak",
          "pl": "Kuchnia",
          "ru": "Кухня",
          "uk": "Кухня",
          "ko": "주방",
          "zh": "厨房",
          "ja": "キッチン"
        },
        {
          "id": "LargeCorrugatedSteelDoorItem",
          "en": "Large Corrugated Steel Door",
          "fr": "Rideau en acier ondulé",
          "es": "Puerta grande corrugada (acero)",
          "de": "Große Wellstahltür",
          "pt": "Porta de Aço Grande Ondulada",
          "it": "Grande Porta in Acciaio Corrugato",
          "tr": "Büyük Kıvrımlı Çelik Kapı",
          "pl": "Duże drzwi ze stali ryflowanej",
          "ru": "Рольставни",
          "uk": "Великі гофровані сталеві двері",
          "ko": "대형 골강판 문",
          "zh": "大型波纹钢门",
          "ja": "波形スチールの大きなドア"
        },
        {
          "id": "LargeHangingLumberSignItem",
          "en": "Large Hanging Lumber Sign",
          "fr": "Grand panneau suspendu en bois d\u0027œuvre",
          "es": "Letrero colgante grande (tablas de madera)",
          "de": "Bauholzschild (Groß",
          "pt": "대형 가공목 현판",
          "it": "Большая вывеска из пиломатериалов",
          "tr": "Large Hanging Lumber Sign",
          "pl": "Large Hanging Lumber Sign",
          "ru": "大型木制标志",
          "uk": "Stort Hængende Skilt i Tømmer",
          "ko": " hängend)",
          "zh": "Placa de Madeira Serrada Grande Pendurada",
          "ja": "Large Hanging Lumber Sign"
        },
        {
          "id": "LargeHangingStoneSignItem",
          "en": "Large Hanging Stone Sign",
          "fr": "Grand panneau suspendu en pierre",
          "es": "Letrero colgante grande (piedra)",
          "de": "Steinschild (Groß",
          "pt": "큰 걸이형 석재 간판",
          "it": "Большая вывеска из камня",
          "tr": "Large Hanging Stone Sign",
          "pl": "Large Hanging Stone Sign",
          "ru": "大型石制标志",
          "uk": "Large Hanging Stone Sign",
          "ko": " hängend)",
          "zh": "Placa de Pedra Grande Pendurada",
          "ja": "Large Hanging Stone Sign"
        },
        {
          "id": "LargeLumberDoorItem",
          "en": "Large Lumber Door",
          "fr": "Porte de garage en bois d\u0027œuvre",
          "es": "Puerta grande de madera",
          "de": "Große Holztür",
          "pt": "Porta de Madeira Serrada Grande",
          "it": "Grande Porta in Legno",
          "tr": "Büyük Kereste Kapı",
          "pl": "Duże drzwi z drewna",
          "ru": "Деревянные ворота",
          "uk": "Великі дерев’яні двері",
          "ko": "대형 가공목 문",
          "zh": "大木门",
          "ja": "大きな板材のドア"
        },
        {
          "id": "LargeStandingLumberSignItem",
          "en": "Large Standing Lumber Sign",
          "fr": "Grand panneau sur pied en bois d\u0027œuvre",
          "es": "Letrero grande (tablas de madera)",
          "de": "Bauholzschild (Groß",
          "pt": "대형 가공목 간판",
          "it": "Большая табличка из пиломатериалов",
          "tr": "Large Standing Lumber Sign",
          "pl": "Large Standing Lumber Sign",
          "ru": "大块木制标志",
          "uk": "Stort Hængende Skilt i Tømmer",
          "ko": " stehend)",
          "zh": "Placa de Madeira Serrada Grande em Pé",
          "ja": "Large Standing Lumber Sign"
        },
        {
          "id": "LargeStandingStoneSignItem",
          "en": "Large Standing Stone Sign",
          "fr": "Grand panneau sur pied en pierre",
          "es": "Letrero grande (piedra)",
          "de": "Steinschild (Groß",
          "pt": "큰 석재 선간판",
          "it": "Большая табличка из камня",
          "tr": "Large Standing Stone Sign",
          "pl": "Large Standing Stone Sign",
          "ru": "大块石制标志",
          "uk": "Large Standing Stone Sign",
          "ko": " stehend)",
          "zh": "Placa de Pedra Grande em Pé",
          "ja": "Large Standing Stone Sign"
        },
        {
          "id": "LargeWindowedLumberDoorItem",
          "en": "Large Windowed Lumber Door",
          "fr": "Porte de garage vitrée en bois d\u0027œuvre",
          "es": "Puerta de troncos grande con ventana",
          "de": "Große Holztür mit Fenster",
          "pt": "Porta de Madeira Serrada Grande com Janela",
          "it": "Grande Portafinestra in Legno",
          "tr": "باب خشبي بنوافذ كبيرة",
          "pl": "Duże",
          "ru": "Деревянные ворота с окошками",
          "uk": "Velké skleněné dřevěné dveře",
          "ko": "대형 가공목 창문 달린 문",
          "zh": "带窗户的大木门",
          "ja": "窓付きの大きな板材のドア"
        },
        {
          "id": "LatheItem",
          "en": "Lathe",
          "fr": "Tour",
          "es": "Torno",
          "de": "Drehmaschine",
          "pt": "Torno",
          "it": "Tornio",
          "tr": "Torna",
          "pl": "Tokarka",
          "ru": "Токарный станок",
          "uk": "Токарний верстат",
          "ko": "선반",
          "zh": "车床",
          "ja": "旋盤"
        },
        {
          "id": "LumberDoorItem",
          "en": "Lumber Door",
          "fr": "Porte en bois d’œuvre",
          "es": "Puerta de Madera",
          "de": "Bauholztür",
          "pt": "Porta de madeira serrada",
          "it": "Porta in Legno",
          "tr": "Kereste Kapı",
          "pl": "Drzwi z Drewna",
          "ru": "Дверь из пиломатериалов",
          "uk": "Дерев’яні двері",
          "ko": "가공목 문",
          "zh": "木门",
          "ja": "板材のドア"
        },
        {
          "id": "MachinistTableItem",
          "en": "Machinist Table",
          "fr": "Établi de mécanicien",
          "es": "Mesa de maquinista",
          "de": "Mechanikertisch",
          "pt": "Mesa de maquinista",
          "it": "Banco del Macchinista",
          "tr": "Makinist Tezgahı",
          "pl": "Stół mechanika",
          "ru": "Слесарный верстак",
          "uk": "Стіл машиніста",
          "ko": "기계공 작업대",
          "zh": "机械师工作台",
          "ja": "機械工のテーブル"
        },
        {
          "id": "RealEstateDeskItem",
          "en": "Real Estate Desk",
          "fr": "Bureau immobilier",
          "es": "Escritorio inmobiliario",
          "de": "Grundbesitztisch",
          "pt": "Balcão de imóveis",
          "it": "Banco Immobiliare",
          "tr": "Gayrimenkul Masası",
          "pl": "Biuro nieruchomości",
          "ru": "Стол риелтора",
          "uk": "Бюро нерухомості",
          "ko": "부동산 중개소",
          "zh": "房地产交易所",
          "ja": "不動産デスク"
        },
        {
          "id": "RoboticAssemblyLineItem",
          "en": "Robotic Assembly Line",
          "fr": "Ligne de montage robotisée",
          "es": "Línea de Ensamblaje Robótica",
          "de": "Robotische Fertigungsstraße",
          "pt": "Linha de montagem robótica",
          "it": "Catena di Montaggio Robotica",
          "tr": "Robotlu Seri Üretim Hattı",
          "pl": "Zrobotyzowana linia produkcyjna",
          "ru": "Роботизированная сборочная линия",
          "uk": "Роботизована лінія для збору",
          "ko": "자동화 조립 라인",
          "zh": "机器人装配线",
          "ja": "ロボット組立ライン"
        },
        {
          "id": "RugLargeItem",
          "en": "Rug Large",
          "fr": "Grand tapis",
          "es": "Alfombra grande",
          "de": "Großer Teppich",
          "pt": "Tapete Grande",
          "it": "Grande Tappeto",
          "tr": "Büyük Halı",
          "pl": "Duży dywan",
          "ru": "Большой ковёр",
          "uk": "Великий килим",
          "ko": "대형 양탄자",
          "zh": "大号地毯",
          "ja": "大きな絨毯"
        },
        {
          "id": "RugMediumItem",
          "en": "Rug Medium",
          "fr": "Tapis moyen",
          "es": "Alfombra mediana",
          "de": "Mittelgroßer Teppich",
          "pt": "Tapete Médio",
          "it": "Tappeto Medio",
          "tr": "Orta Halı",
          "pl": "Średni dywan",
          "ru": "Средний ковёр",
          "uk": "Середній килим",
          "ko": "중형 양탄자",
          "zh": "中号地毯",
          "ja": "中くらいの絨毯"
        },
        {
          "id": "RugSmallItem",
          "en": "Rug Small",
          "fr": "Petit tapis",
          "es": "Alfombra pequeña",
          "de": "Kleiner Teppich",
          "pt": "Tapete Pequeno",
          "it": "Tappeto Piccolo",
          "tr": "Ufak Halı",
          "pl": "Mały dywan",
          "ru": "Маленький ковёр",
          "uk": "Малий килим",
          "ko": "소형 양탄자",
          "zh": "小号地毯",
          "ja": "小さな絨毯"
        },
        {
          "id": "ScrewPressItem",
          "en": "Screw Press",
          "fr": "Presse à vis",
          "es": "Prensa de tornillos",
          "de": "Spindelpresse",
          "pt": "Prensa de rosca",
          "it": "Pressa a Vite",
          "tr": "Vidalı Pres",
          "pl": "Prasa śrubowa",
          "ru": "Винтовой пресс",
          "uk": "Гвинтовий прес",
          "ko": "압입식 조임 기계",
          "zh": "螺旋压榨机",
          "ja": "ねじプレス"
        },
        {
          "id": "ShaperItem",
          "en": "Shaper",
          "fr": "Étau limeur",
          "es": "Modelador (m.) Modeladora (f.)",
          "de": "Fräsmaschine",
          "pt": "Niveladora",
          "it": "Plasmatrice",
          "tr": "Vargel",
          "pl": "Strugarka",
          "ru": "Строгальный станок",
          "uk": "Стругальний верстат",
          "ko": "형삭반",
          "zh": "刨床",
          "ja": "形削り盤"
        },
        {
          "id": "SmallHangingLumberSignItem",
          "en": "Small Hanging Lumber Sign",
          "fr": "Petit panneau suspendu en bois d\u0027œuvre",
          "es": "Letrero pequeño colgante (troncos)",
          "de": "Bauholzschild (klein",
          "pt": "소형 가공목 현판",
          "it": "Маленькая вывеска из пиломатериалов",
          "tr": "Small Hanging Lumber Sign",
          "pl": "Small Hanging Lumber Sign",
          "ru": "小块木制标志",
          "uk": "Lille Hængende Skilt i Tømmer",
          "ko": " hängend)",
          "zh": "Placa de Madeira Serrada Pequena Pendurada",
          "ja": "Small Hanging Lumber Sign"
        },
        {
          "id": "SmallHangingStoneSignItem",
          "en": "Small Hanging Stone Sign",
          "fr": "Petit panneau suspendu en pierre",
          "es": "Letrero pequeño colgante (piedra)",
          "de": "Steinschild (klein",
          "pt": "작은 걸이형 석재 간판",
          "it": "Маленькая вывеска из камня",
          "tr": "Small Hanging Stone Sign",
          "pl": "Lite Hengende Stein Skilt",
          "ru": "小块石制标志",
          "uk": "Small Hanging Stone Sign",
          "ko": " hängend)",
          "zh": "Placa de Pedra Pequena Pendurada",
          "ja": "Small Hanging Stone Sign"
        },
        {
          "id": "SmallStandingLumberSignItem",
          "en": "Small Standing Lumber Sign",
          "fr": "Petit panneau sur pied en bois d\u0027œuvre",
          "es": "Pequeño letrero de pie de madera",
          "de": "Bauholzschild (klein",
          "pt": "소형 가공목 현판",
          "it": "Маленькая табличка из пиломатериалов",
          "tr": "Small Standing Lumber Sign",
          "pl": "Small Standing Lumber Sign",
          "ru": "小块木制标志",
          "uk": "Lille Stående Skilt i Tømmer",
          "ko": " stehend)",
          "zh": "Placa de Madeira Serrada Pequena em Pé",
          "ja": "Small Standing Lumber Sign"
        },
        {
          "id": "SmallStandingStoneSignItem",
          "en": "Small Standing Stone Sign",
          "fr": "Petit panneau sur pied en pierre",
          "es": "Pequeño letrero de pie de piedra",
          "de": "Steinschild (klein",
          "pt": "작은 석재 선간판",
          "it": "Маленькая табличка из камня",
          "tr": "Small Standing Stone Sign",
          "pl": "Small Standing Stone Sign",
          "ru": "小块石制标志",
          "uk": "Small Standing Stone Sign",
          "ko": " stehend)",
          "zh": "Placa de Pedra Pequena em Pé",
          "ja": "Small Standing Stone Sign"
        },
        {
          "id": "SmallStockpileItem",
          "en": "Small Stockpile",
          "fr": "Réserve petite",
          "es": "Pila de almacenamiento pequeña",
          "de": "Lager (Mittel)",
          "pt": "Estoque em pilha pequeno",
          "it": "Piccola Catasta",
          "tr": "Ufak Stok Yeri",
          "pl": "Mały skład",
          "ru": "Маленький склад",
          "uk": "Мала комора",
          "ko": "소형 자재 창고",
          "zh": "小型料堆",
          "ja": "小さいストックパイル"
        },
        {
          "id": "SteamEngineItem",
          "en": "Steam Engine",
          "fr": "Machine à vapeur",
          "es": "Motor de Vapor",
          "de": "Dampf-Stromgenerator",
          "pt": "Motor à Vapor",
          "it": "Motore a Vapore",
          "tr": "Buhar Motoru",
          "pl": "Silnik parowy",
          "ru": "Паровой двигатель",
          "uk": "Паровий двигун",
          "ko": "증기기관",
          "zh": "蒸汽机",
          "ja": "蒸気発電機"
        },
        {
          "id": "SteelCeilingLightItem",
          "en": "Steel Ceiling Light",
          "fr": "Plafonnier en acier",
          "es": "Lámpara de techo de metal",
          "de": "Stahl-Deckenlampe",
          "pt": "Luminária de Teto de Aço",
          "it": "Luce da Soffitto in Acciaio",
          "tr": "Çelik Tavan Lambası",
          "pl": "Stalowe oświetlenie sufitowe",
          "ru": "Стальной потолочный светильник",
          "uk": "Сталева люстра",
          "ko": "강철 천장등",
          "zh": "钢制顶棚灯",
          "ja": "鋼製の天井ライト"
        },
        {
          "id": "SteelFloorLampItem",
          "en": "Steel Floor Lamp",
          "fr": "Lampadaire en acier",
          "es": "Lámpara de suelo de metal",
          "de": "Stählerne Stehlampe",
          "pt": "Luminária de Piso de Aço",
          "it": "Lampada da Pavimento in Acciaio",
          "tr": "Çelik Yer Lambası",
          "pl": "Stalowa lampa stojąca",
          "ru": "Стальной торшер",
          "uk": "Сталевий торшер",
          "ko": "강철 스탠드 전등",
          "zh": "钢制落地灯",
          "ja": "鋼製の室内灯"
        },
        {
          "id": "SteelTableLampItem",
          "en": "Steel Table Lamp",
          "fr": "Lampe de table en acier",
          "es": "Lampara de acero para mesas",
          "de": "Stahltischlampe",
          "pt": "Luminária de Mesa de Aço",
          "it": "Lampada da Tavolo in Acciaio",
          "tr": "Çelik Masa Lambası",
          "pl": "Stalowa lampka biurowa",
          "ru": "Стальная настольная лампа",
          "uk": "Сталева настільна лампа",
          "ko": "강철 탁자 전등",
          "zh": "钢制台灯",
          "ja": "鋼製の電気スタンド"
        },
        {
          "id": "StoneDoorItem",
          "en": "Stone Door",
          "fr": "Porte en pierre",
          "es": "Puerta de piedra",
          "de": "Steintür",
          "pt": "Porta de Pedra",
          "it": "Porta in Pietra",
          "tr": "Taş Kapı",
          "pl": "Kamienne drzwi",
          "ru": "Каменная дверь",
          "uk": "Кам’яні двері",
          "ko": "석재 문",
          "zh": "石门",
          "ja": "石のドア"
        },
        {
          "id": "StoreItem",
          "en": "Store",
          "fr": "Magasin",
          "es": "Tienda",
          "de": "Shop-Name",
          "pt": "Loja",
          "it": "Negozio",
          "tr": "Mağaza",
          "pl": "Sklep",
          "ru": "Магазин",
          "uk": "Крамниця",
          "ko": "상점",
          "zh": "商店",
          "ja": "お店"
        },
        {
          "id": "StuffedElkItem",
          "en": "Stuffed Elk",
          "fr": "Wapiti empaillé",
          "es": "Alce disecado",
          "de": "Ausgestopfter Wapiti",
          "pt": "Alce Empalhado",
          "it": "Alce Impagliato",
          "tr": "Doldurulmuş Geyik",
          "pl": "Nadziewany Łoś",
          "ru": "Чучело вапити",
          "uk": "Опудало лося",
          "ko": "박제된 엘크",
          "zh": "驼鹿标本",
          "ja": "エルクの剥製"
        },
        {
          "id": "TableItem",
          "en": "Table",
          "fr": "Table",
          "es": "Mesa",
          "de": "Tisch",
          "pt": "Mesa",
          "it": "tavolo",
          "tr": "Masa",
          "pl": "Stół",
          "ru": "Стол",
          "uk": "Стіл",
          "ko": "탁자",
          "zh": "Tisch",
          "ja": "テーブル"
        },
        {
          "id": "TinyStockpileItem",
          "en": "Tiny Stockpile",
          "fr": "Réserve minuscule",
          "es": "Pila de almacenamiento diminuta",
          "de": "Lager (Winzig)",
          "pt": "Estoque em pilha minúsculo",
          "it": "Minuscola Catasta",
          "tr": "Çok Ufak Stok Yeri",
          "pl": "Malutki skład",
          "ru": "Крошечный склад",
          "uk": "Крихітна комора",
          "ko": "초소형 자재 창고",
          "zh": "微型料堆",
          "ja": "すごく小さいストックパイル"
        },
        {
          "id": "WoodenCeilingLightItem",
          "en": "Wooden Ceiling Light",
          "fr": "Plafonnier en bois d\u0027œuvre",
          "es": "Lámpara de techo de madera",
          "de": "Hölzerne Deckenlampe",
          "pt": "Luminária de Teto de Madeira",
          "it": "Lampada da Soffitto in Legno",
          "tr": "Ahşap Tavan Lambası",
          "pl": "Drewniane oświetlenie sufitowe",
          "ru": "Деревянный потолочный светильник",
          "uk": "Дерев’яна люстра",
          "ko": "목제 천장등",
          "zh": "木制顶棚灯",
          "ja": "木製の天井ライト"
        },
        {
          "id": "WoodenFloorLampItem",
          "en": "Wooden Floor Lamp",
          "fr": "Lampadaire en bois d\u0027œuvre",
          "es": "Lámpara de suelo de madera",
          "de": "Hölzerne Stehlampe",
          "pt": "Luminária de Piso de Madeira",
          "it": "Lampada da Pavimento in Legno",
          "tr": "Ahşap Yer Lambası",
          "pl": "Drewniana lampa podłogowa",
          "ru": "Деревянный торшер",
          "uk": "Дерев’яний торшер",
          "ko": "목제 스탠드형 전등",
          "zh": "木制落地灯",
          "ja": "木製の室内灯"
        },
        {
          "id": "WoodenTableLampItem",
          "en": "Wooden Table Lamp",
          "fr": "Lampe de table en bois d\u0027œuvre",
          "es": "Lámpara de madera para mesa",
          "de": "Hölzerne Tischlampe",
          "pt": "Luminária de Mesa de Madeira",
          "it": "Lampada da Tavolo in Legno",
          "tr": "Ahşap Masa Lambası",
          "pl": "Drewniana lampa stołowa",
          "ru": "Деревянная настольная лампа",
          "uk": "Дерев’яний настільна лампа",
          "ko": "목제 탁자 전등",
          "zh": "木制台灯",
          "ja": "木製のテーブルランプ"
        },
        {
          "id": "CompostItem",
          "en": "Compost",
          "fr": "Compost",
          "es": "Abono",
          "de": "Kompost",
          "pt": "Composto",
          "it": "Compost",
          "tr": "Bitki Gübresi",
          "pl": "Kompost",
          "ru": "Компост",
          "uk": "Перегній",
          "ko": "퇴비",
          "zh": "堆肥",
          "ja": "堆肥"
        },
        {
          "id": "SteamTractorItem",
          "en": "Steam Tractor",
          "fr": "Tracteur à vapeur",
          "es": "Tractor a vapor",
          "de": "Dampftraktor",
          "pt": "Trator à Vapor",
          "it": "Trattore a Vapore",
          "tr": "Buharlı Traktör",
          "pl": "Ciągnik Parowy",
          "ru": "Паровой трактор",
          "uk": "Паровий трактор",
          "ko": "증기 트랙터",
          "zh": "蒸汽拖拉机",
          "ja": "蒸気トラクター"
        },
        {
          "id": "Vehicles",
          "en": "Vehicles",
          "fr": "Véhicules",
          "es": "Vehículos",
          "de": "Fahrzeuge",
          "pt": "Veículos",
          "it": "Veicoli",
          "tr": "Araçlar",
          "pl": "Pojazdy",
          "ru": "Техника",
          "uk": "Транспортні засоби",
          "ko": "운송수단",
          "zh": "车辆",
          "ja": "乗り物"
        },
        {
          "id": "Skill Scrolls",
          "en": "Skill Scrolls",
          "fr": "Pages de compétence",
          "es": "Pergaminos de Habilidad",
          "de": "Skilschriftrollen",
          "pt": "Pergaminhos de Habilidade",
          "it": "Pergamene delle Abilità",
          "tr": "Beceri Parşömenleri",
          "pl": "Certyfikaty umiejętności",
          "ru": "Страницы навыков",
          "uk": "Сувої вмінь",
          "ko": "기술 두루마리",
          "zh": "技能卷轴",
          "ja": "スキルスクロール"
        },
        {
          "id": "SkillScrolls",
          "en": "Skill Scrolls",
          "fr": "Pages de compétence",
          "es": "Pergaminos de Habilidad",
          "de": "Skilschriftrollen",
          "pt": "Pergaminhos de Habilidade",
          "it": "Pergamene delle Abilità",
          "tr": "Beceri Parşömenleri",
          "pl": "Certyfikaty umiejętności",
          "ru": "Страницы навыков",
          "uk": "Сувої вмінь",
          "ko": "기술 두루마리",
          "zh": "技能卷轴",
          "ja": "スキルスクロール"
        },
        {
          "id": "Crop",
          "en": "Crop",
          "fr": "Culture",
          "es": "Cultivo",
          "de": "Ernte",
          "pt": "Colheita",
          "it": "Coltura",
          "tr": "Ekin",
          "pl": "Plon",
          "ru": "Урожай",
          "uk": "Зернові",
          "ko": "작물",
          "zh": "作物",
          "ja": "作物"
        },
        {
          "id": "Fuel",
          "en": "Fuel",
          "fr": "Carburant",
          "es": "Combustible",
          "de": "Kraftstoff",
          "pt": "Combustível",
          "it": "Carburante",
          "tr": "Yakıt",
          "pl": "Paliwo",
          "ru": "Топливо",
          "uk": "Паливо",
          "ko": "연료",
          "zh": "燃料",
          "ja": "燃料"
        },
        {
          "id": "Animal",
          "en": "Animal",
          "fr": "Animal",
          "es": "Animal",
          "de": "Tier",
          "pt": "Animal",
          "it": "Animale",
          "tr": "Hayvan",
          "pl": "Zwierzę",
          "ru": "Животное",
          "uk": "Тварина",
          "ko": "동물",
          "zh": "动物",
          "ja": "動物"
        },
        {
          "id": "BankItem",
          "en": "Bank",
          "fr": "Banque",
          "es": "Banco",
          "de": "Banktresor",
          "pt": "Banco",
          "it": "Banca",
          "tr": "Banka",
          "pl": "Bank",
          "ru": "Банк",
          "uk": "Банк",
          "ko": "은행",
          "zh": "银行",
          "ja": "銀行"
        },
        {
          "id": "RegistrarItem",
          "en": "Registrar",
          "fr": "Registre",
          "es": "Registrador",
          "de": "Registrar",
          "pt": "Registradora",
          "it": "Cancelliere",
          "tr": "Kayıt Memuru",
          "pl": "Rejestrator",
          "ru": "Регистратор",
          "uk": "Реєстратор",
          "ko": "직위개설 부서",
          "zh": "登记员",
          "ja": "登録者"
        },
        {
          "id": "SteamTruckItem",
          "en": "Steam Truck",
          "fr": "Camion à vapeur",
          "es": "Camión a vapor",
          "de": "Dampflastwagen",
          "pt": "Caminhão à Vapor",
          "it": "Camion a Vapore",
          "tr": "Buharlı Traktör",
          "pl": "Pojazd parowy",
          "ru": "Паровой грузовик",
          "uk": "Парова вантажівка",
          "ko": "증기기관 트럭",
          "zh": "蒸汽卡车",
          "ja": "蒸気トラック"
        },
        {
          "id": "PumpkinItem",
          "en": "Pumpkin",
          "fr": "Citrouille",
          "es": "Calabaza",
          "de": "Kürbis",
          "pt": "Abóbora",
          "it": "Zucca",
          "tr": "Balkabağı",
          "pl": "Dynia",
          "ru": "Тыква",
          "uk": "Гарбуз",
          "ko": "호박",
          "zh": "南瓜",
          "ja": "カボチャ"
        },
        {
          "id": "PineappleItem",
          "en": "Pineapple",
          "fr": "Ananas",
          "es": "Piña",
          "de": "Ananas",
          "pt": "Abacaxi",
          "it": "Ananas",
          "tr": "Ananas",
          "pl": "Ananas",
          "ru": "Ананас",
          "uk": "Ананас",
          "ko": "파인애플",
          "zh": "菠萝",
          "ja": "パイナップル"
        },
        {
          "id": "PapayaItem",
          "en": "Papaya",
          "fr": "Papaye",
          "es": "Papaya",
          "de": "Papaya",
          "pt": "Mamão",
          "it": "Papaia",
          "tr": "Papaya",
          "pl": "Papaja",
          "ru": "Папайя",
          "uk": "Папая",
          "ko": "파파야",
          "zh": "木瓜",
          "ja": "パパイヤ"
        },
        {
          "id": "OrchidItem",
          "en": "Orchid",
          "fr": "Fleur d\u0027orchidée",
          "es": "Orquidea",
          "de": "Orchidee",
          "pt": "Orquídea",
          "it": "Orchidea",
          "tr": "Orkide",
          "pl": "Orchidea",
          "ru": "Орхидея",
          "uk": "Орхідея",
          "ko": "난초",
          "zh": "兰花",
          "ja": "蘭"
        },
        {
          "id": "LupineItem",
          "en": "Lupine",
          "fr": "Lupin",
          "es": "Lupino",
          "de": "Lupine",
          "pt": "Tremoço",
          "it": "Lupino",
          "tr": "Acı Bakla",
          "pl": "Wilcza",
          "ru": "Люпин",
          "uk": "Люпин",
          "ko": "층층이부채꽃",
          "zh": "羽扇豆",
          "ja": "ルピナス"
        },
        {
          "id": "SinkItem",
          "en": "Sink",
          "fr": "Évier",
          "es": "Fregadero",
          "de": "Spüle",
          "pt": "Pia",
          "it": "Scarico",
          "tr": "Lavabo",
          "pl": "Zlew",
          "ru": "Раковина",
          "uk": "Мушля",
          "ko": "개수대",
          "zh": "下沉",
          "ja": "シンク"
        },
        {
          "id": "TrilliumSeedItem",
          "en": "Trillium Seed",
          "fr": "Graine de trillium",
          "es": "Semilla de trilio",
          "de": "Waldliliensamen",
          "pt": "Semente de Lírio-do-bosque",
          "it": "Semi di Trillium",
          "tr": "Trilyum Tohumu",
          "pl": "Materiał siewny Trillium",
          "ru": "Семечко триллиума",
          "uk": "Насіння трилуму",
          "ko": "연령초 씨앗",
          "zh": "延龄草种子",
          "ja": "トリリウムの種子"
        },
        {
          "id": "TaroSeedItem",
          "en": "Taro Seed",
          "fr": "Graine de taro",
          "es": "Semilla de taro",
          "de": "Samen (Taro)",
          "pt": "Semente de Inhame",
          "it": "Semi di Taro",
          "tr": "Gölevez Tohumu",
          "pl": "Nasiona kolokazji",
          "ru": "Семечко таро",
          "uk": "Насіння таро",
          "ko": "토란 씨앗",
          "zh": "芋头籽",
          "ja": "タロイモの種"
        },
        {
          "id": "SaxifrageSeedItem",
          "en": "Saxifrage Seed",
          "fr": "Graine de saxifrage",
          "es": "Semilla de Saxifraga",
          "de": "Samen (Steinbrech)",
          "pt": "Semente de Saxifraga",
          "it": "Semi di Sassifraga",
          "tr": "Taşkıranotu Tohumu",
          "pl": "Nasiono skalnicy",
          "ru": "Семечко камнеломки",
          "uk": "Насіння ломикаменю",
          "ko": "바위취 씨앗",
          "zh": "虎耳草种子",
          "ja": "ユキノシタの種"
        },
        {
          "id": "RedwoodSeedItem",
          "en": "Redwood Seed",
          "fr": "Graine de séquoia",
          "es": "Semilla de Secuoya",
          "de": "Samen (Rottanne)",
          "pt": "Semente de Sequoia-vermelha",
          "it": "Semi di Sequoia",
          "tr": "Kızılçam Tohumu",
          "pl": "Nasiona sekwoi",
          "ru": "Семечко секвойи",
          "uk": "Насіння секвої",
          "ko": "삼나무 씨앗",
          "zh": "红木种子",
          "ja": "レッドウッドの種"
        },
        {
          "id": "PumpkinSeedItem",
          "en": "Pumpkin Seed",
          "fr": "Graine de citrouille",
          "es": "Semilla de Calabaza",
          "de": "Samen (Kürbis)",
          "pt": "Semente de Abóbora",
          "it": "Semi di Zucca",
          "tr": "Balkabağı Tohumu",
          "pl": "Nasiono dyni",
          "ru": "Семечко тыквы",
          "uk": "Насіння гарбуза",
          "ko": "호박 씨앗",
          "zh": "南瓜种子",
          "ja": "カボチャの種"
        },
        {
          "id": "PineappleSeedItem",
          "en": "Pineapple Seed",
          "fr": "Graine d\u0027ananas",
          "es": "Semilla de Piña",
          "de": "Samen (Ananas)",
          "pt": "Semente de Abacaxi",
          "it": "Semi di Ananas",
          "tr": "Ananas Tohumu",
          "pl": "Nasiono ananasa",
          "ru": "Семечко ананаса",
          "uk": "Насіння ананаса",
          "ko": "파인애플 씨앗",
          "zh": "菠萝种子",
          "ja": "パイナップルの種"
        },
        {
          "id": "PapayaSeedItem",
          "en": "Papaya Seed",
          "fr": "Graine de papaye",
          "es": "Semilla de papaya",
          "de": "Samen (Papaya)",
          "pt": "Semente de Mamão",
          "it": "Seme di Papaya",
          "tr": "Papaya Tohumu",
          "pl": "Nasiono papai",
          "ru": "Семечко папайи",
          "uk": "Насіння папаї",
          "ko": "파파야 씨앗",
          "zh": "番木瓜籽",
          "ja": "パパイヤの種"
        },
        {
          "id": "PalmSeedItem",
          "en": "Palm Seed",
          "fr": "Graine de palmier",
          "es": "Semilla de palmera",
          "de": "Samen (Palme)",
          "pt": "Semente de Palmeira",
          "it": "Semi di Palma",
          "tr": "Palmiye Tohumu",
          "pl": "Nasiono palmy",
          "ru": "Семечко пальмы",
          "uk": "Насіння пальми",
          "ko": "야자나무 씨앗",
          "zh": "棕榈树种子",
          "ja": "ヤシの種"
        },
        {
          "id": "OrchidSeedItem",
          "en": "Orchid Seed",
          "fr": "Graine d’orchidée",
          "es": "Semilla de orquídea",
          "de": "Samen (Orchidee)",
          "pt": "Semente de Orquídea",
          "it": "Semi d\u0027Orchidea",
          "tr": "Orkide Tohumu",
          "pl": "Nasiono orchidei",
          "ru": "Семечко орхидеи",
          "uk": "Насіння орхідеї",
          "ko": "난초 씨앗",
          "zh": "兰花种子",
          "ja": "ランの種"
        },
        {
          "id": "OceanSpraySeedItem",
          "en": "Ocean Spray Seed",
          "fr": "Graine d\u0027holodisque discolore",
          "es": "Semilla de Rocío Oceánico",
          "de": "Samen (Schaumspieren)",
          "pt": "Semente de Holodiscus",
          "it": "Semi di Holodiscus",
          "tr": "Okyanus Spreyi Tohumu",
          "pl": "Nasiono oceanicznych zarośli",
          "ru": "Семечко холодискуcа",
          "uk": "Насіння холодискусу",
          "ko": "넌출월귤 씨앗",
          "zh": "海洋喷雾种子",
          "ja": "オーシャンスプレーの種"
        },
        {
          "id": "LupineSeedItem",
          "en": "Lupine Seed",
          "fr": "Graine de lupin",
          "es": "Semilla de Lupino",
          "de": "Samen (Lupine)",
          "pt": "Semente de Tremoço",
          "it": "Semi di Lupino",
          "tr": "Acı Bakla Tohumu",
          "pl": "Nasiono łubinu",
          "ru": "Семечко люпина",
          "uk": "Насіння люпину",
          "ko": "층층이부채꽃 씨앗",
          "zh": "羽扇豆种子",
          "ja": "ルーピンの種"
        },
        {
          "id": "LatticeMushroomSporesItem",
          "en": "Lattice Mushroom Spores",
          "fr": "Spores de clathre rouge",
          "es": "Esporas de Jaula Roja",
          "de": "Sporen (Roter-Gitterling)",
          "pt": "Esporos de Cogumelo Gaiola-de-bruxa",
          "it": "Spore di Fungo Lanterna",
          "tr": "Örgü Mantarı Sporları",
          "pl": "Zarodniki Kraciastego grzyba",
          "ru": "Споры решёточника красного",
          "uk": "Спори решітника червоного",
          "ko": "붉은바구니버섯 포자",
          "zh": "格子蘑菇孢子",
          "ja": "格子きのこの胞子"
        },
        {
          "id": "HeliconiaSeedItem",
          "en": "Heliconia Seed",
          "fr": "Graine d\u0027heliconia",
          "es": "Semilla de Heliconia",
          "de": "Samen (Helikonien)",
          "pt": "Semente de Helicônia",
          "it": "Semi di Eliconia",
          "tr": "Helikonya Tohumu",
          "pl": "Nasiona Helikonii",
          "ru": "Семечко геликонии",
          "uk": "Насіння геліконії",
          "ko": "극락조화 씨앗",
          "zh": "海芋籽",
          "ja": "ヘリコニアの種"
        },
        {
          "id": "DwarfWillowSeedItem",
          "en": "Dwarf Willow Seed",
          "fr": "Graine de saule herbacé",
          "es": "Semilla de sauce enano",
          "de": "Samen (Krautweiden)",
          "pt": "Semente de Salgueiro-anão",
          "it": "Seme di Salice Nano",
          "tr": "Bodursöğüt Tohumu",
          "pl": "Nasiono wierzby karłowatej",
          "ru": "Семечко ивы травянистой",
          "uk": "Насіння верби трав’яної",
          "ko": "난장이버들 씨앗",
          "zh": "矮柳种子",
          "ja": "ドワーフウィローの種"
        },
        {
          "id": "CookeinaMushroomSporesItem",
          "en": "Cookeina Mushroom Spores",
          "fr": "Spores de cookeina",
          "es": "Esporas de seta copa",
          "de": "Sporen (Cookeina)",
          "pt": "Esporos de Cogumelo Taça-de-vinho",
          "it": "Spore di Fungo Cookeina",
          "tr": "Cookeina Mantarı Sporları",
          "pl": "Zarodniki grzybów czarkowatych",
          "ru": "Споры кукейны",
          "uk": "Спори гриба кукейн",
          "ko": "술잔버섯 포자",
          "zh": "蘑菇孢子",
          "ja": "ウスベニコップタケの胞子"
        },
        {
          "id": "BoleteMushroomSporesItem",
          "en": "Bolete Mushroom Spores",
          "fr": "Spores de cèpe de Bordeaux",
          "es": "Esporas de Seta de Boleto",
          "de": "Sporen (Steinpilz)",
          "pt": "Esporos de Cogumelo Boleto",
          "it": "Spore di Fungo Porcino",
          "tr": "Çörek Mantarı Sporları",
          "pl": "Zarodniki borowików szlachetnych",
          "ru": "Споры белого гриба",
          "uk": "Спори білого гриба",
          "ko": "그물버섯 포자",
          "zh": "香菇孢子",
          "ja": "ヤマドリタケの胞子"
        },
        {
          "id": "BigBluestemSeedItem",
          "en": "Big Bluestem Seed",
          "fr": "Graine de barbon de Gerard",
          "es": "Semilla de Andropogon",
          "de": "Samen (Großer-Blauhalm)",
          "pt": "Semente de Capim-andropogon",
          "it": "Semi di Andropogon Gerarchii",
          "tr": "Hindi Budu Tohumu",
          "pl": "Nasiono palczatki Gerarda",
          "ru": "Семечко бородача Жерара",
          "uk": "Насіння бороданя Жерара",
          "ko": "큰 나도기름새 씨앗",
          "zh": "大须芒草种子",
          "ja": "ビッグブルーステムシード"
        },
        {
          "id": "ArcticWillowSeedItem",
          "en": "Arctic Willow Seed",
          "fr": "Graine de saule arctique",
          "es": "Semilla de Sauce del Ártico",
          "de": "Samen (Arktische-Weide)",
          "pt": "Semente de Salgueiro-do-ártico",
          "it": "Semi di Salice Artico",
          "tr": "Bodur Söğüdü Tohumu",
          "pl": "Nasiono wierzby arktycznej",
          "ru": "Семечко ивы арктической",
          "uk": "Насіння верби арктичної",
          "ko": "북극버들 씨앗",
          "zh": "极地柳种子",
          "ja": "北極ヤナギの種子"
        },
        {
          "id": "AgaveSeedItem",
          "en": "Agave Seed",
          "fr": "Graine d\u0027agave",
          "es": "Semilla de agave",
          "de": "Samen (Agave)",
          "pt": "Semente de Agave",
          "it": "Semi d\u0027Agave",
          "tr": "Sabır Otu Tohumu",
          "pl": "Nasiono agawy",
          "ru": "Семечко агавы",
          "uk": "Насіння агави",
          "ko": "용설란 씨앗",
          "zh": "龙舌兰种子",
          "ja": "アガベの種子"
        },
        {
          "id": "ShaleItem",
          "en": "Shale",
          "fr": "Schiste",
          "es": "Pizarra",
          "de": "Schiefer",
          "pt": "Xisto",
          "it": "Scisto",
          "tr": "Kil",
          "pl": "Łupek",
          "ru": "Сланец",
          "uk": "Сланець",
          "ko": "이판암",
          "zh": "页岩",
          "ja": "頁岩"
        },
        {
          "id": "SandstoneItem",
          "en": "Sandstone",
          "fr": "Grès",
          "es": "Arenisca",
          "de": "Sandstein",
          "pt": "Arenito",
          "it": "Arenaria",
          "tr": "Kumtaşı",
          "pl": "Piaskowiec",
          "ru": "Песчаник",
          "uk": "Пісковик",
          "ko": "사암",
          "zh": "沙石",
          "ja": "砂岩"
        },
        {
          "id": "QuicklimeItem",
          "en": "Quicklime",
          "fr": "Chaux vive",
          "es": "Cal viva",
          "de": "Branntkalk",
          "pt": "Cal Viva",
          "it": "Calce viva",
          "tr": "Taş Kireç",
          "pl": "Wapno palone",
          "ru": "Оксид кальция",
          "uk": "Негашене вапно",
          "ko": "생석회",
          "zh": "生石灰",
          "ja": "生石灰"
        },
        {
          "id": "MountainGoatCarcassItem",
          "en": "Mountain Goat Carcass",
          "fr": "Cadavre de chèvre des montagnes",
          "es": "Cadáver de cabra montesa",
          "de": "Bergziegenkadaver",
          "pt": "Carcaça de Cabra-da-montanha",
          "it": "Carcassa di Capra di Montagna",
          "tr": "Dağ Keçisi Cesedi",
          "pl": "Tusza kozła górskiego",
          "ru": "Туша снежной козы",
          "uk": "Туша снігового козла",
          "ko": "흰바위산양 사체",
          "zh": "高山山羊遗骸",
          "ja": "シロイワヤギの死体"
        },
        {
          "id": "MortaredSandstoneItem",
          "en": "Mortared Sandstone",
          "fr": "Grès cimenté",
          "es": "Arenisca con mortero",
          "de": "Ziegel aus Sandstein",
          "pt": "Arenito argamassado",
          "it": "Arenaria Pestata",
          "tr": "Harçlı Kumtaşı",
          "pl": "Spojony zaprawą piaskowiec",
          "ru": "Строительный песчаник",
          "uk": "Будівельний пісковик",
          "ko": "모르타르 마감 사암",
          "zh": "砂浆石",
          "ja": "砂岩モルタル"
        },
        {
          "id": "MortaredLimestoneItem",
          "en": "Mortared Limestone",
          "fr": "Calcaire cimenté",
          "es": "Piedra caliza con mortero",
          "de": "Ziegel aus Kalkstein",
          "pt": "Calcário argamassado",
          "it": "Calcare Pestato",
          "tr": "Harçlı Kireç Taşı",
          "pl": "Spojony zaprawą wapień",
          "ru": "Строительный известняк",
          "uk": "Будівельний вапняк",
          "ko": "모르타르 마감 석회암",
          "zh": "砂浆石灰石",
          "ja": "石灰モルタル"
        },
        {
          "id": "MortaredGraniteItem",
          "en": "Mortared Granite",
          "fr": "Granite cimenté",
          "es": "Granito con mortero",
          "de": "Ziegel aus Granit",
          "pt": "Granito argamassado",
          "it": "Granito Pestato",
          "tr": "Harçlı Granit",
          "pl": "Spojony zaprawą granit",
          "ru": "Строительный гранит",
          "uk": "Будівельний граніт",
          "ko": "모르타르 마감 화강암",
          "zh": "砂浆花岗岩",
          "ja": "花崗岩モルタル"
        },
        {
          "id": "LimestoneItem",
          "en": "Limestone",
          "fr": "Calcaire",
          "es": "Caliza",
          "de": "Kalkstein",
          "pt": "Calcário",
          "it": "Calcare",
          "tr": "Kireç Taşı",
          "pl": "Wapień",
          "ru": "Известняк",
          "uk": "Вапняк",
          "ko": "석회암",
          "zh": "石灰石",
          "ja": "石灰岩"
        },
        {
          "id": "GraniteItem",
          "en": "Granite",
          "fr": "Granite",
          "es": "Granito",
          "de": "Granit",
          "pt": "Granito",
          "it": "Granito",
          "tr": "Granit",
          "pl": "Granit",
          "ru": "Гранит",
          "uk": "Граніт",
          "ko": "화강암",
          "zh": "花岗岩",
          "ja": "花崗岩"
        },
        {
          "id": "GneissItem",
          "en": "Gneiss",
          "fr": "Gneiss",
          "es": "Gneis",
          "de": "Gneis",
          "pt": "Gnaisse",
          "it": "Gneiss",
          "tr": "Gnays",
          "pl": "Gnejs",
          "ru": "Гнейс",
          "uk": "Гнейс",
          "ko": "편마암",
          "zh": "片麻岩",
          "ja": "片麻岩"
        },
        {
          "id": "DeerCarcassItem",
          "en": "Deer Carcass",
          "fr": "Cadavre de cerf mulet",
          "es": "Cadáver de ciervo",
          "de": "Hirschkadaver",
          "pt": "Carcaça de Cervo",
          "it": "Carcassa di Cervo",
          "tr": "Karaca Cesedi",
          "pl": "Tusza sarny",
          "ru": "Туша чернохвостого оленя",
          "uk": "Туша оленя",
          "ko": "사슴 사체",
          "zh": "黑尾鹿遗骸",
          "ja": "鹿の死体"
        },
        {
          "id": "ClayItem",
          "en": "Clay",
          "fr": "Argile",
          "es": "Arcilla",
          "de": "Lehm",
          "pt": "Argila",
          "it": "Argilla",
          "tr": "Kil",
          "pl": "Glina",
          "ru": "Глина",
          "uk": "Глина",
          "ko": "점토",
          "zh": "黏土",
          "ja": "粘土"
        },
        {
          "id": "BighornCarcassItem",
          "en": "Bighorn Carcass",
          "fr": "Cadavre de mouflon",
          "es": "Cadáver de borrego cimarrón",
          "de": "Dickhornschafskadaver",
          "pt": "Carcaça de Carneiro-selvagem",
          "it": "Carcassa di Pecora delle Montagne Rocciose",
          "tr": "Kanada Koyunu Cesedi",
          "pl": "Tusza muflona",
          "ru": "Туша толсторога",
          "uk": "Туша товсторога",
          "ko": "큰뿔양 사체",
          "zh": "大角羊遗骸",
          "ja": "ビッグホーンの死体"
        },
        {
          "id": "BasaltItem",
          "en": "Basalt",
          "fr": "Basalte",
          "es": "Basalto",
          "de": "Basalt",
          "pt": "Basalto",
          "it": "Basalto",
          "tr": "Bazalt",
          "pl": "Bazalt",
          "ru": "Базальт",
          "uk": "Базальт",
          "ko": "현무암",
          "zh": "玄武岩",
          "ja": "玄武岩"
        },
        {
          "id": "TaroRootItem",
          "en": "Taro Root",
          "fr": "Racine de taro",
          "es": "Raíz de taro",
          "de": "Tarowurzel",
          "pt": "Raiz de inhame",
          "it": "Radice di Taro",
          "tr": "Gölevez Kökü",
          "pl": "Korzeń kolokazji",
          "ru": "Корень таро",
          "uk": "Корінь таро",
          "ko": "토란 뿌리",
          "zh": "芋头根",
          "ja": "タロイモの根"
        },
        {
          "id": "PineappleFriendRiceItem",
          "en": "Pineapple Friend Rice",
          "fr": "Riz frit à l\u0027ananas",
          "es": "Arroz frito con piña",
          "de": "Gebratener Reis mit Ananas",
          "pt": "Arroz frito com abacaxi",
          "it": "Riso Fritto con Ananas",
          "tr": "Ananaslı Pilav",
          "pl": "Twój przyjaciel ryż",
          "ru": "Ананас и его друг рис",
          "uk": "Ананас і його друг рис",
          "ko": "파인애플 볶음밥",
          "zh": "菠萝炒饭",
          "ja": "パイナップルチャーハン"
        },
        {
          "id": "CookeinaMushroomsItem",
          "en": "Cookeina Mushrooms",
          "fr": "Cookeinas",
          "es": "Setas copa",
          "de": "Cookeina",
          "pt": "Cogumelos taça-de-vinho",
          "it": "Funghi Cookeina",
          "tr": "Cookeina Mantarları",
          "pl": "Grzyby czarkowate",
          "ru": "Кукейна",
          "uk": "Гриби кукейн",
          "ko": "술잔버섯",
          "zh": "大孢毛菇",
          "ja": "ウスベニコップタケ"
        },
        {
          "id": "CharredTaroItem",
          "en": "Charred Taro",
          "fr": "Taro carbonisé",
          "es": "Taro Carbonizado",
          "de": "Gegrillter Taro",
          "pt": "Inhame tostado",
          "it": "Taro Carbonizzato",
          "tr": "Pişmiş Gölevez",
          "pl": "Opiekana Kolokazja",
          "ru": "Таро на углях",
          "uk": "Обвуглене таро",
          "ko": "그슬린 토란",
          "zh": "烧焦的芋头",
          "ja": "焦げたタロイモ"
        },
        {
          "id": "CharredPineappleItem",
          "en": "Charred Pineapple",
          "fr": "Ananas carbonisé",
          "es": "Piña Carbonizada",
          "de": "Gegrillte Ananas",
          "pt": "Abacaxi tostado",
          "it": "Ananas Carbonizzato",
          "tr": "Pişmiş Ananas",
          "pl": "Opiekany Ananas",
          "ru": "Ананас на углях",
          "uk": "Обвуглений ананас",
          "ko": "그슬린 파인애플",
          "zh": "烧焦的菠萝",
          "ja": "焦げたパイナップル"
        },
        {
          "id": "CharredPapayaItem",
          "en": "Charred Papaya",
          "fr": "Papaye carbonisée",
          "es": "Papaya Carbonizada",
          "de": "Gegrillte Papaya",
          "pt": "Mamão tostado",
          "it": "Papaya Carbonizzata",
          "tr": "Pişmiş Papaya",
          "pl": "Opiekana papaja",
          "ru": "Папайя на углях",
          "uk": "Обвуглена папая",
          "ko": "그슬린 파파야",
          "zh": "烧焦的木瓜",
          "ja": "焦げたパパイヤ"
        },
        {
          "id": "CharredAgaveItem",
          "en": "Charred Agave",
          "fr": "Agave carbonisé",
          "es": "Agave carbonizado",
          "de": "Gegrillte Agave",
          "pt": "Agave tostado",
          "it": "Agave Carbonizzata",
          "tr": "Pişmiş Sabır Otu",
          "pl": "Opiekana Agawa",
          "ru": "Агава на углях",
          "uk": "Обвуглена агава",
          "ko": "그슬린 용설란",
          "zh": "烧焦的龙舌兰",
          "ja": "焦げたリュウゼツラン"
        },
        {
          "id": "BoleteMushroomsItem",
          "en": "Bolete Mushrooms",
          "fr": "Cèpes de Bordeaux",
          "es": "Setas de Boleto",
          "de": "Steinpilze",
          "pt": "Cogumelos boleto",
          "it": "Funghi Porcini",
          "tr": "Çörek Mantarları",
          "pl": "Borowiki szlachetne",
          "ru": "Белые грибы",
          "uk": "Білі гриби",
          "ko": "그물버섯",
          "zh": "牛肝菌菇",
          "ja": "ヤマドリタケ"
        },
        {
          "id": "BoiledRiceItem",
          "en": "Boiled Rice",
          "fr": "Riz bouilli",
          "es": "Arroz Hervido",
          "de": "Gekochter Reis",
          "pt": "Arroz cozido",
          "it": "Riso Bollito",
          "tr": "Haşlanmış Pirinç",
          "pl": "Gotowany ryż",
          "ru": "Отварной рис",
          "uk": "Варений рис",
          "ko": "삶은 쌀",
          "zh": "煮熟的米",
          "ja": "茹でた米"
        },
        {
          "id": "BakedAgaveItem",
          "en": "Baked Agave",
          "fr": "Agave au four",
          "es": "Agave cocinado",
          "de": "Gebackene Agave",
          "pt": "Agave assado",
          "it": "Agave Cotta",
          "tr": "Kavrulmuş Sabır Otu",
          "pl": "Pieczona agawa",
          "ru": "Запечённая агава",
          "uk": "Запечена агава",
          "ko": "구운 용설란",
          "zh": "烘焙过的龙舌兰",
          "ja": "焼いたリュウゼツラン"
        },
        {
          "id": "AgaveLeavesItem",
          "en": "Agave Leaves",
          "fr": "Feuille d\u0027agave",
          "es": "Hojas de agave",
          "de": "Agavenblätter",
          "pt": "Folhas de agave",
          "it": "Foglie d\u0027Agave",
          "tr": "Sabır Otu Yaprakları",
          "pl": "Liście Agawy",
          "ru": "Листья агавы",
          "uk": "Листя агави",
          "ko": "용설란 잎",
          "zh": "龙舌兰叶子",
          "ja": "リュウゼツランの葉"
        },
        {
          "id": "SaguaroSeedItem",
          "en": "Saguaro Seed",
          "fr": "Graine de saguaro",
          "es": "Semilla de saguaro",
          "de": "Samen (Saguaro-Kaktus)",
          "pt": "Semente de Saguaro",
          "it": "Semi di Cactus Saguaro",
          "tr": "Saguaro Tohumu",
          "pl": "Nasiono karnegii",
          "ru": "Семечко карнегии",
          "uk": "Насіння діжкового кактусу",
          "ko": "변경주선인장 씨앗",
          "zh": "树形仙人掌种子",
          "ja": "サグアロサボテンの種"
        },
        {
          "id": "KingFernSporeItem",
          "en": "King Fern Spore",
          "fr": "Spores de fougère royale",
          "es": "Espora de helecho real",
          "de": "Sporen (Königsfarn)",
          "pt": "Esporo de Samambaia Rei",
          "it": "Spore di felce Reale",
          "tr": "Kral Eğreltisi Sporu",
          "pl": "Zarodnik paproci królewskiej",
          "ru": "Спора королевского папоротника",
          "uk": "Спори королівської папороті",
          "ko": "왕고비 포자",
          "zh": "国王蕨孢子",
          "ja": "ゼンマイの胞子"
        },
        {
          "id": "FilmyFernSporeItem",
          "en": "Filmy Fern Spore",
          "fr": "Spores d\u0027hyménophylle",
          "es": "Espora de Helechos Película",
          "de": "Sporen (Schleierfarn)",
          "pt": "Esporo de Samambaia Membranosa",
          "it": "Spore Felce Tropicale",
          "tr": "Şeffaf Eğrelti Otu Sporu",
          "pl": "Zarodnik paproci",
          "ru": "Спора тонколистника",
          "uk": "Спори Тонколистника",
          "ko": "처녀이끼 포자",
          "zh": "瓶蕨袍子",
          "ja": "マメゴケシダの胞子"
        },
        {
          "id": "HeartOfPalmItem",
          "en": "Heart Of Palm",
          "fr": "Cœur de palmier",
          "es": "Palmito",
          "de": "Palmherz",
          "pt": "Palmito",
          "it": "Cuore di Palma",
          "tr": "Palmiye Çekirdeği",
          "pl": "Serce palmy",
          "ru": "Сердцевина пальмы",
          "uk": "Серцевина пальми",
          "ko": "야자심",
          "zh": "棕榈心",
          "ja": "ヤシの芯"
        },
        {
          "id": "CompostFertilizerItem",
          "en": "Compost Fertilizer",
          "fr": "Engrais de compost",
          "es": "Fertilizante de abono orgánico",
          "de": "Dünger aus Kompost",
          "pt": "Fertilizante Composto",
          "it": "Concime fertilizzante",
          "tr": "Doğal Gübre",
          "pl": "Nawóz z kompostu",
          "ru": "Компостное удобрение",
          "uk": "Компостне добриво",
          "ko": "퇴비 비료",
          "zh": "堆肥",
          "ja": "堆肥肥料"
        },
        {
          "id": "WasteFilterItem",
          "en": "Waste Filter",
          "fr": "Filtre à déchets",
          "es": "Filtro de Residuos",
          "de": "Wasserfilter",
          "pt": "Filtro de Resíduos",
          "it": "Filtro dei rifiuti",
          "tr": "Atık Filtresi",
          "pl": "Filtr Odpadów",
          "ru": "Сточный фильтр",
          "uk": "Фільтр відходів",
          "ko": "폐수 여과장치",
          "zh": "废物过滤器",
          "ja": "廃棄物フィルター"
        },
        {
          "id": "CeibaSeedItem",
          "en": "Ceiba Seed",
          "fr": "Graine de ceiba",
          "es": "Semilla de ceiba",
          "de": "Samen (Kapokbaum)",
          "pt": "Semente de Ceiba",
          "it": "Seme di cedro",
          "tr": "Floş Ağacı Tohumu",
          "pl": "Nasiono Puchowca",
          "ru": "Семечко сейбы",
          "uk": "Бавовняне насіння",
          "ko": "명주나무 씨앗",
          "zh": "雪松种子",
          "ja": "パンヤノキの種"
        },
        {
          "id": "Fat",
          "en": "Fat",
          "fr": "Matières grasses",
          "es": "Grasa",
          "de": "Fett",
          "pt": "Gorduras",
          "it": "Grasso",
          "tr": "Yağ",
          "pl": "Tłuszcz",
          "ru": "Жиры",
          "uk": "Жир",
          "ko": "지방",
          "zh": "脂肪",
          "ja": "脂質"
        },
        {
          "id": "BathroomItem",
          "en": "Bathroom",
          "fr": "Salle de bain",
          "es": "Cuarto de baño",
          "de": "Badezimmer",
          "pt": "Banheiro",
          "it": "Bagno",
          "tr": "Banyo",
          "pl": "Łazienka",
          "ru": "Ванная",
          "uk": "Ванна кімната",
          "ko": "욕실",
          "zh": "浴室",
          "ja": "バスルーム"
        },
        {
          "id": "BedroomItem",
          "en": "Bedroom",
          "fr": "Chambre",
          "es": "Dormitorio",
          "de": "Schlafzimmer",
          "pt": "Quarto",
          "it": "Camera da Letto",
          "tr": "Yatak Odası",
          "pl": "Sypialnia",
          "ru": "Спальня",
          "uk": "Спальня",
          "ko": "침실",
          "zh": "卧室",
          "ja": "ベッドルーム"
        },
        {
          "id": "MechanicalWaterPumpItem",
          "en": "Mechanical Water Pump",
          "fr": "Pompe à eau mécanique",
          "es": "Bomba de agua mecánica",
          "de": "Mechanische Wasserpumpe",
          "pt": "Bomba de Água Mecânica",
          "it": "Pompa Idraulica Meccanica",
          "tr": "Mekanik Su Pompası",
          "pl": "Mechaniczna pompa wodna",
          "ru": "Механический водяной насос",
          "uk": "Механічний водяний насос",
          "ko": "기계식 양수기",
          "zh": "机械能水泵",
          "ja": "機械式ウォーター ポンプ"
        },
        {
          "id": "ElectricWaterPumpItem",
          "en": "Electric Water Pump",
          "fr": "Pompe à eau électrique",
          "es": "Bomba de agua eléctrica",
          "de": "Elektrische Wasserpumpe",
          "pt": "Bomba de Água Elétrica",
          "it": "Pompa Idraulica Elettrica",
          "tr": "Elektrikli Su Pompası",
          "pl": "Elektryczna pompa wodna",
          "ru": "Электрический водяной насос",
          "uk": "Електричний водяний насос",
          "ko": "전기식 양수기",
          "zh": "电动水泵",
          "ja": "電動ウォーター ポンプ"
        },
        {
          "id": "WhiteBursageSeedItem",
          "en": "White Bursage Seed",
          "fr": "Graine de bursage blanc",
          "es": "Semilla de ambrosía",
          "de": "Samen (Traubenkraut)",
          "pt": "Semente de Ambrosia Dumosa",
          "it": "Semi di Ambrosia Dumosa",
          "tr": "Beyaz Gömme Tohumu",
          "pl": "Nasiona Ambrozji dumosa",
          "ru": "Семечко амброзии кустарниковой",
          "uk": "Насіння амброзії кущової",
          "ko": "하얀 버세지 씨앗",
          "zh": "白豚草种子",
          "ja": "ブタクサの種"
        },
        {
          "id": "JoshuaSeedItem",
          "en": "Joshua Seed",
          "fr": "Graine de josué",
          "es": "Semilla de árbol de Josué",
          "de": "Samen (Josua-Baum)",
          "pt": "Semente de Árvore de Josué",
          "it": "Semi d\u0027albero di Giosuè",
          "tr": "Joshua Tohumu",
          "pl": "Nasiona jukki",
          "ru": "Семечко юкки коротколистной",
          "uk": "Насіння юкки коротколистної",
          "ko": "여호수아 나무 씨앗",
          "zh": "约书亚树种子",
          "ja": "ジョシュア・ツリーの種"
        },
        {
          "id": "BarrelCactusSeedItem",
          "en": "Barrel Cactus Seed",
          "fr": "Graine de coussin de belle-mère",
          "es": "Semilla de cactus erizo",
          "de": "Samen (Kugelkaktus)",
          "pt": "Semente de Cacto-barril",
          "it": "Semi di Grusone",
          "tr": "Fıçı Kaktüsü Tohumu",
          "pl": "Nasiona okrągłego kaktusa",
          "ru": "Семечко бочкообразного кактуса",
          "uk": "Насіння діжкового кактуса",
          "ko": "고슴도치 선인장 씨앗",
          "zh": "桶形仙人掌种子",
          "ja": "バレルサボテンの種"
        },
        {
          "id": "OtterCarcassItem",
          "en": "Otter Carcass",
          "fr": "Cadavre de loutre",
          "es": "Cadáver de nutria",
          "de": "Otterkadaver",
          "pt": "Carcaça de Lontra",
          "it": "Carcassa di Lontra",
          "tr": "Su Samuru Cesedi",
          "pl": "Tusza wydry",
          "ru": "Туша выдры",
          "uk": "Туша видри",
          "ko": "수달 사체",
          "zh": "水獭遗骸",
          "ja": "カワウソの死体"
        },
        {
          "id": "SpruceSeedItem",
          "en": "Spruce Seed",
          "fr": "Graine d\u0027épicéa",
          "es": "Semilla de abeto",
          "de": "Samen (Fichte)",
          "pt": "Semente de Pinheiro",
          "it": "Semi di Abete Rosso",
          "tr": "Alaçam Tohumu",
          "pl": "Nasiona świerku",
          "ru": "Семечко ели",
          "uk": "Насіння ялинки",
          "ko": "가문비나무 씨앗",
          "zh": "云杉种子",
          "ja": "松の種"
        },
        {
          "id": "MortarItem",
          "en": "Mortar",
          "fr": "Mortier",
          "es": "Mortero",
          "de": "Mörtel",
          "pt": "Argamassa",
          "it": "Malta",
          "tr": "Harç",
          "pl": "Zaprawa",
          "ru": "Строительный раствор",
          "uk": "Будівельний розчин",
          "ko": "모르타르",
          "zh": "砂浆",
          "ja": "モルタル"
        },
        {
          "id": "SunflowerItem",
          "en": "Sunflower",
          "fr": "Tournesol",
          "es": "Girasol",
          "de": "Sonnenblume",
          "pt": "Girassol",
          "it": "Girasole",
          "tr": "Ay Çiçeği",
          "pl": "Słonecznik",
          "ru": "Подсолнечник",
          "uk": "Соняшник",
          "ko": "해바라기",
          "zh": "向日葵",
          "ja": "ひまわり"
        },
        {
          "id": "SunflowerSeedItem",
          "en": "Sunflower Seed",
          "fr": "Graine de tournesol",
          "es": "Semilla de girasol",
          "de": "Samen (Sonnenblume)",
          "pt": "Semente de Girassol",
          "it": "Semi di Girasole",
          "tr": "Ay Çiçeği Tohumu",
          "pl": "Nasiona słonecznika",
          "ru": "Семечко подсолнечника",
          "uk": "Насіння соняшника",
          "ko": "해바라기 씨앗",
          "zh": "向日葵种子",
          "ja": "ひまわりの種"
        },
        {
          "id": "SeagrassSeedItem",
          "en": "Seagrass Seed",
          "fr": "Graine d\u0027herbier marin",
          "es": "Semilla de alga marina",
          "de": "Samen (Seegras)",
          "pt": "Semente de Planta Marinha",
          "it": "Semi di Erba di Mare",
          "tr": "Deniz Yosunu Tohumu",
          "pl": "Nasiona trawy morskiej",
          "ru": "Семечко водоросли",
          "uk": "Насіння водоростей",
          "ko": "해초 씨앗",
          "zh": "海草种子",
          "ja": "海藻の種"
        },
        {
          "id": "JointfirSeedItem",
          "en": "Jointfir Seed",
          "fr": "Graine d\u0027éphédra",
          "es": "Semilla de efedra",
          "de": "Samen (Meerträubel)",
          "pt": "Semente de Efedra",
          "it": "Semi di Efedra",
          "tr": "Efedra Tohumu",
          "pl": "Nasiona przęśli",
          "ru": "Семечко хвойника",
          "uk": "Насіння ефедри",
          "ko": "마황 씨앗",
          "zh": "麻黄种子",
          "ja": "麻黄の種"
        },
        {
          "id": "Power",
          "en": "Power",
          "fr": "Énergie",
          "es": "Energía",
          "de": "Leistung",
          "pt": "Energia",
          "it": "Energia",
          "tr": "Güç",
          "pl": "Moc",
          "ru": "Энергия",
          "uk": "Енергія",
          "ko": "전력",
          "zh": "能源",
          "ja": "動力"
        },
        {
          "id": "Research",
          "en": "Research",
          "fr": "Recherche",
          "es": "Investigar",
          "de": "Forschung",
          "pt": "Pesquisa",
          "it": "Ricerca",
          "tr": "Araştırma",
          "pl": "Badania",
          "ru": "Исследование",
          "uk": "Дослідження",
          "ko": "연구",
          "zh": "研究",
          "ja": "研究"
        },
        {
          "id": "Block",
          "en": "Block",
          "fr": "Bloc",
          "es": "Bloque",
          "de": "Block",
          "pt": "Bloco",
          "it": "Blocco",
          "tr": "Blok",
          "pl": "Blokada",
          "ru": "Блок",
          "uk": "Блок",
          "ko": "블록",
          "zh": "地块",
          "ja": "ブロック"
        },
        {
          "id": "StoneSickleItem",
          "en": "Stone Sickle",
          "fr": "Faucille en pierre",
          "es": "Hoz de piedra",
          "de": "Steinsichel",
          "pt": "Foice de Pedra",
          "it": "Falce di Pietra",
          "tr": "Taş Orak",
          "pl": "Kamienny sierp",
          "ru": "Каменный серп",
          "uk": "Кам\u0027яний серп",
          "ko": "돌 낫",
          "zh": "石质镰刀",
          "ja": "石のカマ"
        },
        {
          "id": "StoneRoadToolItem",
          "en": "Stone Road Tool",
          "fr": "Outil de route en pierre",
          "es": "Herramienta compactadora de piedra",
          "de": "Steinstraßenwerkzeug",
          "pt": "Ferramenta de Estrada de Pedra",
          "it": "Strumento Strada in Pietra",
          "tr": "Taş Yol Aracı",
          "pl": "Kamienne narzędzie do dróg",
          "ru": "Каменная трамбовка",
          "uk": "Кам\u0027яний дорожній інструмент",
          "ko": "돌 도로정비 도구",
          "zh": "石质道路工具",
          "ja": "石の舗装ツール"
        },
        {
          "id": "StoneMacheteItem",
          "en": "Stone Machete",
          "fr": "Machette en pierre",
          "es": "Machete de piedra",
          "de": "Steinmachete",
          "pt": "Facão de Pedra",
          "it": "Machete di Pietra",
          "tr": "Taş Pala",
          "pl": "Kamienna maczeta",
          "ru": "Каменное мачете",
          "uk": "Кам\u0027яне мачете",
          "ko": "돌 마체테",
          "zh": "石质砍刀",
          "ja": "石のマチェーテ"
        },
        {
          "id": "SteelSickleItem",
          "en": "Steel Sickle",
          "fr": "Faucille en acier",
          "es": "Hoz de acero",
          "de": "Stahlsichel",
          "pt": "Foice de Aço",
          "it": "Falce d\u0027Acciaio",
          "tr": "Çelik Orak",
          "pl": "Stalowy sierp",
          "ru": "Стальной серп",
          "uk": "Стальний серп",
          "ko": "강철 낫",
          "zh": "钢质镰刀",
          "ja": "鋼のカマ"
        },
        {
          "id": "SteelMacheteItem",
          "en": "Steel Machete",
          "fr": "Machette en acier",
          "es": "Machete de acero",
          "de": "Stahlmachete",
          "pt": "Facão de Aço",
          "it": "Machete d\u0027Acciaio",
          "tr": "Çelik Pala",
          "pl": "Stalowa maczeta",
          "ru": "Стальное мачете",
          "uk": "Стальне мачете",
          "ko": "강철 마체테",
          "zh": "钢质砍刀",
          "ja": "鋼のマチェーテ"
        },
        {
          "id": "ModernMacheteItem",
          "en": "Modern Machete",
          "fr": "Machette moderne",
          "es": "Machete moderno",
          "de": "Moderne Machete",
          "pt": "Facão Moderno",
          "it": "Machete Moderno",
          "tr": "Modern Pala",
          "pl": "Nowoczesna maczeta",
          "ru": "Современное мачете",
          "uk": "Сучасне мачете",
          "ko": "현대식 마체테",
          "zh": "现代砍刀",
          "ja": "近代的なマチェーテ"
        },
        {
          "id": "IronMacheteItem",
          "en": "Iron Machete",
          "fr": "Machette en fer",
          "es": "Machete de hierro",
          "de": "Eisenmachete",
          "pt": "Facão de Ferro",
          "it": "Machete di Ferro",
          "tr": "Demir Pala",
          "pl": "Żelazna maczeta",
          "ru": "Железное мачете",
          "uk": "Залізне мачете",
          "ko": "철 마체테",
          "zh": "铁质砍刀",
          "ja": "鉄のマチェーテ"
        },
        {
          "id": "Wood",
          "en": "Wood",
          "fr": "Bois",
          "es": "Madera",
          "de": "Holz",
          "pt": "Madeira",
          "it": "Legno",
          "tr": "Odun",
          "pl": "Drewno",
          "ru": "Дерево",
          "uk": "Деревина",
          "ko": "나무",
          "zh": "木",
          "ja": "木材"
        },
        {
          "id": "CanvasItem",
          "en": "Canvas",
          "fr": "Toile",
          "es": "Tela",
          "de": "Leinwand",
          "pt": "Tela",
          "it": "Tela",
          "tr": "Tuval",
          "pl": "Płótno",
          "ru": "Холст",
          "uk": "Полотно",
          "ko": "캔버스",
          "zh": "帆布",
          "ja": "キャンバス"
        },
        {
          "id": "Metal",
          "en": "Metal",
          "fr": "Métal",
          "es": "Metal",
          "de": "Metall",
          "pt": "Metal",
          "it": "Metallo",
          "tr": "Metal",
          "pl": "Metal",
          "ru": "Металл",
          "uk": "Метал",
          "ko": "금속",
          "zh": "金属",
          "ja": "金属"
        },
        {
          "id": "CodItem",
          "en": "Cod",
          "fr": "Morue",
          "es": "Bacalao",
          "de": "Kabeljau",
          "pt": "Bacalhau",
          "it": "Merluzzo",
          "tr": "Morina",
          "pl": "Dorsz",
          "ru": "Треска",
          "uk": "Тріска",
          "ko": "대구",
          "zh": "鳕鱼",
          "ja": "タラ"
        },
        {
          "id": "BassItem",
          "en": "Bass",
          "fr": "Bar",
          "es": "Lubina",
          "de": "Barsch",
          "pt": "Robalo",
          "it": "Branzino",
          "tr": "Levrek",
          "pl": "Okoń",
          "ru": "Окунь",
          "uk": "Морський окунь",
          "ko": "큰입우럭",
          "zh": "鲈鱼",
          "ja": "バス"
        },
        {
          "id": "ZoningOfficeItem",
          "en": "Zoning Office",
          "fr": "Bureau du territoire",
          "es": "Oficina territorial",
          "de": "Planungs- und Bauamt",
          "pt": "Escritório de Zoneamento",
          "it": "Ufficio Zonale",
          "tr": "İmar Ofisi",
          "pl": "Biuro zagospodarowania przestrzennego",
          "ru": "Офис зонирования",
          "uk": "Офіс зонування",
          "ko": "토지관리 부서",
          "zh": "分区办公室",
          "ja": "区画整理局"
        },
        {
          "id": "ToolBenchItem",
          "en": "Tool Bench",
          "fr": "Établi d\u0027outillage",
          "es": "Mesa de herramientas",
          "de": "Werkzeugtisch",
          "pt": "Bancada de ferramentas",
          "it": "Banco degli Attrezzi",
          "tr": "Alet Tezgahı",
          "pl": "Stół narzędziowy",
          "ru": "Стол для инструментов",
          "uk": "Стіл для інструментів",
          "ko": "도구 작업대",
          "zh": "工具台",
          "ja": "ツール制作台"
        },
        {
          "id": "StampMillItem",
          "en": "Stamp Mill",
          "fr": "Concasseur à percussions",
          "es": "Molino de pisón",
          "de": "Pochwerk",
          "pt": "Moinho de carimbo",
          "it": "Mulino a Stampo",
          "tr": "Maden Değirmeni",
          "pl": "Kruszarka",
          "ru": "Штамповочная мельница",
          "uk": "Штамповий млин",
          "ko": "쇄광기",
          "zh": "捣矿机",
          "ja": "砕鉱機"
        },
        {
          "id": "SoftwoodLumberTableItem",
          "en": "Softwood Lumber Table",
          "fr": "Table en bois d\u0027œuvre tendre",
          "es": "Mesa de troncos (madera blanda)",
          "de": "Bauholztisch aus Weichholz",
          "pt": "Mesa de Madeira Macia Serrada",
          "it": "Tavolo in Legno di Conifere",
          "tr": "Yumuşak Odundan Kereste Masa",
          "pl": "Stół z drewna iglastego",
          "ru": "Стол из пиломатериалов хвойных пород",
          "uk": "Стіл з хвойних порід деревини",
          "ko": "가공된 연목 탁자",
          "zh": "软木木质桌",
          "ja": "針葉樹の板材テーブル"
        },
        {
          "id": "SoftwoodLumberDoorItem",
          "en": "Softwood Lumber Door",
          "fr": "Porte en bois d\u0027œuvre tendre",
          "es": "Puerta de troncos (madera blanda)",
          "de": "Bauholztür aus Weichholz",
          "pt": "Porta de Madeira Macia Serrada",
          "it": "Porta in Legno di Conifere",
          "tr": "Yumuşak Odundan Kereste Kapı",
          "pl": "Drzwi z drewna iglastego",
          "ru": "Дверь из пиломатериалов хвойных пород",
          "uk": "Двері з хвойних порід деревини",
          "ko": "가공된 연목재 문",
          "zh": "软木木质门",
          "ja": "針葉樹の板材のドア"
        },
        {
          "id": "SoftwoodLumberChairItem",
          "en": "Softwood Lumber Chair",
          "fr": "Chaise en bois d\u0027œuvre tendre",
          "es": "Silla de troncos (madera blanda)",
          "de": "Bauholzstuhl aus Weichholz",
          "pt": "Cadeira de Madeira Macia Serrada",
          "it": "Sedia in Legno di Conifere",
          "tr": "Yumuşak Odundan Kereste Sandalye",
          "pl": "Krzesło z drewna iglastego",
          "ru": "Стул из пиломатериалов хвойных пород",
          "uk": "Стільчик з хвойних порід деревини",
          "ko": "가공된 연목 의자",
          "zh": "软木木质椅子",
          "ja": "針葉樹の板材の椅子"
        },
        {
          "id": "SoftwoodLumberBenchItem",
          "en": "Softwood Lumber Bench",
          "fr": "Banc en bois d\u0027œuvre tendre",
          "es": "Banco de troncos (madera blanda)",
          "de": "Bauholzbank aus Weichholz",
          "pt": "Banco de Madeira Macia Serrada",
          "it": "Panca in Legno di Conifere",
          "tr": "Yumuşak Odun Kerestesi Tezgahı",
          "pl": "Ławka z drewna iglastego",
          "ru": "Лавка из пиломатериалов хвойных пород",
          "uk": "Лавка з хвойних порід деревини",
          "ko": "가공된 연목 벤치",
          "zh": "软木木质长凳",
          "ja": "針葉樹の板材のベンチ"
        },
        {
          "id": "SmallStandingWoodSignItem",
          "en": "Small Standing Wood Sign",
          "fr": "Petit panneau sur pied en bois",
          "es": "Letrero pequeño (básico)",
          "de": "Holzschild (klein",
          "pt": "작은 목재 선간판",
          "it": "Маленькая деревянная табличка",
          "tr": "Small Standing Wood Sign",
          "pl": "Small Standing Wood Sign",
          "ru": "小型立式木质标志",
          "uk": "Small Standing Wood Sign",
          "ko": " stehend)",
          "zh": "Placa de Madeira Pequena em Pé",
          "ja": "Small Standing Wood Sign"
        },
        {
          "id": "SmallStandingSpruceSignItem",
          "en": "Small Standing Spruce Sign",
          "fr": "Petit panneau sur pied en épicéa",
          "es": "Letrero pequeño (pícea)",
          "de": "Holzschild aus Fichte (klein",
          "pt": "소형 가문비나무 간판",
          "it": "Маленькая еловая табличка",
          "tr": "Small Standing Spruce Sign",
          "pl": "Small Standing Spruce Sign",
          "ru": "小型立式云杉标志",
          "uk": "Small Standing Spruce Sign",
          "ko": " stehend)",
          "zh": "Placa de Pinheiro Pequena em Pé",
          "ja": "Small Standing Spruce Sign"
        },
        {
          "id": "SmallStandingSoftwoodSignItem",
          "en": "Small Standing Softwood Sign",
          "fr": "Petit panneau sur pied en bois tendre",
          "es": "Letrero pequeño (madera blanda)",
          "de": "Holzschild aus Weichholz (klein",
          "pt": "소형 연목재 간판",
          "it": "Маленькая табличка из хвойных пород",
          "tr": "Small Standing Softwood Sign",
          "pl": "Small Standing Softwood Sign",
          "ru": "小型立式软木标志",
          "uk": "Small Standing Softwood Sign",
          "ko": " stehend)",
          "zh": "Placa de Madeira Macia Pequena em Pé",
          "ja": "Small Standing Softwood Sign"
        },
        {
          "id": "SmallStandingSaguaroSignItem",
          "en": "Small Standing Saguaro Sign",
          "fr": "Petit panneau sur pied en saguaro",
          "es": "Letrero pequeño (saguaro)",
          "de": "Holzschild aus Kaktusholz (klein",
          "pt": "소형 변경주선인장 간판",
          "it": "Маленькая табличка из карнегии",
          "tr": "Small Standing Saguaro Sign",
          "pl": "Small Standing Saguaro Sign",
          "ru": "小型立式柱仙人掌标志",
          "uk": "Small Standing Saguaro Sign",
          "ko": " stehend)",
          "zh": "Placa de Saguaro Pequena em Pé",
          "ja": "Small Standing Saguaro Sign"
        },
        {
          "id": "SmallStandingRedwoodSignItem",
          "en": "Small Standing Redwood Sign",
          "fr": "Petit panneau sur pied en séquoia",
          "es": "Letrero pequeño (secuoya)",
          "de": "Holzschild aus Rottanne (klein",
          "pt": "소형 붉은삼나무 간판",
          "it": "Маленькая табличка из секвойи",
          "tr": "Small Standing Redwood Sign",
          "pl": "Small Standing Redwood Sign",
          "ru": "小型立式红木标志",
          "uk": "Lille stående Rødtræskilt",
          "ko": " stehend)",
          "zh": "Placa de Sequoia-vermelha Pequena em Pé",
          "ja": "Small Standing Redwood Sign"
        },
        {
          "id": "SmallStandingPalmSignItem",
          "en": "Small Standing Palm Sign",
          "fr": "Petit panneau sur pied en palmier",
          "es": "Letrero pequeño (palmera)",
          "de": "Holzschild aus Palmenholz (klein",
          "pt": "소형 야자나무 간판",
          "it": "Маленькая пальмовая табличка",
          "tr": "Small Standing Palm Sign",
          "pl": "Small Standing Palm Sign",
          "ru": "小型立式棕榈标志",
          "uk": "Small Standing Palm Sign",
          "ko": " stehend)",
          "zh": "Placa de Palmeira Pequena em Pé",
          "ja": "Small Standing Palm Sign"
        },
        {
          "id": "SmallStandingOakSignItem",
          "en": "Small Standing Oak Sign",
          "fr": "Petit panneau sur pied en chêne",
          "es": "Letrero pequeño (roble)",
          "de": "Holzschild aus Eiche (klein",
          "pt": "소형 참나무 간판",
          "it": "Маленькая дубовая табличка",
          "tr": "Small Standing Oak Sign",
          "pl": "Small Standing Oak Sign",
          "ru": "小型立式立橡木标志",
          "uk": "Small Standing Oak Sign",
          "ko": " stehend)",
          "zh": "Placa de Carvalho Pequena em Pé",
          "ja": "Small Standing Oak Sign"
        },
        {
          "id": "SmallStandingJoshuaSignItem",
          "en": "Small Standing Joshua Sign",
          "fr": "Petit panneau sur pied en josué",
          "es": "Letrero pequeño (joshua)",
          "de": "Holzschild aus Josuaholz (klein",
          "pt": "소형 여호수아 나무 간판",
          "it": "Маленькая табличка из юкки коротколистной",
          "tr": "Small Standing Joshua Sign",
          "pl": "Small Standing Joshua Sign",
          "ru": "小型立式约书亚标志",
          "uk": "Small Standing Joshua Sign",
          "ko": " stehend)",
          "zh": "Placa de Joshua Pequena em Pé",
          "ja": "Small Standing Joshua Sign"
        },
        {
          "id": "SmallStandingHardwoodSignItem",
          "en": "Small Standing Hardwood Sign",
          "fr": "Petit panneau sur pied en bois dur",
          "es": "Letrero pequeño (madera dura)",
          "de": "Holzschild aus Hartholz (klein",
          "pt": "소형 견목재 간판",
          "it": "Маленькая табличка из лиственных пород",
          "tr": "Small Standing Hardwood Sign",
          "pl": "Small Standing Hardwood Sign",
          "ru": "小型立式硬木标志",
          "uk": "Small Standing Hardwood Sign",
          "ko": " stehend)",
          "zh": "Placa de Madeira Dura Pequena em Pé",
          "ja": "Small Standing Hardwood Sign"
        },
        {
          "id": "SmallStandingFirSignItem",
          "en": "Small Standing Fir Sign",
          "fr": "Petit panneau sur pied en sapin",
          "es": "Letrero pequeño (abeto)",
          "de": "Holzschild aus Tannenholz (klein",
          "pt": "소형 전나무 간판",
          "it": "Маленькая пихтовая табличка",
          "tr": "Small Standing Fir Sign",
          "pl": "Small Standing Fir Sign",
          "ru": "小型立式杉木标志",
          "uk": "Small Standing Fir Sign",
          "ko": " stehend)",
          "zh": "Placa de Abeto Pequena em Pé",
          "ja": "Small Standing Fir Sign"
        },
        {
          "id": "SmallStandingCeibaSignItem",
          "en": "Small Standing Ceiba Sign",
          "fr": "Petit panneau sur pied en ceiba",
          "es": "Letrero pequeño (ceiba)",
          "de": "Holzschild aus Kapokholz (klein",
          "pt": "소형 명주나무 간판",
          "it": "Маленькая табличка из сейбы",
          "tr": "Small Standing Ceiba Sign",
          "pl": "Small Standing Ceiba Sign",
          "ru": "小型立式木棉标志",
          "uk": "Small Standing Ceiba Sign",
          "ko": " stehend)",
          "zh": "Placa de Ceiba Pequena em Pé",
          "ja": "Small Standing Ceiba Sign"
        },
        {
          "id": "SmallStandingCedarSignItem",
          "en": "Small Standing Cedar Sign",
          "fr": "Petit panneau sur pied en cèdre",
          "es": "Letrero pequeño (cedro)",
          "de": "Holzschild aus Zedernholz (klein",
          "pt": "소형 삼나무 간판",
          "it": "Маленькая кедровая табличка",
          "tr": "Small Standing Cedar Sign",
          "pl": "Small Standing Cedar Sign",
          "ru": "小型立式雪松标志",
          "uk": "Small Standing Cedar Sign",
          "ko": " stehend)",
          "zh": "Placa de Cedro Pequena em Pé",
          "ja": "Small Standing Cedar Sign"
        },
        {
          "id": "SmallStandingBirchSignItem",
          "en": "Small Standing Birch Sign",
          "fr": "Petit panneau sur pied en bouleau",
          "es": "Letrero pequeño (abedul)",
          "de": "Holzschild aus Birke (klein",
          "pt": "소형 자작나무 간판",
          "it": "Маленькая берёзовая табличка",
          "tr": "Small Standing Birch Sign",
          "pl": "Small Standing Birch Sign",
          "ru": "小型立式桦木标志",
          "uk": "Small Standing Birch Sign",
          "ko": " stehend)",
          "zh": "Placa de Bétula Pequena em Pé",
          "ja": "Small Standing Birch Sign"
        },
        {
          "id": "SmallHangingWoodSignItem",
          "en": "Small Hanging Wood Sign",
          "fr": "Petit panneau suspendu en bois",
          "es": "Letrero pequeño colgante (básico)",
          "de": "Holzschild (klein",
          "pt": "작은 걸이형 목재 간판",
          "it": "Маленькая деревянная вывеска",
          "tr": "Small Hanging Wood Sign",
          "pl": "Small Hanging Wood Sign",
          "ru": "小型立式木质标志",
          "uk": "Small Hanging Wood Sign",
          "ko": " hängend)",
          "zh": "Placa de Madeira Pequena Pendurada",
          "ja": "Small Hanging Wood Sign"
        },
        {
          "id": "SmallHangingSpruceSignItem",
          "en": "Small Hanging Spruce Sign",
          "fr": "Petit panneau suspendu en épicéa",
          "es": "Letrero pequeño colgante (pícea)",
          "de": "Holzschild aus Fichte (klein",
          "pt": "소형 가문비나무 현판",
          "it": "Маленькая еловая вывеска",
          "tr": "Small Hanging Spruce Sign",
          "pl": "Small Hanging Spruce Sign",
          "ru": "小型悬挂云杉标志",
          "uk": "Small Hanging Spruce Sign",
          "ko": " hängend)",
          "zh": "Placa de Pinheiro Pequena Pendurada",
          "ja": "Small Hanging Spruce Sign"
        },
        {
          "id": "SmallHangingSoftwoodSignItem",
          "en": "Small Hanging Softwood Sign",
          "fr": "Petit panneau suspendu en bois tendre",
          "es": "Letrero pequeño colgante (madera blanda)",
          "de": "Holzschild aus Weichholz (klein",
          "pt": "소형 연목재 현판",
          "it": "Маленькая вывеска из хвойных пород",
          "tr": "Small Hanging Softwood Sign",
          "pl": "Small Hanging Softwood Sign",
          "ru": "小型悬挂软木标志",
          "uk": "Small Hanging Softwood Sign",
          "ko": " hängend)",
          "zh": "Placa de Madeira Macia Pequena Pendurada",
          "ja": "Small Hanging Softwood Sign"
        },
        {
          "id": "SmallHangingSaguaroSignItem",
          "en": "Small Hanging Saguaro Sign",
          "fr": "Petit panneau suspendu en saguaro",
          "es": "Letrero pequeño colgante (saguaro)",
          "de": "Holzschild aus Kaktusholz (klein",
          "pt": "소형 변경주선인장 현판",
          "it": "Маленькая вывеска из карнегии",
          "tr": "Small Hanging Saguaro Sign",
          "pl": "Small Hanging Saguaro Sign",
          "ru": "小型悬挂仙人掌标志",
          "uk": "Small Hanging Saguaro Sign",
          "ko": " hängend)",
          "zh": "Placa de Saguaro Pequena Pendurada",
          "ja": "Small Hanging Saguaro Sign"
        },
        {
          "id": "SmallHangingRedwoodSignItem",
          "en": "Small Hanging Redwood Sign",
          "fr": "Petit panneau suspendu en séquoia",
          "es": "Letrero pequeño colgante (secuoya)",
          "de": "Holzschild aus Rottanne (klein",
          "pt": "소형 붉은삼나무 현판",
          "it": "Маленькая вывеска из секвойи",
          "tr": "Small Hanging Redwood Sign",
          "pl": "Small Hanging Redwood Sign",
          "ru": "小型悬挂红木标志",
          "uk": "Small Hanging Redwood Sign",
          "ko": " hängend)",
          "zh": "Placa de Sequoia-vermelha Pequena Pendurada",
          "ja": "Small Hanging Redwood Sign"
        },
        {
          "id": "SmallHangingPalmSignItem",
          "en": "Small Hanging Palm Sign",
          "fr": "Petit panneau suspendu en palmier",
          "es": "Letrero pequeño colgante (palmera)",
          "de": "Holzschild aus Palmenholz (klein",
          "pt": "소형 야자나무 현판",
          "it": "Маленькая пальмовая вывеска",
          "tr": "Small Hanging Palm Sign",
          "pl": "Small Hanging Palm Sign",
          "ru": "小型悬挂棕榈标志",
          "uk": "Small Hanging Palm Sign",
          "ko": " hängend)",
          "zh": "Placa de Palmeira Pequena Pendurada",
          "ja": "Small Hanging Palm Sign"
        },
        {
          "id": "SmallHangingOakSignItem",
          "en": "Small Hanging Oak Sign",
          "fr": "Petit panneau suspendu en chêne",
          "es": "Letrero pequeño colgante (roble)",
          "de": "Holzschild aus Eiche (klein",
          "pt": "소형 참나무 현판",
          "it": "Маленькая дубовая вывеска",
          "tr": "Small Hanging Oak Sign",
          "pl": "Small Hanging Oak Sign",
          "ru": "小型悬挂橡木标志",
          "uk": "Small Hanging Oak Sign",
          "ko": " hängend)",
          "zh": "Placa de Carvalho Pequena Pendurada",
          "ja": "Small Hanging Oak Sign"
        },
        {
          "id": "SmallHangingJoshuaSignItem",
          "en": "Small Hanging Joshua Sign",
          "fr": "Petit panneau suspendu en josué",
          "es": "Letrero pequeño colgante (joshua)",
          "de": "Holzschild aus Josuaholz (klein",
          "pt": "소형 여호수아 나무 현판",
          "it": "Маленькая вывеска из юкки коротколистной",
          "tr": "Small Hanging Joshua Sign",
          "pl": "Small Hanging Joshua Sign",
          "ru": "小型悬挂约书亚标志",
          "uk": "Small Hanging Joshua Sign",
          "ko": " hängend)",
          "zh": "Placa de Joshua Pequena Pendurada",
          "ja": "Small Hanging Joshua Sign"
        },
        {
          "id": "SmallHangingHardwoodSignItem",
          "en": "Small Hanging Hardwood Sign",
          "fr": "Petit panneau suspendu en bois dur",
          "es": "Letrero pequeño colgante (madera noble)",
          "de": "Holzschild aus Hartholz (klein",
          "pt": "소형 견목재 현판",
          "it": "Маленькая вывеска из лиственных пород",
          "tr": "Small Hanging Hardwood Sign",
          "pl": "Small Hanging Hardwood Sign",
          "ru": "小型悬挂硬木标志",
          "uk": "Small Hanging Hardwood Sign",
          "ko": " hängend)",
          "zh": "Placa de Madeira Dura Pequena Pendurada",
          "ja": "Small Hanging Hardwood Sign"
        },
        {
          "id": "SmallHangingFirSignItem",
          "en": "Small Hanging Fir Sign",
          "fr": "Petit panneau suspendu en sapin",
          "es": "Letrero pequeño colgante (abeto)",
          "de": "Holzschild aus Tannenholz (klein",
          "pt": "소형 전나무 현판",
          "it": "Маленькая пихтовая вывеска",
          "tr": "Small Hanging Fir Sign",
          "pl": "Small Hanging Fir Sign",
          "ru": "小型悬挂冷杉标志",
          "uk": "Small Hanging Fir Sign",
          "ko": " hängend)",
          "zh": "Placa de Abeto Pequena Pendurada",
          "ja": "Small Hanging Fir Sign"
        },
        {
          "id": "SmallHangingCeibaSignItem",
          "en": "Small Hanging Ceiba Sign",
          "fr": "Petit panneau suspendu en ceiba",
          "es": "Letrero pequeño colgante (ceiba)",
          "de": "Holzschild aus Kapokholz (klein",
          "pt": "소형 명주나무 현판",
          "it": "Маленькая вывеска из сейбы",
          "tr": "Small Hanging Ceiba Sign",
          "pl": "Small Hanging Ceiba Sign",
          "ru": "小型悬挂木棉标志",
          "uk": "Small Hanging Ceiba Sign",
          "ko": " hängend)",
          "zh": "Placa de Ceiba Pequena Pendurada",
          "ja": "Small Hanging Ceiba Sign"
        },
        {
          "id": "SmallHangingCedarSignItem",
          "en": "Small Hanging Cedar Sign",
          "fr": "Petit panneau suspendu en cèdre",
          "es": "Letrero pequeño colgante (cedro)",
          "de": "Holzschild aus Zedernholz (klein",
          "pt": "소형 삼나무 현판",
          "it": "Маленькая кедровая вывеска",
          "tr": "Small Hanging Cedar Sign",
          "pl": "Small Hanging Cedar Sign",
          "ru": "小型悬挂雪松标志",
          "uk": "Small Hanging Cedar Sign",
          "ko": " hängend)",
          "zh": "Placa de Cedro Pequena Pendurada",
          "ja": "Small Hanging Cedar Sign"
        },
        {
          "id": "SmallHangingBirchSignItem",
          "en": "Small Hanging Birch Sign",
          "fr": "Petit panneau suspendu en bouleau",
          "es": "Letrero pequeño colgante (abedul)",
          "de": "Holzschild aus Birke (klein",
          "pt": "소형 자작나무 현판",
          "it": "Маленькая берёзовая вывеска",
          "tr": "Small Hanging Birch Sign",
          "pl": "Small Hanging Birch Sign",
          "ru": "小型悬挂桦木标志",
          "uk": "Small Hanging Birch Sign",
          "ko": " hängend)",
          "zh": "Placa de Bétula Pequena Pendurada",
          "ja": "Small Hanging Birch Sign"
        },
        {
          "id": "SensorBasedBeltSorterItem",
          "en": "Sensor Based Belt Sorter",
          "fr": "Rampe de tri à détecteurs",
          "es": "Cinta organizadora con sensores",
          "de": "Sensorenbasierter Gürtelsortierer",
          "pt": "Classificador com correia baseado em sensor",
          "it": "Selezionatore A Nastro Basata sul Sensore",
          "tr": "Sensörlere Dayalı Kemer Sınıflandırıcı",
          "pl": "Sorter taśmowy oparty na czujnikach",
          "ru": "Сенсорный конвейерный сортировщик",
          "uk": "Сенсорний сортувальник конвеєрної лінії",
          "ko": "감지기 기반 자동 분류기",
          "zh": "基于传感器的皮带分拣机",
          "ja": "センサー式ベルト選別機"
        },
        {
          "id": "ScreeningMachineItem",
          "en": "Screening Machine",
          "fr": "Machine de criblage",
          "es": "Máquina de escaneo",
          "de": "Siebmaschine",
          "pt": "Máquina de peneiramento",
          "it": "Vaglio Meccanico",
          "tr": "Elek Makinesi",
          "pl": "Maszyna do Przesiewania",
          "ru": "Вибрационный сортировщик",
          "uk": "Просіювальна машина",
          "ko": "건식 정광 기계",
          "zh": "筛选机",
          "ja": "選別機"
        },
        {
          "id": "RockerBoxItem",
          "en": "Rocker Box",
          "fr": "Rampe de lavage",
          "es": "Caja de balancines",
          "de": "Bergbau-Waschtisch",
          "pt": "Caixa de garimpo",
          "it": "Scatola Bilanciere",
          "tr": "Rocker Kutusu",
          "pl": "Sito kołyskowe",
          "ru": "Вашгерд",
          "uk": "Накопичувач руди",
          "ko": "로커 박스",
          "zh": "摇臂箱",
          "ja": "ロッカーボックス"
        },
        {
          "id": "MortaredStoneTableItem",
          "en": "Mortared Stone Table",
          "fr": "Table en pierre cimentée",
          "es": "Mesa de piedra con mortero",
          "de": "Steinziegeltisch",
          "pt": "Mesa de Pedra Argamassada",
          "it": "Tavolo in Pietra Pestata",
          "tr": "Harçlı Taştan Masa",
          "pl": "Kamienny stół",
          "ru": "Стол из строительного камня",
          "uk": "Стіл з будівельного каміння",
          "ko": "모르타르 마감 석재 탁자",
          "zh": "砂浆石桌",
          "ja": "モルタルの石のテーブル"
        },
        {
          "id": "MortaredStoneFireplaceItem",
          "en": "Mortared Stone Fireplace",
          "fr": "Cheminée en pierre cimentée",
          "es": "Chimenea de piedra con mortero",
          "de": "Gemörtelter Steinkamin",
          "pt": "Lareira de Pedra Argamassada",
          "it": "Camino in Pietra Pestata",
          "tr": "Harçlı Taştan Şömine",
          "pl": "Kominek z kamienia spojonego zaprawą",
          "ru": "Камин из строительного камня",
          "uk": "Камін із будівельного каміння",
          "ko": "모르타르 마감 석재 벽난로",
          "zh": "砂浆石壁炉",
          "ja": "モルタルの石の暖炉"
        },
        {
          "id": "MortaredStoneChairItem",
          "en": "Mortared Stone Chair",
          "fr": "Chaise en pierre cimentée",
          "es": "Silla de piedra con mortero",
          "de": "Steinziegelstuhl",
          "pt": "Cadeira de Pedra Argamassada",
          "it": "Sedia in Pietra Pestata",
          "tr": "Harçlı Taştan Sandalye",
          "pl": "Kamienne krzesło",
          "ru": "Стул из строительного камня",
          "uk": "Стілець із будівельного каміння",
          "ko": "모르타르 마감 석재 의자",
          "zh": "砂浆石椅",
          "ja": "モルタルの石の椅子"
        },
        {
          "id": "MortaredStoneBenchItem",
          "en": "Mortared Stone Bench",
          "fr": "Banc en pierre cimentée",
          "es": "Banco de piedra con mortero",
          "de": "Steinziegelbank",
          "pt": "Banco de Pedra Argamassada",
          "it": "Panca in Pietra Pestata",
          "tr": "Harçlı Taş Tezgah",
          "pl": "Kamienna ławka",
          "ru": "Лавка из строительного камня",
          "uk": "Лавка з будівельного каміння",
          "ko": "모르타르 마감 석재 벤치",
          "zh": "砂浆石凳",
          "ja": "モルタルの石のベンチ"
        },
        {
          "id": "MortaredSandstoneTableItem",
          "en": "Mortared Sandstone Table",
          "fr": "Table en grès cimenté",
          "es": "Mesa de arenisca con mortero",
          "de": "Steinziegeltisch aus Sandstein",
          "pt": "Mesa de Arenito Argamassado",
          "it": "Tavolo in Arenaria Pestata",
          "tr": "Harçlı Kumtaşından Masa",
          "pl": "Piaskowcowy stół",
          "ru": "Стол из строительного песчаника",
          "uk": "Стіл із каменя-пісковика",
          "ko": "모르타르 마감 사암 탁자",
          "zh": "砂浆石桌",
          "ja": "モルタルの砂岩のテーブル"
        },
        {
          "id": "MortaredSandstoneFireplaceItem",
          "en": "Mortared Sandstone Fireplace",
          "fr": "Cheminée en grès cimenté",
          "es": "Chimenea de arenisca con mortero",
          "de": "Sandsteinziegel Feuerstelle",
          "pt": "Lareira de Arenito Argamassado",
          "it": "Camino in Arenaria Pestata",
          "tr": "Harçlı Kumtaşından Şömine",
          "pl": "Kominek z piaskowca spojonego zaprawą",
          "ru": "Камин из строительного песчаника",
          "uk": "Камін із каменя-пісковика",
          "ko": "모르타르 마감 사암 벽난로",
          "zh": "砂浆石壁炉",
          "ja": "モルタルの砂岩の暖炉"
        },
        {
          "id": "MortaredSandstoneChairItem",
          "en": "Mortared Sandstone Chair",
          "fr": "Chaise en grès cimenté",
          "es": "Silla de arenisca con mortero",
          "de": "Steinziegelstuhl aus Sandstein",
          "pt": "Cadeira de Arenito Argamassado",
          "it": "Sedia in Arenaria Pestata",
          "tr": "Harçlı Kumtaşından Sandalye",
          "pl": "Piaskowcowe krzesło",
          "ru": "Стул из строительного песчаника",
          "uk": "Стілець із каменя-пісковика",
          "ko": "모르타르 마감 사암 의자",
          "zh": "砂岩砂椅",
          "ja": "モルタルの砂岩の椅子"
        },
        {
          "id": "MortaredSandstoneBenchItem",
          "en": "Mortared Sandstone Bench",
          "fr": "Banc en grès cimenté",
          "es": "Banco de arenisca con mortero",
          "de": "Steinziegelbank aus Sandstein",
          "pt": "Banco de Arenito Argamassado",
          "it": "Panca in Arenaria Pestata",
          "tr": "Harçlı Kumtaşı Tezgahı",
          "pl": "Piaskowcowa ławka",
          "ru": "Лавка из строительного песчаника",
          "uk": "Лавка з каменя-пісковика",
          "ko": "모르타르 마감 사암 벤치",
          "zh": "砂浆石凳",
          "ja": "モルタルの砂岩のベンチ"
        },
        {
          "id": "MortaredLimestoneTableItem",
          "en": "Mortared Limestone Table",
          "fr": "Table en calcaire cimenté",
          "es": "Mesa de piedra caliza con mortero",
          "de": "Steinziegeltisch Kalkstein",
          "pt": "Mesa de Calcário Argamassado",
          "it": "Tavolo in Calcare Pestato",
          "tr": "Harçlı Kireç Taşından Masa",
          "pl": "Wapienny stół",
          "ru": "Стол из строительного известняка",
          "uk": "Стіл із будівельного вапняку",
          "ko": "모르타르 마감 석회암 탁자",
          "zh": "砂浆石灰石桌",
          "ja": "モルタルの石灰岩のテーブル"
        },
        {
          "id": "MortaredLimestoneFireplaceItem",
          "en": "Mortared Limestone Fireplace",
          "fr": "Cheminée en calcaire cimenté",
          "es": "Chimenea de piedra caliza con mortero",
          "de": "Kalksteinziegel Feuerstelle",
          "pt": "Lareira de Calcário Argamassado",
          "it": "Camino in Calcare Pestato",
          "tr": "Harçlı Kireç Taşından Şömine",
          "pl": "Kominek z wapienia spojonego zaprawą",
          "ru": "Камин из строительного известняка",
          "uk": "Камін із будівельного вапняку",
          "ko": "모르타르 마감 석회암 벽난로",
          "zh": "砂浆石灰石壁炉",
          "ja": "モルタルの石灰岩の暖炉"
        },
        {
          "id": "MortaredLimestoneChairItem",
          "en": "Mortared Limestone Chair",
          "fr": "Chaise en calcaire cimenté",
          "es": "Silla de piedra caliza con mortero",
          "de": "Steinziegelstuhl aus Kalkstein",
          "pt": "Cadeira de Calcário Argamassado",
          "it": "Sedia in Calcare Pestato",
          "tr": "Harçlı Kireç Taşından Sandalye",
          "pl": "Wapienne krzesło",
          "ru": "Стул из строительного известняка",
          "uk": "Стілець із будівельного вапняку",
          "ko": "모르타르 마감 석회암 의자",
          "zh": "砂浆石灰石椅子",
          "ja": "モルタルの石灰岩の椅子"
        },
        {
          "id": "MortaredLimestoneBenchItem",
          "en": "Mortared Limestone Bench",
          "fr": "Banc en calcaire cimenté",
          "es": "Banco de piedra caliza con mortero",
          "de": "Steinziegelbank aus Kalkstein",
          "pt": "Banco de Calcário Argamassado",
          "it": "Panca in Calcare Pestato",
          "tr": "Harçlı Kireç Taşı Tezgahı",
          "pl": "Wapienna ławka",
          "ru": "Лавка из строительного известняка",
          "uk": "Лавка з будівельного вапняку",
          "ko": "모르타르 마감 석회암 벤치",
          "zh": "砂浆石灰石长凳",
          "ja": "モルタルの石灰岩のベンチ"
        },
        {
          "id": "MortaredGraniteTableItem",
          "en": "Mortared Granite Table",
          "fr": "Table en granite cimenté",
          "es": "Mesa de granito con mortero",
          "de": "Granitziegeltisch",
          "pt": "Mesa de Granito Argamassado",
          "it": "Tavolo in Granito Pestato",
          "tr": "Harçlı Granitten Masa",
          "pl": "Granitowy stół",
          "ru": "Стол из строительного гранита",
          "uk": "Стіл із будівельного граніту",
          "ko": "모르타르 마감 화강암 탁자",
          "zh": "砂浆花岗岩桌子",
          "ja": "花崗岩のモルタルのテーブル"
        },
        {
          "id": "MortaredGraniteFireplaceItem",
          "en": "Mortared Granite Fireplace",
          "fr": "Cheminée en granite cimenté",
          "es": "Chimenea de granito con mortero",
          "de": "Granitziegel Feuerstelle",
          "pt": "Lareira de Granito Argamassado",
          "it": "Camino in Granito Pestato",
          "tr": "Harçlı Granitten Şömine",
          "pl": "Kominek z granitu spojonego zaprawą",
          "ru": "Камин из строительного гранита",
          "uk": "Камін із будівельного граніту",
          "ko": "모르타르 마감 화강암 벽난로",
          "zh": "砂浆花岗岩壁炉",
          "ja": "花崗岩のモルタルの暖炉"
        },
        {
          "id": "MortaredGraniteChairItem",
          "en": "Mortared Granite Chair",
          "fr": "Chaise en granite cimenté",
          "es": "Silla de granito con mortero",
          "de": "Granitziegelstuhl",
          "pt": "Cadeira de Granito Argamassado",
          "it": "Sedia in Granito Pestato",
          "tr": "Harçlı Granitten Sandalye",
          "pl": "Krzesło z granitu",
          "ru": "Стул из строительного гранита",
          "uk": "Стілець із будівельного граніту",
          "ko": "모르타르 마감 화강암 의자",
          "zh": "砂浆花岗岩椅子",
          "ja": "花崗岩のモルタルの椅子"
        },
        {
          "id": "MortaredGraniteBenchItem",
          "en": "Mortared Granite Bench",
          "fr": "Banc en granite cimenté",
          "es": "Banco de granito con mortero",
          "de": "Granitziegelbank",
          "pt": "Banco de Granito Argamassado",
          "it": "Panca in Granito Pestato",
          "tr": "Harçlı Granit Tezgahı",
          "pl": "Ławka z granitu",
          "ru": "Лавка из строительного гранита",
          "uk": "Лавка з будівельного граніту",
          "ko": "모르타르 마감 화강암 벤치",
          "zh": "砂浆花岗岩长凳",
          "ja": "花崗岩のモルタルのベンチ"
        },
        {
          "id": "LumberTableItem",
          "en": "Lumber Table",
          "fr": "Table en bois d\u0027œuvre",
          "es": "Mesa de troncos",
          "de": "Bauholztisch",
          "pt": "Mesa de Madeira Serrada",
          "it": "Tavolo in Legno",
          "tr": "Kereste Masa",
          "pl": "Stół z tarcicy",
          "ru": "Стол из пиломатериалов",
          "uk": "Стіл з пиломатеріалів",
          "ko": "가공된 목재 테이블",
          "zh": "木材桌",
          "ja": "板材のテーブル"
        },
        {
          "id": "LumberChairItem",
          "en": "Lumber Chair",
          "fr": "Chaise en bois d\u0027œuvre",
          "es": "Silla de troncos",
          "de": "Bauholzstuhl",
          "pt": "Cadeira de Madeira Serrada",
          "it": "Sedia in Legno",
          "tr": "Kereste Sandalye",
          "pl": "Krzesło z Drewna",
          "ru": "Стул из пиломатериалов",
          "uk": "Стілець з пиломатеріалів",
          "ko": "가공된 목재 의자",
          "zh": "木材椅子",
          "ja": "板材の椅子"
        },
        {
          "id": "LumberBenchItem",
          "en": "Lumber Bench",
          "fr": "Banc en bois d\u0027œuvre",
          "es": "Banco de troncos",
          "de": "Bauholzbank",
          "pt": "Banco de Madeira Serrada",
          "it": "Panca in Legno",
          "tr": "Kereste Tezgah",
          "pl": "Ławka z Drewna",
          "ru": "Лавка из пиломатериалов",
          "uk": "Лава з пиломатеріалів",
          "ko": "가공된 목재 벤치",
          "zh": "木质长凳",
          "ja": "板材のベンチ"
        },
        {
          "id": "LargeStandingWoodSignItem",
          "en": "Large Standing Wood Sign",
          "fr": "Grand panneau sur pied en bois",
          "es": "Letrero grande (básico)",
          "de": "Holzschild (Groß",
          "pt": "큰 목재 선간판",
          "it": "Большая деревянная табличка",
          "tr": "Large Standing Wood Sign",
          "pl": "Large Standing Wood Sign",
          "ru": "大型立式木标志",
          "uk": "Large Standing Wood Sign",
          "ko": " stehend)",
          "zh": "Placa de Madeira Grande em Pé",
          "ja": "Large Standing Wood Sign"
        },
        {
          "id": "LargeStandingSpruceSignItem",
          "en": "Large Standing Spruce Sign",
          "fr": "Grand panneau sur pied en épicéa",
          "es": "Letrero grande (pícea)",
          "de": "Holzschild aus Fichtenholz (Groß",
          "pt": "대형 가문비나무 간판",
          "it": "Большая еловая табличка",
          "tr": "Large Standing Spruce Sign",
          "pl": "Large Standing Spruce Sign",
          "ru": "大型立式云杉标志",
          "uk": "Large Standing Spruce Sign",
          "ko": " stehend)",
          "zh": "Placa de Pinheiro Grande em Pé",
          "ja": "Large Standing Spruce Sign"
        },
        {
          "id": "LargeStandingSoftwoodSignItem",
          "en": "Large Standing Softwood Sign",
          "fr": "Grand panneau sur pied en bois tendre",
          "es": "Letrero grande (madera blanda)",
          "de": "Holzschild aus Weichholz (Groß",
          "pt": "대형 연목재 간판",
          "it": "Большая табличка из хвойных пород",
          "tr": "Large Standing Softwood Sign",
          "pl": "Large Standing Softwood Sign",
          "ru": "大型立式软木标志",
          "uk": "Large Standing Softwood Sign",
          "ko": " stehend)",
          "zh": "Placa de Madeira Macia Grande em Pé",
          "ja": "Large Standing Softwood Sign"
        },
        {
          "id": "LargeStandingSaguaroSignItem",
          "en": "Large Standing Saguaro Sign",
          "fr": "Grand panneau sur pied en saguaro",
          "es": "Letrero grande (saguaro)",
          "de": "Holzschild aus Kaktusholz (Groß",
          "pt": "대형 변경주선인장 간판",
          "it": "Большая табличка из карнегии",
          "tr": "Large Standing Saguaro Sign",
          "pl": "Large Standing Saguaro Sign",
          "ru": "大柱仙人掌标志",
          "uk": "Large Standing Saguaro Sign",
          "ko": " stehend)",
          "zh": "Placa de Saguaro Grande em Pé",
          "ja": "Large Standing Saguaro Sign"
        },
        {
          "id": "LargeStandingRedwoodSignItem",
          "en": "Large Standing Redwood Sign",
          "fr": "Grand panneau sur pied en séquoia",
          "es": "Letrero grande (secuoya)",
          "de": "Holzschild aus Rottanne (Groß",
          "pt": "대형 붉은삼나무 간판",
          "it": "Большая табличка из секвойи",
          "tr": "Large Standing Redwood Sign",
          "pl": "Large Standing Redwood Sign",
          "ru": "大型立式红木标志",
          "uk": "Large Standing Redwood Sign",
          "ko": " stehend)",
          "zh": "Placa de Sequoia-vermelha Grande em Pé",
          "ja": "Large Standing Redwood Sign"
        },
        {
          "id": "LargeStandingPalmSignItem",
          "en": "Large Standing Palm Sign",
          "fr": "Grand panneau sur pied en palmier",
          "es": "Letrero grande (palmera)",
          "de": "Holzschild aus Palmenholz (Groß",
          "pt": "대형 야자나무 간판",
          "it": "Большая пальмовая табличка",
          "tr": "Large Standing Palm Sign",
          "pl": "Large Standing Palm Sign",
          "ru": "大型立式棕榈标志",
          "uk": "Large Standing Palm Sign",
          "ko": " stehend)",
          "zh": "Placa de Palmeira Grande em Pé",
          "ja": "Large Standing Palm Sign"
        },
        {
          "id": "LargeStandingOakSignItem",
          "en": "Large Standing Oak Sign",
          "fr": "Grand panneau sur pied en chêne",
          "es": "Letrero grande (roble)",
          "de": "Holzschild aus Eiche (Groß",
          "pt": "대형 참나무 간판",
          "it": "Большая дубовая табличка",
          "tr": "Large Standing Oak Sign",
          "pl": "Large Standing Oak Sign",
          "ru": "大型橡木标志",
          "uk": "Large Standing Oak Sign",
          "ko": " stehend)",
          "zh": "Placa de Carvalho Grande em Pé",
          "ja": "Large Standing Oak Sign"
        },
        {
          "id": "LargeStandingJoshuaSignItem",
          "en": "Large Standing Joshua Sign",
          "fr": "Grand panneau sur pied en josué",
          "es": "Letrero grande (joshua)",
          "de": "Holzschild aus Josuaholz (Groß",
          "pt": "대형 여호수아 나무 간판",
          "it": "Большая табличка из юкки коротколистной",
          "tr": "Large Standing Joshua Sign",
          "pl": "Large Standing Joshua Sign",
          "ru": "大型约书亚标志",
          "uk": "Large Standing Joshua Sign",
          "ko": " stehend)",
          "zh": "Placa de Joshua Grande em Pé",
          "ja": "Large Standing Joshua Sign"
        },
        {
          "id": "LargeStandingHardwoodSignItem",
          "en": "Large Standing Hardwood Sign",
          "fr": "Grand panneau sur pied en bois dur",
          "es": "Letrero grande (madera dura)",
          "de": "Holzschild aus Hartholz (Groß",
          "pt": "대형 견목재 간판",
          "it": "Большая табличка из лиственных пород",
          "tr": "Large Standing Hardwood Sign",
          "pl": "Large Standing Hardwood Sign",
          "ru": "大型立式硬木标志",
          "uk": "Large Standing Hardwood Sign",
          "ko": " stehend)",
          "zh": "Placa de Madeira Dura Grande em Pé",
          "ja": "Large Standing Hardwood Sign"
        },
        {
          "id": "LargeStandingFirSignItem",
          "en": "Large Standing Fir Sign",
          "fr": "Grand panneau sur pied en sapin",
          "es": "Letrero grande (abeto)",
          "de": "Holzschild aus Tannenholz (Groß",
          "pt": "대형 전나무 간판",
          "it": "Большая пихтовая табличка",
          "tr": "Large Standing Fir Sign",
          "pl": "Large Standing Fir Sign",
          "ru": "大型立式杉木标志",
          "uk": "Large Standing Fir Sign",
          "ko": " stehend)",
          "zh": "Placa de Abeto Grande em Pé",
          "ja": "Large Standing Fir Sign"
        },
        {
          "id": "LargeStandingCeibaSignItem",
          "en": "Large Standing Ceiba Sign",
          "fr": "Grand panneau sur pied en ceiba",
          "es": "Letrero grande (ceiba)",
          "de": "Holzschild aus Kapokholz (Groß",
          "pt": "대형 명주나무 간판",
          "it": "Большая табличка из сейбы",
          "tr": "Large Standing Ceiba Sign",
          "pl": "Large Standing Ceiba Sign",
          "ru": "大型立式木棉标志",
          "uk": "Large Standing Ceiba Sign",
          "ko": " stehend)",
          "zh": "Placa de Ceiba Grande em Pé",
          "ja": "Large Standing Ceiba Sign"
        },
        {
          "id": "LargeStandingCedarSignItem",
          "en": "Large Standing Cedar Sign",
          "fr": "Grand panneau sur pied en cèdre",
          "es": "Letrero grande (cedro)",
          "de": "Holzschild aus Zedernholz (Groß",
          "pt": "대형 삼나무 간판",
          "it": "Большая кедровая табличка",
          "tr": "Large Standing Cedar Sign",
          "pl": "Large Standing Cedar Sign",
          "ru": "大型立式雪松标志",
          "uk": "Large Standing Cedar Sign",
          "ko": " stehend)",
          "zh": "Placa de Cedro Grande em Pé",
          "ja": "Large Standing Cedar Sign"
        },
        {
          "id": "LargeStandingBirchSignItem",
          "en": "Large Standing Birch Sign",
          "fr": "Grand panneau sur pied en bouleau",
          "es": "Letrero grande (abedul)",
          "de": "Holzschild aus Birkenholz (Groß",
          "pt": "대형 자작나무 간판",
          "it": "Большая берёзовая табличка",
          "tr": "Large Standing Birch Sign",
          "pl": "Large Standing Birch Sign",
          "ru": "大白桦树标志",
          "uk": "Large Standing Birch Sign",
          "ko": " stehend)",
          "zh": "Placa de Bétula Grande em Pé",
          "ja": "Large Standing Birch Sign"
        },
        {
          "id": "LargeHangingWoodSignItem",
          "en": "Large Hanging Wood Sign",
          "fr": "Grand panneau suspendu en bois",
          "es": "Letrero colgante grande (básico)",
          "de": "Holzschild (Groß",
          "pt": "큰 걸이형 목재 간판",
          "it": "Большая деревянная вывеска",
          "tr": "Large Hanging Wood Sign",
          "pl": "Large Hanging Wood Sign",
          "ru": "大型悬挂木质标志",
          "uk": "Large Hanging Wood Sign",
          "ko": " hängend)",
          "zh": "Placa de Madeira Grande Pendurada",
          "ja": "Large Hanging Wood Sign"
        },
        {
          "id": "LargeHangingSpruceSignItem",
          "en": "Large Hanging Spruce Sign",
          "fr": "Grand panneau suspendu en épicéa",
          "es": "Letrero colgante grande (pícea)",
          "de": "Holzschild aus Fichtenholz (Groß",
          "pt": "대형 가문비나무 현판",
          "it": "Большая еловая вывеска",
          "tr": "Large Hanging Spruce Sign",
          "pl": "Large Hanging Spruce Sign",
          "ru": "大型悬挂云杉标志",
          "uk": "Large Hanging Spruce Sign",
          "ko": " hängend)",
          "zh": "Placa de Pinheiro Grande Pendurada",
          "ja": "Large Hanging Spruce Sign"
        },
        {
          "id": "LargeHangingSoftwoodSignItem",
          "en": "Large Hanging Softwood Sign",
          "fr": "Grand panneau suspendu en bois tendre",
          "es": "Letrero colgante grande (madera blanda)",
          "de": "Holzschild aus Weichholz (Groß",
          "pt": "대형 연목재 현판",
          "it": "Большая вывеска из хвойных пород",
          "tr": "Large Hanging Softwood Sign",
          "pl": "Large Hanging Softwood Sign",
          "ru": "大型悬挂软木标志",
          "uk": "Large Hanging Softwood Sign",
          "ko": " hängend)",
          "zh": "Placa de Madeira Macia Grande Pendurada",
          "ja": "Large Hanging Softwood Sign"
        },
        {
          "id": "LargeHangingSaguaroSignItem",
          "en": "Large Hanging Saguaro Sign",
          "fr": "Grand panneau suspendu en saguaro",
          "es": "Letrero colgante grande (saguaro)",
          "de": "Holzschild aus Kaktusholz (Groß",
          "pt": "대형 변경주선인장 현판",
          "it": "Большая вывеска из карнегии",
          "tr": "Large Hanging Saguaro Sign",
          "pl": "Large Hanging Saguaro Sign",
          "ru": "大型悬挂仙人掌标志",
          "uk": "Large Hanging Saguaro Sign",
          "ko": " hängend)",
          "zh": "Placa de Saguaro Grande Pendurada",
          "ja": "Large Hanging Saguaro Sign"
        },
        {
          "id": "LargeHangingRedwoodSignItem",
          "en": "Large Hanging Redwood Sign",
          "fr": "Grand panneau suspendu en séquoia",
          "es": "Letrero colgante grande (secuoya)",
          "de": "Holzschild aus Rottanne (Groß",
          "pt": "대형 붉은삼나무 현판",
          "it": "Большая вывеска из секвойи",
          "tr": "Large Hanging Redwood Sign",
          "pl": "Large Hanging Redwood Sign",
          "ru": "大型悬挂红木标志",
          "uk": "Large Hanging Redwood Sign",
          "ko": " hängend)",
          "zh": "Placa de Sequoia-vermelha Grande Pendurada",
          "ja": "Large Hanging Redwood Sign"
        },
        {
          "id": "LargeHangingPalmSignItem",
          "en": "Large Hanging Palm Sign",
          "fr": "Grand panneau suspendu en palmier",
          "es": "Letrero colgante grande (palmera)",
          "de": "Holzschild aus Palmenholz (Groß",
          "pt": "대형 야자나무 현판",
          "it": "Большая пальмовая вывеска",
          "tr": "Large Hanging Palm Sign",
          "pl": "Large Hanging Palm Sign",
          "ru": "大型悬挂棕榈标志",
          "uk": "Large Hanging Palm Sign",
          "ko": " hängend)",
          "zh": "Placa de Palmeira Grande Pendurada",
          "ja": "Large Hanging Palm Sign"
        },
        {
          "id": "LargeHangingOakSignItem",
          "en": "Large Hanging Oak Sign",
          "fr": "Grand panneau suspendu en chêne",
          "es": "Letrero colgante grande (roble)",
          "de": "Holzschild aus Eiche (Groß",
          "pt": "대형 참나무 현판",
          "it": "Большая дубовая вывеска",
          "tr": "Large Hanging Oak Sign",
          "pl": "Large Hanging Oak Sign",
          "ru": "大型悬挂橡木标志",
          "uk": "Large Hanging Oak Sign",
          "ko": " hängend)",
          "zh": "Placa de Carvalho Grande Pendurada",
          "ja": "Large Hanging Oak Sign"
        },
        {
          "id": "LargeHangingJoshuaSignItem",
          "en": "Large Hanging Joshua Sign",
          "fr": "Grand panneau suspendu en josué",
          "es": "Letrero colgante grande (joshua)",
          "de": "Holzschild aus Josuaholz (Groß",
          "pt": "대형 여호수아 나무 현판",
          "it": "Большая вывеска из юкки коротколистной",
          "tr": "Large Hanging Joshua Sign",
          "pl": "Large Hanging Joshua Sign",
          "ru": "大型悬挂约书亚标志",
          "uk": "Large Hanging Joshua Sign",
          "ko": " hängend)",
          "zh": "Placa de Joshua Grande Pendurada",
          "ja": "Large Hanging Joshua Sign"
        },
        {
          "id": "LargeHangingHardwoodSignItem",
          "en": "Large Hanging Hardwood Sign",
          "fr": "Grand panneau suspendu en bois dur",
          "es": "Letrero colgante grande (madera noble)",
          "de": "Holzschild aus Hartholz (Groß",
          "pt": "대형 견목재 현판",
          "it": "Большая вывеска из лиственных пород",
          "tr": "Large Hanging Hardwood Sign",
          "pl": "Large Hanging Hardwood Sign",
          "ru": "大型悬挂硬木标志",
          "uk": "Large Hanging Hardwood Sign",
          "ko": " hängend)",
          "zh": "Placa de Madeira Dura Grande Pendurada",
          "ja": "Large Hanging Hardwood Sign"
        },
        {
          "id": "LargeHangingFirSignItem",
          "en": "Large Hanging Fir Sign",
          "fr": "Grand panneau suspendu en sapin",
          "es": "Letrero colgante grande (abeto)",
          "de": "Holzschild aus Tannenholz (Groß",
          "pt": "대형 전나무 현판",
          "it": "Большая пихтовая вывеска",
          "tr": "Large Hanging Fir Sign",
          "pl": "Large Hanging Fir Sign",
          "ru": "大型悬挂冷杉标志",
          "uk": "Large Hanging Fir Sign",
          "ko": " hängend)",
          "zh": "Placa de Abeto Grande Pendurada",
          "ja": "Large Hanging Fir Sign"
        },
        {
          "id": "LargeHangingCeibaSignItem",
          "en": "Large Hanging Ceiba Sign",
          "fr": "Grand panneau suspendu en ceiba",
          "es": "Letrero colgante grande (ceiba)",
          "de": "Holzschild aus Kapokholz (Groß",
          "pt": "대형 명주나무 현판",
          "it": "Большая вывеска из сейбы",
          "tr": "Large Hanging Ceiba Sign",
          "pl": "Large Hanging Ceiba Sign",
          "ru": "大型悬挂木棉标志",
          "uk": "Large Hanging Ceiba Sign",
          "ko": " hängend)",
          "zh": "Placa de Ceiba Grande Pendurada",
          "ja": "Large Hanging Ceiba Sign"
        },
        {
          "id": "LargeHangingCedarSignItem",
          "en": "Large Hanging Cedar Sign",
          "fr": "Grand panneau suspendu en cèdre",
          "es": "Letrero colgante grande (cedro)",
          "de": "Holzschild aus Zedernholz (Groß",
          "pt": "대형 삼나무 현판",
          "it": "Большая кедровая вывеска",
          "tr": "Large Hanging Cedar Sign",
          "pl": "Large Hanging Cedar Sign",
          "ru": "大型悬挂雪松标志",
          "uk": "Large Hanging Cedar Sign",
          "ko": " hängend)",
          "zh": "Placa de Cedro Grande Pendurada",
          "ja": "Large Hanging Cedar Sign"
        },
        {
          "id": "LargeHangingBirchSignItem",
          "en": "Large Hanging Birch Sign",
          "fr": "Grand panneau suspendu en bouleau",
          "es": "Letrero colgante grande (abedul)",
          "de": "Holzschild aus Birkenholz (Groß",
          "pt": "대형 자작나무 현판",
          "it": "Большая берёзовая вывеска",
          "tr": "Large Hanging Birch Sign",
          "pl": "Large Hanging Birch Sign",
          "ru": "大型悬挂桦木标志",
          "uk": "Large Hanging Birch Sign",
          "ko": " hängend)",
          "zh": "Placa de Bétula Grande Pendurada",
          "ja": "Large Hanging Birch Sign"
        },
        {
          "id": "JawCrusherItem",
          "en": "Jaw Crusher",
          "fr": "Concasseur à mâchoires",
          "es": "Trituradora",
          "de": "Kieferbrecher",
          "pt": "Britador de mandíbulas",
          "it": "Frantoio a Mascelle",
          "tr": "Çeneli Konkasör",
          "pl": "Kruszarka szczękowa",
          "ru": "Щековая дробилка",
          "uk": "Щокова дробарка",
          "ko": "암석 파쇄기",
          "zh": "颚式破碎机",
          "ja": "破砕機"
        },
        {
          "id": "HewnTableItem",
          "en": "Hewn Table",
          "fr": "Table taillée",
          "es": "Mesa tallada",
          "de": "Massivholztisch",
          "pt": "Mesa de Madeira Talhada",
          "it": "Tavolo Squadrato",
          "tr": "Yontulmuş Masa",
          "pl": "Ociosany stół",
          "ru": "Стол из обтёсанного дерева",
          "uk": "Стіл із обтесаного дерева",
          "ko": "다듬은 탁자",
          "zh": "割台",
          "ja": "丸太材のテーブル"
        },
        {
          "id": "HewnSoftwoodTableItem",
          "en": "Hewn Softwood Table",
          "fr": "Table en bois tendre taillé",
          "es": "Mesa tallada (madera blanda)",
          "de": "Massivholztisch aus Weichholz",
          "pt": "Mesa de Madeira Macia Cortada",
          "it": "Tavolo in Conifera Squadrato",
          "tr": "Yontulmuş Yumuşak Odundan Masa",
          "pl": "Ociosany stół z drewna iglastego",
          "ru": "Стол из обтёсанных хвойных пород",
          "uk": "Стіл із обтесаних хвойних дерев",
          "ko": "다듬은 연목 탁자",
          "zh": "软木桌",
          "ja": "丸太材の針葉樹のテーブル"
        },
        {
          "id": "HewnSoftwoodChairItem",
          "en": "Hewn Softwood Chair",
          "fr": "Chaise en bois tendre taillé",
          "es": "Silla tallada (madera blanda)",
          "de": "Massivholzstuhl aus Weichholz",
          "pt": "Cadeira de Madeira Macia Cortada",
          "it": "Sedia in Conifera Squadrata",
          "tr": "Yontulmuş Yumuşak Odundan Sandalye",
          "pl": "Ociosane krzesło z drewna iglastego",
          "ru": "Стул из обтёсанных хвойных пород",
          "uk": "Стілець із обтесаних хвойних дерев",
          "ko": "다듬은 연목 의자",
          "zh": "软木椅子",
          "ja": "丸太材の針葉樹の椅子"
        },
        {
          "id": "HewnSoftwoodBenchItem",
          "en": "Hewn Softwood Bench",
          "fr": "Banc en bois tendre taillé",
          "es": "Banco tallado (madera blanda)",
          "de": "Massivholzbank aus Weichholz",
          "pt": "Banco de Madeira Macia Cortada",
          "it": "Panca in Conifera Squadrata",
          "tr": "Yontulmuş Yumuşak Odun Tezgahı",
          "pl": "Ociosana ławka z drewna iglastego",
          "ru": "Лавка из обтёсанных хвойных пород",
          "uk": "Лавка із обтесаних хвойних дерев",
          "ko": "다듬은 연목 벤치",
          "zh": "软木凳",
          "ja": "丸太材の針葉樹のベンチ"
        },
        {
          "id": "HewnHardwoodTableItem",
          "en": "Hewn Hardwood Table",
          "fr": "Table en bois dur taillé",
          "es": "Mesa tallada (madera dura)",
          "de": "Massivholztisch aus Hartholz",
          "pt": "Mesa de Madeira Dura Talhada",
          "it": "Tavolo in Legno Massiccio Scolpito",
          "tr": "Yontulmuş Sert Odundan Masa",
          "pl": "Ociosany stół z drewna liściastego",
          "ru": "Стол из обтёсанных лиственных пород",
          "uk": "Стіл із обтесаної твердої деревини",
          "ko": "다듬은 견목 탁자",
          "zh": "硬木桌子",
          "ja": "丸太材のテーブル"
        },
        {
          "id": "HewnHardwoodChairItem",
          "en": "Hewn Hardwood Chair",
          "fr": "Chaise en bois dur taillé",
          "es": "Silla tallada (madera dura)",
          "de": "Massivholzstuhl aus Hartholz",
          "pt": "Cadeira de Madeira Dura Cortada",
          "it": "Sedia in Legno Massiccio Scolpito",
          "tr": "Yontulmuş Sert Odundan Sandalye",
          "pl": "Ociosane krzesło z drewna liściastego",
          "ru": "Стул из обтёсанных лиственных пород",
          "uk": "Стілець із обтесаної твердої деревини",
          "ko": "다듬은 견목 의자",
          "zh": "硬木椅子",
          "ja": "丸太材の針葉樹の椅子"
        },
        {
          "id": "HewnHardwoodBenchItem",
          "en": "Hewn Hardwood Bench",
          "fr": "Banc en bois dur taillé",
          "es": "Banco tallado (madera dura)",
          "de": "Massivholzbank aus Hartholz",
          "pt": "Banco de Madeira Dura Cortada",
          "it": "Panca in Legno Massiccio Scolpito",
          "tr": "Yontulmuş Sert Ağaç Tezgahı",
          "pl": "Ociosana ławka z drewna liściastego",
          "ru": "Лавка из обтёсанных лиственных пород",
          "uk": "Лавка з обтесаної твердої деревини",
          "ko": "다듬은 견목 벤치",
          "zh": "硬木长凳",
          "ja": "丸太材の針葉樹の椅子"
        },
        {
          "id": "HewnChairItem",
          "en": "Hewn Chair",
          "fr": "Chaise taillée",
          "es": "Silla tallada",
          "de": "Massivholzstuhl",
          "pt": "Cadeira de Madeira Cortada",
          "it": "Sedia Scolpita",
          "tr": "Yontulmuş Sandalye",
          "pl": "Ociosane krzesło",
          "ru": "Стул из обтёсанного дерева",
          "uk": "Стілець із обтесаного дерева",
          "ko": "다듬은 의자",
          "zh": "椅子",
          "ja": "丸太材の椅子"
        },
        {
          "id": "HewnBenchItem",
          "en": "Hewn Bench",
          "fr": "Banc taillé",
          "es": "Banco tallado",
          "de": "Massivholzbank",
          "pt": "Banco de Madeira Cortada",
          "it": "Panca Scolpita",
          "tr": "Yontulmuş Tezgah",
          "pl": "Ociosana ławka",
          "ru": "Лавка из обтёсанной древесины",
          "uk": "Лавка із обтесаного дерева",
          "ko": "다듬은 벤치",
          "zh": "凿台",
          "ja": "丸太材のベンチ"
        },
        {
          "id": "HardwoodLumberTableItem",
          "en": "Hardwood Lumber Table",
          "fr": "Table en bois d\u0027œuvre dur",
          "es": "Mesa de troncos (madera dura)",
          "de": "Bauholztisch aus Hartholz",
          "pt": "Mesa de Madeira Dura Serrada",
          "it": "Tavolo in Legno di Conifera",
          "tr": "Sert Odundan Kereste Masa",
          "pl": "Stół z drewna liściastego",
          "ru": "Стол из пиломатериалов лиственных пород",
          "uk": "Стіл із лісоматеріалів листяних дерев",
          "ko": "가공된 견목 탁자",
          "zh": "硬木木质桌",
          "ja": "広葉樹の板材のテーブル"
        },
        {
          "id": "HardwoodLumberDoorItem",
          "en": "Hardwood Lumber Door",
          "fr": "Porte en bois d\u0027œuvre dur",
          "es": "Puerta de troncos (madera dura)",
          "de": "Bauholztür aus Hartholz",
          "pt": "Porta de Madeira Dura Serrada",
          "it": "Porta in Legname Massiccio",
          "tr": "Sert Odundan Kereste Kapı",
          "pl": "Drzwi z drewna liściastego",
          "ru": "Дверь из пиломатериалов лиственных пород",
          "uk": "Двері з лісоматеріалів листяних дерев",
          "ko": "가공된 견목재 문",
          "zh": "硬木木质门",
          "ja": "広葉樹の板材のドア"
        },
        {
          "id": "HardwoodLumberChairItem",
          "en": "Hardwood Lumber Chair",
          "fr": "Chaise en bois d\u0027œuvre dur",
          "es": "Silla de troncos (madera dura)",
          "de": "Bauholzstuhl aus Hartholz",
          "pt": "Cadeira de Madeira Dura Serrada",
          "it": "Sedia in Legname Massiccio",
          "tr": "Sert Odundan Kereste Sandalye",
          "pl": "Krzesło z drewna liściastego",
          "ru": "Стул из пиломатериалов лиственных пород",
          "uk": "Стілець з лісоматеріалів листяних дерев",
          "ko": "가공된 견목 의자",
          "zh": "硬木木质椅子",
          "ja": "広葉樹の板材の椅子"
        },
        {
          "id": "HardwoodLumberBenchItem",
          "en": "Hardwood Lumber Bench",
          "fr": "Banc en bois d\u0027œuvre dur",
          "es": "Banco de troncos (madera noble)",
          "de": "Bauholzbank aus Hartholz",
          "pt": "Banco de Madeira Dura Serrada",
          "it": "Panca in Legno Massiccio",
          "tr": "Sert Ağaç Kerestesi Tezgahı",
          "pl": "Ławka z drewna liściastego",
          "ru": "Лавка из пиломатериалов лиственных пород",
          "uk": "Лавка з лісоматеріалів листяних дерев",
          "ko": "가공된 견목 벤치",
          "zh": "硬木木质长凳",
          "ja": "広葉樹の板材のベンチ"
        },
        {
          "id": "GovernmentOfficeItem",
          "en": "Government Office",
          "fr": "Bureau des élus",
          "es": "Oficina de gobierno",
          "de": "Amtsverwaltung",
          "pt": "Escritório do Governo",
          "it": "Ufficio Governativo",
          "tr": "Hükümet Ofisi",
          "pl": "Biuro rządowe",
          "ru": "Правительственный офис",
          "uk": "Державний офіс",
          "ko": "행정관청",
          "zh": "公会办公室",
          "ja": "行政官庁"
        },
        {
          "id": "FrothFloatationCellItem",
          "en": "Froth Floatation Cell",
          "fr": "Cellule de flottation",
          "es": "Celda de espuma flotante",
          "de": "Schaumschwimmzelle",
          "pt": "Célula de flotação de espuma",
          "it": "Cella di Flottazione della Schiuma",
          "tr": "Köpük Yüzdürme Hücresi",
          "pl": "Pianka pływacka",
          "ru": "Флотатор",
          "uk": "Флотатор",
          "ko": "거품 부유 분별기",
          "zh": "泡沫浮选池",
          "ja": "泡沫浮選機"
        },
        {
          "id": "ExecutiveOfficeItem",
          "en": "Executive Office",
          "fr": "Bureau de l\u0027exécutif",
          "es": "Oficina ejecutiva",
          "de": "Hauptamt",
          "pt": "Escritório Executivo",
          "it": "Ufficio Esecutivo",
          "tr": "İdarehane",
          "pl": "Biuro wykonawcze",
          "ru": "Исполнительный офис",
          "uk": "Адміністративний офіс",
          "ko": "행정집무실",
          "zh": "行政办公室",
          "ja": "行政府オフィス"
        },
        {
          "id": "CourtItem",
          "en": "Court",
          "fr": "Tribunal",
          "es": "Sala de tribunal",
          "de": "Parlament",
          "pt": "Tribunal",
          "it": "Tribunale",
          "tr": "Mahkeme",
          "pl": "Sąd",
          "ru": "Суд",
          "uk": "Суд",
          "ko": "법원",
          "zh": "机构",
          "ja": "法廷"
        },
        {
          "id": "CompositeSpruceTableItem",
          "en": "Composite Spruce Table",
          "fr": "Table en épicéa composite",
          "es": "Mesa de composite (pícea)",
          "de": "Fichte-Verbundholztisch",
          "pt": "Mesa Composta de Pinheiro",
          "it": "Tavolo Composito in Abete Rosso",
          "tr": "Kompozit Alaçam Masası",
          "pl": "Kompozytowy stół ze świerku",
          "ru": "Стол из елового композита",
          "uk": "Ялиновий композитний стіл",
          "ko": "합성 가문비나무 탁자",
          "zh": "复合云杉桌",
          "ja": "複合材の松のテーブル"
        },
        {
          "id": "CompositeSpruceDoorItem",
          "en": "Composite Spruce Door",
          "fr": "Porte en épicéa composite",
          "es": "Puerta de composite (pícea)",
          "de": "Fichte-Verbundholztür",
          "pt": "Porta Composta de Pinheiro",
          "it": "Porta Composita in Abete Rosso",
          "tr": "Kompozit Alaçam Kapısı",
          "pl": "Kompozytowe drzwi ze świerku",
          "ru": "Дверь из елового композита",
          "uk": "Ялинові композитні двері",
          "ko": "합성 가문비나무 문",
          "zh": "复合云杉门",
          "ja": "複合材の松のドア"
        },
        {
          "id": "CompositeSpruceChairItem",
          "en": "Composite Spruce Chair",
          "fr": "Chaise en épicéa composite",
          "es": "Silla de composite (pícea)",
          "de": "Fichte-Verbundholzstuhl",
          "pt": "Cadeira Composta de Pinheiro",
          "it": "Sedia Composita in Abete Rosso",
          "tr": "Kompozit Alaçam Sandalyesi",
          "pl": "Kompozytowe krzesło ze świerku",
          "ru": "Стул из елового композита",
          "uk": "Ялиновий композитний стілець",
          "ko": "합성 가문비나무 의자",
          "zh": "复合云杉椅",
          "ja": "複合材の松の椅子"
        },
        {
          "id": "CompositeSpruceBenchItem",
          "en": "Composite Spruce Bench",
          "fr": "Banc en épicéa composite",
          "es": "Banco de composite (pícea)",
          "de": "Fichte-Verbundholzbank",
          "pt": "Banco Composto de Pinheiro",
          "it": "Panca Composita in Abete Rosso",
          "tr": "Kompozit Alaçam Tezgahı",
          "pl": "Ławka Ze Świerku",
          "ru": "Лавка из елового композита",
          "uk": "Ялинова композитна лавка",
          "ko": "합성 가문비나무 벤치",
          "zh": "复合云杉长凳",
          "ja": "複合材の松のベンチ"
        },
        {
          "id": "CompositeSoftwoodTableItem",
          "en": "Composite Softwood Table",
          "fr": "Table en bois tendre composite",
          "es": "Mesa de composite (madera blanda)",
          "de": "Verbundholztisch aus Weichholz",
          "pt": "Mesa Composta de Madeira Macia",
          "it": "Tavolo Composito in Conifera",
          "tr": "Kompozit Çam Masası",
          "pl": "Kompozytowy stół z drewna iglastego",
          "ru": "Стол из композита хвойных пород",
          "uk": "Композитний стіл із хвойних дерев",
          "ko": "합성 연목재 탁자",
          "zh": "复合软木桌",
          "ja": "複合材の針葉樹のテーブル"
        },
        {
          "id": "CompositeSoftwoodDoorItem",
          "en": "Composite Softwood Door",
          "fr": "Porte en bois tendre composite",
          "es": "Puerta de composite (madera blanda)",
          "de": "Verbundholztür aus Weichholz",
          "pt": "Porta Composta de Madeira Macia",
          "it": "Porta Composita in Conifera",
          "tr": "Kompozit Çam Kapısı",
          "pl": "Kompozytowe drzwi z drewna iglastego",
          "ru": "Дверь из композита хвойных пород",
          "uk": "Композитні двері із хвойних дерев",
          "ko": "합성 연목재 문",
          "zh": "复合软木门",
          "ja": "複合材の針葉樹のドア"
        },
        {
          "id": "CompositeSoftwoodChairItem",
          "en": "Composite Softwood Chair",
          "fr": "Chaise en bois tendre composite",
          "es": "Silla de composite (madera blanda)",
          "de": "Verbundholzstuhl aus Weichholz",
          "pt": "Cadeira Composta de Madeira Macia",
          "it": "Sedia Composita in Conifera",
          "tr": "Kompozit Çam Sandalyesi",
          "pl": "Kompozytowe krzesło z drewna iglastego",
          "ru": "Стул из композита хвойных пород",
          "uk": "Композитний стілець із хвойних дерев",
          "ko": "합성 연목재 의자",
          "zh": "复合软木椅子",
          "ja": "複合材の針葉樹の椅子"
        },
        {
          "id": "CompositeSoftwoodBenchItem",
          "en": "Composite Softwood Bench",
          "fr": "Banc en bois tendre composite",
          "es": "Banco de composite (madera blanda)",
          "de": "Verbundholzbank aus Weichholz",
          "pt": "Banco Composto de Madeira Macia",
          "it": "Panca Composita in Conifera",
          "tr": "Kompozit Çam Tezgahı",
          "pl": "Kompozytowa ławka z drewna iglastego",
          "ru": "Лавка из композита хвойных пород",
          "uk": "Композитна лавка із хвойних дерев",
          "ko": "합성 연목재 벤치",
          "zh": "复合软木凳",
          "ja": "複合材の針葉樹のベンチ"
        },
        {
          "id": "CompositeSaguaroTableItem",
          "en": "Composite Saguaro Table",
          "fr": "Table en saguaro composite",
          "es": "Mesa de composite (saguaro)",
          "de": "Kaktus-Verbundholztisch",
          "pt": "Mesa Composta de Saguaro",
          "it": "Tavolo Composito in Saguaro",
          "tr": "Kompozit Saguaro Masası",
          "pl": "Kompozytowy stół z saguaro",
          "ru": "Стол из композита карнегии",
          "uk": "Стіл із композита карнегії",
          "ko": "합성 변경주선인장 탁자",
          "zh": "复合柱仙人掌桌",
          "ja": "複合材サグアロサボテンのテーブル"
        },
        {
          "id": "CompositeSaguaroDoorItem",
          "en": "Composite Saguaro Door",
          "fr": "Porte en saguaro composite",
          "es": "Puerta de composite (saguaro)",
          "de": "Kaktus-Verbundholztür",
          "pt": "Porta Composta de Saguaro",
          "it": "Porta Composita in Saguaro",
          "tr": "Kompozit Saguaro Kapısı",
          "pl": "Kompozytowe drzwi z saguaro",
          "ru": "Дверь из композита карнегии",
          "uk": "Двері з композиту карнегії",
          "ko": "합성 변경주선인장 문",
          "zh": "复合柱瓜门",
          "ja": "サグアロサボテンのドア"
        },
        {
          "id": "CompositeSaguaroChairItem",
          "en": "Composite Saguaro Chair",
          "fr": "Chaise en saguaro composite",
          "es": "Silla de composite (saguaro)",
          "de": "Kaktus-Verbundholzstuhl",
          "pt": "Cadeira Composta de Saguaro",
          "it": "Sedia Composita in Saguaro",
          "tr": "Kompozit Saguaro Sandalyesi",
          "pl": "Kompozytowe krzesło z saguaro",
          "ru": "Стул из композита карнегии",
          "uk": "Стілець із композиту карнегії",
          "ko": "합성 변경주선인장 의자",
          "zh": "复合仙人掌椅",
          "ja": "複合材のサグアロサボテンの椅子"
        },
        {
          "id": "CompositeSaguaroBenchItem",
          "en": "Composite Saguaro Bench",
          "fr": "Banc en saguaro composite",
          "es": "Banco de composite (saguaro)",
          "de": "Kaktus-Verbundholzbank",
          "pt": "Banco Composto de Saguaro",
          "it": "Panca Composita in Saguaro",
          "tr": "Kompozit Saguaro Tezgahı",
          "pl": "Kompozytowa ławka z saguaro",
          "ru": "Лавка из композита карнегии",
          "uk": "Лавка з композиту карнегії",
          "ko": "합성 변경주선인장 벤치",
          "zh": "复合仙人掌凳",
          "ja": "複合材のサグアロサボテンのベンチ"
        },
        {
          "id": "CompositeRedwoodTableItem",
          "en": "Composite Redwood Table",
          "fr": "Table en séquoia composite",
          "es": "Mesa de composite (secuoya)",
          "de": "Rottanne-Verbundholztisch",
          "pt": "Mesa Composta de Sequoia-vermelha",
          "it": "Tavolo Composito in Sequoia",
          "tr": "Kompozit Kızılçam Masası",
          "pl": "Kompozytowy stół z sekwoi",
          "ru": "Стол из композита секвойи",
          "uk": "Стіл із композиту секвої",
          "ko": "합성 붉은삼나무 탁자",
          "zh": "复合红木桌",
          "ja": "複合材のレッドウッドのテーブル"
        },
        {
          "id": "CompositeRedwoodDoorItem",
          "en": "Composite Redwood Door",
          "fr": "Porte en séquoia composite",
          "es": "Puerta de composite (secuoya)",
          "de": "Rottanne-Verbundholztür",
          "pt": "Porta Composta de Sequoia-vermelha",
          "it": "Porta Composita in Sequoia",
          "tr": "Kompozit Kızılçam Kapısı",
          "pl": "Kompozytowe drzwi z sekwoi",
          "ru": "Дверь из композита секвойи",
          "uk": "Двері з композиту секвої",
          "ko": "합성 붉은삼나무 문",
          "zh": "复合红木门",
          "ja": "複合材のレッドウッドのドア"
        },
        {
          "id": "CompositeRedwoodChairItem",
          "en": "Composite Redwood Chair",
          "fr": "Chaise en séquoia composite",
          "es": "Silla de composite (secuoya)",
          "de": "Rottanne-Verbundholzstuhl",
          "pt": "Cadeira Composta de Sequoia-vermelha",
          "it": "Sedia Composita in Sequoia",
          "tr": "Kompozit Kızılçam Sandalyesi",
          "pl": "Kompozytowe krzesło z sekwoi",
          "ru": "Стул из композита секвойи",
          "uk": "Стілець із композиту секвої",
          "ko": "합성 붉은삼나무 의자",
          "zh": "复合红木椅子",
          "ja": "複合材のレッドウッドの椅子"
        },
        {
          "id": "CompositeRedwoodBenchItem",
          "en": "Composite Redwood Bench",
          "fr": "Banc en séquoia composite",
          "es": "Banco de composite (secuoya)",
          "de": "Rottanne-Verbundholzbank",
          "pt": "Banco Composto de Sequoia-vermelha",
          "it": "Panca Composita in Sequoia",
          "tr": "Kompozit Kızılçam Tezgahı",
          "pl": "Kompozytowa ławka z sekwoi",
          "ru": "Лавка из композита секвойи",
          "uk": "Лавка з композиту секвої",
          "ko": "합성 붉은삼나무 벤치",
          "zh": "复合红木长凳",
          "ja": "複合材のレッドウッドのベンチ"
        },
        {
          "id": "CompositePalmTableItem",
          "en": "Composite Palm Table",
          "fr": "Table en palmier composite",
          "es": "Mesa de composite (palmera)",
          "de": "Palmen-Verbundholztisch",
          "pt": "Mesa Composta de Palmeira",
          "it": "Tavolo Composito in Palma",
          "tr": "Kompozit Palmiye Masası",
          "pl": "Kompozytowy stół z palmy",
          "ru": "Стол из пальмовых композитов",
          "uk": "Стіл із композиту пальми",
          "ko": "합성 야자나무 탁자",
          "zh": "复合棕榈桌",
          "ja": "複合材のヤシのテーブル"
        },
        {
          "id": "CompositePalmDoorItem",
          "en": "Composite Palm Door",
          "fr": "Porte en palmier composite",
          "es": "Puerta de composite (palmera)",
          "de": "Palmen-Verbundholztür",
          "pt": "Porta Composta de Palmeira",
          "it": "Porta Composita in Palma",
          "tr": "Kompozit Palmiye Kapısı",
          "pl": "Kompozytowe drzwi z palmy",
          "ru": "Дверь из пальмовых композитов",
          "uk": "Двері з композиту пальми",
          "ko": "합성 야자나무 문",
          "zh": "复合棕榈门",
          "ja": "複合材のヤシのドア"
        },
        {
          "id": "CompositePalmChairItem",
          "en": "Composite Palm Chair",
          "fr": "Chaise en palmier composite",
          "es": "Silla de composite (palmera)",
          "de": "Palmen-Verbundholzstuhl",
          "pt": "Cadeira Composta de Palmeira",
          "it": "Sedia Composita in Palma",
          "tr": "Kompozit Palmiye Sandalyesi",
          "pl": "Kompozytowe krzesło z palmy",
          "ru": "Стул из пальмовых композитов",
          "uk": "Стілець із композиту пальми",
          "ko": "합성 야자나무 의자",
          "zh": "复合棕榈椅",
          "ja": "複合材のヤシの椅子"
        },
        {
          "id": "CompositePalmBenchItem",
          "en": "Composite Palm Bench",
          "fr": "Banc en palmier composite",
          "es": "Banco de composite (palmera)",
          "de": "Palmen-Verbundholzbank",
          "pt": "Banco Composto de Palmeira",
          "it": "Panca Composita in Palma",
          "tr": "Kompozit Palmiye Tezgahı",
          "pl": "Kompozytowa ławka z palmy",
          "ru": "Лавка из пальмовых композитов",
          "uk": "Лавка з композиту пальми",
          "ko": "합성 야자나무 벤치",
          "zh": "复合棕榈长凳",
          "ja": "複合材のヤシのベンチ"
        },
        {
          "id": "CompositeOakTableItem",
          "en": "Composite Oak Table",
          "fr": "Table en chêne composite",
          "es": "Mesa de composite (roble)",
          "de": "Eichen-Verbundholztisch",
          "pt": "Mesa Composta de Carvalho",
          "it": "Tavolo Composito in Quercia",
          "tr": "Kompozit Meşe Masası",
          "pl": "Kompozytowy stół z dębu",
          "ru": "Стол из дубовых композитов",
          "uk": "Стіл із дубових композитів",
          "ko": "합성 참나무 탁자",
          "zh": "复合橡木桌",
          "ja": "複合材の樫のテーブル"
        },
        {
          "id": "CompositeOakDoorItem",
          "en": "Composite Oak Door",
          "fr": "Porte en chêne composite",
          "es": "Puerta de composite (roble)",
          "de": "Eichen-Verbundholztür",
          "pt": "Porta Composta de Carvalho",
          "it": "Porta Composita in Quercia",
          "tr": "Kompozit Meşe Kapısı",
          "pl": "Kompozytowe drzwi z dębu",
          "ru": "Дверь из дубовых композитов",
          "uk": "Двері з дубових композитів",
          "ko": "합성 참나무 문",
          "zh": "复合橡木门",
          "ja": "複合材の樫のドア"
        },
        {
          "id": "CompositeOakChairItem",
          "en": "Composite Oak Chair",
          "fr": "Chaise en chêne composite",
          "es": "Silla de composite (roble)",
          "de": "Eichen-Verbundholzstuhl",
          "pt": "Cadeira Composta de Carvalho",
          "it": "Sedia Composita in Quercia",
          "tr": "Kompozit Meşe Sandalyesi",
          "pl": "Kompozytowe krzesło z dębu",
          "ru": "Стул из дубовых композитов",
          "uk": "Стілець із дубових композитів",
          "ko": "합성 참나무 의자",
          "zh": "复合橡木椅子",
          "ja": "複合材の樫の椅子"
        },
        {
          "id": "CompositeOakBenchItem",
          "en": "Composite Oak Bench",
          "fr": "Banc en chêne composite",
          "es": "Banco de composite (roble)",
          "de": "Eichen-Verbundholzbank",
          "pt": "Banco Composto de Carvalho",
          "it": "Panca Composita in Quercia",
          "tr": "Kompozit Meşe Tezgahı",
          "pl": "Kompozytowa ławka z dębu",
          "ru": "Лавка из дубовых композитов",
          "uk": "Лавка з композиту дуба",
          "ko": "합성 참나무 벤치",
          "zh": "复合橡木长凳",
          "ja": "複合材の樫のベンチ"
        },
        {
          "id": "CompositeLumberTableItem",
          "en": "Composite Lumber Table",
          "fr": "Table en composite",
          "es": "Mesa de composite (básica)",
          "de": "Verbundholz-Tisch",
          "pt": "Mesa Composta de Madeira Serrada",
          "it": "Tavolo Composito in Legno",
          "tr": "Kompozit Kereste Masası",
          "pl": "Kompozytowy stół z drewna",
          "ru": "Стол из композитов",
          "uk": "Стіл із композитних пиломатеріалів",
          "ko": "합성 가공목 탁자",
          "zh": "复合木桌",
          "ja": "複合材の板材のテーブル"
        },
        {
          "id": "CompositeLumberDoorItem",
          "en": "Composite Lumber Door",
          "fr": "Porte en composite",
          "es": "Puerta de composite (básica)",
          "de": "Verbundholz-Tür",
          "pt": "Porta Composta de Madeira Serrada",
          "it": "Porta Composita in Legno",
          "tr": "Kompozit Kereste Kapısı",
          "pl": "Kompozytowe drzwi z drewna",
          "ru": "Дверь из композитов",
          "uk": "Двері з композитних пиломатеріалів",
          "ko": "합성 가공목 문",
          "zh": "复合木门",
          "ja": "複合材の板材のドア"
        },
        {
          "id": "CompositeLumberChairItem",
          "en": "Composite Lumber Chair",
          "fr": "Chaise en composite",
          "es": "Silla de composite (básica)",
          "de": "Verbundholz-Stuhl",
          "pt": "Cadeira Composta de Madeira Serrada",
          "it": "Sedia Composita in Legno",
          "tr": "Kompozit Kereste Sandalyesi",
          "pl": "Kompozytowe krzesło z drewna",
          "ru": "Стул из композитов",
          "uk": "Стілець із композитних пиломатеріалів",
          "ko": "합성 가공목 의자",
          "zh": "复合木椅",
          "ja": "複合材の板材の椅子"
        },
        {
          "id": "CompositeLumberBenchItem",
          "en": "Composite Lumber Bench",
          "fr": "Banc en bois composite",
          "es": "Banco de composite (básica)",
          "de": "Verbundholz-Bank",
          "pt": "Banco Composto de Madeira Serrada",
          "it": "Panca Composita in Legno",
          "tr": "Kompozit Kereste Tezgahı",
          "pl": "Kompozytowa ławka z drewna",
          "ru": "Лавка из композитов",
          "uk": "Лавка з композитних пиломатеріалів",
          "ko": "합성 가공목 벤치",
          "zh": "复合木质长凳",
          "ja": "複合材の板材のベンチ"
        },
        {
          "id": "CompositeJoshuaTableItem",
          "en": "Composite Joshua Table",
          "fr": "Table en josué composite",
          "es": "Mesa de composite (joshua)",
          "de": "Josua-Verbundholztisch",
          "pt": "Mesa Composta de Joshua",
          "it": "Tavolo Composito in Albero di Giosuè",
          "tr": "Kompozit Joshua Masası",
          "pl": "Kompozytowy stół z drewna jukki",
          "ru": "Стол из композита юкки коротколистной",
          "uk": "Стіл із композиту юкки",
          "ko": "합성 여호수아나무 탁자",
          "zh": "复合约书亚桌",
          "ja": "複合材のジョシュア・ツリーのテーブル"
        },
        {
          "id": "CompositeJoshuaDoorItem",
          "en": "Composite Joshua Door",
          "fr": "Porte en josué composite",
          "es": "Puerta de composite (joshua)",
          "de": "Josua-Verbundholztür",
          "pt": "Porta Composta de Joshua",
          "it": "Porta Composita in Albero di Giosuè",
          "tr": "Kompozit Joshua Kapısı",
          "pl": "Kompozytowe drzwi z drewna jukki",
          "ru": "Дверь из композита юкки коротколистной",
          "uk": "Двері з композиту юкки",
          "ko": "합성 여호수아나무 문",
          "zh": "复合约书亚门",
          "ja": "複合材のジョシュア・ツリーのドア"
        },
        {
          "id": "CompositeJoshuaChairItem",
          "en": "Composite Joshua Chair",
          "fr": "Chaise en josué composite",
          "es": "Silla de composite (joshua)",
          "de": "Josua-Verbundholzstuhl",
          "pt": "Cadeira Composta de Joshua",
          "it": "Sedia Composita in Albero di Giosuè",
          "tr": "Kompozit Joshua Sandalyesi",
          "pl": "Kompozytowe krzesło z drewna jukki",
          "ru": "Стул из композита юкки коротколистной",
          "uk": "Стілець із композиту юкки",
          "ko": "합성 여호수아나무 의자",
          "zh": "复合约书亚椅",
          "ja": "複合材のジョシュア・ツリーの椅子"
        },
        {
          "id": "CompositeJoshuaBenchItem",
          "en": "Composite Joshua Bench",
          "fr": "Banc en josué composite",
          "es": "Banco de composite (joshua)",
          "de": "Josua-Verbundholzbank",
          "pt": "Banco Composto de Joshua",
          "it": "Panca Composita in Albero di Giosuè",
          "tr": "Kompozit Joshua Tezgahı",
          "pl": "Kompozytowa ławka z drewna jukki",
          "ru": "Лавка из композита юкки коротколистной",
          "uk": "Лавка з композиту юкки",
          "ko": "합성 여호수아나무 벤치",
          "zh": "复合约书亚长凳",
          "ja": "複合材のジョシュア・ツリーのベンチ"
        },
        {
          "id": "CompositeHardwoodTableItem",
          "en": "Composite Hardwood Table",
          "fr": "Table en bois dur composite",
          "es": "Mesa de composite (madera noble)",
          "de": "Verbundholztisch aus Hartholz",
          "pt": "Mesa Composta de Madeira Dura",
          "it": "Tavolo in Legno Massiccio Composito",
          "tr": "Kompozit Sert Ağaç Masası",
          "pl": "Kompozytowy stół z drewna liściastego",
          "ru": "Стол из композитов лиственных пород",
          "uk": "Стіл із твердолистяного композиту",
          "ko": "합성 견목재 탁자",
          "zh": "复合硬木桌",
          "ja": "複合材の針葉樹のテーブル"
        },
        {
          "id": "CompositeHardwoodDoorItem",
          "en": "Composite Hardwood Door",
          "fr": "Porte en bois dur composite",
          "es": "Puerta de composite (madera noble)",
          "de": "Verbundholztür aus Hartholz",
          "pt": "Porta Composta de Madeira Dura",
          "it": "Porta in Legno Massiccio Composito",
          "tr": "Kompozit Sert Ağaç Kapısı",
          "pl": "Kompozytowe drzwi z drewna liściastego",
          "ru": "Дверь из композитов лиственных пород",
          "uk": "Двері з твердолистяного композиту",
          "ko": "합성 견목재 문",
          "zh": "复合硬木门",
          "ja": "複合材のレッドウッドのドア"
        },
        {
          "id": "CompositeHardwoodChairItem",
          "en": "Composite Hardwood Chair",
          "fr": "Chaise en bois dur composite",
          "es": "Silla de composite (madera noble)",
          "de": "Verbundholzstuhl aus Hartholz",
          "pt": "Cadeira Composta de Madeira Dura",
          "it": "Sedia in Legno Massiccio Composito",
          "tr": "Kompozit Sert Ağaç Sandalyesi",
          "pl": "Kompozytowe krzesło z drewna liściastego",
          "ru": "Стул из композитов лиственных пород",
          "uk": "Стілець із твердолистяного композиту",
          "ko": "합성 견목재 의자",
          "zh": "复合硬木椅子",
          "ja": "複合材の硬材の椅子"
        },
        {
          "id": "CompositeHardwoodBenchItem",
          "en": "Composite Hardwood Bench",
          "fr": "Banc en bois dur composite",
          "es": "Banco de composite (madera noble)",
          "de": "Verbundholzbank aus Hartholz",
          "pt": "Banco Composto de Madeira Dura",
          "it": "Panca in Legno Massiccio Composito",
          "tr": "Kompozit Sert AğaçTezgahı",
          "pl": "Kompozytowa ławka z drewna liściastego",
          "ru": "Лавка из композитов лиственных пород",
          "uk": "Лавка з твердолистяного композиту",
          "ko": "합성 견목재 벤치",
          "zh": "复合硬木长凳",
          "ja": "複合材の硬材のベンチ"
        },
        {
          "id": "CompositeFirTableItem",
          "en": "Composite Fir Table",
          "fr": "Table en sapin composite",
          "es": "Mesa de composite (abeto)",
          "de": "Tannen-Verbundholztisch",
          "pt": "Mesa Composta de Abeto",
          "it": "Tavolo Composito in Abete",
          "tr": "Kompozit Köknar Masası",
          "pl": "Kompozytowy stół z jodły",
          "ru": "Стол из композита пихты",
          "uk": "Стіл із композиту ялини",
          "ko": "합성 전나무 탁자",
          "zh": "复合杉木桌",
          "ja": "複合材のモミの木のテーブル"
        },
        {
          "id": "CompositeFirDoorItem",
          "en": "Composite Fir Door",
          "fr": "Porte en sapin composite",
          "es": "Puerta de composite (abeto)",
          "de": "Tannen-Verbundholztür",
          "pt": "Porta Composta de Abeto",
          "it": "Porta Composita in Abete",
          "tr": "Kompozit Köknar Kapısı",
          "pl": "Kompozytowe drzwi z jodły",
          "ru": "Дверь из композита пихты",
          "uk": "Двері з композиту ялини",
          "ko": "합성 전나무 문",
          "zh": "复合杉木门",
          "ja": "モミの木のドア"
        },
        {
          "id": "CompositeFirChairItem",
          "en": "Composite Fir Chair",
          "fr": "Chaise en sapin composite",
          "es": "Silla de composite (abeto)",
          "de": "Tannen-Verbundholzstuhl",
          "pt": "Cadeira Composta de Abeto",
          "it": "Sedia Composita in Abete",
          "tr": "Kompozit Köknar Sandalyesi",
          "pl": "Kompozytowe krzesło z jodły",
          "ru": "Стул из композита пихты",
          "uk": "Стілець із композиту ялини",
          "ko": "합성 전나무 의자",
          "zh": "复合杉木椅子",
          "ja": "複合材のモミの木の椅子"
        },
        {
          "id": "CompositeFirBenchItem",
          "en": "Composite Fir Bench",
          "fr": "Banc en sapin composite",
          "es": "Banco de composite (abeto)",
          "de": "Tannen-Verbundholzbank",
          "pt": "Banco Composto de Abeto",
          "it": "Panca Composita in Abete",
          "tr": "Kompozit Köknar Tezgahı",
          "pl": "Kompozytowa ławka z jodły",
          "ru": "Лавка из композита пихты",
          "uk": "Лавка з композиту ялини",
          "ko": "합성 전나무 벤치",
          "zh": "复合杉木凳",
          "ja": "複合材のモミの木のベンチ"
        },
        {
          "id": "CompositeCeibaTableItem",
          "en": "Composite Ceiba Table",
          "fr": "Table en ceiba composite",
          "es": "Mesa de composite (ceiba)",
          "de": "Kapok-Verbundholztisch",
          "pt": "Mesa Composta de Ceiba",
          "it": "Tavolo Composito in Ceiba",
          "tr": "Kompozit Floş Masası",
          "pl": "Kompozytowy stół z puchowca",
          "ru": "Стол из композита сейбы",
          "uk": "Стіл із композиту сейби",
          "ko": "합성 명주나무 탁자",
          "zh": "复合木棉桌子",
          "ja": "複合材のパンヤノキのテーブル"
        },
        {
          "id": "CompositeCeibaDoorItem",
          "en": "Composite Ceiba Door",
          "fr": "Porte en ceiba composite",
          "es": "Puerta de composite (ceiba)",
          "de": "Kapok-Verbundholztür",
          "pt": "Porta Composta de Ceiba",
          "it": "Porta Composita in Ceiba",
          "tr": "Kompozit Floş Kapısı",
          "pl": "Kompozytowe drzwi z puchowca",
          "ru": "Дверь из композита сейбы",
          "uk": "Двері із композиту сейби",
          "ko": "합성 명주나무 문",
          "zh": "复合木棉门",
          "ja": "パンヤノキのドア"
        },
        {
          "id": "CompositeCeibaChairItem",
          "en": "Composite Ceiba Chair",
          "fr": "Chaise en ceiba composite",
          "es": "Silla de composite (ceiba)",
          "de": "Kapok-Verbundholzstuhl",
          "pt": "Cadeira Composta de Ceiba",
          "it": "Sedia Composita in Ceiba",
          "tr": "Kompozit Floş Sandalyesi",
          "pl": "Kompozytowe krzesło z puchowca",
          "ru": "Стул из композита сейбы",
          "uk": "Стілець із композиту сейби",
          "ko": "합성 명주나무 의자",
          "zh": "复合木棉椅子",
          "ja": "複合材のパンヤノキの椅子"
        },
        {
          "id": "CompositeCeibaBenchItem",
          "en": "Composite Ceiba Bench",
          "fr": "Banc en ceiba composite",
          "es": "Banco de composite (ceiba)",
          "de": "Kapok-Verbundholzbank",
          "pt": "Banco Composto de Ceiba",
          "it": "Panca Composita in Ceiba",
          "tr": "Kompozit Kapok Ağacı Tezgahı",
          "pl": "Kompozytowa ławka z puchowca",
          "ru": "Лавка из композита сейбы",
          "uk": "Лавка з композиту сейби",
          "ko": "합성 명주나무 벤치",
          "zh": "复合木棉长凳",
          "ja": "複合材のパンヤノキのベンチ"
        },
        {
          "id": "CompositeCedarTableItem",
          "en": "Composite Cedar Table",
          "fr": "Table en cèdre composite",
          "es": "Mesa de composite (cedro)",
          "de": "Zedern-Verbundholztisch",
          "pt": "Mesa Composta de Cedro",
          "it": "Tavolo Composito in Cedro",
          "tr": "Kompozit Sedir Masası",
          "pl": "Kompozytowy stół z cedru",
          "ru": "Стол из кедрового композита",
          "uk": "Стіл із композиту кедра",
          "ko": "합성 삼나무 탁자",
          "zh": "复合雪松桌",
          "ja": "複合材の杉のテーブル"
        },
        {
          "id": "CompositeCedarDoorItem",
          "en": "Composite Cedar Door",
          "fr": "Porte en cèdre composite",
          "es": "Puerta de composite (cedro)",
          "de": "Zedern-Verbundholztür",
          "pt": "Porta Composta de Cedro",
          "it": "Porta Composita in Cedro",
          "tr": "Kompozit Sedir Kapısı",
          "pl": "Kompozytowe drzwi z cedru",
          "ru": "Дверь из кедрового композита",
          "uk": "Двері із композиту кедра",
          "ko": "합성 삼나무 문",
          "zh": "复合雪松门",
          "ja": "杉のドア"
        },
        {
          "id": "CompositeCedarChairItem",
          "en": "Composite Cedar Chair",
          "fr": "Chaise en cèdre composite",
          "es": "Silla de composite (cedro)",
          "de": "Zedern-Verbundholzstuhl",
          "pt": "Cadeira Composta de Cedro",
          "it": "Sedia Composita in Cedro",
          "tr": "Kompozit Sedir Sandalyesi",
          "pl": "Kompozytowe krzesło z cedru",
          "ru": "Стул из кедрового композита",
          "uk": "Стелець із композиту кедра",
          "ko": "합성 삼나무 의자",
          "zh": "复合雪松木椅子",
          "ja": "複合材の杉の椅子"
        },
        {
          "id": "CompositeCedarBenchItem",
          "en": "Composite Cedar Bench",
          "fr": "Banc en cèdre composite",
          "es": "Banco de composite (cedro)",
          "de": "Zedern-Verbundholzbank",
          "pt": "Banco Composto de Cedro",
          "it": "Panca Composita in Cedro",
          "tr": "Kompozit Sedir Tezgah",
          "pl": "Kompozytowa ławka z cedru",
          "ru": "Лавка из кедрового композита",
          "uk": "Лавка з композиту кедра",
          "ko": "합성 삼나무 벤치",
          "zh": "复合雪松木长凳",
          "ja": "複合材の杉のベンチ"
        },
        {
          "id": "CompositeBirchTableItem",
          "en": "Composite Birch Table",
          "fr": "Table en bouleau composite",
          "es": "Mesa de composite (abedul)",
          "de": "Birken-Verbundholztisch",
          "pt": "Mesa Composta de Bétula",
          "it": "Tavolo Composito in Betulla",
          "tr": "Kompozit Huş Masası",
          "pl": "Kompozytowy stół z brzozy",
          "ru": "Стол из композитных берёзовых пиломатериалов",
          "uk": "Стіл із композиту берези",
          "ko": "합성 자작나무 탁자",
          "zh": "复合桦木桌",
          "ja": "複合材の白樺のテーブル"
        },
        {
          "id": "CompositeBirchDoorItem",
          "en": "Composite Birch Door",
          "fr": "Porte en bouleau composite",
          "es": "Puerta de composite (abedul)",
          "de": "Birken-Verbundholztür",
          "pt": "Porta Composta de Bétula",
          "it": "Porta Composita in Betulla",
          "tr": "Kompozit Huş Kapısı",
          "pl": "Kompozytowe drzwi z brzozy",
          "ru": "Дверь из композитных берёзовых пиломатериалов",
          "uk": "Двері із композиту берези",
          "ko": "합성 자작나무 문",
          "zh": "复合桦木门",
          "ja": "白樺のドア"
        },
        {
          "id": "CompositeBirchChairItem",
          "en": "Composite Birch Chair",
          "fr": "Chaise en bouleau composite",
          "es": "Silla de composite (abedul)",
          "de": "Birken-Verbundholzstuhl",
          "pt": "Cadeira Composta de Bétula",
          "it": "Sedia Composita in Betulla",
          "tr": "Kompozit Huş Sandalyesi",
          "pl": "Kompozytowe krzesło z brzozy",
          "ru": "Стул из композитных берёзовых пиломатериалов",
          "uk": "Стілець із композиту берези",
          "ko": "합성 자작나무 의자",
          "zh": "复合桦木椅子",
          "ja": "複合材の白樺の椅子"
        },
        {
          "id": "CompositeBirchBenchItem",
          "en": "Composite Birch Bench",
          "fr": "Banc en bouleau composite",
          "es": "Banco de composite (abedul)",
          "de": "Birken-Verbundholzbank",
          "pt": "Banco Composto de Bétula",
          "it": "Panca di Betulla Composita",
          "tr": "Kompozit Huş Ağacı Tezgahı",
          "pl": "Kompozytowa ławka brzozowa",
          "ru": "Лавка из композитных берёзовых пиломатериалов",
          "uk": "Лавка із композиту берези",
          "ko": "합성 자작나무 벤치",
          "zh": "复合桦木长凳",
          "ja": "複合材の白樺のベンチ"
        },
        {
          "id": "CensusBureauItem",
          "en": "Census Bureau",
          "fr": "Bureau du recensement",
          "es": "Oficina de censo",
          "de": "Einwohnermeldeamt",
          "pt": "Escritório do Censo",
          "it": "Ufficio del Censimento",
          "tr": "Nüfus İdaresi",
          "pl": "Biuro spisowe",
          "ru": "Бюро переписи населения",
          "uk": "Бюро перепису населення",
          "ko": "인구조사국",
          "zh": "人口普查局",
          "ja": "国勢調査局"
        },
        {
          "id": "CapitolItem",
          "en": "Capitol",
          "fr": "Pupitre de la Constitution",
          "es": "Capitolio",
          "de": "Tisch der Verfassung",
          "pt": "Capitólio",
          "it": "Campidoglio",
          "tr": "Hükümet Binası",
          "pl": "Kapitol",
          "ru": "Капитолий",
          "uk": "Капітолій",
          "ko": "중앙정부",
          "zh": "公约台",
          "ja": "国会議事堂"
        },
        {
          "id": "BrickFireplaceItem",
          "en": "Brick Fireplace",
          "fr": "Cheminée en briques",
          "es": "Chimenea de ladrillos",
          "de": "Backsteinkamin",
          "pt": "Lareira de Tijolos",
          "it": "Camino in Mattoni",
          "tr": "Tuğla Şömine",
          "pl": "Ceglany kominek",
          "ru": "Кирпичный камин",
          "uk": "Цегляний камін",
          "ko": "벽돌 벽난로",
          "zh": "砖壁炉",
          "ja": "レンガ暖炉"
        },
        {
          "id": "BoardOfElectionsItem",
          "en": "Board Of Elections",
          "fr": "Bureau des élections",
          "es": "Tablón de elecciones",
          "de": "Wahlvorstand",
          "pt": "Conselho Eleitoral",
          "it": "Consiglio Elettorale",
          "tr": "Seçim Kurulu",
          "pl": "Stanowisko wyborcze",
          "ru": "Избирательная комиссия",
          "uk": "Виборча рада",
          "ko": "선거관리위원회",
          "zh": "推选面板",
          "ja": "選挙管理局"
        },
        {
          "id": "BallotBoxItem",
          "en": "Ballot Box",
          "fr": "Urne électorale",
          "es": "Urna electoral",
          "de": "Wahlurne",
          "pt": "Urna Eleitoral",
          "it": "Urna Elettorale",
          "tr": "Oy Sandığı",
          "pl": "Urna wyborcza",
          "ru": "Урна для голосования",
          "uk": "Урна для голосовуння",
          "ko": "투표함",
          "zh": "选票箱",
          "ja": "投票箱"
        },
        {
          "id": "AshlarStoneTableItem",
          "en": "Ashlar Stone Table",
          "fr": "Table en pierre taillée",
          "es": "Mesa de piedra (sillar)",
          "de": "Quadersteintisch",
          "pt": "Mesa de Pedra Polida",
          "it": "Tavolo in Pietra Bugnata",
          "tr": "Kesme Taştan Masa",
          "pl": "Ciosany kamienny stół",
          "ru": "Стол из резного камня",
          "uk": "Стіл з обтесаного каменю",
          "ko": "각진 석재 탁자",
          "zh": "方琢石桌",
          "ja": "切石のテーブル"
        },
        {
          "id": "AshlarStoneFireplaceItem",
          "en": "Ashlar Stone Fireplace",
          "fr": "Cheminée en pierre taillée",
          "es": "Chimenea de piedra (sillar)",
          "de": "Quadersteinfeuerstelle",
          "pt": "Lareira de Pedra Polida",
          "it": "Camino in Pietra Bugnata",
          "tr": "Kesme Taştan Şömine",
          "pl": "Ciosany kamienny kominek",
          "ru": "Камин из резного камня",
          "uk": "Камін з обтесаного каменю",
          "ko": "각진 석재 벽난로",
          "zh": "方琢石壁炉",
          "ja": "切石の暖炉"
        },
        {
          "id": "AshlarStoneChairItem",
          "en": "Ashlar Stone Chair",
          "fr": "Chaise en pierre taillée",
          "es": "Silla de piedra (sillar)",
          "de": "Quadersteinstuhl",
          "pt": "Cadeira de Pedra Polida",
          "it": "Sedia in Pietra Bugnata",
          "tr": "Kesme Taştan Sandalye",
          "pl": "Ciosane kamienne krzesło",
          "ru": "Стул из резного камня",
          "uk": "Стілець з обтесаного каменю",
          "ko": "각진 석재 의자",
          "zh": "方琢石椅",
          "ja": "切石の椅子"
        },
        {
          "id": "AshlarStoneBenchItem",
          "en": "Ashlar Stone Bench",
          "fr": "Banc en pierre taillée",
          "es": "Banco de piedra (sillar)",
          "de": "Quadersteinbank",
          "pt": "Banco de Pedra Polida",
          "it": "Panca in Pietra Bugnata",
          "tr": "Kesme Taş Tezgah",
          "pl": "Ciosana kamienna ławka",
          "ru": "Лавка из резного камня",
          "uk": "Лавка з обтесаного каменю",
          "ko": "각진 석재 벤치",
          "zh": "方琢石凳",
          "ja": "切石のベンチ"
        },
        {
          "id": "AshlarSmallStoneFountainItem",
          "en": "Ashlar Small Stone Fountain",
          "fr": "Petite fontaine en pierre taillée",
          "es": "Fuente pequeña de piedra (sillar)",
          "de": "Kleiner Quadersteinbrunnen",
          "pt": "Fonte Pequena de Pedra Polida",
          "it": "Piccola Fontana in Pietra Bugnata",
          "tr": "Küçük Kesme Taş Çeşme",
          "pl": "Mała fontanna z ciosanego kamienia",
          "ru": "Маленький фонтан из резного камня",
          "uk": "Малий фонтан з обтесаного каменю",
          "ko": "소형 각진 석재 분수",
          "zh": "小型方琢石喷泉",
          "ja": "切石の小さな噴水"
        },
        {
          "id": "AshlarSmallShaleFountainItem",
          "en": "Ashlar Small Shale Fountain",
          "fr": "Petite fontaine en schiste taillé",
          "es": "Fuente pequeña de pizarra (sillar)",
          "de": "Kleiner Schieferquaderbrunnen",
          "pt": "Fonte Pequena de Xisto Polido",
          "it": "Piccola Fontana in Scisto Bugnato",
          "tr": "Küçük Kesme Yaprak Taş Çeşmesi",
          "pl": "Mała fontanna z ciosanego łupku",
          "ru": "Маленький фонтан из резного сланца",
          "uk": "Малий фонтан з обтесаного сланцю",
          "ko": "소형 각진 이판암 분수",
          "zh": "小型方琢页岩喷泉",
          "ja": "頁岩の切石の小さな噴水"
        },
        {
          "id": "AshlarSmallSandstoneFountainItem",
          "en": "Ashlar Small Sandstone Fountain",
          "fr": "Petite fontaine en grès taillé",
          "es": "Fuente pequeña (sillar de arenisca)",
          "de": "Kleiner Sandsteinquaderbrunnen",
          "pt": "Fonte Pequena de Arenito Polido",
          "it": "Piccola Fontana in Arenaria Bugnata",
          "tr": "Küçük Kesme Kumtaşı Çeşmesi",
          "pl": "Mała fontanna z ciosanego piaskowca",
          "ru": "Маленький фонтан из резного песчаника",
          "uk": "Малий фонтан з обтесаного пісковику",
          "ko": "소형 각진 사암 분수",
          "zh": "小型方琢砂岩喷泉",
          "ja": "砂岩の切石の小さな噴水"
        },
        {
          "id": "AshlarSmallLimestoneFountainItem",
          "en": "Ashlar Small Limestone Fountain",
          "fr": "Petite fontaine en calcaire taillé",
          "es": "Fuente pequeña de calcita (sillar)",
          "de": "Kleiner Kalksteinquaderbrunnen",
          "pt": "Fonte Pequena de Calcário Polido",
          "it": "Piccola Fontana in Calcare Bugnato",
          "tr": "Küçük Kesme Kireç Taşı Çeşmesi",
          "pl": "Mała fontanna z ciosanego wapienia",
          "ru": "Маленький фонтан из резного известняка",
          "uk": "Малий фонтан з обтесаного вапняку",
          "ko": "소형 각진 석회암 분수",
          "zh": "小型方琢石灰石喷泉",
          "ja": "石灰岩の切石の小さな噴水"
        },
        {
          "id": "AshlarSmallGraniteFountainItem",
          "en": "Ashlar Small Granite Fountain",
          "fr": "Petite fontaine en granite taillé",
          "es": "Fuente pequeña de granito (sillar)",
          "de": "Kleiner Granitquaderbrunnen",
          "pt": "Fonte Pequena de Granito Polido",
          "it": "Piccola Fontana in Granito Bugnato",
          "tr": "Küçük Kesme Granit Çeşmesi",
          "pl": "Mała fontanna z ciosanego granitu",
          "ru": "Маленький фонтан из резного гранита",
          "uk": "Малий фонтан з обтесаного граніту",
          "ko": "소형 각진 화강암 분수",
          "zh": "小型方琢花岗岩喷泉",
          "ja": "花崗岩の切石の小さな噴水"
        },
        {
          "id": "AshlarSmallGneissFountainItem",
          "en": "Ashlar Small Gneiss Fountain",
          "fr": "Petite fontaine en gneiss taillé",
          "es": "Fuente pequeña de gneis (sillar)",
          "de": "Kleiner Gneisquaderbrunnen",
          "pt": "Fonte Pequena de Gneisse Polido",
          "it": "Piccola Fontana in Gneiss Bugnato",
          "tr": "Küçük Kesme Gnays Çeşmesi",
          "pl": "Mała fontanna z ciosanego gnejsu",
          "ru": "Маленький фонтан из резного гнейса",
          "uk": "Малий фонтан з обтесаного гнейсу",
          "ko": "소형 각진 편마암 분수",
          "zh": "小型方琢片麻岩喷泉",
          "ja": "片麻岩の切石の小さな噴水"
        },
        {
          "id": "AshlarSmallBasaltFountainItem",
          "en": "Ashlar Small Basalt Fountain",
          "fr": "Petite fontaine en basalte taillé",
          "es": "Fuente pequeña de basalto (sillar)",
          "de": "Kleiner Basaltquaderbrunnen",
          "pt": "Fonte Pequena de Basalto Polido",
          "it": "Piccola Fontana in Basalto Bugnato",
          "tr": "Küçük Kesme Bazalt Çeşme",
          "pl": "Mała fontanna z ciosanego bazaltu",
          "ru": "Маленький фонтан из резного базальта",
          "uk": "Малий фонтан з обтесаного базальту",
          "ko": "소형 각진 현무암 분수",
          "zh": "小型方琢玄武岩喷泉",
          "ja": "玄武岩の切石の小さな噴水"
        },
        {
          "id": "AshlarShaleTableItem",
          "en": "Ashlar Shale Table",
          "fr": "Table en schiste taillé",
          "es": "Mesa de pizarra (sillar)",
          "de": "Schieferquadertisch",
          "pt": "Mesa de Xisto Polido",
          "it": "Tavolo in Scisto Bugnato",
          "tr": "Kesme Kilden Masa",
          "pl": "Ciosany łupkowy stół",
          "ru": "Стол из резного сланца",
          "uk": "Стіл з обтесаного сланцю",
          "ko": "각진 이판암 탁자",
          "zh": "方琢页岩台",
          "ja": "頁岩の切石のテーブル"
        },
        {
          "id": "AshlarShaleFireplaceItem",
          "en": "Ashlar Shale Fireplace",
          "fr": "Cheminée en schiste taillé",
          "es": "Chimenea de pizarra (sillar)",
          "de": "Schieferquaderfeuerstelle",
          "pt": "Lareira de Xisto Polido",
          "it": "Camino in Scisto Bugnato",
          "tr": "Kesme Kilden Şömine",
          "pl": "Ciosany łupkowy kominek",
          "ru": "Камин из резного сланца",
          "uk": "Камін з обтесаного сланцю",
          "ko": "각진 이판암 벽난로",
          "zh": "方琢页岩壁炉",
          "ja": "頁岩の切石暖炉"
        },
        {
          "id": "AshlarShaleChairItem",
          "en": "Ashlar Shale Chair",
          "fr": "Chaise en schiste taillé",
          "es": "Silla de pizarra (sillar)",
          "de": "Schieferquaderbank",
          "pt": "Cadeira de Xisto Polido",
          "it": "Sedia in Scisto Bugnato",
          "tr": "Kesme Kilden Sandalye",
          "pl": "Ciosane łupkowe krzesło",
          "ru": "Стул из резного сланца",
          "uk": "Стілець з обтесаного сланцю",
          "ko": "각진 이판암 의자",
          "zh": "方琢页岩椅",
          "ja": "頁岩の切石の椅子"
        },
        {
          "id": "AshlarShaleBenchItem",
          "en": "Ashlar Shale Bench",
          "fr": "Banc en schiste taillé",
          "es": "Banco de pizarra (sillar)",
          "de": "Schieferquaderbank",
          "pt": "Banco de Xisto Polido",
          "it": "Panca in Scisto Bugnato",
          "tr": "Kesme Yaprak Taşı Tezgahı",
          "pl": "Ciosana łupkowa ławka",
          "ru": "Лавка из резного сланца",
          "uk": "Лавка з обтесаного сланцю",
          "ko": "각진 이판암 벤치",
          "zh": "方琢页岩长凳",
          "ja": "頁岩の切石のベンチ"
        },
        {
          "id": "AshlarSandstoneTableItem",
          "en": "Ashlar Sandstone Table",
          "fr": "Table en grès taillé",
          "es": "Mesa (sillar de arenisca)",
          "de": "Sandsteinquadertisch",
          "pt": "Mesa de Arenito Polido",
          "it": "Tavolo in Arenaria Bugnata",
          "tr": "Kesme Kumtaşından Masa",
          "pl": "Ciosany piaskowcowy stół",
          "ru": "Стол из резного песчаника",
          "uk": "Стіл з обтесаного пісковику",
          "ko": "각진 사암 탁자",
          "zh": "方琢砂岩桌",
          "ja": "砂岩の切石のテーブル"
        },
        {
          "id": "AshlarSandstoneFireplaceItem",
          "en": "Ashlar Sandstone Fireplace",
          "fr": "Cheminée en grès taillé",
          "es": "Chimenea (sillar de arenisca)",
          "de": "Sandsteinquaderfeuerstellen",
          "pt": "Lareira de Arenito Polido",
          "it": "Camino in Arenaria Bugnata",
          "tr": "Kesme Kumtaşından Şömine",
          "pl": "Ciosany piaskowcowy kominek",
          "ru": "Камин из резного песчаника",
          "uk": "Камін із облицювального пісковику",
          "ko": "각진 사암 벽난로",
          "zh": "方琢砂岩壁炉",
          "ja": "砂岩の切石の暖炉"
        },
        {
          "id": "AshlarSandstoneChairItem",
          "en": "Ashlar Sandstone Chair",
          "fr": "Chaise en grès taillé",
          "es": "Silla (sillar de arenisca)",
          "de": "Sandsteinquaderstuhl",
          "pt": "Cadeira de Arenito Polido",
          "it": "Sedia in Arenaria Bugnata",
          "tr": "Kesme Kumtaşından Sandalye",
          "pl": "Ciosane piaskowcowe krzesło",
          "ru": "Стул из резного песчаника",
          "uk": "Стілець із облицювального пісковику",
          "ko": "각진 사암 의자",
          "zh": "方琢砂岩椅",
          "ja": "砂岩の切石の椅子"
        },
        {
          "id": "AshlarSandstoneBenchItem",
          "en": "Ashlar Sandstone Bench",
          "fr": "Banc en grès taillé",
          "es": "Banco (sillar de arenisca)",
          "de": "Sandsteinquaderbank",
          "pt": "Banco de Arenito Polido",
          "it": "Panca in Arenaria Bugnata",
          "tr": "Kesme Kumtaşı Tezgahı",
          "pl": "Ciosana piaskowcowa ławka",
          "ru": "Лавка из резного песчаника",
          "uk": "Лавка з облицювального пісковику",
          "ko": "각진 사암 벤치",
          "zh": "方琢砂岩长凳",
          "ja": "砂岩の切石のベンチ"
        },
        {
          "id": "AshlarLimestoneTableItem",
          "en": "Ashlar Limestone Table",
          "fr": "Table en calcaire taillé",
          "es": "Mesa (sillar de piedra caliza)",
          "de": "Kalksteinquadertisch",
          "pt": "Mesa de Calcário Polido",
          "it": "Tavolo in Calcare Bugnato",
          "tr": "Kesme Kireç Taşından Masa",
          "pl": "Ciosany wapienny stół",
          "ru": "Стол из резного известняка",
          "uk": "Стіл із облицювального вапняку",
          "ko": "각진 석회암 탁자",
          "zh": "方琢石灰石桌",
          "ja": "石灰岩の切石のベンチ"
        },
        {
          "id": "AshlarLimestoneFireplaceItem",
          "en": "Ashlar Limestone Fireplace",
          "fr": "Cheminée en calcaire taillé",
          "es": "Chimenea (sillar de piedra caliza)",
          "de": "Kalksteinquaderfeuerstelle",
          "pt": "Lareira de Calcário Polido",
          "it": "Camino in Calcare Bugnato",
          "tr": "Kesme Kireç Taşından Şömine",
          "pl": "Ciosany wapienny kominek",
          "ru": "Камин из обработанного известняка",
          "uk": "Камін із облицювального вапняку",
          "ko": "각진 석회암 벽난로",
          "zh": "方琢石灰石壁炉",
          "ja": "石灰岩の切石の暖炉"
        },
        {
          "id": "AshlarLimestoneChairItem",
          "en": "Ashlar Limestone Chair",
          "fr": "Chaise en calcaire taillé",
          "es": "Silla (sillar de piedra caliza)",
          "de": "Kalksteinquaderstuhl",
          "pt": "Cadeira de Calcário Polido",
          "it": "Sedia in Calcare Bugnato",
          "tr": "Kesme Kireç Taşından Sandalye",
          "pl": "Ciosane wapienne krzesło",
          "ru": "Стул из резного известняка",
          "uk": "Стілець із облицювального вапняку",
          "ko": "각진 석회암 의자",
          "zh": "方琢石灰石椅子",
          "ja": "石灰岩の切石の椅子"
        },
        {
          "id": "AshlarLimestoneBenchItem",
          "en": "Ashlar Limestone Bench",
          "fr": "Banc en calcaire taillé",
          "es": "Banco (sillar de piedra caliza)",
          "de": "Kalksteinquaderbank",
          "pt": "Banco de Calcário Polido",
          "it": "Panca in Calcare Bugnato",
          "tr": "Kesme Kireç Taşı Tezgahı",
          "pl": "Ławka z ciosanego kamienia",
          "ru": "Лавка из резного известняка",
          "uk": "Лавка з облицювального вапняку",
          "ko": "각진 석회암 벤치",
          "zh": "方琢石灰石长凳",
          "ja": "石灰岩の切石のベンチ"
        },
        {
          "id": "AshlarLargeStoneFountainItem",
          "en": "Ashlar Large Stone Fountain",
          "fr": "Grande fontaine en pierre taillée",
          "es": "Fuente grande (sillar de piedra)",
          "de": "Großer Steinquaderbrunnen",
          "pt": "Fonte Grande de Pedra Polida",
          "it": "Grande Fontana in Pietra Bugnata",
          "tr": "Büyük Kesme Taş Çeşme",
          "pl": "Duża fontanna z ciosanego kamienia",
          "ru": "Фонтан из резного камня",
          "uk": "Великий фонтан з обтесаного каменю",
          "ko": "대형 각진 석재 분수",
          "zh": "大型方琢型石喷泉",
          "ja": "大きな石の切石の噴水"
        },
        {
          "id": "AshlarLargeShaleFountainItem",
          "en": "Ashlar Large Shale Fountain",
          "fr": "Grande fontaine en schiste taillé",
          "es": "Fuente grande de pizarra (sillar)",
          "de": "Großer Schieferquaderbrunnen",
          "pt": "Fonte Grande de Xisto Polido",
          "it": "Grande Fontana in Scisto Bugnato",
          "tr": "Küçük Kesme Yaprak Taşı Çeşme",
          "pl": "Duża fontanna z ciosanego łupku",
          "ru": "Фонтан из резного сланца",
          "uk": "Великий фонтан з обтесаного сланцю",
          "ko": "대형 각진 이판암 분수",
          "zh": "大型方琢型页岩喷泉",
          "ja": "大きな頁岩の切石の噴水"
        },
        {
          "id": "AshlarLargeSandstoneFountainItem",
          "en": "Ashlar Large Sandstone Fountain",
          "fr": "Grande fontaine en grès taillé",
          "es": "Fuente grande (sillar de arenisca)",
          "de": "Großer Sandsteinquaderbrunnen",
          "pt": "Fonte Grande de Arenito Polido",
          "it": "Grande Fontana in Arenaria Bugnata",
          "tr": "Büyük Kesme Kumtaşı Çeşmesi",
          "pl": "Duża fontanna z ciosanego piaskowca",
          "ru": "Фонтан из резного песчаника",
          "uk": "Великий фонтан з обтесаного пісковику",
          "ko": "대형 각진 사암 분수",
          "zh": "大型方琢型砂岩喷泉",
          "ja": "大きな砂岩の切石の噴水"
        },
        {
          "id": "AshlarLargeLimestoneFountainItem",
          "en": "Ashlar Large Limestone Fountain",
          "fr": "Grande fontaine en calcaire taillé",
          "es": "Fuente grande (sillar de piedra caliza)",
          "de": "Großer Kalksteinquaderbrunnen",
          "pt": "Fonte Grande de Calcário Polido",
          "it": "Grande Fontana in Calcare Bugnato",
          "tr": "Büyük Kesme Kalker Taşı Çeşmesi",
          "pl": "Duża fontanna z ciosanego wapienia",
          "ru": "Фонтан из резного известняка",
          "uk": "Великий фонтан з обтесаного вапняку",
          "ko": "대형 각진 석회암 분수",
          "zh": "大型方琢型石灰石喷泉",
          "ja": "大きな石灰岩の切石の噴水"
        },
        {
          "id": "AshlarLargeGraniteFountainItem",
          "en": "Ashlar Large Granite Fountain",
          "fr": "Grande fontaine en granite taillé",
          "es": "Fuente grande (sillar de granito)",
          "de": "Großer Granitquaderbrunnen",
          "pt": "Fonte Grande de Granito Polido",
          "it": "Grande Fontana in Granito Bugnato",
          "tr": "Büyük Kesme Granit Çeşmesi",
          "pl": "Duża fontanna z ciosanego granitu",
          "ru": "Фонтан из резного гранита",
          "uk": "Великий фонтан з обтесаного граніту",
          "ko": "대형 각진 화강암 분수",
          "zh": "大型方琢型花岗岩喷泉",
          "ja": "大きな花崗岩の切石の噴水"
        },
        {
          "id": "AshlarLargeGneissFountainItem",
          "en": "Ashlar Large Gneiss Fountain",
          "fr": "Grande fontaine en gneiss taillé",
          "es": "Fuente grande (sillar de gneis)",
          "de": "Großer Gneisquaderbrunnen",
          "pt": "Fonte Grande de Gneisse Polido",
          "it": "Grande Fontana in Gneiss Bugnato",
          "tr": "Büyük Kesme Gnays Çeşmesi",
          "pl": "Duża fontanna z ciosanego gnejsu",
          "ru": "Фонтан из резного гнейса",
          "uk": "Великий фонтан з обтесаного гнейсу",
          "ko": "대형 각진 편마암 분수",
          "zh": "大型方琢片麻岩喷泉",
          "ja": "大きな片麻岩の切石の噴水"
        },
        {
          "id": "AshlarLargeBasaltFountainItem",
          "en": "Ashlar Large Basalt Fountain",
          "fr": "Grande fontaine en basalte taillé",
          "es": "Fuente grande (sillar de basalto)",
          "de": "Großer Basaltquaderbrunnen",
          "pt": "Fonte Grande de Basalto Polido",
          "it": "Grande Fontana in Basalto Bugnato",
          "tr": "Büyük Kesme Bazalt Taşı Çeşmesi",
          "pl": "Duża fontanna z ciosanego bazaltu",
          "ru": "Фонтан из резного базальта",
          "uk": "Великий фонтан з обтесаного базальту",
          "ko": "대형 각진 현무암 분수",
          "zh": "大型方琢型玄武岩喷泉",
          "ja": "大きな切石の玄武岩の噴水"
        },
        {
          "id": "AshlarGraniteTableItem",
          "en": "Ashlar Granite Table",
          "fr": "Table en granite taillé",
          "es": "Mesa (sillar de arenisca)",
          "de": "Granitquadertisch",
          "pt": "Mesa de Granito Polido",
          "it": "Tavolo in Granito Bugnato",
          "tr": "Kesme Granit Masa",
          "pl": "Stół z ciosanego granitu",
          "ru": "Стол из резного гранита",
          "uk": "Стіл з обтесаного граніту",
          "ko": "각진 화강암 탁자",
          "zh": "花岗岩桌子",
          "ja": "花崗岩の切石のテーブル"
        },
        {
          "id": "AshlarGraniteFireplaceItem",
          "en": "Ashlar Granite Fireplace",
          "fr": "Cheminée en granite taillé",
          "es": "Chimenea (sillar de granito)",
          "de": "Granitquaderfeuerstelle",
          "pt": "Lareira de Granito Polido",
          "it": "Camino in Granito Bugnato",
          "tr": "Kesme Granit Şömine",
          "pl": "Kominek z ciosanego granitu",
          "ru": "Камин из резного гранита",
          "uk": "Камін з обтесаного граніту",
          "ko": "각진 화강암 벽난로",
          "zh": "方琢花岗岩壁炉",
          "ja": "花崗岩の切石の暖炉"
        },
        {
          "id": "AshlarGraniteChairItem",
          "en": "Ashlar Granite Chair",
          "fr": "Chaise en granite taillé",
          "es": "Silla (sillar de granito)",
          "de": "Granitquaderstuhl",
          "pt": "Cadeira de Granito Polido",
          "it": "Sedia in Granito Bugnato",
          "tr": "Kesme Granit Sandalye",
          "pl": "Krzesło z ciosanego granitu",
          "ru": "Стул из резного гранита",
          "uk": "Стілець з обтесаного граніту",
          "ko": "각진 화강암 의자",
          "zh": "方琢花岗岩椅子",
          "ja": "花崗岩の切石の椅子"
        },
        {
          "id": "AshlarGraniteBenchItem",
          "en": "Ashlar Granite Bench",
          "fr": "Banc en granite taillé",
          "es": "Banco (sillar de granito)",
          "de": "Granitquaderbank",
          "pt": "Banco de Granito Polido",
          "it": "Panca in Granito Bugnato",
          "tr": "Kesme Granit Tezgah",
          "pl": "Ławka z ciosanego granitu",
          "ru": "Лавка из резного гранита",
          "uk": "Лавка з обтесаного граніту",
          "ko": "각진 화강암 벤치",
          "zh": "方琢花岗岩长凳",
          "ja": "花崗岩の切石のベンチ"
        },
        {
          "id": "AshlarGneissTableItem",
          "en": "Ashlar Gneiss Table",
          "fr": "Table en gneiss taillé",
          "es": "Mesa (sillar de gneis)",
          "de": "Gneisquadertisch",
          "pt": "Mesa de Gnaisse Polido",
          "it": "Tavolo in Gneiss Bugnato",
          "tr": "Kesme Gnays Masa",
          "pl": "Stół z ciosanego gnejsu",
          "ru": "Стол из резного гнейса",
          "uk": "Стіл з обтесаного гнейсу",
          "ko": "각진 편마암 탁자",
          "zh": "方琢片麻岩桌",
          "ja": "片麻岩の切石のテーブル"
        },
        {
          "id": "AshlarGneissFireplaceItem",
          "en": "Ashlar Gneiss Fireplace",
          "fr": "Cheminée en gneiss taillé",
          "es": "Chimenea (sillar de gneis)",
          "de": "Gneisquaderfeuerstelle",
          "pt": "Lareira de Gnaisse Polido",
          "it": "Camino in Gneiss Bugnato",
          "tr": "Kesme Gnays Şömine",
          "pl": "Kominek z ciosanego gnejsu",
          "ru": "Камин из резного гнейса",
          "uk": "Камін з обтесаного гнейсу",
          "ko": "각진 편마암 벽난로",
          "zh": "方琢片麻岩壁炉",
          "ja": "片麻岩の切石の暖炉"
        },
        {
          "id": "AshlarGneissChairItem",
          "en": "Ashlar Gneiss Chair",
          "fr": "Chaise en gneiss taillé",
          "es": "Silla (sillar de gneis)",
          "de": "Gneisquaderstuhl",
          "pt": "Cadeira de Gnaisse Polido",
          "it": "Sedia in Gneiss Bugnato",
          "tr": "Kesme Gnays Sandalye",
          "pl": "Krzesło z ciosanego gnejsu",
          "ru": "Стул из резного гнейса",
          "uk": "Стілець з обтесаного гнейсу",
          "ko": "각진 편마암 의자",
          "zh": "方琢片麻岩椅子",
          "ja": "片麻岩の切石の椅子"
        },
        {
          "id": "AshlarGneissBenchItem",
          "en": "Ashlar Gneiss Bench",
          "fr": "Banc en gneiss taillé",
          "es": "Banco (sillar de gneis)",
          "de": "Gneisquaderbank",
          "pt": "Banco de Gnaisse Polido",
          "it": "Panca in Gneiss Bugnato",
          "tr": "Kesme Gnays Tezgah",
          "pl": "Ławka z ciosanego gnejsu",
          "ru": "Лавка из резного гнейса",
          "uk": "Лавка з обтесаного гнейсу",
          "ko": "각진 편마암 벤치",
          "zh": "方琢片麻岩长凳",
          "ja": "片麻岩の切石のベンチ"
        },
        {
          "id": "AshlarBasaltTableItem",
          "en": "Ashlar Basalt Table",
          "fr": "Table en basalte taillé",
          "es": "Mesa (sillar de basalto)",
          "de": "Basaltquadertisch",
          "pt": "Mesa de Basalto Polido",
          "it": "Tavolo in Basalto Bugnato",
          "tr": "Kesme Bazalttan Masa",
          "pl": "Stół z ciosanego bazaltu",
          "ru": "Стол из резного базальта",
          "uk": "Стіл з обтесаного базальту",
          "ko": "각진 현무암 탁자",
          "zh": "方琢玄武岩桌",
          "ja": "玄武岩の切石のテーブル"
        },
        {
          "id": "AshlarBasaltFireplaceItem",
          "en": "Ashlar Basalt Fireplace",
          "fr": "Cheminée en basalte taillé",
          "es": "Chimenea (sillar de basalto)",
          "de": "Basaltquaderfeuerstelle",
          "pt": "Lareira de Basalto Polido",
          "it": "Camino in Basalto Bugnato",
          "tr": "Kesme Bazalttan Şömine",
          "pl": "Kominek z ciosanego bazaltu",
          "ru": "Камин из резного базальта",
          "uk": "Камін з обтесаного базальту",
          "ko": "각진 현무암 벽난로",
          "zh": "方琢玄武岩壁炉",
          "ja": "玄武岩の切石の暖炉"
        },
        {
          "id": "AshlarBasaltChairItem",
          "en": "Ashlar Basalt Chair",
          "fr": "Chaise en basalte taillé",
          "es": "Silla (sillar de basalto)",
          "de": "Basaltquaderstuhl",
          "pt": "Cadeira de Basalto Polido",
          "it": "Sedia in Basalto Bugnato",
          "tr": "Kesme Bazalttan Sandalye",
          "pl": "Krzesło z ciosanego bazaltu",
          "ru": "Стул из резного базальта",
          "uk": "Стілець з обтесаного базальту",
          "ko": "각진 현무암 의자",
          "zh": "方琢玄武岩椅子",
          "ja": "玄武岩の切石の椅子"
        },
        {
          "id": "AshlarBasaltBenchItem",
          "en": "Ashlar Basalt Bench",
          "fr": "Banc en basalte taillé",
          "es": "Banco (sillar de basalto)",
          "de": "Basaltquaderbank",
          "pt": "Banco de Basalto Polido",
          "it": "Panca in Basalto Bugnato",
          "tr": "Kesme Bazalt Tezgah",
          "pl": "Ławka z ciosanego bazaltu",
          "ru": "Лавка из резного базальта",
          "uk": "Лавка з обтесаного базальту",
          "ko": "각진 현무암 벤치",
          "zh": "方琢玄武岩长凳",
          "ja": "玄武岩の切石のベンチ"
        },
        {
          "id": "ArrastraItem",
          "en": "Arrastra",
          "fr": "Concasseur à meules",
          "es": "Arrastra",
          "de": "Bergbau-Pochmühle",
          "pt": "Arrastra",
          "it": "Arrastra",
          "tr": "Arrastra",
          "pl": "Kamienny młyn",
          "ru": "Аррастра",
          "uk": "Аррастра",
          "ko": "돌 맷돌",
          "zh": "碎金研磨机",
          "ja": "アラストラ"
        },
        {
          "id": "AmendmentsItem",
          "en": "Amendments",
          "fr": "Pupitre des amendements",
          "es": "Enmiendas",
          "de": "Verfassungsänderungen",
          "pt": "Emendas",
          "it": "Emendamenti",
          "tr": "Değişiklikler",
          "pl": "Poprawki",
          "ru": "Поправки",
          "uk": "Поправки",
          "ko": "입법부",
          "zh": "修正案",
          "ja": "改正"
        },
        {
          "id": "AdvancedMasonryTableItem",
          "en": "Advanced Masonry Table",
          "fr": "Établi de maçonnerie avancé",
          "es": "Mesa de mampostería avanzada",
          "de": "Verbesserter Steinmetztisch",
          "pt": "Mesa de alvenaria avançada",
          "it": "Tavolo da Muratura Avanzato",
          "tr": "Gelişmiş Duvarcılık Masası",
          "pl": "Zaawansowany stół kamieniarski",
          "ru": "Продвинутый верстак каменщика",
          "uk": "Покращенний верстак муляра",
          "ko": "고급 석공 작업대",
          "zh": "高级石工台",
          "ja": "高度な石工作業台"
        },
        {
          "id": "AdvancedCarpentryTableItem",
          "en": "Advanced Carpentry Table",
          "fr": "Établi de menuiserie avancé",
          "es": "Mesa de carpintería avanzada",
          "de": "Verbesserter Schreinerhandwerkstisch",
          "pt": "Mesa de carpintaria avançada",
          "it": "Banco da Carpenteria Avanzato",
          "tr": "Gelişmiş Marangoz Masası",
          "pl": "Zaawansowany stół stolarski",
          "ru": "Продвинутый верстак плотника",
          "uk": "Розширений теслярський стіл",
          "ko": "고급 목공 작업대",
          "zh": "高级木工桌",
          "ja": "高度な木工作業台"
        },
        {
          "id": "AdornedAshlarStoneTableItem",
          "en": "Adorned Ashlar Stone Table",
          "fr": "Table en pierre taillée ornée",
          "es": "Mesa adornada (sillar de piedra)",
          "de": "Geschmückter Steinquadertisch",
          "pt": "Mesa de Pedra Polida Adornada",
          "it": "Tavolo di Pietra Bugnata Adornato",
          "tr": "Süslenmiş Kesme Taş Masa",
          "pl": "Zdobiony stół z ciosanego kamienia",
          "ru": "Украшенный стол из резного камня",
          "uk": "Прикрашений стіл з різьбленого каменю",
          "ko": "장식된 각진 석재 탁자",
          "zh": "装饰过的方琢石桌",
          "ja": "装飾付き切石のテーブル"
        },
        {
          "id": "AdornedAshlarStoneChairItem",
          "en": "Adorned Ashlar Stone Chair",
          "fr": "Chaise en pierre taillée ornée",
          "es": "Silla adornada (sillar de piedra)",
          "de": "Geschmückter Steinquaderstuhl",
          "pt": "Cadeira de Pedra Polida Adornada",
          "it": "Sedia in Pietra Bugnata Adornata",
          "tr": "Süslenmiş Kesme Taş Sandalye",
          "pl": "Zdobione krzesło z ciosanego kamienia",
          "ru": "Украшенный стул из резного камня",
          "uk": "Прикрашений стілець з різьбленого каменю",
          "ko": "장식된 각진 석재 의자",
          "zh": "装饰过的方琢石椅",
          "ja": "装飾付き切石の椅子"
        },
        {
          "id": "AdornedAshlarStoneBenchItem",
          "en": "Adorned Ashlar Stone Bench",
          "fr": "Banc en pierre taillée ornée",
          "es": "Banco adornado (sillar de piedra)",
          "de": "Geschmückter Steinquaderbank",
          "pt": "Banco de Pedra Polida Adornada",
          "it": "Panca in Pietra Bugnata Adornata",
          "tr": "Süslenmiş Kesme Taş Tezgah",
          "pl": "Zdobiona ławka z ciosanego kamienia",
          "ru": "Украшенная лавка из резного камня",
          "uk": "Прикрашена лавка з різьбленого каменю",
          "ko": "장식된 각진 석재 벤치",
          "zh": "装饰过的方琢石凳",
          "ja": "装飾付き切石のベンチ"
        },
        {
          "id": "AdornedAshlarShaleTableItem",
          "en": "Adorned Ashlar Shale Table",
          "fr": "Table en schiste taillé ornée",
          "es": "Mesa adornada de pizarra (sillar)",
          "de": "Geschmückter Schieferquadertisch",
          "pt": "Mesa de Xisto Polido Adornado",
          "it": "Tavolo in Scisto Bugnato Adornato",
          "tr": "Süslenmiş Kesme Yaprak Taş Masası",
          "pl": "Zdobiony stół z ciosanego łupku",
          "ru": "Украшенный стол из резного сланца",
          "uk": "Прикрашений стіл із різьбленого сланцю",
          "ko": "장식된 각진 이판암 탁자",
          "zh": "装饰过的方琢页岩桌",
          "ja": "頁岩の装飾付き切石のテーブル"
        },
        {
          "id": "AdornedAshlarShaleChairItem",
          "en": "Adorned Ashlar Shale Chair",
          "fr": "Chaise en schiste taillé ornée",
          "es": "Silla adornada de pizarra (sillar)",
          "de": "Geschmückter Schieferquaderstuhl",
          "pt": "Cadeira de Xisto Polido Adornado",
          "it": "Sedia in Scisto Bugnato Adornata",
          "tr": "Süslenmiş Kesme Yaprak Taş Sandalyesi",
          "pl": "Zdobione krzesło z ciosanego łupku",
          "ru": "Украшенный стул из резного сланца",
          "uk": "Прикрашений стілець із різьбленого сланцю",
          "ko": "장식된 각진 이판암 탁자",
          "zh": "装饰过的方琢页岩椅",
          "ja": "頁岩の装飾付き切石の椅子"
        },
        {
          "id": "AdornedAshlarShaleBenchItem",
          "en": "Adorned Ashlar Shale Bench",
          "fr": "Banc en schiste taillé orné",
          "es": "Banco adornado de pizarra (sillar)",
          "de": "Geschmückter Schieferquaderbank",
          "pt": "Banco de Xisto Polido Adornado",
          "it": "Panca in Scisto Bugnato Adornata",
          "tr": "Süslenmiş Kesme Yaprak Taş Tezgahı",
          "pl": "Zdobiona ławka z ciosanego łupku",
          "ru": "Украшенная лавка из резного сланца",
          "uk": "Прикрашена лавка із різьбленого сланцю",
          "ko": "장식된 각진 이판암 벤치",
          "zh": "装饰过的方琢页岩长凳",
          "ja": "頁岩の装飾付き切石のベンチ"
        },
        {
          "id": "AdornedAshlarSandstoneTableItem",
          "en": "Adorned Ashlar Sandstone Table",
          "fr": "Table en grès taillé ornée",
          "es": "Mesa adornada (sillar de arenisca)",
          "de": "Geschmückter Sandsteinquadertisch",
          "pt": "Mesa de Arenito Polido Adornado",
          "it": "Tavolo in Arenaria Bugnata Adornato",
          "tr": "Süslenmiş Kesme Kumtaşı Masa",
          "pl": "Zdobiony stół z ciosanego piaskowca",
          "ru": "Украшенный стол из резного песчаника",
          "uk": "Прикрашений стіл із різьбленого піщаника",
          "ko": "장식된 각진 사암 탁자",
          "zh": "装饰过的方琢砂岩桌",
          "ja": "砂岩の装飾付き切石のテーブル"
        },
        {
          "id": "AdornedAshlarSandstoneChairItem",
          "en": "Adorned Ashlar Sandstone Chair",
          "fr": "Chaise en grès taillé ornée",
          "es": "Silla adornada (sillar de arenisca)",
          "de": "Geschmückter Sandsteinquaderstuhl",
          "pt": "Cadeira de Arenito Polido Adornado",
          "it": "Sedia in Arenaria Bugnata Adornata",
          "tr": "Süslenmiş Kesme Kumtaşı Sandalye",
          "pl": "Zdobione krzesło z ciosanego piaskowca",
          "ru": "Украшенный стул из резного песчаника",
          "uk": "Прикрашений стілець із різьбленого пісковика",
          "ko": "장식된 각진 사암 의자",
          "zh": "装饰过的方琢砂岩椅",
          "ja": "砂岩の装飾付き切石の椅子"
        },
        {
          "id": "AdornedAshlarSandstoneBenchItem",
          "en": "Adorned Ashlar Sandstone Bench",
          "fr": "Banc en grès taillé orné",
          "es": "Banco adornado (sillar de arenisca)",
          "de": "Geschmückter Sandsteinquaderbank",
          "pt": "Banco de Arenito Polido Adornado",
          "it": "Panca in Arenaria Bugnata Adornata",
          "tr": "Süslenmiş Kesme Kumtaşı Tezgah",
          "pl": "Zdobiona ławka z ciosanego piaskowca",
          "ru": "Украшенная лавка из резного песчаника",
          "uk": "Прикрашена лавка із різьбленого пісковика",
          "ko": "장식된 각진 사암 벤치",
          "zh": "装饰过的方琢砂岩长凳",
          "ja": "砂岩の装飾付き切石のベンチ"
        },
        {
          "id": "AdornedAshlarLimestoneTableItem",
          "en": "Adorned Ashlar Limestone Table",
          "fr": "Table en calcaire taillé ornée",
          "es": "Mesa adornada (sillar de piedra caliza)",
          "de": "Geschmückter Kalksteinquadertisch",
          "pt": "Mesa de Calcário Polido Adornado",
          "it": "Tavolo in Calcare Bugnato Adornato",
          "tr": "Süslenmiş Kesme Kireç Taşı Masası",
          "pl": "Zdobiony stół z ciosanego wapienia",
          "ru": "Украшенный стол из резного известняка",
          "uk": "Прикрашений стіл із різьбленого вапняку",
          "ko": "장식된 각진 석회암 탁자",
          "zh": "装饰过的方琢石灰石桌",
          "ja": "石灰岩の装飾付き切石のベンチ"
        },
        {
          "id": "AdornedAshlarLimestoneChairItem",
          "en": "Adorned Ashlar Limestone Chair",
          "fr": "Chaise en calcaire taillé ornée",
          "es": "Silla adornada (sillar de piedra caliza)",
          "de": "Geschmückter Kalksteinquaderstuhl",
          "pt": "Cadeira de Calcário Polido Adornado",
          "it": "Sedia in Calcare Bugnato Adornata",
          "tr": "Süslenmiş Kesme Kireç Taşı Sandalyesi",
          "pl": "Zdobione krzesło z ciosanego wapienia",
          "ru": "Украшенный стул из резного известняка",
          "uk": "Прикрашений стілець із різьбленого вапняку",
          "ko": "장식된 각진 석회암 의자",
          "zh": "装饰过的方琢石灰石的椅子",
          "ja": "石灰岩の装飾付き切石の椅子"
        },
        {
          "id": "AdornedAshlarLimestoneBenchItem",
          "en": "Adorned Ashlar Limestone Bench",
          "fr": "Banc en calcaire taillé ornée",
          "es": "Banco adornado (sillar de piedra caliza)",
          "de": "Geschmückter Kalksteinquaderbank",
          "pt": "Banco de Calcário Polido Adornado",
          "it": "Panca in Calcare Bugnato Adornata",
          "tr": "Süslenmiş Kesme Kireç Taşı Tezgahı",
          "pl": "Zdobiona ławka z ciosanego wapienia",
          "ru": "Украшенная лавка из резного известняка",
          "uk": "Прикрашена лавка із різьбленого вапняку",
          "ko": "장식된 각진 석회암 벤치",
          "zh": "装饰过的方琢石灰石长凳",
          "ja": "石灰岩の装飾付き切石のベンチ"
        },
        {
          "id": "AdornedAshlarGraniteTableItem",
          "en": "Adorned Ashlar Granite Table",
          "fr": "Table en granite taillé ornée",
          "es": "Mesa adornada (sillar de granito)",
          "de": "Geschmückter Granitquadertisch",
          "pt": "Mesa de Granito Polido Adornado",
          "it": "Tavolo in Granito Bugnato Adornato",
          "tr": "Süslenmiş Kesme Granit Masa",
          "pl": "Zdobiony stół z ciosanego granitu",
          "ru": "Украшенный стол из резного гранита",
          "uk": "Прикрашений стіл із різьбленого граніту",
          "ko": "장식된 각진 화강암 탁자",
          "zh": "装饰过的方琢花岗岩桌",
          "ja": "花崗岩の装飾付き切石のベンチ"
        },
        {
          "id": "AdornedAshlarGraniteChairItem",
          "en": "Adorned Ashlar Granite Chair",
          "fr": "Chaise en granite taillé ornée",
          "es": "Silla adornada (sillar de granito)",
          "de": "Geschmückter Granitquaderstuhl",
          "pt": "Cadeira de Granito Polido Adornado",
          "it": "Sedia in Granito Bugnato Adornata",
          "tr": "Süslenmiş Kesme Granit Sandalye",
          "pl": "Zdobione krzesło z ciosanego granitu",
          "ru": "Украшенный стул из резного гранита",
          "uk": "Прикрашений стілець із різьбленого граніту",
          "ko": "장식된 각진 화강암 의자",
          "zh": "装饰过的方琢花岗岩椅子",
          "ja": "花崗岩の装飾付き切石の椅子"
        },
        {
          "id": "AdornedAshlarGraniteBenchItem",
          "en": "Adorned Ashlar Granite Bench",
          "fr": "Banc en granite taillé orné",
          "es": "Banco adornado (sillar de granito)",
          "de": "Geschmückte Granitquaderbank",
          "pt": "Banco de Granito Polido Adornado",
          "it": "Panca in Granito Bugnato Adornata",
          "tr": "Süslenmiş Kesme Granit Tezgah",
          "pl": "Zdobiona ławka z ciosanego granitu",
          "ru": "Украшенная лавка из резного гранита",
          "uk": "Прикрашена лавка із різьбленого граніту",
          "ko": "장식된 각진 화강암 벤치",
          "zh": "装饰过的方琢花岗岩长凳",
          "ja": "花崗岩の装飾付き切石のベンチ"
        },
        {
          "id": "AdornedAshlarGneissTableItem",
          "en": "Adorned Ashlar Gneiss Table",
          "fr": "Table en gneiss taillé ornée",
          "es": "Mesa adornada (sillar de gneis)",
          "de": "Geschmückter Gneisquadertisch",
          "pt": "Mesa de Gneisse Polido Adornado",
          "it": "Tavolo in Gneiss Bugnato Adornato",
          "tr": "Süslenmiş Kesme Gnays Masa",
          "pl": "Zdobiony stół z ciosanego gnejsu",
          "ru": "Украшенный стол из резного гнейса",
          "uk": "Прикрашений стіл із різьбленого гнейсу",
          "ko": "장식된 각진 편마암 탁자",
          "zh": "装饰过的方琢片麻岩桌",
          "ja": "片麻岩の装飾付き切石のベンチ"
        },
        {
          "id": "AdornedAshlarGneissChairItem",
          "en": "Adorned Ashlar Gneiss Chair",
          "fr": "Chaise en gneiss taillé ornée",
          "es": "Silla adornada (sillar de granito)",
          "de": "Geschmückter Gneisquaderstuhl",
          "pt": "Cadeira de Gneisse Polido Adornado",
          "it": "Sedia in Gneiss Bugnato Adornata",
          "tr": "Süslenmiş Kesme Gnays Sandalye",
          "pl": "Zdobione krzesło z ciosanego gnejsu",
          "ru": "Украшенный стул из резного гнейса",
          "uk": "Прикрашений стілець із різьбленого гнейсу",
          "ko": "장식된 각진 편마암 의자",
          "zh": "装饰过的方琢片麻岩椅子",
          "ja": "片麻岩の装飾付き切石の椅子"
        },
        {
          "id": "AdornedAshlarGneissBenchItem",
          "en": "Adorned Ashlar Gneiss Bench",
          "fr": "Banc en gneiss taillé orné",
          "es": "Banco adornado (sillar de granito)",
          "de": "Geschmückte Gneisquaderbank",
          "pt": "Banco de Gneisse Polido Adornado",
          "it": "Panca in Gneiss Bugnato Adornata",
          "tr": "Süslenmiş Kesme Gnays Tezgah",
          "pl": "Zdobiona ławka z ciosanego gnejsu",
          "ru": "Украшенная лавка из резного гнейса",
          "uk": "Прикрашена лавка із різьбленого гнейсу",
          "ko": "장식된 각진 편마암 벤치",
          "zh": "装饰过的方琢片麻岩长凳",
          "ja": "片麻岩の装飾付き切石のベンチ"
        },
        {
          "id": "AdornedAshlarBasaltTableItem",
          "en": "Adorned Ashlar Basalt Table",
          "fr": "Table en basalte taillé ornée",
          "es": "Mesa adornada (sillar de basalto)",
          "de": "Geschmückter Basaltquadertisch",
          "pt": "Mesa de Basalto Polido Adornado",
          "it": "Tavolo in Basalto Bugnato Adornato",
          "tr": "Süslenmiş Kesme Bazalt Masa",
          "pl": "Zdobiony stół z ciosanego bazaltu",
          "ru": "Украшенный стол из резного базальта",
          "uk": "Прикрашений стіл із різьбленого базальту",
          "ko": "장식된 각진 현무암 탁자",
          "zh": "装饰过的方琢玄武岩桌",
          "ja": "玄武岩の装飾付き切石のベンチ"
        },
        {
          "id": "AdornedAshlarBasaltChairItem",
          "en": "Adorned Ashlar Basalt Chair",
          "fr": "Chaise en basalte taillé ornée",
          "es": "Silla adornada (sillar de basalto)",
          "de": "Geschmückter Basaltquaderstuhl",
          "pt": "Cadeira de Basalto Polido Adornado",
          "it": "Sedia in Basalto Bugnato Adornata",
          "tr": "Süslenmiş Kesme Bazalt Sandalye",
          "pl": "Zdobione krzesło z ciosanego bazaltu",
          "ru": "Украшенный стул из резного базальта",
          "uk": "Прикрашений стілець із різьбленого базальту",
          "ko": "장식된 각진 현무암 의자",
          "zh": "装饰过的方琢玄武岩的椅子",
          "ja": "玄武岩の装飾付き切石の椅子"
        },
        {
          "id": "AdornedAshlarBasaltBenchItem",
          "en": "Adorned Ashlar Basalt Bench",
          "fr": "Banc en basalte taillé orné",
          "es": "Banco adornado (sillar de basalto)",
          "de": "Geschmückte Basaltquaderbank",
          "pt": "Banco de Basalto Polido Adornado",
          "it": "Panca in Basalto Bugnato Adornata",
          "tr": "Süslenmiş Kesme Bazalt Tezgah",
          "pl": "Zdobiona ławka z ciosanego bazaltu",
          "ru": "Украшенная лавка из резного базальта",
          "uk": "Прикрашена лавка із різьбленого базальту",
          "ko": "장식된 각진 현무암 벤치",
          "zh": "装饰过的方琢玄武岩长凳",
          "ja": "玄武岩の装飾付き切石のベンチ"
        },
        {
          "id": "ModernRockDrillItem",
          "en": "Modern Rock Drill",
          "fr": "Foreuse de roche moderne",
          "es": "Perforadora moderna",
          "de": "Moderner Felsbohrer",
          "pt": "Perfuradora de Rocha Moderna",
          "it": "Trapano da Roccia Moderno",
          "tr": "Modern Kaya Matkabı",
          "pl": "Nowoczesne wiertło skalne",
          "ru": "Современный геологический бур",
          "uk": "Сучасний бур",
          "ko": "현대식 착암기",
          "zh": "现代凿岩机",
          "ja": "近代的な削岩ドリル"
        },
        {
          "id": "IronRockDrillItem",
          "en": "Iron Rock Drill",
          "fr": "Foreuse de roche en fer",
          "es": "Perforadora de hierro para rocas",
          "de": "Eisenfelsbohrer",
          "pt": "Perfuradora de Rocha de Ferro",
          "it": "Trapano da Roccia in Ferro",
          "tr": "Demir Kaya Matkabı",
          "pl": "Żelazne wiertło skalne",
          "ru": "Железный геологический бур",
          "uk": "Залізний геологічний бур",
          "ko": "철제 착암기",
          "zh": "铁凿岩机",
          "ja": "鉄の削岩ドリル"
        },
        {
          "id": "RawFood",
          "en": "Raw Food",
          "fr": "Nourriture crue",
          "es": "Comida cruda",
          "de": "Rohe Nahrung",
          "pt": "Comida Crua",
          "it": "Cibo crudo",
          "tr": "Çiğ yemek",
          "pl": "Surowe pożywienie",
          "ru": "Сырая еда",
          "uk": "Сира їжа",
          "ko": "날 것",
          "zh": "生食",
          "ja": "生の食料"
        },
        {
          "id": "Grain",
          "en": "Grain",
          "fr": "Céréale",
          "es": "Grano",
          "de": "Getreide",
          "pt": "Grão",
          "it": "Grano",
          "tr": "Tahıl",
          "pl": "Ziarno",
          "ru": "Зерно",
          "uk": "Зерно",
          "ko": "곡물",
          "zh": "粮食",
          "ja": "穀物"
        },
        {
          "id": "Vegetable",
          "en": "Vegetable",
          "fr": "Légumes",
          "es": "Vegetales",
          "de": "Gemüse",
          "pt": "Vegetal",
          "it": "Verdura",
          "tr": "Sebze",
          "pl": "Warzywo",
          "ru": "Растительность",
          "uk": "Овочі",
          "ko": "야채",
          "zh": "蔬菜",
          "ja": "野菜"
        },
        {
          "id": "BullrushSeedItem",
          "en": "Bullrush Seed",
          "fr": "Graine de jonc",
          "es": "Semilla de Junco",
          "de": "Samen (Binsen)",
          "pt": "Semente de Junco",
          "it": "Seme di Giunco",
          "tr": "Hasır Otu Tohumu",
          "pl": "Nasiona Pałki Wodnej",
          "ru": "Семечко камыша",
          "uk": "Насіння очерету",
          "ko": "부들 씨앗",
          "zh": "芦苇种子",
          "ja": "ガマの種"
        },
        {
          "id": "AmanitaMushroomSporesItem",
          "en": "Amanita Mushroom Spores",
          "fr": "Spores d\u0027amanite tue-mouches",
          "es": "Esporas de Amanita Muscaria",
          "de": "Sporen (Fliegenpilz)",
          "pt": "Esporos de Cogumelo Amanita",
          "it": "Spore di Ovolo Malefico",
          "tr": "Amanita Mantarı Sporları",
          "pl": "Zarodniki muchomora czerwonego",
          "ru": "Споры мухоморов",
          "uk": "Спори мухомора",
          "ko": "광대버섯 포자",
          "zh": "鹅膏菌孢子",
          "ja": "ベニテングダケの胞子"
        },
        {
          "id": "Fish",
          "en": "Fish",
          "fr": "Poisson",
          "es": "Pez",
          "de": "Fisch",
          "pt": "Peixe",
          "it": "Pesce",
          "tr": "Balık",
          "pl": "Ryba",
          "ru": "Рыба",
          "uk": "Риба",
          "ko": "어류",
          "zh": "鱼",
          "ja": "魚"
        },
        {
          "id": "SteelSawBladeItem",
          "en": "Steel Saw Blade",
          "fr": "Lame de scie en acier",
          "es": "Sierra circular de acero",
          "de": "Stahlsägeblatt",
          "pt": "Lâmina de Serra de Aço",
          "it": "Lama da Sega in Acciaio",
          "tr": "Çelik Testere Bıçağı",
          "pl": "Stalowe Ostrze Piły",
          "ru": "Стальной пильный диск",
          "uk": "Сталевий пиляльний диск",
          "ko": "강철 톱날",
          "zh": "钢锯片",
          "ja": "鋼のノコ刃"
        },
        {
          "id": "SteelGearboxItem",
          "en": "Steel Gearbox",
          "fr": "Boîte de vitesses en acier",
          "es": "Caja de engranajes de acero",
          "de": "Stahlgetriebe",
          "pt": "Caixa de Transmissão de Aço",
          "it": "Cambio in Acciaio",
          "tr": "Çelik Dişli Kutusu",
          "pl": "Stalowa Skrzynia Biegów",
          "ru": "Стальная коробка передач",
          "uk": "Сталева коробка передач",
          "ko": "강철 변속장치",
          "zh": "钢齿轮箱",
          "ja": "鋼のギアボックス"
        },
        {
          "id": "SoftwoodBoardItem",
          "en": "Softwood Board",
          "fr": "Planche en bois tendre",
          "es": "Tablón (madera blanda)",
          "de": "Holzbrett aus Weichholz",
          "pt": "Tábua de Madeira Macia",
          "it": "Tavola di Conifere",
          "tr": "Yumuşak Tahta",
          "pl": "Płyta z drewna iglastego",
          "ru": "Доска из хвойных пород",
          "uk": "Дошка із хвойних дерев",
          "ko": "연목 판자",
          "zh": "软木板",
          "ja": "軟材板"
        },
        {
          "id": "RecurveBowItem",
          "en": "Recurve Bow",
          "fr": "Arc recourbé",
          "es": "Arco recurvo",
          "de": "Recurvebogen",
          "pt": "Arco Recurvo",
          "it": "Arco Ricurvo",
          "tr": "Çekmeli Yay",
          "pl": "Łuk Refleksyjny",
          "ru": "Изогнутый лук",
          "uk": "Вигнутий лук",
          "ko": "곡궁",
          "zh": "反曲弓",
          "ja": "リカーブボウ"
        },
        {
          "id": "Tool",
          "en": "Tool",
          "fr": "Outil",
          "es": "Herramienta",
          "de": "Werkzeug",
          "pt": "Ferramenta",
          "it": "Strumento",
          "tr": "Araç",
          "pl": "Narzędzie",
          "ru": "Инструмент",
          "uk": "Інструмент",
          "ko": "도구",
          "zh": "工具",
          "ja": "ツール"
        },
        {
          "id": "IronSawBladeItem",
          "en": "Iron Saw Blade",
          "fr": "Lame de scie en fer",
          "es": "Sierra circular de hierro",
          "de": "Eisensägeblatt",
          "pt": "Lâmina de Serra de Ferro",
          "it": "Lama da Sega in Ferro",
          "tr": "Demir Testere Bıçağı",
          "pl": "Żelazne ostrze piły",
          "ru": "Железный пильный диск",
          "uk": "Залізний пиляльний диск",
          "ko": "철제 톱날",
          "zh": "铁锯片",
          "ja": "鉄のノコ刃"
        },
        {
          "id": "HardwoodBoardItem",
          "en": "Hardwood Board",
          "fr": "Planche en bois dur",
          "es": "Tablón de madera noble",
          "de": "Holzbrett aus Hartholz",
          "pt": "Tábua de Madeira Dura",
          "it": "Bacheca in Legno Massiccio",
          "tr": "Sert Tahta",
          "pl": "Deska z Twardego Drewna",
          "ru": "Доска из лиственных пород",
          "uk": "Дошка із твердої деревини",
          "ko": "견목 판자",
          "zh": "硬木板",
          "ja": "硬材板"
        },
        {
          "id": "GoldWiringItem",
          "en": "Gold Wiring",
          "fr": "Fil d\u0027or",
          "es": "Cables de oro",
          "de": "Goldverdrahtung",
          "pt": "Fiação de Ouro",
          "it": "Cablaggio Dorato",
          "tr": "Altın Kablolama",
          "pl": "Złote okablowanie",
          "ru": "Золотой провод",
          "uk": "Золотий дріт",
          "ko": "금전선",
          "zh": "金接线",
          "ja": "金のワイヤー"
        },
        {
          "id": "AdvancedCircuitItem",
          "en": "Advanced Circuit",
          "fr": "Circuit avancé",
          "es": "Circuito avanzado",
          "de": "Fortschrittlicher Schaltkreis",
          "pt": "Circuito Avançado",
          "it": "Circuito Avanzato",
          "tr": "Gelişmiş Devre",
          "pl": "Zaawansowany Obwód",
          "ru": "Продвинутая электросхема",
          "uk": "Покращена електросхема",
          "ko": "고급 전자회로",
          "zh": "先进电路",
          "ja": "高度な回路"
        },
        {
          "id": "Salad",
          "en": "Salad",
          "fr": "Salade",
          "es": "Ensalada",
          "de": "Salat",
          "pt": "Salada",
          "it": "Insalata",
          "tr": "Salata",
          "pl": "Sałatka",
          "ru": "Салат",
          "uk": "Салат",
          "ko": "샐러드",
          "zh": "沙拉",
          "ja": "サラダ"
        },
        {
          "id": "ToppedPorridgeItem",
          "en": "Topped Porridge",
          "fr": "Porridge garni",
          "es": "Gachas con fruta",
          "de": "Verfeinertes Porridge",
          "pt": "Mingau coberto de frutas",
          "it": "Porridge Decorato",
          "tr": "Kaplı Yulaf Lapası",
          "pl": "Owsianka z owocami",
          "ru": "Каша с добавками",
          "uk": "Каша з добавками",
          "ko": "뭔가 추가된 죽",
          "zh": "稀饭",
          "ja": "具入りのお粥"
        },
        {
          "id": "Fruit",
          "en": "Fruit",
          "fr": "Fruit",
          "es": "Fruta",
          "de": "Frucht",
          "pt": "Fruta",
          "it": "Frutta",
          "tr": "Meyve",
          "pl": "Owoc",
          "ru": "Фрукт",
          "uk": "Фрукт",
          "ko": "과일",
          "zh": "水果",
          "ja": "果実"
        },
        {
          "id": "RootCampfireStewItem",
          "en": "Root Campfire Stew",
          "fr": "Ragoût de racines cuit au feu de camp",
          "es": "Estofado braseado con raíces",
          "de": "Lagerfeuer Wurzeleintopf",
          "pt": "Ensopado de raiz feito na fogueira",
          "it": "Stufato di Radici da Falò",
          "tr": "Kamp Ateşinde Yahni",
          "pl": "Korzenny gulasz z ogniska",
          "ru": "Рагу из корнеплодов на костре",
          "uk": "Рагу приготоване багатті",
          "ko": "구근 모닥불 스튜",
          "zh": "根篝火炖汤",
          "ja": "野外料理の根菜シチュー"
        },
        {
          "id": "RootCampfireSaladItem",
          "en": "Root Campfire Salad",
          "fr": "Salade de racines cuite au feu de camp",
          "es": "Ensalada braseada con raíces",
          "de": "Lagerfeuer Wurzelsalat",
          "pt": "Salada de raiz feita na fogueira",
          "it": "Insalata di Radici da Falò",
          "tr": "Kamp Ateşinde Salata",
          "pl": "Korzenna sałatka z grilla",
          "ru": "Салат из корнеплодов на костре",
          "uk": "Салат приготований на багатті",
          "ko": "구근 모닥불 샐러드",
          "zh": "根篝火沙拉",
          "ja": "野外料理の根菜サラダ"
        },
        {
          "id": "PastryDoughItem",
          "en": "Pastry Dough",
          "fr": "Pâte à tarte",
          "es": "Masa de pastelería",
          "de": "Teig",
          "pt": "Massa folhada",
          "it": "Pasta Sfoglia",
          "tr": "Milföy Böreği",
          "pl": "Kruche ciasto",
          "ru": "Кондитерские изделия",
          "uk": "Кондитерське тісто",
          "ko": "페이스트리 반죽",
          "zh": "糕点面团",
          "ja": "ペストリー生地"
        },
        {
          "id": "MeatyStewItem",
          "en": "Meaty Stew",
          "fr": "Ragoût de viande",
          "es": "Estofado de carne",
          "de": "Lagerfeuer Fleischeintopf",
          "pt": "Ensopado de carne",
          "it": "Stufato di Carne",
          "tr": "Etli Yahni",
          "pl": "Mięsny jeż",
          "ru": "Мясное рагу",
          "uk": "М\u0027ясна рагу",
          "ko": "고기 스튜",
          "zh": "肉炖",
          "ja": "肉のシチュー"
        },
        {
          "id": "LeavenedDoughItem",
          "en": "Leavened Dough",
          "fr": "Pâte au levain",
          "es": "Masa con levadura",
          "de": "Hefeteig",
          "pt": "Massa fermentada",
          "it": "Impasto Lievitato",
          "tr": "Mayalı Hamur İşi",
          "pl": "Ciasto drożdżowe",
          "ru": "Дрожжевое тесто",
          "uk": "Дріжджове тісто",
          "ko": "발효된 반죽",
          "zh": "发酵面团",
          "ja": "発酵生地"
        },
        {
          "id": "JungleCampfireStewItem",
          "en": "Jungle Campfire Stew",
          "fr": "Ragoût de la jungle cuit au feu de camp",
          "es": "Estofado braseado con madera de jungla",
          "de": "Lagerfeuer Dschungeleintopf",
          "pt": "Ensopado da selva feito na fogueira",
          "it": "Stufato della Foresta al Falò",
          "tr": "Jungle Campfire Stew",
          "pl": "Tropikalny gulasz z ogniska",
          "ru": "Джунглевое рагу на костре",
          "uk": "Рагу",
          "ko": "정글 모닥불 스튜",
          "zh": "丛林篝火炖汤",
          "ja": "野外調理のジャングルシチュー"
        },
        {
          "id": "JungleCampfireSaladItem",
          "en": "Jungle Campfire Salad",
          "fr": "Salade de la jungle cuite au feu de camp",
          "es": "Ensalada braseada con madera de jungla",
          "de": "Lagerfeuer Dschungelsalat",
          "pt": "Salada da selva feita na fogueira",
          "it": "Insalata della Foresta al Falò",
          "tr": "Jungle Campfire Salad",
          "pl": "Tropikalna sałatka z grilla",
          "ru": "Джунглевый салат на костре",
          "uk": "Салат",
          "ko": "정글 모닥불 샐러드",
          "zh": "丛林篝火沙拉",
          "ja": "野外調理のジャングルサラダ"
        },
        {
          "id": "FruitTartItem",
          "en": "Fruit Tart",
          "fr": "Tarte aux fruits",
          "es": "Tarta de frutas",
          "de": "Obstkuchen",
          "pt": "Torta de frutas",
          "it": "Crostata di Frutta",
          "tr": "Meyve Turtası",
          "pl": "Tarta owocowa",
          "ru": "Фруктовый тарт",
          "uk": "Фруктовий тарт",
          "ko": "과일 타르트",
          "zh": "水果馅饼",
          "ja": "フルーツのタルト"
        },
        {
          "id": "FruitMuffinItem",
          "en": "Fruit Muffin",
          "fr": "Muffin aux fruits",
          "es": "Muffin de fruta",
          "de": "Fruchtmuffin",
          "pt": "Muffin de frutas",
          "it": "Muffin di Frutta",
          "tr": "Meyveli Çörek",
          "pl": "Babeczka owocowa",
          "ru": "Фруктовый кекс",
          "uk": "Фруктовий мафін",
          "ko": "과일 머핀",
          "zh": "水果松饼",
          "ja": "フルーツのマフィン"
        },
        {
          "id": "FriedVegetablesItem",
          "en": "Fried Vegetables",
          "fr": "Légumes frits",
          "es": "Vegetales fritos",
          "de": "Frittiertes Gemüse",
          "pt": "Vegetais Fritos",
          "it": "Verdure Fritte",
          "tr": "Kızarmış Sebze",
          "pl": "Smażone warzywa",
          "ru": "Жареные овощи",
          "uk": "Смажені овочі",
          "ko": "튀긴 야채",
          "zh": "炒蔬菜",
          "ja": "揚げ野菜"
        },
        {
          "id": "FriedVegetable",
          "en": "Fried Vegetable",
          "fr": "Légumes frits",
          "es": "Vegetal frito",
          "de": "Frittiertes Gemüse",
          "pt": "Vegetal Frito",
          "it": "Verdura Fritta",
          "tr": "Kızarmış Sebze",
          "pl": "Smażone Warzywa",
          "ru": "Жареный овощ",
          "uk": "Підсмажений овоч",
          "ko": "튀긴 야채",
          "zh": "炒蔬菜",
          "ja": "揚げた野菜"
        },
        {
          "id": "FriedTaroItem",
          "en": "Fried Taro",
          "fr": "Taro frit",
          "es": "Taro frito",
          "de": "Frittierte Taro",
          "pt": "Inhame frito",
          "it": "Taro Fritto",
          "tr": "Kızarmış Kulkas",
          "pl": "Smażona kolokazja",
          "ru": "Жареный таро",
          "uk": "Смажене Таро",
          "ko": "튀긴 토란",
          "zh": "炸芋头",
          "ja": "揚げたタロイモ"
        },
        {
          "id": "FriedHeartsOfPalmItem",
          "en": "Fried Hearts Of Palm",
          "fr": "Cœur de palmier frit",
          "es": "Palmitos fritos",
          "de": "Frittierte Palmherzen",
          "pt": "Palmitos fritos",
          "it": "Cuori Di Palma Fritti",
          "tr": "Kızarmış Palmiye Kalbi",
          "pl": "Smażone serca palmy",
          "ru": "Жареные сердцевины пальмы",
          "uk": "Смажені пальмові серцевини",
          "ko": "튀긴 야자심",
          "zh": "棕榈炒心",
          "ja": "揚げたパルミット"
        },
        {
          "id": "FriedFiddleheadsItem",
          "en": "Fried Fiddleheads",
          "fr": "Fougères frits",
          "es": "Brotes de helecho fritos",
          "de": "Frittierte Farnspitzen",
          "pt": "Brotos de samambaia fritos",
          "it": "Germogli di Felce Fritti",
          "tr": "Kızarmış Eğreltiotu Ucu",
          "pl": "Smażone liście młodej paproci",
          "ru": "Жареный папоротник",
          "uk": "Смажена папороть",
          "ko": "튀긴 고사리",
          "zh": "炸羊肠",
          "ja": "揚げたワラビ巻"
        },
        {
          "id": "FriedCamasItem",
          "en": "Fried Camas",
          "fr": "Camassias frits",
          "es": "Camasia frita",
          "de": "Frittierte Prärielilien",
          "pt": "Camassias fritas",
          "it": "Camassia Fritta",
          "tr": "Kızarmış Cama",
          "pl": "Smażona kamasja",
          "ru": "Жареная камассия",
          "uk": "Смажений Камас",
          "ko": "튀긴 카마스",
          "zh": "炸卡马斯",
          "ja": "揚げたカマシア"
        },
        {
          "id": "FieldCampfireStewItem",
          "en": "Field Campfire Stew",
          "fr": "Ragoût des prairies cuit au feu de camp",
          "es": "Ensalada braseada campestre",
          "de": "Lagerfeuer Feldeintopf",
          "pt": "Ensopado do campo feito na fogueira",
          "it": "Stufato di Campo al Falò",
          "tr": "Field Campfire Stew",
          "pl": "Chłopski gulasz z ogniska",
          "ru": "Полевое рагу на костре",
          "uk": "Польове рагу",
          "ko": "들판 모닥불 스튜",
          "zh": "野营篝火炖汤",
          "ja": "野外調理の大地のシチュー"
        },
        {
          "id": "Greens",
          "en": "Greens",
          "fr": "Feuilles",
          "es": "Hojas",
          "de": "Suppengrün",
          "pt": "Folhas",
          "it": "Verdure",
          "tr": "Yeşillik",
          "pl": "Zielenina",
          "ru": "Зелень",
          "uk": "Зелень",
          "ko": "녹색 야채",
          "zh": "青菜",
          "ja": "葉菜"
        },
        {
          "id": "FernCampfireSaladItem",
          "en": "Fern Campfire Salad",
          "fr": "Salade de fougères cuite au feu de camp",
          "es": "Ensalada braseada con helechos",
          "de": "Lagerfeuer Farnspitzensalat",
          "pt": "Salada de samambaia feita na fogueira",
          "it": "Insalata di Felce da Falò",
          "tr": "Fern Campfire Salad",
          "pl": "Paprotna sałatka z grilla",
          "ru": "Салат из папоротника на костре",
          "uk": "Салат із папороті",
          "ko": "고사리 모닥불 샐러드",
          "zh": "蕨篝火沙拉",
          "ja": "野外料理のワラビサラダ"
        },
        {
          "id": "Fungus",
          "en": "Fungus",
          "fr": "Champignon",
          "es": "Hongo",
          "de": "Pilz",
          "pt": "Fungo",
          "it": "Funghi",
          "tr": "Küf Mantarı",
          "pl": "Grzyb",
          "ru": "Гриб",
          "uk": "Гриб",
          "ko": "균류",
          "zh": "菌",
          "ja": "菌類"
        },
        {
          "id": "CharredMushroomsItem",
          "en": "Charred Mushrooms",
          "fr": "Champignons carbonisés",
          "es": "Champiñones carbonizados",
          "de": "Gegrillte Pilze",
          "pt": "Cogumelos tostados",
          "it": "Funghi Carbonizzati",
          "tr": "Güveçte Mantar",
          "pl": "Opiekane grzyby",
          "ru": "Грибы на углях",
          "uk": "Гриби на вугіллі",
          "ko": "그슬린 버섯",
          "zh": "烧焦的蘑菇",
          "ja": "焦げたマッシュルーム"
        },
        {
          "id": "CharredHeartOfPalmItem",
          "en": "Charred Heart Of Palm",
          "fr": "Cœur de palmier carbonisé",
          "es": "Palmito carbonizado",
          "de": "Gegrillte Palmherzen",
          "pt": "Palmito tostado",
          "it": "Cuore di Palma Carbonizzato",
          "tr": "Charred Heart Of Palm",
          "pl": "Opiekane serce palmy",
          "ru": "Сердцевина пальмы на углях",
          "uk": "Серцевина пальми",
          "ko": "그슬린 야자심",
          "zh": "烧焦的棕榈心",
          "ja": "焦げたパルミット"
        },
        {
          "id": "CharredFireweedShootsItem",
          "en": "Charred Fireweed Shoots",
          "fr": "Pousses d\u0027épilobe carbonisées",
          "es": "Brotes de epilobio carbonizados",
          "de": "Gegrillte Weidenröschen",
          "pt": "Brotos de fireweed tostados",
          "it": "Germogli di Camenerio Carbonizzati",
          "tr": "Pişmiş Yakı Otu Filizleri",
          "pl": "Opiekane Pędy Wierzbówki",
          "ru": "Иван-чай на углях",
          "uk": "Іван-чай на вуглях",
          "ko": "그슬린 분홍바늘꽃 순",
          "zh": "烧焦的杂草芽",
          "ja": "焦げたヤナギランの新芽"
        },
        {
          "id": "CharredCactusFruitItem",
          "en": "Charred Cactus Fruit",
          "fr": "Fruit de saguaro carbonisé",
          "es": "Fruto de cactus carbonizado",
          "de": "Gegrillte Kaktusfrucht",
          "pt": "Fruto de cacto tostado",
          "it": "Frutto di Cactus Carbonizzato",
          "tr": "Charred Cactus Fruit",
          "pl": "Opiekany Owoc Kaktusa",
          "ru": "Плод сагуаро на углях",
          "uk": "Опунція",
          "ko": "그슬린 백년초",
          "zh": "烧焦的仙人掌果",
          "ja": "焦げたサボテンの実"
        },
        {
          "id": "CharredBeansItem",
          "en": "Charred Beans",
          "fr": "Haricots carbonisés",
          "es": "Judías carbonizadas",
          "de": "Gegrillte Bohnen",
          "pt": "Feijões tostados",
          "it": "Fagioli Carbonizzati",
          "tr": "Charred Beans",
          "pl": "Opiekana Fasola",
          "ru": "Бобы на углях",
          "uk": "Квасоля",
          "ko": "그슬린 콩",
          "zh": "烧焦的豆",
          "ja": "焦げた豆"
        },
        {
          "id": "CampfireSaladItem",
          "en": "Campfire Salad",
          "fr": "Salade au feu de camp",
          "es": "Ensalada braseada",
          "de": "Lagerfeuersalat",
          "pt": "Salada Feita na Fogueira",
          "it": "Insalata da Campo",
          "tr": "Campfire Salad",
          "pl": "Sałatka z grilla",
          "ru": "Салат на костре",
          "uk": "Салат",
          "ko": "모닥불 샐러드",
          "zh": "篝火沙拉",
          "ja": "野外料理のサラダ"
        },
        {
          "id": "CampfireSalad",
          "en": "Campfire Salad",
          "fr": "Salade au feu de camp",
          "es": "Ensalada braseada",
          "de": "Lagerfeuersalat",
          "pt": "Salada Feita na Fogueira",
          "it": "Insalata da Campo",
          "tr": "Campfire Salad",
          "pl": "Sałatka z grilla",
          "ru": "Салат на костре",
          "uk": "Салат",
          "ko": "모닥불 샐러드",
          "zh": "篝火沙拉",
          "ja": "野外料理のサラダ"
        },
        {
          "id": "BoiledGrainsItem",
          "en": "Boiled Grains",
          "fr": "Grains bouillis",
          "es": "Granos hervidos",
          "de": "Einfaches Porridge",
          "pt": "Grãos fervidos",
          "it": "Grani Bolliti",
          "tr": "Haşlanmış Tahıl",
          "pl": "Ugotowane ziarna",
          "ru": "Варёные зерна",
          "uk": "Зварене зерно",
          "ko": "삶은 곡물",
          "zh": "水煮谷物",
          "ja": "茹でた穀物"
        },
        {
          "id": "BeetGreensItem",
          "en": "Beet Greens",
          "fr": "Feuilles de betteraves",
          "es": "Hojas de remolacha",
          "de": "Rote Bete Blätter",
          "pt": "Folhas de beterraba",
          "it": "Bietole",
          "tr": "Pancar Yaprağı",
          "pl": "Botwina",
          "ru": "Свекольная ботва",
          "uk": "Листя буряка",
          "ko": "사탕무 잎",
          "zh": "甜菜叶",
          "ja": "ビートの葉"
        },
        {
          "id": "BeetCampfireSaladItem",
          "en": "Beet Campfire Salad",
          "fr": "Salade de betteraves cuite au feu de camp",
          "es": "Ensalada de remolacha braseada",
          "de": "Lagefeuer Rote Bete Salat",
          "pt": "Salada de beterraba feita na fogueira",
          "it": "Insalata di Bietole sul Falò",
          "tr": "Beet Campfire Salad",
          "pl": "Sałatka z grillowanego buraka",
          "ru": "Свекольный салат на костре",
          "uk": "Буряковий салат",
          "ko": "사탕무 모닥불 샐러드",
          "zh": "甜菜篝火沙拉",
          "ja": "野外料理のビートサラダ"
        },
        {
          "id": "BakedVegetable",
          "en": "Baked Vegetable",
          "fr": "Légume au four",
          "es": "Vegetal horneado",
          "de": "Gebackenes Gemüse",
          "pt": "Vegetal Assado",
          "it": "Verdure Cotte",
          "tr": "Kavrulmuş Sebze",
          "pl": "Pieczone warzywo",
          "ru": "Запеченные овощи",
          "uk": "Запечений овоч",
          "ko": "구운 야채",
          "zh": "烤蔬菜",
          "ja": "焼いた野菜"
        },
        {
          "id": "BakedTomatoItem",
          "en": "Baked Tomato",
          "fr": "Tomate au four",
          "es": "Tomate horneado",
          "de": "Gebackene Tomaten",
          "pt": "Tomate assado",
          "it": "Pomodoro Cotto",
          "tr": "Kavrulmuş Domates",
          "pl": "Pieczony pomidor",
          "ru": "Запеченный помидор",
          "uk": "Печений томат",
          "ko": "구운 토마토",
          "zh": "烤番茄",
          "ja": "焼いたトマト"
        },
        {
          "id": "BakedTaroItem",
          "en": "Baked Taro",
          "fr": "Taro au four",
          "es": "Taro cocinado",
          "de": "Gebackene Taro",
          "pt": "Inhame assado",
          "it": "Taro Cotto",
          "tr": "Kavrulmuş Gölevez",
          "pl": "Pieczona kolokazja",
          "ru": "Запечённый корень таро",
          "uk": "Печений дашин",
          "ko": "구운 토란",
          "zh": "烤芋头",
          "ja": "焼いたタロイモ"
        },
        {
          "id": "BakedHeartOfPalmItem",
          "en": "Baked Heart Of Palm",
          "fr": "Cœur de palmier au four",
          "es": "Palmito horneado",
          "de": "Gebackene Palmherzen",
          "pt": "Palmito assado",
          "it": "Cuore Di Palma Cotto",
          "tr": "Kavrulmuş Palmiye Kalbi",
          "pl": "Pieczone serce palmy",
          "ru": "Запечённая сердцевина пальмы",
          "uk": "Запечена серцевина пальми",
          "ko": "구운 야자심",
          "zh": "掌心焗",
          "ja": "焼いたパルミット"
        },
        {
          "id": "BakedCornItem",
          "en": "Baked Corn",
          "fr": "Maïs au four",
          "es": "Maíz horneado",
          "de": "Gebackener Mais",
          "pt": "Milho assado",
          "it": "Mais Cotto",
          "tr": "Kavrulmuş Mısır",
          "pl": "Pieczona kukurydza",
          "ru": "Запечённая кукуруза",
          "uk": "Запечена кукурудза",
          "ko": "구운 옥수수",
          "zh": "烤玉米",
          "ja": "焼いたトウモロコシ"
        },
        {
          "id": "BakedBeetItem",
          "en": "Baked Beet",
          "fr": "Betterave au four",
          "es": "Remolacha horneada",
          "de": "Gebackene Rote Bete",
          "pt": "Beterraba assada",
          "it": "Bietola Cotta",
          "tr": "Kavrulmuş Pancar",
          "pl": "Pieczony burak",
          "ru": "Запечённая свекла",
          "uk": "Запечений буряк",
          "ko": "구운 사탕무",
          "zh": "烤甜菜",
          "ja": "焼いたビート"
        },
        {
          "id": "Rock",
          "en": "Rock",
          "fr": "Pierre",
          "es": "Roca",
          "de": "Stein",
          "pt": "Rocha",
          "it": "Roccia",
          "tr": "Kaya",
          "pl": "Skała",
          "ru": "Камень",
          "uk": "Камінь",
          "ko": "바위",
          "zh": "岩",
          "ja": "石材"
        },
        {
          "id": "SteelBarItem",
          "en": "Steel Bar",
          "fr": "Lingot d\u0027acier",
          "es": "Lingote de acero",
          "de": "Stahlbarren",
          "pt": "Barra de aço",
          "it": "Lingotto d\u0027Acciaio",
          "tr": "Çelik Bar",
          "pl": "Sztabka stali",
          "ru": "Стальной брусок",
          "uk": "Стальний брусок",
          "ko": "강철괴",
          "zh": "钢筋",
          "ja": "鋼のインゴット"
        },
        {
          "id": "SpruceLogItem",
          "en": "Spruce Log",
          "fr": "Bûche d\u0027épicéa",
          "es": "Tronco de pícea",
          "de": "Fichtenstamm",
          "pt": "Tora de Pinheiro",
          "it": "Tronco d\u0027Abete Rosso",
          "tr": "Alaçam Kütüğü",
          "pl": "Kłoda świerku",
          "ru": "Бревно Ели",
          "uk": "Ялинова колода",
          "ko": "가문비나무 원목",
          "zh": "云杉原木",
          "ja": "松の丸太"
        },
        {
          "id": "Softwood",
          "en": "Softwood",
          "fr": "Bois tendre",
          "es": "Madera blanda",
          "de": "Weichholz",
          "pt": "Madeira Macia",
          "it": "Legno Tenero",
          "tr": "Yumuşak odun",
          "pl": "Drewno iglaste",
          "ru": "Хвойные породы",
          "uk": "Хвойні дерева",
          "ko": "연목",
          "zh": "软木",
          "ja": "軟材"
        },
        {
          "id": "SoftwoodLumberItem",
          "en": "Softwood Lumber",
          "fr": "Bois d\u0027œuvre tendre",
          "es": "Tronco de madera blanda",
          "de": "Bauholz aus Weichholz",
          "pt": "Madeira macia serrada",
          "it": "Legname Tenero",
          "tr": "Yumuşak Odundan Kereste",
          "pl": "Tarcica z drewna iglastego",
          "ru": "Пиломатериал из хвойных пород",
          "uk": "Двері з хвойних порід деревини",
          "ko": "가공된 연목재",
          "zh": "软木木材",
          "ja": "針葉樹の板材"
        },
        {
          "id": "SoftwoodHewnLogItem",
          "en": "Softwood Hewn Log",
          "fr": "Rondin de bois tendre taillé",
          "es": "Tronco tallado (madera blanda)",
          "de": "Massivholz aus Weichholz",
          "pt": "Madeira Macia Cortada",
          "it": "Tronco di Legno Tenero Scolpito",
          "tr": "Yumuşak Yontulmuş Kütük",
          "pl": "Ociosana kłoda z drewna iglastego",
          "ru": "Тёсаное бревно хвойных пород",
          "uk": "Тесана колода з листяних дерев",
          "ko": "다듬은 연목 통나무",
          "zh": "软木原木",
          "ja": "軟材の丸太材"
        },
        {
          "id": "SlagItem",
          "en": "Slag",
          "fr": "Scorie",
          "es": "Escoria",
          "de": "Schlacke",
          "pt": "Escória",
          "it": "Scoria",
          "tr": "Cüruf",
          "pl": "Żużel",
          "ru": "Шлак",
          "uk": "Окалина",
          "ko": "광물 찌꺼기",
          "zh": "矿渣",
          "ja": "鉱滓"
        },
        {
          "id": "SaguaroRibItem",
          "en": "Saguaro Rib",
          "fr": "Bûche de saguaro",
          "es": "Nervadura de saguaro",
          "de": "Saguarostamm",
          "pt": "Costela de Saguaro",
          "it": "Nervatura di Saguaro",
          "tr": "Saguarodan Çubuk",
          "pl": "Żebro saguaro",
          "ru": "Обрубок карнегии",
          "uk": "Ребро сагуаро",
          "ko": "변경주선인장 능",
          "zh": "仙人掌柱",
          "ja": "サグアロサボテンの茎"
        },
        {
          "id": "RedwoodLogItem",
          "en": "Redwood Log",
          "fr": "Bûche de séquoia",
          "es": "Tronco de secuoya",
          "de": "Rottannenholzstamm",
          "pt": "Tora de Sequoia-vermelha",
          "it": "Tronco di Sequoia",
          "tr": "Kızılçam Kütüğü",
          "pl": "Kłoda sekwoi",
          "ru": "Бревно Секвойи",
          "uk": "Колода секвої",
          "ko": "붉은삼나무 원목",
          "zh": "红木原木",
          "ja": "レッドウッドの丸太"
        },
        {
          "id": "PalmLogItem",
          "en": "Palm Log",
          "fr": "Bûche de palmier",
          "es": "Tronco de palmera",
          "de": "Palmenholzstamm",
          "pt": "Tora de Palmeira",
          "it": "Tronco di Palma",
          "tr": "Palmiye Kütüğü",
          "pl": "Kłoda palmy",
          "ru": "Бревно Пальмы",
          "uk": "Пальмова колода",
          "ko": "야자나무 원목",
          "zh": "棕榈原木",
          "ja": "ヤシの丸太"
        },
        {
          "id": "OakLogItem",
          "en": "Oak Log",
          "fr": "Bûche de chêne",
          "es": "Tronco de roble",
          "de": "Eichenholzstamm",
          "pt": "Tora de Carvalho",
          "it": "Tronco di Quercia",
          "tr": "Meşe Kütüğü",
          "pl": "Kłoda dębu",
          "ru": "Бревно Дуба",
          "uk": "Дубова колода",
          "ko": "참나무 원목",
          "zh": "橡木原木",
          "ja": "樫の丸太"
        },
        {
          "id": "Hardwood",
          "en": "Hardwood",
          "fr": "Bois dur",
          "es": "Madera noble",
          "de": "Hartholz",
          "pt": "Madeira Dura",
          "it": "Legno Massiccio",
          "tr": "Sert Odun",
          "pl": "Drewno liściaste",
          "ru": "Лиственные породы",
          "uk": "Тверда деревина",
          "ko": "견목",
          "zh": "硬木",
          "ja": "硬材"
        },
        {
          "id": "MortaredShaleItem",
          "en": "Mortared Shale",
          "fr": "Schiste cimenté",
          "es": "Pizarra con mortero",
          "de": "Schieferziegel",
          "pt": "Xisto Argamassado",
          "it": "Scisto Pestato",
          "tr": "Harçlı Kil",
          "pl": "Spojony zaprawą łupek",
          "ru": "Строительный сланец",
          "uk": "Будівельний Сланець",
          "ko": "모르타르 마감 이판암",
          "zh": "砂浆页岩",
          "ja": "頁岩のモルタル"
        },
        {
          "id": "MortaredGneissItem",
          "en": "Mortared Gneiss",
          "fr": "Gneiss cimenté",
          "es": "Gneis con mortero",
          "de": "Gneisziegel",
          "pt": "Gnaisse Argamassado",
          "it": "Gneiss Pestato",
          "tr": "Harçlı Gnays",
          "pl": "Spojony zaprawą gnejs",
          "ru": "Строительный гнейс",
          "uk": "Будівельний Гнейс",
          "ko": "모르타르 마감 편마암",
          "zh": "砂浆片麻岩",
          "ja": "片麻岩のモルタル"
        },
        {
          "id": "MortaredBasaltItem",
          "en": "Mortared Basalt",
          "fr": "Basalte cimenté",
          "es": "Basalto con mortero",
          "de": "Basaltziegel",
          "pt": "Basalto Argamassado",
          "it": "Basalto Pestato",
          "tr": "Harçlı Bazalt",
          "pl": "Spojony zaprawą bazalt",
          "ru": "Строительный базальт",
          "uk": "Будівельний Базальт",
          "ko": "모르타르 마감 현무암",
          "zh": "砂浆玄武岩",
          "ja": "玄武岩のモルタル"
        },
        {
          "id": "JoshuaLogItem",
          "en": "Joshua Log",
          "fr": "Bûche de josué",
          "es": "Tronco de árbol de Josué",
          "de": "Josuaholzstamm",
          "pt": "Tora de Joshua",
          "it": "Tronco di Albero di Giosuè",
          "tr": "Joshua Kütüğü",
          "pl": "Kłoda jukki",
          "ru": "Бревно Юкки коротколистной",
          "uk": "Колода юки коротколисної",
          "ko": "여호수아나무 원목",
          "zh": "约书亚原木",
          "ja": "ジョシュア・ツリーの丸太"
        },
        {
          "id": "Ore",
          "en": "Ore",
          "fr": "Minerai",
          "es": "Mineral",
          "de": "Erz",
          "pt": "Minério",
          "it": "Minerale",
          "tr": "Cevher",
          "pl": "Ruda",
          "ru": "Руда",
          "uk": "Руда",
          "ko": "광석",
          "zh": "矿石",
          "ja": "鉱石"
        },
        {
          "id": "IronConcentrateItem",
          "en": "Iron Concentrate",
          "fr": "Concentré de fer",
          "es": "Concentrado de hierro",
          "de": "Eisenkonzentrat",
          "pt": "Concentrado de ferro",
          "it": "Concentrato di Ferro",
          "tr": "Demir Konsantresi",
          "pl": "Koncentrat żelaza",
          "ru": "Концентрат железа",
          "uk": "Концентрат Заліза",
          "ko": "정제된 철광석",
          "zh": "筛选铁矿石",
          "ja": "鉄の精鉱"
        },
        {
          "id": "HardwoodLumberItem",
          "en": "Hardwood Lumber",
          "fr": "Bois d\u0027œuvre dur",
          "es": "Tronco de madera noble",
          "de": "Bauholz aus Hartholz",
          "pt": "Madeira dura serrada",
          "it": "Legname Massiccio",
          "tr": "Sert Odundan Kereste",
          "pl": "Tarcica z drewna liściastego",
          "ru": "Пиломатериал из лиственных пород",
          "uk": "Лісоматеріали з листяних дерев",
          "ko": "가공된 견목재",
          "zh": "硬木木材",
          "ja": "針葉樹の板材"
        },
        {
          "id": "HardwoodLumber",
          "en": "Hardwood Lumber",
          "fr": "Bois d\u0027œuvre dur",
          "es": "Tronco de madera noble",
          "de": "Bauholz aus Hartholz",
          "pt": "Madeira dura serrada",
          "it": "Legname Massiccio",
          "tr": "Sert Odundan Kereste",
          "pl": "Tarcica z drewna liściastego",
          "ru": "Пиломатериал из лиственных пород",
          "uk": "Лісоматеріали з листяних дерев",
          "ko": "가공된 견목재",
          "zh": "硬木木材",
          "ja": "針葉樹の板材"
        },
        {
          "id": "HardwoodHewnLogItem",
          "en": "Hardwood Hewn Log",
          "fr": "Rondin de bois dur taillé",
          "es": "Tronco tallado de madera noble",
          "de": "Massivholz aus Hartholz",
          "pt": "Madeira Dura Cortada",
          "it": "Tronco Massiccio Scolpito",
          "tr": "Sert Yontulmuş Kütük",
          "pl": "Ociosana kłoda z drewna liściastego",
          "ru": "Тёсаное бревно лиственных пород",
          "uk": "Тесана колода з листяних дерев",
          "ko": "다듬은 견목 통나무",
          "zh": "硬木原木",
          "ja": "硬材の丸太材"
        },
        {
          "id": "GoldConcentrateItem",
          "en": "Gold Concentrate",
          "fr": "Concentré d\u0027or",
          "es": "Concentrado de oro",
          "de": "Goldkonzentrat",
          "pt": "Concentrado de ouro",
          "it": "Concentrato d\u0027Oro",
          "tr": "Altın Konsantresi",
          "pl": "Koncentrat złota",
          "ru": "Концентрат золота",
          "uk": "Концентрат золота",
          "ko": "정제된 금광석",
          "zh": "筛选金矿石",
          "ja": "金の精鉱"
        },
        {
          "id": "FirLogItem",
          "en": "Fir Log",
          "fr": "Bûche de sapin",
          "es": "Tronco de abeto",
          "de": "Tannenholzstamm",
          "pt": "Tora de Abeto",
          "it": "Tronco d\u0027Abete",
          "tr": "Köknar Kütüğü",
          "pl": "Kłoda jodły",
          "ru": "Бревно Пихты",
          "uk": "Ялинова колода",
          "ko": "전나무 원목",
          "zh": "杉木原木",
          "ja": "モミの木の丸太"
        },
        {
          "id": "CrushedStoneItem",
          "en": "Crushed Stone",
          "fr": "Pierre concassée",
          "es": "Piedra triturada",
          "de": "Schotter",
          "pt": "Pedra Triturada",
          "it": "Pietra Spaccata",
          "tr": "Kırma Taş",
          "pl": "Pokruszony kamień",
          "ru": "Щебень",
          "uk": "Щебінь",
          "ko": "파쇄된 돌",
          "zh": "破碎岩石",
          "ja": "砕石"
        },
        {
          "id": "CrushedRock",
          "en": "Crushed Rock",
          "fr": "Pierre concassée",
          "es": "Roca triturada",
          "de": "Zerkleinerter Stein",
          "pt": "Rocha Triturada",
          "it": "Roccia Spaccata",
          "tr": "Kırılmış Kaya",
          "pl": "Pokruszona skała",
          "ru": "Щебень",
          "uk": "Щебінь",
          "ko": "으깬 바위",
          "zh": "破碎岩石",
          "ja": "粉砕した岩"
        },
        {
          "id": "CrushedSlagItem",
          "en": "Crushed Slag",
          "fr": "Scories concassés",
          "es": "Escoria triturada",
          "de": "Zerkleinerte Schlacke",
          "pt": "Escória triturada",
          "it": "Scorie Spaccate",
          "tr": "Kırma Cüruf",
          "pl": "Pokruszony żużel",
          "ru": "Дроблёный шлак",
          "uk": "Подрібнена окалина",
          "ko": "파쇄된 광물 찌꺼기",
          "zh": "破碎矿渣",
          "ja": "粉砕した鉱滓"
        },
        {
          "id": "CrushedShaleItem",
          "en": "Crushed Shale",
          "fr": "Schiste concassé",
          "es": "Pizarra triturada",
          "de": "Zerkleinerter Schiefer",
          "pt": "Xisto triturado",
          "it": "Scisto Spaccato",
          "tr": "Kırma Kil",
          "pl": "Pokruszony łupek",
          "ru": "Сланцевый щебень",
          "uk": "Подрібнений сланець",
          "ko": "파쇄된 이판암",
          "zh": "破碎页岩",
          "ja": "粉砕した頁岩"
        },
        {
          "id": "CrushedSandstoneItem",
          "en": "Crushed Sandstone",
          "fr": "Grès concassé",
          "es": "Arenisca triturada",
          "de": "Zerkleinerter Sandstein",
          "pt": "Arenito triturado",
          "it": "Arenaria Spaccata",
          "tr": "Kırma Kumtaşı",
          "pl": "Pokruszony piaskowiec",
          "ru": "Щебень из песчаника",
          "uk": "Подрібнений піщаник",
          "ko": "파쇄된 사암",
          "zh": "破碎砂岩",
          "ja": "粉砕した砂岩"
        },
        {
          "id": "CrushedOilShaleItem",
          "en": "Crushed Oil Shale",
          "fr": "Schiste bitumineux concassé",
          "es": "Pizarra bituminosa triturada",
          "de": "Zerkleinertes Ölschiefer",
          "pt": "Xisto Betuminoso Triturado",
          "it": "Scisto di Petrolio Spaccato",
          "tr": "Kırılmış Tortu Şisti",
          "pl": "Pokruszony łupek naftowy",
          "ru": "Дроблёный нефтяной сланец",
          "uk": "Подрібнений нафтовий сланець",
          "ko": "파쇄된 유혈암",
          "zh": "破碎油页岩",
          "ja": "粉砕した油頁岩"
        },
        {
          "id": "CrushedLimestoneItem",
          "en": "Crushed Limestone",
          "fr": "Calcaire concassé",
          "es": "Piedra caliza triturada",
          "de": "Zerkleinerter Kalkstein",
          "pt": "Calcário triturado",
          "it": "Calcare Spaccato",
          "tr": "Kırma Kireç Taşı",
          "pl": "Pokruszony wapień",
          "ru": "Известняковый щебень",
          "uk": "Вапняковий щебінь",
          "ko": "파쇄된 석회암",
          "zh": "破碎石灰岩",
          "ja": "粉砕した石灰岩"
        },
        {
          "id": "CrushedIronOreItem",
          "en": "Crushed Iron Ore",
          "fr": "Minerai de fer concassé",
          "es": "Mineral de hierro triturado",
          "de": "Zerkleinertes Eisenerz",
          "pt": "Minério de ferro triturado",
          "it": "Ferro Spaccato",
          "tr": "Kırma Demir Cevheri",
          "pl": "Pokruszona ruda żelaza",
          "ru": "Дроблёная железная руда",
          "uk": "Подрібнена залізна руда",
          "ko": "파쇄된 철광석",
          "zh": "破碎铁矿石",
          "ja": "粉砕した鉄鉱石"
        },
        {
          "id": "CrushedGraniteItem",
          "en": "Crushed Granite",
          "fr": "Granite concassé",
          "es": "Granito triturado",
          "de": "Zerkleinerter Granit",
          "pt": "Granito triturado",
          "it": "Granito Spaccato",
          "tr": "Kırma Granit",
          "pl": "Pokruszony granit",
          "ru": "Гранитный щебень",
          "uk": "Подрібнений граніт",
          "ko": "파쇄된 화강암",
          "zh": "破碎花岗岩",
          "ja": "粉砕した花崗岩"
        },
        {
          "id": "CrushedGoldOreItem",
          "en": "Crushed Gold Ore",
          "fr": "Minerai d\u0027or concassé",
          "es": "Mineral de oro triturado",
          "de": "Zerkleinertes Golderz",
          "pt": "Minério de ouro triturado",
          "it": "Oro Spaccato",
          "tr": "Kırma Altın Cevheri",
          "pl": "Pokruszona ruda złota",
          "ru": "Дроблёная золотая руда",
          "uk": "Подрібнена золота руда",
          "ko": "파쇄된 금광석",
          "zh": "破碎金矿石",
          "ja": "粉砕した金鉱石"
        },
        {
          "id": "CrushedGneissItem",
          "en": "Crushed Gneiss",
          "fr": "Gneiss concassé",
          "es": "Gneis triturada",
          "de": "Zerkleinerter Gneis",
          "pt": "Gneisse triturado",
          "it": "Gneiss Spaccato",
          "tr": "Kırma Gnays",
          "pl": "Pokruszony gnejs",
          "ru": "Щебень из гнейса",
          "uk": "Подрібнений гнейс",
          "ko": "파쇄된 편마암",
          "zh": "破碎片麻岩",
          "ja": "粉砕した片麻岩"
        },
        {
          "id": "CrushedCopperOreItem",
          "en": "Crushed Copper Ore",
          "fr": "Minerai de cuivre concassé",
          "es": "Mineral de cobre triturado",
          "de": "Zerkleinertes Kupfererz",
          "pt": "Minério de cobre triturado",
          "it": "Rame Spaccato",
          "tr": "Kırma Bakır Cevheri",
          "pl": "Pokruszona ruda miedzi",
          "ru": "Дроблёная медная руда",
          "uk": "Подрібнена мідна руда",
          "ko": "파쇄된 구리 광석",
          "zh": "破碎铜矿石",
          "ja": "粉砕した銅鉱石"
        },
        {
          "id": "CrushedCoalItem",
          "en": "Crushed Coal",
          "fr": "Charbon concassé",
          "es": "Carbón triturado",
          "de": "Zerkleinerte Kohle",
          "pt": "Carvão Triturado",
          "it": "Carbone Spaccato",
          "tr": "Kırılmış Kömür",
          "pl": "Pokruszony węgiel",
          "ru": "Дроблёный уголь",
          "uk": "Подрібнене вугілля",
          "ko": "파쇄된 석탄",
          "zh": "破碎煤矿石",
          "ja": "粉砕した石炭"
        },
        {
          "id": "CrushedBasaltItem",
          "en": "Crushed Basalt",
          "fr": "Basalte concassé",
          "es": "Basalto triturado",
          "de": "Zerkleinerter Basalt",
          "pt": "Basalto triturado",
          "it": "Basalto Spaccato",
          "tr": "Kırma Bazalt",
          "pl": "Pokruszony bazalt",
          "ru": "Базальтовый щебень",
          "uk": "Подрібнений базальт",
          "ko": "파쇄된 현무암",
          "zh": "破碎玄武岩",
          "ja": "粉砕した玄武岩"
        },
        {
          "id": "CopperConcentrateItem",
          "en": "Copper Concentrate",
          "fr": "Concentré de cuivre",
          "es": "Concentrado de cobre",
          "de": "Kupferkonzentrat",
          "pt": "Concentrado de cobre",
          "it": "Concentrato di Rame",
          "tr": "Bakır Konsantresi",
          "pl": "Koncentrat miedzi",
          "ru": "Концентрат меди",
          "uk": "Концентрат міді",
          "ko": "정제된 구리 광석",
          "zh": "筛选铜矿石",
          "ja": "銅の精鉱"
        },
        {
          "id": "CompositeSpruceLumberItem",
          "en": "Composite Spruce Lumber",
          "fr": "Bois composite d\u0027épicéa",
          "es": "Tronco de composite (pícea)",
          "de": "Fichten-Verbundholz",
          "pt": "Madeira serrada composta de pinheiro",
          "it": "Legno Composito di Abete Rosso",
          "tr": "Kompozit Alaçam Kerestesi",
          "pl": "Kompozytowe drewno ze świerku",
          "ru": "Композитные пиломатериалы из ели",
          "uk": "Ялиновий композитний стіл",
          "ko": "합성 가문비나무 목재",
          "zh": "复合云杉木材",
          "ja": "複合材の松の板材"
        },
        {
          "id": "CompositeSaguaroLumberItem",
          "en": "Composite Saguaro Lumber",
          "fr": "Bois composite de saguaro",
          "es": "Tronco de composite (saguaro)",
          "de": "Kaktus-Verbundholz",
          "pt": "Madeira serrada composta de saguaro",
          "it": "Legno Composito di Saguaro",
          "tr": "Kompozit Saguaro Kerestesi",
          "pl": "Kompozytowe drewno z saguaro",
          "ru": "Композитные пиломатериалы из карнегии",
          "uk": "Композитний пиломатеріал із Карнегі",
          "ko": "합성 변경주선인장 목재",
          "zh": "复合柱瓜木材",
          "ja": "サグアロサボテンの製材"
        },
        {
          "id": "CompositeRedwoodLumberItem",
          "en": "Composite Redwood Lumber",
          "fr": "Bois composite de séquoia",
          "es": "Tronco de secuoya (composite)",
          "de": "Rottannen-Verbundholz",
          "pt": "Madeira serrada composta de sequoia-vermelha",
          "it": "Legno Composito di Sequoia",
          "tr": "Kompozit Kızılçam Kerestesi",
          "pl": "Kompozytowe drewno z sekwoi",
          "ru": "Композитные пиломатериалы из секвойи",
          "uk": "Композитні пиломатеріали червоного дерева",
          "ko": "합성 붉은삼나무 목재",
          "zh": "复合红木木材",
          "ja": "レッドウッドの複合材"
        },
        {
          "id": "CompositePalmLumberItem",
          "en": "Composite Palm Lumber",
          "fr": "Bois composite de palmier",
          "es": "Tronco de palmera (composite)",
          "de": "Palmen-Verbundholz",
          "pt": "Madeira serrada composta de palmeira",
          "it": "Legno Composito di Palma",
          "tr": "Kompozit Palmiye Kerestesi",
          "pl": "Kompozytowe drewno z palmy",
          "ru": "Композитные пиломатериалы из пальмы",
          "uk": "Композитні пальмові пиломатеріали",
          "ko": "합성 야자나무 목재",
          "zh": "复合棕榈木材",
          "ja": "ヤシの複合材"
        },
        {
          "id": "CompositeOakLumberItem",
          "en": "Composite Oak Lumber",
          "fr": "Bois composite de chêne",
          "es": "Tronco de roble (composite)",
          "de": "Eichen-Verbundholz",
          "pt": "Madeira serrada composta de carvalho",
          "it": "Legno Composito di Quercia",
          "tr": "Kompozit Meşe Kerestesi",
          "pl": "Kompozytowe drewno z dębu",
          "ru": "Композитные пиломатериалы из дуба",
          "uk": "Композитний дубовий пиломатеріал",
          "ko": "합성 참나무 목재",
          "zh": "复合橡木木材",
          "ja": "樫の複合材"
        },
        {
          "id": "CompositeLumberItem",
          "en": "Composite Lumber",
          "fr": "Bois composite",
          "es": "Tronco (composite)",
          "de": "Verbundholz",
          "pt": "Madeira serrada composta",
          "it": "Legname Composito",
          "tr": "Kompozit Kereste",
          "pl": "Kompozytowe drewno",
          "ru": "Композитные пиломатериалы",
          "uk": "Композитні пиломатеріали",
          "ko": "합성 가공된 목재",
          "zh": "复合木材",
          "ja": "複合材"
        },
        {
          "id": "CompositeLumber",
          "en": "Composite Lumber",
          "fr": "Bois composite",
          "es": "Tronco (composite)",
          "de": "Verbundholz",
          "pt": "Madeira serrada composta",
          "it": "Legname Composito",
          "tr": "Kompozit Kereste",
          "pl": "Kompozytowe drewno",
          "ru": "Композитные пиломатериалы",
          "uk": "Композитні пиломатеріали",
          "ko": "합성 가공된 목재",
          "zh": "复合木材",
          "ja": "複合材"
        },
        {
          "id": "CompositeJoshuaLumberItem",
          "en": "Composite Joshua Lumber",
          "fr": "Bois composite de josué",
          "es": "Tronco de árbol de Josué (composite)",
          "de": "Josua-Verbundholz",
          "pt": "Madeira serrada composta de Joshua",
          "it": "Legno Composito di Albero di Giosuè",
          "tr": "Kompozit Joshua Kerestesi",
          "pl": "Kompozytowa tarcica z jukki",
          "ru": "Композитные пиломатериалы из юкки",
          "uk": "Композитний пиломатеріал із Карнегі",
          "ko": "합성 여호수아나무 목재",
          "zh": "复合约书亚木材",
          "ja": "ジョシュア・ツリーの複合材"
        },
        {
          "id": "CompositeFirLumberItem",
          "en": "Composite Fir Lumber",
          "fr": "Bois composite de sapin",
          "es": "Tronco de abeto (composite)",
          "de": "Tannen-Verbundholz",
          "pt": "Madeira serrada composta de abeto",
          "it": "Legno Composito di Abete",
          "tr": "Kompozit Köknar Kerestesi",
          "pl": "Kompozytowe drewno z jodły",
          "ru": "Композитные пиломатериалы из пихты",
          "uk": "Композитний ялинковий пиломатеріал",
          "ko": "합성 전나무 목재",
          "zh": "复合杉木木材",
          "ja": "モミの木の複合材"
        },
        {
          "id": "CompositeCeibaLumberItem",
          "en": "Composite Ceiba Lumber",
          "fr": "Bois composite de ceiba",
          "es": "Tronco de ceiba (composite)",
          "de": "Kapok-Verbundholz",
          "pt": "Madeira serrada composta de ceiba",
          "it": "Legno Composito di Ceiba",
          "tr": "Kompozit Floş Kerestesi",
          "pl": "Kompozytowe drewno z puchowca",
          "ru": "Композитные пиломатериалы из сейбы",
          "uk": "Композитний пиломатеріал сейба",
          "ko": "합성 명주나무 목재",
          "zh": "复合木棉木材",
          "ja": "パンヤノキの複合材"
        },
        {
          "id": "CompositeCedarLumberItem",
          "en": "Composite Cedar Lumber",
          "fr": "Bois composite de cèdre",
          "es": "Tronco de cedro (composite)",
          "de": "Zedern-Verbundholz",
          "pt": "Madeira serrada composta de cedro",
          "it": "Legno Composito di Cedro",
          "tr": "Kompozit Sedir Kerestesi",
          "pl": "Kompozytowe drewno z cedru",
          "ru": "Композитные пиломатериалы из кедра",
          "uk": "Композитний кедровий пиломатеріал",
          "ko": "합성 삼나무 목재",
          "zh": "复合雪松木材",
          "ja": "杉の複合材"
        },
        {
          "id": "CompositeBirchLumberItem",
          "en": "Composite Birch Lumber",
          "fr": "Bois composite de bouleau",
          "es": "Tronco de abedul (composite)",
          "de": "Birken-Verbundholz",
          "pt": "Madeira serrada composta de bétula",
          "it": "Legno Composito di Betulla",
          "tr": "Kompozit Huş Kerestesi",
          "pl": "Kompozytowe drewno z brzozy",
          "ru": "Композитные пиломатериалы из березы",
          "uk": "Композитні березові пиломатеріали",
          "ko": "합성 자작나무 목재",
          "zh": "复合桦木",
          "ja": "白樺の複合材"
        },
        {
          "id": "CeibaLogItem",
          "en": "Ceiba Log",
          "fr": "Bûche de ceiba",
          "es": "Tronco de ceiba",
          "de": "Kapokholzstamm",
          "pt": "Tora de Ceiba",
          "it": "Tronco di Ceiba",
          "tr": "Floş Kütüğü",
          "pl": "Kłoda puchowca",
          "ru": "Бревно Сейбы",
          "uk": "Колода сейби",
          "ko": "명주나무 원목",
          "zh": "木棉原木",
          "ja": "パンヤノキの丸太"
        },
        {
          "id": "CedarLogItem",
          "en": "Cedar Log",
          "fr": "Bûche de cèdre",
          "es": "Tronco de cedro",
          "de": "Zedernholzstamm",
          "pt": "Tora de Cedro",
          "it": "Tronco di Cedro",
          "tr": "Sedir Kütüğü",
          "pl": "Kłoda cedru",
          "ru": "Бревно Кедра",
          "uk": "Кедрова колода",
          "ko": "삼나무 원목",
          "zh": "雪松原木",
          "ja": "杉の丸太"
        },
        {
          "id": "BirchLogItem",
          "en": "Birch Log",
          "fr": "Bûche de bouleau",
          "es": "Tronco de abedul",
          "de": "Birkenholzstamm",
          "pt": "Tora de Bétula",
          "it": "Tronco di Betulla",
          "tr": "Huş Kütüğü",
          "pl": "Kłoda brzozy",
          "ru": "Бревно Березы",
          "uk": "Березова колода",
          "ko": "자작나무 원목",
          "zh": "桦木原木",
          "ja": "白樺の丸太"
        },
        {
          "id": "AshlarStone",
          "en": "Ashlar Stone",
          "fr": "Pierre taillé",
          "es": "Sillar de piedra",
          "de": "Quadersteine",
          "pt": "Pedra Polida",
          "it": "Pietra Bugnata",
          "tr": "Kesme Taş",
          "pl": "Ciosany kamień",
          "ru": "Резной камень",
          "uk": "Ашларовий камінь",
          "ko": "각진 돌",
          "zh": "方琢石",
          "ja": "切石"
        },
        {
          "id": "AshlarShaleItem",
          "en": "Ashlar Shale",
          "fr": "Schiste taillé",
          "es": "Pizarra (sillar)",
          "de": "Quader aus Schiefer",
          "pt": "Xisto polido",
          "it": "Scisto Bugnato",
          "tr": "Kesme Kil",
          "pl": "Ciosany łupek",
          "ru": "Резной сланец",
          "uk": "Обтесаний сланець",
          "ko": "각진 이판암",
          "zh": "方琢页岩",
          "ja": "頁岩の切石"
        },
        {
          "id": "AshlarSandstoneItem",
          "en": "Ashlar Sandstone",
          "fr": "Grès taillé",
          "es": "Sillar de arenisca",
          "de": "Quader aus Sandstein",
          "pt": "Arenito polido",
          "it": "Arenaria Bugnata",
          "tr": "Kesme Kumtaşı",
          "pl": "Ciosany piaskowiec",
          "ru": "Резной песчаник",
          "uk": " Обтесаний піщаник",
          "ko": "각진 사암",
          "zh": "方琢砂岩",
          "ja": "砂岩の切石"
        },
        {
          "id": "AshlarLimestoneItem",
          "en": "Ashlar Limestone",
          "fr": "Calcaire taillé",
          "es": "Sillar de piedra caliza",
          "de": "Quader aus Kalkstein",
          "pt": "Calcário polido",
          "it": "Calcare Bugnato",
          "tr": "Kesme Kireç Taşı",
          "pl": "Ciosany wapień",
          "ru": "Резной известняк",
          "uk": "Різьблений Вапняк",
          "ko": "각진 석회암",
          "zh": "方琢石灰石",
          "ja": "石灰岩の切石"
        },
        {
          "id": "AshlarGraniteItem",
          "en": "Ashlar Granite",
          "fr": "Granite taillé",
          "es": "Sillar de granito",
          "de": "Quader aus Granit",
          "pt": "Granito polido",
          "it": "Granito Bugnato",
          "tr": "Kesme Granit",
          "pl": "Ciosany granit",
          "ru": "Резной гранит",
          "uk": "Різьблений Граніт",
          "ko": "각진 화강암",
          "zh": "方琢花岗岩",
          "ja": "花崗岩の切石"
        },
        {
          "id": "AshlarGneissItem",
          "en": "Ashlar Gneiss",
          "fr": "Gneiss taillé",
          "es": "Sillar de gneis",
          "de": "Quader aus Gneis",
          "pt": "Gnaisse polido",
          "it": "Gneiss Bugnato",
          "tr": "Kesme Gnays",
          "pl": "Ciosany gnejs",
          "ru": "Резной гнейс",
          "uk": "Різьблений гнейс",
          "ko": "각진 편마암",
          "zh": "方琢片麻岩",
          "ja": "片麻岩の切石"
        },
        {
          "id": "AshlarBasaltItem",
          "en": "Ashlar Basalt",
          "fr": "Basalte taillé",
          "es": "Sillar de basalto",
          "de": "Quader aus Basalt",
          "pt": "Basalto polido",
          "it": "Basalto Bugnato",
          "tr": "Kesme Bazalt",
          "pl": "Ciosany bazalt",
          "ru": "Резной базальт",
          "uk": "Різьблений Базальт",
          "ko": "각진 현무암",
          "zh": "方琢玄武岩",
          "ja": "玄武岩の切石"
        },
        {
          "id": "Crafting Table",
          "en": "Crafting Table",
          "fr": "Atelier de fabrication",
          "es": "Mesa de trabajo",
          "de": "Herstellungstisch",
          "pt": "Mesa de Fabricação",
          "it": "Tavolo di Fabbricazione",
          "tr": "Üretim Masası",
          "pl": "Stół rzemieślniczy",
          "ru": "Верстак",
          "uk": "Верстат",
          "ko": "제작 작업대",
          "zh": "手工桌",
          "ja": "作業台"
        },
        {
          "id": "CraftingTable",
          "en": "Crafting Table",
          "fr": "Atelier de fabrication",
          "es": "Mesa de trabajo",
          "de": "Herstellungstisch",
          "pt": "Mesa de Fabricação",
          "it": "Tavolo di Fabbricazione",
          "tr": "Üretim Masası",
          "pl": "Stół rzemieślniczy",
          "ru": "Верстак",
          "uk": "Верстат",
          "ko": "제작 작업대",
          "zh": "手工桌",
          "ja": "作業台"
        },
        {
          "id": "SnappingTurtleCarcassItem",
          "en": "Snapping Turtle Carcass",
          "fr": "Cadavre de tortue alligator",
          "es": "Cadáver de tortuga mordedora",
          "de": "Schnappschildkröten-Kadaver",
          "pt": "Carcaça de Tartaruga-mordedora",
          "it": "Carcassa di Testuggine Azzannatrice",
          "tr": "Yapışan Kaplumbağa Cesedi",
          "pl": "Tusza żółwia jaszczurowatego",
          "ru": "Туша каймановой черепахи",
          "uk": "Туша кайманової черепахи",
          "ko": "악어거북 사체",
          "zh": "鳄龟遗骸",
          "ja": "Snapping Turtle Carcass"
        },
        {
          "id": "PacificSardineItem",
          "en": "Pacific Sardine",
          "fr": "Sardine du Pacifique",
          "es": "Sardina del Pacífico",
          "de": "Pazifische Sardine",
          "pt": "Sardinha do Pacífico",
          "it": "Sardina del Pacifico",
          "tr": "Pasifik Sardalyası",
          "pl": "Pacyficzna sardynka",
          "ru": "Перуанская сардина",
          "uk": "Перуанська сардина",
          "ko": "태평양 정어리",
          "zh": "太平洋沙丁鱼",
          "ja": "Pacific Sardine"
        },
        {
          "id": "JaguarCarcassItem",
          "en": "Jaguar Carcass",
          "fr": "Cadavre de jaguar",
          "es": "Cadáver de jaguar",
          "de": "Jaguarkadaver",
          "pt": "Carcaça de Onça-pintada",
          "it": "Carcassa di Giaguaro",
          "tr": "Jaguar Cesedi",
          "pl": "Tusza jaguara",
          "ru": "Туша ягуара",
          "uk": "Каркас ягуара",
          "ko": "재규어 사체",
          "zh": "美洲豹遗骸",
          "ja": "Jaguar Carcass"
        },
        {
          "id": "CrabCarcassItem",
          "en": "Crab Carcass",
          "fr": "Cadavre de crabe",
          "es": "Cadáver de cangrejo",
          "de": "Krabbenkadaver",
          "pt": "Carcaça de Caranguejo",
          "it": "Carcassa di Granchio",
          "tr": "Yengeç Cesedi",
          "pl": "Tusza craba",
          "ru": "Туша краба",
          "uk": "Туша краба",
          "ko": "게 사체",
          "zh": "螃蟹遗骸",
          "ja": "Crab Carcass"
        },
        {
          "id": "CoyoteCarcassItem",
          "en": "Coyote Carcass",
          "fr": "Cadavre de coyote",
          "es": "Cadáver de coyote",
          "de": "Kojotenkadaver",
          "pt": "Carcaça de Coiote",
          "it": "Carcassa di Coyote",
          "tr": "Kır Kurdu Cesedi",
          "pl": "Tusza kojota",
          "ru": "Туша койота",
          "uk": "Туша койота",
          "ko": "코요테 사체",
          "zh": "郊狼遗骸",
          "ja": "Coyote Carcass"
        },
        {
          "id": "BlueSharkItem",
          "en": "Blue Shark",
          "fr": "Requin bleu",
          "es": "Tiburón azul",
          "de": "Blauer Hai",
          "pt": "Tubarão-azul",
          "it": "Squalo Blu",
          "tr": "Mavi Köpekbalığı",
          "pl": "Żarłacz błękitny",
          "ru": "Синяя акула",
          "uk": "Синя акула",
          "ko": "청새리상어",
          "zh": "蓝鲨",
          "ja": "Blue Shark"
        },
        {
          "id": "AlligatorCarcassItem",
          "en": "Alligator Carcass",
          "fr": "Cadavre d\u0027alligator",
          "es": "Cadáver de caimán",
          "de": "Alligatorkadaver",
          "pt": "Carcaça de Jacaré",
          "it": "Carcassa di Alligatore",
          "tr": "Timsah Cesedi",
          "pl": "Tusza aligatora",
          "ru": "Туша аллигатора",
          "uk": "Туша алігатора",
          "ko": "악어 사체",
          "zh": "鳄鱼遗骸",
          "ja": "Alligator Carcass"
        },
        {
          "id": "AgoutiCarcassItem",
          "en": "Agouti Carcass",
          "fr": "Cadavre d\u0027agouti",
          "es": "Cadáver de agutí",
          "de": "Agutikadaver",
          "pt": "Carcaça de Cutia",
          "it": "Carcassa di Agouti",
          "tr": "Aguti Cesedi",
          "pl": "Tusza aguti",
          "ru": "Туша агути",
          "uk": "Туша агуті",
          "ko": "아구티 사체",
          "zh": "刺豚鼠遗骸",
          "ja": "Agouti Carcass"
        },
        {
          "id": "ToiletItem",
          "en": "Toilet",
          "fr": "Toilette",
          "es": "Baño",
          "de": "Toilette",
          "pt": "Vaso Sanitário",
          "it": "Toilet",
          "tr": "Klozet",
          "pl": "Toaleta",
          "ru": "Туалет",
          "uk": "Туалет",
          "ko": "좌변기",
          "zh": "厕所",
          "ja": "Toilet"
        },
        {
          "id": "StuffedWolfItem",
          "en": "Stuffed Wolf",
          "fr": "Loup empaillé",
          "es": "Lobo disecado",
          "de": "Ausgestopfter Wolf",
          "pt": "Lobo Empalhado",
          "it": "Lupo Impagliato",
          "tr": "Doldurulmuş Kurt",
          "pl": "Wypchany wilk",
          "ru": "Чучело волка",
          "uk": "Опудало вовка",
          "ko": "박제된 늑대",
          "zh": "狼标本",
          "ja": "Stuffed Wolf"
        },
        {
          "id": "StuffedJaguarItem",
          "en": "Stuffed Jaguar",
          "fr": "Jaguar empaillé",
          "es": "Jaguar disecado",
          "de": "Ausgestopfter Jaguar",
          "pt": "Onça-pintada Empalhada",
          "it": "Giaguaro Impagliato",
          "tr": "Doldurulmuş Jaguar",
          "pl": "Wypchany jaguar",
          "ru": "Чучело ягуара",
          "uk": "Опудало ягуара",
          "ko": "박제된 재규어",
          "zh": "美洲豹标本",
          "ja": "Stuffed Jaguar"
        },
        {
          "id": "StuffedGoatItem",
          "en": "Stuffed Goat",
          "fr": "Chèvre des montagnes empaillé",
          "es": "Cabra disecada",
          "de": "Ausgestopfte Ziege",
          "pt": "Cabra Empalhada",
          "it": "Capra Impagliata",
          "tr": "Doldurulmuş Keçi",
          "pl": "Wypchana koza",
          "ru": "Чучело козы",
          "uk": "Опудало кози",
          "ko": "박제된 염소",
          "zh": "山羊标本",
          "ja": "Stuffed Goat"
        },
        {
          "id": "StuffedBisonItem",
          "en": "Stuffed Bison",
          "fr": "Bison empaillé",
          "es": "Bisón disecado",
          "de": "Ausgestopftes Bison",
          "pt": "Bisão Empalhado",
          "it": "Bisonte Impagliato",
          "tr": "Doldurulmuş Bufalo",
          "pl": "Wypchany żubr",
          "ru": "Чучело бизона",
          "uk": "Опудало бізона",
          "ko": "박제된 들소",
          "zh": "野牛标本",
          "ja": "Stuffed Bison"
        },
        {
          "id": "StuffedAlligatorItem",
          "en": "Stuffed Alligator",
          "fr": "Alligator empaillé",
          "es": "Caimán disecado",
          "de": "Ausgestopfter Alligator",
          "pt": "Jacaré Empalhado",
          "it": "Alligatore Impagliato",
          "tr": "Doldurulmuş Timsah",
          "pl": "Wypchany aligator",
          "ru": "Чучело аллигатора",
          "uk": "Опудало алігатора",
          "ko": "박제된 악어",
          "zh": "鳄鱼标本",
          "ja": "Stuffed Alligator"
        },
        {
          "id": "SmallStandingMortaredStoneSignItem",
          "en": "Small Standing Mortared Stone Sign",
          "fr": "Petit panneau sur pied en pierre cimenté",
          "es": "Letrero pequeño (piedra con mortero)",
          "de": "Steinziegelschild (klein",
          "pt": "소형 모르타르 마감 석재 간판",
          "it": "Маленькая табличка из строительного камня",
          "tr": "Small Standing Mortared Stone Sign",
          "pl": "Small Standing Mortared Stone Sign",
          "ru": "小型立式砂浆石标志",
          "uk": "Small Standing Mortared Stone Sign",
          "ko": " stehend)",
          "zh": "Placa de Pedra Argamassada Pequena em Pé",
          "ja": "Small Standing Mortared Stone Sign"
        },
        {
          "id": "SmallStandingMortaredSandstoneSignItem",
          "en": "Small Standing Mortared Sandstone Sign",
          "fr": "Petit panneau sur pied en grès cimenté",
          "es": "Letrero pequeño (arenisca con mortero)",
          "de": "Steinziegelschild aus Sandstein (klein",
          "pt": "소형 모르타르 마감 사암 간판",
          "it": "Маленькая табличка из строительного песчаника",
          "tr": "Small Standing Mortared Sandstone Sign",
          "pl": "Small Standing Mortared Sandstone Sign",
          "ru": "小型立式砂浆砂岩标志",
          "uk": "Small Standing Mortared Sandstone Sign",
          "ko": " stehend)",
          "zh": "Placa de Arenito Argamassado Pequena em Pé",
          "ja": "Small Standing Mortared Sandstone Sign"
        },
        {
          "id": "SmallStandingMortaredLimestoneSignItem",
          "en": "Small Standing Mortared Limestone Sign",
          "fr": "Petit panneau sur pied en calcaire cimenté",
          "es": "Letrero pequeño (piedra caliza con mortero)",
          "de": "Steinziegelschild aus Kalkstein (klein",
          "pt": "소형 모르타르 마감 석회암 간판",
          "it": "Маленькая табличка из строительного известняка",
          "tr": "Small Standing Mortared Limestone Sign",
          "pl": "Small Standing Mortared Limestone Sign",
          "ru": "小型立式砂浆石灰石标志",
          "uk": "Small Standing Mortared Limestone Sign",
          "ko": " stehend)",
          "zh": "Placa de Calcário Argamassado Pequena em Pé",
          "ja": "Small Standing Mortared Limestone Sign"
        },
        {
          "id": "SmallStandingMortaredGraniteSignItem",
          "en": "Small Standing Mortared Granite Sign",
          "fr": "Petit panneau sur pied en granite cimenté",
          "es": "Letrero pequeño (granito con mortero)",
          "de": "Steinziegelschild aus Granit (klein",
          "pt": "소형 모르타르 마감 화강암 간판",
          "it": "Маленькая табличка из строительного гранита",
          "tr": "Small Standing Mortared Granite Sign",
          "pl": "Small Standing Mortared Granite Sign",
          "ru": "小型立式砂浆花岗岩标志",
          "uk": "Small Standing Mortared Granite Sign",
          "ko": " stehend)",
          "zh": "Placa de Granito Argamassado Pequena em Pé",
          "ja": "Small Standing Mortared Granite Sign"
        },
        {
          "id": "SmallStandingAshlarStoneSignItem",
          "en": "Small Standing Ashlar Stone Sign",
          "fr": "Petit panneau sur pied en pierre taillé",
          "es": "Letrero pequeño (sillar de piedra)",
          "de": "Steinquaderschild (klein",
          "pt": "소형 각진 석재 간판",
          "it": "Маленькая табличка из резного камня",
          "tr": "Small Standing Ashlar Stone Sign",
          "pl": "Small Standing Ashlar Stone Sign",
          "ru": "小型立式方琢石标志",
          "uk": "Small Standing Ashlar Stone Sign",
          "ko": " stehend)",
          "zh": "Placa de Pedra Polida Pequena em Pé",
          "ja": "Small Standing Ashlar Stone Sign"
        },
        {
          "id": "SmallStandingAshlarShaleSignItem",
          "en": "Small Standing Ashlar Shale Sign",
          "fr": "Petit panneau sur pied en schiste taillé",
          "es": "Letrero pequeño de pizarra (sillar)",
          "de": "Steinquaderschild aus Schiefer (klein",
          "pt": "소형 각진 이판암 간판",
          "it": "Маленькая табличка из резного сланца",
          "tr": "Small Standing Ashlar Shale Sign",
          "pl": "Small Standing Ashlar Shale Sign",
          "ru": "小型立式石板页岩标志",
          "uk": "Small Standing Ashlar Shale Sign",
          "ko": " stehend)",
          "zh": "Placa de Xisto Polido Pequena em Pé",
          "ja": "Small Standing Ashlar Shale Sign"
        },
        {
          "id": "SmallStandingAshlarSandstoneSignItem",
          "en": "Small Standing Ashlar Sandstone Sign",
          "fr": "Petit panneau sur pied en grès taillé",
          "es": "Letrero pequeño (sillar de arenisca)",
          "de": "Steinquaderschild aus Sandstein (klein",
          "pt": "소형 각진 사암 간판",
          "it": "Маленькая табличка из резного песчаника",
          "tr": "Small Standing Ashlar Sandstone Sign",
          "pl": "Small Standing Ashlar Sandstone Sign",
          "ru": "小型立式方琢砂岩标志",
          "uk": "Small Standing Ashlar Sandstone Sign",
          "ko": " stehend)",
          "zh": "Placa de Arenito Polido Pequena em Pé",
          "ja": "Small Standing Ashlar Sandstone Sign"
        },
        {
          "id": "SmallStandingAshlarLimestoneSignItem",
          "en": "Small Standing Ashlar Limestone Sign",
          "fr": "Petit panneau sur pied en calcaire taillé",
          "es": "Letrero pequeño (sillar de piedra caliza)",
          "de": "Steinquaderschild aus Kalkstein (klein",
          "pt": "소형 각진 석회암 간판",
          "it": "Маленькая табличка из резного известняка",
          "tr": "Small Standing Ashlar Limestone Sign",
          "pl": "Small Standing Ashlar Limestone Sign",
          "ru": "小型立式方琢石灰石标志",
          "uk": "Small Standing Ashlar Limestone Sign",
          "ko": " stehend)",
          "zh": "Placa de Calcário Polido Pequena em Pé",
          "ja": "Small Standing Ashlar Limestone Sign"
        },
        {
          "id": "SmallStandingAshlarGraniteSignItem",
          "en": "Small Standing Ashlar Granite Sign",
          "fr": "Petit panneau sur pied en granite taillé",
          "es": "Letrero pequeño (sillar de granito)",
          "de": "Steinquaderschild aus Granit (klein",
          "pt": "소형 각진 화강암 간판",
          "it": "Маленькая табличка из резного гранита",
          "tr": "Small Standing Ashlar Granite Sign",
          "pl": "Small Standing Ashlar Granite Sign",
          "ru": "小型立式方琢花岗岩标志",
          "uk": "Small Standing Ashlar Granite Sign",
          "ko": " stehend)",
          "zh": "Placa de Granito Polido Pequena em Pé",
          "ja": "Small Standing Ashlar Granite Sign"
        },
        {
          "id": "SmallStandingAshlarGneissSignItem",
          "en": "Small Standing Ashlar Gneiss Sign",
          "fr": "Petit panneau sur pied en gneiss taillé",
          "es": "LeLetrero pequeño (sillar de gneis)",
          "de": "Steinquaderschild aus Gneis (klein",
          "pt": "소형 각진 편마암 간판",
          "it": "Маленькая табличка из резного гнейса",
          "tr": "Small Standing Ashlar Gneiss Sign",
          "pl": "Small Standing Ashlar Gneiss Sign",
          "ru": "小型立式立石楠片麻岩标志",
          "uk": "Small Standing Ashlar Gneiss Sign",
          "ko": " stehend)",
          "zh": "Placa de Gnaisse Polido Pequena em Pé",
          "ja": "Small Standing Ashlar Gneiss Sign"
        },
        {
          "id": "SmallStandingAshlarBasaltSignItem",
          "en": "Small Standing Ashlar Basalt Sign",
          "fr": "Petit panneau sur pied en basalte taillé",
          "es": "Letrero pequeño (sillar de basalto)",
          "de": "Steinquaderschild aus Basalt (klein",
          "pt": "소형 각진 현무암 간판",
          "it": "Маленькая табличка из резного базальта",
          "tr": "Small Standing Ashlar Basalt Sign",
          "pl": "Small Standing Ashlar Basalt Sign",
          "ru": "小型立式石拉玄武岩标志",
          "uk": "Small Standing Ashlar Basalt Sign",
          "ko": " stehend)",
          "zh": "Placa de Basalto Polido Pequena em Pé",
          "ja": "Small Standing Ashlar Basalt Sign"
        },
        {
          "id": "SmallSinkItem",
          "en": "Small Sink",
          "fr": "Petit lavabo",
          "es": "Fregadero pequeño",
          "de": "Kleines Waschbecken",
          "pt": "Pia Pequena",
          "it": "Piccolo Scarico",
          "tr": "Ufak Lavabo",
          "pl": "Mały zlew",
          "ru": "Маленькая раковина",
          "uk": "Мала раковина",
          "ko": "작은 개수대",
          "zh": "小水槽",
          "ja": "Small Sink"
        },
        {
          "id": "SmallHangingMortaredStoneSignItem",
          "en": "Small Hanging Mortared Stone Sign",
          "fr": "Petit panneau suspendu en pierre cimentée",
          "es": "Letrero colgante pequeño (mortero)",
          "de": "Steinziegelschild (klein",
          "pt": "소형 모르타르 마감 석재 간판",
          "it": "Маленькая вывеска из строительного камня",
          "tr": "Small Hanging Mortared Stone Sign",
          "pl": "Small Hanging Mortared Stone Sign",
          "ru": "小型悬挂砂浆石标志",
          "uk": "Small Hanging Mortared Stone Sign",
          "ko": " hängend)",
          "zh": "Placa de Pedra Argamassada Pequena Pendurada",
          "ja": "Small Hanging Mortared Stone Sign"
        },
        {
          "id": "SmallHangingMortaredSandstoneSignItem",
          "en": "Small Hanging Mortared Sandstone Sign",
          "fr": "Petit panneau suspendu en grès cimenté",
          "es": "Letrero colgante pequeño (arenisca con mortero)",
          "de": "Steinziegelschild aus Sandstein (klein",
          "pt": "소형 모르타르 마감 사암 간판",
          "it": "Маленькая вывеска из строительного песчаника",
          "tr": "Small Hanging Mortared Sandstone Sign",
          "pl": "Small Hanging Mortared Sandstone Sign",
          "ru": "小型悬挂砂浆砂岩标志",
          "uk": "Small Hanging Mortared Sandstone Sign",
          "ko": " hängend)",
          "zh": "Placa de Arenito Argamassado Pequena Pendurada",
          "ja": "Small Hanging Mortared Sandstone Sign"
        },
        {
          "id": "SmallHangingMortaredLimestoneSignItem",
          "en": "Small Hanging Mortared Limestone Sign",
          "fr": "Petit panneau suspendu en calcaire cimenté",
          "es": "Letrero colgante pequeño (piedra caliza con mortero)",
          "de": "Steinziegelschild aus Kalkstein (klein",
          "pt": "소형 모르타르 마감 석회암 간판",
          "it": "Маленькая вывеска из строительного известняка",
          "tr": "Small Hanging Mortared Limestone Sign",
          "pl": "Small Hanging Mortared Limestone Sign",
          "ru": "小型悬挂砂浆石灰石标志",
          "uk": "Small Hanging Mortared Limestone Sign",
          "ko": " hängend)",
          "zh": "Placa de Calcário Argamassado Pequena Pendurada",
          "ja": "Small Hanging Mortared Limestone Sign"
        },
        {
          "id": "SmallHangingMortaredGraniteSignItem",
          "en": "Small Hanging Mortared Granite Sign",
          "fr": "Petit panneau suspendu en granite cimenté",
          "es": "Letrero colgante pequeño (granito con mortero)",
          "de": "Steinziegelschild aus Granit (klein",
          "pt": "소형 모르타르 마감 화강암 간판",
          "it": "Маленькая вывеска из строительного гранита",
          "tr": "Small Hanging Mortared Granite Sign",
          "pl": "Small Hanging Mortared Granite Sign",
          "ru": "小型悬挂砂浆花岗岩标志",
          "uk": "Small Hanging Mortared Granite Sign",
          "ko": " hängend)",
          "zh": "Placa de Granito Argamassado Pequena Pendurada",
          "ja": "Small Hanging Mortared Granite Sign"
        },
        {
          "id": "SmallHangingAshlarStoneSignItem",
          "en": "Small Hanging Ashlar Stone Sign",
          "fr": "Petit panneau suspendu en pierre taillé",
          "es": "Letrero colgante pequeño (sillar de piedra)",
          "de": "Steinquaderschild (klein",
          "pt": "소형 각진 석재 현판",
          "it": "Маленькая вывеска из резного камня",
          "tr": "Small Hanging Ashlar Stone Sign",
          "pl": "Small Hanging Ashlar Stone Sign",
          "ru": "小型悬挂方琢标志",
          "uk": "Small Hanging Ashlar Stone Sign",
          "ko": " hängend)",
          "zh": "Placa de Pedra Polida Pequena Pendurada",
          "ja": "Small Hanging Ashlar Stone Sign"
        },
        {
          "id": "SmallHangingAshlarShaleSignItem",
          "en": "Small Hanging Ashlar Shale Sign",
          "fr": "Petit panneau suspendu en schiste taillé",
          "es": "Letrero colgante pequeño (sillar de pizarra)",
          "de": "Steinquaderschild aus Schiefer (klein",
          "pt": "소형 각진 이판암 현판",
          "it": "Маленькая вывеска из резного сланца",
          "tr": "Small Hanging Ashlar Shale Sign",
          "pl": "Small Hanging Ashlar Shale Sign",
          "ru": "小型悬挂方琢页岩标志",
          "uk": "Small Hanging Ashlar Shale Sign",
          "ko": " hängend)",
          "zh": "Placa de Xisto Polido Pequena Pendurada",
          "ja": "Small Hanging Ashlar Shale Sign"
        },
        {
          "id": "SmallHangingAshlarSandstoneSignItem",
          "en": "Small Hanging Ashlar Sandstone Sign",
          "fr": "Petit panneau suspendu en grès taillé",
          "es": "Letrero colgante pequeño (sillar de arenisca)",
          "de": "Steinquaderschild aus Sandstein (klein",
          "pt": "소형 각진 사암 현판",
          "it": "Маленькая вывеска из резного песчаника",
          "tr": "Small Hanging Ashlar Sandstone Sign",
          "pl": "Small Hanging Ashlar Sandstone Sign",
          "ru": "小型悬挂石板砂岩标志",
          "uk": "Small Hanging Ashlar Sandstone Sign",
          "ko": " hängend)",
          "zh": "Placa de Arenito Polido Pequena Pendurada",
          "ja": "Small Hanging Ashlar Sandstone Sign"
        },
        {
          "id": "SmallHangingAshlarLimestoneSignItem",
          "en": "Small Hanging Ashlar Limestone Sign",
          "fr": "Petit panneau suspendu en calcaire taillé",
          "es": "Letrero colgante pequeño (sillar de piedra caliza)",
          "de": "Steinquaderschild aus Kalkstein (klein",
          "pt": "소형 각진 석회암 현판",
          "it": "Маленькая вывеска из резного известняка",
          "tr": "Small Hanging Ashlar Limestone Sign",
          "pl": "Small Hanging Ashlar Limestone Sign",
          "ru": "小型悬挂方琢石灰石标志",
          "uk": "Small Hanging Ashlar Limestone Sign",
          "ko": " hängend)",
          "zh": "Placa de Calcário Polido Pequena Pendurada",
          "ja": "Small Hanging Ashlar Limestone Sign"
        },
        {
          "id": "SmallHangingAshlarGraniteSignItem",
          "en": "Small Hanging Ashlar Granite Sign",
          "fr": "Petit panneau suspendu en granite taillé",
          "es": "Letrero colgante pequeño (sillar de granito)",
          "de": "Steinquaderschild aus Granit (klein",
          "pt": "소형 각진 화강암 현판",
          "it": "Маленькая вывеска из резного гранита",
          "tr": "Small Hanging Ashlar Granite Sign",
          "pl": "Small Hanging Ashlar Granite Sign",
          "ru": "小型悬挂石板花岗岩标志",
          "uk": "Small Hanging Ashlar Granite Sign",
          "ko": " hängend)",
          "zh": "Placa de Granito Polido Pequena Pendurada",
          "ja": "Small Hanging Ashlar Granite Sign"
        },
        {
          "id": "SmallHangingAshlarGneissSignItem",
          "en": "Small Hanging Ashlar Gneiss Sign",
          "fr": "Petit panneau suspendu en gneiss taillé",
          "es": "Letrero colgante pequeño (sillar de gneis)",
          "de": "Steinquaderschild aus Gneis (klein",
          "pt": "소형 각진 편마암 현판",
          "it": "Маленькая вывеска из резного гнейса",
          "tr": "Small Hanging Ashlar Gneiss Sign",
          "pl": "Small Hanging Ashlar Gneiss Sign",
          "ru": "小型悬挂方琢片麻岩标志",
          "uk": "Small Hanging Ashlar Gneiss Sign",
          "ko": " hängend)",
          "zh": "Placa de Gnaisse Polido Pequena Pendurada",
          "ja": "Small Hanging Ashlar Gneiss Sign"
        },
        {
          "id": "SmallHangingAshlarBasaltSignItem",
          "en": "Small Hanging Ashlar Basalt Sign",
          "fr": "Petit panneau suspendu en basalte taillé",
          "es": "Letrero colgante pequeño (sillar de basalto)",
          "de": "Steinquaderschild aus Basalt (klein",
          "pt": "소형 각진 현무암 현판",
          "it": "Маленькая вывеска из резного базальта",
          "tr": "Small Hanging Ashlar Basalt Sign",
          "pl": "Small Hanging Ashlar Basalt Sign",
          "ru": "小型悬挂石板玄武岩标志",
          "uk": "Small Hanging Ashlar Basalt Sign",
          "ko": " hängend)",
          "zh": "Placa de Basalto Polido Pequena Pendurada",
          "ja": "Small Hanging Ashlar Basalt Sign"
        },
        {
          "id": "SheepMountItem",
          "en": "Sheep Mount",
          "fr": "Trophée de mouflon",
          "es": "Montura de borrego",
          "de": "Ausgestopftes Bergschaf",
          "pt": "Cabeça de Carneiro",
          "it": "Pecora",
          "tr": "Koyun Binek",
          "pl": "Owcza Góra",
          "ru": "Голова барана",
          "uk": "Голова барана",
          "ko": "박제된 양 벽걸이",
          "zh": "羊山",
          "ja": "Sheep Mount"
        },
        {
          "id": "MortaredStoneDoorItem",
          "en": "Mortared Stone Door",
          "fr": "Porte en pierre cimentée",
          "es": "Puerta de piedra con mortero",
          "de": "Steinziegeltür",
          "pt": "Porta de Pedra Argamassada",
          "it": "Pietra in Pietra Pestata",
          "tr": "Harçlı Taştan Kapı",
          "pl": "Cementowane kamienne drzwi",
          "ru": "Дверь из строительного камня",
          "uk": "Двері з будівельного каміння",
          "ko": "모르타르 마감 석재 문",
          "zh": "砂浆石门",
          "ja": "Mortared Stone Door"
        },
        {
          "id": "LimestoneWolfStatueItem",
          "en": "Limestone Wolf Statue",
          "fr": "Statue de loup en calcaire",
          "es": "Estatura de lobo (piedra caliza)",
          "de": "Kalksteinstatue Wolf",
          "pt": "Estátua de Lobo de Calcário",
          "it": "Statua in Calcare del Lupo",
          "tr": "Kireç Taşından Kurt Heykeli",
          "pl": "Wapienna statua wilka",
          "ru": "Статуя волка из известняка",
          "uk": "Статуя вовка з вапняку",
          "ko": "석회암 늑대 조각상",
          "zh": "石灰石狼雕像",
          "ja": "オオカミの石像「石灰岩」"
        },
        {
          "id": "LimestoneOwlStatueItem",
          "en": "Limestone Owl Statue",
          "fr": "Statue de hibou en calcaire",
          "es": "Estatura de búho (piedra caliza)",
          "de": "Kalksteinstatue Eule",
          "pt": "Estátua de Coruja de Calcário",
          "it": "Statua in Calcare del Gufo",
          "tr": "Kireç Taşından Baykuş Heykeli",
          "pl": "Wapienna statua sowy",
          "ru": "Статуя совы из известняка",
          "uk": "Статуя сови з вапняку",
          "ko": "석회암 부엉이 조각상",
          "zh": "石灰石猫头鹰雕像",
          "ja": "フクロウの石像「石灰岩」"
        },
        {
          "id": "LimestoneOtterStatueItem",
          "en": "Limestone Otter Statue",
          "fr": "Statue de loutre en calcaire",
          "es": "Estatua de nutria (piedra caliza)",
          "de": "Kalksteinstatue Otter",
          "pt": "Estátua de Lontra de Calcário",
          "it": "Statua in Calcare della Lontra",
          "tr": "Kireç Taşından Su Samuru Heykeli",
          "pl": "Wapienna statua wydry",
          "ru": "Статуя выдры из известняка",
          "uk": "Статуя видри з вапняку",
          "ko": "석회암 수달 조각상",
          "zh": "石灰石水獭雕像",
          "ja": "カワウソの石像「石灰岩」"
        },
        {
          "id": "LimestoneBisonStatueItem",
          "en": "Limestone Bison Statue",
          "fr": "Statue de bison en calcaire",
          "es": "Estatua de bisonte (piedra caliza)",
          "de": "Kalksteinstatue Bison",
          "pt": "Estátua de Bisão de Calcário",
          "it": "Statua in Calcare del Bisonte",
          "tr": "Kireç Taşından Bufalo Heykeli",
          "pl": "Wapienna statua bizona",
          "ru": "Статуя бизона из известняка",
          "uk": "Статуя бізона з вапняку",
          "ko": "석회암 들소 조각상",
          "zh": "石灰石野牛雕像",
          "ja": "バイソンの石像「石灰岩」"
        },
        {
          "id": "LargeStandingMortaredStoneSignItem",
          "en": "Large Standing Mortared Stone Sign",
          "fr": "Grand panneau sur pied en pierre cimentée",
          "es": "Letrero grande (piedra con mortero)",
          "de": "Steinziegelschild (Groß",
          "pt": "대형 모르타르 마감 석재 간판",
          "it": "Большая табличка из строительного камня",
          "tr": "Large Standing Mortared Stone Sign",
          "pl": "Large Standing Mortared Stone Sign",
          "ru": "大型立式砂浆石标志",
          "uk": "Large Standing Mortared Stone Sign",
          "ko": " stehend)",
          "zh": "Placa de Pedra Argamassada Grande em Pé",
          "ja": "Large Standing Mortared Stone Sign"
        },
        {
          "id": "LargeStandingMortaredSandstoneSignItem",
          "en": "Large Standing Mortared Sandstone Sign",
          "fr": "Grand panneau sur pied en grès cimenté",
          "es": "Letrero grande (arenisca con mortero)",
          "de": "Steinziegelschild aus Sandstein (Groß",
          "pt": "대형 모르타르 마감 사암 간판",
          "it": "Большая табличка из строительного песчаника",
          "tr": "Large Standing Mortared Sandstone Sign",
          "pl": "Large Standing Mortared Sandstone Sign",
          "ru": "大型砂浆砂岩标志",
          "uk": "Large Standing Mortared Sandstone Sign",
          "ko": " stehend)",
          "zh": "Placa de Arenito Argamassado Grande em Pé",
          "ja": "Large Standing Mortared Sandstone Sign"
        },
        {
          "id": "LargeStandingMortaredLimestoneSignItem",
          "en": "Large Standing Mortared Limestone Sign",
          "fr": "Grand panneau sur pied en calcaire cimenté",
          "es": "Letrero grande (piedra caliza con mortero)",
          "de": "Steinziegelschild aus Kalkstein (Groß",
          "pt": "대형 모르타르 마감 석회암 간판",
          "it": "Большая табличка из строительного известняка",
          "tr": "Large Standing Mortared Limestone Sign",
          "pl": "Large Standing Mortared Limestone Sign",
          "ru": "大型砂浆石灰石标志",
          "uk": "Large Standing Mortared Limestone Sign",
          "ko": " stehend)",
          "zh": "Placa de Calcário Argamassado Grande em Pé",
          "ja": "Large Standing Mortared Limestone Sign"
        },
        {
          "id": "LargeStandingMortaredGraniteSignItem",
          "en": "Large Standing Mortared Granite Sign",
          "fr": "Grand panneau sur pied en granite cimenté",
          "es": "Letrero grande (granito con mortero)",
          "de": "Steinziegelschild aus Granit (Groß",
          "pt": "대형 모르타르 마감 화강암 간판",
          "it": "Большая табличка из строительного гранита",
          "tr": "Large Standing Mortared Granite Sign",
          "pl": "Large Standing Mortared Granite Sign",
          "ru": "大型砂浆花岗岩标志",
          "uk": "Large Standing Mortared Granite Sign",
          "ko": " stehend)",
          "zh": "Placa de Granito Argamassado Grande em Pé",
          "ja": "Large Standing Mortared Granite Sign"
        },
        {
          "id": "LargeStandingAshlarStoneSignItem",
          "en": "Large Standing Ashlar Stone Sign",
          "fr": "Grand panneau sur pied en pierre taillée",
          "es": "Letrero grande (sillar de piedra)",
          "de": "Steinquaderschild (Groß",
          "pt": "대형 각진 석재 현판",
          "it": "Большая табличка из резного камня",
          "tr": "Large Standing Ashlar Stone Sign",
          "pl": "Large Standing Ashlar Stone Sign",
          "ru": "大型立方琢石标志",
          "uk": "Large Standing Ashlar Stone Sign",
          "ko": " stehend)",
          "zh": "Placa de Pedra Polida Grande em Pé",
          "ja": "Large Standing Ashlar Stone Sign"
        },
        {
          "id": "LargeStandingAshlarShaleSignItem",
          "en": "Large Standing Ashlar Shale Sign",
          "fr": "Grand panneau sur pied en schiste taillé",
          "es": "Letrero grande (sillar de pizarra)",
          "de": "Steinquaderschild aus Schiefer (Groß",
          "pt": "대형 각진 이판암 현판",
          "it": "Большая табличка из резного сланца",
          "tr": "Large Standing Ashlar Shale Sign",
          "pl": "Large Standing Ashlar Shale Sign",
          "ru": "大型立式石炭页岩标志",
          "uk": "Large Standing Ashlar Shale Sign",
          "ko": " stehend)",
          "zh": "Placa de Xisto Polido Grande em Pé",
          "ja": "Large Standing Ashlar Shale Sign"
        },
        {
          "id": "LargeStandingAshlarSandstoneSignItem",
          "en": "Large Standing Ashlar Sandstone Sign",
          "fr": "Grand panneau sur pied en grès taillé",
          "es": "Letrero grande (sillar de arenisca)",
          "de": "Steinquaderschild aus Sandstein (Groß",
          "pt": "대형 각진 사암 현판",
          "it": "Большая табличка из резного песчаника",
          "tr": "Large Standing Ashlar Sandstone Sign",
          "pl": "Large Standing Ashlar Sandstone Sign",
          "ru": "大型立方琢砂岩标志",
          "uk": "Large Standing Ashlar Sandstone Sign",
          "ko": " stehend)",
          "zh": "Placa de Arenito Polido Grande em Pé",
          "ja": "Large Standing Ashlar Sandstone Sign"
        },
        {
          "id": "LargeStandingAshlarLimestoneSignItem",
          "en": "Large Standing Ashlar Limestone Sign",
          "fr": "Grand panneau sur pied en calcaire taillé",
          "es": "Letrero grande (sillar de piedra caliza)",
          "de": "Steinquaderschild aus Kalkstein (Groß",
          "pt": "대형 각진 석회암 현판",
          "it": "Большая табличка из резного известняка",
          "tr": "Large Standing Ashlar Limestone Sign",
          "pl": "Large Standing Ashlar Limestone Sign",
          "ru": "大型立式方琢石灰石标志",
          "uk": "Large Standing Ashlar Limestone Sign",
          "ko": " stehend)",
          "zh": "Placa de Calcário Polido Grande em Pé",
          "ja": "Large Standing Ashlar Limestone Sign"
        },
        {
          "id": "LargeStandingAshlarGraniteSignItem",
          "en": "Large Standing Ashlar Granite Sign",
          "fr": "Grand panneau sur pied en granite taillé",
          "es": "Letrero grande (sillar de granito)",
          "de": "Steinquaderschild aus Granit (Groß",
          "pt": "대형 각진 화강암 현판",
          "it": "Большая табличка из резного гранита",
          "tr": "Large Standing Ashlar Granite Sign",
          "pl": "Large Standing Ashlar Granite Sign",
          "ru": "大型立方琢花岗岩标志",
          "uk": "Large Standing Ashlar Granite Sign",
          "ko": " stehend)",
          "zh": "Placa de Granito Polido Grande em Pé",
          "ja": "Large Standing Ashlar Granite Sign"
        },
        {
          "id": "LargeStandingAshlarGneissSignItem",
          "en": "Large Standing Ashlar Gneiss Sign",
          "fr": "Grand panneau sur pied en gneiss taillé",
          "es": "Letrero grande (sillar de gneis)",
          "de": "Steinquaderschild aus Gneiss (Groß",
          "pt": "대형 각진 편마암 현판",
          "it": "Большая табличка из резного гнейса",
          "tr": "Large Standing Ashlar Gneiss Sign",
          "pl": "Large Standing Ashlar Gneiss Sign",
          "ru": "大型立式方琢片麻岩标志",
          "uk": "Large Standing Ashlar Gneiss Sign",
          "ko": " stehend)",
          "zh": "Placa de Gnaisse Polido Grande em Pé",
          "ja": "Large Standing Ashlar Gneiss Sign"
        },
        {
          "id": "LargeStandingAshlarBasaltSignItem",
          "en": "Large Standing Ashlar Basalt Sign",
          "fr": "Grand panneau sur pied en basalte taillé",
          "es": "Letrero grande (sillar de basalto)",
          "de": "Steinquaderschild aus Basalt (Groß",
          "pt": "대형 각진 현무암 현판",
          "it": "Большая табличка из резного базальта",
          "tr": "Large Standing Ashlar Basalt Sign",
          "pl": "Large Standing Ashlar Basalt Sign",
          "ru": "大型立式石拉玄武岩标志",
          "uk": "Large Standing Ashlar Basalt Sign",
          "ko": " stehend)",
          "zh": "Placa de Basalto Polido Grande em Pé",
          "ja": "Large Standing Ashlar Basalt Sign"
        },
        {
          "id": "LargeHangingMortaredStoneSignItem",
          "en": "Large Hanging Mortared Stone Sign",
          "fr": "Grand panneau suspendu en pierre cimentée",
          "es": "Letrero colgante grande (piedra con mortero)",
          "de": "Steinziegelschild (Groß",
          "pt": "대형 모르타르 마감 석재 현판",
          "it": "Большая вывеска из строительного камня",
          "tr": "Large Hanging Mortared Stone Sign",
          "pl": "Large Hanging Mortared Stone Sign",
          "ru": "大型悬挂砂浆石标志",
          "uk": "Large Hanging Mortared Stone Sign",
          "ko": " hängend)",
          "zh": "Placa de Pedra Argamassada Grande Pendurada",
          "ja": "Large Hanging Mortared Stone Sign"
        },
        {
          "id": "LargeHangingMortaredSandstoneSignItem",
          "en": "Large Hanging Mortared Sandstone Sign",
          "fr": "Grand panneau suspendu en grès cimenté",
          "es": "Letrero colgante grande (arenisca con mortero)",
          "de": "Steinziegelschild aus Sandstein (Groß",
          "pt": "대형 모르타르 마감 사암 현판",
          "it": "Большая вывеска из строительного песчаника",
          "tr": "Large Hanging Mortared Sandstone Sign",
          "pl": "Large Hanging Mortared Sandstone Sign",
          "ru": "大型悬挂砂浆砂岩标志",
          "uk": "Large Hanging Mortared Sandstone Sign",
          "ko": " hängend)",
          "zh": "Placa de Arenito Argamassado Grande Pendurada",
          "ja": "Large Hanging Mortared Sandstone Sign"
        },
        {
          "id": "LargeHangingMortaredLimestoneSignItem",
          "en": "Large Hanging Mortared Limestone Sign",
          "fr": "Grand panneau suspendu en calcaire cimenté",
          "es": "Letrero colgante grande (piedra caliza con mortero)",
          "de": "Steinziegelschild aus Kalkstein (Groß",
          "pt": "대형 모르타르 마감 석회암 현판",
          "it": "Большая вывеска из строительного известняка",
          "tr": "Large Hanging Mortared Limestone Sign",
          "pl": "Large Hanging Mortared Limestone Sign",
          "ru": "大型悬挂砂浆石灰石标志",
          "uk": "Large Hanging Mortared Limestone Sign",
          "ko": " hängend)",
          "zh": "Placa de Calcário Argamassado Grande Pendurada",
          "ja": "Large Hanging Mortared Limestone Sign"
        },
        {
          "id": "LargeHangingMortaredGraniteSignItem",
          "en": "Large Hanging Mortared Granite Sign",
          "fr": "Grand panneau suspendu en granite cimenté",
          "es": "Letrero colgante grande (granito con mortero)",
          "de": "Steinziegelschild aus Granit (Groß",
          "pt": "대형 모르타르 마감 화강암 현판",
          "it": "Большая вывеска из строительного гранита",
          "tr": "Large Hanging Mortared Granite Sign",
          "pl": "Large Hanging Mortared Granite Sign",
          "ru": "大型悬挂砂浆花岗岩标志",
          "uk": "Large Hanging Mortared Granite Sign",
          "ko": " hängend)",
          "zh": "Placa de Granito Argamassado Grande Pendurada",
          "ja": "Large Hanging Mortared Granite Sign"
        },
        {
          "id": "LargeHangingAshlarStoneSignItem",
          "en": "Large Hanging Ashlar Stone Sign",
          "fr": "Grand panneau suspendu en pierre taillée",
          "es": "Letrero colgante grande (sillar de piedra)",
          "de": "Steinquaderschild (Groß",
          "pt": "대형 각진 석재 현판",
          "it": "Большая вывеска из резного камня",
          "tr": "Large Hanging Ashlar Stone Sign",
          "pl": "Large Hanging Ashlar Stone Sign",
          "ru": "大型吊石板标志",
          "uk": "Large Hanging Ashlar Stone Sign",
          "ko": " hängend)",
          "zh": "Placa de Pedra Polida Grande Pendurada",
          "ja": "Large Hanging Ashlar Stone Sign"
        },
        {
          "id": "LargeHangingAshlarShaleSignItem",
          "en": "Large Hanging Ashlar Shale Sign",
          "fr": "Grand panneau suspendu en schiste taillé",
          "es": "Letrero colgante grande (sillar de pizarra)",
          "de": "Steinquaderschild aus Schiefer (Groß",
          "pt": "대형 각진 이판암 현판",
          "it": "Большая вывеска из резного сланца",
          "tr": "Large Hanging Ashlar Shale Sign",
          "pl": "Large Hanging Ashlar Shale Sign",
          "ru": "大型悬挂方琢页岩标志",
          "uk": "Large Hanging Ashlar Shale Sign",
          "ko": " hängend)",
          "zh": "Placa de Xisto Polido Grande Pendurada",
          "ja": "Large Hanging Ashlar Shale Sign"
        },
        {
          "id": "LargeHangingAshlarSandstoneSignItem",
          "en": "Large Hanging Ashlar Sandstone Sign",
          "fr": "Grand panneau suspendu en grès taillé",
          "es": "Letrero colgante grande (sillar de arenisca)",
          "de": "Steinquaderschild aus Sandstein (Groß",
          "pt": "대형 각진 사암 현판",
          "it": "Большая вывеска из резного песчаника",
          "tr": "Large Hanging Ashlar Sandstone Sign",
          "pl": "Large Hanging Ashlar Sandstone Sign",
          "ru": "大型悬挂石板砂岩标志",
          "uk": "Large Hanging Ashlar Sandstone Sign",
          "ko": " hängend)",
          "zh": "Placa de Arenito Polido Grande Pendurada",
          "ja": "Large Hanging Ashlar Sandstone Sign"
        },
        {
          "id": "LargeHangingAshlarLimestoneSignItem",
          "en": "Large Hanging Ashlar Limestone Sign",
          "fr": "Grand panneau suspendu en calcaire taillé",
          "es": "Letrero colgante grande (sillar de piedra caliza)",
          "de": "Steinquaderschild aus Kalkstein (Groß",
          "pt": "대형 각진 석회암 현판",
          "it": "Большая вывеска из резного известняка",
          "tr": "Large Hanging Ashlar Limestone Sign",
          "pl": "Large Hanging Ashlar Limestone Sign",
          "ru": "大型悬挂方琢石灰石标志",
          "uk": "Large Hanging Ashlar Limestone Sign",
          "ko": " hängend)",
          "zh": "Placa de Calcário Polido Grande Pendurada",
          "ja": "Large Hanging Ashlar Limestone Sign"
        },
        {
          "id": "LargeHangingAshlarGraniteSignItem",
          "en": "Large Hanging Ashlar Granite Sign",
          "fr": "Grand panneau suspendu en granite taillé",
          "es": "Letrero colgante grande (sillar de granito)",
          "de": "Steinquaderschild aus Granit (Groß",
          "pt": "대형 각진 화강암 현판",
          "it": "Большая вывеска из резного гранита",
          "tr": "Large Hanging Ashlar Granite Sign",
          "pl": "Large Hanging Ashlar Granite Sign",
          "ru": "大型悬挂石板花岗岩标志",
          "uk": "Large Hanging Ashlar Granite Sign",
          "ko": " hängend)",
          "zh": "Placa de Granito Polido Grande Pendurada",
          "ja": "Large Hanging Ashlar Granite Sign"
        },
        {
          "id": "LargeHangingAshlarGneissSignItem",
          "en": "Large Hanging Ashlar Gneiss Sign",
          "fr": "Grand panneau suspendu en gneiss taillé",
          "es": "Letrero colgante grande (sillar de gneis)",
          "de": "Steinquaderschild aus Gneiss (Groß",
          "pt": "대형 각진 편마암 현판",
          "it": "Большая вывеска из резного гнейса",
          "tr": "Large Hanging Ashlar Gneiss Sign",
          "pl": "Large Hanging Ashlar Gneiss Sign",
          "ru": "大型悬挂方琢片麻岩标志",
          "uk": "Large Hanging Ashlar Gneiss Sign",
          "ko": " hängend)",
          "zh": "Placa de Gnaisse Polido Grande Pendurada",
          "ja": "Large Hanging Ashlar Gneiss Sign"
        },
        {
          "id": "LargeHangingAshlarBasaltSignItem",
          "en": "Large Hanging Ashlar Basalt Sign",
          "fr": "Grand panneau suspendu en basalte taillé",
          "es": "Letrero colgante grande (sillar de basalto)",
          "de": "Steinquaderschild aus Basalt (Groß",
          "pt": "대형 각진 현무암 현판",
          "it": "Большая вывеска из резного базальта",
          "tr": "Large Hanging Ashlar Basalt Sign",
          "pl": "Large Hanging Ashlar Basalt Sign",
          "ru": "大型悬挂方琢玄武岩标志",
          "uk": "Large Hanging Ashlar Basalt Sign",
          "ko": " hängend)",
          "zh": "Placa de Basalto Polido Grande Pendurada",
          "ja": "Large Hanging Ashlar Basalt Sign"
        },
        {
          "id": "GoatMountItem",
          "en": "Goat Mount",
          "fr": "Trophée de chèvre des montagnes",
          "es": "Montura para cabra",
          "de": "Ausgestopfte Bergziege",
          "pt": "Cabeça de Cabra",
          "it": "Capra",
          "tr": "Keçi Binek",
          "pl": "Kozia Góra",
          "ru": "Голова козы",
          "uk": "Голова кози",
          "ko": "박제된 염소 벽걸이",
          "zh": "山羊山",
          "ja": "Goat Mount"
        },
        {
          "id": "BathtubItem",
          "en": "Bathtub",
          "fr": "Baignoire",
          "es": "Bañera",
          "de": "Badewanne",
          "pt": "Banheira",
          "it": "Vasca da Bagno",
          "tr": "Banyo",
          "pl": "Wanna",
          "ru": "Ванна",
          "uk": "Ванна",
          "ko": "욕조",
          "zh": "浴缸",
          "ja": "Bathtub"
        },
        {
          "id": "AshlarStoneDoorItem",
          "en": "Ashlar Stone Door",
          "fr": "Porte en pierre taillée",
          "es": "Puerta (sillar de piedra)",
          "de": "Quadersteintür",
          "pt": "Porta de Pedra Polida",
          "it": "Porta di Pietra Bugnata",
          "tr": "Kesme Taştan Kapı",
          "pl": "Drzwi z ciosanego kamienia",
          "ru": "Дверь из резного камня",
          "uk": "Двері з обтесаного каменю",
          "ko": "각진 석재 문",
          "zh": "方琢石门",
          "ja": "切石のドア"
        },
        {
          "id": "AshlarShaleDoorItem",
          "en": "Ashlar Shale Door",
          "fr": "Porte en schiste taillé",
          "es": "Puerta de pizarra (sillar)",
          "de": "Schieferquadertür",
          "pt": "Porta de Xisto Polido",
          "it": "Porta in Scisto Bugnato",
          "tr": "Kesme Kilden Kapı",
          "pl": "Drzwi z ciosanego łupka",
          "ru": "Дверь из резного сланца",
          "uk": "Двері з обтесаного сланцю",
          "ko": "각진 이판암 문",
          "zh": "方琢页岩门",
          "ja": "頁岩の切石のドア"
        },
        {
          "id": "AshlarSandstoneDoorItem",
          "en": "Ashlar Sandstone Door",
          "fr": "Porte en grès taillé",
          "es": "Puerta (sillar de arenisca)",
          "de": "Sandsteinquadertür",
          "pt": "Porta de Arenito Polido",
          "it": "Porta in Arenaria Bugnata",
          "tr": "Kesme Kumtaşından Kapı",
          "pl": "Drzwi z ciosanego piaskowca",
          "ru": "Дверь из резного песчаника",
          "uk": "Двері з обтесаного піщаника",
          "ko": "각진 사암 문",
          "zh": "方琢砂岩门",
          "ja": "砂岩の切石のドア"
        },
        {
          "id": "AshlarLimestoneDoorItem",
          "en": "Ashlar Limestone Door",
          "fr": "Porte en calcaire taillé",
          "es": "Puerta (sillar de piedra caliza)",
          "de": "Kalksteinquadertür",
          "pt": "Porta de Calcário Polido",
          "it": "Porta in Calcare Bugnato",
          "tr": "Kesme Kireç Taşından Kapı",
          "pl": "Drzwi z ciosanego wapienia",
          "ru": "Дверь из резного известняка",
          "uk": "Двері з обтесаного вапняку",
          "ko": "각진 석회암 문",
          "zh": "方琢石灰石门",
          "ja": "石灰岩の切石のドア"
        },
        {
          "id": "AshlarGraniteDoorItem",
          "en": "Ashlar Granite Door",
          "fr": "Porte en granite taillé",
          "es": "Puerta (sillar de granito)",
          "de": "Granitquadertür",
          "pt": "Porta de Granito Polido",
          "it": "Porta in Granito Bugnato",
          "tr": "Kesme Granit Kapı",
          "pl": "Drzwi z ciosanego granitu",
          "ru": "Дверь из резного гранита",
          "uk": "Двері з обтесаного граніту",
          "ko": "각진 화강암 문",
          "zh": "方琢花岗岩门",
          "ja": "花崗岩の切石のドア"
        },
        {
          "id": "AshlarGneissDoorItem",
          "en": "Ashlar Gneiss Door",
          "fr": "Porte en gneiss taillé",
          "es": "Puerta (sillar de gneis)",
          "de": "Gneisquadertür",
          "pt": "Porta de Gnaisse Polido",
          "it": "Porta in Gneiss Bugnato",
          "tr": "Kesme Gnays Kapı",
          "pl": "Drzwi z ciosanego gnejsu",
          "ru": "Дверь из резного гнейса",
          "uk": "Двері з обтесаного гнейсу",
          "ko": "각진 편마암 문",
          "zh": "方琢片麻岩门",
          "ja": "片麻岩の切石のドア"
        },
        {
          "id": "AshlarBasaltDoorItem",
          "en": "Ashlar Basalt Door",
          "fr": "Porte en basalte taillé",
          "es": "Puerta (sillar de basalto)",
          "de": "Basaltquadertür",
          "pt": "Porta de Basalto Polido",
          "it": "Porta in Basalto Bugnato",
          "tr": "Kesme Bazalttan Kapı",
          "pl": "Drzwi z ciosanego bazaltu",
          "ru": "Дверь из резного базальта",
          "uk": "Двері з обтесаного базальту",
          "ko": "각진 현무암 문",
          "zh": "方琢玄武岩门",
          "ja": "玄武岩の切石のドア"
        },
        {
          "id": "WoodenBowItem",
          "en": "Wooden Bow",
          "fr": "Arc en bois",
          "es": "Arco de madera",
          "de": "Holzbogen",
          "pt": "Arco de Madeira",
          "it": "Arco di Legno",
          "tr": "Ahşap Yay",
          "pl": "Drewniany łuk",
          "ru": "Деревянный лук",
          "uk": "Дерев\u0027яний лук",
          "ko": "나무 활",
          "zh": "木弓",
          "ja": "木の弓"
        },
        {
          "id": "SmallCarcass",
          "en": "Small Carcass",
          "fr": "Petit cadavre",
          "es": "Cadáver pequeño",
          "de": "Kleiner Kadaver",
          "pt": "Carcaça Pequena",
          "it": "Piccola Carcassa",
          "tr": "Küçük Ceset",
          "pl": "Mała tusza",
          "ru": "Маленькая Туша",
          "uk": "Мала туша",
          "ko": "작은 사체",
          "zh": "小型遗骸",
          "ja": "Small Carcass"
        },
        {
          "id": "TinyCarcass",
          "en": "Tiny Carcass",
          "fr": "Minuscule cadavre",
          "es": "Cadáver minúsculo",
          "de": "Winziger Kadaver",
          "pt": "Carcaça Minúscula",
          "it": "Carcassa Minuscola",
          "tr": "Ufak Ceset",
          "pl": "Malutka tusza",
          "ru": "Крошечная Туша",
          "uk": "Крихітна туша",
          "ko": "칠면조 사체",
          "zh": "微型遗骸",
          "ja": "Tiny Carcass"
        },
        {
          "id": "NaturalFiber",
          "en": "Natural Fiber",
          "fr": "Fibre naturelle",
          "es": "Fibra natural",
          "de": "Naturfaser",
          "pt": "Fibra Natural",
          "it": "Fibra Naturale",
          "tr": "Doğal Lif",
          "pl": "Naturalne włókno",
          "ru": "Натуральное волокно",
          "uk": "Природні волокна",
          "ko": "천연 섬유",
          "zh": "天然纤维",
          "ja": "天然繊維"
        },
        {
          "id": "NailItem",
          "en": "Nail",
          "fr": "Clou",
          "es": "Clavo",
          "de": "Nagel",
          "pt": "Prego",
          "it": "Chiodo",
          "tr": "Çivi",
          "pl": "Gwóźdź",
          "ru": "Гвоздь",
          "uk": "Цвях",
          "ko": "못",
          "zh": "钉",
          "ja": "Nail"
        },
        {
          "id": "MediumCarcass",
          "en": "Medium Carcass",
          "fr": "Cadavre moyen",
          "es": "Cadáver mediano",
          "de": "Mittelgroßer Kadaver",
          "pt": "Carcaça Média",
          "it": "Carcassa Media",
          "tr": "Orta Büyüklükte Ceset",
          "pl": "Średnia tusza",
          "ru": "Средняя Туша",
          "uk": "Середня туша",
          "ko": "중간 사체",
          "zh": "中型遗骸",
          "ja": "Medium Carcass"
        },
        {
          "id": "MetallurgyResearchPaperBasicItem",
          "en": "Metallurgy Research Paper Basic",
          "fr": "Papier de recherche : Métallurgie basique",
          "es": "Trabajo de investigación en metalurgia (básico)",
          "de": "Grundlegendes Forschungspapier: Metallurgie",
          "pt": "Documento de Pesquisa Básico de Metalurgia",
          "it": "Documento di Ricerca Base di Metallurgia",
          "tr": "Madencilik Araştırma Makalesi Temeller",
          "pl": "Podstawowy artykuł badawczy Metalurgii",
          "ru": "Исследование по базовой металлургии",
          "uk": "Дослідження базової металургії",
          "ko": "기초 금속공학 연구지",
          "zh": "基础冶金研究论文",
          "ja": "精錬の基礎研究書"
        },
        {
          "id": "BasicResearch",
          "en": "Basic Research",
          "fr": "Recherche Basique",
          "es": "Investigación básica",
          "de": "Grundlagenforschung",
          "pt": "Pesquisa Básica",
          "it": "Ricerca di Base",
          "tr": "Temel Araştırma",
          "pl": "Podstawowe badanie",
          "ru": "Базовое исследование",
          "uk": "Базове дослідження",
          "ko": "기초 연구",
          "zh": "基础研究",
          "ja": "基礎的な研究"
        },
        {
          "id": "MetallurgyResearchPaperAdvancedItem",
          "en": "Metallurgy Research Paper Advanced",
          "fr": "Papier de recherche : Métallurgie avancée",
          "es": "Trabajo de investigación en metalurgia (avanzado)",
          "de": "Fortgeschrittenes Forschungspapier: Metallurgie",
          "pt": "Documento de Pesquisa Avançado de Metalurgia",
          "it": "Documento di Ricerca Avanzato di Metallurgia",
          "tr": "Madencilik Araştırma Makalesi İleri Seviye",
          "pl": "Zaawansowany artykuł badawczy Metalurgii",
          "ru": "Исследование по продвинутой металлургии",
          "uk": "Дослідження вдосконаленої металургії",
          "ko": "고급 금속공학 연구지",
          "zh": "高级冶金研究论文",
          "ja": "精錬の応用研究書"
        },
        {
          "id": "ModernResearch",
          "en": "Modern Research",
          "fr": "Recherche moderne",
          "es": "Investigación moderna",
          "de": "Moderne Forschung",
          "pt": "Pesquisa Moderna",
          "it": "Ricerca Moderna",
          "tr": "Modern Araştırma",
          "pl": "Nowoczesne badanie",
          "ru": "Современное исследование",
          "uk": "Сучасне дослідження",
          "ko": "현대 연구",
          "zh": "现代研究",
          "ja": "近代的な研究"
        },
        {
          "id": "GeologyResearchPaperModernItem",
          "en": "Geology Research Paper Modern",
          "fr": "Papier de recherche : Géologie moderne",
          "es": "Trabajo de investigación en geología (moderno)",
          "de": "Modernes Forschungspapier: Geologie",
          "pt": "Documento de Pesquisa Moderno de Geologia",
          "it": "Documento di Ricerca Moderno di Geologia",
          "tr": "Yer Bilimi Araştırma Makalesi Modern",
          "pl": "Nowoczesny artykuł badawczy Geologii",
          "ru": "Исследование по современной геологии",
          "uk": "Дослідження сучасної геології",
          "ko": "현대식 지질학 연구지",
          "zh": "现代地质学研究论文",
          "ja": "地質学の最先端研究書"
        },
        {
          "id": "GeologyResearchPaperBasicItem",
          "en": "Geology Research Paper Basic",
          "fr": "Papier de recherche : Géologie basique",
          "es": "Trabajo de investigación en geología (básico)",
          "de": "Grundlegendes Forschungspapier: Geologie",
          "pt": "Documento de Pesquisa Básico de Geologia",
          "it": "Documento di Ricerca Base di Geologia",
          "tr": "Yer Bilimi Araştırma Makalesi Temeller",
          "pl": "Podstawowy artykuł badawczy Geologii",
          "ru": "Исследование по базовой геологии",
          "uk": "Дослідження базової геології",
          "ko": "기초 지질학 연구지",
          "zh": "基础地质学研究论文",
          "ja": "地質学の基礎研究書"
        },
        {
          "id": "GeologyResearchPaperAdvancedItem",
          "en": "Geology Research Paper Advanced",
          "fr": "Papier de recherche : Géologie avancée",
          "es": "Trabajo de investigación en geología (avanzado)",
          "de": "Fortgeschrittenes Forschungspapier: Geologie",
          "pt": "Documento de Pesquisa Avançado de Geologia",
          "it": "Documento di Ricerca Avanzato di Geologia",
          "tr": "Yer Bilimi Araştırma Makalesi İleri Seviye",
          "pl": "Zaawansowany artykuł badawczy Geologii",
          "ru": "Исследование по продвинутой геологии",
          "uk": "Дослідження вдосконаленої геології",
          "ko": "고급 지질학 연구지",
          "zh": "高级地质学研究论文",
          "ja": "地質学の応用研究書"
        },
        {
          "id": "AdvancedResearch",
          "en": "Advanced Research",
          "fr": "Recherche avancée",
          "es": "Investigación avanzada",
          "de": "Fortgeschrittene Forschung",
          "pt": "Pesquisa Avançada",
          "it": "Ricerca Avanzata",
          "tr": "İleri Seviye Araştırma",
          "pl": "Zaawansowane badanie",
          "ru": "Продвинутое исследование",
          "uk": "Вдосконалене дослідження",
          "ko": "고급 연구",
          "zh": "高级研究",
          "ja": "応用的な研究"
        },
        {
          "id": "GatheringResearchPaperBasicItem",
          "en": "Gathering Research Paper Basic",
          "fr": "Papier de recherche : Récolte basique",
          "es": "Trabajo de investigación en recolección (básico)",
          "de": "Grundlegendes Forschungspapier: Sammeln",
          "pt": "Documento de Pesquisa Básico de Coleta",
          "it": "Documento di Ricerca Base di Raccolta",
          "tr": "Toplayıcılık Araştırma Makalesi Temeller",
          "pl": "Podstawowy artykuł badawczy Zbieractwa",
          "ru": "Исследование по базовому собирательству",
          "uk": "Базове дослідження збирання",
          "ko": "기초 채집 연구지",
          "zh": "基础收集研究论文",
          "ja": "採集の基礎研究書"
        },
        {
          "id": "EngineeringResearchPaperModernItem",
          "en": "Engineering Research Paper Modern",
          "fr": "Papier de recherche : Ingénierie moderne",
          "es": "Trabajo de investigación en ingeniería (moderno)",
          "de": "Modernes Forschungspapier: Ingenieurswesen",
          "pt": "Documento de Pesquisa Moderno de Engenharia",
          "it": "Documento di Ricerca Moderno di Ingegneria",
          "tr": "Mühendislik Araştırma Makalesi Modern",
          "pl": "Nowoczesny artykuł badawczy Inżynierii",
          "ru": "Исследование по современному инженерному делу",
          "uk": "Дослідження сучасної інженерії",
          "ko": "현대식 기계공학 연구지",
          "zh": "现代工程学研究论文",
          "ja": "工学の最先端研究書"
        },
        {
          "id": "EngineeringResearchPaperAdvancedItem",
          "en": "Engineering Research Paper Advanced",
          "fr": "Papier de recherche : Ingénierie avancée",
          "es": "Trabajo de investigación en ingeniería (avanzado)",
          "de": "Fortgeschrittenes Forschungspapier: Ingenieurswesen",
          "pt": "Documento de Pesquisa Avançado de Engenharia",
          "it": "Documento di Ricerca Avanzato di Ingegneria",
          "tr": "Mühendislik Araştırma Makalesi İleri Seviye",
          "pl": "Zaawansowany artykuł badawczy Inżynierii",
          "ru": "Исследование по продвинутому инженерному делу",
          "uk": "Дослідження вдосконаленої інженерії",
          "ko": "고급 기계공학 연구지",
          "zh": "高级工程学研究论文",
          "ja": "工学の応用研究書"
        },
        {
          "id": "DendrologyResearchPaperModernItem",
          "en": "Dendrology Research Paper Modern",
          "fr": "Papier de recherche : Dendrologie moderne",
          "es": "Trabajo de investigación en dendrología (moderno)",
          "de": "Modernes Forschungspapier: Dendrologie",
          "pt": "Documento de Pesquisa Moderno de Dendrologia",
          "it": "Documento di Ricerca Moderno di Dendrologia",
          "tr": "Ağaç Bilimi Araştırma Makalesi Modern",
          "pl": "Nowoczesny artykuł badawczy Dendrologii",
          "ru": "Исследование по современной дендрологии",
          "uk": "Дослідження сучасної дендрології",
          "ko": "현대식 산림학 연구지",
          "zh": "现代树木学研究论文",
          "ja": "樹木学の最先端研究書"
        },
        {
          "id": "DendrologyResearchPaperBasicItem",
          "en": "Dendrology Research Paper Basic",
          "fr": "Papier de recherche : Dendrologie basique",
          "es": "Trabajo de investigación en dendrología (básico)",
          "de": "Grundlegendes Forschungspapier: Dendrologie",
          "pt": "Documento de Pesquisa Básico de Dendrologia",
          "it": "Documento di Ricerca Base di Dendrologia",
          "tr": "Ağaç Bilimi Araştırma Makalesi Temeller",
          "pl": "Podstawowy artykuł badawczy Drzewoznawstwa",
          "ru": "Исследование по базовой дендрологии",
          "uk": "Дослідження базової дендрології",
          "ko": "기초 산림학 연구지",
          "zh": "基础树木学研究论文",
          "ja": "樹木学の基礎研究書"
        },
        {
          "id": "DendrologyResearchPaperAdvancedItem",
          "en": "Dendrology Research Paper Advanced",
          "fr": "Papier de recherche : Dendrologie avancée",
          "es": "Trabajo de investigación en dendrología (avanzado)",
          "de": "Fortgeschrittenes Forschungspapier: Dendrologie",
          "pt": "Documento de Pesquisa Avançado de Dendrologia",
          "it": "Documento di Ricerca Avanzato di Dendrologia",
          "tr": "Ağaç Bilimi Araştırma Makalesi İleri Seviye",
          "pl": "Zaawansowany artykuł badawczy Drzewoznawstwa",
          "ru": "Исследование по продвинутой дендрологии",
          "uk": "Дослідження вдосконаленої дендрології",
          "ko": "고급 산림학 연구지",
          "zh": "高级树木学研究论文",
          "ja": "樹木学の応用研究書"
        },
        {
          "id": "CulinaryResearchPaperModernItem",
          "en": "Culinary Research Paper Modern",
          "fr": "Papier de recherche : Culinaire moderne",
          "es": "Trabajo de investigación culinaria (moderno)",
          "de": "Modernes Forschungspapier: Kochkunst",
          "pt": "Documento de Pesquisa Moderno de Culinária",
          "it": "Documento di Ricerca Moderno di Culinaria",
          "tr": "Aşçılık Araştırma Makalesi Modern",
          "pl": "Nowoczesny artykuł badawczy Kulinariów",
          "ru": "Исследование по современной кулинарии",
          "uk": "Дослідження сучасної кулінарії",
          "ko": "현대식 요리 연구지",
          "zh": "现代烹饪研究论文",
          "ja": "料理の最先端研究書"
        },
        {
          "id": "CulinaryResearchPaperBasicItem",
          "en": "Culinary Research Paper Basic",
          "fr": "Papier de recherche : Culinaire basique",
          "es": "Trabajo de investigación culinaria (básico)",
          "de": "Grundlegendes Forschungspapier: Kochkunst",
          "pt": "Documento de Pesquisa Básico de Culinária",
          "it": "Documento di Ricerca Base di Culinaria",
          "tr": "Aşçılık Araştırma Makalesi Temeller",
          "pl": "Podstawowy papier badawczy Kulinariów",
          "ru": "Исследование по базовой кулинарии",
          "uk": "Дослідження базової кулінарії",
          "ko": "기초 요리 연구지",
          "zh": "基础烹饪研究论文",
          "ja": "料理の基礎研究書"
        },
        {
          "id": "CulinaryResearchPaperAdvancedItem",
          "en": "Culinary Research Paper Advanced",
          "fr": "Papier de recherche : Culinaire avancé",
          "es": "Trabajo de investigación culinaria (avanzado)",
          "de": "Fortgeschrittenes Forschungspapier: Kochkunst",
          "pt": "Documento de Pesquisa Avançado de Culinária",
          "it": "Documento di Ricerca Avanzato di Culinaria",
          "tr": "Aşçılık Araştırma Makalesi İleri Seviye",
          "pl": "Zaawansowany papier badawczy Kulinarii",
          "ru": "Исследование по продвинутой кулинарии",
          "uk": "Дослідження вдосконаленої кулінарії",
          "ko": "고급 요리 연구지",
          "zh": "高级烹饪研究论文",
          "ja": "料理の応用研究書"
        },
        {
          "id": "BasicCircuitItem",
          "en": "Basic Circuit",
          "fr": "Circuit basique",
          "es": "Circuito básico",
          "de": "Einfacher Schaltkreis",
          "pt": "Circuito Básico",
          "it": "Circuito di Base",
          "tr": "Basit Devre",
          "pl": "Podstawowy obwód",
          "ru": "Базовая электросхема",
          "uk": "Базова електросхема",
          "ko": "기초 회로",
          "zh": "基础电路",
          "ja": "Basic Circuit"
        },
        {
          "id": "AgricultureResearchPaperModernItem",
          "en": "Agriculture Research Paper Modern",
          "fr": "Papier de recherche : Agriculture moderne",
          "es": "Trabajo de investigación en agricultura (moderno)",
          "de": "Modernes Forschungspapier: Landwirtschaft",
          "pt": "Documento de Pesquisa Moderno de Agricultura",
          "it": "Documento di Ricerca Moderno di Agricoltura",
          "tr": "Tarımcılık Araştırma Makalesi Modern",
          "pl": "Nowoczesny artykuł badawczy Agrokultury",
          "ru": "Исследование по современному сельскому хозяйству",
          "uk": "Дослідження сучасного сільського господарства",
          "ko": "현대식 농업 연구지",
          "zh": "现代农业研究论文",
          "ja": "農業の最先端研究書"
        },
        {
          "id": "AgricultureResearchPaperAdvancedItem",
          "en": "Agriculture Research Paper Advanced",
          "fr": "Papier de recherche : Agriculture avancée",
          "es": "Trabajo de investigación en agricultura (avanzado)",
          "de": "Fortgeschrittenes Forschungspapier: Landwirtschaft",
          "pt": "Documento de Pesquisa Avançado de Agricultura",
          "it": "Documento di Ricerca Avanzato di Agricoltura",
          "tr": "Tarımcılık Araştırma Makalesi İleri Seviye",
          "pl": "Zaawansowany artykuł badawczy Agrokultury",
          "ru": "Исследование по продвинутому сельскому хозяйству",
          "uk": "Дослідження вдосконаленого сільського господарства",
          "ko": "고급 농업 연구지",
          "zh": "高级农业研究论文",
          "ja": "農業の応用研究書"
        },
        {
          "id": "ShortsItem",
          "en": "Shorts",
          "fr": "Short",
          "es": "Pantalones cortos",
          "de": "Kurze Hose",
          "pt": "Bermuda",
          "it": "Pantaloncini",
          "tr": "Kısa Pantalon",
          "pl": "Spodenki",
          "ru": "Шорты",
          "uk": "Шорти",
          "ko": "반바지",
          "zh": "短裤",
          "ja": "Shorts"
        },
        {
          "id": "ClothCapeItem",
          "en": "Cloth Cape",
          "fr": "Cape en tissu",
          "es": "Capa de tela",
          "de": "Stoffumhang",
          "pt": "Capa de Tecido",
          "it": "Mantello di Stoffa",
          "tr": "Kumaş Pelerin",
          "pl": "Płaszcz z tkaniny",
          "ru": "Тканевая накидка",
          "uk": "Тканинна накидка",
          "ko": "천 망토",
          "zh": "布斗篷",
          "ja": "Cloth Cape"
        },
        {
          "id": "ClothBeltItem",
          "en": "Cloth Belt",
          "fr": "Ceinture en tissu",
          "es": "Cinturón de tela",
          "de": "Gürtel",
          "pt": "Cinto de Tecido",
          "it": "Cintura di Tessuto",
          "tr": "Kumaş Kemer",
          "pl": "Bluza na pasie",
          "ru": "Тканый пояс",
          "uk": "Тканинний ремінь",
          "ko": "천 벨트",
          "zh": "布带",
          "ja": "Cloth Belt"
        },
        {
          "id": "BandanaItem",
          "en": "Bandana",
          "fr": "Bandana",
          "es": "Bandana",
          "de": "Bandana",
          "pt": "Bandana",
          "it": "Bandana",
          "tr": "Bandana",
          "pl": "Bandana",
          "ru": "Бандана",
          "uk": "Бандана",
          "ko": "반다나",
          "zh": "头巾",
          "ja": "Bandana"
        },
        {
          "id": "LumberStockpileItem",
          "en": "Lumber Stockpile",
          "fr": "Réserve en bois d\u0027œuvre",
          "es": "Pila de almacenamiento para troncos",
          "de": "Bauholzlager",
          "pt": "Estoque em pilha de madeira serrada",
          "it": "Pila di Legname",
          "tr": "Keresteden Stok Yeri",
          "pl": "Skład drewna",
          "ru": "Склад из пиломатериалов",
          "uk": "Склад з пиломатеріалів",
          "ko": "가공목 자재창고",
          "zh": "木制料堆",
          "ja": "Lumber Stockpile"
        },
        {
          "id": "LargeLumberStockpileItem",
          "en": "Large Lumber Stockpile",
          "fr": "Réserve de grande taille en bois d\u0027oeuvre",
          "es": "Pila grande de troncos",
          "de": "Bauholzlager (Groß)",
          "pt": "Estoque em pilha grande de madeira serrada",
          "it": "Grande Pila di Legname",
          "tr": "Keresteden Geniş Stok Yeri",
          "pl": "Duży Skład Drewna",
          "ru": "Большой склад из пиломатериалов",
          "uk": "Великий склад з пиломатеріалів",
          "ko": "대형 가공목 자재 창고",
          "zh": "大型木制料堆",
          "ja": "Large Lumber Stockpile"
        },
        {
          "id": "HewnDoorItem",
          "en": "Hewn Door",
          "fr": "Porte en rondins taillés",
          "es": "Puerta tallada",
          "de": "Massivholztür",
          "pt": "Porta de Madeira Cortada",
          "it": "Porta Scolpita",
          "tr": "Yontma Odun Kapı",
          "pl": "Ociosane drzwi",
          "ru": "Дверь из обтёсанного дерева",
          "uk": "Двері з обтісаних досок",
          "ko": "다듬은 문",
          "zh": "凿门",
          "ja": "丸太材のドア"
        },
        {
          "id": "SmeltingUpgradeItem",
          "en": "Smelting Upgrade",
          "fr": "Amélioration avancée : Fonte",
          "es": "Mejora: Fundición",
          "de": "Fortgeschrittenes Upgrade: Schmelzen",
          "pt": "Melhoria de Fundição",
          "it": "Aggiornamento Fusione",
          "tr": "Eritmecilik Geliştirmesi",
          "pl": "Ulepszenie Wytapiania",
          "ru": "Улучшение для выплавки",
          "uk": "Покращення виплавки",
          "ko": "제련 업그레이드",
          "zh": "冶炼升级",
          "ja": "製錬アップグレード"
        },
        {
          "id": "PotteryUpgradeItem",
          "en": "Pottery Upgrade",
          "fr": "Amélioration avancée : Poterie",
          "es": "Mejora: Cerámica",
          "de": "Fortgeschrittenes Upgrade: Töpfern",
          "pt": "Melhoria de Cerâmica",
          "it": "Aggiornamento Ceramica",
          "tr": "Çömlekçilik Geliştirmesi",
          "pl": "Ulepszenie Garncarstwa",
          "ru": "Улучшение для гончарного ремесла",
          "uk": "Покращення гончарства",
          "ko": "도기 업그레이드",
          "zh": "陶艺升级",
          "ja": "陶芸アップグレード"
        },
        {
          "id": "PaperMillingUpgradeItem",
          "en": "Paper Milling Upgrade",
          "fr": "Amélioration basique : Production de papier",
          "es": "Mejora: Molienda de papel",
          "de": "Fortgeschrittenes Upgrade: Papierherstellung",
          "pt": "Melhoria de Fabricação de Papel",
          "it": "Aggiornamento Cartiera",
          "tr": "Kağıt İşleme Geliştirmesi",
          "pl": "Ulepszenie Papierni",
          "ru": "Улучшение для производства бумаги",
          "uk": "Покращення виготовлення паперу",
          "ko": "제지 가공 업그레이드",
          "zh": "造纸升级",
          "ja": "紙すきアップグレード"
        },
        {
          "id": "OilDrillingUpgradeItem",
          "en": "Oil Drilling Upgrade",
          "fr": "Amélioration moderne : Forage pétrolier",
          "es": "Mejora: Prospección de petróleo",
          "de": "Modernes Upgrade: Ölgewinnung",
          "pt": "Melhoria de Perfuração de Petróleo",
          "it": "Aggiornamento Trivellazione Petrolifera",
          "tr": "Petrol Çıkarma Geliştirmesi",
          "pl": "Ulepszenie Wydobycia Ropy",
          "ru": "Улучшение для добычи нефти",
          "uk": "Покращення буріння",
          "ko": "유정 굴착 업그레이드",
          "zh": "石油钻探升级",
          "ja": "Oil Drilling Upgrade"
        },
        {
          "id": "MillingUpgradeItem",
          "en": "Milling Upgrade",
          "fr": "Amélioration avancée : Mouture",
          "es": "Mejora: Molienda",
          "de": "Fortschrittliches Upgrade: Mahlen",
          "pt": "Melhoria de Moagem",
          "it": "Aggiornamento Fresatura",
          "tr": "Değirmencilik Geliştirmesi",
          "pl": "Ulepszenie Młynarstwa",
          "ru": "Улучшение для мельничного дела",
          "uk": "Покращення млинарства",
          "ko": "제분 업그레이드",
          "zh": "铣削升级",
          "ja": "Milling Upgrade"
        },
        {
          "id": "IndustryUpgradeItem",
          "en": "Industry Upgrade",
          "fr": "Amélioration moderne : Industrie",
          "es": "Mejora: Industria",
          "de": "Upgrade Industrie",
          "pt": "Melhoria de Indústria",
          "it": "Aggiornamento Industria",
          "tr": "Sanayi Geliştirmesi",
          "pl": "Ulepszenie Przemysłu",
          "ru": "Улучшение для промышленности",
          "uk": "Покращення промисловості",
          "ko": "산업 업그레이드",
          "zh": "产业升级",
          "ja": "Industry Upgrade"
        },
        {
          "id": "FertilizersUpgradeItem",
          "en": "Fertilizers Upgrade",
          "fr": "Amélioration basique : Engrais",
          "es": "Mejora: Fertilizantes",
          "de": "Upgrade Dünger",
          "pt": "Melhoria de Fertilizantes",
          "it": "Aggiornamento Fertilizzanti",
          "tr": "Gübreleme Geliştirmesi",
          "pl": "Ulepszenie Nawozów",
          "ru": "Улучшение для производства удобрений",
          "uk": "Покращення виготовлення добрив",
          "ko": "비료 제조 업그레이드",
          "zh": "肥料升级",
          "ja": "Fertilizers Upgrade"
        },
        {
          "id": "FarmingUpgradeItem",
          "en": "Farming Upgrade",
          "fr": "Amélioration basique : Agriculture",
          "es": "Mejora: Agricultura",
          "de": "Upgrade Landwirtschaft",
          "pt": "Melhoria de Agricultura",
          "it": "Aggiornamento Agricoltura",
          "tr": "Çiftçilik Geliştirmesi",
          "pl": "Moduł modernizacji rolnictwa",
          "ru": "Улучшение для фермерского дела",
          "uk": "Покращення фермерства",
          "ko": "농업 업그레이드",
          "zh": "农业升级",
          "ja": "Farming Upgrade"
        },
        {
          "id": "ElectronicsUpgradeItem",
          "en": "Electronics Upgrade",
          "fr": "Amélioration moderne : Électronique",
          "es": "Mejora: Electrónica",
          "de": "Upgrade Elektronik",
          "pt": "Melhoria de Eletrônica",
          "it": "Aggiornamento Elettronica",
          "tr": "Elektronik Geliştirmesi",
          "pl": "Ulepszenie Elektroniki",
          "ru": "Улучшение для электроники",
          "uk": "Покращення електроніки",
          "ko": "전자공학 업그레이드",
          "zh": "电子升级",
          "ja": "Electronics Upgrade"
        },
        {
          "id": "CuttingEdgeCookingUpgradeItem",
          "en": "Cutting Edge Cooking Upgrade",
          "fr": "Amélioration moderne : Cuisine moléculaire",
          "es": "Mejora: Cocina innovadora",
          "de": "Upgrade Innovatives Kochen",
          "pt": "Melhoria de Cozimento de Ponta",
          "it": "Aggiornamento Cucina d\u0027Avanguardia",
          "tr": "Çağdaş Aşçılık Geliştirmesi",
          "pl": "Ulepszenie Nowoczesnego Gotowania",
          "ru": "Улучшение для передовой кулинарии",
          "uk": "Покращення сучасної кухні",
          "ko": "식품공학 업그레이드",
          "zh": "尖端烹饪升级",
          "ja": "Cutting Edge Cooking Upgrade"
        },
        {
          "id": "CookingUpgradeItem",
          "en": "Cooking Upgrade",
          "fr": "Amélioration avancée : Cuisine",
          "es": "Mejora: Cocina",
          "de": "Fortschrittliches Upgrade: Kochen",
          "pt": "Melhoria de Cozimento",
          "it": "Aggiornamento Cucina",
          "tr": "Aşçılık Geliştirmesi",
          "pl": "Ulepszenie Gotowania",
          "ru": "Улучшение для готовки",
          "uk": "Покращення приготування їжі",
          "ko": "요리 업그레이드",
          "zh": "烹饪升级",
          "ja": "Cooking Upgrade"
        },
        {
          "id": "CompositesUpgradeItem",
          "en": "Composites Upgrade",
          "fr": "Amélioration moderne : Composites",
          "es": "Mejora: Composites",
          "de": "Upgrade Verbundhölzer",
          "pt": "Melhoria de Compósitos",
          "it": "Aggiornamento Materiali Compositi",
          "tr": "Kompozit Geliştirmesi",
          "pl": "Ulepszenie Kompozytów",
          "ru": "Улучшение для изготовления композитов",
          "uk": "Покращення сполук",
          "ko": "복합 목재 업그레이드",
          "zh": "复合材料升级",
          "ja": "複合材アップグレード"
        },
        {
          "id": "CampfireCookingUpgradeItem",
          "en": "Campfire Cooking Upgrade",
          "fr": "Amélioration basique : Cuisine au feu de camp",
          "es": "Mejora: Cocina con fogata",
          "de": "Grundlegendes Upgrade: Lagerfeuerkochen",
          "pt": "Melhoria de Cozimento com Fogueira",
          "it": "Aggiornamento Cucina da falò",
          "tr": "Güveçte Pişirme Geliştirmesi",
          "pl": "Ulepszenie Gotowania Na Ognisku",
          "ru": "Улучшение для готовки на костре",
          "uk": "Покращення приготування їжі на багатті",
          "ko": "모닥불 요리 업그레이드",
          "zh": "篝火烹饪升级",
          "ja": "野外料理アップグレード"
        },
        {
          "id": "ButcheryUpgradeItem",
          "en": "Butchery Upgrade",
          "fr": "Amélioration basique : Boucherie",
          "es": "Mejora: Carnicería",
          "de": "Grundlegendes Upgrade: Metzgerei",
          "pt": "Melhoria de Açougue",
          "it": "Aggiornamento Macelleria",
          "tr": "Kasaplık Geliştirmesi",
          "pl": "Ulepszenie Rzeźnictwa",
          "ru": "Улучшение разделки",
          "uk": "Покращення різництва",
          "ko": "도축 업그레이드",
          "zh": "加工升级组件",
          "ja": "Butchery Upgrade"
        },
        {
          "id": "BasicEngineeringUpgradeItem",
          "en": "Basic Engineering Upgrade",
          "fr": "Amélioration basique : Ingénierie basique",
          "es": "Mejora básica: Ingeniería",
          "de": "Grundlegendes Upgrade: Grundlegende Technik",
          "pt": "Melhoria Básica de Engenharia",
          "it": "Aggiornamento Ingegneria Base",
          "tr": "Basit Mühendislik Geliştirmesi",
          "pl": "Podstawowe ulepszenie Inżynierii",
          "ru": "Улучшение для основ инженерного дела",
          "uk": "Базове покращення інженерії",
          "ko": "기초 기계공학 업그레이드",
          "zh": "基础工程升级",
          "ja": "Basic Engineering Upgrade"
        },
        {
          "id": "BakingUpgradeItem",
          "en": "Baking Upgrade",
          "fr": "Amélioration avancée : Boulangerie",
          "es": "Mejora: Horneado",
          "de": "Fortschrittliches Upgrade: Backen",
          "pt": "Melhoria de Assados",
          "it": "Aggiornamento Cottura al forno",
          "tr": "Fırınlama Geliştirmesi",
          "pl": "Ulepszenie Pieczenia",
          "ru": "Улучшение для выпечки",
          "uk": "Покращення випічки",
          "ko": "제빵 업그레이드",
          "zh": "烘烤升级",
          "ja": "Baking Upgrade"
        },
        {
          "id": "AdvancedSmeltingUpgradeItem",
          "en": "Advanced Smelting Upgrade",
          "fr": "Amélioration avancée : Fonte avancée",
          "es": "Mejora avanzada: Fundición",
          "de": "Fortschrittliches Upgrade: Schmelzen",
          "pt": "Melhoria Avançada de Fundição",
          "it": "Aggiornamento Avanzato Fusione",
          "tr": "İleri Seviye Eritme Geliştirmesi",
          "pl": "Zaawansowane ulepszenie Wytapiania",
          "ru": "Улучшение для продвинутой выплавки",
          "uk": "Просунуте покращення виплавки",
          "ko": "고급 제련 업그레이드",
          "zh": "高级冶炼升级",
          "ja": "Advanced Smelting Upgrade"
        },
        {
          "id": "AdvancedMasonryUpgradeItem",
          "en": "Advanced Masonry Upgrade",
          "fr": "Amélioration moderne : Maçonnerie avancée",
          "es": "Mejora: Mampostería avanzada",
          "de": "Fortschrittliches Upgrade: Steinmetz",
          "pt": "Melhoria de Alvenaria Avançada",
          "it": "Aggiornamento Avanzato Muratura",
          "tr": "İleri Seviye Duvarcılık Geliştirmesi",
          "pl": "Zaawansowane ulepszenie Kamieniarstwa",
          "ru": "Улучшение для продвинутой каменной кладки",
          "uk": "Просунуте покращення кладки",
          "ko": "고급 석조 업그레이드",
          "zh": "高级石工升级组件",
          "ja": "高度な石工アップグレード"
        },
        {
          "id": "AdvancedCookingUpgradeItem",
          "en": "Advanced Cooking Upgrade",
          "fr": "Amélioration avancée : Cuisine avancée",
          "es": "Mejora avanzada: Cocina",
          "de": "Fortschrittliches Upgrade: Kochen",
          "pt": "Melhoria Avançada de Cozimento",
          "it": "Aggiornamento Avanzato Cucina",
          "tr": "İleri Seviye Aşçılık Geliştirmesi",
          "pl": "Zaawansowane ulepszenie Gotowania",
          "ru": "Улучшение для продвинутой кулинарии",
          "uk": "Просунуте покращення приготування їжі",
          "ko": "고급 요리 업그레이드",
          "zh": "高级烹饪升级",
          "ja": "Advanced Cooking Upgrade"
        },
        {
          "id": "AdvancedBakingUpgradeItem",
          "en": "Advanced Baking Upgrade",
          "fr": "Amélioration avancée : Boulangerie avancée",
          "es": "Mejora avanzada: Horneado",
          "de": "Fortschrittliches Upgrade: Backen",
          "pt": "Melhoria Avançada de Assados",
          "it": "Aggiornamento Avanzato Cottura al forno",
          "tr": "İleri Seviye Fırınlama Geliştirmesi",
          "pl": "Ulepszenie Zaawansowanego Pieczenia",
          "ru": "Улучшение для продвинутой выпечки",
          "uk": "Просунуте покращення випічки",
          "ko": "고급 제빵 업그레이드",
          "zh": "高级烘烤升级",
          "ja": "Advanced Baking Upgrade"
        },
        {
          "id": "TinyLeatherCarcass",
          "en": "Tiny Leather Carcass",
          "fr": "Minuscule cadavre à cuir",
          "es": "Cadáver minúsculo con cuero",
          "de": "Winziger Lederkadaver",
          "pt": "Carcaça de Couro Minúscula",
          "it": "Piccola Carcassa di Pelle",
          "tr": "Ufak Deri Ceset",
          "pl": "Malutka skórzana tusza",
          "ru": "Крошечная Кожаная Туша",
          "uk": "Крихітна шкіряна туша",
          "ko": "작은 가죽 사체",
          "zh": "微型皮革遗骸",
          "ja": "Tiny Leather Carcass"
        },
        {
          "id": "TinyFurCarcass",
          "en": "Tiny Fur Carcass",
          "fr": "Minuscule cadavre à fourrure",
          "es": "Cadáver minúsculo con piel",
          "de": "Winziger Fellkadaver",
          "pt": "Carcaça Peluda Minúscula",
          "it": "Piccola Carcassa di Pelliccia",
          "tr": "Ufak Kürk Ceset",
          "pl": "Malutka futrzana tusza",
          "ru": "Крошечная Меховая Туша",
          "uk": "Крихітна шерстяна туша",
          "ko": "칠면조 사체",
          "zh": "微型毛皮遗骸",
          "ja": "Tiny Fur Carcass"
        },
        {
          "id": "MetallurgyResearchPaperModernItem",
          "en": "Metallurgy Research Paper Modern",
          "fr": "Papier de recherche : Métallurgie moderne",
          "es": "Trabajo de investigación en metalurgia (moderno)",
          "de": "Modernes Forschungspapier: Metallurgie",
          "pt": "Documento de Pesquisa Moderno de Metalurgia",
          "it": "Documento di Ricerca Moderno di Metallurgia",
          "tr": "Madencilik Araştırma Makalesi Modern",
          "pl": "Nowoczesny artykuł badawczy Metalurgii",
          "ru": "Исследование по современной металлургии",
          "uk": "Дослідження сучасної металургії",
          "ko": "현대식 금속공학 연구지",
          "zh": "现代冶金研究论文",
          "ja": "精錬の最先端な研究書"
        },
        {
          "id": "PirozhokItem",
          "en": "Pirozhok",
          "fr": "Pirozhok",
          "es": "Pirozhok",
          "de": "Pirozhok",
          "pt": "Pirozhok",
          "it": "Pirozhoki",
          "tr": "Pirozhok",
          "pl": "Kulebiak",
          "ru": "Пирожок",
          "uk": "Пиріжок",
          "ko": "피로시키",
          "zh": "皮罗佐克",
          "ja": "Pirozhok"
        },
        {
          "id": "Silica",
          "en": "Silica",
          "fr": "Silice",
          "es": "Sílice",
          "de": "Silikate",
          "pt": "Sílica",
          "it": "Silicone",
          "tr": "Silika",
          "pl": "Silica",
          "ru": "Кремнезем",
          "uk": "Силіка",
          "ko": "이산화 규소",
          "zh": "二氧化硅",
          "ja": "Silica"
        },
        {
          "id": "WetTailingsItem",
          "en": "Wet Tailings",
          "fr": "Résidus humides",
          "es": "Relaves húmedos",
          "de": "Giftiger Schlamm",
          "pt": "Rejeitos úmidos",
          "it": "Particelle Umide",
          "tr": "Islak Atıklar",
          "pl": "Mokre Odpady",
          "ru": "Сырые хвосты",
          "uk": "Сирі хвости",
          "ko": "축축한 광재",
          "zh": "湿尾矿",
          "ja": "Wet Tailings"
        },
        {
          "id": "MoonJellyfishItem",
          "en": "Moon Jellyfish",
          "fr": "Méduse lune",
          "es": "Medusa luna",
          "de": "Mondqualle",
          "pt": "Medusa-da-lua",
          "it": "Medusa Quadrifoglio",
          "tr": "Ay Denizanası",
          "pl": "Meduza księżycowa",
          "ru": "Ушастая аурелия",
          "uk": "Аурелія",
          "ko": "보름달물해파리",
          "zh": "月亮水母",
          "ja": "Moon Jellyfish"
        },
        {
          "id": "Clothes",
          "en": "Clothes",
          "fr": "Vêtements",
          "es": "Ropas",
          "de": "Kleider",
          "pt": "Roupas",
          "it": "Vestiti",
          "tr": "Kıyafetler",
          "pl": "Ubrania",
          "ru": "Одежда",
          "uk": "Одяг",
          "ko": "옷",
          "zh": "衣服",
          "ja": "Clothes"
        },
        {
          "id": "IronSickleItem",
          "en": "Iron Sickle",
          "fr": "Faucille en fer",
          "es": "Hoz de hierro",
          "de": "Eisensichel",
          "pt": "Foice de Ferro",
          "it": "Falce di Ferro",
          "tr": "Demir Orak",
          "pl": "Żelazny Sierp",
          "ru": "Железный серп",
          "uk": "Залізний серп",
          "ko": "철 낫",
          "zh": "铁镰",
          "ja": "Iron Sickle"
        },
        {
          "id": "StreetSignItem",
          "en": "Street Sign",
          "fr": "Panneau de rue",
          "es": "Letrero de calle",
          "de": "Straßenschild",
          "pt": "Placa de Rua",
          "it": "Cartello Stradale",
          "tr": "Sokak Tabelası",
          "pl": "Znak Uliczny",
          "ru": "Уличный указатель",
          "uk": "Вуличний знак",
          "ko": "거리 표지판",
          "zh": "街道路标",
          "ja": "道路標識"
        },
        {
          "id": "StopSignItem",
          "en": "Stop Sign",
          "fr": "Panneau stop",
          "es": "Señal de STOP",
          "de": "Stoppschild",
          "pt": "Placa de Pare",
          "it": "Segnale di Stop",
          "tr": "Dur Tabelası",
          "pl": "Znak stop",
          "ru": "Знак Стоп",
          "uk": "Знак стоп",
          "ko": "일단정지 표지판",
          "zh": "停止标志",
          "ja": "停止標識"
        },
        {
          "id": "ModernStreetLightItem",
          "en": "Modern Street Light",
          "fr": "Lampadaire moderne",
          "es": "Farola moderna",
          "de": "Moderne Straßenlaterne",
          "pt": "Poste de Luz Moderno",
          "it": "Lampione Moderno",
          "tr": "Modern Sokak Lambası",
          "pl": "Nowoczesna lampa uliczna",
          "ru": "Современный уличный фонарь",
          "uk": "Сучасний вуличний ліхтар",
          "ko": "현대식 가로등",
          "zh": "现代路灯",
          "ja": "Modern Street Light"
        },
        {
          "id": "ModernDoubleStreetLightItem",
          "en": "Modern Double Street Light",
          "fr": "Lampadaire moderne à deux bras",
          "es": "Farola doble moderna",
          "de": "Moderne zweiarmige Straßenlaterne",
          "pt": "Poste de Luz Duplo Moderno",
          "it": "Doppio Lampione Moderno",
          "tr": "Modern İkili Sokak Lambası",
          "pl": "Nowoczesna podwójna lampa uliczna",
          "ru": "Современный двойной уличный фонарь",
          "uk": "Сучасний подвійний вуличний ліхтар",
          "ko": "현대식 이중 가로등",
          "zh": "现代双路灯",
          "ja": "Modern Double Street Light"
        },
        {
          "id": "MiningModernUpgradeItem",
          "en": "Mining Modern Upgrade",
          "fr": "Amélioration moderne : Minage",
          "es": "Mejora moderna: Minería",
          "de": "Modernes Upgrade: Bergbau",
          "pt": "Melhoria Moderna de Mineração",
          "it": "Aggiornamento Moderno Estrazione Mineraria",
          "tr": "Madencilik Modern Geliştirme",
          "pl": "Nowoczesne ulepszenie Górnictwa",
          "ru": "Современное улучшение для горного дела",
          "uk": "Новітнє покращення видобутку",
          "ko": "현대식 채광 업그레이드",
          "zh": "采矿现代化升级",
          "ja": "Mining Modern Upgrade"
        },
        {
          "id": "MiningBasicUpgradeItem",
          "en": "Mining Basic Upgrade",
          "fr": "Amélioration basique : Minage",
          "es": "Mejora básica: Minería",
          "de": "Grundlegendes Upgrade: Bergbau",
          "pt": "Melhoria Básica de Mineração",
          "it": "Aggiornamento Base Estrazione Mineraria",
          "tr": "Madencilik Temel Geliştirme",
          "pl": "Podstawowe ulepszenie Górnictwa",
          "ru": "Базовое улучшение для горного дела",
          "uk": "Базове покращення видобутку",
          "ko": "기초 채광 업그레이드",
          "zh": "采矿基础升级",
          "ja": "Mining Basic Upgrade"
        },
        {
          "id": "MiningAdvancedUpgradeItem",
          "en": "Mining Advanced Upgrade",
          "fr": "Amélioration avancée : Minage",
          "es": "Mejora avanzada: Minería",
          "de": "Fortschrittliches Upgrade: Bergbau",
          "pt": "Melhoria Avançada de Mineração",
          "it": "Aggiornamento Avanzato Estrazione Mineraria",
          "tr": "Madencilik İleri Seviye Geliştirme",
          "pl": "Zaawansowane ulepszenie Górnictwa",
          "ru": "Продвинутое улучшение для горного дела",
          "uk": "Просунуте покращення видобутку",
          "ko": "고급 채광 업그레이드",
          "zh": "采矿高级升级",
          "ja": "Mining Advanced Upgrade"
        },
        {
          "id": "MechanicsModernUpgradeItem",
          "en": "Mechanics Modern Upgrade",
          "fr": "Amélioration moderne : Mécaniques",
          "es": "Mejora moderna: Mecánica",
          "de": "Modernes Upgrade: Mechanik",
          "pt": "Melhoria Moderna de Mecânica",
          "it": "Aggiornamento Moderno Meccanica",
          "tr": "Mekanik Modern Geliştirme",
          "pl": "Nowoczesne ulepszenie Mechaniki",
          "ru": "Современное улучшение для механики",
          "uk": "Новітнє покращення механіки",
          "ko": "현대식 기계정비 업그레이드",
          "zh": "机械现代升级",
          "ja": "Mechanics Modern Upgrade"
        },
        {
          "id": "MechanicsAdvancedUpgradeItem",
          "en": "Mechanics Advanced Upgrade",
          "fr": "Amélioration avancée : Mécaniques",
          "es": "Mejora avanzada: Mecánica",
          "de": "Fortschrittliches Upgrade: Mechanik",
          "pt": "Melhoria Avançada de Mecânica",
          "it": "Aggiornamento Avanzato Meccanica",
          "tr": "Mekanik İleri Seviye Geliştirme",
          "pl": "Zaawansowane ulepszenie Mechaniki",
          "ru": "Продвинутое улучшение для механики",
          "uk": "Mechanics Advanced Upgrade",
          "ko": "고급 기계정비 업그레이드",
          "zh": "机械高级升级",
          "ja": "Mechanics Advanced Upgrade"
        },
        {
          "id": "MasonryBasicUpgradeItem",
          "en": "Masonry Basic Upgrade",
          "fr": "Amélioration basique : Maçonnerie",
          "es": "Mejora básica: Mampostería",
          "de": "Grundlegendes Upgrade: Steinmetz",
          "pt": "Melhoria Básica de Alvenaria",
          "it": "Aggiornamento Base Muratura",
          "tr": "Duvarcılık Temel Geliştirme",
          "pl": "Podstawowe ulepszenie Kamieniarstwa",
          "ru": "Базовое улучшение для каменной кладки",
          "uk": "Masonry Basic Upgrade",
          "ko": "기초 석조 업그레이드",
          "zh": "基础石工升级组件",
          "ja": "石工の基礎アップグレード"
        },
        {
          "id": "LoggingBasicUpgradeItem",
          "en": "Logging Basic Upgrade",
          "fr": "Amélioration basique : Abattage",
          "es": "Mejora básica: Tala",
          "de": "Grundlegendes Upgrade: Holzfäller",
          "pt": "Melhoria Básica de Extração de Madeira",
          "it": "Aggiornamento Base Tagliare Tronchi",
          "tr": "Odunculuk Temel Geliştirme",
          "pl": "Podstawowe ulepszenie Wyrębu Drzew",
          "ru": "Базовое улучшение для заготовки леса",
          "uk": "Logging Basic Upgrade",
          "ko": "기초 벌목 업그레이드",
          "zh": "伐木基础升级",
          "ja": "Logging Basic Upgrade"
        },
        {
          "id": "LoggingAdvancedUpgradeItem",
          "en": "Logging Advanced Upgrade",
          "fr": "Amélioration avancée : Abattage",
          "es": "Mejora avanzada: Tala",
          "de": "Fortschrittliches Upgrade: Holzfäller",
          "pt": "Melhoria Avançada de Extração de Madeira",
          "it": "Aggiornamento Avanzato Tagliare Tronchi",
          "tr": "Odunculuk İleri Seviye Geliştirme",
          "pl": "Zaawansowane ulepszenie Wyrębu Drzew",
          "ru": "Продвинутое улучшение для заготовки леса",
          "uk": "Logging Advanced Upgrade",
          "ko": "고급 벌목 업그레이드",
          "zh": "伐木高级升级",
          "ja": "Logging Advanced Upgrade"
        },
        {
          "id": "GlassworkingModernUpgradeItem",
          "en": "Glassworking Modern Upgrade",
          "fr": "Amélioration moderne : Travail du verre",
          "es": "Mejora moderna: Artesanía del cristal",
          "de": "Modernes Upgrade: Glasverarbeitung",
          "pt": "Melhoria Moderna de Trabalho com Vidro",
          "it": "Aggiornamento Moderno Lavorazione del Vetro",
          "tr": "Cam İşleme Modern Geliştirme",
          "pl": "Nowoczesne ulepszenie Obróbki Szkła",
          "ru": "Современное улучшение для обработки стекла",
          "uk": "Новітнє покращення обробки скла",
          "ko": "현대식 유리 제조 업그레이드",
          "zh": "玻璃加工现代升级",
          "ja": "Glassworking Modern Upgrade"
        },
        {
          "id": "GlassworkingAdvancedUpgradeItem",
          "en": "Glassworking Advanced Upgrade",
          "fr": "Amélioration avancée : Travail du verre",
          "es": "Mejora avanzada: Artesanía de cristal",
          "de": "Fortschrittliches Upgrade: Glasverarbeitung",
          "pt": "Melhoria Avançada de Trabalho com Vidro",
          "it": "Aggiornamento Avanzato Lavorazione del Vetro",
          "tr": "Cam İşleme İleri Seviye Geliştirme",
          "pl": "Zaawansowane ulepszenie Obróbki Szkła",
          "ru": "Продвинутое улучшение для стеклообработки",
          "uk": "Glassworking Advanced Upgrade",
          "ko": "고급 유리 제조 업그레이드",
          "zh": "玻璃加工高级升级",
          "ja": "Glassworking Advanced Upgrade"
        },
        {
          "id": "CarpentryBasicUpgradeItem",
          "en": "Carpentry Basic Upgrade",
          "fr": "Amélioration basique : Menuiserie",
          "es": "Mejora básica: Carpintería",
          "de": "Grundlegendes Upgrade: Schreinerei",
          "pt": "Melhoria Básica de Carpintaria",
          "it": "Aggiornamento Base Carpenteria",
          "tr": "Marangozluk Temel Geliştirme",
          "pl": "Podstawowe ulepszenie Stolarstwa",
          "ru": "Базовое улучшение для плотницкого дела",
          "uk": "Carpentry Basic Upgrade",
          "ko": "기초 목공 업그레이드",
          "zh": "木工基础升级",
          "ja": "Carpentry Basic Upgrade"
        },
        {
          "id": "CarpentryAdvancedUpgradeItem",
          "en": "Carpentry Advanced Upgrade",
          "fr": "Amélioration avancée : Menuiserie",
          "es": "Mejora avanzada: Carpintería",
          "de": "Fortschrittliches Upgrade: Schreinerei",
          "pt": "Melhoria Avançada de Carpintaria",
          "it": "Aggiornamento Avanzato Carpenteria",
          "tr": "Marangozluk İleri Seviye Geliştirme",
          "pl": "Zaawansowane ulepszenie Stolarstwa",
          "ru": "Продвинутое улучшение для плотницкого дела",
          "uk": "Carpentry Advanced Upgrade",
          "ko": "고급 목공 업그레이드",
          "zh": "木工高级升级",
          "ja": "Carpentry Advanced Upgrade"
        },
        {
          "id": "AsphaltConcreteItem",
          "en": "Asphalt Concrete",
          "fr": "Route en asphalte",
          "es": "Hormigón asfáltico",
          "de": "Asphaltbeton",
          "pt": "Concreto asfáltico",
          "it": "Asfalto",
          "tr": "Beton Asfalt",
          "pl": "Asfaltobeton",
          "ru": "Асфальтобетон",
          "uk": "Asphalt Concrete",
          "ko": "아스팔트 콘크리트",
          "zh": "沥青混凝土",
          "ja": "Asphalt Concrete"
        },
        {
          "id": "HandPlowItem",
          "en": "Hand Plow",
          "fr": "Charrue à main",
          "es": "Arado manual",
          "de": "Handpflug",
          "pt": "Arado Manual",
          "it": "Aratro Manuale",
          "tr": "El Sabanı",
          "pl": "Hand Plow",
          "ru": "Ручной плуг",
          "uk": "Ручний плуг",
          "ko": "손쟁기",
          "zh": "手犁",
          "ja": "手鋤"
        },
        {
          "id": "CompositeBowItem",
          "en": "Composite Bow",
          "fr": "Arc composite",
          "es": "Arco de madera de composite",
          "de": "Kompositbogen",
          "pt": "Arco Composto",
          "it": "Arco Composito",
          "tr": "Kompozit Yay",
          "pl": "Łuk kompozytowy",
          "ru": "Композитный лук",
          "uk": "Composite Bow",
          "ko": "합성 활",
          "zh": "复合弓",
          "ja": "Composite Bow"
        },
        {
          "id": "ModernUpgradeLvl4Item",
          "en": "Modern Upgrade 4",
          "fr": "Amélioration moderne nv. 4",
          "es": "Mejora moderna 4",
          "de": "Modernes Upgrade 4",
          "pt": "Melhoria Moderna 4",
          "it": "Aggiornamento Moderno 4",
          "tr": "Modern Geliştirme 4",
          "pl": "Nowoczesne ulepszenie 4",
          "ru": "Современное улучшение 4",
          "uk": "Новітнє покращення 4",
          "ko": "현대식 업그레이드 4",
          "zh": "现代升级4",
          "ja": "近代アップグレード4"
        },
        {
          "id": "ModernUpgradeLvl3Item",
          "en": "Modern Upgrade 3",
          "fr": "Amélioration moderne nv. 3",
          "es": "Mejora moderna 3",
          "de": "Modernes Upgrade 3",
          "pt": "Melhoria Moderna 3",
          "it": "Aggiornamento Moderno 3",
          "tr": "Modern Geliştirme 3",
          "pl": "Nowoczesne ulepszenie 3",
          "ru": "Современное улучшение 3",
          "uk": "Новітнє покращення 3",
          "ko": "현대식 업그레이드 3",
          "zh": "现代升级3",
          "ja": "近代アップグレード3"
        },
        {
          "id": "ModernUpgradeLvl2Item",
          "en": "Modern Upgrade 2",
          "fr": "Amélioration moderne nv. 2",
          "es": "Mejora moderna 2",
          "de": "Modernes Upgrade 2",
          "pt": "Melhoria Moderna 2",
          "it": "Aggiornamento Moderno 2",
          "tr": "Modern Geliştirme 2",
          "pl": "Nowoczesne ulepszenie 2",
          "ru": "Современное улучшение 2",
          "uk": "Новітнє покращення 2",
          "ko": "현대식 업그레이드 2",
          "zh": "现代升级2",
          "ja": "近代アップグレード2"
        },
        {
          "id": "ModernUpgradeLvl1Item",
          "en": "Modern Upgrade 1",
          "fr": "Amélioration moderne nv. 1",
          "es": "Mejora moderna 1",
          "de": "Modernes Upgrade 1",
          "pt": "Melhoria Moderna 1",
          "it": "Aggiornamento Moderno 1",
          "tr": "Modern Geliştirme 1",
          "pl": "Nowoczesne ulepszenie 1",
          "ru": "Современное улучшение 1",
          "uk": "Новітнє покращення 1",
          "ko": "현대식 업그레이드 1",
          "zh": "现代升级1",
          "ja": "近代アップグレード1"
        },
        {
          "id": "BasicUpgradeLvl4Item",
          "en": "Basic Upgrade 4",
          "fr": "Amélioration basique nv. 4",
          "es": "Mejora básica 4",
          "de": "Grundlegendes Upgrade 4",
          "pt": "Melhoria Básica 4",
          "it": "Aggiornamento Base 4",
          "tr": "Temel Geliştirme 4",
          "pl": "Podstawowe ulepszenie 4",
          "ru": "Базовое улучшение 4",
          "uk": "Базове покращення 4",
          "ko": "기초 업그레이드 4",
          "zh": "基础升级4",
          "ja": "基礎アップグレード4"
        },
        {
          "id": "BasicUpgradeLvl3Item",
          "en": "Basic Upgrade 3",
          "fr": "Amélioration basique nv. 3",
          "es": "Mejora básica 3",
          "de": "Grundlegendes Upgrade 3",
          "pt": "Melhoria Básica 3",
          "it": "Aggiornamento Base 3",
          "tr": "Temel Geliştirme 3",
          "pl": "Podstawowe ulepszenie 3",
          "ru": "Базовое улучшение 3",
          "uk": "Базове покращення 3",
          "ko": "기초 업그레이드 3",
          "zh": "基础升级3",
          "ja": "基礎アップグレード3"
        },
        {
          "id": "BasicUpgradeLvl2Item",
          "en": "Basic Upgrade 2",
          "fr": "Amélioration basique nv. 2",
          "es": "Mejora básica 2",
          "de": "Grundlegendes Upgrade 2",
          "pt": "Melhoria Básica 2",
          "it": "Aggiornamento Base 2",
          "tr": "Temel Geliştirme 2",
          "pl": "Podstawowe ulepszenie 2",
          "ru": "Базовое улучшение 2",
          "uk": "Базове покращення 2",
          "ko": "기초 업그레이드 2",
          "zh": "基础升级2",
          "ja": "基礎アップグレード2"
        },
        {
          "id": "BasicUpgradeLvl1Item",
          "en": "Basic Upgrade 1",
          "fr": "Amélioration basique nv. 1",
          "es": "Mejora básica 1",
          "de": "Grundlegendes Upgrade 1",
          "pt": "Melhoria Básica 1",
          "it": "Aggiornamento Base 1",
          "tr": "Temel Geliştirme 1",
          "pl": "Podstawowe ulepszenie 1",
          "ru": "Базовое улучшение 1",
          "uk": "Базове покращення 1",
          "ko": "기초 업그레이드 1",
          "zh": "基础升级1",
          "ja": "基礎アップグレード1"
        },
        {
          "id": "AdvancedUpgradeLvl4Item",
          "en": "Advanced Upgrade 4",
          "fr": "Amélioration avancée nv. 4",
          "es": "Mejora avanzada 4",
          "de": "Fortschrittliches Upgrade 4",
          "pt": "Melhoria Avançada 4",
          "it": "Aggiornamento Avanzato 4",
          "tr": "İleri Seviye Geliştirme 4",
          "pl": "Zaawansowane ulepszenie 4",
          "ru": "Продвинутое улучшение 4",
          "uk": "Просунуте покращення 4",
          "ko": "고급 업그레이드 4",
          "zh": "高级升级4",
          "ja": "Advanced Upgrade 4"
        },
        {
          "id": "AdvancedUpgradeLvl3Item",
          "en": "Advanced Upgrade 3",
          "fr": "Amélioration avancée nv. 3",
          "es": "Mejora avanzada 3",
          "de": "Fortschrittliches Upgrade 3",
          "pt": "Melhoria Avançada 3",
          "it": "Aggiornamento Avanzato 3",
          "tr": "İleri Seviye Geliştirme 3",
          "pl": "Zaawansowane ulepszenie 3",
          "ru": "Продвинутое улучшение 3",
          "uk": "Просунуте покращення 3",
          "ko": "고급 업그레이드 3",
          "zh": "高级升级3",
          "ja": "Advanced Upgrade 3"
        },
        {
          "id": "AdvancedUpgradeLvl2Item",
          "en": "Advanced Upgrade 2",
          "fr": "Amélioration avancée nv. 2",
          "es": "Mejora avanzada 2",
          "de": "Fortschrittliches Upgrade 2",
          "pt": "Melhoria Avançada 2",
          "it": "Aggiornamento Avanzato 2",
          "tr": "İleri Seviye Geliştirme 2",
          "pl": "Zaawansowane ulepszenie 2",
          "ru": "Продвинутое улучшение 2",
          "uk": "Просунуте покращення 2",
          "ko": "고급 업그레이드 2",
          "zh": "高级升级2",
          "ja": "Advanced Upgrade 2"
        },
        {
          "id": "AdvancedUpgradeLvl1Item",
          "en": "Advanced Upgrade 1",
          "fr": "Amélioration avancée nv. 1",
          "es": "Mejora avanzada 1",
          "de": "Fortschrittliches Upgrade 1",
          "pt": "Melhoria Avançada 1",
          "it": "Aggiornamento Avanzato 1",
          "tr": "İleri Seviye Geliştirme 1",
          "pl": "Zaawansowane ulepszenie 1",
          "ru": "Продвинутое улучшение 1",
          "uk": "Просунуте покращення 1",
          "ko": "고급 업그레이드 1",
          "zh": "高级升级1",
          "ja": "Advanced Upgrade 1"
        },
        {
          "id": "SteamTractorPlowItem",
          "en": "Steam Tractor Plow",
          "fr": "Charrue pour tracteur à vapeur",
          "es": "Arado con tractor a vapor",
          "de": "Dampftraktor-Pflug",
          "pt": "Trator Arador à Vapor",
          "it": "Aratro del Trattore A Vapore",
          "tr": "Buharlı Traktör Sabanı",
          "pl": "Steam Tractor Plow",
          "ru": "Плуг парового трактора",
          "uk": "Steam Tractor Plow",
          "ko": "증기기관 트랙터 쟁기",
          "zh": "蒸汽拖拉机犁",
          "ja": "Steam Tractor Plow"
        },
        {
          "id": "IndustrialItem",
          "en": "Industrial",
          "fr": "Industriel",
          "es": "Industrial",
          "de": "Industriell",
          "pt": "Industrial",
          "it": "Industriale",
          "tr": "Endüstriyel",
          "pl": "Przemysł",
          "ru": "Промышленная",
          "uk": "Industrial",
          "ko": "산업",
          "zh": "产业的",
          "ja": "工業"
        },
        {
          "id": "TailoringUpgradeItem",
          "en": "Tailoring Basic Upgrade",
          "fr": "Amélioration basique : Couture",
          "es": "Mejora básica: Sastrería",
          "de": "Grundlegendes Upgrade: Schneidern",
          "pt": "Melhoria Básica de Alfaiataria",
          "it": "Aggiornamento Base Sartoria",
          "tr": "Terzicilik Temel Geliştirme",
          "pl": "Podstawowe ulepszenie Krawiectwa",
          "ru": "Базовое улучшение для портняжного дела",
          "uk": "Tailoring Basic Upgrade",
          "ko": "기초 재단 업그레이드",
          "zh": "裁缝基础升级",
          "ja": "Tailoring Basic Upgrade"
        },
        {
          "id": "TailoringBasicUpgradeItem",
          "en": "Tailoring Basic Upgrade",
          "fr": "Amélioration basique : Couture",
          "es": "Mejora básica: Sastrería",
          "de": "Grundlegendes Upgrade: Schneidern",
          "pt": "Melhoria Básica de Alfaiataria",
          "it": "Aggiornamento Base Sartoria",
          "tr": "Terzicilik Temel Geliştirme",
          "pl": "Podstawowe ulepszenie Krawiectwa",
          "ru": "Базовое улучшение для портняжного дела",
          "uk": "Tailoring Basic Upgrade",
          "ko": "기초 재단 업그레이드",
          "zh": "裁缝基础升级",
          "ja": "Tailoring Basic Upgrade"
        },
        {
          "id": "MasonryAdvancedUpgradeItem",
          "en": "Masonry Advanced Upgrade",
          "fr": "Amélioration avancée : Maçonnerie",
          "es": "Mejora avanzada: Mampostería",
          "de": "Fortschrittliches Upgrade: Steinmetz",
          "pt": "Melhoria Avançada de Alvenaria",
          "it": "Aggiornamento Avanzato Muratura",
          "tr": "Marangozluk İleri Seviye Geliştirme",
          "pl": "Zaawansowane ulepszenie Kamieniarstwa",
          "ru": "Продвинутое улучшение для каменной кладки",
          "uk": "Masonry Advanced Upgrade",
          "ko": "고급 석조 업그레이드",
          "zh": "高级石工升级组件",
          "ja": "石工の応用アップグレード"
        },
        {
          "id": "Upgrade",
          "en": "Upgrade",
          "fr": "Amélioration",
          "es": "Mejora",
          "de": "Upgrade",
          "pt": "Melhoria",
          "it": "Aggiornamento",
          "tr": "Geliştirme",
          "pl": "Ulepszenie",
          "ru": "Улучшение",
          "uk": "Покращення",
          "ko": "업그레이드",
          "zh": "升级",
          "ja": "Upgrade"
        },
        {
          "id": "MortaredSandstoneDoorItem",
          "en": "Mortared Sandstone Door",
          "fr": "Porte en grès cimenté",
          "es": "Puerta de arenisca con mortero",
          "de": "Sandsteinziegeltür",
          "pt": "Porta de Arenito Argamassado",
          "it": "Porta di Arenaria Pestata",
          "tr": "Harçlı Kumtaşından Kapı",
          "pl": "Piaskowcowe drzwi",
          "ru": "Дверь из строительного песчаника",
          "uk": "Mortared Sandstone Door",
          "ko": "모르타르 마감 사암 문",
          "zh": "砂岩砂门",
          "ja": "Mortared Sandstone Door"
        },
        {
          "id": "MortaredLimestoneDoorItem",
          "en": "Mortared Limestone Door",
          "fr": "Porte en calcaire cimenté",
          "es": "Puerta de piedra caliza con mortero",
          "de": "Kalksteinziegeltür",
          "pt": "Porta de Calcário Argamassado",
          "it": "Porta di Calcare Pestato",
          "tr": "Harçlı Kireç Taşından Kapı",
          "pl": "Wapienne drzwi",
          "ru": "Дверь из строительного известняка",
          "uk": "Mortared Limestone Door",
          "ko": "모르타르 마감 석회암 문",
          "zh": "砂浆石灰石门",
          "ja": "モルタルの石灰岩のドア"
        },
        {
          "id": "MortaredGraniteDoorItem",
          "en": "Mortared Granite Door",
          "fr": "Porte en granite cimenté",
          "es": "Puerta de granito con mortero",
          "de": "Granitziegeltür",
          "pt": "Porta de Granito Argamassado",
          "it": "Porta di Granito Pestato",
          "tr": "Harçlı Granitten Kapı",
          "pl": "Granitowe drzwi",
          "ru": "Дверь из строительного гранита",
          "uk": "Mortared Granite Door",
          "ko": "모르타르 마감 화강암 문",
          "zh": "砂浆花岗岩门",
          "ja": "Mortared Granite Door"
        },
        {
          "id": "HewnSoftwoodDoorItem",
          "en": "Hewn Softwood Door",
          "fr": "Porte en bois tendre taillé",
          "es": "Puerta tallada (madera blanda)",
          "de": "Massivholztür aus Weichholz",
          "pt": "Porta de Madeira Macia Cortada",
          "it": "Porta Intagliata in Legno Tenero",
          "tr": "Hewn Softwood Door",
          "pl": "Ociosane drzwi z drewna iglastego",
          "ru": "Дверь из обтёсанных хвойных пород",
          "uk": "Hewn Softwood Door",
          "ko": "다듬은 연목 문",
          "zh": "软木门",
          "ja": "針葉樹の丸太材のドア"
        },
        {
          "id": "HewnHardwoodDoorItem",
          "en": "Hewn Hardwood Door",
          "fr": "Porte en bois dur taillé",
          "es": "Puerta tallada (madera noble)",
          "de": "Massivholztür aus Hartholz",
          "pt": "Porta de Madeira Dura Cortada",
          "it": "Porta Intagliata in Legno Massiccio",
          "tr": "Hewn Hardwood Door",
          "pl": "Ociosane drzwi z drewna liściastego",
          "ru": "Дверь из обтёсанных лиственных пород",
          "uk": "Hewn Hardwood Door",
          "ko": "다듬은 견목 문",
          "zh": "砍伐硬木门",
          "ja": "粗削りの硬材のドア"
        },
        {
          "id": "FlatSteelDoorItem",
          "en": "Flat Steel Door",
          "fr": "Porte en acier lisse",
          "es": "Puerta plana de acero",
          "de": "Wohnungstüre aus Stahl",
          "pt": "Porta de Aço Plano",
          "it": "Porta in acciaio Piatta",
          "tr": "Flat Steel Door",
          "pl": "Drzwi z blachy stalowej",
          "ru": "Дверь из листовой стали",
          "uk": "Flat Steel Door",
          "ko": "평철 문",
          "zh": "扁平铁门",
          "ja": "Flat Steel Door"
        },
        {
          "id": "IndustrialElevatorItem",
          "en": "Industrial Elevator",
          "fr": "Ascenseur industriel",
          "es": "Montacargas industrial",
          "de": "Industrieaufzug",
          "pt": "Elevador Industrial",
          "it": "Ascensore industriale",
          "tr": "Endüstriyel Asansör",
          "pl": "Industrial Elevator",
          "ru": "Промышленный лифт",
          "uk": "Industrial Elevator",
          "ko": "공업용 승강기",
          "zh": "工业化升降机",
          "ja": "Industrial Elevator"
        },
        {
          "id": "StorageSiloItem",
          "en": "Storage Silo",
          "fr": "Silo de stockage",
          "es": "Silo de almacenamiento",
          "de": "Hölzernes Vorratssilo",
          "pt": "Silo de Armazenamento",
          "it": "Silo di Stoccaggio",
          "tr": "Storage Silo",
          "pl": "Silos magazynowy",
          "ru": "Силосная башня",
          "uk": "Storage Silo",
          "ko": "사일로",
          "zh": "储料仓",
          "ja": "Storage Silo"
        },
        {
          "id": "StandingSteelBrickSignItem",
          "en": "Standing Steel Brick Sign",
          "fr": "Panneau sur pied de brique et d\u0027acier",
          "es": "Letrero de acero (ladrillos)",
          "de": "Stahlschild mit Ziegelsteinfundament (stehend)",
          "pt": "Placa de Tijolos de Aço em Pé",
          "it": "Segnale Verticale in Mattoni d\u0027Acciaio",
          "tr": "Standing Steel Brick Sign",
          "pl": "Standing Steel Brick Sign",
          "ru": "Стальная стела на кирпичном основании",
          "uk": "Standing Steel Brick Sign",
          "ko": "강철 벽돌 간판",
          "zh": "钢砖标志",
          "ja": "鋼の立て看板（レンガ）"
        },
        {
          "id": "StandingLongSteelSignItem",
          "en": "Standing Long Steel Sign",
          "fr": "Long panneau sur pied en acier",
          "es": "Letrero largo (acero)",
          "de": "Stahlschild (lang",
          "pt": "강철 긴 간판",
          "it": "Стальная длинная стела",
          "tr": "Standing Long Steel Sign",
          "pl": "Standing Long Steel Sign",
          "ru": "长条钢制标志",
          "uk": "Standing Long Steel Sign",
          "ko": " stehend)",
          "zh": "Placa Longa de Aço em Pé",
          "ja": "Standing Long Steel Sign"
        },
        {
          "id": "StandingGlassSignItem",
          "en": "Standing Glass Sign",
          "fr": "Grand panneau sur pied en verre",
          "es": "Letrero de vidrio",
          "de": "Glasschild (stehend)",
          "pt": "Placa de Vidro em Pé",
          "it": "Segnale Verticale in Vetro",
          "tr": "Standing Glass Sign",
          "pl": "Standing Glass Sign",
          "ru": "Стеклянная табличка",
          "uk": "Standing Glass Sign",
          "ko": "유리 간판",
          "zh": "玻璃标志",
          "ja": "ガラスの立て看板"
        },
        {
          "id": "PoweredStorageSiloItem",
          "en": "Powered Storage Silo",
          "fr": "Silo de stockage électrique",
          "es": "Silo de almacenamiento eléctronico",
          "de": "Modernes Lagersilo",
          "pt": "Silo de Armazenamento Elétrico",
          "it": "Silo di Stoccaggio Alimentato",
          "tr": "Powered Storage Silo",
          "pl": "Silos napędzany energią elektryczną",
          "ru": "Электрическая Силосная башня",
          "uk": "Powered Storage Silo",
          "ko": "전기식 사일로",
          "zh": "已充电储料仓",
          "ja": "Powered Storage Silo"
        },
        {
          "id": "HangingSteelShopSignItem",
          "en": "Hanging Steel Shop Sign",
          "fr": "Panneau suspendu en acier pour magasin",
          "es": "Letrero colgante de tienda (acero)",
          "de": "Stahlschild für Geschäft (hängend)",
          "pt": "Placa de Loja de Aço Pendurada",
          "it": "Cartellone da Negozio Appeso in Acciaio",
          "tr": "Hanging Steel Shop Sign",
          "pl": "Hanging Steel Shop Sign",
          "ru": "Стальная магазинная вывеска",
          "uk": "Hanging Steel Shop Sign",
          "ko": "강철 가게 현판",
          "zh": "钢制商店悬挂标志",
          "ja": "鋼の掛け看板（店舗）"
        },
        {
          "id": "HangingSteelPlainSignItem",
          "en": "Hanging Steel Plain Sign",
          "fr": "Panneau suspendu en acier épuré",
          "es": "Letrero colgante (acero)",
          "de": "Stahlschild (glatt",
          "pt": "강철 평평한 현판",
          "it": "Стальная обычная вывеска",
          "tr": "Hanging Steel Plain Sign",
          "pl": "Hanging Steel Plain Sign",
          "ru": "钢制平整悬挂标志",
          "uk": "Hanging Steel Plain Sign",
          "ko": " hängend)",
          "zh": "Placa Plana de Aço Pendurada",
          "ja": "Hanging Steel Plain Sign"
        },
        {
          "id": "HangingSteelMineSignItem",
          "en": "Hanging Steel Mine Sign",
          "fr": "Panneau suspendu en acier pour mine",
          "es": "Letrero colgante de mina (acero)",
          "de": "Stahlschild für Minen (hängend)",
          "pt": "Placa de Mina de Aço Pendurada",
          "it": "Cartellone da Miniera in Acciaio Appeso",
          "tr": "Hanging Steel Mine Sign",
          "pl": "Hanging Steel Mine Sign",
          "ru": "Стальная вывеска для шахты",
          "uk": "Hanging Steel Mine Sign",
          "ko": "강철 광산 현판",
          "zh": "矿用钢悬挂标志",
          "ja": "鋼の掛け看板（採掘）"
        },
        {
          "id": "HangingSteelFramedSignItem",
          "en": "Hanging Steel Framed Sign",
          "fr": "Grand panneau suspendu encadré en acier",
          "es": "Letrero colgante con marco (acero)",
          "de": "Stahlschild (gerahmt",
          "pt": "강철 액자식 현판",
          "it": "Стальная обрамлённая вывеска",
          "tr": "Hanging Steel Framed Sign",
          "pl": "Hanging Steel Framed Sign",
          "ru": "钢制框式悬挂标志",
          "uk": "Hanging Steel Framed Sign",
          "ko": " hängend)",
          "zh": "Placa Emoldurada de Aço Pendurada",
          "ja": "Hanging Steel Framed Sign"
        },
        {
          "id": "HangingLongSteelSignItem",
          "en": "Hanging Long Steel Sign",
          "fr": "Long panneau suspendu en acier",
          "es": "Letrero colgante largo (acero)",
          "de": "Stahlschild (lang",
          "pt": "강철 기다란 현판",
          "it": "Стальная длинная вывеска",
          "tr": "Hanging Long Steel Sign",
          "pl": "Hanging Long Steel Sign",
          "ru": "长条钢制悬挂标志",
          "uk": "Hanging Long Steel Sign",
          "ko": " hängend)",
          "zh": "Placa Longa de Aço Pendurada",
          "ja": "Hanging Long Steel Sign"
        },
        {
          "id": "CorrugatedSteelFenceDoorItem",
          "en": "Corrugated Steel Fence Door",
          "fr": "Porte en acier ondulé à croisillons",
          "es": "Puerta de valla (acero corrugado)",
          "de": "Wellstahl Gittertür",
          "pt": "Porta de Cerca de Aço Corrugado",
          "it": "Porta Recinzione in Acciaio Ondulato",
          "tr": "Corrugated Steel Fence Door",
          "pl": "Furtka ze stali ryflowanej",
          "ru": "Дверь из решетки гофрированной стали",
          "uk": "Corrugated Steel Fence Door",
          "ko": "골강판 울타리 문",
          "zh": "波纹钢制栅栏门",
          "ja": "Corrugated Steel Fence Door"
        },
        {
          "id": "CorrugatedSteelDoorItem",
          "en": "Corrugated Steel Door",
          "fr": "Porte en acier ondulé",
          "es": "Puerta (acero corrugado)",
          "de": "Wellstahltür",
          "pt": "Porta de Aço Corrugado",
          "it": "Porta in Acciaio Ondulato",
          "tr": "Corrugated Steel Door",
          "pl": "Drzwi ze stali ryflowanej",
          "ru": "Дверь из гофрированной стали",
          "uk": "Corrugated Steel Door",
          "ko": "골강판 문",
          "zh": "波纹钢制门",
          "ja": "Corrugated Steel Door"
        },
        {
          "id": "ElkSkypiercerItem",
          "en": "Elk Skypiercer",
          "fr": "Wapiti Perce-ciel",
          "es": "Cuerno de alce celestial",
          "de": "Elch Himmelsstecher",
          "pt": "Montanha do Alce",
          "it": "Alce Skypiercer",
          "tr": "Semadelen Geyik",
          "pl": "Łoś skypiercer",
          "ru": "Олень Небокол",
          "uk": "Лось Протинач Неба",
          "ko": "엘크 천공지배자",
          "zh": "驼鹿高跃",
          "ja": "エルク・スカイピアサー"
        },
        {
          "id": "SpinMelterItem",
          "en": "Spin Melter",
          "fr": "Extrudeuse",
          "es": "Torno de fusión",
          "de": "Schmelzschleuderer",
          "pt": "Máquina de fiação",
          "it": "Tornio A Fusione",
          "tr": "Spin Melter",
          "pl": "Spin Melter",
          "ru": "Прядильная машина",
          "uk": "Spin Melter",
          "ko": "용융 방사기",
          "zh": "旋转熔炉",
          "ja": "Spin Melter"
        },
        {
          "id": "ShippingContainerRedItem",
          "en": "Shipping Container Red",
          "fr": "Conteneur rouge",
          "es": "Contenedor de carga rojo",
          "de": "Versandbehälter Rot",
          "pt": "Contêiner de Carga Vermelho",
          "it": "Container di Spedizione Rosso",
          "tr": "Shipping Container Red",
          "pl": "Czerwony Kontener transportowy",
          "ru": "Красный Транспортный Контейнер",
          "uk": "Shipping Container Red",
          "ko": "선적 컨테이너 레드",
          "zh": "红色运输集装箱",
          "ja": "Shipping Container Red"
        },
        {
          "id": "ShippingContainerGreenItem",
          "en": "Shipping Container Green",
          "fr": "Conteneur vert",
          "es": "Contenedor de carga verde",
          "de": "Versandbehälter Grün",
          "pt": "Contêiner de Carga Verde",
          "it": "Container di Spedizione Verde",
          "tr": "Shipping Container Green",
          "pl": "Zielony Kontener transportowy",
          "ru": "Зеленый Транспортный Контейнер",
          "uk": "Shipping Container Green",
          "ko": "선적 컨테이너 그린",
          "zh": "绿色运输集装箱",
          "ja": "Shipping Container Green"
        },
        {
          "id": "ShippingContainerBlueItem",
          "en": "Shipping Container Blue",
          "fr": "Conteneur bleu",
          "es": "Contenedor de carga azul",
          "de": "Versandbehälter Blau",
          "pt": "Contêiner de Carga Azul",
          "it": "Container di Spedizione Blu",
          "tr": "Shipping Container Blue",
          "pl": "Niebieski Kontener transportowy",
          "ru": "Синий Транспортный Контейнер",
          "uk": "Shipping Container Blue",
          "ko": "배송 컨테이너 블루",
          "zh": "蓝色运输集装箱",
          "ja": "Shipping Container Blue"
        },
        {
          "id": "PrintingPressItem",
          "en": "Printing Press",
          "fr": "Presse à imprimer",
          "es": "Imprenta",
          "de": "Druckerpresse",
          "pt": "Máquina de Impressão",
          "it": "Stampante",
          "tr": "Printing Press",
          "pl": "Printing Press",
          "ru": "Печатный станок",
          "uk": "Printing Press",
          "ko": "인쇄기",
          "zh": "印刷机",
          "ja": "Printing Press"
        },
        {
          "id": "PaperMachineItem",
          "en": "Paper Machine",
          "fr": "Machine à papier",
          "es": "Prensa de papel",
          "de": "Papiermaschine",
          "pt": "Máquina de Papel",
          "it": "Macchina della Carta",
          "tr": "Paper Machine",
          "pl": "Maszyna do papieru",
          "ru": "Бумагоделательная машина",
          "uk": "Paper Machine",
          "ko": "제지 기계",
          "zh": "造纸机",
          "ja": "Paper Machine"
        },
        {
          "id": "OfficeMailboxItem",
          "en": "Office Mailbox",
          "fr": "Boite aux lettres collective",
          "es": "Buzón de oficina",
          "de": "Office-Mailbox",
          "pt": "Caixa de Correio do Escritório",
          "it": "Cassetta delle Lettere dell\u0027Ufficio",
          "tr": "Office Mailbox",
          "pl": "Office Mailbox",
          "ru": "Офисный Почтовый Ящик",
          "uk": "Office Mailbox",
          "ko": "사무실 사서함",
          "zh": "办公室信箱",
          "ja": "Office Mailbox"
        },
        {
          "id": "MailboxItem",
          "en": "Mailbox",
          "fr": "Boite aux lettres",
          "es": "Buzón",
          "de": "Posteingang",
          "pt": "Caixa de Correio",
          "it": "Cassetta delle Lettere",
          "tr": "Mailbox",
          "pl": "Mailbox",
          "ru": "Почтовый Ящик",
          "uk": "Mailbox",
          "ko": "사서함",
          "zh": "信箱",
          "ja": "Mailbox"
        },
        {
          "id": "LoomItem",
          "en": "Loom",
          "fr": "Métier à tisser",
          "es": "Telar",
          "de": "Webstuhl",
          "pt": "Tear",
          "it": "Telaio",
          "tr": "Loom",
          "pl": "Krosno tkackie",
          "ru": "Ткацкий станок",
          "uk": "Loom",
          "ko": "직조기",
          "zh": "织布机",
          "ja": "織機"
        },
        {
          "id": "InjectionMoldMachineItem",
          "en": "Injection Mold Machine",
          "fr": "Presse à injection",
          "es": "Máquina de moldeo por inyección",
          "de": "Spritzgußmaschine",
          "pt": "Máquina de Moldagem por Injeção",
          "it": "Macchina di Iniezione Muffa",
          "tr": "Injection Mold Machine",
          "pl": "Injection Mold Machine",
          "ru": "Термопластавтомат",
          "uk": "Injection Mold Machine",
          "ko": "사출 금형 기계",
          "zh": "模具注塑机",
          "ja": "Injection Mold Machine"
        },
        {
          "id": "IndustrialRefrigeratorItem",
          "en": "Industrial Refrigerator",
          "fr": "Réfrigérateur industriel",
          "es": "Nevera industrial",
          "de": "Industrieller Kühlschrank",
          "pt": "Refrigerador Industrial",
          "it": "Frigorifero Industriale",
          "tr": "Industrial Refrigerator",
          "pl": "Industrial Refrigerator",
          "ru": "Промышленный Холодильник",
          "uk": "Industrial Refrigerator",
          "ko": "공업용 냉장고",
          "zh": "工业冷藏库",
          "ja": "Industrial Refrigerator"
        },
        {
          "id": "EaselItem",
          "en": "Easel",
          "fr": "Chevalet",
          "es": "Caballete",
          "de": "Staffelei",
          "pt": "Cavalete",
          "it": "Cavalletto",
          "tr": "Easel",
          "pl": "Easel",
          "ru": "Мольберт",
          "uk": "Easel",
          "ko": "이젤",
          "zh": "画架",
          "ja": "Easel"
        },
        {
          "id": "DumpsterRecycleItem",
          "en": "Dumpster Recycle",
          "fr": "Benne à ordures recyclables",
          "es": "Contenedor de reciclables",
          "de": "Recyclingcontainer",
          "pt": "Deposito de Lixo Reciclável",
          "it": "Discarica Riciclaggio",
          "tr": "Dumpster Recycle",
          "pl": "Dumpster Recycle",
          "ru": "Мусорный контейнер",
          "uk": "Dumpster Recycle",
          "ko": "쓰레기 수거통 재활용",
          "zh": "垃圾回收桶",
          "ja": "Dumpster Recycle"
        },
        {
          "id": "DumpsterGarbageItem",
          "en": "Dumpster Garbage",
          "fr": "Benne à ordures",
          "es": "Contenedor de basura",
          "de": "Müllcontainer",
          "pt": "Deposito de Lixo Comum",
          "it": "Discarica Rifiuti",
          "tr": "Dumpster Garbage",
          "pl": "Dumpster Garbage",
          "ru": "Мусорный контейнер",
          "uk": "Dumpster Garbage",
          "ko": "쓰레기 수거통",
          "zh": "垃圾铁桶",
          "ja": "Dumpster Garbage"
        },
        {
          "id": "DumpsterCompostItem",
          "en": "Dumpster Compost",
          "fr": "Benne à compost",
          "es": "Contenedor de compostables",
          "de": "Biomüllcontainer",
          "pt": "Deposito de Lixo Compostável",
          "it": "Discarica Composto",
          "tr": "Dumpster Compost",
          "pl": "Dumpster Compost",
          "ru": "Мусорный контейнер для компоста",
          "uk": "Dumpster Compost",
          "ko": "쓰레기통 퇴비",
          "zh": "肥料垃圾桶",
          "ja": "Dumpster Compost"
        },
        {
          "id": "CrabPotItem",
          "en": "Crab Pot",
          "fr": "Casier à crabes",
          "es": "Cazuela de cangrejo",
          "de": "Krabbentopf",
          "pt": "Armadilha de Caranguejo",
          "it": "Casseruola del Granchio",
          "tr": "Crab Pot",
          "pl": "Crab Pot",
          "ru": "Ловушка для крабов",
          "uk": "Crab Pot",
          "ko": "게 통발",
          "zh": "蟹笼",
          "ja": "カニ用の罠"
        },
        {
          "id": "AutomaticLoomItem",
          "en": "Automatic Loom",
          "fr": "Métier à tisser automatique",
          "es": "Telar mecánico",
          "de": "Automatischer Webstuhl",
          "pt": "Tear automático",
          "it": "Impilatore Automatico",
          "tr": "Automatic Loom",
          "pl": "Zautomatyzowane Krosno tkackie",
          "ru": "Автоматический ткацкий станок",
          "uk": "Automatic Loom",
          "ko": "자동 직조기",
          "zh": "自动织布机",
          "ja": "自動織機"
        },
        {
          "id": "AdvancedTailoringTableItem",
          "en": "Advanced Tailoring Table",
          "fr": "Établi de couture avancé",
          "es": "Mesa de sastrería avanzada",
          "de": "Verbesserter Schneidertisch",
          "pt": "Mesa de alfaiataria avançada",
          "it": "Banco di Sartoria Avanzato",
          "tr": "Advanced Tailoring Table",
          "pl": "Zaawansowany stół krawiecki",
          "ru": "Продвинутый Стол Портного",
          "uk": "Advanced Tailoring Table",
          "ko": "고급 재단 작업대",
          "zh": "高级裁缝台",
          "ja": "Advanced Tailoring Table"
        },
        {
          "id": "CottonSeedItem",
          "en": "Cotton Seed",
          "fr": "Graine de coton",
          "es": "Semilla de algodón",
          "de": "Samen (Baumwollpflanze)",
          "pt": "Semente de Algodão",
          "it": "Semi di Cotone",
          "tr": "Cotton Seed",
          "pl": "Nasiono bawełny",
          "ru": "Семечко хлопка",
          "uk": "Cotton Seed",
          "ko": "목화씨",
          "zh": "棉花种子",
          "ja": "Cotton Seed"
        },
        {
          "id": "WoolYarnItem",
          "en": "Wool Yarn",
          "fr": "Fil de laine",
          "es": "Hilo de lana",
          "de": "Wollgarn",
          "pt": "Fios de Lã",
          "it": "Filo di Lana",
          "tr": "Wool Yarn",
          "pl": "Wool Yarn",
          "ru": "Шерстяная пряжа",
          "uk": "Wool Yarn",
          "ko": "양모사",
          "zh": "毛纱",
          "ja": "Wool Yarn"
        },
        {
          "id": "WoolFabricItem",
          "en": "Wool Fabric",
          "fr": "Tissu en laine",
          "es": "Tela de lana",
          "de": "Wollstoff",
          "pt": "Tecido de Lã",
          "it": "Tessuto di Lana",
          "tr": "Wool Fabric",
          "pl": "Tkanina wełniana",
          "ru": "Шерстяная ткань",
          "uk": "Wool Fabric",
          "ko": "모직물",
          "zh": "呢绒",
          "ja": "Wool Fabric"
        },
        {
          "id": "ShornWoolItem",
          "en": "Shorn Wool",
          "fr": "Laine tondue",
          "es": "Lana esquilada",
          "de": "Geschorene Wolle",
          "pt": "Lã Cortada",
          "it": "Lana Tosata",
          "tr": "Shorn Wool",
          "pl": "Shorn Wool",
          "ru": "Стриженная шерсть",
          "uk": "Shorn Wool",
          "ko": "뿔양털",
          "zh": "剪绒毛",
          "ja": "Shorn Wool"
        },
        {
          "id": "NylonThreadItem",
          "en": "Nylon Thread",
          "fr": "Fil de nylon",
          "es": "Fibra de nailon",
          "de": "Nylonfaden",
          "pt": "Fio de Náilon",
          "it": "Filo di Nylon",
          "tr": "Nylon Thread",
          "pl": "Nić nylonowa",
          "ru": "Нейлоновая нить",
          "uk": "Nylon Thread",
          "ko": "나일론 실",
          "zh": "尼龙线",
          "ja": "ナイロン糸"
        },
        {
          "id": "NylonFabricItem",
          "en": "Nylon Fabric",
          "fr": "Tissu en nylon",
          "es": "Tela de nailon",
          "de": "Nylonstoff",
          "pt": "Tecido de Náilon",
          "it": "Tessuto di Nylon",
          "tr": "Nylon Fabric",
          "pl": "Tkanina nylonowa",
          "ru": "Нейлоновая ткань",
          "uk": "Nylon Fabric",
          "ko": "나일론 원단",
          "zh": "尼龙织物",
          "ja": "ナイロン生地"
        },
        {
          "id": "NylonChipsItem",
          "en": "Nylon Chips",
          "fr": "Copeaux de nylon",
          "es": "Virutas de nailon",
          "de": "Nylonchips",
          "pt": "Chips de Náilon",
          "it": "Chip di Nylon",
          "tr": "Nylon Chips",
          "pl": "Nylon Chips",
          "ru": "Нейлоновые гранулы",
          "uk": "Nylon Chips",
          "ko": "나일론 칩",
          "zh": "尼龙碎屑",
          "ja": "Nylon Chips"
        },
        {
          "id": "NylonItem",
          "en": "Nylon",
          "fr": "Nylon",
          "es": "Nailon",
          "de": "Nylon",
          "pt": "Náilon",
          "it": "Nylon",
          "tr": "Nylon",
          "pl": "Nylon",
          "ru": "Нейлон",
          "uk": "Nylon",
          "ko": "나일론",
          "zh": "尼龙",
          "ja": "ナイロン"
        },
        {
          "id": "CottonThreadItem",
          "en": "Cotton Thread",
          "fr": "Fil de coton",
          "es": "Fibra de algodón",
          "de": "Baumwollfaden",
          "pt": "Fio de Algodão",
          "it": "Filo di Cotone",
          "tr": "Cotton Thread",
          "pl": "Nici bawełniane",
          "ru": "Хлопковая нить",
          "uk": "Cotton Thread",
          "ko": "면사",
          "zh": "棉线",
          "ja": "Cotton Thread"
        },
        {
          "id": "CottonFabricItem",
          "en": "Cotton Fabric",
          "fr": "Tissu en coton",
          "es": "Tela de algodón",
          "de": "Baumwollstoff",
          "pt": "Tecido de Algodão",
          "it": "Tessuto di Cotone",
          "tr": "Cotton Fabric",
          "pl": "Tkanina bawełniana",
          "ru": "Хлопковая ткань",
          "uk": "Cotton Fabric",
          "ko": "면직물",
          "zh": "棉织物",
          "ja": "Cotton Fabric"
        },
        {
          "id": "CottonBollItem",
          "en": "Cotton Boll",
          "fr": "Capsule de coton",
          "es": "Bellota de algodón",
          "de": "Baumwoll Samenkapsel",
          "pt": "Cápsula de Algodão",
          "it": "Cotone",
          "tr": "Cotton Boll",
          "pl": "Bawełniana kulka",
          "ru": "Хлопковая коробочка",
          "uk": "Cotton Boll",
          "ko": "목화 솜",
          "zh": "棉桃",
          "ja": "Cotton Boll"
        },
        {
          "id": "TailorShoesItem",
          "en": "Tailor Shoes",
          "fr": "Ensemble de tailleur : Chaussures",
          "es": "Zapatos de sastre",
          "de": "Schneiderschuhe",
          "pt": "Sapatos de Alfaiate",
          "it": "Scarpe del Sarto",
          "tr": "Tailor Shoes",
          "pl": "Buty krawca",
          "ru": "Ботинки Портного",
          "uk": "Tailor Shoes",
          "ko": "재단사 신발",
          "zh": "裁缝的鞋子",
          "ja": "Tailor Shoes"
        },
        {
          "id": "TailorShirtItem",
          "en": "Tailor Shirt",
          "fr": "Ensemble de tailleur : Chemise",
          "es": "Camisa de sastre",
          "de": "Schneiderhemd",
          "pt": "Camisa de Alfaiate",
          "it": "Camicia del Sarto",
          "tr": "Tailor Shirt",
          "pl": "Koszula Krawca",
          "ru": "Рубашка Портного",
          "uk": "Tailor Shirt",
          "ko": "재단사 셔츠",
          "zh": "裁缝的衬衫",
          "ja": "Tailor Shirt"
        },
        {
          "id": "TailorPantsItem",
          "en": "Tailor Pants",
          "fr": "Ensemble de tailleur : Pantalon",
          "es": "Pantalones de sastre",
          "de": "Schneiderhose",
          "pt": "Calça de Alfaiate",
          "it": "Pantaloni del Sarto",
          "tr": "Tailor Pants",
          "pl": "Spodnie krawca",
          "ru": "Штаны Портного",
          "uk": "Tailor Pants",
          "ko": "재단사 바지",
          "zh": "裁缝的裤子",
          "ja": "Tailor Pants"
        },
        {
          "id": "TailorBowlerHatItem",
          "en": "Tailor Bowler Hat",
          "fr": "Ensemble de tailleur : Chapeau melon",
          "es": "Bombín de sastre",
          "de": "Schneidermelone",
          "pt": "Chapéu-coco de Alfaiate",
          "it": "Bombetta del Sarto",
          "tr": "Tailor Bowler Hat",
          "pl": "Melonik krawca",
          "ru": "Шляпа-котелок Портного",
          "uk": "Tailor Bowler Hat",
          "ko": "재단사 중산모",
          "zh": "裁缝的圆顶礼帽",
          "ja": "Tailor Bowler Hat"
        },
        {
          "id": "SmithPantsItem",
          "en": "Smith Pants",
          "fr": "Ensemble de forgeron : Pantalon",
          "es": "Pantalones de herrero",
          "de": "Schmiedhose",
          "pt": "Calça de Ferreiro",
          "it": "Pantaloni del Fabbro",
          "tr": "Smith Pants",
          "pl": "Spodnie kowala",
          "ru": "Штаны Кузнеца",
          "uk": "Smith Pants",
          "ko": "대장장이 바지",
          "zh": "铁匠的裤子",
          "ja": "Smith Pants"
        },
        {
          "id": "SmithGlovesItem",
          "en": "Smith Gloves",
          "fr": "Ensemble de forgeron : Gants",
          "es": "Guantes de herrero",
          "de": "Schmiedhandschuhe",
          "pt": "Luvas de Ferreiro",
          "it": "Guanti del Fabbro",
          "tr": "Smith Gloves",
          "pl": "Rękawice kowala",
          "ru": "Перчатки Кузнеца",
          "uk": "Smith Gloves",
          "ko": "대장장이 장갑",
          "zh": "铁匠的手套",
          "ja": "Smith Gloves"
        },
        {
          "id": "SmithBootsItem",
          "en": "Smith Boots",
          "fr": "Ensemble de forgeron : Bottes",
          "es": "Botas de herrero",
          "de": "Schmiedstiefel",
          "pt": "Botas de Ferreiro",
          "it": "Stivali del Fabbro",
          "tr": "Smith Boots",
          "pl": "Buty kowala",
          "ru": "Ботинки Кузнеца",
          "uk": "Smith Boots",
          "ko": "대장장이 부츠",
          "zh": "铁匠的靴子",
          "ja": "Smith Boots"
        },
        {
          "id": "SmithBandanaItem",
          "en": "Smith Bandana",
          "fr": "Ensemble de forgeron : Bandana",
          "es": "Pañuelo de herrero",
          "de": "Schmiedbandana",
          "pt": "Bandana de Ferreiro",
          "it": "Bandana del Fabbro",
          "tr": "Smith Bandana",
          "pl": "Bandana kowala",
          "ru": "Бандана Кузнеца",
          "uk": "Smith Bandana",
          "ko": "대장장이 반다나",
          "zh": "铁匠的头巾",
          "ja": "Smith Bandana"
        },
        {
          "id": "SmithApronItem",
          "en": "Smith Apron",
          "fr": "Ensemble de forgeron : Tablier",
          "es": "Delantal de herrero",
          "de": "Schmiedeschürze",
          "pt": "Avental de Ferreiro",
          "it": "Grembiule del Fabbro",
          "tr": "Smith Apron",
          "pl": "Fartuch kowala",
          "ru": "Фартук Кузнеца",
          "uk": "Smith Apron",
          "ko": "대장장이 앞치마",
          "zh": "铁匠的围裙",
          "ja": "Smith Apron"
        },
        {
          "id": "FarmerShirtItem",
          "en": "Farmer Shirt",
          "fr": "Ensemble de fermier : Chemise",
          "es": "Camisa de granjero",
          "de": "Farmerhemd",
          "pt": "Camisa de Agricultor",
          "it": "Camicia dell\u0027Agricoltore",
          "tr": "Farmer Shirt",
          "pl": "Koszula Rolnika",
          "ru": "Рубашка Фермера",
          "uk": "Farmer Shirt",
          "ko": "농부 셔츠",
          "zh": "农民的衬衫",
          "ja": "Farmer Shirt"
        },
        {
          "id": "FarmerOverallsItem",
          "en": "Farmer Overalls",
          "fr": "Ensemble de fermier : Salopette",
          "es": "Mono de granjero",
          "de": "Farmeroveralls",
          "pt": "Macacão de Agricultor",
          "it": "Salopette dell\u0027Agricoltore",
          "tr": "Farmer Overalls",
          "pl": "Kombinezon Rolnika",
          "ru": "Комбинезон Фермера",
          "uk": "Farmer Overalls",
          "ko": "농부 작업복",
          "zh": "农民的工装裤",
          "ja": "Farmer Overalls"
        },
        {
          "id": "FarmerHatItem",
          "en": "Farmer Hat",
          "fr": "Ensemble de fermier : Chapeau",
          "es": "Sombrero de granjero",
          "de": "Farmerhut",
          "pt": "Chapéu de Agricultor",
          "it": "Cappello dell\u0027Agricoltore",
          "tr": "Farmer Hat",
          "pl": "Kapelusz Rolnika",
          "ru": "Шляпа Фермера",
          "uk": "Farmer Hat",
          "ko": "농부 모자",
          "zh": "农民的帽子",
          "ja": "Farmer Hat"
        },
        {
          "id": "FarmerGlovesItem",
          "en": "Farmer Gloves",
          "fr": "Ensemble de fermier : Gants",
          "es": "Guantes de granjero",
          "de": "Farmerhandschuhe",
          "pt": "Luvas de Agricultor",
          "it": "Guanti dell\u0027Agricoltore",
          "tr": "Farmer Gloves",
          "pl": "Rękawice Rolnika",
          "ru": "Перчатки Фермера",
          "uk": "Farmer Gloves",
          "ko": "농부 장갑",
          "zh": "农民的手套",
          "ja": "Farmer Gloves"
        },
        {
          "id": "FarmerBootsItem",
          "en": "Farmer Boots",
          "fr": "Ensemble de fermier : Bottes",
          "es": "Botas de granjero",
          "de": "Farmerstiefel",
          "pt": "Botas de Agricultor",
          "it": "Stivali dell\u0027Agricoltore",
          "tr": "Farmer Boots",
          "pl": "Buty Rolnika",
          "ru": "Ботинки Фермера",
          "uk": "Farmer Boots",
          "ko": "농부 부츠",
          "zh": "农民的靴子",
          "ja": "Farmer Boots"
        },
        {
          "id": "BuilderShirtItem",
          "en": "Builder Shirt",
          "fr": "Ensemble de chantier : Chemise",
          "es": "Camisa de constructor",
          "de": "Baumeisterhemd",
          "pt": "Camisa de Construtor",
          "it": "Camicia del Costruttore",
          "tr": "Builder Shirt",
          "pl": "Koszula Budowniczego",
          "ru": "Рубашка Строителя",
          "uk": "Builder Shirt",
          "ko": "건축가 셔츠",
          "zh": "建筑工的衬衫",
          "ja": "Builder Shirt"
        },
        {
          "id": "BuilderOverallsItem",
          "en": "Builder Overalls",
          "fr": "Ensemble de chantier : Salopette",
          "es": "Mono de constructor",
          "de": "Baumeisteroverall",
          "pt": "Macacão de Construtor",
          "it": "Salopette del Costruttore",
          "tr": "Builder Overalls",
          "pl": "Kombinezon Budowniczego",
          "ru": "Комбинезон Строителя",
          "uk": "Builder Overalls",
          "ko": "건축가 작업복",
          "zh": "建筑工的工装裤",
          "ja": "Builder Overalls"
        },
        {
          "id": "BuilderHelmetItem",
          "en": "Builder Helmet",
          "fr": "Ensemble de chantier : Casque",
          "es": "Casco de constructor",
          "de": "Baumeisterhelm",
          "pt": "Capacete de Construtor",
          "it": "Casco del Costruttore",
          "tr": "Builder Helmet",
          "pl": "Kapelusz Budowniczego",
          "ru": "Каска Строителя",
          "uk": "Builder Helmet",
          "ko": "건축가 헬멧",
          "zh": "建筑工的安全帽",
          "ja": "建築者のヘルメット"
        },
        {
          "id": "BuilderGlovesItem",
          "en": "Builder Gloves",
          "fr": "Ensemble de chantier : Gants",
          "es": "Guantes de constructor",
          "de": "Baumeisterhandschuhe",
          "pt": "Luvas de Construtor",
          "it": "Guanti del Costruttore",
          "tr": "Builder Gloves",
          "pl": "Rękawice Budowniczego",
          "ru": "Перчатки Строителя",
          "uk": "Builder Gloves",
          "ko": "건축가 장갑",
          "zh": "建筑工的手套",
          "ja": "建築者のグローブ"
        },
        {
          "id": "BuilderBootsItem",
          "en": "Builder Boots",
          "fr": "Ensemble de chantier : Bottes",
          "es": "Botas de constructor",
          "de": "Baumeisterstiefel",
          "pt": "Botas de Construtor",
          "it": "Stivali del Costruttore",
          "tr": "Builder Boots",
          "pl": "Buty Budowniczego",
          "ru": "Ботинки Строителя",
          "uk": "Builder Boots",
          "ko": "건축가 부츠",
          "zh": "建筑工的靴子",
          "ja": "Builder Boots"
        },
        {
          "id": "WoolCurtainsItem",
          "en": "Wool Curtains",
          "fr": "Rideaux en laine",
          "es": "Cortinas de lana",
          "de": "Wollvorhänge",
          "pt": "Cortinas de lã",
          "it": "Tende in Lana",
          "tr": "Wool Curtains",
          "pl": "Wool Curtains",
          "ru": "Шерстяные Шторы",
          "uk": "Wool Curtains",
          "ko": "양모 커튼",
          "zh": "羊毛窗帘",
          "ja": "Wool Curtains"
        },
        {
          "id": "NylonCarpetItem",
          "en": "Nylon Carpet",
          "fr": "Moquette en nylon",
          "es": "Alfombra de nailon",
          "de": "Nylonteppich",
          "pt": "Tapete de náilon",
          "it": "Tappeto in Nylon",
          "tr": "Nylon Carpet",
          "pl": "Dywan z nylonu",
          "ru": "Нейлоновый ковер",
          "uk": "Nylon Carpet",
          "ko": "나일론 카펫",
          "zh": "尼龙地毯",
          "ja": "Nylon Carpet"
        },
        {
          "id": "WoolCarpetItem",
          "en": "Wool Carpet",
          "fr": "Moquette en laine",
          "es": "Alfombra de lana",
          "de": "Wollteppich",
          "pt": "Tapete de lã",
          "it": "Tappeto in Lana",
          "tr": "Wool Carpet",
          "pl": "Wool Carpet",
          "ru": "Шерстяной ковер",
          "uk": "Wool Carpet",
          "ko": "양모 카펫",
          "zh": "羊毛地毯",
          "ja": "Wool Carpet"
        },
        {
          "id": "NylonCurtainsItem",
          "en": "Nylon Curtains",
          "fr": "Rideaux en nylon",
          "es": "Cortinas de nailon",
          "de": "Nylonvorhänge",
          "pt": "Cortinas de náilon",
          "it": "Tende in Nylon",
          "tr": "Nylon Curtains",
          "pl": "Zasłony z nylonu",
          "ru": "Нейлоновые шторы",
          "uk": "Nylon Curtains",
          "ko": "나일론 커튼",
          "zh": "尼龙窗帘",
          "ja": "ナイロンのカーテン"
        },
        {
          "id": "CrushedMixedRockItem",
          "en": "Crushed Mixed Rock",
          "fr": "Mélange de pierres concassées",
          "es": "Mezcla de rocas triturada",
          "de": "Zerstoßener gemischter Stein",
          "pt": "Rocha mista triturada",
          "it": "Roccia Mista Spaccata",
          "tr": "Crushed Mixed Rock",
          "pl": "Crushed Mixed Rock",
          "ru": "Дробленый Смешанный Камень",
          "uk": "Crushed Mixed Rock",
          "ko": "파쇄된 혼합석",
          "zh": "压碎的混合岩石",
          "ja": "Crushed Mixed Rock"
        },
        {
          "id": "CottonCurtainsItem",
          "en": "Cotton Curtains",
          "fr": "Rideaux en coton",
          "es": "Cortinas de algodón",
          "de": "Baumwollvorhänge",
          "pt": "Cortinas de algodão",
          "it": "Tende in Cotone",
          "tr": "Cotton Curtains",
          "pl": "Bawełniane zasłony",
          "ru": "Хлопковые шторы",
          "uk": "Cotton Curtains",
          "ko": "면 커튼",
          "zh": "棉制窗帘",
          "ja": "Cotton Curtains"
        },
        {
          "id": "CottonCarpetItem",
          "en": "Cotton Carpet",
          "fr": "Moquette en coton",
          "es": "Alfombra de algodón",
          "de": "Baumwollteppich",
          "pt": "Tapete de algodão",
          "it": "Tappeto in Cotone",
          "tr": "Cotton Carpet",
          "pl": "Bawełniany dywan",
          "ru": "Хлопковый ковер",
          "uk": "Cotton Carpet",
          "ko": "면 카펫",
          "zh": "棉制地毯",
          "ja": "Cotton Carpet"
        },
        {
          "id": "ExplorerShirtItem",
          "en": "Explorer Shirt",
          "fr": "Ensemble d\u0027explorateur : Chemise",
          "es": "Camisa de explorador",
          "de": "Forscherhemd",
          "pt": "Camisa de Explorador",
          "it": "Camicia dell\u0027Esploratore",
          "tr": "Explorer Shirt",
          "pl": "Koszula Odkrywcy",
          "ru": "Китель Исследователя",
          "uk": "Explorer Shirt",
          "ko": "탐험가 셔츠",
          "zh": "探索者的衬衫",
          "ja": "Explorer Shirt"
        },
        {
          "id": "ExplorerPantsItem",
          "en": "Explorer Pants",
          "fr": "Ensemble d\u0027explorateur : Pantalon",
          "es": "Pantalones de explorador",
          "de": "Forscherhose",
          "pt": "Calças de Explorador",
          "it": "Pantaloni dell\u0027Esploratore",
          "tr": "Explorer Pants",
          "pl": "Spodnie Odkrywcy",
          "ru": "Штаны Исследователя",
          "uk": "Explorer Pants",
          "ko": "탐험가 바지",
          "zh": "探索者的裤子",
          "ja": "Explorer Pants"
        },
        {
          "id": "ExplorerHatItem",
          "en": "Explorer Hat",
          "fr": "Ensemble d\u0027explorateur : Chapeau",
          "es": "Gorro de explorador",
          "de": "Forscherhut",
          "pt": "Chapéu de Explorador",
          "it": "Cappello dell\u0027Esploratore",
          "tr": "Explorer Hat",
          "pl": "Kapelusz odkrywcy",
          "ru": "Пробковый шлем",
          "uk": "Explorer Hat",
          "ko": "탐험가 모자",
          "zh": "探索者的帽子",
          "ja": "Explorer Hat"
        },
        {
          "id": "ExplorerGlovesItem",
          "en": "Explorer Gloves",
          "fr": "Ensemble d\u0027explorateur : Gants",
          "es": "Guantes de explorador",
          "de": "Forscherhandschuhe",
          "pt": "Luvas de Explorador",
          "it": "Guanti dell\u0027Esploratore",
          "tr": "Explorer Gloves",
          "pl": "Rękawice Odkrywcy",
          "ru": "Перчатки Исследователя",
          "uk": "Explorer Gloves",
          "ko": "탐험가 장갑",
          "zh": "探索者的手套",
          "ja": "Explorer Gloves"
        },
        {
          "id": "ChefShoesItem",
          "en": "Chef Shoes",
          "fr": "Ensemble de cuisinier : Chaussures",
          "es": "Zapatos de cocinero",
          "de": "Kochschuhe",
          "pt": "Sapatos de Chefe de Cozinha",
          "it": "Scarpe del Cuoco",
          "tr": "Chef Shoes",
          "pl": "Buty kuchmistrza",
          "ru": "Ботинки Повара",
          "uk": "Chef Shoes",
          "ko": "요리사 신발",
          "zh": "厨师的鞋子",
          "ja": "Chef Shoes"
        },
        {
          "id": "ChefShirtItem",
          "en": "Chef Shirt",
          "fr": "Ensemble de cuisinier : Veste",
          "es": "Camisa de cocinero",
          "de": "Kochhemd",
          "pt": "Camisa de Chefe de Cozinha",
          "it": "Camicia del Cuoco",
          "tr": "Chef Shirt",
          "pl": "Koszula kuchmistrza",
          "ru": "Китель Повара",
          "uk": "Chef Shirt",
          "ko": "요리사 셔츠",
          "zh": "厨师的衬衫",
          "ja": "Chef Shirt"
        },
        {
          "id": "ChefPantsItem",
          "en": "Chef Pants",
          "fr": "Ensemble de cuisinier : Pantalon",
          "es": "Pantalones de cocinero",
          "de": "Kochhosen",
          "pt": "Calças de Chefe de Cozinha",
          "it": "Pantaloni del Cuoco",
          "tr": "Chef Pants",
          "pl": "Spodnie kuchmistrza",
          "ru": "Штаны Повара",
          "uk": "Chef Pants",
          "ko": "요리사 바지",
          "zh": "厨师的裤子",
          "ja": "Chef Pants"
        },
        {
          "id": "ChefHatItem",
          "en": "Chef Hat",
          "fr": "Ensemble de cuisinier : Toque",
          "es": "Gorro de cocinero",
          "de": "Kochmütze",
          "pt": "Chapéu de Chefe de Cozinha",
          "it": "Cappello del Cuoco",
          "tr": "Chef Hat",
          "pl": "Czapka kuchmistrza",
          "ru": "Колпак Повара",
          "uk": "Chef Hat",
          "ko": "요리사 모자",
          "zh": "厨师的帽子",
          "ja": "Chef Hat"
        },
        {
          "id": "Fertilizer",
          "en": "Fertilizer",
          "fr": "Engrais",
          "es": "Fertilizante",
          "de": "Dünger",
          "pt": "Fertilizante",
          "it": "Fertilizzante",
          "tr": "Fertilizer",
          "pl": "Fertilizer",
          "ru": "Удобрение",
          "uk": "Fertilizer",
          "ko": "비료",
          "zh": "化肥",
          "ja": "Fertilizer"
        },
        {
          "id": "ExplorerBootsItem",
          "en": "Explorer Boots",
          "fr": "Ensemble d\u0027explorateur : Bottes",
          "es": "Botas de explorador",
          "de": "Forscherstiefel",
          "pt": "Botas de Explorador",
          "it": "Stivali da Esploratore",
          "tr": "Explorer Boots",
          "pl": "Buty Odkrywcy",
          "ru": "Ботинки Исследователя",
          "uk": "Explorer Boots",
          "ko": "탐험가 부츠",
          "zh": "探索者的靴子",
          "ja": "探検者のブーツ"
        },
        {
          "id": "BeaverCarcassItem",
          "en": "Beaver Carcass",
          "fr": "Cadavre de castor",
          "es": "Cadáver de castor",
          "de": "Biberkadaver",
          "pt": "Carcaça de Castor",
          "it": "Carcassa di Castoro",
          "tr": "Beaver Carcass",
          "pl": "Tusza bobra",
          "ru": "Туша бобра",
          "uk": "Beaver Carcass",
          "ko": "비버 사체",
          "zh": "海狸遗骸",
          "ja": "Beaver Carcass"
        },
        {
          "id": "MarmotCarcassItem",
          "en": "Marmot Carcass",
          "fr": "Cadavre de marmotte",
          "es": "Cadáver de marmota",
          "de": "Murmeltierkadaver",
          "pt": "Carcaça de Marmota",
          "it": "Carcassa di Marmotta",
          "tr": "Marmot Carcass",
          "pl": "Tusza świstaka",
          "ru": "Туша сурка",
          "uk": "Marmot Carcass",
          "ko": "마멋 사체",
          "zh": "土拨鼠遗骸",
          "ja": "Marmot Carcass"
        },
        {
          "id": "PrairieDogCarcassItem",
          "en": "Prairie Dog Carcass",
          "fr": "Cadavre de chien de prairie",
          "es": "Cadáver de perrito de las praderas",
          "de": "Präriehundkadaver",
          "pt": "Carcaça de Cão-da-pradaria",
          "it": "Carcassa di Cane delle Praterie",
          "tr": "Prairie Dog Carcass",
          "pl": "Tusza nieświszczuka",
          "ru": "Туша луговой собачки",
          "uk": "Prairie Dog Carcass",
          "ko": "개쥐 사체",
          "zh": "草原犬鼠遗骸",
          "ja": "Prairie Dog Carcass"
        },
        {
          "id": "TailoringModernUpgradeItem",
          "en": "Tailoring Modern Upgrade",
          "fr": "Amélioration moderne : Couture",
          "es": "Mejora moderna: Sastrería",
          "de": "Modernes Upgrade: Schneidern",
          "pt": "Melhoria Moderna de Compósitos",
          "it": "Aggiornamento Moderno Sartoria",
          "tr": "Tailoring Modern Upgrade",
          "pl": "Nowoczesne ulepszenie Krawiectwa",
          "ru": "Современное улучшение для портняжного дела",
          "uk": "Tailoring Modern Upgrade",
          "ko": "현대식 재단 업그레이드",
          "zh": "裁缝现代化升级",
          "ja": "Tailoring Modern Upgrade"
        },
        {
          "id": "BlackboardItem",
          "en": "Blackboard",
          "fr": "Tableau noir",
          "es": "Pizarra",
          "de": "Schwarzes Brett",
          "pt": "Quadro-negro",
          "it": "Lavagna",
          "tr": "Blackboard",
          "pl": "Blackboard",
          "ru": "Классная доска",
          "uk": "Blackboard",
          "ko": "칠판",
          "zh": "黑板",
          "ja": "Blackboard"
        },
        {
          "id": "CanningAssemblyItem",
          "en": "Canning Assembly",
          "fr": "Ligne de mise en conserve",
          "es": "Montaje de conservas",
          "de": "Dosenmacherei",
          "pt": "Montagem de Conservas",
          "it": "Assemblaggio Conserviero",
          "tr": "Canning Assembly",
          "pl": "Canning Assembly",
          "ru": "Линия производства консерв",
          "uk": "Canning Assembly",
          "ko": "통조림 공장",
          "zh": "罐头装配",
          "ja": "Canning Assembly"
        },
        {
          "id": "CastIronBedItem",
          "en": "Cast Iron Bed",
          "fr": "Lit en fer forgé",
          "es": "Cama de hierro fundido",
          "de": "Gusseisernes Bett",
          "pt": "Cama de Ferro Fundido",
          "it": "Letto in Ghisa",
          "tr": "Cast Iron Bed",
          "pl": "Żeliwne łóżko",
          "ru": "Чугунная кровать",
          "uk": "Cast Iron Bed",
          "ko": "무쇠 침대",
          "zh": "铸铁床",
          "ja": "Cast Iron Bed"
        },
        {
          "id": "CastIronBenchItem",
          "en": "Cast Iron Bench",
          "fr": "Banc en fer forgé",
          "es": "Banco de hierro fundido",
          "de": "Gusseiserne Bank",
          "pt": "Banco de Ferro Fundido",
          "it": "Panca in Ghisa",
          "tr": "Cast Iron Bench",
          "pl": "Żeliwna ławka",
          "ru": "Чугунная лавка",
          "uk": "Cast Iron Bench",
          "ko": "무쇠 벤치",
          "zh": "铸铁长凳",
          "ja": "鋳鉄のベンチ"
        },
        {
          "id": "CastIronChairItem",
          "en": "Cast Iron Chair",
          "fr": "Chaise en fer forgé",
          "es": "Silla de hierro fundido",
          "de": "Gusseiserner Stuhl",
          "pt": "Cadeira de Ferro Fundido",
          "it": "Sedia in Ghisa",
          "tr": "Cast Iron Chair",
          "pl": "Żeliwne krzesło",
          "ru": "Чугунный стул",
          "uk": "Cast Iron Chair",
          "ko": "무쇠 의자",
          "zh": "铸铁椅子",
          "ja": "鋳鉄の椅子"
        },
        {
          "id": "CastIronRoyalBedItem",
          "en": "Cast Iron Royal Bed",
          "fr": "Lit royal en fer forgé",
          "es": "Cama de lujo de hierro fundido",
          "de": "Gusseisernes Königliches Bett",
          "pt": "Cama Real de Ferro Fundido",
          "it": "Letto Reale in Ghisa",
          "tr": "Cast Iron Royal Bed",
          "pl": "Żeliwne łoże królewskie",
          "ru": "Чугунная Королевская Кровать",
          "uk": "Cast Iron Royal Bed",
          "ko": "무쇠 로얄 침대",
          "zh": "铸铁皇家床",
          "ja": "Cast Iron Royal Bed"
        },
        {
          "id": "CastIronTableItem",
          "en": "Cast Iron Table",
          "fr": "Table en fer forgé",
          "es": "Mesa de hierro fundido",
          "de": "Gusseiserner Tisch",
          "pt": "Mesa de Ferro Fundido",
          "it": "Tavolo in Ghisa",
          "tr": "Cast Iron Table",
          "pl": "Żeliwny stół",
          "ru": "Чугунный стол",
          "uk": "Cast Iron Table",
          "ko": "무쇠 테이블",
          "zh": "铸铁桌子",
          "ja": "Cast Iron Table"
        },
        {
          "id": "ElevatorCallPostItem",
          "en": "Elevator Call Post",
          "fr": "Bouton d\u0027appel d\u0027ascenseur",
          "es": "Punto de llamada del ascensor",
          "de": "Holzaufzug-Rufposten",
          "pt": "Posto de Chamada de Elevador",
          "it": "Punto di Chiamata Ascensore",
          "tr": "Elevator Call Post",
          "pl": "Elevator Call Post",
          "ru": "Пульт управления лифтом",
          "uk": "Elevator Call Post",
          "ko": "승강기 호출판",
          "zh": "电梯呼叫站",
          "ja": "Elevator Call Post"
        },
        {
          "id": "FeminineMannequinItem",
          "en": "Feminine Mannequin",
          "fr": "Mannequin femme",
          "es": "Maniquí femenino",
          "de": "Weiblich Männlich",
          "pt": "Manequim Feminino",
          "it": "Manichino Femminile",
          "tr": "Feminine Mannequin",
          "pl": "Feminine Mannequin",
          "ru": "Женский манекен",
          "uk": "Feminine Mannequin",
          "ko": "여성 마네킹",
          "zh": "女模特儿",
          "ja": "Feminine Mannequin"
        },
        {
          "id": "HewnDresserItem",
          "en": "Hewn Dresser",
          "fr": "Commode taillée",
          "es": "Vestidor tallado",
          "de": "Massivholz Kommode",
          "pt": "Cômoda de Madeira Cortada",
          "it": "Comò Scolpito",
          "tr": "Hewn Dresser",
          "pl": "Hewn Dresser",
          "ru": "Комод из тесаного дерева",
          "uk": "Hewn Dresser",
          "ko": "다듬은 원목 옷장",
          "zh": "锯木化妆台",
          "ja": "粗削りのドレッサー"
        },
        {
          "id": "HewnNightstandItem",
          "en": "Hewn Nightstand",
          "fr": "Table de chevet en bois taillé",
          "es": "Mesa de noche tallada",
          "de": "Massivholz Nachttisch",
          "pt": "Criado-mudo",
          "it": "Comodino Scolpito",
          "tr": "Hewn Nightstand",
          "pl": "Hewn Nightstand",
          "ru": "Тумбочка из тесаного дерева",
          "uk": "Hewn Nightstand",
          "ko": "다듬은 원목 협탁",
          "zh": "锯木床头柜",
          "ja": "粗削りのナイトスタンド"
        },
        {
          "id": "HugeBannerSignItem",
          "en": "Huge Banner Sign",
          "fr": "Grande enseigne en toile",
          "es": "Pancarta enorme",
          "de": "Riesiges Bannerschild",
          "pt": "Placa Banner Enorme",
          "it": "Cartello Banner Gigante",
          "tr": "Huge Banner Sign",
          "pl": "Huge Banner Sign",
          "ru": "Огромная вывеска",
          "uk": "Huge Banner Sign",
          "ko": "거대한 횡단막 표지판",
          "zh": "巨型横幅标志",
          "ja": "Huge Banner Sign"
        },
        {
          "id": "HugeIronBannerSignItem",
          "en": "Huge Iron Banner Sign",
          "fr": "Grande enseigne sur pied en fer",
          "es": "Pancarta enorme (hierro)",
          "de": "Riesiges eisernes Bannerschild",
          "pt": "Placa Banner de Ferro Enorme",
          "it": "Cartello Banner Gigante di Ferro",
          "tr": "Huge Iron Banner Sign",
          "pl": "Huge Iron Banner Sign",
          "ru": "Огромная железная вывеска",
          "uk": "Huge Iron Banner Sign",
          "ko": "거대한 철제 횡단막 표지판",
          "zh": "巨型铁质横幅标志",
          "ja": "Huge Iron Banner Sign"
        },
        {
          "id": "HugeIronSignItem",
          "en": "Huge Iron Sign",
          "fr": "Grande enseigne en fer",
          "es": "Letrero enorme (hierro)",
          "de": "Riesiges Eisenschild",
          "pt": "Placa Enorme de Ferro",
          "it": "Cartello di Ferro Gigante",
          "tr": "Huge Iron Sign",
          "pl": "Huge Iron Sign",
          "ru": "Огромный железный знак",
          "uk": "Huge Iron Sign",
          "ko": "거대한 철제 표지판",
          "zh": "巨型铁质标志",
          "ja": "Huge Iron Sign"
        },
        {
          "id": "HugeSteelBannerSignItem",
          "en": "Huge Steel Banner Sign",
          "fr": "Grande enseigne sur pied en acier",
          "es": "Pancarta enorme (acero)",
          "de": "Riesiges stählernes Bannerschild",
          "pt": "Placa Banner de Aço Enorme",
          "it": "Cartello Banner d\u0027Acciaio Gigante",
          "tr": "Huge Steel Banner Sign",
          "pl": "Ogromny stalowy znak banerowy",
          "ru": "Огромная стальная вывеска",
          "uk": "Huge Steel Banner Sign",
          "ko": "거대한 강철 횡단막 표지판",
          "zh": "巨型钢铁横幅标志",
          "ja": "Huge Steel Banner Sign"
        },
        {
          "id": "HugeSteelSignItem",
          "en": "Huge Steel Sign",
          "fr": "Grande enseigne en acier",
          "es": "Letrero enorme (acero)",
          "de": "Riesiges Stahlschild",
          "pt": "Placa Enorme de Aço",
          "it": "Cartello d\u0027Acciaio Gigante",
          "tr": "Huge Steel Sign",
          "pl": "Ogromny stalowy znak",
          "ru": "Огромный стальной знак",
          "uk": "Huge Steel Sign",
          "ko": "거대한 강철 표지판",
          "zh": "巨型钢铁标志",
          "ja": "Huge Steel Sign"
        },
        {
          "id": "HugeWoodenBannerSignItem",
          "en": "Huge Wooden Banner Sign",
          "fr": "Grande enseigne sur pied en bois",
          "es": "Pancarta enorme (madera)",
          "de": "Riesiges hölzernes Bannerschild",
          "pt": "Placa Banner de Madeira Enorme",
          "it": "Cartello Banner Gigante in Legno",
          "tr": "Huge Wooden Banner Sign",
          "pl": "Huge Wooden Banner Sign",
          "ru": "Огромная деревянная вывеска",
          "uk": "Huge Wooden Banner Sign",
          "ko": "거대한 목제 횡단막 표지판",
          "zh": "巨型木质横幅标志",
          "ja": "Huge Wooden Banner Sign"
        },
        {
          "id": "LargeWoodenBookshelfItem",
          "en": "Large Wooden Bookshelf",
          "fr": "Grande bibliothèque en bois",
          "es": "Estantería grande (madera)",
          "de": "Großes hölzernes Bücherregal",
          "pt": "Estante Grande de Madeira",
          "it": "Grande Libreria in Legno",
          "tr": "Large Wooden Bookshelf",
          "pl": "Średnia drewniana biblioteczka",
          "ru": "Большой деревянный книжный шкаф",
          "uk": "Large Wooden Bookshelf",
          "ko": "대형 나무 책장",
          "zh": "大型木质书架",
          "ja": "Large Wooden Bookshelf"
        },
        {
          "id": "LimestonePodiumItem",
          "en": "Limestone Podium",
          "fr": "Pupitre en calcaire",
          "es": "Podio de arenisca",
          "de": "Kalksteinpodium",
          "pt": "Pódio de Calcário",
          "it": "Podio di Calcare",
          "tr": "Limestone Podium",
          "pl": "Limestone Podium",
          "ru": "Кафедра из известняка",
          "uk": "Limestone Podium",
          "ko": "석회암 연단",
          "zh": "石灰石讲台",
          "ja": "石灰岩の演壇"
        },
        {
          "id": "MasculineMannequinItem",
          "en": "Masculine Mannequin",
          "fr": "Mannequin homme",
          "es": "Maniquí masculino",
          "de": "Männlicher Mannequin",
          "pt": "Manequim Masculino",
          "it": "Manichino Maschile",
          "tr": "Masculine Mannequin",
          "pl": "Masculine Mannequin",
          "ru": "Мужской манекен",
          "uk": "Masculine Mannequin",
          "ko": "남성적인 마네킹",
          "zh": "男模特儿",
          "ja": "Masculine Mannequin"
        },
        {
          "id": "PotteryTableItem",
          "en": "Pottery Table",
          "fr": "Table de poterie",
          "es": "Mesa del té",
          "de": "Töpfertisch",
          "pt": "Mesa de Cerâmica",
          "it": "Tavolo in Ceramica",
          "tr": "Pottery Table",
          "pl": "Stół garncarski",
          "ru": "Гончарный круг",
          "uk": "Pottery Table",
          "ko": "도자기 테이블",
          "zh": "制陶工作台",
          "ja": "Pottery Table"
        },
        {
          "id": "SmallMeetingChairItem",
          "en": "Small Meeting Chair",
          "fr": "Petite chaise de réunion",
          "es": "Silla pequeña de trabajo",
          "de": "Kleiner Besprechungsstuhl",
          "pt": "Cadeira para Pequenas Reuniões",
          "it": "Piccola Sedia da Meeting",
          "tr": "Small Meeting Chair",
          "pl": "Małe krzesło konferencyjne",
          "ru": "Маленький стул",
          "uk": "Small Meeting Chair",
          "ko": "작은 회의 의자",
          "zh": "小型会议椅子",
          "ja": "小さい会議椅子"
        },
        {
          "id": "SmallMeetingTableItem",
          "en": "Small Meeting Table",
          "fr": "Petite table de réunion",
          "es": "Mesa pequeña de trabajo",
          "de": "Kleiner Besprechungstisch",
          "pt": "Mesa para Pequenas Reuniões",
          "it": "Piccola Tavolo da Meeting",
          "tr": "Small Meeting Table",
          "pl": "Mały stół konferencyjny",
          "ru": "Маленький стол",
          "uk": "Small Meeting Table",
          "ko": "작은 회의 테이블",
          "zh": "小型会议桌子",
          "ja": "Small Meeting Table"
        },
        {
          "id": "SteelAbstractFixtureItem",
          "en": "Steel Abstract Fixture",
          "fr": "Plafonnier abstrait en acier",
          "es": "Accesorio abstracto (acero)",
          "de": "Stählerne abstrakte Vorrichtung",
          "pt": "Luminária Abstrata de Aço",
          "it": "Fissaggio Astratto in Acciaio",
          "tr": "Steel Abstract Fixture",
          "pl": "Stalowa abstrakcyjna oprawa",
          "ru": "Стальной абстрактный светильник",
          "uk": "Steel Abstract Fixture",
          "ko": "강철 추상 고정등",
          "zh": "钢制抽象灯具",
          "ja": "Steel Abstract Fixture"
        },
        {
          "id": "SteelHangingFixtureItem",
          "en": "Steel Hanging Fixture",
          "fr": "Plafonnier décoratif en acier",
          "es": "Accesorio colgante (acero)",
          "de": "Stählerne hängende Vorrichtung",
          "pt": "Luminária Pendurada de Aço",
          "it": "Fissaggio Appeso in Acciaio",
          "tr": "Steel Hanging Fixture",
          "pl": "Stalowa oprawa wisząca",
          "ru": "Стальной подвесной светильник",
          "uk": "Steel Hanging Fixture",
          "ko": "강철 매달린 고정등",
          "zh": "钢制悬挂式灯具",
          "ja": "Steel Hanging Fixture"
        },
        {
          "id": "SteelHangingLampItem",
          "en": "Steel Hanging Lamp",
          "fr": "Plafonnier suspendu en acier",
          "es": "Lámpara colgante (acero)",
          "de": "Stählerne Hängelampe",
          "pt": "Lâmpada Suspensa de Aço",
          "it": "Lampada da Soffitto in Acciaio",
          "tr": "Steel Hanging Lamp",
          "pl": "Stalowa wisząca lampa",
          "ru": "Стальная подвесная лампа",
          "uk": "Steel Hanging Lamp",
          "ko": "강철 매달린 전등",
          "zh": "钢制悬挂式灯",
          "ja": "Steel Hanging Lamp"
        },
        {
          "id": "SteelKitchenLampItem",
          "en": "Steel Kitchen Lamp",
          "fr": "Lustre de cuisine en acier",
          "es": "Lámpara de cocina (acero)",
          "de": "Stählerne Küchenlampe",
          "pt": "Lâmpada de Cozinha de Aço",
          "it": "Lampada da Cucina in Acciaio",
          "tr": "Steel Kitchen Lamp",
          "pl": "Stalowa lampa kuchenna",
          "ru": "Стальная кухонная лампа",
          "uk": "Steel Kitchen Lamp",
          "ko": "강철 주방 전등",
          "zh": "钢制厨房灯",
          "ja": "Steel Kitchen Lamp"
        },
        {
          "id": "SteelPodiumItem",
          "en": "Steel Podium",
          "fr": "Pupitre en acier",
          "es": "Podio de acero",
          "de": "Stahlpodium",
          "pt": "Pódio de Aço",
          "it": "Podio in Acciaio",
          "tr": "Steel Podium",
          "pl": "Steel Podium",
          "ru": "Кафедра из стали",
          "uk": "Steel Podium",
          "ko": "강철 연단",
          "zh": "钢制讲台",
          "ja": "Steel Podium"
        },
        {
          "id": "SteelRowSeatingItem",
          "en": "Steel Row Seating",
          "fr": "Rangée de sièges en acier",
          "es": "Fila de asientos (acero)",
          "de": "Stählerne Reihenbestuhlung",
          "pt": "Fileira de Assentos de Aço",
          "it": "Fila di Posti a sedere in Acciaio",
          "tr": "Steel Row Seating",
          "pl": "Steel Row Seating",
          "ru": "Стальная лавка",
          "uk": "Steel Row Seating",
          "ko": "스틸 로우 좌석",
          "zh": "钢制座椅",
          "ja": "Steel Row Seating"
        },
        {
          "id": "SteelSearchlightItem",
          "en": "Steel Searchlight",
          "fr": "Projecteur en acier",
          "es": "Reflector (acero)",
          "de": "Stählerner Suchscheinwerver",
          "pt": "Holofote de Aço",
          "it": "Faro in Acciaio",
          "tr": "Steel Searchlight",
          "pl": "Steel Searchlight",
          "ru": "Стальной прожектор",
          "uk": "Steel Searchlight",
          "ko": "강철 탐조등",
          "zh": "钢制探照灯",
          "ja": "Steel Searchlight"
        },
        {
          "id": "SteelSquareFixtureItem",
          "en": "Steel Square Fixture",
          "fr": "Plafonnier carré en acier",
          "es": "Accesorio cuadrado (acero)",
          "de": "Stählerne quadratische Halterung",
          "pt": "Luminária Quadrada de Aço",
          "it": "Fissaggio Quadrato in Acciaio",
          "tr": "Steel Square Fixture",
          "pl": "Steel Square Fixture",
          "ru": "Стальной квадратный светильник",
          "uk": "Steel Square Fixture",
          "ko": "강철 사각 고정등",
          "zh": "钢制方形灯具",
          "ja": "Steel Square Fixture"
        },
        {
          "id": "WoodenPodiumItem",
          "en": "Wooden Podium",
          "fr": "Pupitre en bois",
          "es": "Podio de madera",
          "de": "Hölzernes Podium",
          "pt": "Pódio de Madeira",
          "it": "Podio in Legno",
          "tr": "Wooden Podium",
          "pl": "Wooden Podium",
          "ru": "Кафедра из дерева",
          "uk": "Wooden Podium",
          "ko": "목제 연단",
          "zh": "木质讲台",
          "ja": "Wooden Podium"
        },
        {
          "id": "CornrowsItem",
          "en": "Cornrows",
          "fr": "Tresses plaquées",
          "es": "Trenzas",
          "de": "Cornrows",
          "pt": "Cabelo Trancinhas",
          "it": "Treccine",
          "tr": "Cornrows",
          "pl": "Warkoczyki",
          "ru": "Брейды",
          "uk": "Cornrows",
          "ko": "Cornrows",
          "zh": "玉米垄发型",
          "ja": "Cornrows"
        },
        {
          "id": "CurlyItem",
          "en": "Curly",
          "fr": "Frisé",
          "es": "Rizado",
          "de": "Curly",
          "pt": "Cabelo Encaracolado",
          "it": "Ricci",
          "tr": "Curly",
          "pl": "Kręcone",
          "ru": "Кудри",
          "uk": "Curly",
          "ko": "곱슬머리",
          "zh": "卷发",
          "ja": "Curly"
        },
        {
          "id": "PonytailItem",
          "en": "Ponytail",
          "fr": "Queue de cheval",
          "es": "Coleta",
          "de": "Ponyschnitt",
          "pt": "Cabelo Rabo de Cavalo",
          "it": "Coda",
          "tr": "Ponytail",
          "pl": "Kucyk",
          "ru": "Конский хвост",
          "uk": "Ponytail",
          "ko": "포니테일",
          "zh": "马尾辫",
          "ja": "Ponytail"
        },
        {
          "id": "SleekShortHairItem",
          "en": "Sleek Short Hair",
          "fr": "Cheveux courts lisses et brillants",
          "es": "Pelo Corto Elegante",
          "de": "Glatte kurze Haare",
          "pt": "Cabelo Curto Liso",
          "it": "Capelli Corti Eleganti",
          "tr": "Sleek Short Hair",
          "pl": "Przylizane krótkie włosy",
          "ru": "Гладкая короткая стрижка",
          "uk": "Sleek Short Hair",
          "ko": "짧은 머리",
          "zh": "光滑短发",
          "ja": "Sleek Short Hair"
        },
        {
          "id": "TheBobItem",
          "en": "The Bob",
          "fr": "Coupe au carré",
          "es": "El Bob",
          "de": "Der Bob",
          "pt": "Cabelo O Bob",
          "it": "Il Bob",
          "tr": "The Bob",
          "pl": "Równe włosy",
          "ru": "Боб",
          "uk": "The Bob",
          "ko": "폭탄 머리",
          "zh": "齐短发型",
          "ja": "The Bob"
        },
        {
          "id": "AgoutiEnchiladasItem",
          "en": "Agouti Enchiladas",
          "fr": "Enchiladas d\u0027agouti",
          "es": "Enchiladas de agutí",
          "de": "Agouti Enchiladas",
          "pt": "Enchiladas de cutia",
          "it": "Enchilada d\u0027Agouti",
          "tr": "Agouti Enchiladas",
          "pl": "Enchilady z Aguti",
          "ru": "Энчиладас с агути",
          "uk": "Agouti Enchiladas",
          "ko": "아구티 엔칠라다스",
          "zh": "刺鼠玉米卷",
          "ja": "Agouti Enchiladas"
        },
        {
          "id": "AutumnStewItem",
          "en": "Autumn Stew",
          "fr": "Ragoût d\u0027automne",
          "es": "Estofado otoñal",
          "de": "Herbsteintopf",
          "pt": "Ensopado outonal",
          "it": "Stufato Autunnale",
          "tr": "Autumn Stew",
          "pl": "Gulasz dyniowy",
          "ru": "Осеннее рагу",
          "uk": "Autumn Stew",
          "ko": "가을 스튜",
          "zh": "秋季炖汤",
          "ja": "Autumn Stew"
        },
        {
          "id": "BanhXeoItem",
          "en": "Banh Xeo",
          "fr": "Banh Xeo",
          "es": "Banh Xeo",
          "de": "Banh Xeo",
          "pt": "Banh xeo",
          "it": "Banh Xeo",
          "tr": "Banh Xeo",
          "pl": "Banh Xeo",
          "ru": "Блинчики Бан Хео",
          "uk": "Banh Xeo",
          "ko": "반 세오",
          "zh": "越南煎饼",
          "ja": "バインセオ"
        },
        {
          "id": "BeanSproutItem",
          "en": "Bean Sprout",
          "fr": "Pousses de haricots",
          "es": "Germinado de Judías",
          "de": "Bohnensprosse",
          "pt": "Broto de feijão",
          "it": "Germoglio di Fagiolo",
          "tr": "Bean Sprout",
          "pl": "Bean Sprout",
          "ru": "Бобовый росток",
          "uk": "Bean Sprout",
          "ko": "콩 새싹",
          "zh": "豆芽菜",
          "ja": "Bean Sprout"
        },
        {
          "id": "BisonChowFunItem",
          "en": "Bison Chow Fun",
          "fr": "Chow Fun au bison",
          "es": "Chow Fun de Bisonte",
          "de": "Bison Kau-Genuß",
          "pt": "Chow fun de bisão",
          "it": "Chow Fun di Bisonte",
          "tr": "Bison Chow Fun",
          "pl": "Chow fun z żubra",
          "ru": "Фан-чау из бизона",
          "uk": "Bison Chow Fun",
          "ko": "바이슨 쵸우 펀",
          "zh": "野牛炒粉",
          "ja": "Bison Chow Fun"
        },
        {
          "id": "ClamChowderItem",
          "en": "Clam Chowder",
          "fr": "Chaudrée de palourdes",
          "es": "Sopa de mariscos",
          "de": "Suppe mit Muscheln",
          "pt": "Sopa de molusco",
          "it": "Zuppa di Vongole",
          "tr": "Clam Chowder",
          "pl": "Chowder z małży",
          "ru": "Похлебка из моллюсков",
          "uk": "Clam Chowder",
          "ko": "클램 차우더",
          "zh": "蛤蜊汤",
          "ja": "Clam Chowder"
        },
        {
          "id": "FantasticForestPizzaItem",
          "en": "Fantastic Forest Pizza",
          "fr": "Pizza fantastique de la forêt",
          "es": "Pizza del Bosque Fantástico",
          "de": "Pizza Wald Fantastica",
          "pt": "Pizza fantástica da floresta",
          "it": "Pizza Forestale Fantastica",
          "tr": "Fantastic Forest Pizza",
          "pl": "Fantastyczna leśna pizza",
          "ru": "Фантастическая лесная пицца",
          "uk": "Fantastic Forest Pizza",
          "ko": "환상의 숲 피자",
          "zh": "奇幻森林比萨",
          "ja": "Fantastic Forest Pizza"
        },
        {
          "id": "FishNChipsItem",
          "en": "Fish N Chips",
          "fr": "Fish and Chips",
          "es": "Fish N Chips",
          "de": "Fish N Chips",
          "pt": "Peixe e fritas",
          "it": "Fish N Chips",
          "tr": "Fish N Chips",
          "pl": "Fish N Chips",
          "ru": "Рыбные чипсы",
          "uk": "Fish N Chips",
          "ko": "피쉬 앤 칩스",
          "zh": "炸鱼薯条",
          "ja": "Fish N Chips"
        },
        {
          "id": "HeartyHometownPizzaItem",
          "en": "Hearty Hometown Pizza",
          "fr": "Pizza copieuse de mon enfance",
          "es": "Pizza de la Ciudad Natal",
          "de": "Pizza Home Sweet Home",
          "pt": "Pizza calorosa da cidade natal",
          "it": "Pizza Cordiale della Città Natia",
          "tr": "Hearty Hometown Pizza",
          "pl": "Sycąca domowa pizza",
          "ru": "Пицца в форме сердца",
          "uk": "Hearty Hometown Pizza",
          "ko": "따뜻한 고향 피자",
          "zh": "温馨故乡比萨",
          "ja": "Hearty Hometown Pizza"
        },
        {
          "id": "HosomakiItem",
          "en": "Hosomaki",
          "fr": "Hosomaki",
          "es": "Hosomaki",
          "de": "Hosomaki",
          "pt": "Hosomaki",
          "it": "Hosomaki",
          "tr": "Hosomaki",
          "pl": "Hosomaki",
          "ru": "Хосомаки",
          "uk": "Hosomaki",
          "ko": "김초밥",
          "zh": "手握寿司",
          "ja": "Hosomaki"
        },
        {
          "id": "HuckleberryFritterItem",
          "en": "Huckleberry Fritter",
          "fr": "Beignet aux myrtilles",
          "es": "Buñuelo de Arándanos",
          "de": "Gebackene Heidelbeeren",
          "pt": "Bolinho de mirtilo",
          "it": "Frittele di Mirtilli",
          "tr": "Huckleberry Fritter",
          "pl": "Huckleberry Fritter",
          "ru": "Черничные Оладьи",
          "uk": "Huckleberry Fritter",
          "ko": "월귤전",
          "zh": "越橘油炸馅饼",
          "ja": "Huckleberry Fritter"
        },
        {
          "id": "KelpyCrabRollItem",
          "en": "Kelpy Crab Roll",
          "fr": "Maki au crabe",
          "es": "Rollo de Cangrejo con Algas",
          "de": "Krabbenrolle mit Algen",
          "pt": "Rolo de caranguejo com algas",
          "it": "Rotolo di Granchio Algoso",
          "tr": "Kelpy Crab Roll",
          "pl": "Wodorostowa rolka z krabem",
          "ru": "Ролл Краб в ламинарии",
          "uk": "Kelpy Crab Roll",
          "ko": "다시마 게 초밥",
          "zh": "苏格兰蟹肉卷",
          "ja": "Kelpy Crab Roll"
        },
        {
          "id": "LoadedTaroFriesItem",
          "en": "Loaded Taro Fries",
          "fr": "Frites de taro garnies",
          "es": "Patatas fritas de Taro Cargadas",
          "de": "Überbackene Taro-Fritten",
          "pt": "Batatas fritas de inhame",
          "it": "Patatine Fritte di Taro",
          "tr": "Loaded Taro Fries",
          "pl": "Frytki na bogato",
          "ru": "Заправленный Таро фри",
          "uk": "Loaded Taro Fries",
          "ko": "토란 튀김 곱빼기",
          "zh": "油炸芋头",
          "ja": "Loaded Taro Fries"
        },
        {
          "id": "MillionairesSaladItem",
          "en": "Millionaires Salad",
          "fr": "Salade du millionnaire",
          "es": "Ensalada del millionario",
          "de": "Millionär-Salat",
          "pt": "Salada milionária",
          "it": "Insalata dei Miliardari",
          "tr": "Millionaires Salad",
          "pl": "Sałatka Milionerów",
          "ru": "Салат Миллионера",
          "uk": "Millionaires Salad",
          "ko": "백만장자 샐러드",
          "zh": "百万富翁沙拉",
          "ja": "Millionaires Salad"
        },
        {
          "id": "MochiItem",
          "en": "Mochi",
          "fr": "Mochi",
          "es": "Mochi",
          "de": "Mochi",
          "pt": "Mochi",
          "it": "Mochi",
          "tr": "Mochi",
          "pl": "Mochi",
          "ru": "Моти",
          "uk": "Mochi",
          "ko": "모찌",
          "zh": "糯米团",
          "ja": "Mochi"
        },
        {
          "id": "PhadThaiItem",
          "en": "Phad Thai",
          "fr": "Phad Thai",
          "es": "Phad Thai",
          "de": "Phad Thai",
          "pt": "Phad thai",
          "it": "Phad Thai",
          "tr": "Phad Thai",
          "pl": "Pad Thai",
          "ru": "Пад-тай",
          "uk": "Phad Thai",
          "ko": "팟 타이",
          "zh": "泰式炒河粉",
          "ja": "Phad Thai"
        },
        {
          "id": "PokeBowlItem",
          "en": "Poke Bowl",
          "fr": "Poke Bowl",
          "es": "Poke",
          "de": "Gemüse-Bowle",
          "pt": "Poke bowl",
          "it": "Poke Bowl",
          "tr": "Poke Bowl",
          "pl": "Poke Bowl",
          "ru": "Поке Боул",
          "uk": "Poke Bowl",
          "ko": "포케",
          "zh": "冲浪碗",
          "ja": "Poke Bowl"
        },
        {
          "id": "PupusasItem",
          "en": "Pupusas",
          "fr": "Pupusas",
          "es": "Pupusas",
          "de": "Pupusas",
          "pt": "Pupusas",
          "it": "Pupusa",
          "tr": "Pupusas",
          "pl": "Pupusas",
          "ru": "Пупусас",
          "uk": "Pupusas",
          "ko": "푸푸사스",
          "zh": "奶酪猪肉玉米饼",
          "ja": "Pupusas"
        },
        {
          "id": "RiceFlourItem",
          "en": "Rice Flour",
          "fr": "Farine de riz",
          "es": "Harina de arroz",
          "de": "Reismehl",
          "pt": "Farinha de arroz",
          "it": "Farina di Riso",
          "tr": "Rice Flour",
          "pl": "Mąka Ryżowa",
          "ru": "Рисовая мука",
          "uk": "Rice Flour",
          "ko": "쌀가루",
          "zh": "米粉",
          "ja": "Rice Flour"
        },
        {
          "id": "RiceNoodlesItem",
          "en": "Rice Noodles",
          "fr": "Nouilles de riz",
          "es": "Fideos de arroz",
          "de": "Reisnudeln",
          "pt": "Macarrão de arroz",
          "it": "Noodles di Riso",
          "tr": "Rice Noodles",
          "pl": "Makaron Ryżowy",
          "ru": "Рисовая лапша",
          "uk": "Rice Noodles",
          "ko": "쌀 면",
          "zh": "米线",
          "ja": "Rice Noodles"
        },
        {
          "id": "RoastPumpkinItem",
          "en": "Roast Pumpkin",
          "fr": "Citrouille cuite",
          "es": "Calabaza asada",
          "de": "Gerösteter Kürbis",
          "pt": "Abóbora assada",
          "it": "Zucca Arrosto",
          "tr": "Roast Pumpkin",
          "pl": "Roast Pumpkin",
          "ru": "Жареная тыква",
          "uk": "Roast Pumpkin",
          "ko": "구운 호박",
          "zh": "烤南瓜",
          "ja": "Roast Pumpkin"
        },
        {
          "id": "SeededCamasRollItem",
          "en": "Seeded Camas Roll",
          "fr": "Rouleau aux graines de camassia",
          "es": "Rollos de Camas con Semillas",
          "de": "Bestreute Prärielilienrolle",
          "pt": "Rolo de sementes de camassia",
          "it": "Involtini di Camas Con Semi",
          "tr": "Seeded Camas Roll",
          "pl": "Seeded Camas Roll",
          "ru": "Ролл с семенами Камассии",
          "uk": "Seeded Camas Roll",
          "ko": "씨 있는 카마스 롤",
          "zh": "去籽卡马斯卷",
          "ja": "Seeded Camas Roll"
        },
        {
          "id": "SensuousSeaPizzaItem",
          "en": "Sensuous Sea Pizza",
          "fr": "Pizza sensuelle de la mer",
          "es": "Pizza de Mar Agradable a los Sentidos",
          "de": "Pizza di Mare Fantastico",
          "pt": "Pizza do mar sensuoso",
          "it": "Pizza di Mare Piacevole ai Sensi",
          "tr": "Sensuous Sea Pizza",
          "pl": "Smakowita morska pizza",
          "ru": "Морская Пицца",
          "uk": "Sensuous Sea Pizza",
          "ko": "바다 내음 피자",
          "zh": "悠扬之海比萨",
          "ja": "Sensuous Sea Pizza"
        },
        {
          "id": "SharkFilletSoupItem",
          "en": "Shark Fillet Soup",
          "fr": "Soupe d\u0027ailerons de requin",
          "es": "Sopa de Filete de Tiburón",
          "de": "Suppe aus Haifilet",
          "pt": "Sopa de filé de tubarão",
          "it": "Zuppa di Filetto di Squalo",
          "tr": "Shark Fillet Soup",
          "pl": "Zupa z płetwy rekina",
          "ru": "Суп из филе акулы",
          "uk": "Shark Fillet Soup",
          "ko": "상어 지느러미 수프",
          "zh": "鲨鱼片汤",
          "ja": "Shark Fillet Soup"
        },
        {
          "id": "SmoothGutNoodleRollItem",
          "en": "Smooth Gut Noodle Roll",
          "fr": "Rouleau de nouilles à la viande",
          "es": "Rollo de Fideos e Intestino Delgado",
          "de": "Canelloni mit Hackfleisch",
          "pt": "Rolo de macarrão liso",
          "it": "Involtino di Noodle e Intestino Tenue",
          "tr": "Smooth Gut Noodle Roll",
          "pl": "Aksamitne sajgonki",
          "ru": "Ролл из гладкой кишки с лапшой",
          "uk": "Smooth Gut Noodle Roll",
          "ko": "부드러운 위장 누들 롤",
          "zh": "肠粉卷",
          "ja": "Smooth Gut Noodle Roll"
        },
        {
          "id": "SpikyRollItem",
          "en": "Spiky Roll",
          "fr": "Maki hérissé",
          "es": "Rollo Puntiagudo",
          "de": "Stachelige Rolle",
          "pt": "Rolo espinhoso",
          "it": "Involtino Appuntito",
          "tr": "Spiky Roll",
          "pl": "Spiky Roll",
          "ru": "Колючий ролл",
          "uk": "Spiky Roll",
          "ko": "성게 초밥",
          "zh": "穗状花卷",
          "ja": "Spiky Roll"
        },
        {
          "id": "SunButterItem",
          "en": "Sun Butter",
          "fr": "Margarine",
          "es": "Mantequilla solar",
          "de": "Sonnenblumenbutter",
          "pt": "Manteiga de Girassol",
          "it": "Burro di Girasole",
          "tr": "Sun Butter",
          "pl": "Sun Butter",
          "ru": "Паста из семечек подсолнуха",
          "uk": "Sun Butter",
          "ko": "버터",
          "zh": "向日葵黄油",
          "ja": "Sun Butter"
        },
        {
          "id": "SunCheeseItem",
          "en": "Sun Cheese",
          "fr": "Fromage de tournesol",
          "es": "Queso solar",
          "de": "Sonnenblumenkäse",
          "pt": "Queijo sol",
          "it": "Formaggio di Girasole",
          "tr": "Sun Cheese",
          "pl": "Sun Cheese",
          "ru": "Сыр из семечек подсолнуха",
          "uk": "Sun Cheese",
          "ko": "치즈",
          "zh": "向日葵奶酪",
          "ja": "Sun Cheese"
        },
        {
          "id": "TaroFriesItem",
          "en": "Taro Fries",
          "fr": "Frites de taro",
          "es": "Patatas fritas de taro",
          "de": "Taro-Fritten",
          "pt": "Fritas de inhame",
          "it": "Patatine di Taro",
          "tr": "Taro Fries",
          "pl": "Frytki z kolokazji",
          "ru": "Таро Фри",
          "uk": "Taro Fries",
          "ko": "토란 튀김",
          "zh": "芋头炸薯条",
          "ja": "Taro Fries"
        },
        {
          "id": "TastyTropicalPizzaItem",
          "en": "Tasty Tropical Pizza",
          "fr": "Pizza tropicale savoureuse",
          "es": "Pizza tropical",
          "de": "Pizza Tropica",
          "pt": "Pizza tropical saborosa",
          "it": "Saporita Pizza Tropicale",
          "tr": "Tasty Tropical Pizza",
          "pl": "Pyszna pizza tropikalna",
          "ru": "Вкусная Тропическая Пицца",
          "uk": "Tasty Tropical Pizza",
          "ko": "하와이안 피자",
          "zh": "可口热带比萨",
          "ja": "Tasty Tropical Pizza"
        },
        {
          "id": "WorldlyDonutItem",
          "en": "Worldly Donut",
          "fr": "Beignet mondain",
          "es": "Donut del mundo",
          "de": "Schmackhafter Donut",
          "pt": "Rosquinha mundana",
          "it": "Ciambella Mondana",
          "tr": "Worldly Donut",
          "pl": "Worldly Donut",
          "ru": "Пончик Мира",
          "uk": "Worldly Donut",
          "ko": "월들리 도넛",
          "zh": "惊世甜甜圈",
          "ja": "Worldly Donut"
        },
        {
          "id": "CO2CanisterItem",
          "en": "CO2 Canister",
          "fr": "Cartouche de CO2",
          "es": "Botella de CO2",
          "de": "CO₂-Kanister",
          "pt": "Vasilha de CO2",
          "it": "Bombola di CO2",
          "tr": "CO2 Canister",
          "pl": "CO2 Canister",
          "ru": "Баллон CO2",
          "uk": "CO2 Canister",
          "ko": "CO2 통",
          "zh": "二氧化碳罐",
          "ja": "CO2 Canister"
        },
        {
          "id": "CompositeLumberDresserItem",
          "en": "Composite Lumber Dresser",
          "fr": "Commode en bois composite",
          "es": "Vestidor de composite",
          "de": "Verbundholz-Kleiderschrank",
          "pt": "Cômoda Composta de Madeira Serrada",
          "it": "Cassettiera in Legname Composito",
          "tr": "Composite Lumber Dresser",
          "pl": "Kompozytowa komoda z drewna",
          "ru": "Комод из композитов",
          "uk": "Composite Lumber Dresser",
          "ko": "합성 가공 목재 드레서",
          "zh": "复合木质化妆台",
          "ja": "Composite Lumber Dresser"
        },
        {
          "id": "LargeBathMatItem",
          "en": "Large Bath Mat",
          "fr": "Grand tapis de bain",
          "es": "Alfombrilla de baño grande",
          "de": "Große Badematte",
          "pt": "Tapete de Banho Grande",
          "it": "Grande Tappetino da Bagno",
          "tr": "Large Bath Mat",
          "pl": "Duża Mata Łazienkowa",
          "ru": "Большой коврик для ванной",
          "uk": "Large Bath Mat",
          "ko": "대형 욕실 매트",
          "zh": "大型浴室防滑垫",
          "ja": "大きいバスマット"
        },
        {
          "id": "NylonFutonBedItem",
          "en": "Nylon Futon Bed",
          "fr": "Lit futon en nylon",
          "es": "Cama-futón con funda de nailon",
          "de": "Nylon Futon Bett",
          "pt": "Cama Futon de Náilon",
          "it": "Letto Futon in Nylon",
          "tr": "Nylon Futon Bed",
          "pl": "Nylonowe łóżko Futon",
          "ru": "Кровать с нейлоновым футоном",
          "uk": "Nylon Futon Bed",
          "ko": "나일론 깔개 침대",
          "zh": "尼龙沙发床",
          "ja": "Nylon Futon Bed"
        },
        {
          "id": "NylonFutonCouchItem",
          "en": "Nylon Futon Couch",
          "fr": "Canapé futon en nylon",
          "es": "Futón con funda de nailon",
          "de": "Nylon Futon Couch",
          "pt": "Sofá-cama de Náilon",
          "it": "Divano Futon in Nylon",
          "tr": "Nylon Futon Couch",
          "pl": "Nylonowa Kanapa Futon",
          "ru": "Диван с нейлоновым футоном",
          "uk": "Nylon Futon Couch",
          "ko": "나일론 깔개 소파",
          "zh": "尼龙蒲团沙发",
          "ja": "Nylon Futon Couch"
        },
        {
          "id": "SmallBathMatItem",
          "en": "Small Bath Mat",
          "fr": "Petit tapis de bain",
          "es": "Alfombrilla de baño pequeña",
          "de": "Kleine Badematte",
          "pt": "Tapete de Banho Pequeno",
          "it": "Piccolo Tappetino da Bagno",
          "tr": "Small Bath Mat",
          "pl": "Small Bath Mat",
          "ru": "Небольшой Коврик для ванной",
          "uk": "Small Bath Mat",
          "ko": "소형 욕실 매트",
          "zh": "小型浴室防滑垫",
          "ja": "小さいバスマット"
        },
        {
          "id": "StudentsDeskT1Item",
          "en": "Students Desk T1",
          "fr": "Chaise d\u0027étudiant nv. 1",
          "es": "Pupitre de estudiante (niv. 1)",
          "de": "Schülertisch T1",
          "pt": "Carteira do Estudante Nível 1",
          "it": "Banco T1",
          "tr": "Students Desk T1",
          "pl": "Students Desk T1",
          "ru": "Парта T1",
          "uk": "Students Desk T1",
          "ko": "학생 책상 T1",
          "zh": "学生书桌 1",
          "ja": "Students Desk T1"
        },
        {
          "id": "StudentsDeskT2Item",
          "en": "Students Desk T2",
          "fr": "Chaise d\u0027étudiant nv. 2",
          "es": "Pupitre de estudiante (niv. 2)",
          "de": "Schülertisch T2",
          "pt": "Carteira do Estudante Nível 2",
          "it": "Banco T2",
          "tr": "Students Desk T2",
          "pl": "Students Desk T2",
          "ru": "Парта T2",
          "uk": "Students Desk T2",
          "ko": "학생 책상 T2",
          "zh": "学生书桌 2",
          "ja": "Students Desk T2"
        },
        {
          "id": "StudentsDeskT3Item",
          "en": "Students Desk T3",
          "fr": "Chaise d\u0027étudiant nv. 3",
          "es": "Pupitre de estudiante (niv. 3)",
          "de": "Schülertisch T3",
          "pt": "Carteira do Estudante Nível 3",
          "it": "Banco T3",
          "tr": "Students Desk T3",
          "pl": "Students Desk T3",
          "ru": "Парта T3",
          "uk": "Students Desk T3",
          "ko": "학생 책상 T3",
          "zh": "学生书桌 3",
          "ja": "Students Desk T3"
        },
        {
          "id": "TeachersDeskT1Item",
          "en": "Teachers Desk T1",
          "fr": "Bureau du professeur nv. 1",
          "es": "Mesa de profesor (niv. 1)",
          "de": "Lehrerpult T1",
          "pt": "Carteira do Professor Nível 1",
          "it": "Cattedra T1",
          "tr": "Teachers Desk T1",
          "pl": "Teachers Desk T1",
          "ru": "Стол Учителя T1",
          "uk": "Teachers Desk T1",
          "ko": "교사 책상 T1",
          "zh": "学生书桌 1",
          "ja": "Teachers Desk T1"
        },
        {
          "id": "TeachersDeskT2Item",
          "en": "Teachers Desk T2",
          "fr": "Bureau du professeur nv. 2",
          "es": "Mesa de profesor (niv. 2)",
          "de": "Lehrerpult T2",
          "pt": "Carteira do Professor Nível 2",
          "it": "Cattedra T2",
          "tr": "Teachers Desk T2",
          "pl": "Teachers Desk T2",
          "ru": "Стол Учителя T2",
          "uk": "Teachers Desk T2",
          "ko": "교사 책상 T2",
          "zh": "学生书桌 2",
          "ja": "Teachers Desk T2"
        },
        {
          "id": "TeachersDeskT3Item",
          "en": "Teachers Desk T3",
          "fr": "Bureau du professeur nv. 3",
          "es": "Mesa de profesor (niv. 3)",
          "de": "Lehrerpult T3",
          "pt": "Carteira do Professor Nível 3",
          "it": "Cattedra T3",
          "tr": "Teachers Desk T3",
          "pl": "Teachers Desk T3",
          "ru": "Стол Учителя T3",
          "uk": "Teachers Desk T3",
          "ko": "교사 책상 T3",
          "zh": "学生书桌 3",
          "ja": "Teachers Desk T3"
        },
        {
          "id": "TowelRackItem",
          "en": "Towel Rack",
          "fr": "Porte-serviettes",
          "es": "Colgador de toalla",
          "de": "Handtuchständer",
          "pt": "Toalheiro",
          "it": "Portasciugamani",
          "tr": "Towel Rack",
          "pl": "Towel Rack",
          "ru": "Вешалка для полотенец",
          "uk": "Towel Rack",
          "ko": "수건걸이",
          "zh": "毛巾架",
          "ja": "Towel Rack"
        },
        {
          "id": "UpholsteredChairItem",
          "en": "Upholstered Chair",
          "fr": "Fauteuil rembourré",
          "es": "Silla tapizada",
          "de": "Gepolsteter Stuhl",
          "pt": "Cadeira Estofada",
          "it": "Sedia Imbottita",
          "tr": "Upholstered Chair",
          "pl": "Tapiecerowane krzesło",
          "ru": "Стул с обивкой",
          "uk": "Upholstered Chair",
          "ko": "푹신한 의자",
          "zh": "铺软垫的椅子",
          "ja": "布張りの椅子"
        },
        {
          "id": "UpholsteredCouchItem",
          "en": "Upholstered Couch",
          "fr": "Canapé rembourré",
          "es": "Sofá tapizado",
          "de": "Gepolsterte Couch",
          "pt": "Sofá Estofado",
          "it": "Divano Imbottito",
          "tr": "Upholstered Couch",
          "pl": "Tapicerowana kanapa",
          "ru": "Диван с обивкой",
          "uk": "Upholstered Couch",
          "ko": "푹신한 소파",
          "zh": "铺软垫的沙发",
          "ja": "Upholstered Couch"
        },
        {
          "id": "EthanolItem",
          "en": "Ethanol",
          "fr": "Éthanol",
          "es": "Etanol",
          "de": "Ethanol",
          "pt": "Etanol",
          "it": "Etanolo",
          "tr": "Ethanol",
          "pl": "Ethanol",
          "ru": "Этанол",
          "uk": "Ethanol",
          "ko": "에탄올",
          "zh": "乙醇",
          "ja": "Ethanol"
        },
        {
          "id": "TrailerTruckItem",
          "en": "Trailer Truck",
          "fr": "Semi-remorque",
          "es": "Camión Remolque",
          "de": "Trailer Truck",
          "pt": "Carreta",
          "it": "Autotreno",
          "tr": "Trailer Truck",
          "pl": "Trailer Truck",
          "ru": "Тягач с полуприцепом",
          "uk": "Trailer Truck",
          "ko": "Trailer Truck",
          "zh": "房车",
          "ja": "Trailer Truck"
        },
        {
          "id": "CropSeed",
          "en": "Crop Seed",
          "fr": "Graine de culture",
          "es": "Semilla de Cultivo",
          "de": "Erntesamen",
          "pt": "Sementes de Colheita",
          "it": "Sementi",
          "tr": "Crop Seed",
          "pl": "Crop Seed",
          "ru": "Урожай",
          "uk": "Crop Seed",
          "ko": "작물 씨앗",
          "zh": "作物种子",
          "ja": "作物の種子"
        },
        {
          "id": "CropSeed",
          "en": "Crop Seed",
          "fr": "Graine de culture",
          "es": "Semilla de Cultivo",
          "de": "Erntesamen",
          "pt": "Sementes de Colheita",
          "it": "Sementi",
          "tr": "Crop Seed",
          "pl": "Crop Seed",
          "ru": "Урожай",
          "uk": "Crop Seed",
          "ko": "작물 씨앗",
          "zh": "作物种子",
          "ja": "作物の種子"
        },
        {
          "id": "Fabric",
          "en": "Fabric",
          "fr": "Tissu",
          "es": "Tejido",
          "de": "Stoff",
          "pt": "Tecido",
          "it": "Tessuto",
          "tr": "Fabric",
          "pl": "Tkanina",
          "ru": "Ткань",
          "uk": "Тканина",
          "ko": "Fabric",
          "zh": "织物",
          "ja": "Fabric"
        },
        {
          "id": "LargeFish",
          "en": "Large Fish",
          "fr": "Grand Poisson",
          "es": "Pez grande",
          "de": "Großer Fisch",
          "pt": "Peixe Grande",
          "it": "Pesce Grande",
          "tr": "Large Fish",
          "pl": "Duża ryba",
          "ru": "Большая рыба",
          "uk": "Велика риба",
          "ko": "큰 물고기",
          "zh": "大鱼",
          "ja": "Large Fish"
        },
        {
          "id": "MediumFish",
          "en": "Medium Fish",
          "fr": "Poisson moyen",
          "es": "Pez Mediano",
          "de": "Mittlerer Fisch",
          "pt": "Peixe Médio",
          "it": "Pesce Medio",
          "tr": "Medium Fish",
          "pl": "Średnia ryba",
          "ru": "Средняя рыба",
          "uk": "Середня риба",
          "ko": "중간 물고기",
          "zh": "中鱼",
          "ja": "Medium Fish"
        },
        {
          "id": "MediumWoolyCarcass",
          "en": "Medium Wooly Carcass",
          "fr": "Cadavre moyen à laine",
          "es": "Cadáver Mediano Lanoso",
          "de": "Wollkadaver (Mittel)",
          "pt": "Carcaça Lanosa Média",
          "it": "Carcassa Lanosa Media",
          "tr": "Medium Wooly Carcass",
          "pl": "Średnia wełniana tusza",
          "ru": "Средняя Шерстяная Туша",
          "uk": "Середня шерстяна туша",
          "ko": "중형 양털 사체",
          "zh": "中型毛绒遗骸",
          "ja": "Medium Wooly Carcass"
        },
        {
          "id": "SmallFish",
          "en": "Small Fish",
          "fr": "Petit poisson",
          "es": "Pez Pequeño",
          "de": "Kleiner Fisch",
          "pt": "Peixe Pequeno",
          "it": "Piccolo Pesce",
          "tr": "Small Fish",
          "pl": "Mała ryba",
          "ru": "Маленькая рыба",
          "uk": "Мала риба",
          "ko": "작은 물고기",
          "zh": "小鱼",
          "ja": "Small Fish"
        },
        {
          "id": "MediumLeatherCarcass",
          "en": "Medium Leather Carcass",
          "fr": "Cadavre moyen à cuir",
          "es": "Cadáver Mediano con Cuero",
          "de": "Lederkadaver (Mittel)",
          "pt": "Carcaça de Couro Média",
          "it": "Carcassa di Pelle Media",
          "tr": "Medium Leather Carcass",
          "pl": "Średnia skórzana tusza",
          "ru": "Средняя Кожаная Туша",
          "uk": "Medium Leather Carcass",
          "ko": "Medium Leather Carcass",
          "zh": "中型皮革遗骸",
          "ja": "Medium Leather Carcass"
        },
        {
          "id": "FertilizerFiller",
          "en": "Fertilizer Filler",
          "fr": "Garnissage d\u0027engrais",
          "es": "Relleno de Fertilizante",
          "de": "Füller aus Dünger",
          "pt": "Preenchimento de Fertilizante",
          "it": "Riempitivo di Fertilizzante",
          "tr": "Fertilizer Filler",
          "pl": "Fertilizer Filler",
          "ru": "Наполнитель удобрений",
          "uk": "Fertilizer Filler",
          "ko": "비료 충전재",
          "zh": "化肥填料",
          "ja": "Fertilizer Filler"
        },
        {
          "id": "Seeds",
          "en": "Seeds",
          "fr": "Graines",
          "es": "Semillas",
          "de": "Samen",
          "pt": "Sementes",
          "it": "Semi",
          "tr": "Seeds",
          "pl": "Nasiona",
          "ru": "Семена",
          "uk": "Насіння",
          "ko": "씨앗",
          "zh": "种子",
          "ja": "種子"
        },
        {
          "id": "WoodenBargeItem",
          "en": "Wooden Barge",
          "fr": "Bac en bois",
          "es": "Barcaza de Madera",
          "de": "Hölzerner Kahn",
          "pt": "Barcaça de Madeira",
          "it": "Chiatta in Legno",
          "tr": "Wooden Barge",
          "pl": "Drewniana barka",
          "ru": "Деревянная баржа",
          "uk": "Дерев\u0027яна баржа",
          "ko": "목제 바지선",
          "zh": "木质驳船",
          "ja": "Wooden Barge"
        },
        {
          "id": "SmallWoodenBoatItem",
          "en": "Small Wooden Boat",
          "fr": "Petit bateau en bois",
          "es": "Pequeño Barco de Madera",
          "de": "Holzboot (klein)",
          "pt": "Barco de Madeira Pequeno",
          "it": "Piccola Barca in Legno",
          "tr": "Small Wooden Boat",
          "pl": "Mała drewniana łódka",
          "ru": "Маленькая деревянная лодка",
          "uk": "Малий дерев’яний човен",
          "ko": "소형 목제 보트",
          "zh": "小木船",
          "ja": "Small Wooden Boat"
        },
        {
          "id": "HardwoodLumberDresserItem",
          "en": "Hardwood Lumber Dresser",
          "fr": "Commode en bois d\u0027œuvre dur",
          "es": "Vestidor de Troncos (Madera Dura)",
          "de": "Bauholzkommode aus Hartholz",
          "pt": "Cômoda de Madeira Dura Serrada",
          "it": "Credenza in Legno Massiccio",
          "tr": "Hardwood Lumber Dresser",
          "pl": "Komoda z drewna liściastego",
          "ru": "Комод из пиломатериалов лиственных пород",
          "uk": "Hardwood Lumber Dresser",
          "ko": "가공된 견목재 옷장",
          "zh": "硬木衣柜",
          "ja": "Hardwood Lumber Dresser"
        },
        {
          "id": "LumberDresserItem",
          "en": "Lumber Dresser",
          "fr": "Commode en bois d\u0027œuvre",
          "es": "Cómoda de madera",
          "de": "Bauholzkommode",
          "pt": "Cômoda de Madeira Serrada",
          "it": "Credenza in Legno",
          "tr": "Lumber Dresser",
          "pl": "Drewniana komoda",
          "ru": "Комод из пиломатериалов",
          "uk": "Lumber Dresser",
          "ko": "가공된 목재 옷장",
          "zh": "木衣柜",
          "ja": "Lumber Dresser"
        },
        {
          "id": "SoftwoodLumberDresserItem",
          "en": "Softwood Lumber Dresser",
          "fr": "Commode en bois d\u0027œuvre tendre",
          "es": "Vestidor de Troncos (Madera Blanda)",
          "de": "Bauhholzkommode aus Weichholz",
          "pt": "Cômoda de Madeira Macia Serrada",
          "it": "Credenza in Legno Morbido",
          "tr": "Softwood Lumber Dresser",
          "pl": "Komoda z drewna iglastego",
          "ru": "Комод из пиломатериалов хвойных пород",
          "uk": "Softwood Lumber Dresser",
          "ko": "가공된 연목 옷장",
          "zh": "软木衣柜",
          "ja": "Softwood Lumber Dresser"
        },
        {
          "id": "WoodShopCartItem",
          "en": "Wood Shop Cart",
          "fr": "Boutique itinérante en bois",
          "es": "Carro de Compras de Madera",
          "de": "Holzladenwagen",
          "pt": "Carrinho de Madeira com Loja",
          "it": "Carrello della Spesa in Legno",
          "tr": "Ahşap Dükkanı Sepeti",
          "pl": "Wood Shop Cart",
          "ru": "Передвижной деревянный магазин",
          "uk": "Wood Shop Cart",
          "ko": "포장마차",
          "zh": "木质购物车",
          "ja": "Wood Shop Cart"
        },
        {
          "id": "MacaronsItem",
          "en": "Macarons",
          "fr": "Macarons",
          "es": "Macarones",
          "de": "Makaronen",
          "pt": "Macaron",
          "it": "Macaron",
          "tr": "Macarons",
          "pl": "Macarons",
          "ru": "Макарон",
          "uk": "Macarons",
          "ko": "마카롱",
          "zh": "马卡龙",
          "ja": "Macarons"
        },
        {
          "id": "FlaxFiberItem",
          "en": "Flax Fiber",
          "fr": "Fibre de lin",
          "es": "Fibra de lino",
          "de": "Flachsfaser",
          "pt": "Fibra de Linho",
          "it": "Fibra di lino",
          "tr": "Flax Fiber",
          "pl": "Włókno lniane",
          "ru": "Льняное волокно",
          "uk": "Flax Fiber",
          "ko": "아마 섬유",
          "zh": "亚麻纤维",
          "ja": "亜麻繊維"
        },
        {
          "id": "FlaxStemItem",
          "en": "Flax Stem",
          "fr": "Tige de lin",
          "es": "Tallo de lino",
          "de": "Flachsstamm",
          "pt": "Caule de Linho",
          "it": "Gambo di lino",
          "tr": "Flax Stem",
          "pl": "Łodyga lnu",
          "ru": "Стебель льна",
          "uk": "Flax Stem",
          "ko": "아마 줄기",
          "zh": "亚麻杆",
          "ja": "Flax Stem"
        },
        {
          "id": "LinenFabricItem",
          "en": "Linen Fabric",
          "fr": "Tissu de lin",
          "es": "Tela de lino",
          "de": "Leinenstoff",
          "pt": "Tecido de Linho",
          "it": "Tessuto di lino",
          "tr": "Linen Fabric",
          "pl": "Tkanina lniana",
          "ru": "Льняная ткань",
          "uk": "Linen Fabric",
          "ko": "아마포",
          "zh": "亚麻织物",
          "ja": "Linen Fabric"
        },
        {
          "id": "LinenYarnItem",
          "en": "Linen Yarn",
          "fr": "Fil de lin",
          "es": "Hilo de lino",
          "de": "Leinengarn",
          "pt": "Fio de Linho",
          "it": "Filato di lino",
          "tr": "Linen Yarn",
          "pl": "Linen Yarn",
          "ru": "Льняная пряжа",
          "uk": "Linen Yarn",
          "ko": "아마 실타래",
          "zh": "亚麻纱",
          "ja": "Linen Yarn"
        },
        {
          "id": "SpoiledFoodItem",
          "en": "Spoiled Food",
          "fr": "Nourriture avariée",
          "es": "Comida deteriorada",
          "de": "Verrottetes Essen",
          "pt": "Comida Estragada",
          "it": "Cibo avariato",
          "tr": "Spoiled Food",
          "pl": "Zepsute jedzenie",
          "ru": "Испорченная еда",
          "uk": "Spoiled Food",
          "ko": "음식물 쓰레기",
          "zh": "变质食物",
          "ja": "Spoiled Food"
        },
        {
          "id": "FlaxSeedItem",
          "en": "Flax Seed",
          "fr": "Graine de lin",
          "es": "Semilla de lino",
          "de": "Flachssaat",
          "pt": "Semente de Linho",
          "it": "Seme di lino",
          "tr": "Flax Seed",
          "pl": "Nasiono lnu",
          "ru": "Семечко льна",
          "uk": "Flax Seed",
          "ko": "아마씨",
          "zh": "亚麻种子",
          "ja": "Flax Seed"
        },
        {
          "id": "FiberScutchingStationItem",
          "en": "Fiber Scutching Station",
          "fr": "Établi de teillage de fibres",
          "es": "Estación de espaldillado de fibras",
          "de": "Flachsschwinge",
          "pt": "Estação de corte de fibra",
          "it": "Stazione di gramolatura delle fibre",
          "tr": "Fiber Scutching Station",
          "pl": "Fiber Scutching Station",
          "ru": "Прядильный станок",
          "uk": "Fiber Scutching Station",
          "ko": "섬유 타면기",
          "zh": "纤维脱胶台",
          "ja": "Fiber Scutching Station"
        },
        {
          "id": "PictureFrameItem",
          "en": "Picture Frame",
          "fr": "Cadre photo",
          "es": "Marco de cuadro",
          "de": "Bilderrahmen",
          "pt": "Porta-retrato",
          "it": "Cornice per fotografia",
          "tr": "Picture Frame",
          "pl": "Picture Frame",
          "ru": "Рамка картины",
          "uk": "Picture Frame",
          "ko": "사진 틀",
          "zh": "相框",
          "ja": "Picture Frame"
        },
        {
          "id": "SpinningJennyItem",
          "en": "Spinning Jenny",
          "fr": "Machine à filer",
          "es": "Hiladora multibobina",
          "de": "Spinnmaschine",
          "pt": "Máquina de fiar Jenny",
          "it": "Giannetta",
          "tr": "Spinning Jenny",
          "pl": "Spinning Jenny",
          "ru": "Прялка Дженни",
          "uk": "Spinning Jenny",
          "ko": "다축방적기",
          "zh": "珍妮纺织机",
          "ja": "Spinning Jenny"
        },
        {
          "id": "WoodenKitchenLampItem",
          "en": "Wooden Kitchen Lamp",
          "fr": "Lustre de cuisine en bois d\u0027œuvre",
          "es": "Lámpara de cocina (madera)",
          "de": "Hölzerne Küchenlampe",
          "pt": "Lâmpada de Cozinha de Madeira",
          "it": "Lampada da Cucina in Legno",
          "tr": "Wooden Kitchen Lamp",
          "pl": "Drewniana lampa kuchenna",
          "ru": "Деревянная кухонная лампа",
          "uk": "Дерев\u0027яна кухонна лампа",
          "ko": "목제 주방 전등",
          "zh": "木制厨房灯",
          "ja": "Wooden Kitchen Lamp"
        },
        {
          "id": "ImmigrationDeskItem",
          "en": "Immigration Desk",
          "fr": "Bureau de l’immigration",
          "es": "Oficina de inmigración",
          "de": "Einwanderungsbehörde",
          "pt": "Mesa de imigração",
          "it": "Tavolo d\u0027immigrazione",
          "tr": "Immigration Desk",
          "pl": "Immigration Desk",
          "ru": "Иммиграционная служба",
          "uk": "Immigration Desk",
          "ko": "출입국관리 책상",
          "zh": "Immigration Desk",
          "ja": "Immigration Desk"
        },
        {
          "id": "TownFoundationItem",
          "en": "Town Foundation",
          "fr": "Fondation municipale",
          "es": "Fundación de un pueblo",
          "de": "Stadtgründung",
          "pt": "Fundação da cidade",
          "it": "Fondazione del villaggio",
          "tr": "Town Foundation",
          "pl": "Town Foundation",
          "ru": "Закладной камень города",
          "uk": "Town Foundation",
          "ko": "마을 설립",
          "zh": "Town Foundation",
          "ja": "Town Foundation"
        },
        {
          "id": "CountryFoundationItem",
          "en": "Country Foundation",
          "fr": "Fondation nationale",
          "es": "Fundación de un país",
          "de": "Landesgründung",
          "pt": "Fundação do país",
          "it": "Fondazione del Paese",
          "tr": "Country Foundation",
          "pl": "Country Foundation",
          "ru": "Закладной камень Страны",
          "uk": "Country Foundation",
          "ko": "나라 설립",
          "zh": "Country Foundation",
          "ja": "Country Foundation"
        },
        {
          "id": "FederationFoundationItem",
          "en": "Federation Foundation",
          "fr": "Fondation fédérale",
          "es": "Fundación de una federación",
          "de": "Föderationsgründung",
          "pt": "Fundação da Federação",
          "it": "Fondazione della federazione",
          "tr": "Federation Foundation",
          "pl": "Federation Foundation",
          "ru": "Закладной камень Федерации",
          "uk": "Federation Foundation",
          "ko": "연방 설립",
          "zh": "Federation Foundation",
          "ja": "Federation Foundation"
        },
        {
          "id": "CopperPlateItem",
          "en": "Copper Plate",
          "fr": "Plaque de cuivre",
          "es": "Placa de cobre",
          "de": "Kupferplatte",
          "pt": "Placa de Cobre",
          "it": "Piatto di rame",
          "tr": "Copper Plate",
          "pl": "Copper Plate",
          "ru": "Медная пластина",
          "uk": "Copper Plate",
          "ko": "구리판",
          "zh": "铜管",
          "ja": "銅板"
        },
        {
          "id": "CottonLintItem",
          "en": "Cotton Lint",
          "fr": "Bourre de coton",
          "es": "Hilacha de algodón",
          "de": "Baumwollflusen",
          "pt": "Fiapos de Algodão",
          "it": "Lanugine di cotone",
          "tr": "Cotton Lint",
          "pl": "Włókno bawełniane",
          "ru": "Хлопковое волокно",
          "uk": "Cotton Lint",
          "ko": "목화 보푸라기",
          "zh": "棉絮",
          "ja": "Cotton Lint"
        },
        {
          "id": "FlaxTrawlerNetItem",
          "en": "Flax Trawler Net",
          "fr": "Filet de chalutier en lin",
          "es": "Red de arrastre de lino",
          "de": "Flachs-Trawlernetz",
          "pt": "Rede de arrasto de linho",
          "it": "Rete di peschereccio in lino",
          "tr": "Flax Trawler Net",
          "pl": "Lniana sieć rybacka",
          "ru": "Льняная сеть Траулера",
          "uk": "Flax Trawler Net",
          "ko": "아마 저인망",
          "zh": "亚麻拖网",
          "ja": "亜麻のトロール網"
        },
        {
          "id": "GlassLensItem",
          "en": "Glass Lens",
          "fr": "Lentille en verre",
          "es": "Lente de vidrio",
          "de": "Glaslinse",
          "pt": "Lente de vidro",
          "it": "Lenti di vetro",
          "tr": "Glass Lens",
          "pl": "Glass Lens",
          "ru": "Стеклянная линза",
          "uk": "Glass Lens",
          "ko": "유리 렌즈",
          "zh": "玻璃",
          "ja": "Glass Lens"
        },
        {
          "id": "CourtChairItem",
          "en": "Court Chair",
          "fr": "Chaise du tribunal",
          "es": "Silla de tribunal",
          "de": "Gerichtsstuhl",
          "pt": "Cadeira de Tribunal",
          "it": "Sedia da tribunale",
          "tr": "Court Chair",
          "pl": "Court Chair",
          "ru": "Судебный стул",
          "uk": "Court Chair",
          "ko": "법정 의자",
          "zh": "Court Chair",
          "ja": "法廷の椅子"
        },
        {
          "id": "CourtTableItem",
          "en": "Court Table",
          "fr": "Table du tribunal",
          "es": "Mesa de tribunal",
          "de": "Gerichtstisch",
          "pt": "Mesa de Tribunal",
          "it": "Tavolo da tribunale",
          "tr": "Court Table",
          "pl": "Court Table",
          "ru": "Судебный стол",
          "uk": "Court Table",
          "ko": "법원 탁자",
          "zh": "法庭桌",
          "ja": "Court Table"
        },
        {
          "id": "EmbassyDeskItem",
          "en": "Embassy Desk",
          "fr": "Bureau de l\u0027ambassade",
          "es": "Oficina de embajada",
          "de": "Botschaftsbüro",
          "pt": "Escritório da Embaixada",
          "it": "Ufficio dell\u0027Ambasciata",
          "tr": "Embassy Desk",
          "pl": "Biurko ambasady",
          "ru": "Посольство",
          "uk": "Embassy Desk",
          "ko": "대사관 책상",
          "zh": "Embassy Desk",
          "ja": "Embassy Desk"
        },
        {
          "id": "GalaxyVaseItem",
          "en": "Galaxy Vase",
          "fr": "Vase galaxie",
          "es": "Jarrón galáctico",
          "de": "Galaxie-Vase",
          "pt": "Vaso galáxia",
          "it": "Vaso con galassia",
          "tr": "Galaxy Vase",
          "pl": "Galaxy Vase",
          "ru": "Галактическая ваза",
          "uk": "Galaxy Vase",
          "ko": "은하수 화병",
          "zh": "Galaxy Vase",
          "ja": "Galaxy Vase"
        },
        {
          "id": "GlassworksItem",
          "en": "Glassworks",
          "fr": "Fourneau de verrerie",
          "es": "Materiales de vidrio",
          "de": "Glasfabrik",
          "pt": "Forno de vidro",
          "it": "Vetreria",
          "tr": "Glassworks",
          "pl": "Glassworks",
          "ru": "Стекольная мастерская",
          "uk": "Glassworks",
          "ko": "유리 제작용 가마",
          "zh": "Glassworks",
          "ja": "Glassworks"
        },
        {
          "id": "OrangeVaseItem",
          "en": "Orange Vase",
          "fr": "Vase orange",
          "es": "Jarrón naranja",
          "de": "Orangefarbene Vase",
          "pt": "Vaso laranja",
          "it": "Vaso arancione",
          "tr": "Orange Vase",
          "pl": "Orange Vase",
          "ru": "Оранжевая ваза",
          "uk": "Orange Vase",
          "ko": "주황색 화병",
          "zh": "橙色花瓶",
          "ja": "Orange Vase"
        },
        {
          "id": "OutpostNettingItem",
          "en": "Outpost Netting",
          "fr": "Stockage d\u0027avant-poste",
          "es": "Redes de puesto avanzado",
          "de": "Außenpostennetz",
          "pt": "Rede de posto avançado",
          "it": "Rete dell\u0027avamposto",
          "tr": "Outpost Netting",
          "pl": "Outpost Netting",
          "ru": "Потолочная сетка",
          "uk": "Outpost Netting",
          "ko": "Outpost Netting",
          "zh": "Outpost Netting",
          "ja": "Outpost Netting"
        },
        {
          "id": "OutpostTableItem",
          "en": "Outpost Table",
          "fr": "Table de l\u0027avant-poste",
          "es": "Mesa de puesto avanzado",
          "de": "Außenposten Tisch",
          "pt": "Mesa de posto avançado",
          "it": "Tavolo dell\u0027avamposto",
          "tr": "Outpost Table",
          "pl": "Outpost Table",
          "ru": "Стол аванпоста",
          "uk": "Outpost Table",
          "ko": "출장소",
          "zh": "探险桌",
          "ja": "Outpost Table"
        },
        {
          "id": "PlantVaseItem",
          "en": "Plant Vase",
          "fr": "Vase fleur",
          "es": "Jarrón para planta",
          "de": "Blumenvase",
          "pt": "Vaso de planta",
          "it": "Vaso con pianta decorata",
          "tr": "Plant Vase",
          "pl": "Plant Vase",
          "ru": "Ваза для растений",
          "uk": "Plant Vase",
          "ko": "초록빛 화병",
          "zh": "Plant Vase",
          "ja": "Plant Vase"
        },
        {
          "id": "PurpleVaseItem",
          "en": "Purple Vase",
          "fr": "Vase violet",
          "es": "Jarrón púrpura",
          "de": "Lila Vase",
          "pt": "Vaso violeta",
          "it": "Vaso viola",
          "tr": "Purple Vase",
          "pl": "Purple Vase",
          "ru": "Фиолетовая ваза",
          "uk": "Purple Vase",
          "ko": "보라색 화병",
          "zh": "紫色花瓶",
          "ja": "Purple Vase"
        },
        {
          "id": "RedVaseItem",
          "en": "Red Vase",
          "fr": "Vase rouge",
          "es": "Jarrón rojo",
          "de": "Rote Vase",
          "pt": "Vaso vermelho",
          "it": "Vaso rosso",
          "tr": "Red Vase",
          "pl": "Red Vase",
          "ru": "Красная ваза",
          "uk": "Red Vase",
          "ko": "빨간색 화병",
          "zh": "Red Vase",
          "ja": "Red Vase"
        },
        {
          "id": "SteelMooragePostItem",
          "en": "Steel Moorage Post",
          "fr": "Bollard en acier",
          "es": "Poste de amarre de acero",
          "de": "Stahl Ankerplatz",
          "pt": "Posto de Amarração de Aço",
          "it": "Palo d\u0027ormeggio d\u0027acciaio",
          "tr": "Steel Moorage Post",
          "pl": "Steel Moorage Post",
          "ru": "Стальной Причальный столб",
          "uk": "Steel Moorage Post",
          "ko": "강철 계선주",
          "zh": "Steel Moorage Post",
          "ja": "Steel Moorage Post"
        },
        {
          "id": "StenographersTableItem",
          "en": "Stenographers Table",
          "fr": "Table des sténographes",
          "es": "Mesa de taquígrafo",
          "de": "Stenographentisch",
          "pt": "Mesa de Estenógrafos",
          "it": "Tavolo degli stenografi",
          "tr": "Stenographers Table",
          "pl": "Stenographers Table",
          "ru": "Стол стенографиста",
          "uk": "Stenographers Table",
          "ko": "속기사의 책상",
          "zh": "速记员桌",
          "ja": "Stenographers Table"
        },
        {
          "id": "SwirlVaseItem",
          "en": "Swirl Vase",
          "fr": "Vase tourbillonnant",
          "es": "Jarrón en espiral",
          "de": "Strudelvase",
          "pt": "Vaso em Espiral",
          "it": "Vaso a onde",
          "tr": "Swirl Vase",
          "pl": "Swirl Vase",
          "ru": "Вихревая ваза",
          "uk": "Swirl Vase",
          "ko": "소용돌이 화병",
          "zh": "Swirl Vase",
          "ja": "Swirl Vase"
        },
        {
          "id": "WoodenMooragePostItem",
          "en": "Wooden Moorage Post",
          "fr": "Bollard en bois",
          "es": "Poste de amarre de madera",
          "de": "Hölzerner Ankerplatz",
          "pt": "Posto de Amarração de Madeira",
          "it": "Palo d\u0027ormeggio in legno",
          "tr": "Wooden Moorage Post",
          "pl": "Wooden Moorage Post",
          "ru": "Деревянный Причальный столб",
          "uk": "Wooden Moorage Post",
          "ko": "목제 계선주",
          "zh": "木制停泊墩",
          "ja": "Wooden Moorage Post"
        },
        {
          "id": "CultureItem",
          "en": "Culture",
          "fr": "Culture",
          "es": "Cultura",
          "de": "Kultur",
          "pt": "Cultura",
          "it": "Cultura",
          "tr": "Culture",
          "pl": "Culture",
          "ru": "Культура",
          "uk": "Culture",
          "ko": "Culture",
          "zh": "文化",
          "ja": "Culture"
        },
        {
          "id": "MediumShipyardItem",
          "en": "Medium Shipyard",
          "fr": "Chantier naval de taille moyenne",
          "es": "Astillero mediano",
          "de": "Mittelgroße Werft",
          "pt": "Medium Shipyard",
          "it": "Cantiere navale medio",
          "tr": "Medium Shipyard",
          "pl": "Średnia Stocznia",
          "ru": "Средняя Верфь",
          "uk": "Середня корабельня",
          "ko": "중형 조선소",
          "zh": "中型船坞",
          "ja": "Medium Shipyard"
        },
        {
          "id": "LargeCourtItem",
          "en": "Large Court",
          "fr": "Grand tribunal",
          "es": "Large Court",
          "de": "Großes Gericht",
          "pt": "Large Court",
          "it": "Grande tribunale",
          "tr": "Large Court",
          "pl": "Duży Sąd",
          "ru": "Большой Суд",
          "uk": "Великий суд",
          "ko": "큰 법원",
          "zh": "Large Court",
          "ja": "Large Court"
        },
        {
          "id": "SmallCourtItem",
          "en": "Small Court",
          "fr": "Petit tribunal",
          "es": "Small Court",
          "de": "Kleines Gericht",
          "pt": "Small Court",
          "it": "Piccolo tribunale",
          "tr": "Small Court",
          "pl": "Small Court",
          "ru": "Маленький Суд",
          "uk": "Малий суд",
          "ko": "작은 법원",
          "zh": "Small Court",
          "ja": "Small Court"
        },
        {
          "id": "CarbideHelmetLampItem",
          "en": "Carbide Helmet Lamp",
          "fr": "Casque en carbure avec lampe",
          "es": "Carbide Helmet Lamp",
          "de": "Hartmetall-Helmlampe",
          "pt": "Carbide Helmet Lamp",
          "it": "Lampada a carburo da casco",
          "tr": "Carbide Helmet Lamp",
          "pl": "Karbidowa lampka nahełmowa",
          "ru": "Карбидная лампа для шлема",
          "uk": "Карбідна шоломна лампа",
          "ko": "카바이드 안전등",
          "zh": "Carbide Helmet Lamp",
          "ja": "Carbide Helmet Lamp"
        },
        {
          "id": "OilHeadLampItem",
          "en": "Oil Head Lamp",
          "fr": "Lampe à huile frontale",
          "es": "Oil Head Lamp",
          "de": "Öl-Kopfscheinwerfer",
          "pt": "Oil Head Lamp",
          "it": "Lampada a olio frontale",
          "tr": "Oil Head Lamp",
          "pl": "Olejowa lampka czołowa",
          "ru": "Масляная фара",
          "uk": "Масляна шоломна лампа",
          "ko": "등유 안전등",
          "zh": "油灯头盔",
          "ja": "Oil Head Lamp"
        },
        {
          "id": "SandalsItem",
          "en": "Sandals",
          "fr": "Sandales",
          "es": "Sandalias",
          "de": "Sandalen",
          "pt": "Sandals",
          "it": "Sandali",
          "tr": "Sandals",
          "pl": "Sandały",
          "ru": "Сандалии",
          "uk": "Сандалі",
          "ko": "샌들",
          "zh": "Sandals",
          "ja": "Sandals"
        },
        {
          "id": "ShipwrightHatItem",
          "en": "Shipwright Hat",
          "fr": "Ensemble de charpentier naval : Chapeau",
          "es": "Shipwright Hat",
          "de": "Schiffsbauer-Hut",
          "pt": "Shipwright Hat",
          "it": "Cappello da Carpentiere Navale",
          "tr": "Shipwright Hat",
          "pl": "Kapelusz Szkutnika",
          "ru": "Фуражка кораблестроителя",
          "uk": "Капелюх корабельника",
          "ko": "조선공의 모자",
          "zh": "船工帽",
          "ja": "船大工の帽子"
        },
        {
          "id": "ShipwrightSandalsItem",
          "en": "Shipwright Sandals",
          "fr": "Ensemble de charpentier naval : Sandales",
          "es": "Shipwright Sandals",
          "de": "Schiffsbauer-Sandalen",
          "pt": "Shipwright Sandals",
          "it": "Sandali da Carpentiere Navale",
          "tr": "Shipwright Sandals",
          "pl": "Sandały Szkutnika",
          "ru": "Сандалии кораблестроителя",
          "uk": "Сандалі корабельника",
          "ko": "조선공의 샌들",
          "zh": "船工凉鞋",
          "ja": "船大工のサンダル"
        },
        {
          "id": "ShipwrightShirtItem",
          "en": "Shipwright Shirt",
          "fr": "Ensemble de charpentier naval : Chemise",
          "es": "Shipwright Shirt",
          "de": "Schiffsbauer-Oberteil",
          "pt": "Shipwright Shirt",
          "it": "Camicia da Carpentiere Navale",
          "tr": "Shipwright Shirt",
          "pl": "Koszula Szkutnika",
          "ru": "Тельняшка",
          "uk": "Сорочка корабельника",
          "ko": "조선공의 셔츠",
          "zh": "船工衬衫",
          "ja": "船大工のシャツ"
        },
        {
          "id": "SmithShirtItem",
          "en": "Smith Shirt",
          "fr": "Ensemble de forgeron : Chemise",
          "es": "Smith Shirt",
          "de": "Schmied-Oberteil",
          "pt": "Smith Shirt",
          "it": "Camicia da fabbro",
          "tr": "Smith Shirt",
          "pl": "Koszula Kowala",
          "ru": "Рубашка кузнеца",
          "uk": "Сорочка коваля",
          "ko": "대장장이 셔츠",
          "zh": "Smith Shirt",
          "ja": "Smith Shirt"
        },
        {
          "id": "ClaimToolItem",
          "en": "Claim Tool",
          "fr": "Outil de revendication",
          "es": "Herramienta de reclamo",
          "de": "Grundstückswerkzeug",
          "pt": "Claim Tool",
          "it": "Strumento di rivendicazione",
          "tr": "Claim Tool",
          "pl": "Claim Tool",
          "ru": "Инструмент землемера",
          "uk": "Інструмент подання претензій",
          "ko": "토지 소유 도구",
          "zh": "认领工具",
          "ja": "Claim Tool"
        },
        {
          "id": "HempMooringRopeItem",
          "en": "Hemp Mooring Rope",
          "fr": "Corde d\u0027amarrage en chanvre",
          "es": "Hemp Mooring Rope",
          "de": "Hanftau",
          "pt": "Hemp Mooring Rope",
          "it": "Corda d\u0027ormeggio in canapa",
          "tr": "Hemp Mooring Rope",
          "pl": "Konopna cuma",
          "ru": "Конопляный причальный канат",
          "uk": "Конопляний швартовий трос",
          "ko": "삼베 계선 밧줄",
          "zh": "Hemp Mooring Rope",
          "ja": "Hemp Mooring Rope"
        },
        {
          "id": "IronAnchorItem",
          "en": "Iron Anchor",
          "fr": "Ancre en fer",
          "es": "Ancla de hierro",
          "de": "Eisenanker",
          "pt": "Iron Anchor",
          "it": "Ancora di ferro",
          "tr": "Iron Anchor",
          "pl": "Żelazna kotwica",
          "ru": "Железный якорь",
          "uk": "Залізний якір",
          "ko": "철제 닻",
          "zh": "Iron Anchor",
          "ja": "Iron Anchor"
        },
        {
          "id": "IronHullSheetItem",
          "en": "Iron Hull Sheet",
          "fr": "Coque en plaque de fer",
          "es": "Iron Hull Sheet",
          "de": "Eisenrumpfblech",
          "pt": "Iron Hull Sheet",
          "it": "Lamiera dello scafo in ferro",
          "tr": "Iron Hull Sheet",
          "pl": "Żelazna płyta poszycia",
          "ru": "Железные листы обшивки корпуса",
          "uk": "Залізний лист корпусу",
          "ko": "철제 선각",
          "zh": "Iron Hull Sheet",
          "ja": "Iron Hull Sheet"
        },
        {
          "id": "LargeMetalShipFrameItem",
          "en": "Large Metal Ship Frame",
          "fr": "Structure de bateau grande en acier",
          "es": "Large Metal Ship Frame",
          "de": "Großer Metallschiffsrahmen",
          "pt": "Large Metal Ship Frame",
          "it": "Grande telaio da nave in metallo",
          "tr": "Large Metal Ship Frame",
          "pl": "Duża metalowa rama statku",
          "ru": "Большой металлический каркас корабля",
          "uk": "Великий металевий каркас корабля",
          "ko": "대형 철제 늑골",
          "zh": "Large Metal Ship Frame",
          "ja": "Large Metal Ship Frame"
        },
        {
          "id": "LargeWoodenShipFrameItem",
          "en": "Large Wooden Ship Frame",
          "fr": "Structure de bateau grande en bois",
          "es": "Large Wooden Ship Frame",
          "de": "Großer Holzschiffsrahmen",
          "pt": "Large Wooden Ship Frame",
          "it": "Grande telaio da nave in legno",
          "tr": "Large Wooden Ship Frame",
          "pl": "Duża drewniana rama statku",
          "ru": "Большой деревянный каркас корабля",
          "uk": "Великий дерев\u0027яний каркас корабля",
          "ko": "대형 목제 늑골",
          "zh": "大型木船龙骨",
          "ja": "Large Wooden Ship Frame"
        },
        {
          "id": "MediumMetalShipFrameItem",
          "en": "Medium Metal Ship Frame",
          "fr": "Structure de bateau moyenne en fer",
          "es": "Medium Metal Ship Frame",
          "de": "Mittelgroßer Metallschiffsrahmen",
          "pt": "Medium Metal Ship Frame",
          "it": "Telaio medio da nave in metallo",
          "tr": "Medium Metal Ship Frame",
          "pl": "Średnia metalowa rama statku",
          "ru": "Средний металлический каркас корабля",
          "uk": "Середній металевий каркас корабля",
          "ko": "중형 철제 늑골",
          "zh": "Medium Metal Ship Frame",
          "ja": "Medium Metal Ship Frame"
        },
        {
          "id": "MediumWoodenShipFrameItem",
          "en": "Medium Wooden Ship Frame",
          "fr": "Structure de bateau moyenne en bois",
          "es": "Medium Wooden Ship Frame",
          "de": "Großer Holzschiffsrahmen",
          "pt": "Medium Wooden Ship Frame",
          "it": "Telaio medio da nave in legno",
          "tr": "Medium Wooden Ship Frame",
          "pl": "Średnia drewniana rama statku",
          "ru": "Средний деревянный каркас корабля",
          "uk": "Середній дерев\u0027яний каркас корабля",
          "ko": "중형 목제 늑골",
          "zh": "中型木船龙骨",
          "ja": "Medium Wooden Ship Frame"
        },
        {
          "id": "MetalKeelItem",
          "en": "Metal Keel",
          "fr": "Quille en fer",
          "es": "Quilla de metal",
          "de": "Metallkiel",
          "pt": "Metal Keel",
          "it": "Chiglia in metallo",
          "tr": "Metal Keel",
          "pl": "Metalowy kil",
          "ru": "Металлический киль",
          "uk": "Металевий кіль",
          "ko": "철제 용골",
          "zh": "Metal Keel",
          "ja": "Metal Keel"
        },
        {
          "id": "MetalRudderItem",
          "en": "Metal Rudder",
          "fr": "Gouvernail en fer",
          "es": "Timón de metal",
          "de": "Ruder aus Metall",
          "pt": "Metal Rudder",
          "it": "Timone in metallo",
          "tr": "Metal Rudder",
          "pl": "Metalowy ster",
          "ru": "Металлический руль",
          "uk": "Металеве стерно",
          "ko": "철제 방향키",
          "zh": "Metal Rudder",
          "ja": "Metal Rudder"
        },
        {
          "id": "NylonMooringRopeItem",
          "en": "Nylon Mooring Rope",
          "fr": "Corde d\u0027amarrage en nylon",
          "es": "Nylon Mooring Rope",
          "de": "Nylontau",
          "pt": "Nylon Mooring Rope",
          "it": "Corda d\u0027ormeggio in nylon",
          "tr": "Nylon Mooring Rope",
          "pl": "Nylonowa cuma",
          "ru": "Нейлоновый причальный канат",
          "uk": "Нейлоновий швартовий трос",
          "ko": "나일론 계선 밧줄",
          "zh": "Nylon Mooring Rope",
          "ja": "Nylon Mooring Rope"
        },
        {
          "id": "SmallWoodenShipFrameItem",
          "en": "Small Wooden Ship Frame",
          "fr": "Structure de bateau petite en bois",
          "es": "Small Wooden Ship Frame",
          "de": "Kleiner Holzschiffsrahmen",
          "pt": "Small Wooden Ship Frame",
          "it": "Piccolo telaio da nave in legno",
          "tr": "Small Wooden Ship Frame",
          "pl": "Mała drewniana rama statku",
          "ru": "Маленький деревянный каркас корабля",
          "uk": "Малий дерев\u0027яний каркас корабля",
          "ko": "소형 목제 늑골",
          "zh": "小型木船龙骨",
          "ja": "Small Wooden Ship Frame"
        },
        {
          "id": "WoodenHullPlanksItem",
          "en": "Wooden Hull Planks",
          "fr": "Coque en bois",
          "es": "Wooden Hull Planks",
          "de": "Holzrumpfplanken",
          "pt": "Wooden Hull Planks",
          "it": "Assi dello scafo in legna",
          "tr": "Wooden Hull Planks",
          "pl": "Drewniane klepki poszycia",
          "ru": "Деревянные доски обшивки корпуса",
          "uk": "Дерев\u0027яні дошки корпусу",
          "ko": "목제 선각",
          "zh": "船身木板",
          "ja": "Wooden Hull Planks"
        },
        {
          "id": "WoodenKeelItem",
          "en": "Wooden Keel",
          "fr": "Quille en bois",
          "es": "Quilla de madera",
          "de": "Holzkiel",
          "pt": "Wooden Keel",
          "it": "Chiglia in legno",
          "tr": "Wooden Keel",
          "pl": "Drewniany kil",
          "ru": "Деревянный Киль",
          "uk": "Дерев’яний кіль",
          "ko": "목제 용골",
          "zh": "木制龙骨",
          "ja": "Wooden Keel"
        },
        {
          "id": "WoodenOarItem",
          "en": "Wooden Oar",
          "fr": "Rame en bois",
          "es": "Wooden Oar",
          "de": "Holzruder",
          "pt": "Wooden Oar",
          "it": "Remo in legno",
          "tr": "Wooden Oar",
          "pl": "Drewniane wiosło",
          "ru": "Деревянное весло",
          "uk": "Дерев’яне весло",
          "ko": "목제 노",
          "zh": "木桨",
          "ja": "Wooden Oar"
        },
        {
          "id": "WoodenRudderItem",
          "en": "Wooden Rudder",
          "fr": "Gouvernail en bois",
          "es": "Timón de madera",
          "de": "Holzruder",
          "pt": "Wooden Rudder",
          "it": "Timone in legno",
          "tr": "Wooden Rudder",
          "pl": "Drewniany ster",
          "ru": "Деревянный руль",
          "uk": "Дерев’яне стерно",
          "ko": "목제 방향키",
          "zh": "木制尾舵",
          "ja": "Wooden Rudder"
        },
        {
          "id": "ShipwrightAdvancedUpgradeItem",
          "en": "Shipwright Advanced Upgrade",
          "fr": "Amélioration avancée : Construction navale",
          "es": "Shipwright Advanced Upgrade",
          "de": "Fortgeschrittenes Werft-Upgrade",
          "pt": "Shipwright Advanced Upgrade",
          "it": "Aggiornamento avanzato del carpentiere navale",
          "tr": "Shipwright Advanced Upgrade",
          "pl": "Zaawansowane ulepszenie Szkutnictwa",
          "ru": "Продвинутое улучшение для кораблестроения",
          "uk": "Просунуте покращення корабельництва",
          "ko": "고급 조선 업그레이드",
          "zh": "造船高级升级",
          "ja": "船大工の応用アップグレード"
        },
        {
          "id": "ShipwrightBasicUpgradeItem",
          "en": "Shipwright Basic Upgrade",
          "fr": "Amélioration basique : Construction navale",
          "es": "Shipwright Basic Upgrade",
          "de": "Grundlegendes Werft-Upgrade",
          "pt": "Shipwright Basic Upgrade",
          "it": "Aggiornamento di base del carpentiere navale",
          "tr": "Shipwright Basic Upgrade",
          "pl": "Podstawowe ulepszenie Szkutnictwa",
          "ru": "Базовое улучшение для кораблестроения",
          "uk": "Базове покращення корабельництва",
          "ko": "기초 조선 업그레이드",
          "zh": "造船基础升级",
          "ja": "船大工の基礎アップグレード"
        },
        {
          "id": "HandheldCameraItem",
          "en": "Handheld Camera",
          "fr": "Appareil photo de poche",
          "es": "Handheld Camera",
          "de": "Handkamera",
          "pt": "Handheld Camera",
          "it": "Fotocamera portatile",
          "tr": "Handheld Camera",
          "pl": "Handheld Camera",
          "ru": "Портативная камера",
          "uk": "Ручна камера",
          "ko": "휴대용 카메라",
          "zh": "手持相机",
          "ja": "Handheld Camera"
        },
        {
          "id": "IronRoadToolItem",
          "en": "Iron Road Tool",
          "fr": "Outil de route en fer",
          "es": "Iron Road Tool",
          "de": "Eisen-Straßenwerkzeug",
          "pt": "Iron Road Tool",
          "it": "Strumento stradale in ferro",
          "tr": "Iron Road Tool",
          "pl": "Iron Road Tool",
          "ru": "Железная трамбовка",
          "uk": "Залізний дорожній інструмент",
          "ko": "철제 도로정비 도구",
          "zh": "Iron Road Tool",
          "ja": "Iron Road Tool"
        },
        {
          "id": "TripodCameraItem",
          "en": "Tripod Camera",
          "fr": "Appareil photo à trépied",
          "es": "Tripod Camera",
          "de": "Stativ-Kamera",
          "pt": "Tripod Camera",
          "it": "Telecamera treppiede",
          "tr": "Tripod Camera",
          "pl": "Tripod Camera",
          "ru": "Камера на штативе",
          "uk": "Камера на штативі",
          "ko": "삼각대 카메라",
          "zh": "三脚架相机",
          "ja": "Tripod Camera"
        },
        {
          "id": "IndustrialBargeItem",
          "en": "Industrial Barge",
          "fr": "Bac industriel",
          "es": "Industrial Barge",
          "de": "Industriekahn",
          "pt": "Industrial Barge",
          "it": "Chiatta industriale",
          "tr": "Industrial Barge",
          "pl": "Industrial Barge",
          "ru": "Промышленная Баржа",
          "uk": "Промислова баржа",
          "ko": "공업용 바지선",
          "zh": "Industrial Barge",
          "ja": "Industrial Barge"
        },
        {
          "id": "LargeCanoeItem",
          "en": "Large Canoe",
          "fr": "Grand canoë",
          "es": "Large Canoe",
          "de": "Großes Kanu",
          "pt": "Large Canoe",
          "it": "Canoa grande",
          "tr": "Large Canoe",
          "pl": "Duży kajak",
          "ru": "Большое Каноэ",
          "uk": "Велике каное",
          "ko": "대형 카누",
          "zh": "Large Canoe",
          "ja": "Large Canoe"
        },
        {
          "id": "MediumFishingTrawlerItem",
          "en": "Medium Fishing Trawler",
          "fr": "Chalutier de pêche de taille moyenne",
          "es": "Medium Fishing Trawler",
          "de": "Mittelgroßer Schleppnetzfischer",
          "pt": "Medium Fishing Trawler",
          "it": "Peschereccio medio",
          "tr": "Medium Fishing Trawler",
          "pl": "Średni kuter rybacki",
          "ru": "Средний рыболовный траулер",
          "uk": "Середній рибальський траулер",
          "ko": "중형 저인망 어선",
          "zh": "Medium Fishing Trawler",
          "ja": "Medium Fishing Trawler"
        },
        {
          "id": "SmallCanoeItem",
          "en": "Small Canoe",
          "fr": "Petit canoë",
          "es": "Small Canoe",
          "de": "Kleines Kanu",
          "pt": "Small Canoe",
          "it": "Canoa piccola",
          "tr": "Small Canoe",
          "pl": "Small Canoe",
          "ru": "Маленькое Каноэ",
          "uk": "Мале каное",
          "ko": "소형 카누",
          "zh": "小独木舟",
          "ja": "小さなカヌー"
        },
        {
          "id": "WoodenTransportShipItem",
          "en": "Wooden Transport Ship",
          "fr": "Bateau de transport en bois",
          "es": "Wooden Transport Ship",
          "de": "Holztransportschiff",
          "pt": "Wooden Transport Ship",
          "it": "Nave da trasporto in legno",
          "tr": "Wooden Transport Ship",
          "pl": "Drewniany statek transportowy",
          "ru": "Деревянный Транспортный Корабль",
          "uk": "Дерев\u0027яний транспортний корабель",
          "ko": "목제 수송선",
          "zh": "木制运输船",
          "ja": "Wooden Transport Ship"
        },
        {
          "id": "CopperFrameLandscapeItem",
          "en": "Copper Frame Landscape",
          "fr": "Cadre paysage en cuivre",
          "es": "Copper Frame Landscape",
          "de": "Kupferrahmen: Querformat",
          "pt": "Copper Frame Landscape",
          "it": "Cornice orizzontale in rame",
          "tr": "Copper Frame Landscape",
          "pl": "Copper Frame Landscape",
          "ru": "Альбомная медная рамка",
          "uk": "Краєвид у мідній рамці",
          "ko": "동테 풍경화 액자",
          "zh": "Copper Frame Landscape",
          "ja": "Copper Frame Landscape"
        },
        {
          "id": "CopperFramePortraitItem",
          "en": "Copper Frame Portrait",
          "fr": "Cadre portrait en cuivre",
          "es": "Copper Frame Portrait",
          "de": "Kupferrahmen: Hochformat",
          "pt": "Copper Frame Portrait",
          "it": "Cornice verticale in rame",
          "tr": "Copper Frame Portrait",
          "pl": "Copper Frame Portrait",
          "ru": "Книжная медная рамка",
          "uk": "Портрет у мідній рамці",
          "ko": "동테 초상화 액자",
          "zh": "Copper Frame Portrait",
          "ja": "Copper Frame Portrait"
        },
        {
          "id": "CopperFrameSquareItem",
          "en": "Copper Frame Square",
          "fr": "Cadre carré en cuivre",
          "es": "Marco cuadrado de cobre",
          "de": "Kupferrahmen: Quadratisch",
          "pt": "Copper Frame Square",
          "it": "Cornice quadrata in rame",
          "tr": "Copper Frame Square",
          "pl": "Copper Frame Square",
          "ru": "Квадратная медная рамка",
          "uk": "Квадратна мідна рамка",
          "ko": "동테 사각형 액자",
          "zh": "Copper Frame Square",
          "ja": "Copper Frame Square"
        },
        {
          "id": "CopperFrameTallItem",
          "en": "Copper Frame Tall",
          "fr": "Cadre grand portrait en cuivre",
          "es": "Copper Frame Tall",
          "de": "Kupferrahmen: Hoch",
          "pt": "Copper Frame Tall",
          "it": "Cornice alta in rame",
          "tr": "Copper Frame Tall",
          "pl": "Copper Frame Tall",
          "ru": "Вытянутая медная рамка",
          "uk": "Висока мідна рамка",
          "ko": "동테 기다란 액자",
          "zh": "Copper Frame Tall",
          "ja": "Copper Frame Tall"
        },
        {
          "id": "CopperFrameWideItem",
          "en": "Copper Frame Wide",
          "fr": "Cadre grand paysage en cuivre",
          "es": "Copper Frame Wide",
          "de": "Kupferrahmen: Breit",
          "pt": "Copper Frame Wide",
          "it": "Cornice ampia in rame",
          "tr": "Copper Frame Wide",
          "pl": "Copper Frame Wide",
          "ru": "Широкая медная рамка",
          "uk": "Широка мідна рамка",
          "ko": "동테 넓은 액자",
          "zh": "Copper Frame Wide",
          "ja": "Copper Frame Wide"
        },
        {
          "id": "CottonStreamerStarsItem",
          "en": "Cotton Streamer Stars",
          "fr": "Banderole étoilée en coton",
          "es": "Cotton Streamer Stars",
          "de": "Cotton Streamer Stars",
          "pt": "Cotton Streamer Stars",
          "it": "Stelle filanti di cotone",
          "tr": "Cotton Streamer Stars",
          "pl": "Cotton Streamer Stars",
          "ru": "Хлопковая лента флажков со звездами",
          "uk": "Зоряний бавовняний банер",
          "ko": "별이 그려진 면직물 현수막",
          "zh": "Cotton Streamer Stars",
          "ja": "Cotton Streamer Stars"
        },
        {
          "id": "CottonStreamerStripesItem",
          "en": "Cotton Streamer Stripes",
          "fr": "Banderole à rayures en coton",
          "es": "Cotton Streamer Stripes",
          "de": "Cotton Streamer Stripes",
          "pt": "Cotton Streamer Stripes",
          "it": "Strisce filanti di cotone",
          "tr": "Cotton Streamer Stripes",
          "pl": "Cotton Streamer Stripes",
          "ru": "Хлопковая лента флажков с полосками",
          "uk": "Смугастий бавовняний банер",
          "ko": "줄이 그려진 면직물 현수막",
          "zh": "Cotton Streamer Stripes",
          "ja": "Cotton Streamer Stripes"
        },
        {
          "id": "DecorativeAnchorItem",
          "en": "Decorative Anchor",
          "fr": "Ancre décorative",
          "es": "Decorative Anchor",
          "de": "Dekorativer Anker",
          "pt": "Decorative Anchor",
          "it": "Ancora decorativa",
          "tr": "Decorative Anchor",
          "pl": "Decorative Anchor",
          "ru": "Декоративный якорь",
          "uk": "Декоративний якір",
          "ko": "장식용 닻",
          "zh": "Decorative Anchor",
          "ja": "Decorative Anchor"
        },
        {
          "id": "DecorativeGlassBuoyBlueItem",
          "en": "Decorative Glass Buoy Blue",
          "fr": "Flotteur décoratif en verre bleu",
          "es": "Boya azul decorativa de cristal",
          "de": "Dekorative blaue Glasboje",
          "pt": "Decorative Glass Buoy Blue",
          "it": "Boa di vetro decorativa blu",
          "tr": "Decorative Glass Buoy Blue",
          "pl": "Decorative Glass Buoy Blue",
          "ru": "Декоративный стеклянный синий буй",
          "uk": "Декоративний скляний синій буй",
          "ko": "장식용 파란색 유리 부표",
          "zh": "Decorative Glass Buoy Blue",
          "ja": "Decorative Glass Buoy Blue"
        },
        {
          "id": "DecorativeGlassBuoyGreenItem",
          "en": "Decorative Glass Buoy Green",
          "fr": "Flotteur décoratif en verre vert",
          "es": "Boya verde decorativa de cristal",
          "de": "Dekorative grüne Glasboje",
          "pt": "Decorative Glass Buoy Green",
          "it": "Boa di vetro decorativa verde",
          "tr": "Decorative Glass Buoy Green",
          "pl": "Decorative Glass Buoy Green",
          "ru": "Декоративный стеклянный зеленый буй",
          "uk": "Декоративний скляний зелений буй",
          "ko": "장식용 연두색 유리 부표",
          "zh": "Decorative Glass Buoy Green",
          "ja": "Decorative Glass Buoy Green"
        },
        {
          "id": "DecorativeGlassBuoyRedItem",
          "en": "Decorative Glass Buoy Red",
          "fr": "Flotteur décoratif en verre rouge",
          "es": "Boya roja decorativa de cristal",
          "de": "Dekorative rote Glasboje",
          "pt": "Decorative Glass Buoy Red",
          "it": "Boa di vetro decorativa rossa",
          "tr": "Decorative Glass Buoy Red",
          "pl": "Decorative Glass Buoy Red",
          "ru": "Декоративный стеклянный красный буй",
          "uk": "Декоративний скляний червоний буй",
          "ko": "장식용 빨간색 유리 부표",
          "zh": "Decorative Glass Buoy Red",
          "ja": "Decorative Glass Buoy Red"
        },
        {
          "id": "DecorativeGlassBuoyVioletItem",
          "en": "Decorative Glass Buoy Violet",
          "fr": "Flotteur décoratif en verre violet",
          "es": "Boya violeta decorativa de cristal",
          "de": "Dekorative lilafarbene Glasboje",
          "pt": "Decorative Glass Buoy Violet",
          "it": "Boa di vetro decorativa viola",
          "tr": "Decorative Glass Buoy Violet",
          "pl": "Decorative Glass Buoy Violet",
          "ru": "Декоративный стеклянный фиолетовый буй",
          "uk": "Декоративний скляний фіолетовий буй",
          "ko": "장식용 보라색 유리 부표",
          "zh": "Decorative Glass Buoy Violet",
          "ja": "Decorative Glass Buoy Violet"
        },
        {
          "id": "DecorativeGlassBuoyYellowItem",
          "en": "Decorative Glass Buoy Yellow",
          "fr": "Flotteur décoratif en verre jaune",
          "es": "Boya amarilla decorativa de cristal",
          "de": "Dekorative gelbe Glasboje",
          "pt": "Decorative Glass Buoy Yellow",
          "it": "Boa di vetro decorativa gialla",
          "tr": "Decorative Glass Buoy Yellow",
          "pl": "Decorative Glass Buoy Yellow",
          "ru": "Декоративный стеклянный жёлтый буй",
          "uk": "Декоративний скляний жовтий буй",
          "ko": "장식용 노란색 유리 부표",
          "zh": "Decorative Glass Buoy Yellow",
          "ja": "Decorative Glass Buoy Yellow"
        },
        {
          "id": "DecorativeHangingBuoyItem",
          "en": "Decorative Hanging Buoy",
          "fr": "Flotteurs décoratifs suspendus",
          "es": "Boya colgante decorativa",
          "de": "Dekorative Hängeboje",
          "pt": "Decorative Hanging Buoy",
          "it": "Boa decorativa appesa",
          "tr": "Decorative Hanging Buoy",
          "pl": "Decorative Hanging Buoy",
          "ru": "Декоративный подвесной буй",
          "uk": "Декоративний підвісний буй",
          "ko": "장식용 내건 부표",
          "zh": "Decorative Hanging Buoy",
          "ja": "Decorative Hanging Buoy"
        },
        {
          "id": "DecorativeLifePreserverItem",
          "en": "Decorative Life Preserver",
          "fr": "Bouée de sauvetage décorative",
          "es": "Decorative Life Preserver",
          "de": "Dekorativer Lebensretter",
          "pt": "Decorative Life Preserver",
          "it": "Salvagente decorativo",
          "tr": "Decorative Life Preserver",
          "pl": "Decorative Life Preserver",
          "ru": "Декоративный спасательный круг",
          "uk": "Декоративний рятувальний круг",
          "ko": "장식용 구명 튜브",
          "zh": "Decorative Life Preserver",
          "ja": "Decorative Life Preserver"
        },
        {
          "id": "DecorativeShipWheelItem",
          "en": "Decorative Ship Wheel",
          "fr": "Barre de bateau décorative",
          "es": "Decorative Ship Wheel",
          "de": "Dekoratives Steuerrad",
          "pt": "Decorative Ship Wheel",
          "it": "Timone decorativo",
          "tr": "Decorative Ship Wheel",
          "pl": "Decorative Ship Wheel",
          "ru": "Декоративный штурвал",
          "uk": "Декоративний штурвал",
          "ko": "장식용 조타기",
          "zh": "Decorative Ship Wheel",
          "ja": "Decorative Ship Wheel"
        },
        {
          "id": "FishRackItem",
          "en": "Fish Rack",
          "fr": "Séchoir à poissons",
          "es": "Fish Rack",
          "de": "Fischregal",
          "pt": "Fish Rack",
          "it": "Scaffale per pesci",
          "tr": "Fish Rack",
          "pl": "Fish Rack",
          "ru": "Стойка для рыбы",
          "uk": "Рибна стійка",
          "ko": "건조용 생선 걸개",
          "zh": "Fish Rack",
          "ja": "Fish Rack"
        },
        {
          "id": "GoldFrameLandscapeItem",
          "en": "Gold Frame Landscape",
          "fr": "Cadre paysage en or",
          "es": "Gold Frame Landscape",
          "de": "Goldrahmen: Querformat",
          "pt": "Gold Frame Landscape",
          "it": "Cornice orizzontale d\u0027oro",
          "tr": "Gold Frame Landscape",
          "pl": "Gold Frame Landscape",
          "ru": "Альбомная золотая рамка",
          "uk": "Краєвид у золотій рамці",
          "ko": "금테 풍경화 액자",
          "zh": "Gold Frame Landscape",
          "ja": "Gold Frame Landscape"
        },
        {
          "id": "GoldFramePortraitItem",
          "en": "Gold Frame Portrait",
          "fr": "Cadre portrait en or",
          "es": "Gold Frame Portrait",
          "de": "Goldrahmen: Hochformat",
          "pt": "Gold Frame Portrait",
          "it": "Cornice verticale d\u0027oro",
          "tr": "Gold Frame Portrait",
          "pl": "Gold Frame Portrait",
          "ru": "Книжная золотая рамка",
          "uk": "Портрет у золотій рамці",
          "ko": "금테 초상화 액자",
          "zh": "Gold Frame Portrait",
          "ja": "Gold Frame Portrait"
        },
        {
          "id": "GoldFrameSquareItem",
          "en": "Gold Frame Square",
          "fr": "Cadre carré en or",
          "es": "Marco cuadrado de oro",
          "de": "Goldrahmen: Quadratisch",
          "pt": "Gold Frame Square",
          "it": "Cornice quadrata d\u0027oro",
          "tr": "Gold Frame Square",
          "pl": "Gold Frame Square",
          "ru": "Квадратная золотая рамка",
          "uk": "Квадратна золота рамка",
          "ko": "금테 사각 액자",
          "zh": "Gold Frame Square",
          "ja": "Gold Frame Square"
        },
        {
          "id": "GoldFrameTallItem",
          "en": "Gold Frame Tall",
          "fr": "Cadre grand portrait en or",
          "es": "Gold Frame Tall",
          "de": "Goldrahmen: Hoch",
          "pt": "Gold Frame Tall",
          "it": "Cornice alta d\u0027oro",
          "tr": "Gold Frame Tall",
          "pl": "Gold Frame Tall",
          "ru": "Вытянутая золотая рамка",
          "uk": "Висока золота рамка",
          "ko": "금테 기다란 액자",
          "zh": "Gold Frame Tall",
          "ja": "Gold Frame Tall"
        },
        {
          "id": "GoldFrameWideItem",
          "en": "Gold Frame Wide",
          "fr": "Cadre grand paysage en or",
          "es": "Gold Frame Wide",
          "de": "Goldrahmen: Breit",
          "pt": "Gold Frame Wide",
          "it": "Cornice ampia d\u0027oro",
          "tr": "Gold Frame Wide",
          "pl": "Gold Frame Wide",
          "ru": "Широкая золотая рамка",
          "uk": "Широка золота рамка",
          "ko": "금테 넓은 액자",
          "zh": "Gold Frame Wide",
          "ja": "Gold Frame Wide"
        },
        {
          "id": "IronFrameLandscapeItem",
          "en": "Iron Frame Landscape",
          "fr": "Cadre paysage en fer",
          "es": "Iron Frame Landscape",
          "de": "Eisenrahmen: Querformat",
          "pt": "Iron Frame Landscape",
          "it": "Cornice orizzontale di ferro",
          "tr": "Iron Frame Landscape",
          "pl": "Iron Frame Landscape",
          "ru": "Альбомная железная рамка",
          "uk": "Краєвид у залізній рамці",
          "ko": "철테 풍경화 액자",
          "zh": "Iron Frame Landscape",
          "ja": "Iron Frame Landscape"
        },
        {
          "id": "IronFramePortraitItem",
          "en": "Iron Frame Portrait",
          "fr": "Cadre portrait en fer",
          "es": "Iron Frame Portrait",
          "de": "Eisenrahmen: Hochformat",
          "pt": "Iron Frame Portrait",
          "it": "Cornice verticale di ferro",
          "tr": "Iron Frame Portrait",
          "pl": "Iron Frame Portrait",
          "ru": "Книжная железная рамка",
          "uk": "Портрет у залізній рамці",
          "ko": "철테 초상화 액자",
          "zh": "Iron Frame Portrait",
          "ja": "Iron Frame Portrait"
        },
        {
          "id": "IronFrameSquareItem",
          "en": "Iron Frame Square",
          "fr": "Cadre carré en fer",
          "es": "Marco cuadrado de hierro",
          "de": "Eisenrahmen: Quadratisch",
          "pt": "Iron Frame Square",
          "it": "Cornice quadrata di ferro",
          "tr": "Iron Frame Square",
          "pl": "Iron Frame Square",
          "ru": "Квадратная железная рамка",
          "uk": "Квадратна залізна рамка",
          "ko": "철테 사각 액자",
          "zh": "Iron Frame Square",
          "ja": "Iron Frame Square"
        },
        {
          "id": "IronFrameTallItem",
          "en": "Iron Frame Tall",
          "fr": "Cadre grand portrait en fer",
          "es": "Iron Frame Tall",
          "de": "Eisenrahmen: Hoch",
          "pt": "Iron Frame Tall",
          "it": "Cornice alta in ferro",
          "tr": "Iron Frame Tall",
          "pl": "Iron Frame Tall",
          "ru": "Вытянутая железная рамка",
          "uk": "Висока залізна рамка",
          "ko": "철테 기다란 액자",
          "zh": "Iron Frame Tall",
          "ja": "Iron Frame Tall"
        },
        {
          "id": "IronFrameWideItem",
          "en": "Iron Frame Wide",
          "fr": "Cadre grand paysage en fer",
          "es": "Iron Frame Wide",
          "de": "Eisenrahmen: Breit",
          "pt": "Iron Frame Wide",
          "it": "Cornice ampia in ferro",
          "tr": "Iron Frame Wide",
          "pl": "Iron Frame Wide",
          "ru": "Широкая железная рамка",
          "uk": "Широка залізна рамка",
          "ko": "철테 넓은 액자",
          "zh": "Iron Frame Wide",
          "ja": "Iron Frame Wide"
        },
        {
          "id": "LargeCottonBuntingFestiveItem",
          "en": "Large Cotton Bunting Festive",
          "fr": "Grande guirlande festive en coton",
          "es": "Large Cotton Bunting Festive",
          "de": "Große festliche Baumwoll-Wimpelkette",
          "pt": "Large Cotton Bunting Festive",
          "it": "Bandierina da festa in cotone grande",
          "tr": "Large Cotton Bunting Festive",
          "pl": "Duża świąteczna girlanda z bawełny",
          "ru": "Большой хлопковый праздничный флаг",
          "uk": "Великий святковий прапор з бавовни",
          "ko": "대형 축제용 면직물 깃발",
          "zh": "Large Cotton Bunting Festive",
          "ja": "Large Cotton Bunting Festive"
        },
        {
          "id": "LargeCottonBuntingRedItem",
          "en": "Large Cotton Bunting Red",
          "fr": "Grande guirlande rouge en coton",
          "es": "Large Cotton Bunting Red",
          "de": "Große rote Baumwoll-Wimpelkette",
          "pt": "Large Cotton Bunting Red",
          "it": "Bandierina rossa in cotone grande",
          "tr": "Large Cotton Bunting Red",
          "pl": "Duża czerwona girlanda z bawełny",
          "ru": "Большой хлопковый красный флаг",
          "uk": "Великий червоний прапор з бавовни",
          "ko": "대형 빨간색 면직물 깃발",
          "zh": "Large Cotton Bunting Red",
          "ja": "Large Cotton Bunting Red"
        },
        {
          "id": "LargeCottonBuntingRegalItem",
          "en": "Large Cotton Bunting Regal",
          "fr": "Grande guirlande royale en coton",
          "es": "Large Cotton Bunting Regal",
          "de": "Große majestätische Baumwoll-Wimpelkette",
          "pt": "Large Cotton Bunting Regal",
          "it": "Bandierina regale in cotone grande",
          "tr": "Large Cotton Bunting Regal",
          "pl": "Duża królewska girlanda z bawełny",
          "ru": "Большой хлопковый королевский флаг",
          "uk": "Великий королівський прапор з бавовни",
          "ko": "대형 국왕의 면직물 깃발",
          "zh": "Large Cotton Bunting Regal",
          "ja": "Large Cotton Bunting Regal"
        },
        {
          "id": "LargeCottonBuntingVibrantItem",
          "en": "Large Cotton Bunting Vibrant",
          "fr": "Grande guirlande éclatante en coton",
          "es": "Large Cotton Bunting Vibrant",
          "de": "Große lebendige Baumwoll-Wimpelkette",
          "pt": "Large Cotton Bunting Vibrant",
          "it": "Bandierina vivace in cotone grande",
          "tr": "Large Cotton Bunting Vibrant",
          "pl": "Duża jasna girlanda z bawełny",
          "ru": "Большой хлопковый яркий флаг",
          "uk": "Великий яскравий прапор з бавовни",
          "ko": "대형 활기찬 면직물 깃발",
          "zh": "Large Cotton Bunting Vibrant",
          "ja": "Large Cotton Bunting Vibrant"
        },
        {
          "id": "LargeFestivePaperLanternItem",
          "en": "Large Festive Paper Lantern",
          "fr": "Grande lanterne festive en papier",
          "es": "Large Festive Paper Lantern",
          "de": "Große festliche Papierlaterne",
          "pt": "Large Festive Paper Lantern",
          "it": "Grande lanterna di carta festiva",
          "tr": "Large Festive Paper Lantern",
          "pl": "Duży świąteczny lampion z papieru",
          "ru": "Большой праздничный бумажный фонарь",
          "uk": "Великий святковий паперовий ліхтарик",
          "ko": "대형 축제용 종이 제등",
          "zh": "Large Festive Paper Lantern",
          "ja": "Large Festive Paper Lantern"
        },
        {
          "id": "LargeNylonBuntingGreenItem",
          "en": "Large Nylon Bunting Green",
          "fr": "Grande guirlande verte en nylon",
          "es": "Large Nylon Bunting Green",
          "de": "Große grüne Nylon-Wimpelkette",
          "pt": "Large Nylon Bunting Green",
          "it": "Grande bandierina verde in nylon",
          "tr": "Large Nylon Bunting Green",
          "pl": "Duża nylonowa girlanda w kolorze zielonym",
          "ru": "Большой нейлоновый зеленый флаг",
          "uk": "Великий зелений прапор з нейлону",
          "ko": "대형 연두색 나일론 깃발",
          "zh": "Large Nylon Bunting Green",
          "ja": "Large Nylon Bunting Green"
        },
        {
          "id": "LargeNylonBuntingPurpleItem",
          "en": "Large Nylon Bunting Purple",
          "fr": "Grande guirlande violette en nylon",
          "es": "Large Nylon Bunting Purple",
          "de": "Große lilafarbene Nylon-Wimpelkette",
          "pt": "Large Nylon Bunting Purple",
          "it": "Grande bandierina viola in nylon",
          "tr": "Large Nylon Bunting Purple",
          "pl": "Duża nylonowa girlanda w kolorze fioletowym",
          "ru": "Большой нейлоновый фиолетовый флаг",
          "uk": "Великий фіолетовий прапор з нейлону",
          "ko": "대형 보라색 나일론 깃발",
          "zh": "Large Nylon Bunting Purple",
          "ja": "Large Nylon Bunting Purple"
        },
        {
          "id": "LargeNylonBuntingYellowItem",
          "en": "Large Nylon Bunting Yellow",
          "fr": "Grande guirlande jaune en nylon",
          "es": "Large Nylon Bunting Yellow",
          "de": "Große gelbe Nylon-Wimpelkette",
          "pt": "Large Nylon Bunting Yellow",
          "it": "Grande bandierina gialla in nylon",
          "tr": "Large Nylon Bunting Yellow",
          "pl": "Duża nylonowa girlanda w kolorze żółtym",
          "ru": "Большой нейлоновый жёлтый флаг",
          "uk": "Великий жовтий прапор з нейлону",
          "ko": "대형 노란색 나일론 깃발",
          "zh": "Large Nylon Bunting Yellow",
          "ja": "Large Nylon Bunting Yellow"
        },
        {
          "id": "LargePaperLanternItem",
          "en": "Large Paper Lantern",
          "fr": "Grande lanterne en papier",
          "es": "Large Paper Lantern",
          "de": "Großer Papierlaterne",
          "pt": "Large Paper Lantern",
          "it": "Grande lanterna di carta",
          "tr": "Large Paper Lantern",
          "pl": "Duży lampion z papieru",
          "ru": "Большой бумажный фонарь",
          "uk": "Великий паперовий ліхтар",
          "ko": "대형 종이 제등",
          "zh": "Large Paper Lantern",
          "ja": "Large Paper Lantern"
        },
        {
          "id": "LumberWarehouseShelvesItem",
          "en": "Lumber Warehouse Shelves",
          "fr": "Rayonnages d\u0027entrepôt en bois d\u0027œuvre",
          "es": "Lumber Warehouse Shelves",
          "de": "Holz-Lagerhausregale",
          "pt": "Lumber Warehouse Shelves",
          "it": "Scaffali del magazzino del falegname",
          "tr": "Lumber Warehouse Shelves",
          "pl": "Drewniane półki magazynowe",
          "ru": "Складской стеллаж из пиломатериалов",
          "uk": "Стелажі для складу пиломатеріалів",
          "ko": "Lumber Warehouse Shelves",
          "zh": "Lumber Warehouse Shelves",
          "ja": "Lumber Warehouse Shelves"
        },
        {
          "id": "OrnateGoldFrameLandscapeItem",
          "en": "Ornate Gold Frame Landscape",
          "fr": "Cadre paysage orné en or",
          "es": "Ornate Gold Frame Landscape",
          "de": "Kunstvoller Goldrahmen: Querformat",
          "pt": "Ornate Gold Frame Landscape",
          "it": "Cornice orizzontale ornata in oro",
          "tr": "Ornate Gold Frame Landscape",
          "pl": "Ornate Gold Frame Landscape",
          "ru": "Изящная золотая рамка для панорамы",
          "uk": "Краєвид в оздоблений золотій рамці",
          "ko": "장식된 금테 풍경화 액자",
          "zh": "Ornate Gold Frame Landscape",
          "ja": "Ornate Gold Frame Landscape"
        },
        {
          "id": "OrnateGoldFramePortraitItem",
          "en": "Ornate Gold Frame Portrait",
          "fr": "Cadre portrait orné en or",
          "es": "Ornate Gold Frame Portrait",
          "de": "Kunstvoller Goldrahmen: Hochformat",
          "pt": "Ornate Gold Frame Portrait",
          "it": "Cornice verticale ornata in oro",
          "tr": "Ornate Gold Frame Portrait",
          "pl": "Ornate Gold Frame Portrait",
          "ru": "Изящная золотая портретная рамка",
          "uk": "Портрет в оздобленій золотій рамці",
          "ko": "장식된 금테 초상화 액자",
          "zh": "Ornate Gold Frame Portrait",
          "ja": "Ornate Gold Frame Portrait"
        },
        {
          "id": "OrnateGoldFrameSquareItem",
          "en": "Ornate Gold Frame Square",
          "fr": "Cadre carré orné en or",
          "es": "Marco cuadrado de oro con adornos",
          "de": "Kunstvoller Goldrahmen: Quadratisch",
          "pt": "Ornate Gold Frame Square",
          "it": "Cornice quadrata ornata in oro",
          "tr": "Ornate Gold Frame Square",
          "pl": "Ornate Gold Frame Square",
          "ru": "Изящная золотая квадратная рамка",
          "uk": "Квадратна оздоблена золота рамка",
          "ko": "장식된 금테 사각 액자",
          "zh": "Ornate Gold Frame Square",
          "ja": "Ornate Gold Frame Square"
        },
        {
          "id": "OrnateGoldFrameTallItem",
          "en": "Ornate Gold Frame Tall",
          "fr": "Cadre grand portrait orné en or",
          "es": "Ornate Gold Frame Tall",
          "de": "Kunstvoller Goldrahmen: Hoch",
          "pt": "Ornate Gold Frame Tall",
          "it": "Cornice alta ornata in oro",
          "tr": "Ornate Gold Frame Tall",
          "pl": "Ornate Gold Frame Tall",
          "ru": "Изящная золотая вертикальная рамка",
          "uk": "Висока оздоблена золота рамка",
          "ko": "장식된 금테 기다란 액자",
          "zh": "Ornate Gold Frame Tall",
          "ja": "Ornate Gold Frame Tall"
        },
        {
          "id": "OrnateGoldFrameWideItem",
          "en": "Ornate Gold Frame Wide",
          "fr": "Cadre grand paysage orné en or",
          "es": "Ornate Gold Frame Wide",
          "de": "Kunstvoller Goldrahmen: Breit",
          "pt": "Ornate Gold Frame Wide",
          "it": "Cornice ampia ornata in oro",
          "tr": "Ornate Gold Frame Wide",
          "pl": "Ornate Gold Frame Wide",
          "ru": "Изящная золотая широкая рамка",
          "uk": "Широка оздоблена золота рамка",
          "ko": "장식된 금테 넓은 액자",
          "zh": "Ornate Gold Frame Wide",
          "ja": "Ornate Gold Frame Wide"
        },
        {
          "id": "OrnateIronFrameLandscapeItem",
          "en": "Ornate Iron Frame Landscape",
          "fr": "Cadre paysage orné en fer",
          "es": "Ornate Iron Frame Landscape",
          "de": "Kunstvoller Eisenrahmen: Querformat",
          "pt": "Ornate Iron Frame Landscape",
          "it": "Cornice orizzontale ornata in ferro",
          "tr": "Ornate Iron Frame Landscape",
          "pl": "Ornate Iron Frame Landscape",
          "ru": "Изящная железная панорамная рамка",
          "uk": "Краєвид в оздоблений залізній рамці",
          "ko": "장식된 철테 풍경화 액자",
          "zh": "Ornate Iron Frame Landscape",
          "ja": "Ornate Iron Frame Landscape"
        },
        {
          "id": "OrnateIronFramePortraitItem",
          "en": "Ornate Iron Frame Portrait",
          "fr": "Cadre portrait orné en fer",
          "es": "Ornate Iron Frame Portrait",
          "de": "Kunstvoller Eisenrahmen: Hochformat",
          "pt": "Ornate Iron Frame Portrait",
          "it": "Cornice verticale ornata in ferro",
          "tr": "Ornate Iron Frame Portrait",
          "pl": "Ornate Iron Frame Portrait",
          "ru": "Изящная железная портретная рамка",
          "uk": "Портрет в оздобленій залізній рамці",
          "ko": "장식된 철테 초상화 액자",
          "zh": "Ornate Iron Frame Portrait",
          "ja": "Ornate Iron Frame Portrait"
        },
        {
          "id": "OrnateIronFrameSquareItem",
          "en": "Ornate Iron Frame Square",
          "fr": "Cadre carré orné en fer",
          "es": "Marco cuadrado de hierro con adornos",
          "de": "Kunstvoller Eisenrahmen: Quadratisch",
          "pt": "Ornate Iron Frame Square",
          "it": "Cornice quadrata ornata in ferro",
          "tr": "Ornate Iron Frame Square",
          "pl": "Ornate Iron Frame Square",
          "ru": "Изящная железная квадратная рамка",
          "uk": "Квадратна оздоблена залізна рамка",
          "ko": "장식된 철테 사각 액자",
          "zh": "Ornate Iron Frame Square",
          "ja": "Ornate Iron Frame Square"
        },
        {
          "id": "OrnateIronFrameTallItem",
          "en": "Ornate Iron Frame Tall",
          "fr": "Cadre grand portrait orné en fer",
          "es": "Ornate Iron Frame Tall",
          "de": "Kunstvoller Eisenrahmen: Hoch",
          "pt": "Ornate Iron Frame Tall",
          "it": "Cornice alta ornata in ferro",
          "tr": "Ornate Iron Frame Tall",
          "pl": "Ornate Iron Frame Tall",
          "ru": "Изящная железная высокая рамка",
          "uk": "Висока оздоблена залізна рамка",
          "ko": "장식된 철테 기다란 액자",
          "zh": "Ornate Iron Frame Tall",
          "ja": "Ornate Iron Frame Tall"
        },
        {
          "id": "OrnateIronFrameWideItem",
          "en": "Ornate Iron Frame Wide",
          "fr": "Cadre grand paysage orné en fer",
          "es": "Ornate Iron Frame Wide",
          "de": "Kunstvoller Eisenrahmen: Breit",
          "pt": "Ornate Iron Frame Wide",
          "it": "Cornice ampia ornata in ferro",
          "tr": "Ornate Iron Frame Wide",
          "pl": "Ornate Iron Frame Wide",
          "ru": "Изящная железная широкая рамка",
          "uk": "Широка оздоблена залізна рамка",
          "ko": "장식된 철테 넓은 액자",
          "zh": "Ornate Iron Frame Wide",
          "ja": "Ornate Iron Frame Wide"
        },
        {
          "id": "OrnateWoodenFrameLandscapeItem",
          "en": "Ornate Wooden Frame Landscape",
          "fr": "Cadre paysage orné en bois",
          "es": "Ornate Wooden Frame Landscape",
          "de": "Kunstvoller Holzrahmen: Querformat",
          "pt": "Ornate Wooden Frame Landscape",
          "it": "Cornice orizzontale ornata in legno",
          "tr": "Ornate Wooden Frame Landscape",
          "pl": "Ornate Wooden Frame Landscape",
          "ru": "Изящная деревянная панорамная рамка",
          "uk": "Ornate Wooden Frame Landscape",
          "ko": "장식된 원목 풍경화 액자",
          "zh": "华丽木框风景画",
          "ja": "Ornate Wooden Frame Landscape"
        },
        {
          "id": "OrnateWoodenFramePortraitItem",
          "en": "Ornate Wooden Frame Portrait",
          "fr": "Cadre portrait orné en bois",
          "es": "Ornate Wooden Frame Portrait",
          "de": "Kunstvoller Holzrahmen: Hochformat",
          "pt": "Ornate Wooden Frame Portrait",
          "it": "Cornice verticale ornata in legno",
          "tr": "Ornate Wooden Frame Portrait",
          "pl": "Ornate Wooden Frame Portrait",
          "ru": "Изящная деревянная портретная рамка",
          "uk": "Ornate Wooden Frame Portrait",
          "ko": "장식된 원목 초상화 액자",
          "zh": "华丽木框肖像画",
          "ja": "Ornate Wooden Frame Portrait"
        },
        {
          "id": "OrnateWoodenFrameSquareItem",
          "en": "Ornate Wooden Frame Square",
          "fr": "Cadre carré orné en bois",
          "es": "Marco cuadrado de madera con adornos",
          "de": "Kunstvoller Holzrahmen: Quadratisch",
          "pt": "Ornate Wooden Frame Square",
          "it": "Cornice quadrata ornata in legno",
          "tr": "Ornate Wooden Frame Square",
          "pl": "Ornate Wooden Frame Square",
          "ru": "Изящная деревянная квадртная рамка",
          "uk": "Ornate Wooden Frame Square",
          "ko": "장식된 원목 사각 액자",
          "zh": "方形华丽木框",
          "ja": "Ornate Wooden Frame Square"
        },
        {
          "id": "OrnateWoodenFrameTallItem",
          "en": "Ornate Wooden Frame Tall",
          "fr": "Cadre grand portrait orné en bois",
          "es": "Ornate Wooden Frame Tall",
          "de": "Kunstvoller Holzrahmen: Hoch",
          "pt": "Ornate Wooden Frame Tall",
          "it": "Cornice alta ornata in legno",
          "tr": "Ornate Wooden Frame Tall",
          "pl": "Ornate Wooden Frame Tall",
          "ru": "Изящная деревянная высокая рамка",
          "uk": "Ornate Wooden Frame Tall",
          "ko": "장식된 원목 기다란 액자",
          "zh": "竖向华丽木框",
          "ja": "Ornate Wooden Frame Tall"
        },
        {
          "id": "OrnateWoodenFrameWideItem",
          "en": "Ornate Wooden Frame Wide",
          "fr": "Cadre grand paysage orné en bois",
          "es": "Ornate Wooden Frame Wide",
          "de": "Kunstvoller Holzrahmen: Breit",
          "pt": "Ornate Wooden Frame Wide",
          "it": "Cornice ampia ornata in legno",
          "tr": "Ornate Wooden Frame Wide",
          "pl": "Ornate Wooden Frame Wide",
          "ru": "Изящная деревянная широкая рамка",
          "uk": "Ornate Wooden Frame Wide",
          "ko": "장식된 원목 넓은 액자",
          "zh": "横向华丽木框",
          "ja": "Ornate Wooden Frame Wide"
        },
        {
          "id": "PaperStreamersItem",
          "en": "Paper Streamers",
          "fr": "Serpentin en papier",
          "es": "Paper Streamers",
          "de": "Luftschlangen",
          "pt": "Paper Streamers",
          "it": "Stelle filanti di carta",
          "tr": "Paper Streamers",
          "pl": "Papierowe Serpentyny",
          "ru": "Бумажные ленты",
          "uk": "Paper Streamers",
          "ko": "Paper Streamers",
          "zh": "Paper Streamers",
          "ja": "Paper Streamers"
        },
        {
          "id": "PlasticBuoyItem",
          "en": "Plastic Buoy",
          "fr": "Balise en plastique",
          "es": "Boya de plástico",
          "de": "Boje aus Plastik",
          "pt": "Plastic Buoy",
          "it": "Boa di plastica",
          "tr": "Plastic Buoy",
          "pl": "Plastic Buoy",
          "ru": "Пластиковый буй",
          "uk": "Пластиковий буй",
          "ko": "플라스틱 부표",
          "zh": "Plastic Buoy",
          "ja": "Plastic Buoy"
        },
        {
          "id": "SmallCottonBuntingFestiveItem",
          "en": "Small Cotton Bunting Festive",
          "fr": "Petite guirlande festive en coton",
          "es": "Banderín festivo pequeño de algodón",
          "de": "Kleine festliche Baumwoll-Wimpelkette",
          "pt": "Small Cotton Bunting Festive",
          "it": "Bandierina da festa in cotone piccola",
          "tr": "Small Cotton Bunting Festive",
          "pl": "Mała świąteczna girlanda z bawełny",
          "ru": "Маленький хлопковый праздничный флаг",
          "uk": "Small Cotton Bunting Festive",
          "ko": "소형 축제용 면직물 깃발",
          "zh": "Small Cotton Bunting Festive",
          "ja": "Small Cotton Bunting Festive"
        },
        {
          "id": "SmallCottonBuntingRedItem",
          "en": "Small Cotton Bunting Red",
          "fr": "Petite guirlande rouge en coton",
          "es": "Banderín rojo pequeño de algodón",
          "de": "Kleine rote Baumwoll-Wimpelkette",
          "pt": "Small Cotton Bunting Red",
          "it": "Bandierina rossa in cotone piccola",
          "tr": "Small Cotton Bunting Red",
          "pl": "Mała czerwona girlanda z bawełny",
          "ru": "Маленький хлопковый красный флаг",
          "uk": "Small Cotton Bunting Red",
          "ko": "소형 빨간색 면직물 깃발",
          "zh": "Small Cotton Bunting Red",
          "ja": "Small Cotton Bunting Red"
        },
        {
          "id": "SmallCottonBuntingRegalItem",
          "en": "Small Cotton Bunting Regal",
          "fr": "Petite guirlande royale en coton",
          "es": "Banderín de realeza pequeño de algodón",
          "de": "Kleine majestätische Baumwoll-Wimpelkette",
          "pt": "Small Cotton Bunting Regal",
          "it": "Bandierina regale in cotone piccola",
          "tr": "Small Cotton Bunting Regal",
          "pl": "Mała królewska girlanda z bawełny",
          "ru": "Маленький хлопковый королевский флаг",
          "uk": "Small Cotton Bunting Regal",
          "ko": "소형 국왕의 면직물 깃발",
          "zh": "Small Cotton Bunting Regal",
          "ja": "Small Cotton Bunting Regal"
        },
        {
          "id": "SmallCottonBuntingVibrantItem",
          "en": "Small Cotton Bunting Vibrant",
          "fr": "Petite guirlande éclatante en coton",
          "es": "Banderín colorido pequeño de algodón",
          "de": "Kleine lebendige Baumwoll-Wimpelkette",
          "pt": "Small Cotton Bunting Vibrant",
          "it": "Bandierina vivace in cotone piccola",
          "tr": "Small Cotton Bunting Vibrant",
          "pl": "Mała jasna girlanda z bawełny",
          "ru": "Маленький хлопковый яркий флаг",
          "uk": "Small Cotton Bunting Vibrant",
          "ko": "소형 활기찬 면직물 깃발",
          "zh": "Small Cotton Bunting Vibrant",
          "ja": "Small Cotton Bunting Vibrant"
        },
        {
          "id": "SmallFestivePaperLanternItem",
          "en": "Small Festive Paper Lantern",
          "fr": "Petite lanterne festive en papier",
          "es": "Small Festive Paper Lantern",
          "de": "Kleine festliche Papierlaterne",
          "pt": "Small Festive Paper Lantern",
          "it": "Piccola lanterna di carta festiva",
          "tr": "Small Festive Paper Lantern",
          "pl": "Mały świąteczny lampion z papieru",
          "ru": "Маленький праздничный бумажный фонарь",
          "uk": "Small Festive Paper Lantern",
          "ko": "Small Festive Paper Lantern",
          "zh": "Small Festive Paper Lantern",
          "ja": "Small Festive Paper Lantern"
        },
        {
          "id": "SmallNylonBuntingGreenItem",
          "en": "Small Nylon Bunting Green",
          "fr": "Petite guirlande verte en nylon",
          "es": "Small Nylon Bunting Green",
          "de": "Kleine grüne Nylon-Wimpelkette",
          "pt": "Small Nylon Bunting Green",
          "it": "Piccola bandierina verde in nylon",
          "tr": "Small Nylon Bunting Green",
          "pl": "Mała nylonowa girlanda w kolorze zielonym",
          "ru": "Маленький нейлоновый зеленый флаг",
          "uk": "Small Nylon Bunting Green",
          "ko": "소형 연두색 나일론 깃발",
          "zh": "Small Nylon Bunting Green",
          "ja": "Small Nylon Bunting Green"
        },
        {
          "id": "SmallNylonBuntingPurpleItem",
          "en": "Small Nylon Bunting Purple",
          "fr": "Petite guirlande violette en nylon",
          "es": "Small Nylon Bunting Purple",
          "de": "Kleine lilafarbene Nylon-Wimpelkette",
          "pt": "Small Nylon Bunting Purple",
          "it": "Piccola bandierina viola in nylon",
          "tr": "Small Nylon Bunting Purple",
          "pl": "Mała nylonowa girlanda w kolorze fioletowym",
          "ru": "Маленький нейлоновый фиолетовый флаг",
          "uk": "Small Nylon Bunting Purple",
          "ko": "소형 보라색 나일론 깃발",
          "zh": "Small Nylon Bunting Purple",
          "ja": "Small Nylon Bunting Purple"
        },
        {
          "id": "SmallNylonBuntingYellowItem",
          "en": "Small Nylon Bunting Yellow",
          "fr": "Petite guirlande jaune en nylon",
          "es": "Small Nylon Bunting Yellow",
          "de": "Kleine gelbe Nylon-Wimpelkette",
          "pt": "Small Nylon Bunting Yellow",
          "it": "Piccola bandierina gialla in nylon",
          "tr": "Small Nylon Bunting Yellow",
          "pl": "Mała nylonowa girlanda w kolorze żółtym",
          "ru": "Маленький нейлоновый жёлтый флаг",
          "uk": "Small Nylon Bunting Yellow",
          "ko": "소형 노란색 나일론 깃발",
          "zh": "Small Nylon Bunting Yellow",
          "ja": "Small Nylon Bunting Yellow"
        },
        {
          "id": "SmallPaperLanternItem",
          "en": "Small Paper Lantern",
          "fr": "Petite lanterne en papier",
          "es": "Small Paper Lantern",
          "de": "Kleine Papierlaterne",
          "pt": "Small Paper Lantern",
          "it": "Piccola lanterna di carta",
          "tr": "Small Paper Lantern",
          "pl": "Mały lampion z papieru",
          "ru": "Маленький бумажный фонарь",
          "uk": "Малий паперовий ліхтар",
          "ko": "소형 종이 제등",
          "zh": "Small Paper Lantern",
          "ja": "Small Paper Lantern"
        },
        {
          "id": "SmallPaperMachineItem",
          "en": "Small Paper Machine",
          "fr": "Petite machine à papier",
          "es": "Small Paper Machine",
          "de": "Kleine Papiermaschine",
          "pt": "Small Paper Machine",
          "it": "Piccola macchina per la carta",
          "tr": "Small Paper Machine",
          "pl": "Mała maszyna do papieru",
          "ru": "Маленькая бумагоделательная машина",
          "uk": "Small Paper Machine",
          "ko": "소형 제지 기계",
          "zh": "Small Paper Machine",
          "ja": "Small Paper Machine"
        },
        {
          "id": "SmallShipyardItem",
          "en": "Small Shipyard",
          "fr": "Petit chantier naval",
          "es": "Astillero pequeño",
          "de": "Kleine Werft",
          "pt": "Small Shipyard",
          "it": "Piccolo cantiere",
          "tr": "Small Shipyard",
          "pl": "Mała stocznia",
          "ru": "Маленькая верфь",
          "uk": "Мала корабельня",
          "ko": "소형 조선소",
          "zh": "小型船坞",
          "ja": "Small Shipyard"
        },
        {
          "id": "SteelBuoyItem",
          "en": "Steel Buoy",
          "fr": "Balise en acier",
          "es": "Boya de acero",
          "de": "Stahlboje",
          "pt": "Steel Buoy",
          "it": "Boa d\u0027acciaio",
          "tr": "Steel Buoy",
          "pl": "Stalowa boja",
          "ru": "Стальной буй",
          "uk": "Сталевий буй",
          "ko": "강철 부표",
          "zh": "Steel Buoy",
          "ja": "Steel Buoy"
        },
        {
          "id": "SteelLiquidsTankItem",
          "en": "Steel Liquids Tank",
          "fr": "Réservoir de liquides en acier",
          "es": "Steel Liquids Tank",
          "de": "Stahl-Flüssigkeitstank",
          "pt": "Steel Liquids Tank",
          "it": "Serbatoio dei liquidi in acciaio",
          "tr": "Steel Liquids Tank",
          "pl": "Steel Liquids Tank",
          "ru": "Стальной резервуар",
          "uk": "Steel Liquids Tank",
          "ko": "Steel Liquids Tank",
          "zh": "Steel Liquids Tank",
          "ja": "Steel Liquids Tank"
        },
        {
          "id": "SteelWarehouseShelvesItem",
          "en": "Steel Warehouse Shelves",
          "fr": "Rayonnages d\u0027entrepôt en acier",
          "es": "Steel Warehouse Shelves",
          "de": "Stahl-Lagerhausregale",
          "pt": "Steel Warehouse Shelves",
          "it": "Scaffali d\u0027acciaio del magazzino",
          "tr": "Steel Warehouse Shelves",
          "pl": "Steel Warehouse Shelves",
          "ru": "Стальной складской стеллаж",
          "uk": "Steel Warehouse Shelves",
          "ko": "Steel Warehouse Shelves",
          "zh": "Steel Warehouse Shelves",
          "ja": "Steel Warehouse Shelves"
        },
        {
          "id": "WoodenFrameLandscapeItem",
          "en": "Wooden Frame Landscape",
          "fr": "Cadre paysage en bois",
          "es": "Wooden Frame Landscape",
          "de": "Holzrahmen: Querformat",
          "pt": "Wooden Frame Landscape",
          "it": "Cornice orizzontale in legno",
          "tr": "Wooden Frame Landscape",
          "pl": "Wooden Frame Landscape",
          "ru": "Альбомная деревянная рамка",
          "uk": "Краєвид у дерев\u0027яній рамці",
          "ko": "원목 풍경화 액자",
          "zh": "木框风景画",
          "ja": "Wooden Frame Landscape"
        },
        {
          "id": "WoodenFramePortraitItem",
          "en": "Wooden Frame Portrait",
          "fr": "Cadre portrait en bois",
          "es": "Wooden Frame Portrait",
          "de": "Holzrahmen: Hochformat",
          "pt": "Wooden Frame Portrait",
          "it": "Cornice verticale in legno",
          "tr": "Wooden Frame Portrait",
          "pl": "Wooden Frame Portrait",
          "ru": "Книжная деревянная рамка",
          "uk": "Портрет у дерев\u0027яній рамці",
          "ko": "원목 초상화 액자",
          "zh": "木框肖像画",
          "ja": "Wooden Frame Portrait"
        },
        {
          "id": "WoodenFrameSquareItem",
          "en": "Wooden Frame Square",
          "fr": "Cadre carré en bois",
          "es": "Marco cuadrado de madera",
          "de": "Holzrahmen: Quadratisch",
          "pt": "Wooden Frame Square",
          "it": "Cornice quadrata in legno",
          "tr": "Wooden Frame Square",
          "pl": "Wooden Frame Square",
          "ru": "Квадратная деревянная рамка",
          "uk": "Квадратна дерев\u0027яна рамка",
          "ko": "원목 사각 액자",
          "zh": "方形华丽木框",
          "ja": "Wooden Frame Square"
        },
        {
          "id": "WoodenFrameTallItem",
          "en": "Wooden Frame Tall",
          "fr": "Cadre grand portrait en bois",
          "es": "Wooden Frame Tall",
          "de": "Holzrahmen: Hoch",
          "pt": "Wooden Frame Tall",
          "it": "Cornice alta in legno",
          "tr": "Wooden Frame Tall",
          "pl": "Wooden Frame Tall",
          "ru": "Вытянутая деревянная рамка",
          "uk": "Висока дерев\u0027яна рамка",
          "ko": "원목 기다란 액자",
          "zh": "竖向木框",
          "ja": "Wooden Frame Tall"
        },
        {
          "id": "WoodenFrameWideItem",
          "en": "Wooden Frame Wide",
          "fr": "Cadre grand paysage en bois",
          "es": "Wooden Frame Wide",
          "de": "Holzrahmen: Breit",
          "pt": "Wooden Frame Wide",
          "it": "Cornice ampia in legno",
          "tr": "Wooden Frame Wide",
          "pl": "Wooden Frame Wide",
          "ru": "Широкая деревянная рамка",
          "uk": "Широка дерев\u0027яна рамка",
          "ko": "원목 넓은 액자",
          "zh": "横向木框",
          "ja": "Wooden Frame Wide"
        },
        {
          "id": "WoodenLiquidsTankItem",
          "en": "Wooden Liquids Tank",
          "fr": "Réservoir de liquides en bois",
          "es": "Wooden Liquids Tank",
          "de": "Holz-Flüssigkeitstank",
          "pt": "Wooden Liquids Tank",
          "it": "Serbatoio dei liquidi in legno",
          "tr": "Wooden Liquids Tank",
          "pl": "Wooden Liquids Tank",
          "ru": "Деревянный резервуар",
          "uk": "Дерев\u0027яний резервуар",
          "ko": "Wooden Liquids Tank",
          "zh": "木制液罐",
          "ja": "Wooden Liquids Tank"
        },
        {
          "id": "CameraFilmItem",
          "en": "Camera Film",
          "fr": "Pellicule",
          "es": "Camera Film",
          "de": "Kamera-Film",
          "pt": "Camera Film",
          "it": "Rullino della videocamera",
          "tr": "Camera Film",
          "pl": "Klisza do aparatu",
          "ru": "Пленка камеры",
          "uk": "Camera Film",
          "ko": "카메라 필름",
          "zh": "Camera Film",
          "ja": "Camera Film"
        },
        {
          "id": "CreosoteFlowerItem",
          "en": "Creosote Flower",
          "fr": "Fleur de créosotier",
          "es": "Creosote Flower",
          "de": "Creosote Flower",
          "pt": "Creosote Flower",
          "it": "Fiore di creosoto",
          "tr": "Creosote Flower",
          "pl": "Creosote Flower",
          "ru": "Цветок ларреи",
          "uk": "Creosote Flower",
          "ko": "크레오소트 꽃",
          "zh": "Creosote Flower",
          "ja": "Creosote Flower"
        },
        {
          "id": "FlaxseedOilItem",
          "en": "Flaxseed Oil",
          "fr": "Huile de lin",
          "es": "Flaxseed Oil",
          "de": "Flaxseed Oil",
          "pt": "Flaxseed Oil",
          "it": "Olio di semi di lino",
          "tr": "Flaxseed Oil",
          "pl": "Olej z siemienia lnianego",
          "ru": "Льняное масло",
          "uk": "Flaxseed Oil",
          "ko": "아마씨유",
          "zh": "亚麻籽油",
          "ja": "フラックスオイル"
        },
        {
          "id": "TrilliumFlowerItem",
          "en": "Trillium Flower",
          "fr": "Fleur de trillium",
          "es": "Trillium Flower",
          "de": "Trillium Blume",
          "pt": "Trillium Flower",
          "it": "Fiore di Trillium",
          "tr": "Trillium Flower",
          "pl": "Trillium Flower",
          "ru": "Цветок Триллиума",
          "uk": "Trillium Flower",
          "ko": "연령초 꽃",
          "zh": "Trillium Flower",
          "ja": "Trillium Flower"
        },
        {
          "id": "ArtSuppliesItem",
          "en": "Art Supplies",
          "fr": "Nécessaire d\u0027art",
          "es": "Art Supplies",
          "de": "Art Supplies",
          "pt": "Art Supplies",
          "it": "Materiali Artistici",
          "tr": "Art Supplies",
          "pl": "Przybory do sztuki",
          "ru": "Набор художника",
          "uk": "Art Supplies",
          "ko": "미술 용품",
          "zh": "美术用具",
          "ja": "Art Supplies"
        },
        {
          "id": "ColoredPowderItem",
          "en": "Colored Powder",
          "fr": "Poudre colorée",
          "es": "Polvo coloreado",
          "de": "Farbiges Puder",
          "pt": "Colored Powder",
          "it": "Polvere colorata",
          "tr": "Colored Powder",
          "pl": "Colored Powder",
          "ru": "Цветной порошок",
          "uk": "Colored Powder",
          "ko": "가루 안료",
          "zh": "彩色粉末",
          "ja": "Colored Powder"
        },
        {
          "id": "NylonTrawlerNetItem",
          "en": "Nylon Trawler Net",
          "fr": "Filet de chalutier en nylon",
          "es": "Nylon Trawler Net",
          "de": "Nylon Trawler Net",
          "pt": "Nylon Trawler Net",
          "it": "Rete da peschereccio in nylon",
          "tr": "Nylon Trawler Net",
          "pl": "Nylonowa sieć rybacka",
          "ru": "Нейлоновая сеть Траулера",
          "uk": "Nylon Trawler Net",
          "ko": "나일론 저인망",
          "zh": "Nylon Trawler Net",
          "ja": "Nylon Trawler Net"
        },
        {
          "id": "OilPaintItem",
          "en": "Oil Paint",
          "fr": "Peinture à l\u0027huile",
          "es": "Oil Paint",
          "de": "Ölfarbe",
          "pt": "Oil Paint",
          "it": "Dipinto a olio",
          "tr": "Oil Paint",
          "pl": "Farba olejna",
          "ru": "Масляная краска",
          "uk": "Oil Paint",
          "ko": "유성 페인트",
          "zh": "油画颜料",
          "ja": "Oil Paint"
        },
        {
          "id": "GatheringBasicUpgradeItem",
          "en": "Gathering Basic Upgrade",
          "fr": "Amélioration basique : Récolte",
          "es": "Gathering Basic Upgrade",
          "de": "Gathering Basic Upgrade",
          "pt": "Gathering Basic Upgrade",
          "it": "Aggiornamento Base Raccolta",
          "tr": "Gathering Basic Upgrade",
          "pl": "Gathering Basic Upgrade",
          "ru": "Базовое улучшение для собирательства",
          "uk": "Gathering Basic Upgrade",
          "ko": "기초 채집 업그레이드",
          "zh": "采集基础升级",
          "ja": "Gathering Basic Upgrade"
        },
        {
          "id": "IndustrialGeneratorItem",
          "en": "Industrial Generator",
          "fr": "Générateur électrique industriel",
          "es": "Generador industrial",
          "de": "Industrial Generator",
          "pt": "Industrial Generator",
          "it": "Generatore industriale",
          "tr": "Industrial Generator",
          "pl": "Industrial Generator",
          "ru": "Промышленный генератор",
          "uk": "Industrial Generator",
          "ko": "공업용 발전기",
          "zh": "Industrial Generator",
          "ja": "Industrial Generator"
        },
        {
          "id": "Petals",
          "en": "Petals",
          "fr": "Pétales",
          "es": "Petalos",
          "de": "Blätter",
          "pt": "Petals",
          "it": "Petali",
          "tr": "Petals",
          "pl": "Petals",
          "ru": "Лепестки",
          "uk": "Petals",
          "ko": "꽃잎",
          "zh": "Petals",
          "ja": "Petals"
        },
        {
          "id": "WetBrickItem",
          "en": "Wet Brick",
          "fr": "Brique humide",
          "es": "Wet Brick",
          "de": "Nasser Ziegel",
          "pt": "Wet Brick",
          "it": "Mattone umido",
          "tr": "Wet Brick",
          "pl": "Mokra cegła",
          "ru": "Сырой кирпич",
          "uk": "Wet Brick",
          "ko": "축축한 벽돌",
          "zh": "Wet Brick",
          "ja": "Wet Brick"
        },
        {
          "id": "WoodenMoldItem",
          "en": "Wooden Mold",
          "fr": "Moule en bois",
          "es": "Wooden Mold",
          "de": "Holzform",
          "pt": "Wooden Mold",
          "it": "Stampo in legno",
          "tr": "Wooden Mold",
          "pl": "Drewniana forma",
          "ru": "Деревянная форма",
          "uk": "Wooden Mold",
          "ko": "목제 틀",
          "zh": "木制模具",
          "ja": "Wooden Mold"
        },
        {
          "id": "BycocketItem",
          "en": "Bycocket",
          "fr": "Chapeau à bec",
          "es": "Bycocket",
          "de": "Schnabelhut",
          "pt": "Bycocket",
          "it": "Borsetta",
          "tr": "Bycocket",
          "pl": "Bycocket",
          "ru": "Байкет",
          "uk": "Bycocket",
          "ko": "바이코켓",
          "zh": "Bycocket",
          "ja": "Bycocket"
        },
        {
          "id": "MuffinHatItem",
          "en": "Muffin Hat",
          "fr": "Chapeau muffin",
          "es": "Muffin Hat",
          "de": "Muffin Hut",
          "pt": "Muffin Hat",
          "it": "Cappello medievale",
          "tr": "Muffin Hat",
          "pl": "Muffin Hat",
          "ru": "Старомодный берет",
          "uk": "Muffin Hat",
          "ko": "머핀 모자",
          "zh": "松饼帽",
          "ja": "Muffin Hat"
        },
        {
          "id": "PrimitiveCanvasBootsItem",
          "en": "Primitive Canvas Boots",
          "fr": "Bottes primitives en toile",
          "es": "Primitive Canvas Boots",
          "de": "Einfache Leinenstiefel",
          "pt": "Primitive Canvas Boots",
          "it": "Stivali in tela rudimentali",
          "tr": "Primitive Canvas Boots",
          "pl": "Primitive Canvas Boots",
          "ru": "Простые Лапти",
          "uk": "Primitive Canvas Boots",
          "ko": "Primitive Canvas Boots",
          "zh": "原始帆布靴",
          "ja": "Primitive Canvas Boots"
        },
        {
          "id": "PrimitiveCanvasPantsItem",
          "en": "Primitive Canvas Pants",
          "fr": "Pantalon primitif en toile",
          "es": "Primitive Canvas Pants",
          "de": "Einfache Leinenhose",
          "pt": "Primitive Canvas Pants",
          "it": "Pantaloni in tela rudimentali",
          "tr": "Primitive Canvas Pants",
          "pl": "Primitive Canvas Pants",
          "ru": "Штаны из мешковины",
          "uk": "Primitive Canvas Pants",
          "ko": "Primitive Canvas Pants",
          "zh": "原始帆布长裤",
          "ja": "Primitive Canvas Pants"
        },
        {
          "id": "PrimitiveCanvasShortsItem",
          "en": "Primitive Canvas Shorts",
          "fr": "Short primitif en toile",
          "es": "Primitive Canvas Shorts",
          "de": "Einfache Leinenshorts",
          "pt": "Primitive Canvas Shorts",
          "it": "Pantaloncini in tela rudimentali",
          "tr": "Primitive Canvas Shorts",
          "pl": "Primitive Canvas Shorts",
          "ru": "Primitive Canvas Shorts",
          "uk": "Primitive Canvas Shorts",
          "ko": "Primitive Canvas Shorts",
          "zh": "原始帆布短裤",
          "ja": "Primitive Canvas Shorts"
        },
        {
          "id": "PrimitiveFurBeltItem",
          "en": "Primitive Fur Belt",
          "fr": "Ceinture primitive en fourrure",
          "es": "Primitive Fur Belt",
          "de": "Einfacher Fellgürtel",
          "pt": "Primitive Fur Belt",
          "it": "Cintura rudimentale in pelliccia",
          "tr": "Primitive Fur Belt",
          "pl": "Primitive Fur Belt",
          "ru": "Примитивный шерстяной пояс",
          "uk": "Primitive Fur Belt",
          "ko": "Primitive Fur Belt",
          "zh": "原始毛皮腰带",
          "ja": "Primitive Fur Belt"
        },
        {
          "id": "PrimitiveLeatherBootsItem",
          "en": "Primitive Leather Boots",
          "fr": "Bottes primitives en cuir",
          "es": "Primitive Leather Boots",
          "de": "Einfache Lederstiefel",
          "pt": "Primitive Leather Boots",
          "it": "Stivali rudimentali in pelle",
          "tr": "Primitive Leather Boots",
          "pl": "Primitive Leather Boots",
          "ru": "Примитивные кожаные сапоги",
          "uk": "Primitive Leather Boots",
          "ko": "Primitive Leather Boots",
          "zh": "原始皮革靴",
          "ja": "Primitive Leather Boots"
        },
        {
          "id": "PrimitiveLeatherPantsItem",
          "en": "Primitive Leather Pants",
          "fr": "Pantalon primitif en cuir",
          "es": "Primitive Leather Pants",
          "de": "Einfache Lederhose",
          "pt": "Primitive Leather Pants",
          "it": "Pantaloni rudimentali in pelle",
          "tr": "Primitive Leather Pants",
          "pl": "Primitive Leather Pants",
          "ru": "Простые кожаные штаны",
          "uk": "Primitive Leather Pants",
          "ko": "Primitive Leather Pants",
          "zh": "原始皮革长裤",
          "ja": "Primitive Leather Pants"
        },
        {
          "id": "PrimitiveLeatherShirtItem",
          "en": "Primitive Leather Shirt",
          "fr": "Chemise primitive en cuir",
          "es": "Primitive Leather Shirt",
          "de": "Einfaches Lederhemd",
          "pt": "Primitive Leather Shirt",
          "it": "Camicia rudimentale in pelle",
          "tr": "Primitive Leather Shirt",
          "pl": "Primitive Leather Shirt",
          "ru": "Primitive Leather Shirt",
          "uk": "Primitive Leather Shirt",
          "ko": "Primitive Leather Shirt",
          "zh": "原始皮革衬衫",
          "ja": "Primitive Leather Shirt"
        },
        {
          "id": "PrimitiveLeatherShortsItem",
          "en": "Primitive Leather Shorts",
          "fr": "Short primitif en cuir",
          "es": "Primitive Leather Shorts",
          "de": "Einfache Ledershorts",
          "pt": "Primitive Leather Shorts",
          "it": "Pantaloncini rudimentali in pelle",
          "tr": "Primitive Leather Shorts",
          "pl": "Primitive Leather Shorts",
          "ru": "Primitive Leather Shorts",
          "uk": "Primitive Leather Shorts",
          "ko": "Primitive Leather Shorts",
          "zh": "原始皮革短裤",
          "ja": "Primitive Leather Shorts"
        },
        {
          "id": "ShipwrightOverallsItem",
          "en": "Shipwright Overalls",
          "fr": "Ensemble de charpentier naval : Salopette",
          "es": "Shipwright Overalls",
          "de": "Shipwright Overalls",
          "pt": "Shipwright Overalls",
          "it": "Tuta da Carpentiere Navale",
          "tr": "Shipwright Overalls",
          "pl": "Shipwright Overalls",
          "ru": "Комбинезон кораблестроителя",
          "uk": "Shipwright Overalls",
          "ko": "조선공의 작업복",
          "zh": "造船工工作服",
          "ja": "Shipwright Overalls"
        },
        {
          "id": "TrapperFurHatItem",
          "en": "Trapper Fur Hat",
          "fr": "Chapeau de trappeur en fourrure",
          "es": "Trapper Fur Hat",
          "de": "Trapper Fur Hat",
          "pt": "Trapper Fur Hat",
          "it": "Colbacco dell\u0027esperto di trappole",
          "tr": "Trapper Fur Hat",
          "pl": "Trapper Fur Hat",
          "ru": "Меховая шапка Зверолова",
          "uk": "Trapper Fur Hat",
          "ko": "Trapper Fur Hat",
          "zh": "Trapper Fur Hat",
          "ja": "Trapper Fur Hat"
        },
        {
          "id": "TrapperLeatherHatItem",
          "en": "Trapper Leather Hat",
          "fr": "Chapeau de trappeur en cuir",
          "es": "Trapper Leather Hat",
          "de": "Trapper Leather Hat",
          "pt": "Trapper Leather Hat",
          "it": "Cappello di pelle dell\u0027esperto di trappole",
          "tr": "Trapper Leather Hat",
          "pl": "Trapper Leather Hat",
          "ru": "Кожаная шапка Зверолова",
          "uk": "Trapper Leather Hat",
          "ko": "Trapper Leather Hat",
          "zh": "Trapper Leather Hat",
          "ja": "Trapper Leather Hat"
        },
        {
          "id": "TunicItem",
          "en": "Tunic",
          "fr": "Tunique",
          "es": "Túnica",
          "de": "Tunika",
          "pt": "Tunic",
          "it": "Tunica",
          "tr": "Tunic",
          "pl": "Tunic",
          "ru": "Туника",
          "uk": "Tunic",
          "ko": "Tunic",
          "zh": "Tunic",
          "ja": "Tunic"
        },
        {
          "id": "VillagersCowlLoweredItem",
          "en": "Villagers Cowl Lowered",
          "fr": "Capuchon abaissé de villageois",
          "es": "Villagers Cowl Lowered",
          "de": "Villagers Cowl Lowered",
          "pt": "Villagers Cowl Lowered",
          "it": "Cappuccio abitanti abbassato",
          "tr": "Villagers Cowl Lowered",
          "pl": "Villagers Cowl Lowered",
          "ru": "Льняной капюшон поселенца",
          "uk": "Villagers Cowl Lowered",
          "ko": "Villagers Cowl Lowered",
          "zh": "Villagers Cowl Lowered",
          "ja": "Villagers Cowl Lowered"
        },
        {
          "id": "VillagersCowlRaisedItem",
          "en": "Villagers Cowl Raised",
          "fr": "Capuchon relevé de villageois",
          "es": "Villagers Cowl Raised",
          "de": "Villagers Cowl Raised",
          "pt": "Villagers Cowl Raised",
          "it": "Cappuccio abitanti alzato",
          "tr": "Villagers Cowl Raised",
          "pl": "Villagers Cowl Raised",
          "ru": "Поднятый льняной капюшон поселенца",
          "uk": "Villagers Cowl Raised",
          "ko": "Villagers Cowl Raised",
          "zh": "Villagers Cowl Raised",
          "ja": "Villagers Cowl Raised"
        },
        {
          "id": "WanderersHoodLoweredItem",
          "en": "Wanderers Hood Lowered",
          "fr": "Capuche abaissée de vagabond",
          "es": "Wanderers Hood Lowered",
          "de": "Wanderers Hood Lowered",
          "pt": "Wanderers Hood Lowered",
          "it": "Cappuccio dei vagabondi abbassato",
          "tr": "Wanderers Hood Lowered",
          "pl": "Wanderers Hood Lowered",
          "ru": "Wanderers Hood Lowered",
          "uk": "Wanderers Hood Lowered",
          "ko": "Wanderers Hood Lowered",
          "zh": "Wanderers Hood Lowered",
          "ja": "Wanderers Hood Lowered"
        },
        {
          "id": "WanderersHoodRaisedItem",
          "en": "Wanderers Hood Raised",
          "fr": "Capuche de vagabond relevée",
          "es": "Wanderers Hood Raised",
          "de": "Wanderers Hood Raised",
          "pt": "Wanderers Hood Raised",
          "it": "Cappuccio dei vagabondi alzato",
          "tr": "Wanderers Hood Raised",
          "pl": "Wanderers Hood Raised",
          "ru": "Wanderers Hood Raised",
          "uk": "Wanderers Hood Raised",
          "ko": "Wanderers Hood Raised",
          "zh": "Wanderers Hood Raised",
          "ja": "Wanderers Hood Raised"
        },
        {
          "id": "DriedFishItem",
          "en": "Dried Fish",
          "fr": "Poisson séché",
          "es": "Pescado seco",
          "de": "Getrockneter Fisch",
          "pt": "Dried Fish",
          "it": "Pesce essiccato",
          "tr": "Dried Fish",
          "pl": "Dried Fish",
          "ru": "Сушеная рыба",
          "uk": "Dried Fish",
          "ko": "Dried Fish",
          "zh": "鱼干",
          "ja": "Dried Fish"
        },
        {
          "id": "DriedMeatItem",
          "en": "Dried Meat",
          "fr": "Viande séchée",
          "es": "Carne seca",
          "de": "Getrocknetes Fleisch",
          "pt": "Dried Meat",
          "it": "Carne essiccata",
          "tr": "Dried Meat",
          "pl": "Dried Meat",
          "ru": "Вяленое мясо",
          "uk": "Dried Meat",
          "ko": "Dried Meat",
          "zh": "肉干",
          "ja": "Dried Meat"
        },
        {
          "id": "SweetDeerJerkyItem",
          "en": "Sweet Deer Jerky",
          "fr": "Viande séchée de cerf",
          "es": "Sweet Deer Jerky",
          "de": "Süßes Reh-Jerky",
          "pt": "Sweet Deer Jerky",
          "it": "Carne di cervo essiccata dolce",
          "tr": "Sweet Deer Jerky",
          "pl": "Sweet Deer Jerky",
          "ru": "Сладкая вяленая оленина",
          "uk": "Sweet Deer Jerky",
          "ko": "Sweet Deer Jerky",
          "zh": "Sweet Deer Jerky",
          "ja": "Sweet Deer Jerky"
        },
        {
          "id": "HuntingUpgradeItem",
          "en": "Hunting Upgrade",
          "fr": "Amélioration basique : Chasse",
          "es": "Hunting Upgrade",
          "de": "Hunting Upgrade",
          "pt": "Hunting Upgrade",
          "it": "Aggiornamento di caccia",
          "tr": "Hunting Upgrade",
          "pl": "Hunting Upgrade",
          "ru": "Улучшение для охоты",
          "uk": "Hunting Upgrade",
          "ko": "Hunting Upgrade",
          "zh": "Hunting Upgrade",
          "ja": "Hunting Upgrade"
        },
        {
          "id": "KitchenroomItem",
          "en": "Kitchenroom",
          "fr": "Cuisine",
          "es": "Cocina",
          "de": "Küche",
          "pt": "Kitchenroom",
          "it": "Cucina",
          "tr": "Kitchenroom",
          "pl": "Kitchenroom",
          "ru": "Kitchenroom",
          "uk": "Kitchenroom",
          "ko": "Kitchenroom",
          "zh": "Kitchenroom",
          "ja": "Kitchenroom"
        },
        {
          "id": "LivingroomItem",
          "en": "Livingroom",
          "fr": "Salon",
          "es": "Sala de estar",
          "de": "Wohnzimmer",
          "pt": "Livingroom",
          "it": "Salotto",
          "tr": "Livingroom",
          "pl": "Livingroom",
          "ru": "Livingroom",
          "uk": "Livingroom",
          "ko": "Livingroom",
          "zh": "Livingroom",
          "ja": "Livingroom"
        },
        {
          "id": "SettlementCraftingTableItem",
          "en": "Settlement Crafting Table",
          "fr": "Établi de la colonie",
          "es": "Settlement Crafting Table",
          "de": "Settlement Crafting Table",
          "pt": "Settlement Crafting Table",
          "it": "Banco da lavoro dell\u0027insediamento",
          "tr": "Settlement Crafting Table",
          "pl": "Settlement Crafting Table",
          "ru": "Стол создания поселения",
          "uk": "Settlement Crafting Table",
          "ko": "Settlement Crafting Table",
          "zh": "定居点工作台",
          "ja": "Settlement Crafting Table"
        },
        {
          "id": "TownBellItem",
          "en": "Town Bell",
          "fr": "Cloche municipale",
          "es": "Town Bell",
          "de": "Town Bell",
          "pt": "Town Bell",
          "it": "Town Bell",
          "tr": "Town Bell",
          "pl": "Town Bell",
          "ru": "Городской колокол",
          "uk": "Town Bell",
          "ko": "Town Bell",
          "zh": "Town Bell",
          "ja": "Town Bell"
        },
        {
          "id": "CeramicMoldItem",
          "en": "Ceramic Mold",
          "fr": "Moule en céramique",
          "es": "Ceramic Mold",
          "de": "Ceramic Mold",
          "pt": "Ceramic Mold",
          "it": "Ceramic Mold",
          "tr": "Ceramic Mold",
          "pl": "Ceramic Mold",
          "ru": "Керамическая форма",
          "uk": "Ceramic Mold",
          "ko": "Ceramic Mold",
          "zh": "Ceramic Mold",
          "ja": "Ceramic Mold"
        },
        {
          "id": "ClayMoldItem",
          "en": "Clay Mold",
          "fr": "Moule en argile",
          "es": "Clay Mold",
          "de": "Clay Mold",
          "pt": "Clay Mold",
          "it": "Clay Mold",
          "tr": "Clay Mold",
          "pl": "Clay Mold",
          "ru": "Глиняная форма",
          "uk": "Clay Mold",
          "ko": "Clay Mold",
          "zh": "Clay Mold",
          "ja": "Clay Mold"
        },
        {
          "id": "InkItem",
          "en": "Ink",
          "fr": "Encre",
          "es": "Ink",
          "de": "Ink",
          "pt": "Ink",
          "it": "Ink",
          "tr": "Ink",
          "pl": "Ink",
          "ru": "Чернила",
          "uk": "Ink",
          "ko": "Ink",
          "zh": "Ink",
          "ja": "Ink"
        },
        {
          "id": "PaintBucketItem",
          "en": "Paint Bucket",
          "fr": "Seau à peinture",
          "es": "Paint Bucket",
          "de": "Paint Bucket",
          "pt": "Paint Bucket",
          "it": "Paint Bucket",
          "tr": "Paint Bucket",
          "pl": "Paint Bucket",
          "ru": "Paint Bucket",
          "uk": "Paint Bucket",
          "ko": "Paint Bucket",
          "zh": "Paint Bucket",
          "ja": "Paint Bucket"
        },
        {
          "id": "PrintingSuppliesItem",
          "en": "Printing Supplies",
          "fr": "Nécessaire d\u0027impression",
          "es": "Printing Supplies",
          "de": "Printing Supplies",
          "pt": "Printing Supplies",
          "it": "Printing Supplies",
          "tr": "Printing Supplies",
          "pl": "Printing Supplies",
          "ru": "Printing Supplies",
          "uk": "Printing Supplies",
          "ko": "인쇄 용품",
          "zh": "Printing Supplies",
          "ja": "Printing Supplies"
        },
        {
          "id": "BlacksmithAdvancedUpgradeItem",
          "en": "Blacksmith Advanced Upgrade",
          "fr": "Amélioration avancée : Forgeron",
          "es": "Blacksmith Advanced Upgrade",
          "de": "Blacksmith Advanced Upgrade",
          "pt": "Blacksmith Advanced Upgrade",
          "it": "Blacksmith Advanced Upgrade",
          "tr": "Blacksmith Advanced Upgrade",
          "pl": "Blacksmith Advanced Upgrade",
          "ru": "Продвинутое улучшение для ковки",
          "uk": "Blacksmith Advanced Upgrade",
          "ko": "Blacksmith Advanced Upgrade",
          "zh": "Blacksmith Advanced Upgrade",
          "ja": "Blacksmith Advanced Upgrade"
        },
        {
          "id": "BlacksmithUpgradeItem",
          "en": "Blacksmith Upgrade",
          "fr": "Amélioration basique : Forgeron",
          "es": "Blacksmith Upgrade",
          "de": "Blacksmith Upgrade",
          "pt": "Blacksmith Upgrade",
          "it": "Blacksmith Upgrade",
          "tr": "Blacksmith Upgrade",
          "pl": "Blacksmith Upgrade",
          "ru": "Улучшение для ковки",
          "uk": "Blacksmith Upgrade",
          "ko": "Blacksmith Upgrade",
          "zh": "Blacksmith Upgrade",
          "ja": "Blacksmith Upgrade"
        },
        {
          "id": "GatheringAdvancedUpgradeItem",
          "en": "Gathering Advanced Upgrade",
          "fr": "Amélioration avancée : Récolte",
          "es": "Gathering Advanced Upgrade",
          "de": "Gathering Advanced Upgrade",
          "pt": "Gathering Advanced Upgrade",
          "it": "Gathering Advanced Upgrade",
          "tr": "Gathering Advanced Upgrade",
          "pl": "Gathering Advanced Upgrade",
          "ru": "Gathering Advanced Upgrade",
          "uk": "Gathering Advanced Upgrade",
          "ko": "Gathering Advanced Upgrade",
          "zh": "Gathering Advanced Upgrade",
          "ja": "Gathering Advanced Upgrade"
        },
        {
          "id": "SmeltingBasicUpgradeItem",
          "en": "Smelting Basic Upgrade",
          "fr": "Amélioration basique : Fonte",
          "es": "Smelting Basic Upgrade",
          "de": "Smelting Basic Upgrade",
          "pt": "Smelting Basic Upgrade",
          "it": "Smelting Basic Upgrade",
          "tr": "Smelting Basic Upgrade",
          "pl": "Smelting Basic Upgrade",
          "ru": "Smelting Basic Upgrade",
          "uk": "Smelting Basic Upgrade",
          "ko": "Smelting Basic Upgrade",
          "zh": "Smelting Basic Upgrade",
          "ja": "Smelting Basic Upgrade"
        },
        {
          "id": "BlacksmithTableItem",
          "en": "Blacksmith Table",
          "fr": "Établi de forgeron",
          "es": "Blacksmith Table",
          "de": "Blacksmith Table",
          "pt": "Blacksmith Table",
          "it": "Blacksmith Table",
          "tr": "Blacksmith Table",
          "pl": "Blacksmith Table",
          "ru": "Кузнечный стол",
          "uk": "Blacksmith Table",
          "ko": "Blacksmith Table",
          "zh": "Blacksmith Table",
          "ja": "Blacksmith Table"
        },
        {
          "id": "DigitalWorkStationItem",
          "en": "Digital Work Station",
          "fr": "Poste de travail numérique",
          "es": "Digital Work Station",
          "de": "Digital Work Station",
          "pt": "Digital Work Station",
          "it": "Digital Work Station",
          "tr": "Digital Work Station",
          "pl": "Digital Work Station",
          "ru": "Цифровая рабочая станция",
          "uk": "Digital Work Station",
          "ko": "Digital Work Station",
          "zh": "Digital Work Station",
          "ja": "Digital Work Station"
        },
        {
          "id": "ExtruderItem",
          "en": "Extruder",
          "fr": "Extrudeur",
          "es": "Extruder",
          "de": "Extruder",
          "pt": "Extruder",
          "it": "Extruder",
          "tr": "Extruder",
          "pl": "Extruder",
          "ru": "Extruder",
          "uk": "Extruder",
          "ko": "Extruder",
          "zh": "Extruder",
          "ja": "Extruder"
        },
        {
          "id": "FletchingTableItem",
          "en": "Fletching Table",
          "fr": "Établi d\u0027empennage",
          "es": "Fletching Table",
          "de": "Fletching Table",
          "pt": "Fletching Table",
          "it": "Fletching Table",
          "tr": "Fletching Table",
          "pl": "Fletching Table",
          "ru": "Fletching Table",
          "uk": "Fletching Table",
          "ko": "Fletching Table",
          "zh": "Fletching Table",
          "ja": "Fletching Table"
        },
        {
          "id": "GrindstoneItem",
          "en": "Grindstone",
          "fr": "Meule d\u0027affûtage",
          "es": "Grindstone",
          "de": "Grindstone",
          "pt": "Grindstone",
          "it": "Grindstone",
          "tr": "Grindstone",
          "pl": "Grindstone",
          "ru": "Grindstone",
          "uk": "Grindstone",
          "ko": "Grindstone",
          "zh": "Grindstone",
          "ja": "Grindstone"
        },
        {
          "id": "LighthouseLampItem",
          "en": "Lighthouse Lamp",
          "fr": "Lampe de phare",
          "es": "Lighthouse Lamp",
          "de": "Lighthouse Lamp",
          "pt": "Lighthouse Lamp",
          "it": "Lighthouse Lamp",
          "tr": "Lighthouse Lamp",
          "pl": "Lighthouse Lamp",
          "ru": "Lighthouse Lamp",
          "uk": "Lighthouse Lamp",
          "ko": "Lighthouse Lamp",
          "zh": "Lighthouse Lamp",
          "ja": "Lighthouse Lamp"
        },
        {
          "id": "PowerHammerItem",
          "en": "Power Hammer",
          "fr": "Marteau-pilon",
          "es": "Power Hammer",
          "de": "Power Hammer",
          "pt": "Power Hammer",
          "it": "Power Hammer",
          "tr": "Power Hammer",
          "pl": "Power Hammer",
          "ru": "Power Hammer",
          "uk": "Power Hammer",
          "ko": "Power Hammer",
          "zh": "Power Hammer",
          "ja": "Power Hammer"
        }
      ]
    },
    {
      "type": "recipes",
      "entries": [
        {
          "id": "IronAxe",
          "en": "Iron Axe",
          "fr": "Hache en fer",
          "es": "Hacha de Hierro",
          "de": "Eisenaxt",
          "pt": "Machado de Ferro",
          "it": "Ascia di ferro",
          "tr": "Demir Balta",
          "pl": "Żelazna siekiera",
          "ru": "Железный топор",
          "uk": "Залізна сокира",
          "ko": "철 도끼",
          "zh": "铁斧",
          "ja": "鉄のオノ"
        },
        {
          "id": "IronHammer",
          "en": "Iron Hammer",
          "fr": "Marteau en fer",
          "es": "Martillo de Hierro",
          "de": "Eisenhammer",
          "pt": "Martelo de Ferro",
          "it": "Martello di ferro",
          "tr": "Demir Çekiç",
          "pl": "Żelazny młotek",
          "ru": "Железный молоток",
          "uk": "Залізний молоток",
          "ko": "철 망치",
          "zh": "铁锤",
          "ja": "鉄のハンマー"
        },
        {
          "id": "IronHoe",
          "en": "Iron Hoe",
          "fr": "Binette en fer",
          "es": "Azada de Hierro",
          "de": "Eisenhacke",
          "pt": "Enxada de Ferro",
          "it": "Zappa di ferro",
          "tr": "Demir Çapa",
          "pl": "Żelazna motyka",
          "ru": "Железная тяпка",
          "uk": "Залізна мотика",
          "ko": "철 괭이",
          "zh": "铁锄",
          "ja": "鉄のクワ"
        },
        {
          "id": "IronPickaxe",
          "en": "Iron Pickaxe",
          "fr": "Pioche en fer",
          "es": "Pico de Hierro",
          "de": "Eisenspitzhacke",
          "pt": "Picareta de Ferro",
          "it": "Piccone di ferro",
          "tr": "Demir Kazma",
          "pl": "Żelazny kilof",
          "ru": "Железная кирка",
          "uk": "Залізне кайло",
          "ko": "철 곡괭이",
          "zh": "铁镐",
          "ja": "鉄のツルハシ"
        },
        {
          "id": "IronShovel",
          "en": "Iron Shovel",
          "fr": "Pelle en fer",
          "es": "Pala de Hierro",
          "de": "Eisenschaufel",
          "pt": "Pá de Ferro",
          "it": "Pala di ferro",
          "tr": "Demir Kürek",
          "pl": "Żelazna łopata",
          "ru": "Железная лопата",
          "uk": "Залізна лопата",
          "ko": "철 삽",
          "zh": "铁铲",
          "ja": "鉄のシャベル"
        },
        {
          "id": "ModernAxe",
          "en": "Modern Axe",
          "fr": "Hache moderne",
          "es": "Hacha moderna",
          "de": "Moderne Axt",
          "pt": "Machado Moderno",
          "it": "Ascia moderna",
          "tr": "Modern Balta",
          "pl": "Nowoczesna Siekiera",
          "ru": "Современный топор",
          "uk": "Сучасна сокира",
          "ko": "현대식 도끼",
          "zh": "现代斧",
          "ja": "近代的なオノ"
        },
        {
          "id": "ModernHammer",
          "en": "Modern Hammer",
          "fr": "Marteau moderne",
          "es": "Martillo Moderno",
          "de": "Moderner Hammer",
          "pt": "Martelo Moderno",
          "it": "Martello moderno",
          "tr": "Modern Çekiç",
          "pl": "Nowoczesny Młotek",
          "ru": "Современный молоток",
          "uk": "Сучасний молоток",
          "ko": "현대식 망치",
          "zh": "现代锤",
          "ja": "近代的なハンマー"
        },
        {
          "id": "ModernHoe",
          "en": "Modern Hoe",
          "fr": "Binette moderne",
          "es": "Azada Moderna",
          "de": "Moderne Hacke",
          "pt": "Enxada Moderna",
          "it": "Zappa moderna",
          "tr": "Modern Çapa",
          "pl": "Nowoczesna Motyka",
          "ru": "Современная тяпка",
          "uk": "Сучасна мотика",
          "ko": "현대식 괭이",
          "zh": "现代锄",
          "ja": "近代的なクワ"
        },
        {
          "id": "ModernPickaxe",
          "en": "Modern Pickaxe",
          "fr": "Pioche moderne",
          "es": "Pico Moderno",
          "de": "Moderne Spitzhacke",
          "pt": "Picareta Moderna",
          "it": "Piccone moderno",
          "tr": "Modern Kazma",
          "pl": "Nowoczesny Kilof",
          "ru": "Современная кирка",
          "uk": "Сучасне кайло",
          "ko": "현대식 곡괭이",
          "zh": "现代镐",
          "ja": "近代的なツルハシ"
        },
        {
          "id": "ModernScythe",
          "en": "Modern Scythe",
          "fr": "Faucille moderne",
          "es": "Guadaña moderna",
          "de": "Moderne Sense",
          "pt": "Foice Moderna",
          "it": "Falce moderna",
          "tr": "Modern Tırpan",
          "pl": "Nowoczesna Kosa",
          "ru": "Современная коса",
          "uk": "Сучасна коса",
          "ko": "현대식 낫",
          "zh": "现代镰刀",
          "ja": "近代的なカマ"
        },
        {
          "id": "ModernShovel",
          "en": "Modern Shovel",
          "fr": "Pelle moderne",
          "es": "Pala Moderna",
          "de": "Moderne Schaufel",
          "pt": "Pá Moderna",
          "it": "Pala moderna",
          "tr": "Modern Kürek",
          "pl": "Nowoczesna Łopata",
          "ru": "Современная лопата",
          "uk": "Сучасна лопата",
          "ko": "현대식 삽",
          "zh": "现代铲",
          "ja": "近代的なシャベル"
        },
        {
          "id": "SteelAxe",
          "en": "Steel Axe",
          "fr": "Hache en acier",
          "es": "Hacha de Acero",
          "de": "Stahlaxt",
          "pt": "Machado de Aço",
          "it": "Ascia d\u0027acciaio",
          "tr": "Çelik Balta",
          "pl": "Stalowa siekiera",
          "ru": "Стальной топор",
          "uk": "Сталева сокира",
          "ko": "강철 도끼",
          "zh": "钢斧",
          "ja": "鋼のオノ"
        },
        {
          "id": "SteelHammer",
          "en": "Steel Hammer",
          "fr": "Marteau en acier",
          "es": "Martillo de Acero",
          "de": "Stahlhammer",
          "pt": "Martelo de Aço",
          "it": "Martello d\u0027acciaio",
          "tr": "Çelik Çekiç",
          "pl": "Stalowy młotek",
          "ru": "Стальной молоток",
          "uk": "Сталевий молоток",
          "ko": "강철 망치",
          "zh": "钢锤",
          "ja": "鋼のハンマー"
        },
        {
          "id": "SteelHoe",
          "en": "Steel Hoe",
          "fr": "Binette en acier",
          "es": "Azada de Acero",
          "de": "Stahlhacke",
          "pt": "Enxada de Aço",
          "it": "Zappa d\u0027acciaio",
          "tr": "Çelik Çapa",
          "pl": "Stalowa motyka",
          "ru": "Стальная тяпка",
          "uk": "Сталева мотика",
          "ko": "강철 괭이",
          "zh": "钢锄",
          "ja": "鋼のクワ"
        },
        {
          "id": "SteelPickaxe",
          "en": "Steel Pickaxe",
          "fr": "Pioche en acier",
          "es": "Pico de Acero",
          "de": "Stahlspitzhacke",
          "pt": "Picareta de Aço",
          "it": "Piccone d\u0027acciaio",
          "tr": "Çelik Kazma",
          "pl": "Stalowy kilof",
          "ru": "Стальная кирка",
          "uk": "Сталеве кайло",
          "ko": "강철 곡괭이",
          "zh": "钢镐",
          "ja": "鋼のツルハシ"
        },
        {
          "id": "SteelShovel",
          "en": "Steel Shovel",
          "fr": "Pelle en acier",
          "es": "Pala de Acero",
          "de": "Stahlschaufel",
          "pt": "Pá de Aço",
          "it": "Pala d\u0027acciaio",
          "tr": "Çelik Kürek",
          "pl": "Stalowa łopata",
          "ru": "Стальная лопата",
          "uk": "Сталева лопата",
          "ko": "강철 삽",
          "zh": "钢铲",
          "ja": "鋼のシャベル"
        },
        {
          "id": "StoneAxe",
          "en": "Stone Axe",
          "fr": "Hache en pierre",
          "es": "Hacha de piedra",
          "de": "Steinaxt",
          "pt": "Machado de Pedra",
          "it": "Ascia di pietra",
          "tr": "Taş Balta",
          "pl": "Kamienna siekiera",
          "ru": "Каменный топор",
          "uk": "Кам’яна сокира",
          "ko": "돌 도끼",
          "zh": "石斧",
          "ja": "石のオノ"
        },
        {
          "id": "StoneHammer",
          "en": "Stone Hammer",
          "fr": "Marteau en pierre",
          "es": "Martillo de Piedra",
          "de": "Steinhammer",
          "pt": "Martelo de Pedra",
          "it": "Martello di pietra",
          "tr": "Taş Çekiç",
          "pl": "Kamienny młotek",
          "ru": "Каменный молоток",
          "uk": "Кам’яний молоток",
          "ko": "돌 망치",
          "zh": "石锤",
          "ja": "石のハンマー"
        },
        {
          "id": "StonePickaxe",
          "en": "Stone Pickaxe",
          "fr": "Pioche en pierre",
          "es": "Pico de piedra",
          "de": "Steinspitzhacke",
          "pt": "Picareta de Pedra",
          "it": "Piccone di pietra",
          "tr": "Taş Kazma",
          "pl": "Kamienny kilof",
          "ru": "Каменная кирка",
          "uk": "Кам’яне кайло",
          "ko": "돌 곡괭이",
          "zh": "石镐",
          "ja": "石のツルハシ"
        },
        {
          "id": "WoodenHoe",
          "en": "Wooden Hoe",
          "fr": "Binette en bois",
          "es": "Azada de Madera",
          "de": "Holzhacke",
          "pt": "Enxada de Madeira",
          "it": "Zappa di legno",
          "tr": "Ahşap Çapa",
          "pl": "Drewniana motyka",
          "ru": "Деревянная тяпка",
          "uk": "Дерев’яна мотика",
          "ko": "나무 괭이",
          "zh": "木锄",
          "ja": "木のクワ"
        },
        {
          "id": "WoodenShovel",
          "en": "Wooden Shovel",
          "fr": "Pelle en bois",
          "es": "Pala de Madera",
          "de": "Holzschaufel",
          "pt": "Pá de Madeira",
          "it": "Pala di legno",
          "tr": "Ahşap Kürek",
          "pl": "Drewniana łopata",
          "ru": "Деревянная лопата",
          "uk": "Дерев’яна лопата",
          "ko": "나무 삽",
          "zh": "木铲",
          "ja": "木のシャベル"
        },
        {
          "id": "BeetSeed",
          "en": "Beet Seed",
          "fr": "Graine de betterave",
          "es": "Semilla de remolacha",
          "de": "Samen (Rote Bete)",
          "pt": "Semente de Beterraba",
          "it": "Seme di barbabietola",
          "tr": "Pancar Tohumu",
          "pl": "Nasiona buraka",
          "ru": "Семечко свёклы",
          "uk": "Насіння буряка",
          "ko": "사탕무 씨앗",
          "zh": "甜菜种子",
          "ja": "ビートの種"
        },
        {
          "id": "CornSeed",
          "en": "Corn Seed",
          "fr": "Graine de maïs",
          "es": "Semilla de Maíz",
          "de": "Samen (Mais)",
          "pt": "Semente de Milho",
          "it": "Semi di Mais",
          "tr": "Mısır Tohumu",
          "pl": "Nasiona Kukurydzy",
          "ru": "Семечко кукурузы",
          "uk": "Насіння кукурудзи",
          "ko": "옥수수 씨앗",
          "zh": "玉米种子",
          "ja": "トウモロコシの種"
        },
        {
          "id": "CreosoteBushSeed",
          "en": "Creosote Bush Seed",
          "fr": "Graine de créosotier",
          "es": "Semilla de planta gobernadora",
          "de": "Samen (Kreosotbusch)",
          "pt": "Semente de Arbusto de Creosoto",
          "it": "Seme di Cespuglio di Creosoto",
          "tr": "Katran Ruhu Çalısı Tohumu",
          "pl": "Nasiona Trójnika Pustynnego",
          "ru": "Семечко ларреи",
          "uk": "Насіння креозотового куща",
          "ko": "크레오소트 덤불 씨앗",
          "zh": "灌木种子",
          "ja": "クレオソートブッシュの種"
        },
        {
          "id": "CriminiMushroomSpores",
          "en": "Crimini Mushroom Spores",
          "fr": "Spores de champignon de Paris",
          "es": "Esporas de Champiñón Común",
          "de": "Sporen (Champignon)",
          "pt": "Esporos de Cogumelo Champignon",
          "it": "Spore di champignon",
          "tr": "Crimini Mantarı Sporları",
          "pl": "Zarodniki Pieczarki",
          "ru": "Споры шампиньонов",
          "uk": "Спори печериць",
          "ko": "양송이버섯 포자",
          "zh": "香啡菇孢子",
          "ja": "マッシュルームの胞子"
        },
        {
          "id": "FernSpore",
          "en": "Fern Spore",
          "fr": "Spores de fougère",
          "es": "Espora de Helecho",
          "de": "Sporen (Farn)",
          "pt": "Esporos de Samambaia",
          "it": "Spora di felce",
          "tr": "Füjer Sporu",
          "pl": "Zarodniki Paproci",
          "ru": "Спора папоротника",
          "uk": "Спори папороті",
          "ko": "고사리 포자",
          "zh": "蕨类孢子",
          "ja": "シダの胞子"
        },
        {
          "id": "FireweedSeed",
          "en": "Fireweed Seed",
          "fr": "Graine d\u0027épilobe",
          "es": "Semilla de Epilobio",
          "de": "Samen (Weidenröschen)",
          "pt": "Semente de Fireweed",
          "it": "Seme di Camenerio",
          "tr": "Yakı Otu Tohumu",
          "pl": "Nasiona Wierzbówki",
          "ru": "Семечко иван-чая",
          "uk": "Насіння дикого льону",
          "ko": "분홍바늘꽃 씨앗",
          "zh": "柳兰种子",
          "ja": "ヤナギランの種"
        },
        {
          "id": "HuckleberrySeed",
          "en": "Huckleberry Seed",
          "fr": "Graine de myrtille",
          "es": "Semilla de Arándano",
          "de": "Samen (Heidelbeere)",
          "pt": "Semente de Mirtilo",
          "it": "Seme di Mirtillo",
          "tr": "Yabanmersini Tohumu",
          "pl": "Nasiona Jagody",
          "ru": "Семечко черники",
          "uk": "Насіння чорниць",
          "ko": "월귤 씨앗",
          "zh": "越橘种子",
          "ja": "ハックルベリーの種"
        },
        {
          "id": "PricklyPearSeed",
          "en": "Prickly Pear Seed",
          "fr": "Graine de figue de Barbarie",
          "es": "Semilla de higo chumbo",
          "de": "Samen (Kaktusfeigen)",
          "pt": "Semente de Pera Espinhosa",
          "it": "Seme di fico",
          "tr": "Firavuninciri Tohumu",
          "pl": "Nasiona opuncji",
          "ru": "Семечко опунции",
          "uk": "Насіння опунції",
          "ko": "천년초 씨앗",
          "zh": "仙人球种子",
          "ja": "ウチワサボテンの種"
        },
        {
          "id": "TomatoSeed",
          "en": "Tomato Seed",
          "fr": "Graine de tomate",
          "es": "Semilla de tomate",
          "de": "Samen (Tomaten)",
          "pt": "Semente de Tomate",
          "it": "Semi di Pomodori",
          "tr": "Domates Tohumu",
          "pl": "Nasiona Pomidora",
          "ru": "Семечко помидора",
          "uk": "Насіння помідору",
          "ko": "토마토 씨앗",
          "zh": "番茄种子",
          "ja": "トマトの種"
        },
        {
          "id": "WheatSeed",
          "en": "Wheat Seed",
          "fr": "Graine de blé",
          "es": "Semilla de Trigo",
          "de": "Samen (Weizen)",
          "pt": "Semente de Trigo",
          "it": "Seme di grano",
          "tr": "Buğday Tohumu",
          "pl": "Nasiona Pszenicy",
          "ru": "Семечко пшеницы",
          "uk": "Насіння пшениці",
          "ko": "밀 씨앗",
          "zh": "小麦种子",
          "ja": "小麦の種"
        },
        {
          "id": "CelluloseFiber",
          "en": "Cellulose Fiber",
          "fr": "Fibres de cellulose",
          "es": "Fibra de celulosa",
          "de": "Zellulosefaser",
          "pt": "Fibra de Celulose",
          "it": "Fibra di Cellulosa",
          "tr": "Selüloz Lifi",
          "pl": "Włókna celulozowe",
          "ru": "Целлюлозное волокно",
          "uk": "Клітковина",
          "ko": "셀룰로오스 섬유",
          "zh": "人造纤维",
          "ja": "セルロース繊維"
        },
        {
          "id": "CompositeFiller",
          "en": "Composite Filler",
          "fr": "Charge renforçante composite",
          "es": "Relleno de Compuesto",
          "de": "Füller aus Verbundstoffen",
          "pt": "Enchimento Composto",
          "it": "Riempitivo Misto",
          "tr": "Karma Gübre",
          "pl": "Wypełniacz kompozytowy",
          "ru": "Композитный наполнитель",
          "uk": "Композитний наповнювач",
          "ko": "합성 보충제",
          "zh": "复合填料",
          "ja": "複合フィラー"
        },
        {
          "id": "HuckleberryExtract",
          "en": "Huckleberry Extract",
          "fr": "Extrait de myrtilles",
          "es": "Extracto de Arándano",
          "de": "Heidelbeerextrakt",
          "pt": "Extrato de mirtilo",
          "it": "Estratto di Mirtillo",
          "tr": "Yabanmersini Özü",
          "pl": "Ekstrakt z Czarnej Jagody",
          "ru": "Экстракт черники",
          "uk": "Екстракт чорниці",
          "ko": "월귤 추출물",
          "zh": "越橘汁",
          "ja": "ハックルベリーエキス"
        },
        {
          "id": "BerryExtractFertilizer",
          "en": "Berry Extract Fertilizer",
          "fr": "Engrais à l\u0027extrait de baies",
          "es": "Fertilizante de Extracto de Baya",
          "de": "Dünger aus Beerenextrakt",
          "pt": "Fertilizante de Extrato de Baga",
          "it": "Fertilizzante all’estratto di bacca",
          "tr": "Dut Özü Gübresi",
          "pl": "Nawóz z ekstraktu jagodowego",
          "ru": "Удобрение из ягодного экстракта",
          "uk": "Добриво з ягідного екстракту",
          "ko": "월귤 추출물 비료",
          "zh": "浆果萃取化肥",
          "ja": "ハックルベリーエキスの肥料"
        },
        {
          "id": "PulpFiller",
          "en": "Pulp Filler",
          "fr": "Charge renforçante boisée",
          "es": "Relleno de Pulpa",
          "de": "Füller aus Holzspähnen",
          "pt": "Enchimento de Polpa",
          "it": "Polpa Riempitiva",
          "tr": "Odun Hamuru Gübresi",
          "pl": "Wypełniacz z miazgi",
          "ru": "Древесный наполнитель",
          "uk": "Наповнювач із деревини",
          "ko": "펄프 보충제",
          "zh": "纸浆填料",
          "ja": "パルプフィラー"
        },
        {
          "id": "ScrapMeat",
          "en": "Scrap Meat",
          "fr": "Restes de viande",
          "es": "Carne de desechos",
          "de": "Fleischreste",
          "pt": "Sobras de carne",
          "it": "Carne di scarto",
          "tr": "Parça Et",
          "pl": "Ochłapy Mięsa",
          "ru": "Мясные обрезки",
          "uk": "Обрізки м’яса",
          "ko": "고기 조각",
          "zh": "碎肉",
          "ja": "くず肉"
        },
        {
          "id": "BloodMealFertilizer",
          "en": "Blood Meal Fertilizer",
          "fr": "Engrais à base de farine de sang",
          "es": "Fertilizante de Harina de Sangre",
          "de": "Dünger aus Blutmahl",
          "pt": "Fertilizante de Sangue em Pó",
          "it": "Fertilizzante alla farina di sangue",
          "tr": "Kan Unu Gübresi",
          "pl": "Nawóz z mączki krwistej",
          "ru": "Удобрение из кровяной муки",
          "uk": "Добриво з кров’яного борошна",
          "ko": "혈분비료",
          "zh": "血粉化肥",
          "ja": "血粉の肥料"
        },
        {
          "id": "FiberFiller",
          "en": "Fiber Filler",
          "fr": "Charge renforçante fibreuse",
          "es": "Relleno de Fibra",
          "de": "Füller aus Fasern",
          "pt": "Enchimento de Fibra",
          "it": "Fibra Riempitiva",
          "tr": "Lif Tütünü",
          "pl": "Wypełniacz włóknowy",
          "ru": "Волоконный наполнитель",
          "uk": "Наповнювач із волокна",
          "ko": "식물섬유 보충제",
          "zh": "纤维填料",
          "ja": "繊維フィラー"
        },
        {
          "id": "CharredCamasBulb",
          "en": "Charred Camas Bulb",
          "fr": "Bulbe de camassia carbonisé",
          "es": "Bulbo de camasia carbonizado",
          "de": "Gegrillte Prärielilienzwiebel",
          "pt": "Bulbo de camassia tostado",
          "it": "Bulbo di Camassia Carbonizzato",
          "tr": "Pişmiş Camas Soğanı",
          "pl": "Opiekana Bulwa Kamasji",
          "ru": "Обжаренная луковица камассии",
          "uk": "Обвуглена цибулина камасії",
          "ko": "그슬린 카마스 구근",
          "zh": "烧焦的卡马斯球茎",
          "ja": "焦げたカマシアの球根"
        },
        {
          "id": "CamasAshFertilizer",
          "en": "Camas Ash Fertilizer",
          "fr": "Engrais à la cendre de camassia",
          "es": "Fertilizante de cenizas de camasia",
          "de": "Dünger aus Prärielilienasche",
          "pt": "Fertilizante de Cinzas de Camassia",
          "it": "Fertilizzante di Polvere di Camassia",
          "tr": "Camas Karbonatlı Gübre",
          "pl": "Nawóz z popiołu Kamasji",
          "ru": "Удобрение из пепла камассии",
          "uk": "Добриво з попелу камасії",
          "ko": "카마스 재 비료",
          "zh": "卡马斯灰化肥",
          "ja": "カマシア灰の肥料"
        },
        {
          "id": "HideAshFertilizer",
          "en": "Hide Ash Fertilizer",
          "fr": "Engrais à base de cendres de peaux",
          "es": "Fertilizante de Ceniza de Cuero",
          "de": "Dünger aus Lederasche",
          "pt": "Fertilizante de Cinzas de Couro",
          "it": "Nascondi Cenere Fertilizzante",
          "tr": "Karbonatlı Post Gübresi",
          "pl": "Nawóz z popiołu skórzanego",
          "ru": "Зольное удобрение из шкуры",
          "uk": "Добриво з попелу від згорілої шкіри",
          "ko": "가죽 재 비료",
          "zh": "皮灰化肥",
          "ja": "皮灰の肥料"
        },
        {
          "id": "PeltFertilizer",
          "en": "Pelt Fertilizer",
          "fr": "Engrais à base de fourrures",
          "es": "Fertilizante de Pieles",
          "de": "Dünger aus Pelz",
          "pt": "Fertilizante de Pele",
          "it": "Fertilizzante per Pelle",
          "tr": "Deri Gübresi",
          "pl": "Nawóz z futer",
          "ru": "Удобрение из меха",
          "uk": "Добриво з хутра",
          "ko": "모피 비료",
          "zh": "毛皮化肥",
          "ja": "毛皮の肥料"
        },
        {
          "id": "PhosphateFertilizer",
          "en": "Phosphate Fertilizer",
          "fr": "Engrais à base de phosphate",
          "es": "Fertilizante de Fosfato",
          "de": "Dünger mit Phosphat",
          "pt": "Fertilizante de Fosfato",
          "it": "Fertilizzante di Fosfato",
          "tr": "Fosfatlı Gübre",
          "pl": "Nawóz fosforowy",
          "ru": "Фосфорное удобрение",
          "uk": "Фосфорні добрива",
          "ko": "인산염 비료",
          "zh": "磷肥",
          "ja": "リン酸肥料"
        },
        {
          "id": "AcornPowder",
          "en": "Acorn Powder",
          "fr": "Poudre de gland",
          "es": "Polvo de Bellota",
          "de": "Eichelpulver",
          "pt": "Pó de bolota",
          "it": "Polvere di ghianda",
          "tr": "Palamut Tozu",
          "pl": "Mączka z żołędzi",
          "ru": "Мука из желудей",
          "uk": "Порошок із жолудів",
          "ko": "도토리 분말",
          "zh": "橡子粉",
          "ja": "ドングリの粉"
        },
        {
          "id": "BakedMeat",
          "en": "Baked Meat",
          "fr": "Viande au four",
          "es": "Carne Horneada",
          "de": "Gebackenes Fleisch",
          "pt": "Carne assada",
          "it": "Carne al forno",
          "tr": "Kavrulmuş Et",
          "pl": "Pieczone mięso",
          "ru": "Запечённое мясо",
          "uk": "Запечене м’ясо",
          "ko": "구운 고기",
          "zh": "熟肉",
          "ja": "焼いた肉"
        },
        {
          "id": "RawRoast",
          "en": "Raw Roast",
          "fr": "Rôti cru",
          "es": "Asado Crudo",
          "de": "Roher Braten",
          "pt": "Copa crua",
          "it": "Arrosto Crudo",
          "tr": "Çiğ Et Parçası",
          "pl": "Surowa pieczeń",
          "ru": "Мясо для жаркого",
          "uk": "Сира печеня",
          "ko": "안 익은 구이용 고기",
          "zh": "未烤肉",
          "ja": "生のロースト"
        },
        {
          "id": "BakedRoast",
          "en": "Baked Roast",
          "fr": "Rôti au four",
          "es": "Asado Horneado",
          "de": "Gebackener Braten",
          "pt": "Copa assada",
          "it": "Arrosto al forno",
          "tr": "Kavrulmuş Rosto",
          "pl": "Zapiekana pieczeń",
          "ru": "Запечённое жаркое",
          "uk": "Запечена печеня",
          "ko": "구운 구이용 고기",
          "zh": "熟烤肉",
          "ja": "焼きたてのロースト"
        },
        {
          "id": "Bannock",
          "en": "Bannock",
          "fr": "Bannique",
          "es": "Bannock",
          "de": "Lagerfeuerbrot",
          "pt": "Bannock",
          "it": "Pagnotta",
          "tr": "Pide",
          "pl": "Placek pszenny",
          "ru": "Пресная лепёшка",
          "uk": "Коржик",
          "ko": "과자빵",
          "zh": "麦饼",
          "ja": "バノック"
        },
        {
          "id": "BeanPaste",
          "en": "Bean Paste",
          "fr": "Pâte de haricots",
          "es": "Pasta de Judías",
          "de": "Bohnenpaste",
          "pt": "Pasta de feijão",
          "it": "Pasta di fagioli",
          "tr": "Fasulye Macunu",
          "pl": "Pasta z fasoli",
          "ru": "Бобовая паста",
          "uk": "Паста з бобів",
          "ko": "갈린 콩",
          "zh": "豆浆",
          "ja": "ペースト状の豆"
        },
        {
          "id": "Flour",
          "en": "Flour",
          "fr": "Farine",
          "es": "Harina",
          "de": "Mehl",
          "pt": "Farinha",
          "it": "Farina",
          "tr": "Un",
          "pl": "Mąka",
          "ru": "Мука",
          "uk": "Борошно",
          "ko": "밀가루",
          "zh": "面粉",
          "ja": "小麦粉"
        },
        {
          "id": "Sugar",
          "en": "Sugar",
          "fr": "Sucre",
          "es": "Azúcar",
          "de": "Zucker",
          "pt": "Açúcar",
          "it": "Zucchero",
          "tr": "Şeker",
          "pl": "Cukier",
          "ru": "Сахар",
          "uk": "Цукор",
          "ko": "설탕",
          "zh": "糖",
          "ja": "砂糖"
        },
        {
          "id": "Yeast",
          "en": "Yeast",
          "fr": "Levure",
          "es": "Levadura",
          "de": "Hefe",
          "pt": "Fermento",
          "it": "Lievito",
          "tr": "Maya",
          "pl": "Drożdże",
          "ru": "Дрожжи",
          "uk": "Дріжджі",
          "ko": "효모",
          "zh": "酵母",
          "ja": "酵母"
        },
        {
          "id": "Bearclaw",
          "en": "Bearclaw",
          "fr": "Gâteau patte d\u0027ours",
          "es": "Pastel Garra de Oso",
          "de": "Bärenklaue",
          "pt": "Garra de urso",
          "it": "Artiglio d\u0027orso",
          "tr": "Ayı Pençesi Keki",
          "pl": "Niedźwiadka",
          "ru": "Пирог «Медвежий коготь»",
          "uk": "Пиріг «Ведмежий кіготь»",
          "ko": "곰 발톱 빵",
          "zh": "熊爪包",
          "ja": "ベアクロウ"
        },
        {
          "id": "PrimeCut",
          "en": "Prime Cut",
          "fr": "Morceau de choix",
          "es": "Corte Primo",
          "de": "Filet",
          "pt": "Carne de primeira",
          "it": "Carne di Prima Scelta",
          "tr": "Astar Kesim",
          "pl": "Mięso prima sort",
          "ru": "Вырезка",
          "uk": "М’ясо найвищого ґатунку",
          "ko": "최고급 고기",
          "zh": "特级肉块",
          "ja": "プライムカット"
        },
        {
          "id": "MeatStock",
          "en": "Meat Stock",
          "fr": "Bouillon de viandes",
          "es": "Caldo de Carne",
          "de": "Brühe aus Fleisch",
          "pt": "Caldo de carne",
          "it": "Brodo di carne",
          "tr": "Et Stoğu",
          "pl": "Rosół",
          "ru": "Мясной бульон",
          "uk": "М’ясний бульйон",
          "ko": "고기 육수",
          "zh": "肉汤料",
          "ja": "肉のスープストック"
        },
        {
          "id": "InfusedOil",
          "en": "Infused Oil",
          "fr": "Huile infusée",
          "es": "Aceite Infusionado",
          "de": "Raffiniertes Öl",
          "pt": "Óleo infundido",
          "it": "Olio infuso",
          "tr": "Demlenmiş Sıvı Yağ",
          "pl": "Olej smakowy",
          "ru": "Масляный настой",
          "uk": "Насичена олія",
          "ko": "침출유",
          "zh": "浸泡油",
          "ja": "混合油"
        },
        {
          "id": "BearSUPREME",
          "en": "Bear S U P R E M E",
          "fr": "Suprême d\u0027ours",
          "es": "Oso S U P R E M O",
          "de": "Bärensteak",
          "pt": "Urso S U P R E M O",
          "it": "Orso Supreme",
          "tr": "Y Ü C E Ayı",
          "pl": "Nedzwiedź S U P R E M E",
          "ru": "Блюдо «Матёрый медведь»",
          "uk": "Ведмежий стейк",
          "ko": "쩔어주는 곰기",
          "zh": "顶级熊肉",
          "ja": "Bear S U P R E M E"
        },
        {
          "id": "RawSausage",
          "en": "Raw Sausage",
          "fr": "Saucisse crue",
          "es": "Salchicha Cruda",
          "de": "Rohe Wurst",
          "pt": "Linguiça crua",
          "it": "Salsicia cruda",
          "tr": "Çiğ Sosis",
          "pl": "Surowa kiełbasa",
          "ru": "Сырая сарделька",
          "uk": "Сира сарделька",
          "ko": "생 소시지",
          "zh": "生香肠",
          "ja": "生のソーセージ"
        },
        {
          "id": "BoiledSausage",
          "en": "Boiled Sausage",
          "fr": "Saucisse bouillie",
          "es": "Salchicha Cocida",
          "de": "Gekochte Wurst",
          "pt": "Linguiça cozida",
          "it": "Salsiccia bollita",
          "tr": "Haşlanmış Sosis",
          "pl": "Gotowana kiełbasa",
          "ru": "Варёная сосиска",
          "uk": "Варена сарделька",
          "ko": "삶은 소시지",
          "zh": "煮香肠",
          "ja": "茹でたソーセージ"
        },
        {
          "id": "Bread",
          "en": "Bread",
          "fr": "Pain",
          "es": "Pan",
          "de": "Brot",
          "pt": "Pão",
          "it": "Pane",
          "tr": "Ekmek",
          "pl": "Chleb",
          "ru": "Хлеб",
          "uk": "Хліб",
          "ko": "빵",
          "zh": "面包",
          "ja": "パン"
        },
        {
          "id": "CamasPaste",
          "en": "Camas Paste",
          "fr": "Pâte de camassia",
          "es": "Pasta de camasia",
          "de": "Prärielilienpaste",
          "pt": "Pasta de camassia",
          "it": "Pasta di Camassia",
          "tr": "Camas Lapası",
          "pl": "Pasta z Kamasji",
          "ru": "Паста из камассии",
          "uk": "Паста з камасії",
          "ko": "갈린 카마스",
          "zh": "卡马斯浆",
          "ja": "ペースト状のカマシア"
        },
        {
          "id": "CamasBread",
          "en": "Camas Bread",
          "fr": "Pain au camassia",
          "es": "Pan de camasia",
          "de": "Prärielilienbrot",
          "pt": "Pão de camassia",
          "it": "Pane di Camassia",
          "tr": "Camas Ekmeği",
          "pl": "Chleb Kamasjowy",
          "ru": "Хлеб с камассией",
          "uk": "Хліб з камасією",
          "ko": "카마스 빵",
          "zh": "卡马斯面包",
          "ja": "カマシアパン"
        },
        {
          "id": "CamasBulbBake",
          "en": "Camas Bulb Bake",
          "fr": "Bulbe de camassia cuit",
          "es": "Bulbo de camasia horneado",
          "de": "Gebackene Prärielilienzwiebel",
          "pt": "Bulbo de camassia assado",
          "it": "Bulbo di Camassia cotto al forno",
          "tr": "Fırında Camas Soğanı",
          "pl": "Ciasto z bulw Kamasji",
          "ru": "Запечённая луковица камассии",
          "uk": "Запечена цибулина камасії",
          "ko": "구운 카마스 구근",
          "zh": "烤卡马斯球茎",
          "ja": "焼いたカマシアの球根"
        },
        {
          "id": "CampfireRoast",
          "en": "Campfire Roast",
          "fr": "Rôti cuit au feu de camp",
          "es": "Asado a la Fogata",
          "de": "Lagerfeuerbraten",
          "pt": "Copa feita na fogueira",
          "it": "Arosto di falò",
          "tr": "Güveçte Rosto",
          "pl": "Pieczeń z ogniska",
          "ru": "Жаркое на костре",
          "uk": "Печеня на багатті",
          "ko": "모닥불 구운 고기",
          "zh": "篝火烧肉",
          "ja": "野外調理のロースト"
        },
        {
          "id": "CharredBeet",
          "en": "Charred Beet",
          "fr": "Betterave carbonisée",
          "es": "Remolacha carbonizada",
          "de": "Gegrillte Rübe",
          "pt": "Beterraba tostada",
          "it": "Barbabietola carbonizzata",
          "tr": "Pişmiş Pancar",
          "pl": "Opiekany burak",
          "ru": "Свёкла на углях",
          "uk": "Обвуглений буряк",
          "ko": "그슬린 사탕무",
          "zh": "烧焦的甜菜",
          "ja": "焦げたビート"
        },
        {
          "id": "CharredCorn",
          "en": "Charred Corn",
          "fr": "Maïs carbonisé",
          "es": "Maíz carbonizado",
          "de": "Gegrillter Mais",
          "pt": "Milho tostado",
          "it": "Cereali carbonizzati",
          "tr": "Pişmiş Mısır",
          "pl": "Opiekana Kukurydza",
          "ru": "Кукуруза на углях",
          "uk": "Обвуглений кукурудзяний качан",
          "ko": "그슬린 옥수수",
          "zh": "烧焦的玉米",
          "ja": "焦げたトウモロコシ"
        },
        {
          "id": "CharredFish",
          "en": "Charred Fish",
          "fr": "Poisson carbonisé",
          "es": "Pescado carbonizado",
          "de": "Gegrillter Fisch",
          "pt": "Peixe tostado",
          "it": "Pesce carbonizzato",
          "tr": "Pişmiş Balık",
          "pl": "Opiekana Ryba",
          "ru": "Жареная на костре рыба",
          "uk": "Обвуглена риба",
          "ko": "그슬린 생선",
          "zh": "烧焦的鱼",
          "ja": "焦げた魚"
        },
        {
          "id": "CharredMeat",
          "en": "Charred Meat",
          "fr": "Viande carbonisée",
          "es": "Carne carbonizada",
          "de": "Gegrilltes Fleisch",
          "pt": "Carne tostada",
          "it": "Carne carbonizzata",
          "tr": "Pişmiş Et",
          "pl": "Opiekane Mięso",
          "ru": "Жареное на костре мясо",
          "uk": "Обвуглене м’ясо",
          "ko": "그슬린 고기",
          "zh": "烧焦的肉",
          "ja": "焦げた肉"
        },
        {
          "id": "CharredSausage",
          "en": "Charred Sausage",
          "fr": "Saucisse carbonisée",
          "es": "Salchicha Carbonizada",
          "de": "Gegrillte Wurst",
          "pt": "Linguiça tostada",
          "it": "Salsiccia carbonizzata",
          "tr": "Pişmiş Sosis",
          "pl": "Opiekana Kiełbasa",
          "ru": "Сарделька на углях",
          "uk": "Обвуглена сарделька",
          "ko": "그슬린 소시지",
          "zh": "烧焦的香肠",
          "ja": "焦げたソーセージ"
        },
        {
          "id": "CharredTomato",
          "en": "Charred Tomato",
          "fr": "Tomate carbonisée",
          "es": "Tomate Carbonizado",
          "de": "Gegrillte Tomate",
          "pt": "Tomate tostado",
          "it": "Pomodoro carbonizzato",
          "tr": "Pişmiş Domates",
          "pl": "Opiekany Pomidor",
          "ru": "Помидор на углях",
          "uk": "Обвуглений помідор",
          "ko": "그슬린 토마토",
          "zh": "烧焦的番茄",
          "ja": "焦げたトマト"
        },
        {
          "id": "Cornmeal",
          "en": "Cornmeal",
          "fr": "Farine de maïs",
          "es": "Harina de Maíz",
          "de": "Maismehl",
          "pt": "Farinha de milho",
          "it": "Farina di mais",
          "tr": "Mısır Unu",
          "pl": "Kasza kukurydziana",
          "ru": "Кукурузная мука",
          "uk": "Кукурудзянe борошно",
          "ko": "옥수수 가루",
          "zh": "玉米粉",
          "ja": "コーンミール"
        },
        {
          "id": "Oil",
          "en": "Oil",
          "fr": "Huile",
          "es": "Aceite",
          "de": "Öl",
          "pt": "Óleo",
          "it": "Olio",
          "tr": "Yağ",
          "pl": "Olej",
          "ru": "Масло",
          "uk": "Олія",
          "ko": "식용유",
          "zh": "油",
          "ja": "オイル"
        },
        {
          "id": "CornFritters",
          "en": "Corn Fritters",
          "fr": "Beignets de maïs",
          "es": "Buñuelos de maíz",
          "de": "Frittierter Mais",
          "pt": "Bolinho de milho",
          "it": "Frittelle di mais",
          "tr": "Mısır Parçası",
          "pl": "Kukurydza w cieście",
          "ru": "Кукурузные оладьи",
          "uk": "Кукурудзяні оладки",
          "ko": "옥수수튀김",
          "zh": "玉米煎饼",
          "ja": "トウモロコシのフリッター"
        },
        {
          "id": "CrimsonSalad",
          "en": "Crimson Salad",
          "fr": "Salade cramoisie",
          "es": "Ensalada Carmesí",
          "de": "Purpursalat",
          "pt": "Salada carmesim",
          "it": "Insalata Rossa",
          "tr": "Renkli Salata",
          "pl": "Karmazynowa sałatka",
          "ru": "Винегрет",
          "uk": "Вінегрет",
          "ko": "붉은 채소 샐러드",
          "zh": "深红沙拉",
          "ja": "クリムゾン サラダ"
        },
        {
          "id": "RawBacon",
          "en": "Raw Bacon",
          "fr": "Bacon cru",
          "es": "Tocino Crudo",
          "de": "Roher Speck",
          "pt": "Bacon cru",
          "it": "Pancetta cruda",
          "tr": "Çiğ Domuz Pastırma",
          "pl": "Surowy Boczek",
          "ru": "Сырой бекон",
          "uk": "Сирий бекон",
          "ko": "생 베이컨",
          "zh": "生培根",
          "ja": "生のベーコン"
        },
        {
          "id": "CrispyBacon",
          "en": "Crispy Bacon",
          "fr": "Bacon croustillant",
          "es": "Tocino Crujiente",
          "de": "Knuspriger Speck",
          "pt": "Bacon crocante",
          "it": "Pancetta croccante",
          "tr": "Çıtır Domuz Pastırması",
          "pl": "Chrupiący boczek",
          "ru": "Хрустящий бекон",
          "uk": "Хрусткий бекон",
          "ko": "바삭한 베이컨",
          "zh": "香脆培根",
          "ja": "カリカリに焼いたベーコン"
        },
        {
          "id": "Tortilla",
          "en": "Tortilla",
          "fr": "Tortilla",
          "es": "Tortilla",
          "de": "Tortilla",
          "pt": "Tortilha",
          "it": "Tortilla",
          "tr": "Tortilla",
          "pl": "Tortilla",
          "ru": "Тортилья",
          "uk": "Тортилья",
          "ko": "토르티야",
          "zh": "玉米饼",
          "ja": "トルティーヤ"
        },
        {
          "id": "WildMix",
          "en": "Wild Mix",
          "fr": "Mélange sauvage",
          "es": "Mezcla Silvestre",
          "de": "Wildsalat",
          "pt": "Mistura selvagem",
          "it": "Mix selvaggio",
          "tr": "Yabani Karışım",
          "pl": "Bukiet surówek",
          "ru": "Смесь диких растений",
          "uk": "Суміш диких трав",
          "ko": "야채 샐러드",
          "zh": "蔬菜捞",
          "ja": "ワイルドミックス"
        },
        {
          "id": "ElkTaco",
          "en": "Elk Taco",
          "fr": "Taco de wapiti",
          "es": "Taco de alce",
          "de": "Elchtaco",
          "pt": "Taco de alce",
          "it": "Alci taco",
          "tr": "Geyik Etli Taco",
          "pl": "Taco z Jelenia",
          "ru": "Тако с олениной",
          "uk": "Лосяче тако",
          "ko": "엘크 고기 타코",
          "zh": "鹿肉玉米卷",
          "ja": "エルクのタコス"
        },
        {
          "id": "ElkWellington",
          "en": "Elk Wellington",
          "fr": "Rôti de wapiti façon Wellington",
          "es": "Wellington de alce",
          "de": "Wapitiwellington",
          "pt": "Bife Wellington de alce",
          "it": "Alce alla Wellington",
          "tr": "Dışı Yufkalı Geyik Eti",
          "pl": "Jeleń w Cieście",
          "ru": "Оленина «Веллингтон»",
          "uk": "Лосятина по-веллінгтонськи",
          "ko": "엘크 웰링턴",
          "zh": "惠灵顿鹿排",
          "ja": "エルクウェリントン"
        },
        {
          "id": "Flatbread",
          "en": "Flatbread",
          "fr": "Pain plat",
          "es": "Pan Plano",
          "de": "Fladenbrot",
          "pt": "Pão achatado",
          "it": "Focaccia",
          "tr": "Bazlama",
          "pl": "Podpłomyk",
          "ru": "Лепёшка",
          "uk": "Корж",
          "ko": "무발효빵",
          "zh": "大饼",
          "ja": "Podpłomyk"
        },
        {
          "id": "PreparedMeat",
          "en": "Prepared Meat",
          "fr": "Viande préparée",
          "es": "Carne Preparada",
          "de": "Vorbereitetes Fleisch",
          "pt": "Carne preparada",
          "it": "Carne preparata",
          "tr": "Hazırlanmış Et",
          "pl": "Gotowe do przyrządzenia mięso",
          "ru": "Обработанное мясо",
          "uk": "Оброблене м’ясо",
          "ko": "손질된 고기",
          "zh": "预加工肉",
          "ja": "下ごしらえした肉"
        },
        {
          "id": "FriedHareHaunches",
          "en": "Fried Hare Haunches",
          "fr": "Cuisses de lièvre frites",
          "es": "Ancas de Liebre Fritas",
          "de": "Frittierte Hasenkeule",
          "pt": "Coxas de lebre fritas",
          "it": "Cosce di lepre fritte",
          "tr": "Kızartılmış Yabani Tavşan Kalçası",
          "pl": "Smażony udziec z zająca",
          "ru": "Жаренное филе зайца",
          "uk": "Смажене заяче філе",
          "ko": "튀긴 토끼 뒷다리",
          "zh": "炸兔后腿",
          "ja": "野ウサギの唐揚げ"
        },
        {
          "id": "FriedTomatoes",
          "en": "Fried Tomatoes",
          "fr": "Tomates frites",
          "es": "Tomates fritos",
          "de": "Frittierte Tomaten",
          "pt": "Tomates fritos",
          "it": "Pomodori fritti",
          "tr": "Kızartılmış Domatesler",
          "pl": "Smażone pomidory",
          "ru": "Жареные помидоры",
          "uk": "Смажені помідори",
          "ko": "튀긴 토마토",
          "zh": "炸番茄",
          "ja": "フライドトマト"
        },
        {
          "id": "HuckleberryPie",
          "en": "Huckleberry Pie",
          "fr": "Tourte aux myrtilles",
          "es": "Tarta de Arándanos",
          "de": "Heidelbeerkuchen",
          "pt": "Torta de mirtilo",
          "it": "Torta di Mirtilli",
          "tr": "Yabanmersinli Turta",
          "pl": "Ciasto Jagodowe",
          "ru": "Черничный пирог",
          "uk": "Чорничний пиріг",
          "ko": "월귤 파이",
          "zh": "越橘馅饼",
          "ja": "ハックルベリーパイ"
        },
        {
          "id": "SimpleSyrup",
          "en": "Simple Syrup",
          "fr": "Sirop simple",
          "es": "Jarabe Simple",
          "de": "Zuckersirup",
          "pt": "Xarope simples",
          "it": "Sciroppo semplice",
          "tr": "Basit Şurup",
          "pl": "Prosty syrop",
          "ru": "Простой сироп",
          "uk": "Простий сироп",
          "ko": "간단한 시럽",
          "zh": "普通糖浆",
          "ja": "シンプルシロップ"
        },
        {
          "id": "MeatPie",
          "en": "Meat Pie",
          "fr": "Tourte à la viande",
          "es": "Tarta de Carne",
          "de": "Fleischpastete",
          "pt": "Torta de carne",
          "it": "Torta di carne",
          "tr": "Etli Börek",
          "pl": "Mięso w cieście",
          "ru": "Мясной пирог",
          "uk": "М’ясний пиріг",
          "ko": "고기 파이",
          "zh": "肉馅饼",
          "ja": "ミートパイ"
        },
        {
          "id": "SearedMeat",
          "en": "Seared Meat",
          "fr": "Viande poêlée",
          "es": "Carne Chamuscada",
          "de": "Kurz angebratenes Fleisch",
          "pt": "Carne grelhada",
          "it": "Carne Cotta",
          "tr": "Kurutulmuş Et",
          "pl": "Obsmażone mięso",
          "ru": "Обжаренное мясо",
          "uk": "Обсмажене м’ясо",
          "ko": "직화 고기",
          "zh": "煎肉",
          "ja": "焼き目がついた肉"
        },
        {
          "id": "SimmeredMeat",
          "en": "Simmered Meat",
          "fr": "Viande mijotée",
          "es": "Carne Hervida",
          "de": "Geschmortes Fleisch",
          "pt": "Carne cozida",
          "it": "Carne bollita",
          "tr": "Kısık Ateşte Pişmiş Et",
          "pl": "Wolno gotowane mięso",
          "ru": "Тушёное мясо",
          "uk": "Тушковане м’ясо",
          "ko": "육즙을 가둔 고기",
          "zh": "炖肉",
          "ja": "煮込み肉"
        },
        {
          "id": "StuffedTurkey",
          "en": "Stuffed Turkey",
          "fr": "Dinde farcie",
          "es": "Pavo Relleno",
          "de": "Gefüllter Truthahn",
          "pt": "Peru recheado",
          "it": "Tacchino Imbottito",
          "tr": "Hindi Dolması",
          "pl": "Indyk faszerowany",
          "ru": "Фаршированная индейка",
          "uk": "Фарширована індичка",
          "ko": "속을 채운 칠면조",
          "zh": "填馅火鸡",
          "ja": "七面鳥の丸焼き"
        },
        {
          "id": "SweetSalad",
          "en": "Sweet Salad",
          "fr": "Salade douce",
          "es": "Ensalada Dulce",
          "de": "Süßer Salat",
          "pt": "Salada doce",
          "it": "Insalata Dolce",
          "tr": "Tatlı Salata",
          "pl": "Słodka sałatka",
          "ru": "Сладкий салат",
          "uk": "Солодкий салат",
          "ko": "달콤한 샐러드",
          "zh": "甜沙拉",
          "ja": "スウィートサラダ"
        },
        {
          "id": "VegetableStock",
          "en": "Vegetable Stock",
          "fr": "Bouillon de légumes",
          "es": "Caldo de Verduras",
          "de": "Brühe aus Gemüse",
          "pt": "Caldo de vegetais",
          "it": "Assortimento di Vegetali",
          "tr": "Sebze Stoğu",
          "pl": "Bulion warzywny",
          "ru": "Овощной бульон",
          "uk": "Овочевий бульйон",
          "ko": "야채 육수",
          "zh": "蔬菜汤料",
          "ja": "野菜のスープストック"
        },
        {
          "id": "VegetableSoup",
          "en": "Vegetable Soup",
          "fr": "Soupe de légumes",
          "es": "Sopa de Verduras",
          "de": "Suppe mit Gemüse",
          "pt": "Sopa de vegetais",
          "it": "Brodo Vegetale",
          "tr": "Sebze Çorbası",
          "pl": "Zupa jarzynowa",
          "ru": "Овощной суп",
          "uk": "Овочевий суп",
          "ko": "야채 스프",
          "zh": "蔬菜汤",
          "ja": "野菜スープ"
        },
        {
          "id": "WildStew",
          "en": "Wild Stew",
          "fr": "Ragoût sauvage",
          "es": "Estofado silvestre",
          "de": "Lagerfeuer Waldeintopf",
          "pt": "Ensopado selvagem",
          "it": "Stufato di selvaggina",
          "tr": "Yabani Yahni",
          "pl": "Gulasz z dzikich roślin",
          "ru": "Рагу из диких растений",
          "uk": "Рагу з диких трав",
          "ko": "야생 스튜",
          "zh": "蔬菜炖",
          "ja": "ワイルドシチュー"
        },
        {
          "id": "WiltedFiddleheads",
          "en": "Wilted Fiddleheads",
          "fr": "Crosses de fougère flétries",
          "es": "Brotes de helecho marchitos",
          "de": "Farnspitzen getrocknet",
          "pt": "Brotos de samambaia murchos",
          "it": "Germogli di felce appassiti",
          "tr": "Solmuş Eğrelti Otları",
          "pl": "Blanszowane pędy paproci",
          "ru": "Увядшие побеги папоротника",
          "uk": "Зів’яла папороть",
          "ko": "살짝 익힌 고사리",
          "zh": "蕨菜干",
          "ja": "しおれたシダ"
        },
        {
          "id": "Piston",
          "en": "Piston",
          "fr": "Piston",
          "es": "Pistón",
          "de": "Kolben",
          "pt": "Pistão",
          "it": "Pistone",
          "tr": "Piston",
          "pl": "Tłok",
          "ru": "Поршень",
          "uk": "Поршень",
          "ko": "피스톤",
          "zh": "活塞",
          "ja": "ピストン"
        },
        {
          "id": "Valve",
          "en": "Valve",
          "fr": "Soupape",
          "es": "Válvula",
          "de": "Ventil",
          "pt": "Válvula",
          "it": "Valvola",
          "tr": "Vana",
          "pl": "Zawór",
          "ru": "Клапан",
          "uk": "Вентиль",
          "ko": "밸브",
          "zh": "阀门",
          "ja": "バルブ"
        },
        {
          "id": "Servo",
          "en": "Servo",
          "fr": "Servomoteur",
          "es": "Servomotor",
          "de": "Servomotor",
          "pt": "Servomotor",
          "it": "Servomotore",
          "tr": "Servo",
          "pl": "Serwomechanizm",
          "ru": "Сервопривод",
          "uk": "Сервопривід",
          "ko": "자동 제어 장치",
          "zh": "传动装置",
          "ja": "サーボ"
        },
        {
          "id": "AdvancedCombustionEngine",
          "en": "Advanced Combustion Engine",
          "fr": "Moteur avancé à combustion",
          "es": "Motor de Combustión Avanzado",
          "de": "Fortschrittlicher Verbrennungsmotor",
          "pt": "Motor de Combustão Avançado",
          "it": "Motore a Combustione Avanzato",
          "tr": "Geliştirilmiş Yanmalı Motor",
          "pl": "Zaawansowany silnik spalinowy",
          "ru": "Улучшенный двигатель внутреннего сгорания",
          "uk": "Удосконалений двигун внутрішнього згоряння",
          "ko": "고급 연소기관",
          "zh": "高级内燃机",
          "ja": "高度な内燃機関"
        },
        {
          "id": "Arrow",
          "en": "Arrow",
          "fr": "Flèche",
          "es": "Flecha",
          "de": "Pfeil",
          "pt": "Flecha",
          "it": "Freccia",
          "tr": "Ok",
          "pl": "Strzała",
          "ru": "Стрела",
          "uk": "Стріла",
          "ko": "화살",
          "zh": "箭",
          "ja": "矢"
        },
        {
          "id": "Barrel",
          "en": "Barrel",
          "fr": "Baril",
          "es": "Barril",
          "de": "Fass",
          "pt": "Barril",
          "it": "Barile",
          "tr": "Varil",
          "pl": "Beczka",
          "ru": "Бочка",
          "uk": "Діжка",
          "ko": "배럴통",
          "zh": "桶",
          "ja": "ドラム缶"
        },
        {
          "id": "Biodiesel",
          "en": "Biodiesel",
          "fr": "Bio-gazole",
          "es": "Biodiésel",
          "de": "Biodiesel",
          "pt": "Biodiesel",
          "it": "Biodiesel",
          "tr": "Biyodizel",
          "pl": "Biodisel",
          "ru": "Биодизель",
          "uk": "Біодизель",
          "ko": "바이오디젤",
          "zh": "生物柴油",
          "ja": "バイオディーゼル"
        },
        {
          "id": "Board",
          "en": "Board",
          "fr": "Planche",
          "es": "Tabla",
          "de": "Bretter",
          "pt": "Tábua",
          "it": "Tavola",
          "tr": "Tahta",
          "pl": "Deska",
          "ru": "Доска",
          "uk": "Дошка",
          "ko": "판자",
          "zh": "木板",
          "ja": "板"
        },
        {
          "id": "Brick",
          "en": "Brick",
          "fr": "Brique",
          "es": "Ladrillo",
          "de": "Ziegel aus Lehm",
          "pt": "Tijolo",
          "it": "Mattone",
          "tr": "Tuğla",
          "pl": "Cegła",
          "ru": "Кирпич",
          "uk": "Цегла",
          "ko": "벽돌",
          "zh": "砖块",
          "ja": "レンガ"
        },
        {
          "id": "Lumber",
          "en": "Lumber",
          "fr": "Bois d\u0027œuvre",
          "es": "Maderas",
          "de": "Bauholz",
          "pt": "Madeira serrada",
          "it": "Legname",
          "tr": "Kereste",
          "pl": "Tarcica",
          "ru": "Пиломатериал",
          "uk": "Пиломатеріали",
          "ko": "가공된 목재",
          "zh": "板材",
          "ja": "製材"
        },
        {
          "id": "Charcoal",
          "en": "Charcoal",
          "fr": "Charbon de bois",
          "es": "Carbón vegetal",
          "de": "Holzkohle",
          "pt": "Carvão Vegetal",
          "it": "Carbone Vegetale",
          "tr": "Odun Kömürü",
          "pl": "Węgiel drzewny",
          "ru": "Древесный уголь",
          "uk": "Вугілля з деревини",
          "ko": "숯",
          "zh": "木炭",
          "ja": "木炭"
        },
        {
          "id": "Substrate",
          "en": "Substrate",
          "fr": "Substrat",
          "es": "Oblea",
          "de": "Substrat",
          "pt": "Substrato",
          "it": "Substrato",
          "tr": "Alt Katman",
          "pl": "Płytka podkładowa",
          "ru": "Подложка",
          "uk": "Підкладка",
          "ko": "기판",
          "zh": "基底",
          "ja": "基板"
        },
        {
          "id": "CopperWiring",
          "en": "Copper Wiring",
          "fr": "Fil de cuivre",
          "es": "Cableado de Cobre",
          "de": "Kupferkabel",
          "pt": "Fiação de Cobre",
          "it": "Cablaggio in rame",
          "tr": "Bakır Kablo",
          "pl": "Miedziane przewody",
          "ru": "Медный провод",
          "uk": "Мідний дріт",
          "ko": "구리선",
          "zh": "铜线",
          "ja": "銅線"
        },
        {
          "id": "GoldFlakes",
          "en": "Gold Flakes",
          "fr": "Paillettes d\u0027or",
          "es": "Copos de Oro",
          "de": "Blattgold",
          "pt": "Flocos de Ouro",
          "it": "Scaglie d\u0027oro",
          "tr": "Altın Pullar",
          "pl": "Płatki złota",
          "ru": "Чешуйки золота",
          "uk": "Золоті пластівці",
          "ko": "금조각",
          "zh": "金片",
          "ja": "金箔"
        },
        {
          "id": "Gearbox",
          "en": "Gearbox",
          "fr": "Boîte de vitesses",
          "es": "Caja de Cambios",
          "de": "Getriebe",
          "pt": "Caixa de Transmissão",
          "it": "Scatola del Cambio di velocità",
          "tr": "Şanzıman Kutusu",
          "pl": "Skrzynia Biegów",
          "ru": "Коробка передач",
          "uk": "Коробка передач",
          "ko": "변속 장치",
          "zh": "齿轮箱",
          "ja": "ギアボックス"
        },
        {
          "id": "CombustionEngine",
          "en": "Combustion Engine",
          "fr": "Moteur à combustion",
          "es": "Motor de Combustión",
          "de": "Verbrennungsmotor",
          "pt": "Motor de Combustão",
          "it": "Motore a combustione",
          "tr": "Yanmalı Motor",
          "pl": "Silnik spalinowy",
          "ru": "Двигатель внутреннего сгорания",
          "uk": "Двигун внутрішнього згоряння",
          "ko": "연소기관",
          "zh": "内燃机",
          "ja": "内燃機関"
        },
        {
          "id": "CopperPipe",
          "en": "Copper Pipe",
          "fr": "Tuyau en cuivre",
          "es": "Tubo de Cobre",
          "de": "Kupferrohr",
          "pt": "Tubo de cobre",
          "it": "Tubo di rame",
          "tr": "Bakır Boru",
          "pl": "Miedziana rura",
          "ru": "Медная труба",
          "uk": "Мідна труба",
          "ko": "구리 파이프",
          "zh": "铜管",
          "ja": "銅パイプ"
        },
        {
          "id": "CorrugatedSteel",
          "en": "Corrugated Steel",
          "fr": "Tôle d\u0027acier ondulée",
          "es": "Acero Corrugado",
          "de": "Wellblech",
          "pt": "Aço corrugado",
          "it": "Acciaio ondulato",
          "tr": "Oluklu Çelik",
          "pl": "Stal ryflowana",
          "ru": "Гофрированная сталь",
          "uk": "Гофрована сталь",
          "ko": "골강판",
          "zh": "波纹钢",
          "ja": "波形鋼"
        },
        {
          "id": "DirtRamp",
          "en": "Dirt Ramp",
          "fr": "Rampe en terre",
          "es": "Rampa de Tierra",
          "de": "Erdrampe",
          "pt": "Rampa de terra",
          "it": "Rampa di Terra",
          "tr": "Toprak Rampa",
          "pl": "Podjazd ziemny",
          "ru": "Земляная рампа",
          "uk": "Земляний підйом",
          "ko": "흙 경사로",
          "zh": "泥土坡道",
          "ja": "土のランプ"
        },
        {
          "id": "ElectricMotor",
          "en": "Electric Motor",
          "fr": "Moteur électrique",
          "es": "Motor Eléctrico",
          "de": "Elektromotor",
          "pt": "Motor Elétrico",
          "it": "Motore elettrico",
          "tr": "Elektrik Motoru",
          "pl": "Silnik elektryczny",
          "ru": "Электродвигатель",
          "uk": "Електродвигун",
          "ko": "전기 모터",
          "zh": "电动机",
          "ja": "電気モーター"
        },
        {
          "id": "Petroleum",
          "en": "Petroleum",
          "fr": "Pétrole",
          "es": "Petróleo",
          "de": "Petroleum",
          "pt": "Petróleo",
          "it": "Petrolio",
          "tr": "Petrol",
          "pl": "Ropa naftowa",
          "ru": "Нефть",
          "uk": "Нафта",
          "ko": "석유",
          "zh": "石油",
          "ja": "石油"
        },
        {
          "id": "Epoxy",
          "en": "Epoxy",
          "fr": "Résine époxy",
          "es": "Resina Epoxi",
          "de": "Epoxidharz",
          "pt": "Epóxi",
          "it": "Resina epossidica",
          "tr": "Tutkal",
          "pl": "Żywica epoksydowa",
          "ru": "Эпоксидная смола",
          "uk": "Епоксидна смола",
          "ko": "에폭시 수지",
          "zh": "环氧树脂",
          "ja": "エポキシ樹脂"
        },
        {
          "id": "Plastic",
          "en": "Plastic",
          "fr": "Plastique",
          "es": "Plástico",
          "de": "Kunststoff",
          "pt": "Plástico",
          "it": "Plastica",
          "tr": "Plastik",
          "pl": "Plastik",
          "ru": "Пластик",
          "uk": "Пластик",
          "ko": "플라스틱",
          "zh": "塑料",
          "ja": "プラスチック"
        },
        {
          "id": "Glass",
          "en": "Glass",
          "fr": "Verre",
          "es": "Vidrio",
          "de": "Glas",
          "pt": "Vidro",
          "it": "Vetro",
          "tr": "Cam",
          "pl": "Szkło",
          "ru": "Стекло",
          "uk": "Скло",
          "ko": "유리",
          "zh": "玻璃",
          "ja": "ガラス"
        },
        {
          "id": "Fiberglass",
          "en": "Fiberglass",
          "fr": "Fibre de verre",
          "es": "Fibra de Vidrio",
          "de": "Glasfaserverstärkter Kunststoff",
          "pt": "Fibra de Vidro",
          "it": "Fibra di vetro",
          "tr": "Fiberglas",
          "pl": "Włokno szklane",
          "ru": "Стекловолокно",
          "uk": "Скловолокно",
          "ko": "유리섬유",
          "zh": "玻璃钢",
          "ja": "ガラス繊維"
        },
        {
          "id": "FishingPole",
          "en": "Fishing Pole",
          "fr": "Canne à pêche",
          "es": "Caña de Pescar",
          "de": "Angel",
          "pt": "Vara de Pesca",
          "it": "Canna da pesca",
          "tr": "Olta Kamışı",
          "pl": "Wędka",
          "ru": "Удочка",
          "uk": "Вудка",
          "ko": "낚싯대",
          "zh": "钓鱼竿",
          "ja": "釣り竿"
        },
        {
          "id": "FlatSteel",
          "en": "Flat Steel",
          "fr": "Tôle d\u0027acier lisse",
          "es": "Acero Plano",
          "de": "Flachstahl",
          "pt": "Aço plano",
          "it": "Piatto in acciaio",
          "tr": "Yassı Çelik",
          "pl": "Blacha stalowa",
          "ru": "Листовая сталь",
          "uk": "Листова сталь",
          "ko": "평철",
          "zh": "扁钢",
          "ja": "鋼板"
        },
        {
          "id": "FramedGlass",
          "en": "Framed Glass",
          "fr": "Verre encadré",
          "es": "Vidrio Enmarcado",
          "de": "Gerahmtes Glas",
          "pt": "Vidro emoldurado",
          "it": "Vetro Incorniciato",
          "tr": "Çerçeveli Cam",
          "pl": "Szyba oprawiona",
          "ru": "Обрамлённое стекло",
          "uk": "Рамкове скло",
          "ko": "유리 창틀",
          "zh": "框式玻璃",
          "ja": "ガラスの窓枠"
        },
        {
          "id": "Gasoline",
          "en": "Gasoline",
          "fr": "Essence",
          "es": "Gasolina",
          "de": "Benzin",
          "pt": "Gasolina",
          "it": "Benzina",
          "tr": "Benzin",
          "pl": "Benzyna",
          "ru": "Бензин",
          "uk": "Бензин",
          "ko": "휘발유",
          "zh": "汽油",
          "ja": "ガソリン"
        },
        {
          "id": "HewnLog",
          "en": "Hewn Log",
          "fr": "Rondin taillé",
          "es": "Tronco tallado",
          "de": "Massivholz",
          "pt": "Madeira cortada",
          "it": "Tronco Tagliato",
          "tr": "Yontulmuş Kütük",
          "pl": "Ociosana Kłoda",
          "ru": "Тёсаное бревно",
          "uk": "Обтесана колода",
          "ko": "다듬은 통나무",
          "zh": "粗凿原木",
          "ja": "丸太材"
        },
        {
          "id": "IronPipe",
          "en": "Iron Pipe",
          "fr": "Tuyau en fer",
          "es": "Tuberia de Hierro",
          "de": "Eisenrohr",
          "pt": "Tubo de ferro",
          "it": "Tubo di ferro",
          "tr": "Demir Boru",
          "pl": "Żelazna rura",
          "ru": "Железная труба",
          "uk": "Залізна труба",
          "ko": "쇠 파이프",
          "zh": "铁管",
          "ja": "鉄パイプ"
        },
        {
          "id": "MortaredStone",
          "en": "Mortared Stone",
          "fr": "Pierre cimentée",
          "es": "Piedra con mortero",
          "de": "Ziegel aus Stein",
          "pt": "Pedra argamassada",
          "it": "Mortaio in Pietra",
          "tr": "Harçlı Taş",
          "pl": "Spojony zaprawą kamień",
          "ru": "Строительный камень",
          "uk": "Будівельне каміння",
          "ko": "모르타르 마감 석재",
          "zh": "浆砌石",
          "ja": "モルタルストーン"
        },
        {
          "id": "Paper",
          "en": "Paper",
          "fr": "Papier",
          "es": "Papel",
          "de": "Papier",
          "pt": "Papel",
          "it": "Carta",
          "tr": "Kağıt",
          "pl": "Papier",
          "ru": "Бумага",
          "uk": "Папір",
          "ko": "종이",
          "zh": "纸",
          "ja": "紙"
        },
        {
          "id": "Rebar",
          "en": "Rebar",
          "fr": "Barre d\u0027armature",
          "es": "Barra corrugada",
          "de": "Bewehrungsstahl",
          "pt": "Vergalhão",
          "it": "Tondo per cemento armato",
          "tr": "Ribar",
          "pl": "Zbrojenie",
          "ru": "Арматура",
          "uk": "Арматура",
          "ko": "철근",
          "zh": "钢筋",
          "ja": "鉄筋"
        },
        {
          "id": "ReinforcedConcrete",
          "en": "Reinforced Concrete",
          "fr": "Béton armé",
          "es": "Hormigón reforzado",
          "de": "Stahlbeton",
          "pt": "Concreto reforçado",
          "it": "Cemento armato",
          "tr": "Güçlendirilmiş Beton",
          "pl": "Beton zbrojony",
          "ru": "Железобетон",
          "uk": "Вироби залізобетонні",
          "ko": "철근 콘크리트",
          "zh": "钢筋混凝土",
          "ja": "鉄筋コンクリート"
        },
        {
          "id": "Rivet",
          "en": "Rivet",
          "fr": "Rivet",
          "es": "Remache",
          "de": "Niete",
          "pt": "Rebite",
          "it": "Rivetto",
          "tr": "Perçin",
          "pl": "Nit",
          "ru": "Заклёпка",
          "uk": "Заклепка",
          "ko": "대갈못",
          "zh": "铆钉",
          "ja": "鋲"
        },
        {
          "id": "SoilSampler",
          "en": "Soil Sampler",
          "fr": "Analyseur de sol",
          "es": "Muestreador de suelo",
          "de": "Bodenprüfer",
          "pt": "Amostrador de Solo",
          "it": "Campionatore di terreno",
          "tr": "Zemin Örneği Toplayıcı",
          "pl": "Próbnik Gleby",
          "ru": "Анализатор почвы",
          "uk": "Аналізатор ґрунту",
          "ko": "토양 채취기",
          "zh": "土壤取样器",
          "ja": "ソイルサンプラー"
        },
        {
          "id": "SteelPipe",
          "en": "Steel Pipe",
          "fr": "Tuyau en acier",
          "es": "Tubo de Acero",
          "de": "Stahlrohr",
          "pt": "Tubo de aço",
          "it": "Tubo d\u0027acciaio",
          "tr": "Çelik Boru",
          "pl": "Stalowa Rura",
          "ru": "Стальная труба",
          "uk": "Сталева труба",
          "ko": "강철 파이프",
          "zh": "钢管",
          "ja": "鋼パイプ"
        },
        {
          "id": "StoneRoad",
          "en": "Stone Road",
          "fr": "Route pavée",
          "es": "Camino de Piedra",
          "de": "Steinstraße",
          "pt": "Estrada de pedra",
          "it": "Strada di pietra",
          "tr": "Taş Yol",
          "pl": "Kamienna droga",
          "ru": "Каменная дорога",
          "uk": "Кам’яна дорога",
          "ko": "돌 길",
          "zh": "石质道路",
          "ja": "石の道路"
        },
        {
          "id": "Torch",
          "en": "Torch",
          "fr": "Torche",
          "es": "Antorcha",
          "de": "Fackel",
          "pt": "Tocha",
          "it": "Torcia",
          "tr": "Meşale",
          "pl": "Pochodnia",
          "ru": "Факел",
          "uk": "Факел",
          "ko": "횃불",
          "zh": "火把",
          "ja": "松明"
        },
        {
          "id": "Waterwheel",
          "en": "Waterwheel",
          "fr": "Moulin à eau",
          "es": "Molino de agua",
          "de": "Wasserrad",
          "pt": "Roda D\u0027água",
          "it": "Ruota idrica",
          "tr": "Su Çarkı",
          "pl": "Koło Wodne",
          "ru": "Водяное колесо",
          "uk": "Водяне колесо",
          "ko": "물레방아",
          "zh": "水车",
          "ja": "水車"
        },
        {
          "id": "Anvil",
          "en": "Anvil",
          "fr": "Enclume",
          "es": "Yunque",
          "de": "Amboss",
          "pt": "Bigorna",
          "it": "Incudine",
          "tr": "Örs",
          "pl": "Kowadło",
          "ru": "Наковальня",
          "uk": "Ковадло",
          "ko": "모루",
          "zh": "铁砧",
          "ja": "金床"
        },
        {
          "id": "BakeryOven",
          "en": "Bakery Oven",
          "fr": "Four à pain",
          "es": "Horno de Panadería",
          "de": "Bäckereiofen",
          "pt": "Forno de Padaria",
          "it": "Forno per panetteria",
          "tr": "Ekmek Fırını",
          "pl": "Piec piekarniczy",
          "ru": "Печь для выпечки",
          "uk": "Піч для випічки",
          "ko": "제빵 화덕",
          "zh": "烤炉",
          "ja": "ベーカリーオーブン"
        },
        {
          "id": "BlastFurnace",
          "en": "Blast Furnace",
          "fr": "Haut fourneau",
          "es": "Alto Horno",
          "de": "Hochofen",
          "pt": "Alto-forno",
          "it": "Altoforno",
          "tr": "Maden Eritme Ocağı",
          "pl": "Piec hutniczy",
          "ru": "Доменная печь",
          "uk": "Домна",
          "ko": "용광로",
          "zh": "高炉",
          "ja": "高炉"
        },
        {
          "id": "Bloomery",
          "en": "Bloomery",
          "fr": "Bas fourneau",
          "es": "Horno de fundición",
          "de": "Schmelzofen",
          "pt": "Forja catalã",
          "it": "Forno per Metalli",
          "tr": "Demirci Ocağı",
          "pl": "Dymarka",
          "ru": "Сыродутная печь",
          "uk": "Сиродутне горно",
          "ko": "괴철로",
          "zh": "锻铁炉",
          "ja": "塊鉄炉"
        },
        {
          "id": "Bookshelf",
          "en": "Bookshelf",
          "fr": "Bibliothèque",
          "es": "Librería",
          "de": "Bücherregal",
          "pt": "Estante de Livro",
          "it": "Scaffale dei libri",
          "tr": "Kitaplık",
          "pl": "Biblioteczka",
          "ru": "Книжный шкаф",
          "uk": "Книжкова полиця",
          "ko": "책장",
          "zh": "书架",
          "ja": "本棚"
        },
        {
          "id": "Brazier",
          "en": "Brazier",
          "fr": "Brasero en fer",
          "es": "Bracero",
          "de": "Feuerschale",
          "pt": "Braseiro",
          "it": "Braciere",
          "tr": "Mangal",
          "pl": "Koksownik",
          "ru": "Жаровня",
          "uk": "Жаровня",
          "ko": "화로",
          "zh": "火盆",
          "ja": "火鉢"
        },
        {
          "id": "ButcheryTable",
          "en": "Butchery Table",
          "fr": "Table de boucherie",
          "es": "Mesa de carnicería",
          "de": "Metzgertisch",
          "pt": "Mesa de Açougue",
          "it": "Tavolo da Macellaio",
          "tr": "Kasap Tezgahı",
          "pl": "Stół rzeźnicki",
          "ru": "Разделочный стол",
          "uk": "Різницький стіл",
          "ko": "도축 작업대",
          "zh": "肉加工工作台",
          "ja": "食肉加工台"
        },
        {
          "id": "Campfire",
          "en": "Campfire",
          "fr": "Feu de camp",
          "es": "Fogata",
          "de": "Lagerfeuer",
          "pt": "Fogueira",
          "it": "Falò",
          "tr": "Kamp Ateşi",
          "pl": "Ognisko",
          "ru": "Костёр",
          "uk": "Багаття",
          "ko": "모닥불",
          "zh": "篝火",
          "ja": "焚き火"
        },
        {
          "id": "CandleStand",
          "en": "Candle Stand",
          "fr": "Bougeoir",
          "es": "Soporte de Vela",
          "de": "Kerzenständer",
          "pt": "Suporte de Vela",
          "it": "Supporto per candele",
          "tr": "Mum Tutucu",
          "pl": "Stojak na świecę",
          "ru": "Подсвечник",
          "uk": "Підсвічник",
          "ko": "촛대",
          "zh": "烛台",
          "ja": "ろうそく立て"
        },
        {
          "id": "CarpentryTable",
          "en": "Carpentry Table",
          "fr": "Établi de menuiserie",
          "es": "Mesa de carpintería",
          "de": "Zimmermanntisch",
          "pt": "Mesa de carpintaria",
          "it": "Tavolo da carpentiere",
          "tr": "Marangoz Masası",
          "pl": "Stół Stolarski",
          "ru": "Плотницкий верстак",
          "uk": "Стіл теслі",
          "ko": "목공 작업대",
          "zh": "木工工作台",
          "ja": "木工作業台"
        },
        {
          "id": "CastIronStove",
          "en": "Cast Iron Stove",
          "fr": "Poêle en fonte",
          "es": "Estufa de hierro fundido",
          "de": "Gusseiserner Ofen",
          "pt": "Fogão de Ferro Fundido",
          "it": "Stufa in ghisa",
          "tr": "Dökme Demir Ocak",
          "pl": "Żeliwna kuchnia",
          "ru": "Чугунная плита",
          "uk": "Чавунна піч",
          "ko": "철재 화덕",
          "zh": "铸铁火炉",
          "ja": "鋳鉄のストーブ"
        },
        {
          "id": "CeilingCandle",
          "en": "Ceiling Candle",
          "fr": "Lustre à monture en fer",
          "es": "Vela de Techo",
          "de": "Deckenlampe",
          "pt": "Vela de Teto",
          "it": "Candela da Soffitto",
          "tr": "Tavan Mumu",
          "pl": "Kandelabr",
          "ru": "Люстра со свечами",
          "uk": "Люстра зі свічками",
          "ko": "천장 촛대",
          "zh": "吊式烛灯",
          "ja": "吊り下げろうそく"
        },
        {
          "id": "CementKiln",
          "en": "Cement Kiln",
          "fr": "Four à ciment",
          "es": "Horno de Cemento",
          "de": "Zementbrennofen",
          "pt": "Forno de cimento",
          "it": "Forno da cemento",
          "tr": "Çimento Fırını",
          "pl": "Cementownia",
          "ru": "Барабанная печь",
          "uk": "Піч для цементу",
          "ko": "시멘트 가마",
          "zh": "水泥窑",
          "ja": "セメントのかまど"
        },
        {
          "id": "CombustionGenerator",
          "en": "Combustion Generator",
          "fr": "Générateur électrique à combustion",
          "es": "Generador de Combustión",
          "de": "Verbrennungsgenerator",
          "pt": "Gerador a Combustão",
          "it": "Generatore a combustione",
          "tr": "Yanmalı Jeneratör",
          "pl": "Generator Spalinowy",
          "ru": "Генератор внутреннего сгорания",
          "uk": "Генератор внутрішнього згоряння",
          "ko": "연소 발전기",
          "zh": "内燃发电机",
          "ja": "火力発電機"
        },
        {
          "id": "ComputerLab",
          "en": "Computer Lab",
          "fr": "Ordinateur de contrôle",
          "es": "Laboratorio de Computación",
          "de": "Computerlabor",
          "pt": "Laboratório de Computação",
          "it": "Laboratorio informatico",
          "tr": "Bilgisayar Lab",
          "pl": "Laboratorium komputerowe",
          "ru": "Компьютерная лаборатория",
          "uk": "Комп’ютерна лабораторія",
          "ko": "컴퓨터 연구대",
          "zh": "实验室电脑",
          "ja": "コンピューター・ラボ"
        },
        {
          "id": "ConstructionPost",
          "en": "Construction Post",
          "fr": "Piquet de construction",
          "es": "Poste de Construcción",
          "de": "Baupfosten",
          "pt": "Posto de Construção",
          "it": "Paletto per Costruzione",
          "tr": "İnşaat Binası",
          "pl": "Stanowisko Budowlane",
          "ru": "Строительный знак",
          "uk": "Будівельний знак",
          "ko": "건설계약 기둥",
          "zh": "建筑标识",
          "ja": "建設標識"
        },
        {
          "id": "ContractBoard",
          "en": "Contract Board",
          "fr": "Tableau de contrats",
          "es": "Tablero de Contratos",
          "de": "Anschlagbrett",
          "pt": "Quadro de contrato",
          "it": "Tabellone dei Contratti",
          "tr": "Kontrat Panosu",
          "pl": "Tablica Zleceń",
          "ru": "Доска объявлений",
          "uk": "Дошка договорів",
          "ko": "계약 게시판",
          "zh": "合同公告板",
          "ja": "契約掲示板"
        },
        {
          "id": "Couch",
          "en": "Couch",
          "fr": "Canapé",
          "es": "Sofá",
          "de": "Sofa",
          "pt": "Sofá",
          "it": "Divano",
          "tr": "Kanepe",
          "pl": "Kanapa",
          "ru": "Диван",
          "uk": "Диван",
          "ko": "소파",
          "zh": "沙发",
          "ja": "ソファ"
        },
        {
          "id": "CurrencyExchange",
          "en": "Currency Exchange",
          "fr": "Bureau de change",
          "es": "Cambio de Divisas",
          "de": "Wechselstube",
          "pt": "Casa de câmbio",
          "it": "Cambio Valuta",
          "tr": "Para Birimi Değişimi",
          "pl": "Wymiana walut",
          "ru": "Пункт обмена валюты",
          "uk": "Обмін валют",
          "ko": "환전소",
          "zh": "货币兑换",
          "ja": "両替機"
        },
        {
          "id": "ElectricWallLamp",
          "en": "Electric Wall Lamp",
          "fr": "Lampe murale électrique",
          "es": "Lámpara de Pared Eléctrica",
          "de": "Elektrische Wandleuchte",
          "pt": "Lâmpada Elétrica de Parede",
          "it": "Lampada da Muro Elettrica",
          "tr": "Elektrikli Duvar Lambası",
          "pl": "Elektryczna lampa ścienna",
          "ru": "Электрическая настенная лампа",
          "uk": "Електричний настінний світильник",
          "ko": "벽걸이형 전등",
          "zh": "电壁灯",
          "ja": "壁掛け電灯"
        },
        {
          "id": "ElectronicsAssembly",
          "en": "Electronics Assembly",
          "fr": "Établi d\u0027assemblage électronique",
          "es": "Sección de ensamblaje electrónico",
          "de": "Elektronikfertigung",
          "pt": "Montagem eletrônica",
          "it": "Assemblaggi elettronici",
          "tr": "Elektronik Montaj",
          "pl": "Montaż Elektroniki",
          "ru": "Сборщик электроники",
          "uk": "Збирач електроніки",
          "ko": "전자 공학 작업대",
          "zh": "电子装配套装",
          "ja": "電子機器組立機"
        },
        {
          "id": "FarmersTable",
          "en": "Farmers Table",
          "fr": "Atelier d\u0027agriculture",
          "es": "Mesa de Agricultor",
          "de": "Landwirttisch",
          "pt": "Mesa de agricultor",
          "it": "Tavolo da Contadino",
          "tr": "Çiftçi Masası",
          "pl": "Stół rolniczy",
          "ru": "Фермерский стол",
          "uk": "Фермерський стіл",
          "ko": "농업 작업대",
          "zh": "农业工作台",
          "ja": "園芸作業台"
        },
        {
          "id": "Fishery",
          "en": "Fishery",
          "fr": "Atelier de pêche",
          "es": "Pesquería",
          "de": "Fischereitisch",
          "pt": "Mesa de pesca",
          "it": "Tavolo da Pescatore",
          "tr": "Balıkçılık",
          "pl": "Rybołóstwo",
          "ru": "Шкаф рыбака",
          "uk": "Шафка рибалки",
          "ko": "어업 작업대",
          "zh": "渔具",
          "ja": "釣り具作業台"
        },
        {
          "id": "FishTrap",
          "en": "Fish Trap",
          "fr": "Nasse à poissons",
          "es": "Trampa para Peces",
          "de": "Reuse",
          "pt": "Armadilha de Pesca",
          "it": "Trappola per pesci",
          "tr": "Balık Tuzağı",
          "pl": "Samołówka",
          "ru": "Верша",
          "uk": "Рибна пастка",
          "ko": "통발",
          "zh": "捕鱼器",
          "ja": "梁(やな）"
        },
        {
          "id": "Icebox",
          "en": "Icebox",
          "fr": "Glacière",
          "es": "Nevera",
          "de": "Eisschrank",
          "pt": "Caixa de Gelo",
          "it": "Ghiacciaia",
          "tr": "Soğutucu",
          "pl": "Lodówka",
          "ru": "Ледник",
          "uk": "Льодовник",
          "ko": "아이스 박스",
          "zh": "冷藏箱",
          "ja": "アイスボックス"
        },
        {
          "id": "Kiln",
          "en": "Kiln",
          "fr": "Four à céramique",
          "es": "Horno",
          "de": "Brennofen",
          "pt": "Forno",
          "it": "Forno",
          "tr": "Fırın",
          "pl": "Piec do Wypalania",
          "ru": "Печь для обжига",
          "uk": "Промислова піч",
          "ko": "가마",
          "zh": "窑",
          "ja": "かまど"
        },
        {
          "id": "Laboratory",
          "en": "Laboratory",
          "fr": "Laboratoire",
          "es": "Laboratorio",
          "de": "Laboratorium",
          "pt": "Laboratório",
          "it": "Laboratorio",
          "tr": "Laboratuvar",
          "pl": "Laboratorium",
          "ru": "Лаборатория",
          "uk": "Лабораторія",
          "ko": "연구대",
          "zh": "实验室",
          "ja": "研究所"
        },
        {
          "id": "Laser",
          "en": "Laser",
          "fr": "Laser",
          "es": "Láser",
          "de": "Laser",
          "pt": "Laser",
          "it": "Laser",
          "tr": "Lazer",
          "pl": "Laser",
          "ru": "Лазер",
          "uk": "Лазер",
          "ko": "레이저",
          "zh": "激光",
          "ja": "レーザー"
        },
        {
          "id": "WoodenLatrine",
          "en": "Wooden Latrine",
          "fr": "Latrines en bois",
          "es": "Letrina de madera",
          "de": "Holzlatrine",
          "pt": "Latrina de Madeira",
          "it": "Latrina in Legno",
          "tr": "Ahşap Tuvalet",
          "pl": "Drewniana Latryna",
          "ru": "Деревянный туалет",
          "uk": "Дерев’яний туалет",
          "ko": "나무 변소",
          "zh": "木质马桶",
          "ja": "木製トイレ"
        },
        {
          "id": "MasonryTable",
          "en": "Masonry Table",
          "fr": "Établi de maçonnerie",
          "es": "Mesa de mampostería",
          "de": "Steinmetztisch",
          "pt": "Mesa de alvenaria",
          "it": "Tavolo da Muratore",
          "tr": "Duvarcılık Masası",
          "pl": "Stół murarski",
          "ru": "Верстак каменщика",
          "uk": "Каменярський стіл",
          "ko": "석조 작업대",
          "zh": "石匠工作台",
          "ja": "石工作業台"
        },
        {
          "id": "Mill",
          "en": "Mill",
          "fr": "Meule",
          "es": "Molino",
          "de": "Mahlwerk",
          "pt": "Moedor",
          "it": "Mulino",
          "tr": "Değirmen",
          "pl": "Młyn",
          "ru": "Мельница",
          "uk": "Млин",
          "ko": "맷돌",
          "zh": "磨坊",
          "ja": "製粉機"
        },
        {
          "id": "Mint",
          "en": "Mint",
          "fr": "Hôtel de la monnaie",
          "es": "Ceca",
          "de": "Münzprägemaschine",
          "pt": "Prensa de cunhagem",
          "it": "Zecca",
          "tr": "Darphane",
          "pl": "Mennica",
          "ru": "Пресс для чеканки монет",
          "uk": "Карбувальний верстат",
          "ko": "조폐기",
          "zh": "铸币厂",
          "ja": "造幣機"
        },
        {
          "id": "OilRefinery",
          "en": "Oil Refinery",
          "fr": "Raffinerie de pétrole",
          "es": "Refinería de Petróleo",
          "de": "Raffinerie",
          "pt": "Refinaria de petróleo",
          "it": "Raffineria di petrolio",
          "tr": "Petrol Rafinerisi",
          "pl": "Rafineria",
          "ru": "Нефтеперерабатывающий завод",
          "uk": "Нафтопереробний завод",
          "ko": "정유소",
          "zh": "炼油厂",
          "ja": "石油精製所"
        },
        {
          "id": "PaddedChair",
          "en": "Padded Chair",
          "fr": "Fauteuil",
          "es": "Silla Acolchada",
          "de": "Gepolsterter Stuhl",
          "pt": "Poltrona Acolchoada",
          "it": "Sedia imbottita",
          "tr": "Yastıklı Sandalye",
          "pl": "Fotel tapicerowany",
          "ru": "Кресло",
          "uk": "М’яке крісло",
          "ko": "안락의자",
          "zh": "软垫椅",
          "ja": "パッド入りの椅子"
        },
        {
          "id": "RoundPot",
          "en": "Round Pot",
          "fr": "Pot rond",
          "es": "Maceta Redonda",
          "de": "Blumentopf (rund)",
          "pt": "Vaso Redondo",
          "it": "Vaso rotondo",
          "tr": "Yuvarlak Çömlek",
          "pl": "Okrągłą donica",
          "ru": "Круглый горшок",
          "uk": "Круглий горщик",
          "ko": "둥근 화분",
          "zh": "圆盆",
          "ja": "丸い植木鉢"
        },
        {
          "id": "SquarePot",
          "en": "Square Pot",
          "fr": "Pot carré",
          "es": "Maceta Cuadrada",
          "de": "Blumentopf (quadratisch)",
          "pt": "Vaso Quadrado",
          "it": "Vaso quadrato",
          "tr": "Kare Çömlek",
          "pl": "Kwadratowa donica",
          "ru": "Квадратный горшок",
          "uk": "Квадратний горщик",
          "ko": "각진 화분",
          "zh": "方盆",
          "ja": "四角い植木鉢"
        },
        {
          "id": "PumpJack",
          "en": "Pump Jack",
          "fr": "Chevalet de pompage",
          "es": "Unidad de Bombeo",
          "de": "Ölbohrturm",
          "pt": "Bomba petrolífera",
          "it": "Pompa Petrolifera",
          "tr": "Atbaşı Pompa",
          "pl": "Kiwak",
          "ru": "Нефтяная вышка",
          "uk": "Нафтовий насос",
          "ko": "석유 시추기",
          "zh": "油压机",
          "ja": "ポンプジャッキ"
        },
        {
          "id": "Refrigerator",
          "en": "Refrigerator",
          "fr": "Réfrigérateur",
          "es": "Refrigerador",
          "de": "Kühlschrank",
          "pt": "Refrigerador",
          "it": "Frigorifero",
          "tr": "Buzdolabı",
          "pl": "Lodówka",
          "ru": "Холодильник",
          "uk": "Холодильник",
          "ko": "냉장고",
          "zh": "冰箱",
          "ja": "冷蔵庫"
        },
        {
          "id": "ResearchTable",
          "en": "Research Table",
          "fr": "Table de recherche",
          "es": "Mesa de investigación",
          "de": "Forschungstisch",
          "pt": "Mesa de pesquisa",
          "it": "Tabella di ricerca",
          "tr": "Araştırma Masası",
          "pl": "Stół badawczy",
          "ru": "Стол для исследований",
          "uk": "Дослідницький стіл",
          "ko": "연구 작업대",
          "zh": "研究工作台",
          "ja": "リサーチテーブル"
        },
        {
          "id": "RollingMill",
          "en": "Rolling Mill",
          "fr": "Laminoir",
          "es": "Molino de laminado",
          "de": "Walzwerk",
          "pt": "Rolo de laminação",
          "it": "Laminatoio",
          "tr": "Hadde Makinesi",
          "pl": "Walcownia",
          "ru": "Прокатный стан",
          "uk": "Стан прокатний",
          "ko": "압연기",
          "zh": "轧机",
          "ja": "圧延機"
        },
        {
          "id": "SaltBasket",
          "en": "Salt Basket",
          "fr": "Panier de sel",
          "es": "Cesta de Sal",
          "de": "Salzkorb",
          "pt": "Cesta de Sal",
          "it": "Cesto di sale",
          "tr": "Tuz Sepeti",
          "pl": "Kosz Soli",
          "ru": "Корзина с солью",
          "uk": "Кошик солі",
          "ko": "소금 바구니",
          "zh": "盐篓",
          "ja": "カゴに入った塩"
        },
        {
          "id": "Sawmill",
          "en": "Sawmill",
          "fr": "Scierie",
          "es": "Aserradero",
          "de": "Sägewerk",
          "pt": "Serraria",
          "it": "Segheria",
          "tr": "Bıçkıhane",
          "pl": "Tartak",
          "ru": "Лесопилка",
          "uk": "Лісопилка",
          "ko": "제재대",
          "zh": "锯木台",
          "ja": "製材機"
        },
        {
          "id": "ShelfCabinet",
          "en": "Shelf Cabinet",
          "fr": "Étagères",
          "es": "Armario",
          "de": "Regalschrank",
          "pt": "Armário com Prateleira",
          "it": "Scaffale",
          "tr": "Raflı Dolap",
          "pl": "Szafa z półkami",
          "ru": "Сервант",
          "uk": "Сервант",
          "ko": "선반 보관장",
          "zh": "柜架",
          "ja": "飾りつけた棚"
        },
        {
          "id": "SolarGenerator",
          "en": "Solar Generator",
          "fr": "Générateur électrique solaire",
          "es": "Generador Solar",
          "de": "Solargenerator",
          "pt": "Gerador Solar",
          "it": "Generatore Solare",
          "tr": "Güneş Jeneratörü",
          "pl": "Generator słoneczny",
          "ru": "Солнечный генератор",
          "uk": "Сонячний генератор",
          "ko": "태양열 발전기",
          "zh": "太阳能发电机",
          "ja": "太陽光発電機"
        },
        {
          "id": "Stockpile",
          "en": "Stockpile",
          "fr": "Réserve",
          "es": "Pila de almacenamiento",
          "de": "Lager (Groß)",
          "pt": "Estoque em pilha",
          "it": "Scorta",
          "tr": "Stok Yeri",
          "pl": "Skład",
          "ru": "Склад",
          "uk": "Комора",
          "ko": "자재 창고",
          "zh": "料堆",
          "ja": "ストックパイル"
        },
        {
          "id": "StoneBrazier",
          "en": "Stone Brazier",
          "fr": "Brasero en pierre",
          "es": "Brasero de piedra",
          "de": "Feuerschale aus Stein",
          "pt": "Braseiro de Pedra",
          "it": "Braciere in pietra",
          "tr": "Taş Mangal",
          "pl": "Kamienny koksownik",
          "ru": "Каменная жаровня",
          "uk": "Кам’яна жаровня",
          "ko": "돌 화로",
          "zh": "石火盆",
          "ja": "石火鉢"
        },
        {
          "id": "StorageChest",
          "en": "Storage Chest",
          "fr": "Coffre",
          "es": "Cofre de almacenamiento",
          "de": "Truhe",
          "pt": "Baú de armazenamento",
          "it": "Cassa",
          "tr": "Eşya sandığı",
          "pl": "Skrzynia",
          "ru": "Сундук",
          "uk": "Скриня",
          "ko": "인벤토리",
          "zh": "储物箱",
          "ja": "ストレージチェスト"
        },
        {
          "id": "Stove",
          "en": "Stove",
          "fr": "Cuisinière",
          "es": "Estufa",
          "de": "Herd",
          "pt": "Fogão",
          "it": "Stufa",
          "tr": "Ocak",
          "pl": "Kuchnia",
          "ru": "Плита",
          "uk": "Плита",
          "ko": "화덕",
          "zh": "火炉",
          "ja": "ストーブ"
        },
        {
          "id": "Streetlamp",
          "en": "Streetlamp",
          "fr": "Réverbère",
          "es": "Farola",
          "de": "Straßenlaterne",
          "pt": "Lâmpada de Rua",
          "it": "Lampione",
          "tr": "Sokak Lambası",
          "pl": "Lampa uliczna",
          "ru": "Уличный фонарь",
          "uk": "Вуличний ліхтар",
          "ko": "가로등",
          "zh": "街灯",
          "ja": "街灯"
        },
        {
          "id": "TailoringTable",
          "en": "Tailoring Table",
          "fr": "Atelier de couture",
          "es": "Mesa de sastrería",
          "de": "Schneidertisch",
          "pt": "Mesa de alfaiataria",
          "it": "Tavolo da Sarto",
          "tr": "Terzi Masası",
          "pl": "Stacja Krawiecka",
          "ru": "Стол портного",
          "uk": "Кравецький стіл",
          "ko": "재단 작업대",
          "zh": "裁缝工作台",
          "ja": "裁縫作業台"
        },
        {
          "id": "TallowCandle",
          "en": "Tallow Candle",
          "fr": "Bougie en suif",
          "es": "Vela de sebo",
          "de": "Talgkerze",
          "pt": "Vela de Sebo",
          "it": "Candela di sego",
          "tr": "Don Yağı Mumu",
          "pl": "Świeca łojowa",
          "ru": "Сальная свеча",
          "uk": "Сальна свічка",
          "ko": "수지 양초",
          "zh": "油脂蜡烛",
          "ja": "獣脂ろうそく"
        },
        {
          "id": "TallowLamp",
          "en": "Tallow Lamp",
          "fr": "Lampe à suif",
          "es": "Lámpara de Sebo",
          "de": "Talglampe",
          "pt": "Lâmpada de Sebo",
          "it": "Lampada a sego",
          "tr": "Don Yağı Lambası",
          "pl": "Lampa łojowa",
          "ru": "Сальная лампа",
          "uk": "Сальний світильник",
          "ko": "수지 등",
          "zh": "油脂灯",
          "ja": "獣脂ランプ"
        },
        {
          "id": "TallowWallLamp",
          "en": "Tallow Wall Lamp",
          "fr": "Lampe à suif murale",
          "es": "Lámpara de Pared de Sebo",
          "de": "Talgwandlampe",
          "pt": "Lâmpada de Parede de Sebo",
          "it": "Lampada a Sego da Muro",
          "tr": "Don Yağı Duvar Lambası",
          "pl": "Ścienna Lampa Łojowa",
          "ru": "Настенная сальная лампа",
          "uk": "Сальний настінний світильник",
          "ko": "벽걸이형 수지 등",
          "zh": "油脂壁灯",
          "ja": "壁掛け獣脂ろうそく"
        },
        {
          "id": "TorchStand",
          "en": "Torch Stand",
          "fr": "Support de torche",
          "es": "Soporte de antorcha",
          "de": "Fackelhalter",
          "pt": "Suporte para Tocha",
          "it": "Supporto per Torce",
          "tr": "Meşale Standı",
          "pl": "Stojak na pochodnię",
          "ru": "Стойка для факела",
          "uk": "Факельна стійка",
          "ko": "횃불 받침대",
          "zh": "火把架",
          "ja": "松明スタンド"
        },
        {
          "id": "Treasury",
          "en": "Treasury",
          "fr": "Trésor public",
          "es": "Tesorería",
          "de": "Steuertresor",
          "pt": "Tesouraria",
          "it": "Tesoreria",
          "tr": "Hazine",
          "pl": "Skarbiec",
          "ru": "Казна",
          "uk": "Скарбниця",
          "ko": "정부 금고",
          "zh": "金库",
          "ja": "金庫"
        },
        {
          "id": "WainwrightTable",
          "en": "Wainwright Table",
          "fr": "Établi d\u0027ingénierie routière",
          "es": "Mesa de carretero",
          "de": "Wagenmachertisch",
          "pt": "Mesa reta",
          "it": "Tavolo dei Trasporti",
          "tr": "Vagon Tamircisi Masası",
          "pl": "Stół Powoźniczy",
          "ru": "Верстак колесника",
          "uk": "Стіл стельмаха",
          "ko": "짐수레 작업대",
          "zh": "车匠工作台",
          "ja": "荷車作業台"
        },
        {
          "id": "WallCandle",
          "en": "Wall Candle",
          "fr": "Bougeoir mural",
          "es": "Vela de Pared",
          "de": "Wandkerze",
          "pt": "Vela de Parede",
          "it": "Candela da Muro",
          "tr": "Duvar Mumu",
          "pl": "Świeca ścienna",
          "ru": "Настенная свеча",
          "uk": "Настінна свічка",
          "ko": "벽걸이형 양초",
          "zh": "挂壁烛灯",
          "ja": "壁掛けろうそく"
        },
        {
          "id": "Washboard",
          "en": "Washboard",
          "fr": "Planche à laver",
          "es": "Lavadero",
          "de": "Waschbrett",
          "pt": "Tábua de Lavar",
          "it": "Asse per lavare",
          "tr": "Yıkama Tahtası",
          "pl": "Tara",
          "ru": "Стиральная доска",
          "uk": "Пральна дошка",
          "ko": "빨래판",
          "zh": "搓衣板",
          "ja": "洗濯板"
        },
        {
          "id": "WashingMachine",
          "en": "Washing Machine",
          "fr": "Machine à laver",
          "es": "Lavadora",
          "de": "Waschmaschine",
          "pt": "Máquina de Lavar",
          "it": "Lavatrice",
          "tr": "Çamaşır Makinesi",
          "pl": "Pralka",
          "ru": "Стиральная машина",
          "uk": "Пральна машина",
          "ko": "세탁기",
          "zh": "洗衣机",
          "ja": "洗濯機"
        },
        {
          "id": "Windmill",
          "en": "Windmill",
          "fr": "Moulin à vent",
          "es": "Molino",
          "de": "Windmühle",
          "pt": "Moinho de Vento",
          "it": "Mulino a vento",
          "tr": "Rüzgâr Değirmeni",
          "pl": "Wiatrak",
          "ru": "Ветряная мельница",
          "uk": "Вітряк",
          "ko": "풍차",
          "zh": "风车",
          "ja": "風車"
        },
        {
          "id": "WindTurbine",
          "en": "Wind Turbine",
          "fr": "Éolienne",
          "es": "Turbina Eólica",
          "de": "Windrad",
          "pt": "Turbina Eólica",
          "it": "Turbina a vento",
          "tr": "Rüzgâr Türbini",
          "pl": "Turbina powietrzna",
          "ru": "Ветряная турбина",
          "uk": "Вітрова турбіна",
          "ko": "풍력 발전기",
          "zh": "风力涡轮机",
          "ja": "風力タービン"
        },
        {
          "id": "WoodenFabricBed",
          "en": "Wooden Fabric Bed",
          "fr": "Lit confortable en bois d\u0027œuvre",
          "es": "Cama de madera y tela",
          "de": "Hölzernes Stoffbett",
          "pt": "Cama de Madeira e Tecido",
          "it": "Letto in Legno",
          "tr": "Ahşap Dokuma Yatak",
          "pl": "Drewniane łóżko z materacem",
          "ru": "Деревянная кровать с матрасом",
          "uk": "Дерев’яне ліжко з матрацем",
          "ko": "목제 천 침대",
          "zh": "木质布料床",
          "ja": "木製の布ベッド"
        },
        {
          "id": "WoodenStrawBed",
          "en": "Wooden Straw Bed",
          "fr": "Lit de paille en bois",
          "es": "Cama de madera y paja",
          "de": "Hölzernes Strohbett",
          "pt": "Cama de Madeira e Palha",
          "it": "Letto in Paglia e Legno",
          "tr": "Ahşap Hazır Yatak",
          "pl": "Drewniane Łożko z Siennikiem",
          "ru": "Деревянная кровать с соломой",
          "uk": "Дерев\u0027яне ліжко з соломою",
          "ko": "목제 짚 침대",
          "zh": "木质稻草床",
          "ja": "木製の藁ベッド"
        },
        {
          "id": "Workbench",
          "en": "Workbench",
          "fr": "Établi de bricolage",
          "es": "Mesa de Trabajo",
          "de": "Werkbank",
          "pt": "Bancada de trabalho",
          "it": "Banco da lavoro",
          "tr": "Çalışma tezgahı",
          "pl": "Stół Roboczy",
          "ru": "Верстак",
          "uk": "Верстат",
          "ko": "작업대",
          "zh": "工作台",
          "ja": "作業台"
        },
        {
          "id": "Cement",
          "en": "Cement",
          "fr": "Ciment",
          "es": "Cemento",
          "de": "Zement",
          "pt": "Cimento",
          "it": "Cemento",
          "tr": "Çimentolama",
          "pl": "Cement",
          "ru": "Цемент",
          "uk": "Цемент",
          "ko": "시멘트",
          "zh": "水泥",
          "ja": "セメント"
        },
        {
          "id": "BasicBackpack",
          "en": "Basic Backpack",
          "fr": "Sac à dos basique",
          "es": "Mochila básica",
          "de": "Einfacher Rucksack",
          "pt": "Mochila Básica",
          "it": "Zaino base",
          "tr": "Basit Sırt Çantası",
          "pl": "Zwykły Plecak",
          "ru": "Простой рюкзак",
          "uk": "Звичайний рюкзак",
          "ko": "기본 배낭",
          "zh": "基础背包",
          "ja": "ベーシックバックパック"
        },
        {
          "id": "Bearpack",
          "en": "Bearpack",
          "fr": "Sac à d\u0027ours",
          "es": "Mochila de Oso",
          "de": "Bärenrucksack",
          "pt": "Mochila de Urso",
          "it": "Zaino per Orsi",
          "tr": "Ayı Çantası",
          "pl": "Plecak Olbrzymi",
          "ru": "Медвежий рюкзак",
          "uk": "Величезний наплічник",
          "ko": "곰낭",
          "zh": "熊背包",
          "ja": "巨大なバックパック"
        },
        {
          "id": "BigBackpack",
          "en": "Big Backpack",
          "fr": "Grand sac à dos",
          "es": "Mochila Grande",
          "de": "Großer Rucksack",
          "pt": "Mochila Grande",
          "it": "Zaino Grande",
          "tr": "Büyük Sırt Çantası",
          "pl": "Duży Plecak",
          "ru": "Большой рюкзак",
          "uk": "Великий рюкзак",
          "ko": "큰 배낭",
          "zh": "大背包",
          "ja": "大きなバックパック"
        },
        {
          "id": "CamoPants",
          "en": "Camo Pants",
          "fr": "Pantalon de camouflage",
          "es": "Pantalones de Camuflaje",
          "de": "Tarnhose",
          "pt": "Calças Camufladas",
          "it": "Pantaloni Mimetici",
          "tr": "Kamuflaj Pantolonu",
          "pl": "Spodnie Moro",
          "ru": "Камуфляжные штаны",
          "uk": "Камуфляжні штани",
          "ko": "위장무늬 바지",
          "zh": "迷彩裤",
          "ja": "迷彩パンツ"
        },
        {
          "id": "CamoShirt",
          "en": "Camo Shirt",
          "fr": "Chemise de camouflage",
          "es": "Camiseta de Camuflaje",
          "de": "Tarnshirt",
          "pt": "Camisa Camuflada",
          "it": "Magliette Mimetiche",
          "tr": "Kamuflaj Gömleği",
          "pl": "Koszula Moro",
          "ru": "Камуфляжная рубашка",
          "uk": "Камуфляжна сорочка",
          "ko": "위장무늬 셔츠",
          "zh": "迷彩衬衫",
          "ja": "迷彩シャツ"
        },
        {
          "id": "Capris",
          "en": "Capris",
          "fr": "Corsaire",
          "es": "Pantalones Caprí",
          "de": "Caprihose",
          "pt": "Calça Capri",
          "it": "Pantaloni alla Caprese",
          "tr": "Kapri",
          "pl": "Rybaczki",
          "ru": "Короткие брюки",
          "uk": "Капрі",
          "ko": "칠부 바지",
          "zh": "紧身裤",
          "ja": "カプリ"
        },
        {
          "id": "DerpyHat",
          "en": "Derpy Hat",
          "fr": "Chapeau ridicule",
          "es": "Sombrero Ridículo",
          "de": "Trotteliger Hut",
          "pt": "Chapéu de Bobo",
          "it": "Cappello Ridicolo",
          "tr": "Melon Şapka",
          "pl": "Durnowaty kapelusz",
          "ru": "Неуклюжая шляпа",
          "uk": "Недоладний капелюх",
          "ko": "이상한 모자",
          "zh": "德比帽",
          "ja": "おかしな帽子"
        },
        {
          "id": "GardenBoots",
          "en": "Garden Boots",
          "fr": "Bottes de jardinage",
          "es": "Botas de Jardín",
          "de": "Gartenschuhe",
          "pt": "Botas de Jardim",
          "it": "Stivali da giardino",
          "tr": "Bahçe Botları",
          "pl": "Buty ogrodnicze",
          "ru": "Садовые сапоги",
          "uk": "Садові чоботи",
          "ko": "정원 부츠",
          "zh": "花园靴",
          "ja": "ガーデンブーツ"
        },
        {
          "id": "GigotSleeveShirt",
          "en": "Gigot Sleeve Shirt",
          "fr": "Chemise à manches gigot",
          "es": "Camisa de manga gigot",
          "de": "Hülsenhemd",
          "pt": "Camisa de Manga Gigot",
          "it": "Camicia con maniche Gigot",
          "tr": "Büzülmüş Kollu Tişört",
          "pl": "Bufiasta Koszula",
          "ru": "Рубашка с пышными рукавами",
          "uk": "Сорочка з пишними рукавами",
          "ko": "지고 소매 셔츠",
          "zh": "羊腿袖衬衫",
          "ja": "ジゴスリーブシャツ"
        },
        {
          "id": "Henley",
          "en": "Henley",
          "fr": "Chemise Henley",
          "es": "Henley",
          "de": "Henleyshirt",
          "pt": "Camiseta Henley",
          "it": "Henley",
          "tr": "Henley",
          "pl": "Koszulka z Guzikami",
          "ru": "Хенли",
          "uk": "Хенлі",
          "ko": "헨리 셔츠",
          "zh": "亨利衫",
          "ja": "襟なしのシャツ"
        },
        {
          "id": "LightBackpack",
          "en": "Light Backpack",
          "fr": "Sac à dos léger",
          "es": "Mochila Ligera",
          "de": "Leichter Rucksack",
          "pt": "Mochila Leve",
          "it": "Zaino Piccolo",
          "tr": "Hafif Sırt Çantası",
          "pl": "Lekki Plecak",
          "ru": "Лёгкий рюкзак",
          "uk": "Легкий рюкзак",
          "ko": "가벼운 배낭",
          "zh": "轻便背包",
          "ja": "軽量バックパック"
        },
        {
          "id": "LowTopShoes",
          "en": "Low Top Shoes",
          "fr": "Chaussures basses",
          "es": "Zapatos Bajos",
          "de": "Halbschuhe",
          "pt": "Sapatos de Cano Baixo",
          "it": "Scarpe basse",
          "tr": "Kısa Topuklu Ayakkabı",
          "pl": "Trampki",
          "ru": "Кеды",
          "uk": "Кеди",
          "ko": "로우탑 운동화",
          "zh": "低帮鞋",
          "ja": "ロートップシューズ"
        },
        {
          "id": "RunningShoes",
          "en": "Running Shoes",
          "fr": "Chaussures de course",
          "es": "Zapatos de Correr",
          "de": "Laufschuhe",
          "pt": "Tênis de Corrida",
          "it": "Scarpe da corsa",
          "tr": "Spor Ayakkabı",
          "pl": "Buty do biegania",
          "ru": "Беговые кеды",
          "uk": "Взуття для бігу",
          "ko": "운동화",
          "zh": "跑鞋",
          "ja": "ランニングシューズ"
        },
        {
          "id": "SquareBelt",
          "en": "Square Belt",
          "fr": "Ceinture carrée",
          "es": "Cinturón Cuadrado",
          "de": "Quadratgürtel",
          "pt": "Cinto Quadrado",
          "it": "Cintura Quadrata",
          "tr": "Kare Kemer",
          "pl": "Pas z kwadratową sprzączką",
          "ru": "Ремень с квадратной пряжкой",
          "uk": "Ремінь із квадратною пряжкою",
          "ko": "사각 벨트",
          "zh": "方皮带",
          "ja": "角ばったベルト"
        },
        {
          "id": "TallBoots",
          "en": "Tall Boots",
          "fr": "Bottes hautes",
          "es": "Botas altas",
          "de": "Hohe Stiefel",
          "pt": "Botas Altas",
          "it": "Stivali alti",
          "tr": "Uzun Botlar",
          "pl": "Wysokie Buty",
          "ru": "Сапоги",
          "uk": "Високі чоботи",
          "ko": "롱부츠",
          "zh": "高筒靴",
          "ja": "トールブーツ"
        },
        {
          "id": "Trousers",
          "en": "Trousers",
          "fr": "Pantalon",
          "es": "Pantalones",
          "de": "Hosen",
          "pt": "Calças",
          "it": "Pantaloni",
          "tr": "Pantolon",
          "pl": "Spodnie",
          "ru": "Брюки",
          "uk": "Брюки",
          "ko": "바지",
          "zh": "裤子",
          "ja": "ズボン"
        },
        {
          "id": "WorkBackpack",
          "en": "Work Backpack",
          "fr": "Sac à dos de travail",
          "es": "Mochila de Trabajo",
          "de": "Arbeitsrucksack",
          "pt": "Mochila de Trabalho",
          "it": "Zaino da Lavoro",
          "tr": "İş Sırt Çantası",
          "pl": "Plecak roboczy",
          "ru": "Рабочий рюкзак",
          "uk": "Робочий рюкзак",
          "ko": "작업 배낭",
          "zh": "工作背包",
          "ja": "作業バッグ"
        },
        {
          "id": "WorkBoots",
          "en": "Work Boots",
          "fr": "Bottes de travail",
          "es": "Botas de Trabajo",
          "de": "Arbeitsstiefel",
          "pt": "Botas de Trabalho",
          "it": "Stivali da lavoro",
          "tr": "İş Botu",
          "pl": "Buty Robocze",
          "ru": "Рабочие ботинки",
          "uk": "Робочі чоботи",
          "ko": "작업화",
          "zh": "工作靴",
          "ja": "作業靴"
        },
        {
          "id": "Boards",
          "en": "Boards",
          "fr": "Planches",
          "es": "Tablas",
          "de": "Bretter",
          "pt": "Tábuas",
          "it": "Tavole",
          "tr": "Tahtalar",
          "pl": "Deski",
          "ru": "Доски",
          "uk": "Дошки",
          "ko": "판자",
          "zh": "木板",
          "ja": "板"
        },
        {
          "id": "CarvedPumpkin",
          "en": "Carved Pumpkin",
          "fr": "Citrouille sculptée",
          "es": "Calabaza tallada",
          "de": "Geschnitzter Kürbis",
          "pt": "Abóbora Esculpida",
          "it": "Zucca Scavata",
          "tr": "Oyulmuş Balkabağı",
          "pl": "Wydrążona dynia",
          "ru": "Резная тыква",
          "uk": "Різьблений гарбуз",
          "ko": "조각된 호박",
          "zh": "南瓜灯",
          "ja": "切り分けられたカボチャ"
        },
        {
          "id": "Excavator",
          "en": "Excavator",
          "fr": "Pelleteuse",
          "es": "Excavadora",
          "de": "Bagger",
          "pt": "Escavadeira",
          "it": "Escavatore",
          "tr": "Kazı Makinesi",
          "pl": "Koparka",
          "ru": "Экскаватор",
          "uk": "Екскаватор",
          "ko": "굴착기",
          "zh": "挖掘机",
          "ja": "ショベルカー"
        },
        {
          "id": "PoweredCart",
          "en": "Powered Cart",
          "fr": "Chariot motorisé",
          "es": "Carro Motorizado",
          "de": "Dampfbetriebener Wagen",
          "pt": "Carrinho Motorizado",
          "it": "Carrello Motorizzato",
          "tr": "Motorlu Yük Arabası",
          "pl": "Wózek z Napędem",
          "ru": "Повозка с мотором",
          "uk": "Возик із мотором",
          "ko": "전동 수레",
          "zh": "动力推车",
          "ja": "動力付カート"
        },
        {
          "id": "SmallWoodCart",
          "en": "Small Wood Cart",
          "fr": "Petit chariot en bois",
          "es": "Carro de Madera Pequeño",
          "de": "Kleiner Holzkarren",
          "pt": "Carrinho de Madeira Pequeno",
          "it": "Piccolo Carrello di Legno",
          "tr": "Ufak Ahşap Vagon",
          "pl": "Mały drewniany wózek",
          "ru": "Маленькая деревянная телега",
          "uk": "Малий дерев’яний віз",
          "ko": "작은 목재 수레",
          "zh": "小木质拖车",
          "ja": "小さい木製カート"
        },
        {
          "id": "TransmissionPole",
          "en": "Transmission Pole",
          "fr": "Poteau électrique",
          "es": "Poste de Transmisión",
          "de": "Übertragungsmast",
          "pt": "Poste de Transmissão",
          "it": "Palo di trasmissione",
          "tr": "Vites Direği",
          "pl": "Słup elektryczny",
          "ru": "Опора линии электропередач",
          "uk": "Опора ЛЕП",
          "ko": "전봇대",
          "zh": "传动杆",
          "ja": "電柱"
        },
        {
          "id": "WoodCart",
          "en": "Wood Cart",
          "fr": "Chariot en bois",
          "es": "Carro de Madera",
          "de": "Großer Holzkarren",
          "pt": "Carrinho de Madeira",
          "it": "Carrello di Legno",
          "tr": "Ahşap Yük Arabası",
          "pl": "Drewniany wózek",
          "ru": "Деревянная тележка",
          "uk": "Дерев’яний віз",
          "ko": "목재 수레",
          "zh": "木质拖车",
          "ja": "木製カート"
        },
        {
          "id": "Boiler",
          "en": "Boiler",
          "fr": "Chaudière",
          "es": "Caldera",
          "de": "Heizkessel",
          "pt": "Caldeira",
          "it": "Caldaia",
          "tr": "Kazan",
          "pl": "Bojler",
          "ru": "Котёл",
          "uk": "Котел",
          "ko": "보일러",
          "zh": "锅炉",
          "ja": "ボイラー"
        },
        {
          "id": "CopperBar",
          "en": "Copper Bar",
          "fr": "Lingot de cuivre",
          "es": "Lingote de cobre",
          "de": "Kupferbarren",
          "pt": "Barra de cobre",
          "it": "Lingotto di Rame",
          "tr": "Bakır Bar",
          "pl": "Sztabka miedzi",
          "ru": "Медный брусок",
          "uk": "Мідний брусок",
          "ko": "구리괴",
          "zh": "铜条",
          "ja": "銅インゴット"
        },
        {
          "id": "IronGear",
          "en": "Iron Gear",
          "fr": "Engrenage en fer",
          "es": "Engranaje de hierro",
          "de": "Eisenzahnrad",
          "pt": "Engrenagem de Ferro",
          "it": "Ingranaggio di Ferro",
          "tr": "Demir Dişli",
          "pl": "Żelazne koło zębate",
          "ru": "Железная шестерня",
          "uk": "Залізна шестірня",
          "ko": "철제 톱니바퀴",
          "zh": "铁质齿轮",
          "ja": "鉄のギア"
        },
        {
          "id": "GoldBar",
          "en": "Gold Bar",
          "fr": "Lingot d\u0027or",
          "es": "Lingote de oro",
          "de": "Goldbarren",
          "pt": "Barra de ouro",
          "it": "Lingotto d\u0027Oro",
          "tr": "Altın Bar",
          "pl": "Sztabka złota",
          "ru": "Золотой брусок",
          "uk": "Золотий брусок",
          "ko": "금괴",
          "zh": "金条",
          "ja": "金のインゴット"
        },
        {
          "id": "HeatSink",
          "en": "Heat Sink",
          "fr": "Dissipateur thermique",
          "es": "Disipador de calor",
          "de": "Kühlkörper",
          "pt": "Dissipador de Calor",
          "it": "Radiatore",
          "tr": "Soğutucu Bloğu",
          "pl": "Radiator",
          "ru": "Теплообменник",
          "uk": "Розсіювач тепла",
          "ko": "방열판",
          "zh": "散热片",
          "ja": "ヒートシンク"
        },
        {
          "id": "IronAxle",
          "en": "Iron Axle",
          "fr": "Essieu en fer",
          "es": "Eje de hierro",
          "de": "Eisenachse",
          "pt": "Eixo de Ferro",
          "it": "Ascia di Ferro",
          "tr": "Demir Dingil",
          "pl": "Żelazna oś",
          "ru": "Железная ось",
          "uk": "Залізна вісь",
          "ko": "철제 차축",
          "zh": "铁质车轴",
          "ja": "鉄の車軸"
        },
        {
          "id": "IronBar",
          "en": "Iron Bar",
          "fr": "Lingot de fer",
          "es": "Lingote de hierro",
          "de": "Eisenbarren",
          "pt": "Barra de ferro",
          "it": "Lingotto di Ferro",
          "tr": "Demir Bar",
          "pl": "Sztabka żelaza",
          "ru": "Железный брусок",
          "uk": "Залізний брусок",
          "ko": "철괴",
          "zh": "铁锭",
          "ja": "鉄のインゴット"
        },
        {
          "id": "IronPlate",
          "en": "Iron Plate",
          "fr": "Plaque de fer",
          "es": "Placa de hierro",
          "de": "Eisenplatte",
          "pt": "Chapa de Ferro",
          "it": "Lastra di Ferro",
          "tr": "Demir Plaka",
          "pl": "Żelazna płyta",
          "ru": "Железная пластина",
          "uk": "Залізна пластина",
          "ko": "철판",
          "zh": "铁板",
          "ja": "鉄板"
        },
        {
          "id": "IronWheel",
          "en": "Iron Wheel",
          "fr": "Roue en fer",
          "es": "Rueda de hierro",
          "de": "Rad aus Eisen",
          "pt": "Roda de Ferro",
          "it": "Ruota di Ferro",
          "tr": "Demir Tekerlek",
          "pl": "Żelazne koło",
          "ru": "Железное колесо",
          "uk": "Залізне колесо",
          "ko": "철제 바퀴",
          "zh": "铁轮",
          "ja": "鉄の車輪"
        },
        {
          "id": "LightBulb",
          "en": "Light Bulb",
          "fr": "Ampoule",
          "es": "Bombilla",
          "de": "Glühbirne",
          "pt": "Lâmpada",
          "it": "Lampadina",
          "tr": "Ampul",
          "pl": "Żarówka",
          "ru": "Лампочка",
          "uk": "Лампочка",
          "ko": "전구",
          "zh": "灯泡",
          "ja": "電球"
        },
        {
          "id": "PortableSteamEngine",
          "en": "Portable Steam Engine",
          "fr": "Moteur à vapeur portable",
          "es": "Motor a vapor portátil",
          "de": "Tragbarer Dampf-Stromgenerator",
          "pt": "Motor à Vapor Portátil",
          "it": "Motore a Vapore Portatile",
          "tr": "Taşınabilir Buhar Motoru",
          "pl": "Przenośny Silnik Parowy",
          "ru": "Портативный паровой двигатель",
          "uk": "Портативний паровий двигун",
          "ko": "이동식 증기기관",
          "zh": "便携式蒸汽机",
          "ja": "携帯型蒸気エンジン"
        },
        {
          "id": "Radiator",
          "en": "Radiator",
          "fr": "Radiateur",
          "es": "Radiador",
          "de": "Kühler",
          "pt": "Radiador",
          "it": "Radiatore",
          "tr": "Radyatör",
          "pl": "Chłodnica",
          "ru": "Радиатор",
          "uk": "Радіатор",
          "ko": "방열기",
          "zh": "散热器",
          "ja": "ラジエーター"
        },
        {
          "id": "RubberWheel",
          "en": "Rubber Wheel",
          "fr": "Roue en caoutchouc",
          "es": "Rueda de caucho",
          "de": "Gummirad",
          "pt": "Roda de Borracha",
          "it": "Ruota Gommata",
          "tr": "Lastik Tekerlek",
          "pl": "Gumowe Koło",
          "ru": "Резиновое колесо",
          "uk": "Гумове колесо",
          "ko": "고무 바퀴",
          "zh": "橡胶轮",
          "ja": "ゴム製ホイール"
        },
        {
          "id": "Screws",
          "en": "Screws",
          "fr": "Vis",
          "es": "Tornillos",
          "de": "Schrauben",
          "pt": "Parafusos",
          "it": "Viti",
          "tr": "Vida",
          "pl": "Śruby",
          "ru": "Винты",
          "uk": "Гвинти",
          "ko": "나사",
          "zh": "螺钉",
          "ja": "ネジ"
        },
        {
          "id": "SteamTractorHarvester",
          "en": "Steam Tractor Harvester",
          "fr": "Moissonneuse pour tracteur à vapeur",
          "es": "Cosechadora a vapor",
          "de": "Dampftraktor-Erntemaschine",
          "pt": "Trator Colheitadeira à Vapor",
          "it": "Raccoglitore del Trattore a Vapore",
          "tr": "Buharlı Traktör Biçerdöveri",
          "pl": "Kombajn Parowy",
          "ru": "Жатка парового трактора",
          "uk": "Збирач для парового трактора",
          "ko": "증기기관 트랙터용 수확기",
          "zh": "蒸汽拖拉机式收割机",
          "ja": "蒸気トラクター式収穫機"
        },
        {
          "id": "SteamTractorSower",
          "en": "Steam Tractor Sower",
          "fr": "Semoir pour tracteur à vapeur",
          "es": "Sembradora para el Tractor de Vapor",
          "de": "Dampftraktor-Sämaschine",
          "pt": "Trator Semeador à Vapor",
          "it": "Seminatrice del Trattore a Vapore",
          "tr": "Buharlı Traktör Tohum Ekme Aracı",
          "pl": "Siewnik Parowy",
          "ru": "Сеялка парового трактора",
          "uk": "Сіялка парового трактора",
          "ko": "증기기관 트랙터용 파종기",
          "zh": "蒸汽拖拉机用播种机",
          "ja": "蒸気トラクター用播種機"
        },
        {
          "id": "SteelAxle",
          "en": "Steel Axle",
          "fr": "Essieu en acier",
          "es": "Hacha de Acero",
          "de": "Stahlachse",
          "pt": "Eixo de Aço",
          "it": "Ascia d\u0027Acciaio",
          "tr": "Çelik Dingil",
          "pl": "Oś stalowa",
          "ru": "Стальная ось",
          "uk": "Сталева вісь",
          "ko": "강철 차축",
          "zh": "钢质车轴",
          "ja": "鋼の車軸"
        },
        {
          "id": "SteelGear",
          "en": "Steel Gear",
          "fr": "Engrenage en acier",
          "es": "Engranaje de acero",
          "de": "Stahlzahnrad",
          "pt": "Engrenagem de Aço",
          "it": "Ingranaggio d\u0027Acciaio",
          "tr": "Çelik Dişli",
          "pl": "Stalowy bieg",
          "ru": "Стальная шестерня",
          "uk": "Сталева шестірня",
          "ko": "강철 기어",
          "zh": "钢质齿轮",
          "ja": "鋼のギア"
        },
        {
          "id": "SteelPlate",
          "en": "Steel Plate",
          "fr": "Plaque d’acier",
          "es": "Placa de acero",
          "de": "Stahlplatte",
          "pt": "Chapa de Aço",
          "it": "Lastra d\u0027Acciaio",
          "tr": "Çelik Plaka",
          "pl": "Blacha Stalowa",
          "ru": "Стальная пластина",
          "uk": "Сталева пластина",
          "ko": "강철판",
          "zh": "钢板",
          "ja": "鋼板"
        },
        {
          "id": "SyntheticRubber",
          "en": "Synthetic Rubber",
          "fr": "Caoutchouc synthétique",
          "es": "Caucho Sintético",
          "de": "Synthetischer Gummi",
          "pt": "Borracha Sintética",
          "it": "Gomma Sintetica",
          "tr": "Sentetik Kauçuk",
          "pl": "Kauczuk Syntetyczny",
          "ru": "Синтетическая резина",
          "uk": "Синтетична гума",
          "ko": "합성 고무",
          "zh": "合成橡胶",
          "ja": "合成ゴム"
        },
        {
          "id": "WoodenWheel",
          "en": "Wooden Wheel",
          "fr": "Roue en bois",
          "es": "Rueda de madera",
          "de": "Rad aus Holz",
          "pt": "Roda de Madeira",
          "it": "Ruota in Legno",
          "tr": "Ahşap Tekerlek",
          "pl": "Drewniane Koło",
          "ru": "Деревянное колесо",
          "uk": "Дерев’яне колесо",
          "ko": "목제 바퀴",
          "zh": "木轮",
          "ja": "木の車輪"
        },
        {
          "id": "BeetSugar",
          "en": "Beet Sugar",
          "fr": "Sucre de betterave",
          "es": "Azúcar de remolacha",
          "de": "Zucker aus Rote Bete",
          "pt": "Açúcar de Beterraba",
          "it": "Zucchero di Barbabietola",
          "tr": "Pancar Şekeri",
          "pl": "Cukier buraczany",
          "ru": "Свекольный сахар",
          "uk": "Цукор буряковий",
          "ko": "사탕무 설탕",
          "zh": "甜菜糖",
          "ja": "てんさい糖"
        },
        {
          "id": "ButcherBison",
          "en": "Butcher Bison",
          "fr": "Dépecer le bison",
          "es": "Trocear Bisonte",
          "de": "Schlachte Bison",
          "pt": "Carnear Bisão",
          "it": "Macella Bisonte",
          "tr": "Bufalo Kes",
          "pl": "Przerób bizona",
          "ru": "Разделка бизона",
          "uk": "Оброблення бізонячої туші",
          "ko": "들소 도축법",
          "zh": "肉加工野牛",
          "ja": "バイソンを解体"
        },
        {
          "id": "ButcherHare",
          "en": "Butcher Hare",
          "fr": "Dépecer le lièvre",
          "es": "Trocear Liebre",
          "de": "Schlachte Hase",
          "pt": "Carnear Lebre",
          "it": "Macella Lepre",
          "tr": "Tavşan Kes",
          "pl": "Przerób królika",
          "ru": "Разделка зайца",
          "uk": "Оброблення заячої туші",
          "ko": "토끼 도축법",
          "zh": "肉加工野兔",
          "ja": "ノウサギを解体"
        },
        {
          "id": "CampfireBison",
          "en": "Campfire Bison",
          "fr": "Bison cuit au feu de camp",
          "es": "Bisonte a la brasa",
          "de": "Lagerfeuerbison",
          "pt": "Bisão Feito na Fogueira",
          "it": "Bisonte al Falò",
          "tr": "Güveçte Bizon Eti",
          "pl": "Mięso żubra z ogniska",
          "ru": "Жареный на костре бизон",
          "uk": "Бізоняче м’ясо на багатті",
          "ko": "들소 모닥불 요리",
          "zh": "篝火慢烤野牛肉",
          "ja": "野外調理のバイソン"
        },
        {
          "id": "CleanUrchins",
          "en": "Clean Urchins",
          "fr": "Vider les oursins",
          "es": "Erizos Limpios",
          "de": "Seeigel ausnehmen",
          "pt": "Limpar Ouriço-do-mar",
          "it": "Pulisci Ricci di Mare",
          "tr": "Temizlenmiş Su Kirpisi",
          "pl": "Czysty Jeżowiec",
          "ru": "Очистка морских ежей",
          "uk": "Почистити морських їжаків",
          "ko": "성게 손질법",
          "zh": "清洗海胆",
          "ja": "ウニ"
        },
        {
          "id": "ExoticFruitSalad",
          "en": "Exotic Fruit Salad",
          "fr": "Salade de fruits exotiques",
          "es": "Ensalada de Frutas Exóticas",
          "de": "Exotischer Fruchtsalat",
          "pt": "Salada de Frutas Exóticas",
          "it": "Insalata di Frutta Esotica",
          "tr": "Egzotik Meyve Salatası",
          "pl": "Tropikalna sałatka owocowa",
          "ru": "Экзотический фруктовый салат",
          "uk": "Екзотичний фруктовий салат",
          "ko": "이국적인 과일 샐러드",
          "zh": "异国风味的水果沙拉",
          "ja": "エキゾチックフルーツサラダ"
        },
        {
          "id": "ExoticSalad",
          "en": "Exotic Salad",
          "fr": "Salade exotique",
          "es": "Ensalada Exótica",
          "de": "Exotischer Salat",
          "pt": "Salada Exótica",
          "it": "Insalata Esotica",
          "tr": "Egzotik Salata",
          "pl": "Sałatka tropikalna",
          "ru": "Экзотический салат",
          "uk": "Екзотичний салат",
          "ko": "이국적인 샐러드",
          "zh": "异国风味沙拉",
          "ja": "エキゾチックサラダ"
        },
        {
          "id": "ExoticVegetableMedley",
          "en": "Exotic Vegetable Medley",
          "fr": "Assortiment de légumes exotiques",
          "es": "Mezcla de Verduras Exóticas",
          "de": "Exotische Gemüsemischung",
          "pt": "Mistura Vegetal Exótica",
          "it": "Miscuglio di Verdure Esotiche",
          "tr": "Egzotik Sebze Oturtma",
          "pl": "Tropikalna mieszanka warzywna",
          "ru": "Экзотическая овощная смесь",
          "uk": "Екзотична овочева суміш",
          "ko": "이국적인 야채 모듬",
          "zh": "异国风味蔬菜拼盘",
          "ja": "エキゾチックな野菜の盛り合せ"
        },
        {
          "id": "ForestSalad",
          "en": "Forest Salad",
          "fr": "Salade forestière",
          "es": "Ensalada del bosque",
          "de": "Waldsalat",
          "pt": "Salada da Floresta",
          "it": "Insalata di Foresta",
          "tr": "Orman Salatası",
          "pl": "Sałatka leśna",
          "ru": "Лесной салат",
          "uk": "Лісовий салат",
          "ko": "숲 샐러드",
          "zh": "森林沙拉",
          "ja": "森のサラダ"
        },
        {
          "id": "GrasslandSalad",
          "en": "Grassland Salad",
          "fr": "Salade des plaines",
          "es": "Ensalada de las praderas",
          "de": "Wiesensalat",
          "pt": "Salada do Campo",
          "it": "Insalata di Prateria",
          "tr": "Ot Salatası",
          "pl": "Sałatka pastewna",
          "ru": "Равнинный салат",
          "uk": "Рівнинний салат",
          "ko": "초원 샐러드",
          "zh": "草原沙拉",
          "ja": "草原サラダ"
        },
        {
          "id": "MixedFruitSalad",
          "en": "Mixed Fruit Salad",
          "fr": "Salade de fruits variés",
          "es": "Ensalada Mixta de Frutas",
          "de": "Gemischter Fruchtsalat",
          "pt": "Salada de Frutas Mistas",
          "it": "Macedonia Mista",
          "tr": "Karışık Meyveli Salata",
          "pl": "Mieszana sałatka owocowa",
          "ru": "Смешанный фруктовый салат",
          "uk": "Змішаний фруктовий салат",
          "ko": "혼합 과일 샐러드",
          "zh": "什果沙拉",
          "ja": "ミックスフルーツサラダ"
        },
        {
          "id": "MixedSalad",
          "en": "Mixed Salad",
          "fr": "Salade composée",
          "es": "Ensalada Mixta",
          "de": "Gemischter Salat",
          "pt": "Salada Mista",
          "it": "Insalata Mista",
          "tr": "Karışık Salata",
          "pl": "Sałatka mieszana",
          "ru": "Смешанный салат",
          "uk": "Змішаний салат",
          "ko": "혼합 샐러드",
          "zh": "什锦沙拉",
          "ja": "ミックスサラダ"
        },
        {
          "id": "MixedVegetableMedley",
          "en": "Mixed Vegetable Medley",
          "fr": "Assortiment de légumes variés",
          "es": "Mezcla de Verduras Mixtas",
          "de": "Gemischtes Gemüsepotpourri",
          "pt": "Mistura de Vegetais Mistos",
          "it": "Miscuglio di Verdure Miste",
          "tr": "Karışık Sebze Oturtma",
          "pl": "Różnorodna mieszanka warzywna",
          "ru": "Сложная овощная смесь",
          "uk": "Змішана овочева суміш",
          "ko": "혼합 야채 모듬",
          "zh": "什锦蔬菜拼盘",
          "ja": "ミックス野菜盛り合わせ"
        },
        {
          "id": "RefineTallow",
          "en": "Refine Tallow",
          "fr": "Affiner le suif",
          "es": "Refinar sebo",
          "de": "Talg aufbereiten",
          "pt": "Refinar Sebo",
          "it": "Raffina Sego",
          "tr": "Dilimlenmiş Don Yağı",
          "pl": "Oczyszczony tłuszcz",
          "ru": "Переработать жир",
          "uk": "Переробити сало",
          "ko": "수지 가공법",
          "zh": "精制牛油",
          "ja": "獣脂を精製する"
        },
        {
          "id": "RenderFat",
          "en": "Render Fat",
          "fr": "Affiner la graisse",
          "es": "Extracción de grasas",
          "de": "Fett auslassen",
          "pt": "Extração de Gordura",
          "it": "Estrai Grassi",
          "tr": "Kuyruk Yağı",
          "pl": "Wytopiony tłuszcz",
          "ru": "Вытопить жир",
          "uk": "Витопити жир",
          "ko": "지방 가공법",
          "zh": "提炼脂肪",
          "ja": "脂肪を精製する"
        },
        {
          "id": "SawBoards",
          "en": "Saw Boards",
          "fr": "Scier des planches",
          "es": "Tablas de Sierra",
          "de": "Holzbretter",
          "pt": "Tábuas Serradas",
          "it": "Assi segate",
          "tr": "Testere Tezgahı",
          "pl": "Pocięte deski",
          "ru": "Пилить доски",
          "uk": "Розпилити дошки",
          "ko": "판자 자르기",
          "zh": "粗凿原木板",
          "ja": "板材"
        },
        {
          "id": "ShuckClams",
          "en": "Shuck Clams",
          "fr": "Ouvrir les palourdes",
          "es": "Almejas sin concha",
          "de": "Muscheln öffnen",
          "pt": "Amêijoa Descascada",
          "it": "Sguscia Vongole",
          "tr": "Kabuklu İstiridye",
          "pl": "Otwarte małże",
          "ru": "Очистить моллюсков",
          "uk": "Обчистити молюсків",
          "ko": "조개 까는 법",
          "zh": "带壳蛤蜊",
          "ja": "貝の殻を取る"
        },
        {
          "id": "SmeltCopper",
          "en": "Smelt Copper",
          "fr": "Fondre du cuivre",
          "es": "Fundir Cobre",
          "de": "Kupfer schmelzen",
          "pt": "Cobre Fundido",
          "it": "Fondi Rame",
          "tr": "Erimiş Bakır",
          "pl": "Wytopić miedź",
          "ru": "Плавить медь",
          "uk": "Виплавити мідь",
          "ko": "구리 제련법",
          "zh": "冶铜",
          "ja": "銅の精錬"
        },
        {
          "id": "SmeltGold",
          "en": "Smelt Gold",
          "fr": "Fondre de l\u0027or",
          "es": "Fundir Oro",
          "de": "Gold schmelzen",
          "pt": "Ouro Fundido",
          "it": "Fondi Oro",
          "tr": "Erimiş Altın",
          "pl": "Wytopić złoto",
          "ru": "Плавить золото",
          "uk": "Виплавити золото",
          "ko": "금 제련법",
          "zh": "炼金",
          "ja": "金の精錬"
        },
        {
          "id": "SmeltIron",
          "en": "Smelt Iron",
          "fr": "Fondre du fer",
          "es": "Fundir Hierro",
          "de": "Eisen schmelzen",
          "pt": "Ferro Fundido",
          "it": "Fondi Ferro",
          "tr": "Erimiş Demir",
          "pl": "Wytopić żelazo",
          "ru": "Плавить железо",
          "uk": "Виплавити залізо",
          "ko": "철 제련법",
          "zh": "炼铁",
          "ja": "鉄の精錬"
        },
        {
          "id": "Chainsaw",
          "en": "Chainsaw",
          "fr": "Tronçonneuse",
          "es": "Motosierra",
          "de": "Kettensäge",
          "pt": "Serra Elétrica",
          "it": "Motosega",
          "tr": "Motorlu Testere",
          "pl": "Piła Łańcuchowa",
          "ru": "Бензопила",
          "uk": "Бензопила",
          "ko": "전기톱",
          "zh": "链锯",
          "ja": "チェーンソー"
        },
        {
          "id": "Crane",
          "en": "Crane",
          "fr": "Grue",
          "es": "Grúa",
          "de": "Kran",
          "pt": "Guindaste",
          "it": "Gru",
          "tr": "Vinç",
          "pl": "Dźwig",
          "ru": "Кран",
          "uk": "Кран",
          "ko": "크레인",
          "zh": "起重机",
          "ja": "クレーン"
        },
        {
          "id": "SkidSteer",
          "en": "Skid Steer",
          "fr": "Bulldozer",
          "es": "Minicargador",
          "de": "Kompaktlader",
          "pt": "Mini-carregadeira",
          "it": "Minipala",
          "tr": "Dozer",
          "pl": "Miniładowarka",
          "ru": "Погрузчик",
          "uk": "Міні-навантажувач",
          "ko": "스키드 스티어",
          "zh": "滑移装载机",
          "ja": "スキッドステア"
        },
        {
          "id": "Truck",
          "en": "Truck",
          "fr": "Camion",
          "es": "Camión",
          "de": "LKW",
          "pt": "Caminhão",
          "it": "Camion",
          "tr": "Kamyon",
          "pl": "Ciężarówka",
          "ru": "Грузовик",
          "uk": "Вантажівка",
          "ko": "트럭",
          "zh": "卡车",
          "ja": "トラック"
        },
        {
          "id": "Wheelbarrow",
          "en": "Wheelbarrow",
          "fr": "Brouette",
          "es": "Carretilla",
          "de": "Schubkarre",
          "pt": "Carrinho de Mão",
          "it": "Carriola",
          "tr": "El Arabası",
          "pl": "Taczka",
          "ru": "Тачка",
          "uk": "Візок",
          "ko": "외바퀴 손수레",
          "zh": "独轮手推车",
          "ja": "手押し車"
        },
        {
          "id": "WoodenElevator",
          "en": "Wooden Elevator",
          "fr": "Ascenseur en bois",
          "es": "Ascensor de Madera",
          "de": "Hölzerner Aufzug",
          "pt": "Elevador de Madeira",
          "it": "Ascensore in Legno",
          "tr": "Ahşap Asansör",
          "pl": "Winda drewniana",
          "ru": "Деревянный лифт",
          "uk": "Дерев’яний ліфт",
          "ko": "목제 승강기",
          "zh": "木制升降机",
          "ja": "木製エレベーター"
        },
        {
          "id": "AssemblyLine",
          "en": "Assembly Line",
          "fr": "Ligne de montage",
          "es": "Línea de Ensamblaje",
          "de": "Mechanische Fertigungsstraße",
          "pt": "Linha de montagem",
          "it": "Catena di montaggio",
          "tr": "Seri Üretim Hattı",
          "pl": "Linia Produkcyjna",
          "ru": "Сборочная линия",
          "uk": "Лінія для збору",
          "ko": "조립 라인",
          "zh": "装配线",
          "ja": "組立ライン"
        },
        {
          "id": "BisonMount",
          "en": "Bison Mount",
          "fr": "Trophée de bison",
          "es": "Soporte para bisonte",
          "de": "Ausgestopfter Bison",
          "pt": "Cabeça de Bisão",
          "it": "Bisonte",
          "tr": "Doldurulmuş Bufalo",
          "pl": "Żubr Górski",
          "ru": "Голова бизона",
          "uk": "Голова бізона",
          "ko": "박제된 들소 벽걸이",
          "zh": "野牛头壁挂",
          "ja": "バイソンマウント"
        },
        {
          "id": "Campsite",
          "en": "Campsite",
          "fr": "Camping",
          "es": "Campamento",
          "de": "Campingplatz",
          "pt": "Acampamento",
          "it": "Campo",
          "tr": "Kamp alanı",
          "pl": "Obóz",
          "ru": "Палатка",
          "uk": "Кемпінг",
          "ko": "야영지",
          "zh": "营地",
          "ja": "キャンプサイト"
        },
        {
          "id": "DistributionStation",
          "en": "Distribution Station",
          "fr": "Station de distribution",
          "es": "Estación de Distribución",
          "de": "Verteilungsstation",
          "pt": "Estação de Distribuição",
          "it": "Stazione di Distribuzione",
          "tr": "Dağıtım Terminali",
          "pl": "Stacja Dystrybucyjna",
          "ru": "Станция распределения",
          "uk": "Станція розподілу",
          "ko": "물자 배급소",
          "zh": "分发站",
          "ja": "集配ステーション"
        },
        {
          "id": "ElectricLathe",
          "en": "Electric Lathe",
          "fr": "Tour électrique",
          "es": "Torno eléctrico",
          "de": "Elektrische Drehmaschine",
          "pt": "Torno elétrico",
          "it": "Tornio Elettrico",
          "tr": "Elektrikli Torna Tezgahı",
          "pl": "Tokarka Elektryczna",
          "ru": "Электрический токарный станок",
          "uk": "Електричний токарний верстат",
          "ko": "전동식 선반",
          "zh": "电动车床",
          "ja": "電気旋盤"
        },
        {
          "id": "ElectricMachinistTable",
          "en": "Electric Machinist Table",
          "fr": "Établi électrique",
          "es": "Mesa eléctrica de maquinista",
          "de": "Elektrischer Montagetisch",
          "pt": "Mesa elétrica de maquinista",
          "it": "Banco Elettrico da Macchinista",
          "tr": "Elektrik Ustası Tezgahı",
          "pl": "Elektryczny Stół Maszynowy",
          "ru": "Электрический слесарный верстак",
          "uk": "Стіл електромашиніста",
          "ko": "전동식 기계 정비공 작업대",
          "zh": "电动机械师工作台",
          "ja": "電気工作機械台"
        },
        {
          "id": "ElectricPlaner",
          "en": "Electric Planer",
          "fr": "Fraiseuse électrique",
          "es": "Cepilladora eléctrica",
          "de": "Elektrische Hobelmaschine",
          "pt": "Plaina elétrica",
          "it": "Pialla Elettrica",
          "tr": "Elektrikli Rendeleme Tezgahı",
          "pl": "Strug Elektryczny",
          "ru": "Электрический строгальный станок",
          "uk": "Електричний стругальний верстат",
          "ko": "전동식 대패",
          "zh": "电动刨床",
          "ja": "電気かんな盤"
        },
        {
          "id": "ElectricStampingPress",
          "en": "Electric Stamping Press",
          "fr": "Presse électrique",
          "es": "Prensa de Estampado Hidráulica",
          "de": "Elektrische Stanzpresse",
          "pt": "Prensa de estampagem elétrica",
          "it": "Pressa per Stampaggio Elettrica",
          "tr": "Elektrikli Çelik İşleme Aleti",
          "pl": "Elektryczna prasa do tłoczenia",
          "ru": "Электрический пресс",
          "uk": "Електричний прес",
          "ko": "전동식 금속 가공기",
          "zh": "电动冲床",
          "ja": "電気スタンピングプレス機"
        },
        {
          "id": "ElkMount",
          "en": "Elk Mount",
          "fr": "Trophée de wapiti",
          "es": "Montura de alce",
          "de": "Ausgestopfter Wapiti",
          "pt": "Cabeça de Alce",
          "it": "Alce",
          "tr": "Doldurulmuş Geyik",
          "pl": "Łoś wierzchowiec",
          "ru": "Голова вапити",
          "uk": "Голова оленя",
          "ko": "박제된 엘크 벽걸이",
          "zh": "驼鹿壁挂",
          "ja": "エルクマウント"
        },
        {
          "id": "FramedGlassDoor",
          "en": "Framed Glass Door",
          "fr": "Porte en verre encadré",
          "es": "Puerta de cristal enmarcado",
          "de": "Gerahmte Glastür",
          "pt": "Porta de Vidro Moldado",
          "it": "Porta a Vetri con Cornice",
          "tr": "Çerçeveli Cam Kapı",
          "pl": "Oprawione Szklane Drzwi",
          "ru": "Стеклянная дверь",
          "uk": "Скляні двері",
          "ko": "유리창틀 문",
          "zh": "带框架的玻璃门",
          "ja": "枠付きのガラス戸"
        },
        {
          "id": "Kitchen",
          "en": "Kitchen",
          "fr": "Cuisine",
          "es": "Cocina",
          "de": "Küche",
          "pt": "Cozinha",
          "it": "Cucina",
          "tr": "Mutfak",
          "pl": "Kuchnia",
          "ru": "Кухня",
          "uk": "Кухня",
          "ko": "주방",
          "zh": "厨房",
          "ja": "キッチン"
        },
        {
          "id": "LargeCorrugatedSteelDoor",
          "en": "Large Corrugated Steel Door",
          "fr": "Rideau en acier ondulé",
          "es": "Puerta grande corrugada (acero)",
          "de": "Große Wellstahltür",
          "pt": "Porta de Aço Grande Ondulada",
          "it": "Grande Porta in Acciaio Corrugato",
          "tr": "Büyük Kıvrımlı Çelik Kapı",
          "pl": "Duże drzwi ze stali ryflowanej",
          "ru": "Рольставни",
          "uk": "Великі гофровані сталеві двері",
          "ko": "대형 골강판 문",
          "zh": "大型波纹钢门",
          "ja": "波形スチールの大きなドア"
        },
        {
          "id": "LargeHangingLumberSign",
          "en": "Large Hanging Lumber Sign",
          "fr": "Grand panneau suspendu en bois d\u0027œuvre",
          "es": "Letrero colgante grande (tablas de madera)",
          "de": "Bauholzschild (Groß",
          "pt": "대형 가공목 현판",
          "it": "Большая вывеска из пиломатериалов",
          "tr": "Large Hanging Lumber Sign",
          "pl": "Large Hanging Lumber Sign",
          "ru": "大型木制标志",
          "uk": "Stort Hængende Skilt i Tømmer",
          "ko": " hängend)",
          "zh": "Placa de Madeira Serrada Grande Pendurada",
          "ja": "Large Hanging Lumber Sign"
        },
        {
          "id": "LargeLumberDoor",
          "en": "Large Lumber Door",
          "fr": "Porte de garage en bois d\u0027œuvre",
          "es": "Puerta grande de madera",
          "de": "Große Holztür",
          "pt": "Porta de Madeira Serrada Grande",
          "it": "Grande Porta in Legno",
          "tr": "Büyük Kereste Kapı",
          "pl": "Duże drzwi z drewna",
          "ru": "Деревянные ворота",
          "uk": "Великі дерев’яні двері",
          "ko": "대형 가공목 문",
          "zh": "大木门",
          "ja": "大きな板材のドア"
        },
        {
          "id": "LargeStandingLumberSign",
          "en": "Large Standing Lumber Sign",
          "fr": "Grand panneau sur pied en bois d\u0027œuvre",
          "es": "Letrero grande (tablas de madera)",
          "de": "Bauholzschild (Groß",
          "pt": "대형 가공목 간판",
          "it": "Большая табличка из пиломатериалов",
          "tr": "Large Standing Lumber Sign",
          "pl": "Large Standing Lumber Sign",
          "ru": "大块木制标志",
          "uk": "Stort Hængende Skilt i Tømmer",
          "ko": " stehend)",
          "zh": "Placa de Madeira Serrada Grande em Pé",
          "ja": "Large Standing Lumber Sign"
        },
        {
          "id": "LargeWindowedLumberDoor",
          "en": "Large Windowed Lumber Door",
          "fr": "Porte de garage vitrée en bois d\u0027œuvre",
          "es": "Puerta de troncos grande con ventana",
          "de": "Große Holztür mit Fenster",
          "pt": "Porta de Madeira Serrada Grande com Janela",
          "it": "Grande Portafinestra in Legno",
          "tr": "باب خشبي بنوافذ كبيرة",
          "pl": "Duże",
          "ru": "Деревянные ворота с окошками",
          "uk": "Velké skleněné dřevěné dveře",
          "ko": "대형 가공목 창문 달린 문",
          "zh": "带窗户的大木门",
          "ja": "窓付きの大きな板材のドア"
        },
        {
          "id": "Lathe",
          "en": "Lathe",
          "fr": "Tour",
          "es": "Torno",
          "de": "Drehmaschine",
          "pt": "Torno",
          "it": "Tornio",
          "tr": "Torna",
          "pl": "Tokarka",
          "ru": "Токарный станок",
          "uk": "Токарний верстат",
          "ko": "선반",
          "zh": "车床",
          "ja": "旋盤"
        },
        {
          "id": "LumberDoor",
          "en": "Lumber Door",
          "fr": "Porte en bois d’œuvre",
          "es": "Puerta de Madera",
          "de": "Bauholztür",
          "pt": "Porta de madeira serrada",
          "it": "Porta in Legno",
          "tr": "Kereste Kapı",
          "pl": "Drzwi z Drewna",
          "ru": "Дверь из пиломатериалов",
          "uk": "Дерев’яні двері",
          "ko": "가공목 문",
          "zh": "木门",
          "ja": "板材のドア"
        },
        {
          "id": "MachinistTable",
          "en": "Machinist Table",
          "fr": "Établi de mécanicien",
          "es": "Mesa de maquinista",
          "de": "Mechanikertisch",
          "pt": "Mesa de maquinista",
          "it": "Banco del Macchinista",
          "tr": "Makinist Tezgahı",
          "pl": "Stół mechanika",
          "ru": "Слесарный верстак",
          "uk": "Стіл машиніста",
          "ko": "기계공 작업대",
          "zh": "机械师工作台",
          "ja": "機械工のテーブル"
        },
        {
          "id": "RealEstateDesk",
          "en": "Real Estate Desk",
          "fr": "Bureau immobilier",
          "es": "Escritorio inmobiliario",
          "de": "Grundbesitztisch",
          "pt": "Balcão de imóveis",
          "it": "Banco Immobiliare",
          "tr": "Gayrimenkul Masası",
          "pl": "Biuro nieruchomości",
          "ru": "Стол риелтора",
          "uk": "Бюро нерухомості",
          "ko": "부동산 중개소",
          "zh": "房地产交易所",
          "ja": "不動産デスク"
        },
        {
          "id": "RoboticAssemblyLine",
          "en": "Robotic Assembly Line",
          "fr": "Ligne de montage robotisée",
          "es": "Línea de Ensamblaje Robótica",
          "de": "Robotische Fertigungsstraße",
          "pt": "Linha de montagem robótica",
          "it": "Catena di Montaggio Robotica",
          "tr": "Robotlu Seri Üretim Hattı",
          "pl": "Zrobotyzowana linia produkcyjna",
          "ru": "Роботизированная сборочная линия",
          "uk": "Роботизована лінія для збору",
          "ko": "자동화 조립 라인",
          "zh": "机器人装配线",
          "ja": "ロボット組立ライン"
        },
        {
          "id": "RugLarge",
          "en": "Rug Large",
          "fr": "Grand tapis",
          "es": "Alfombra grande",
          "de": "Großer Teppich",
          "pt": "Tapete Grande",
          "it": "Grande Tappeto",
          "tr": "Büyük Halı",
          "pl": "Duży dywan",
          "ru": "Большой ковёр",
          "uk": "Великий килим",
          "ko": "대형 양탄자",
          "zh": "大号地毯",
          "ja": "大きな絨毯"
        },
        {
          "id": "RugMedium",
          "en": "Rug Medium",
          "fr": "Tapis moyen",
          "es": "Alfombra mediana",
          "de": "Mittelgroßer Teppich",
          "pt": "Tapete Médio",
          "it": "Tappeto Medio",
          "tr": "Orta Halı",
          "pl": "Średni dywan",
          "ru": "Средний ковёр",
          "uk": "Середній килим",
          "ko": "중형 양탄자",
          "zh": "中号地毯",
          "ja": "中くらいの絨毯"
        },
        {
          "id": "RugSmall",
          "en": "Rug Small",
          "fr": "Petit tapis",
          "es": "Alfombra pequeña",
          "de": "Kleiner Teppich",
          "pt": "Tapete Pequeno",
          "it": "Tappeto Piccolo",
          "tr": "Ufak Halı",
          "pl": "Mały dywan",
          "ru": "Маленький ковёр",
          "uk": "Малий килим",
          "ko": "소형 양탄자",
          "zh": "小号地毯",
          "ja": "小さな絨毯"
        },
        {
          "id": "ScrewPress",
          "en": "Screw Press",
          "fr": "Presse à vis",
          "es": "Prensa de tornillos",
          "de": "Spindelpresse",
          "pt": "Prensa de rosca",
          "it": "Pressa a Vite",
          "tr": "Vidalı Pres",
          "pl": "Prasa śrubowa",
          "ru": "Винтовой пресс",
          "uk": "Гвинтовий прес",
          "ko": "압입식 조임 기계",
          "zh": "螺旋压榨机",
          "ja": "ねじプレス"
        },
        {
          "id": "Shaper",
          "en": "Shaper",
          "fr": "Étau limeur",
          "es": "Modelador (m.) Modeladora (f.)",
          "de": "Fräsmaschine",
          "pt": "Niveladora",
          "it": "Plasmatrice",
          "tr": "Vargel",
          "pl": "Strugarka",
          "ru": "Строгальный станок",
          "uk": "Стругальний верстат",
          "ko": "형삭반",
          "zh": "刨床",
          "ja": "形削り盤"
        },
        {
          "id": "SmallHangingLumberSign",
          "en": "Small Hanging Lumber Sign",
          "fr": "Petit panneau suspendu en bois d\u0027œuvre",
          "es": "Letrero pequeño colgante (troncos)",
          "de": "Bauholzschild (klein",
          "pt": "소형 가공목 현판",
          "it": "Маленькая вывеска из пиломатериалов",
          "tr": "Small Hanging Lumber Sign",
          "pl": "Small Hanging Lumber Sign",
          "ru": "小块木制标志",
          "uk": "Lille Hængende Skilt i Tømmer",
          "ko": " hängend)",
          "zh": "Placa de Madeira Serrada Pequena Pendurada",
          "ja": "Small Hanging Lumber Sign"
        },
        {
          "id": "SmallStandingLumberSign",
          "en": "Small Standing Lumber Sign",
          "fr": "Petit panneau sur pied en bois d\u0027œuvre",
          "es": "Pequeño letrero de pie de madera",
          "de": "Bauholzschild (klein",
          "pt": "소형 가공목 현판",
          "it": "Маленькая табличка из пиломатериалов",
          "tr": "Small Standing Lumber Sign",
          "pl": "Small Standing Lumber Sign",
          "ru": "小块木制标志",
          "uk": "Lille Stående Skilt i Tømmer",
          "ko": " stehend)",
          "zh": "Placa de Madeira Serrada Pequena em Pé",
          "ja": "Small Standing Lumber Sign"
        },
        {
          "id": "SmallStockpile",
          "en": "Small Stockpile",
          "fr": "Réserve petite",
          "es": "Pila de almacenamiento pequeña",
          "de": "Lager (Mittel)",
          "pt": "Estoque em pilha pequeno",
          "it": "Piccola Catasta",
          "tr": "Ufak Stok Yeri",
          "pl": "Mały skład",
          "ru": "Маленький склад",
          "uk": "Мала комора",
          "ko": "소형 자재 창고",
          "zh": "小型料堆",
          "ja": "小さいストックパイル"
        },
        {
          "id": "SteamEngine",
          "en": "Steam Engine",
          "fr": "Machine à vapeur",
          "es": "Motor de Vapor",
          "de": "Dampf-Stromgenerator",
          "pt": "Motor à Vapor",
          "it": "Motore a Vapore",
          "tr": "Buhar Motoru",
          "pl": "Silnik parowy",
          "ru": "Паровой двигатель",
          "uk": "Паровий двигун",
          "ko": "증기기관",
          "zh": "蒸汽机",
          "ja": "蒸気発電機"
        },
        {
          "id": "SteelCeilingLight",
          "en": "Steel Ceiling Light",
          "fr": "Plafonnier en acier",
          "es": "Lámpara de techo de metal",
          "de": "Stahl-Deckenlampe",
          "pt": "Luminária de Teto de Aço",
          "it": "Luce da Soffitto in Acciaio",
          "tr": "Çelik Tavan Lambası",
          "pl": "Stalowe oświetlenie sufitowe",
          "ru": "Стальной потолочный светильник",
          "uk": "Сталева люстра",
          "ko": "강철 천장등",
          "zh": "钢制顶棚灯",
          "ja": "鋼製の天井ライト"
        },
        {
          "id": "SteelFloorLamp",
          "en": "Steel Floor Lamp",
          "fr": "Lampadaire en acier",
          "es": "Lámpara de suelo de metal",
          "de": "Stählerne Stehlampe",
          "pt": "Luminária de Piso de Aço",
          "it": "Lampada da Pavimento in Acciaio",
          "tr": "Çelik Yer Lambası",
          "pl": "Stalowa lampa stojąca",
          "ru": "Стальной торшер",
          "uk": "Сталевий торшер",
          "ko": "강철 스탠드 전등",
          "zh": "钢制落地灯",
          "ja": "鋼製の室内灯"
        },
        {
          "id": "SteelTableLamp",
          "en": "Steel Table Lamp",
          "fr": "Lampe de table en acier",
          "es": "Lampara de acero para mesas",
          "de": "Stahltischlampe",
          "pt": "Luminária de Mesa de Aço",
          "it": "Lampada da Tavolo in Acciaio",
          "tr": "Çelik Masa Lambası",
          "pl": "Stalowa lampka biurowa",
          "ru": "Стальная настольная лампа",
          "uk": "Сталева настільна лампа",
          "ko": "강철 탁자 전등",
          "zh": "钢制台灯",
          "ja": "鋼製の電気スタンド"
        },
        {
          "id": "Store",
          "en": "Store",
          "fr": "Magasin",
          "es": "Tienda",
          "de": "Shop-Name",
          "pt": "Loja",
          "it": "Negozio",
          "tr": "Mağaza",
          "pl": "Sklep",
          "ru": "Магазин",
          "uk": "Крамниця",
          "ko": "상점",
          "zh": "商店",
          "ja": "お店"
        },
        {
          "id": "StuffedElk",
          "en": "Stuffed Elk",
          "fr": "Wapiti empaillé",
          "es": "Alce disecado",
          "de": "Ausgestopfter Wapiti",
          "pt": "Alce Empalhado",
          "it": "Alce Impagliato",
          "tr": "Doldurulmuş Geyik",
          "pl": "Nadziewany Łoś",
          "ru": "Чучело вапити",
          "uk": "Опудало лося",
          "ko": "박제된 엘크",
          "zh": "驼鹿标本",
          "ja": "エルクの剥製"
        },
        {
          "id": "TinyStockpile",
          "en": "Tiny Stockpile",
          "fr": "Réserve minuscule",
          "es": "Pila de almacenamiento diminuta",
          "de": "Lager (Winzig)",
          "pt": "Estoque em pilha minúsculo",
          "it": "Minuscola Catasta",
          "tr": "Çok Ufak Stok Yeri",
          "pl": "Malutki skład",
          "ru": "Крошечный склад",
          "uk": "Крихітна комора",
          "ko": "초소형 자재 창고",
          "zh": "微型料堆",
          "ja": "すごく小さいストックパイル"
        },
        {
          "id": "WoodenCeilingLight",
          "en": "Wooden Ceiling Light",
          "fr": "Plafonnier en bois d\u0027œuvre",
          "es": "Lámpara de techo de madera",
          "de": "Hölzerne Deckenlampe",
          "pt": "Luminária de Teto de Madeira",
          "it": "Lampada da Soffitto in Legno",
          "tr": "Ahşap Tavan Lambası",
          "pl": "Drewniane oświetlenie sufitowe",
          "ru": "Деревянный потолочный светильник",
          "uk": "Дерев’яна люстра",
          "ko": "목제 천장등",
          "zh": "木制顶棚灯",
          "ja": "木製の天井ライト"
        },
        {
          "id": "WoodenFloorLamp",
          "en": "Wooden Floor Lamp",
          "fr": "Lampadaire en bois d\u0027œuvre",
          "es": "Lámpara de suelo de madera",
          "de": "Hölzerne Stehlampe",
          "pt": "Luminária de Piso de Madeira",
          "it": "Lampada da Pavimento in Legno",
          "tr": "Ahşap Yer Lambası",
          "pl": "Drewniana lampa podłogowa",
          "ru": "Деревянный торшер",
          "uk": "Дерев’яний торшер",
          "ko": "목제 스탠드형 전등",
          "zh": "木制落地灯",
          "ja": "木製の室内灯"
        },
        {
          "id": "WoodenTableLamp",
          "en": "Wooden Table Lamp",
          "fr": "Lampe de table en bois d\u0027œuvre",
          "es": "Lámpara de madera para mesa",
          "de": "Hölzerne Tischlampe",
          "pt": "Luminária de Mesa de Madeira",
          "it": "Lampada da Tavolo in Legno",
          "tr": "Ahşap Masa Lambası",
          "pl": "Drewniana lampa stołowa",
          "ru": "Деревянная настольная лампа",
          "uk": "Дерев’яний настільна лампа",
          "ko": "목제 탁자 전등",
          "zh": "木制台灯",
          "ja": "木製のテーブルランプ"
        },
        {
          "id": "SteamTractor",
          "en": "Steam Tractor",
          "fr": "Tracteur à vapeur",
          "es": "Tractor a vapor",
          "de": "Dampftraktor",
          "pt": "Trator à Vapor",
          "it": "Trattore a Vapore",
          "tr": "Buharlı Traktör",
          "pl": "Ciągnik Parowy",
          "ru": "Паровой трактор",
          "uk": "Паровий трактор",
          "ko": "증기 트랙터",
          "zh": "蒸汽拖拉机",
          "ja": "蒸気トラクター"
        },
        {
          "id": "Bank",
          "en": "Bank",
          "fr": "Banque",
          "es": "Banco",
          "de": "Banktresor",
          "pt": "Banco",
          "it": "Banca",
          "tr": "Banka",
          "pl": "Bank",
          "ru": "Банк",
          "uk": "Банк",
          "ko": "은행",
          "zh": "银行",
          "ja": "銀行"
        },
        {
          "id": "Registrar",
          "en": "Registrar",
          "fr": "Registre",
          "es": "Registrador",
          "de": "Registrar",
          "pt": "Registradora",
          "it": "Cancelliere",
          "tr": "Kayıt Memuru",
          "pl": "Rejestrator",
          "ru": "Регистратор",
          "uk": "Реєстратор",
          "ko": "직위개설 부서",
          "zh": "登记员",
          "ja": "登録者"
        },
        {
          "id": "SteamTruck",
          "en": "Steam Truck",
          "fr": "Camion à vapeur",
          "es": "Camión a vapor",
          "de": "Dampflastwagen",
          "pt": "Caminhão à Vapor",
          "it": "Camion a Vapore",
          "tr": "Buharlı Traktör",
          "pl": "Pojazd parowy",
          "ru": "Паровой грузовик",
          "uk": "Парова вантажівка",
          "ko": "증기기관 트럭",
          "zh": "蒸汽卡车",
          "ja": "蒸気トラック"
        },
        {
          "id": "Sink",
          "en": "Sink",
          "fr": "Évier",
          "es": "Fregadero",
          "de": "Spüle",
          "pt": "Pia",
          "it": "Scarico",
          "tr": "Lavabo",
          "pl": "Zlew",
          "ru": "Раковина",
          "uk": "Мушля",
          "ko": "개수대",
          "zh": "下沉",
          "ja": "シンク"
        },
        {
          "id": "TrilliumSeed",
          "en": "Trillium Seed",
          "fr": "Graine de trillium",
          "es": "Semilla de trilio",
          "de": "Waldliliensamen",
          "pt": "Semente de Lírio-do-bosque",
          "it": "Semi di Trillium",
          "tr": "Trilyum Tohumu",
          "pl": "Materiał siewny Trillium",
          "ru": "Семечко триллиума",
          "uk": "Насіння трилуму",
          "ko": "연령초 씨앗",
          "zh": "延龄草种子",
          "ja": "トリリウムの種子"
        },
        {
          "id": "TaroSeed",
          "en": "Taro Seed",
          "fr": "Graine de taro",
          "es": "Semilla de taro",
          "de": "Samen (Taro)",
          "pt": "Semente de Inhame",
          "it": "Semi di Taro",
          "tr": "Gölevez Tohumu",
          "pl": "Nasiona kolokazji",
          "ru": "Семечко таро",
          "uk": "Насіння таро",
          "ko": "토란 씨앗",
          "zh": "芋头籽",
          "ja": "タロイモの種"
        },
        {
          "id": "PumpkinSeed",
          "en": "Pumpkin Seed",
          "fr": "Graine de citrouille",
          "es": "Semilla de Calabaza",
          "de": "Samen (Kürbis)",
          "pt": "Semente de Abóbora",
          "it": "Semi di Zucca",
          "tr": "Balkabağı Tohumu",
          "pl": "Nasiono dyni",
          "ru": "Семечко тыквы",
          "uk": "Насіння гарбуза",
          "ko": "호박 씨앗",
          "zh": "南瓜种子",
          "ja": "カボチャの種"
        },
        {
          "id": "PineappleSeed",
          "en": "Pineapple Seed",
          "fr": "Graine d\u0027ananas",
          "es": "Semilla de Piña",
          "de": "Samen (Ananas)",
          "pt": "Semente de Abacaxi",
          "it": "Semi di Ananas",
          "tr": "Ananas Tohumu",
          "pl": "Nasiono ananasa",
          "ru": "Семечко ананаса",
          "uk": "Насіння ананаса",
          "ko": "파인애플 씨앗",
          "zh": "菠萝种子",
          "ja": "パイナップルの種"
        },
        {
          "id": "PapayaSeed",
          "en": "Papaya Seed",
          "fr": "Graine de papaye",
          "es": "Semilla de papaya",
          "de": "Samen (Papaya)",
          "pt": "Semente de Mamão",
          "it": "Seme di Papaya",
          "tr": "Papaya Tohumu",
          "pl": "Nasiono papai",
          "ru": "Семечко папайи",
          "uk": "Насіння папаї",
          "ko": "파파야 씨앗",
          "zh": "番木瓜籽",
          "ja": "パパイヤの種"
        },
        {
          "id": "OrchidSeed",
          "en": "Orchid Seed",
          "fr": "Graine d’orchidée",
          "es": "Semilla de orquídea",
          "de": "Samen (Orchidee)",
          "pt": "Semente de Orquídea",
          "it": "Semi d\u0027Orchidea",
          "tr": "Orkide Tohumu",
          "pl": "Nasiono orchidei",
          "ru": "Семечко орхидеи",
          "uk": "Насіння орхідеї",
          "ko": "난초 씨앗",
          "zh": "兰花种子",
          "ja": "ランの種"
        },
        {
          "id": "CookeinaMushroomSpores",
          "en": "Cookeina Mushroom Spores",
          "fr": "Spores de cookeina",
          "es": "Esporas de seta copa",
          "de": "Sporen (Cookeina)",
          "pt": "Esporos de Cogumelo Taça-de-vinho",
          "it": "Spore di Fungo Cookeina",
          "tr": "Cookeina Mantarı Sporları",
          "pl": "Zarodniki grzybów czarkowatych",
          "ru": "Споры кукейны",
          "uk": "Спори гриба кукейн",
          "ko": "술잔버섯 포자",
          "zh": "蘑菇孢子",
          "ja": "ウスベニコップタケの胞子"
        },
        {
          "id": "BoleteMushroomSpores",
          "en": "Bolete Mushroom Spores",
          "fr": "Spores de cèpe de Bordeaux",
          "es": "Esporas de Seta de Boleto",
          "de": "Sporen (Steinpilz)",
          "pt": "Esporos de Cogumelo Boleto",
          "it": "Spore di Fungo Porcino",
          "tr": "Çörek Mantarı Sporları",
          "pl": "Zarodniki borowików szlachetnych",
          "ru": "Споры белого гриба",
          "uk": "Спори білого гриба",
          "ko": "그물버섯 포자",
          "zh": "香菇孢子",
          "ja": "ヤマドリタケの胞子"
        },
        {
          "id": "AgaveSeed",
          "en": "Agave Seed",
          "fr": "Graine d\u0027agave",
          "es": "Semilla de agave",
          "de": "Samen (Agave)",
          "pt": "Semente de Agave",
          "it": "Semi d\u0027Agave",
          "tr": "Sabır Otu Tohumu",
          "pl": "Nasiono agawy",
          "ru": "Семечко агавы",
          "uk": "Насіння агави",
          "ko": "용설란 씨앗",
          "zh": "龙舌兰种子",
          "ja": "アガベの種子"
        },
        {
          "id": "RainforestSalad",
          "en": "Rainforest Salad",
          "fr": "Salade de la jungle",
          "es": "Ensalada de la jungla",
          "de": "Regenwaldsalat",
          "pt": "Salada da Floresta Tropical",
          "it": "Insalata della Foresta Pluviale",
          "tr": "Yağmur Ormanları Salatası",
          "pl": "Sałatka z lasu deszczowego",
          "ru": "Тропический салат",
          "uk": "Тропічний салат",
          "ko": "열대우림 샐러드",
          "zh": "雨林沙拉",
          "ja": "熱帯雨林のサラダ"
        },
        {
          "id": "RainforestFruitSalad",
          "en": "Rainforest Fruit Salad",
          "fr": "Salade de fruits de la jungle",
          "es": "Ensalada de frutas de la jungla",
          "de": "Regenwaldfruchtsalat",
          "pt": "Salada de Fruta da Floresta Tropical",
          "it": "Macedonia della Foresta Pluviale",
          "tr": "Yağmur Ormanları Meyve Salatası",
          "pl": "Sałatka z owoców z lasu deszczowego",
          "ru": "Тропический фруктовый салат",
          "uk": "Тропічний фруктовий салат",
          "ko": "열대우림 과일 샐러드",
          "zh": "雨林水果沙拉",
          "ja": "熱帯雨林のフルーツ サラダ"
        },
        {
          "id": "MushroomMedley",
          "en": "Mushroom Medley",
          "fr": "Assortiment de champignons",
          "es": "Mezcla de champiñones",
          "de": "Pilzpotpourri",
          "pt": "Mistura de Cogumelos",
          "it": "Miscuglio di Funghi",
          "tr": "Mantar Karışımı",
          "pl": "Mieszanka grzybów",
          "ru": "Грибное попурри",
          "uk": "Грибна суміш",
          "ko": "버섯 모듬",
          "zh": "菌菇拼盘",
          "ja": "キノコのメドレー"
        },
        {
          "id": "Quicklime",
          "en": "Quicklime",
          "fr": "Chaux vive",
          "es": "Cal viva",
          "de": "Branntkalk",
          "pt": "Cal Viva",
          "it": "Calce viva",
          "tr": "Taş Kireç",
          "pl": "Wapno palone",
          "ru": "Оксид кальция",
          "uk": "Негашене вапно",
          "ko": "생석회",
          "zh": "生石灰",
          "ja": "生石灰"
        },
        {
          "id": "PineappleFriendRice",
          "en": "Pineapple Friend Rice",
          "fr": "Riz frit à l\u0027ananas",
          "es": "Arroz frito con piña",
          "de": "Gebratener Reis mit Ananas",
          "pt": "Arroz frito com abacaxi",
          "it": "Riso Fritto con Ananas",
          "tr": "Ananaslı Pilav",
          "pl": "Twój przyjaciel ryż",
          "ru": "Ананас и его друг рис",
          "uk": "Ананас і його друг рис",
          "ko": "파인애플 볶음밥",
          "zh": "菠萝炒饭",
          "ja": "パイナップルチャーハン"
        },
        {
          "id": "CharredTaro",
          "en": "Charred Taro",
          "fr": "Taro carbonisé",
          "es": "Taro Carbonizado",
          "de": "Gegrillter Taro",
          "pt": "Inhame tostado",
          "it": "Taro Carbonizzato",
          "tr": "Pişmiş Gölevez",
          "pl": "Opiekana Kolokazja",
          "ru": "Таро на углях",
          "uk": "Обвуглене таро",
          "ko": "그슬린 토란",
          "zh": "烧焦的芋头",
          "ja": "焦げたタロイモ"
        },
        {
          "id": "CharredPineapple",
          "en": "Charred Pineapple",
          "fr": "Ananas carbonisé",
          "es": "Piña Carbonizada",
          "de": "Gegrillte Ananas",
          "pt": "Abacaxi tostado",
          "it": "Ananas Carbonizzato",
          "tr": "Pişmiş Ananas",
          "pl": "Opiekany Ananas",
          "ru": "Ананас на углях",
          "uk": "Обвуглений ананас",
          "ko": "그슬린 파인애플",
          "zh": "烧焦的菠萝",
          "ja": "焦げたパイナップル"
        },
        {
          "id": "CharredPapaya",
          "en": "Charred Papaya",
          "fr": "Papaye carbonisée",
          "es": "Papaya Carbonizada",
          "de": "Gegrillte Papaya",
          "pt": "Mamão tostado",
          "it": "Papaya Carbonizzata",
          "tr": "Pişmiş Papaya",
          "pl": "Opiekana papaja",
          "ru": "Папайя на углях",
          "uk": "Обвуглена папая",
          "ko": "그슬린 파파야",
          "zh": "烧焦的木瓜",
          "ja": "焦げたパパイヤ"
        },
        {
          "id": "CharredAgave",
          "en": "Charred Agave",
          "fr": "Agave carbonisé",
          "es": "Agave carbonizado",
          "de": "Gegrillte Agave",
          "pt": "Agave tostado",
          "it": "Agave Carbonizzata",
          "tr": "Pişmiş Sabır Otu",
          "pl": "Opiekana Agawa",
          "ru": "Агава на углях",
          "uk": "Обвуглена агава",
          "ko": "그슬린 용설란",
          "zh": "烧焦的龙舌兰",
          "ja": "焦げたリュウゼツラン"
        },
        {
          "id": "BoiledRice",
          "en": "Boiled Rice",
          "fr": "Riz bouilli",
          "es": "Arroz Hervido",
          "de": "Gekochter Reis",
          "pt": "Arroz cozido",
          "it": "Riso Bollito",
          "tr": "Haşlanmış Pirinç",
          "pl": "Gotowany ryż",
          "ru": "Отварной рис",
          "uk": "Варений рис",
          "ko": "삶은 쌀",
          "zh": "煮熟的米",
          "ja": "茹でた米"
        },
        {
          "id": "BakedAgave",
          "en": "Baked Agave",
          "fr": "Agave au four",
          "es": "Agave cocinado",
          "de": "Gebackene Agave",
          "pt": "Agave assado",
          "it": "Agave Cotta",
          "tr": "Kavrulmuş Sabır Otu",
          "pl": "Pieczona agawa",
          "ru": "Запечённая агава",
          "uk": "Запечена агава",
          "ko": "구운 용설란",
          "zh": "烘焙过的龙舌兰",
          "ja": "焼いたリュウゼツラン"
        },
        {
          "id": "CompostFertilizer",
          "en": "Compost Fertilizer",
          "fr": "Engrais de compost",
          "es": "Fertilizante de abono orgánico",
          "de": "Dünger aus Kompost",
          "pt": "Fertilizante Composto",
          "it": "Concime fertilizzante",
          "tr": "Doğal Gübre",
          "pl": "Nawóz z kompostu",
          "ru": "Компостное удобрение",
          "uk": "Компостне добриво",
          "ko": "퇴비 비료",
          "zh": "堆肥",
          "ja": "堆肥肥料"
        },
        {
          "id": "WasteFilter",
          "en": "Waste Filter",
          "fr": "Filtre à déchets",
          "es": "Filtro de Residuos",
          "de": "Wasserfilter",
          "pt": "Filtro de Resíduos",
          "it": "Filtro dei rifiuti",
          "tr": "Atık Filtresi",
          "pl": "Filtr Odpadów",
          "ru": "Сточный фильтр",
          "uk": "Фільтр відходів",
          "ko": "폐수 여과장치",
          "zh": "废物过滤器",
          "ja": "廃棄物フィルター"
        },
        {
          "id": "MechanicalWaterPump",
          "en": "Mechanical Water Pump",
          "fr": "Pompe à eau mécanique",
          "es": "Bomba de agua mecánica",
          "de": "Mechanische Wasserpumpe",
          "pt": "Bomba de Água Mecânica",
          "it": "Pompa Idraulica Meccanica",
          "tr": "Mekanik Su Pompası",
          "pl": "Mechaniczna pompa wodna",
          "ru": "Механический водяной насос",
          "uk": "Механічний водяний насос",
          "ko": "기계식 양수기",
          "zh": "机械能水泵",
          "ja": "機械式ウォーター ポンプ"
        },
        {
          "id": "ElectricWaterPump",
          "en": "Electric Water Pump",
          "fr": "Pompe à eau électrique",
          "es": "Bomba de agua eléctrica",
          "de": "Elektrische Wasserpumpe",
          "pt": "Bomba de Água Elétrica",
          "it": "Pompa Idraulica Elettrica",
          "tr": "Elektrikli Su Pompası",
          "pl": "Elektryczna pompa wodna",
          "ru": "Электрический водяной насос",
          "uk": "Електричний водяний насос",
          "ko": "전기식 양수기",
          "zh": "电动水泵",
          "ja": "電動ウォーター ポンプ"
        },
        {
          "id": "WheatMortar",
          "en": "Wheat Mortar",
          "fr": "Mortier de blé",
          "es": "Mortero de trigo",
          "de": "Weizenmörtel",
          "pt": "Argamassa de Trigo",
          "it": "Mortaio di Grano",
          "tr": "Buğday Harcı",
          "pl": "Pszenna zaprawa",
          "ru": "Раствор из пшеницы",
          "uk": "Мелена пшениця",
          "ko": "밀 모르타르",
          "zh": "小麦砂浆",
          "ja": "小麦モルタル"
        },
        {
          "id": "MasonryMortar",
          "en": "Masonry Mortar",
          "fr": "Mortier de maçonnerie",
          "es": "Mortero de mampostería",
          "de": "Steinmörtel",
          "pt": "Argamassa de Alvenaria",
          "it": "Malta per Muratura",
          "tr": "Duvar Harcı",
          "pl": "Zaprawa murarska",
          "ru": "Раствор каменщика",
          "uk": "Розчин для кам\u0027яної кладки",
          "ko": "석조 모르타르",
          "zh": "石料砂浆",
          "ja": "石工モルタル"
        },
        {
          "id": "CharredMortar",
          "en": "Charred Mortar",
          "fr": "Mortier carbonisé",
          "es": "Mortero quemado",
          "de": "Verkohlter Mörtel",
          "pt": "Argamassa Carbonizada",
          "it": "Malta Carbonata",
          "tr": "Közlenmiş Harç",
          "pl": "Zwęglona zaprawa",
          "ru": "Пережжённый раствор",
          "uk": "Перепалений розчин",
          "ko": "그슬린 모르타르",
          "zh": "焦化砂浆",
          "ja": "焦げたモルタル"
        },
        {
          "id": "BakedMortar",
          "en": "Baked Mortar",
          "fr": "Mortier au four",
          "es": "Mortero cocido",
          "de": "Gebackener Mörtel",
          "pt": "Argamassa Assada",
          "it": "Malta Cotta",
          "tr": "Pişirilmiş Harç",
          "pl": "Wypalona zaprawa",
          "ru": "Вытопленный раствор",
          "uk": "Витоплений розчин",
          "ko": "구운 모르타르",
          "zh": "烘烤砂浆",
          "ja": "焼けたモルタル"
        },
        {
          "id": "SunflowerSeed",
          "en": "Sunflower Seed",
          "fr": "Graine de tournesol",
          "es": "Semilla de girasol",
          "de": "Samen (Sonnenblume)",
          "pt": "Semente de Girassol",
          "it": "Semi di Girasole",
          "tr": "Ay Çiçeği Tohumu",
          "pl": "Nasiona słonecznika",
          "ru": "Семечко подсолнечника",
          "uk": "Насіння соняшника",
          "ko": "해바라기 씨앗",
          "zh": "向日葵种子",
          "ja": "ひまわりの種"
        },
        {
          "id": "Stockpile",
          "en": "stockpile",
          "fr": "réserve",
          "es": "stockpile",
          "de": "stockpile",
          "pt": "stockpile",
          "it": "stockpile",
          "tr": "stockpile",
          "pl": "stockpile",
          "ru": "stockpile",
          "uk": "склад",
          "ko": "무더기",
          "zh": "料堆",
          "ja": "ストックパイル"
        },
        {
          "id": "StoneSickle",
          "en": "Stone Sickle",
          "fr": "Faucille en pierre",
          "es": "Hoz de piedra",
          "de": "Steinsichel",
          "pt": "Foice de Pedra",
          "it": "Falce di Pietra",
          "tr": "Taş Orak",
          "pl": "Kamienny sierp",
          "ru": "Каменный серп",
          "uk": "Кам\u0027яний серп",
          "ko": "돌 낫",
          "zh": "石质镰刀",
          "ja": "石のカマ"
        },
        {
          "id": "StoneRoadTool",
          "en": "Stone Road Tool",
          "fr": "Outil de route en pierre",
          "es": "Herramienta compactadora de piedra",
          "de": "Steinstraßenwerkzeug",
          "pt": "Ferramenta de Estrada de Pedra",
          "it": "Strumento Strada in Pietra",
          "tr": "Taş Yol Aracı",
          "pl": "Kamienne narzędzie do dróg",
          "ru": "Каменная трамбовка",
          "uk": "Кам\u0027яний дорожній інструмент",
          "ko": "돌 도로정비 도구",
          "zh": "石质道路工具",
          "ja": "石の舗装ツール"
        },
        {
          "id": "StoneMachete",
          "en": "Stone Machete",
          "fr": "Machette en pierre",
          "es": "Machete de piedra",
          "de": "Steinmachete",
          "pt": "Facão de Pedra",
          "it": "Machete di Pietra",
          "tr": "Taş Pala",
          "pl": "Kamienna maczeta",
          "ru": "Каменное мачете",
          "uk": "Кам\u0027яне мачете",
          "ko": "돌 마체테",
          "zh": "石质砍刀",
          "ja": "石のマチェーテ"
        },
        {
          "id": "SteelSickle",
          "en": "Steel Sickle",
          "fr": "Faucille en acier",
          "es": "Hoz de acero",
          "de": "Stahlsichel",
          "pt": "Foice de Aço",
          "it": "Falce d\u0027Acciaio",
          "tr": "Çelik Orak",
          "pl": "Stalowy sierp",
          "ru": "Стальной серп",
          "uk": "Стальний серп",
          "ko": "강철 낫",
          "zh": "钢质镰刀",
          "ja": "鋼のカマ"
        },
        {
          "id": "SteelMachete",
          "en": "Steel Machete",
          "fr": "Machette en acier",
          "es": "Machete de acero",
          "de": "Stahlmachete",
          "pt": "Facão de Aço",
          "it": "Machete d\u0027Acciaio",
          "tr": "Çelik Pala",
          "pl": "Stalowa maczeta",
          "ru": "Стальное мачете",
          "uk": "Стальне мачете",
          "ko": "강철 마체테",
          "zh": "钢质砍刀",
          "ja": "鋼のマチェーテ"
        },
        {
          "id": "ModernMachete",
          "en": "Modern Machete",
          "fr": "Machette moderne",
          "es": "Machete moderno",
          "de": "Moderne Machete",
          "pt": "Facão Moderno",
          "it": "Machete Moderno",
          "tr": "Modern Pala",
          "pl": "Nowoczesna maczeta",
          "ru": "Современное мачете",
          "uk": "Сучасне мачете",
          "ko": "현대식 마체테",
          "zh": "现代砍刀",
          "ja": "近代的なマチェーテ"
        },
        {
          "id": "IronMachete",
          "en": "Iron Machete",
          "fr": "Machette en fer",
          "es": "Machete de hierro",
          "de": "Eisenmachete",
          "pt": "Facão de Ferro",
          "it": "Machete di Ferro",
          "tr": "Demir Pala",
          "pl": "Żelazna maczeta",
          "ru": "Железное мачете",
          "uk": "Залізне мачете",
          "ko": "철 마체테",
          "zh": "铁质砍刀",
          "ja": "鉄のマチェーテ"
        },
        {
          "id": "ShaleBrick",
          "en": "Shale Brick",
          "fr": "Brique de schiste",
          "es": "Ladrillo de pizarra",
          "de": "Lehmziegel mit Schiefer",
          "pt": "Tijolo de Xisto",
          "it": "Mattone di Scisto",
          "tr": "Kil Tuğlası",
          "pl": "Cegła łupkowa",
          "ru": "Сланцевый кирпич",
          "uk": "Сланцева цегла",
          "ko": "이판암 벽돌",
          "zh": "页岩砖",
          "ja": "頁岩レンガ"
        },
        {
          "id": "Store",
          "en": "store",
          "fr": "store",
          "es": "tienda",
          "de": "store",
          "pt": "lojas",
          "it": "negozio",
          "tr": "mağaza",
          "pl": "sklep",
          "ru": "store",
          "uk": "крамниця",
          "ko": "상점",
          "zh": "商店",
          "ja": "お店"
        },
        {
          "id": "Canvas",
          "en": "Canvas",
          "fr": "Toile",
          "es": "Tela",
          "de": "Leinwand",
          "pt": "Tela",
          "it": "Tela",
          "tr": "Tuval",
          "pl": "Płótno",
          "ru": "Холст",
          "uk": "Полотно",
          "ko": "캔버스",
          "zh": "帆布",
          "ja": "キャンバス"
        },
        {
          "id": "ZoningOffice",
          "en": "Zoning Office",
          "fr": "Bureau du territoire",
          "es": "Oficina territorial",
          "de": "Planungs- und Bauamt",
          "pt": "Escritório de Zoneamento",
          "it": "Ufficio Zonale",
          "tr": "İmar Ofisi",
          "pl": "Biuro zagospodarowania przestrzennego",
          "ru": "Офис зонирования",
          "uk": "Офіс зонування",
          "ko": "토지관리 부서",
          "zh": "分区办公室",
          "ja": "区画整理局"
        },
        {
          "id": "ToolBench",
          "en": "Tool Bench",
          "fr": "Établi d\u0027outillage",
          "es": "Mesa de herramientas",
          "de": "Werkzeugtisch",
          "pt": "Bancada de ferramentas",
          "it": "Banco degli Attrezzi",
          "tr": "Alet Tezgahı",
          "pl": "Stół narzędziowy",
          "ru": "Стол для инструментов",
          "uk": "Стіл для інструментів",
          "ko": "도구 작업대",
          "zh": "工具台",
          "ja": "ツール制作台"
        },
        {
          "id": "StampMill",
          "en": "Stamp Mill",
          "fr": "Concasseur à percussions",
          "es": "Molino de pisón",
          "de": "Pochwerk",
          "pt": "Moinho de carimbo",
          "it": "Mulino a Stampo",
          "tr": "Maden Değirmeni",
          "pl": "Kruszarka",
          "ru": "Штамповочная мельница",
          "uk": "Штамповий млин",
          "ko": "쇄광기",
          "zh": "捣矿机",
          "ja": "砕鉱機"
        },
        {
          "id": "SmallStandingWoodSign",
          "en": "Small Standing Wood Sign",
          "fr": "Petit panneau sur pied en bois",
          "es": "Letrero pequeño (básico)",
          "de": "Holzschild (klein",
          "pt": "작은 목재 선간판",
          "it": "Маленькая деревянная табличка",
          "tr": "Small Standing Wood Sign",
          "pl": "Small Standing Wood Sign",
          "ru": "小型立式木质标志",
          "uk": "Small Standing Wood Sign",
          "ko": " stehend)",
          "zh": "Placa de Madeira Pequena em Pé",
          "ja": "Small Standing Wood Sign"
        },
        {
          "id": "SmallHangingWoodSign",
          "en": "Small Hanging Wood Sign",
          "fr": "Petit panneau suspendu en bois",
          "es": "Letrero pequeño colgante (básico)",
          "de": "Holzschild (klein",
          "pt": "작은 걸이형 목재 간판",
          "it": "Маленькая деревянная вывеска",
          "tr": "Small Hanging Wood Sign",
          "pl": "Small Hanging Wood Sign",
          "ru": "小型立式木质标志",
          "uk": "Small Hanging Wood Sign",
          "ko": " hängend)",
          "zh": "Placa de Madeira Pequena Pendurada",
          "ja": "Small Hanging Wood Sign"
        },
        {
          "id": "SensorBasedBeltSorter",
          "en": "Sensor Based Belt Sorter",
          "fr": "Rampe de tri à détecteurs",
          "es": "Cinta organizadora con sensores",
          "de": "Sensorenbasierter Gürtelsortierer",
          "pt": "Classificador com correia baseado em sensor",
          "it": "Selezionatore A Nastro Basata sul Sensore",
          "tr": "Sensörlere Dayalı Kemer Sınıflandırıcı",
          "pl": "Sorter taśmowy oparty na czujnikach",
          "ru": "Сенсорный конвейерный сортировщик",
          "uk": "Сенсорний сортувальник конвеєрної лінії",
          "ko": "감지기 기반 자동 분류기",
          "zh": "基于传感器的皮带分拣机",
          "ja": "センサー式ベルト選別機"
        },
        {
          "id": "ScreeningMachine",
          "en": "Screening Machine",
          "fr": "Machine de criblage",
          "es": "Máquina de escaneo",
          "de": "Siebmaschine",
          "pt": "Máquina de peneiramento",
          "it": "Vaglio Meccanico",
          "tr": "Elek Makinesi",
          "pl": "Maszyna do Przesiewania",
          "ru": "Вибрационный сортировщик",
          "uk": "Просіювальна машина",
          "ko": "건식 정광 기계",
          "zh": "筛选机",
          "ja": "選別機"
        },
        {
          "id": "RockerBox",
          "en": "Rocker Box",
          "fr": "Rampe de lavage",
          "es": "Caja de balancines",
          "de": "Bergbau-Waschtisch",
          "pt": "Caixa de garimpo",
          "it": "Scatola Bilanciere",
          "tr": "Rocker Kutusu",
          "pl": "Sito kołyskowe",
          "ru": "Вашгерд",
          "uk": "Накопичувач руди",
          "ko": "로커 박스",
          "zh": "摇臂箱",
          "ja": "ロッカーボックス"
        },
        {
          "id": "MortaredStoneTable",
          "en": "Mortared Stone Table",
          "fr": "Table en pierre cimentée",
          "es": "Mesa de piedra con mortero",
          "de": "Steinziegeltisch",
          "pt": "Mesa de Pedra Argamassada",
          "it": "Tavolo in Pietra Pestata",
          "tr": "Harçlı Taştan Masa",
          "pl": "Kamienny stół",
          "ru": "Стол из строительного камня",
          "uk": "Стіл з будівельного каміння",
          "ko": "모르타르 마감 석재 탁자",
          "zh": "砂浆石桌",
          "ja": "モルタルの石のテーブル"
        },
        {
          "id": "MortaredStoneFireplace",
          "en": "Mortared Stone Fireplace",
          "fr": "Cheminée en pierre cimentée",
          "es": "Chimenea de piedra con mortero",
          "de": "Gemörtelter Steinkamin",
          "pt": "Lareira de Pedra Argamassada",
          "it": "Camino in Pietra Pestata",
          "tr": "Harçlı Taştan Şömine",
          "pl": "Kominek z kamienia spojonego zaprawą",
          "ru": "Камин из строительного камня",
          "uk": "Камін із будівельного каміння",
          "ko": "모르타르 마감 석재 벽난로",
          "zh": "砂浆石壁炉",
          "ja": "モルタルの石の暖炉"
        },
        {
          "id": "MortaredStoneChair",
          "en": "Mortared Stone Chair",
          "fr": "Chaise en pierre cimentée",
          "es": "Silla de piedra con mortero",
          "de": "Steinziegelstuhl",
          "pt": "Cadeira de Pedra Argamassada",
          "it": "Sedia in Pietra Pestata",
          "tr": "Harçlı Taştan Sandalye",
          "pl": "Kamienne krzesło",
          "ru": "Стул из строительного камня",
          "uk": "Стілець із будівельного каміння",
          "ko": "모르타르 마감 석재 의자",
          "zh": "砂浆石椅",
          "ja": "モルタルの石の椅子"
        },
        {
          "id": "MortaredStoneBench",
          "en": "Mortared Stone Bench",
          "fr": "Banc en pierre cimentée",
          "es": "Banco de piedra con mortero",
          "de": "Steinziegelbank",
          "pt": "Banco de Pedra Argamassada",
          "it": "Panca in Pietra Pestata",
          "tr": "Harçlı Taş Tezgah",
          "pl": "Kamienna ławka",
          "ru": "Лавка из строительного камня",
          "uk": "Лавка з будівельного каміння",
          "ko": "모르타르 마감 석재 벤치",
          "zh": "砂浆石凳",
          "ja": "モルタルの石のベンチ"
        },
        {
          "id": "LumberTable",
          "en": "Lumber Table",
          "fr": "Table en bois d\u0027œuvre",
          "es": "Mesa de troncos",
          "de": "Bauholztisch",
          "pt": "Mesa de Madeira Serrada",
          "it": "Tavolo in Legno",
          "tr": "Kereste Masa",
          "pl": "Stół z tarcicy",
          "ru": "Стол из пиломатериалов",
          "uk": "Стіл з пиломатеріалів",
          "ko": "가공된 목재 테이블",
          "zh": "木材桌",
          "ja": "板材のテーブル"
        },
        {
          "id": "LumberChair",
          "en": "Lumber Chair",
          "fr": "Chaise en bois d\u0027œuvre",
          "es": "Silla de troncos",
          "de": "Bauholzstuhl",
          "pt": "Cadeira de Madeira Serrada",
          "it": "Sedia in Legno",
          "tr": "Kereste Sandalye",
          "pl": "Krzesło z Drewna",
          "ru": "Стул из пиломатериалов",
          "uk": "Стілець з пиломатеріалів",
          "ko": "가공된 목재 의자",
          "zh": "木材椅子",
          "ja": "板材の椅子"
        },
        {
          "id": "LumberBench",
          "en": "Lumber Bench",
          "fr": "Banc en bois d\u0027œuvre",
          "es": "Banco de troncos",
          "de": "Bauholzbank",
          "pt": "Banco de Madeira Serrada",
          "it": "Panca in Legno",
          "tr": "Kereste Tezgah",
          "pl": "Ławka z Drewna",
          "ru": "Лавка из пиломатериалов",
          "uk": "Лава з пиломатеріалів",
          "ko": "가공된 목재 벤치",
          "zh": "木质长凳",
          "ja": "板材のベンチ"
        },
        {
          "id": "LargeStandingWoodSign",
          "en": "Large Standing Wood Sign",
          "fr": "Grand panneau sur pied en bois",
          "es": "Letrero grande (básico)",
          "de": "Holzschild (Groß",
          "pt": "큰 목재 선간판",
          "it": "Большая деревянная табличка",
          "tr": "Large Standing Wood Sign",
          "pl": "Large Standing Wood Sign",
          "ru": "大型立式木标志",
          "uk": "Large Standing Wood Sign",
          "ko": " stehend)",
          "zh": "Placa de Madeira Grande em Pé",
          "ja": "Large Standing Wood Sign"
        },
        {
          "id": "LargeHangingWoodSign",
          "en": "Large Hanging Wood Sign",
          "fr": "Grand panneau suspendu en bois",
          "es": "Letrero colgante grande (básico)",
          "de": "Holzschild (Groß",
          "pt": "큰 걸이형 목재 간판",
          "it": "Большая деревянная вывеска",
          "tr": "Large Hanging Wood Sign",
          "pl": "Large Hanging Wood Sign",
          "ru": "大型悬挂木质标志",
          "uk": "Large Hanging Wood Sign",
          "ko": " hängend)",
          "zh": "Placa de Madeira Grande Pendurada",
          "ja": "Large Hanging Wood Sign"
        },
        {
          "id": "JawCrusher",
          "en": "Jaw Crusher",
          "fr": "Concasseur à mâchoires",
          "es": "Trituradora",
          "de": "Kieferbrecher",
          "pt": "Britador de mandíbulas",
          "it": "Frantoio a Mascelle",
          "tr": "Çeneli Konkasör",
          "pl": "Kruszarka szczękowa",
          "ru": "Щековая дробилка",
          "uk": "Щокова дробарка",
          "ko": "암석 파쇄기",
          "zh": "颚式破碎机",
          "ja": "破砕機"
        },
        {
          "id": "HewnTable",
          "en": "Hewn Table",
          "fr": "Table taillée",
          "es": "Mesa tallada",
          "de": "Massivholztisch",
          "pt": "Mesa de Madeira Talhada",
          "it": "Tavolo Squadrato",
          "tr": "Yontulmuş Masa",
          "pl": "Ociosany stół",
          "ru": "Стол из обтёсанного дерева",
          "uk": "Стіл із обтесаного дерева",
          "ko": "다듬은 탁자",
          "zh": "割台",
          "ja": "丸太材のテーブル"
        },
        {
          "id": "HewnChair",
          "en": "Hewn Chair",
          "fr": "Chaise taillée",
          "es": "Silla tallada",
          "de": "Massivholzstuhl",
          "pt": "Cadeira de Madeira Cortada",
          "it": "Sedia Scolpita",
          "tr": "Yontulmuş Sandalye",
          "pl": "Ociosane krzesło",
          "ru": "Стул из обтёсанного дерева",
          "uk": "Стілець із обтесаного дерева",
          "ko": "다듬은 의자",
          "zh": "椅子",
          "ja": "丸太材の椅子"
        },
        {
          "id": "HewnBench",
          "en": "Hewn Bench",
          "fr": "Banc taillé",
          "es": "Banco tallado",
          "de": "Massivholzbank",
          "pt": "Banco de Madeira Cortada",
          "it": "Panca Scolpita",
          "tr": "Yontulmuş Tezgah",
          "pl": "Ociosana ławka",
          "ru": "Лавка из обтёсанной древесины",
          "uk": "Лавка із обтесаного дерева",
          "ko": "다듬은 벤치",
          "zh": "凿台",
          "ja": "丸太材のベンチ"
        },
        {
          "id": "GovernmentOffice",
          "en": "Government Office",
          "fr": "Bureau des élus",
          "es": "Oficina de gobierno",
          "de": "Amtsverwaltung",
          "pt": "Escritório do Governo",
          "it": "Ufficio Governativo",
          "tr": "Hükümet Ofisi",
          "pl": "Biuro rządowe",
          "ru": "Правительственный офис",
          "uk": "Державний офіс",
          "ko": "행정관청",
          "zh": "公会办公室",
          "ja": "行政官庁"
        },
        {
          "id": "FrothFloatationCell",
          "en": "Froth Floatation Cell",
          "fr": "Cellule de flottation",
          "es": "Celda de espuma flotante",
          "de": "Schaumschwimmzelle",
          "pt": "Célula de flotação de espuma",
          "it": "Cella di Flottazione della Schiuma",
          "tr": "Köpük Yüzdürme Hücresi",
          "pl": "Pianka pływacka",
          "ru": "Флотатор",
          "uk": "Флотатор",
          "ko": "거품 부유 분별기",
          "zh": "泡沫浮选池",
          "ja": "泡沫浮選機"
        },
        {
          "id": "ExecutiveOffice",
          "en": "Executive Office",
          "fr": "Bureau de l\u0027exécutif",
          "es": "Oficina ejecutiva",
          "de": "Hauptamt",
          "pt": "Escritório Executivo",
          "it": "Ufficio Esecutivo",
          "tr": "İdarehane",
          "pl": "Biuro wykonawcze",
          "ru": "Исполнительный офис",
          "uk": "Адміністративний офіс",
          "ko": "행정집무실",
          "zh": "行政办公室",
          "ja": "行政府オフィス"
        },
        {
          "id": "CompositeLumberTable",
          "en": "Composite Lumber Table",
          "fr": "Table en composite",
          "es": "Mesa de composite (básica)",
          "de": "Verbundholz-Tisch",
          "pt": "Mesa Composta de Madeira Serrada",
          "it": "Tavolo Composito in Legno",
          "tr": "Kompozit Kereste Masası",
          "pl": "Kompozytowy stół z drewna",
          "ru": "Стол из композитов",
          "uk": "Стіл із композитних пиломатеріалів",
          "ko": "합성 가공목 탁자",
          "zh": "复合木桌",
          "ja": "複合材の板材のテーブル"
        },
        {
          "id": "CompositeLumberDoor",
          "en": "Composite Lumber Door",
          "fr": "Porte en composite",
          "es": "Puerta de composite (básica)",
          "de": "Verbundholz-Tür",
          "pt": "Porta Composta de Madeira Serrada",
          "it": "Porta Composita in Legno",
          "tr": "Kompozit Kereste Kapısı",
          "pl": "Kompozytowe drzwi z drewna",
          "ru": "Дверь из композитов",
          "uk": "Двері з композитних пиломатеріалів",
          "ko": "합성 가공목 문",
          "zh": "复合木门",
          "ja": "複合材の板材のドア"
        },
        {
          "id": "CompositeLumberChair",
          "en": "Composite Lumber Chair",
          "fr": "Chaise en composite",
          "es": "Silla de composite (básica)",
          "de": "Verbundholz-Stuhl",
          "pt": "Cadeira Composta de Madeira Serrada",
          "it": "Sedia Composita in Legno",
          "tr": "Kompozit Kereste Sandalyesi",
          "pl": "Kompozytowe krzesło z drewna",
          "ru": "Стул из композитов",
          "uk": "Стілець із композитних пиломатеріалів",
          "ko": "합성 가공목 의자",
          "zh": "复合木椅",
          "ja": "複合材の板材の椅子"
        },
        {
          "id": "CompositeLumberBench",
          "en": "Composite Lumber Bench",
          "fr": "Banc en bois composite",
          "es": "Banco de composite (básica)",
          "de": "Verbundholz-Bank",
          "pt": "Banco Composto de Madeira Serrada",
          "it": "Panca Composita in Legno",
          "tr": "Kompozit Kereste Tezgahı",
          "pl": "Kompozytowa ławka z drewna",
          "ru": "Лавка из композитов",
          "uk": "Лавка з композитних пиломатеріалів",
          "ko": "합성 가공목 벤치",
          "zh": "复合木质长凳",
          "ja": "複合材の板材のベンチ"
        },
        {
          "id": "CensusBureau",
          "en": "Census Bureau",
          "fr": "Bureau du recensement",
          "es": "Oficina de censo",
          "de": "Einwohnermeldeamt",
          "pt": "Escritório do Censo",
          "it": "Ufficio del Censimento",
          "tr": "Nüfus İdaresi",
          "pl": "Biuro spisowe",
          "ru": "Бюро переписи населения",
          "uk": "Бюро перепису населення",
          "ko": "인구조사국",
          "zh": "人口普查局",
          "ja": "国勢調査局"
        },
        {
          "id": "Capitol",
          "en": "Capitol",
          "fr": "Pupitre de la Constitution",
          "es": "Capitolio",
          "de": "Tisch der Verfassung",
          "pt": "Capitólio",
          "it": "Campidoglio",
          "tr": "Hükümet Binası",
          "pl": "Kapitol",
          "ru": "Капитолий",
          "uk": "Капітолій",
          "ko": "중앙정부",
          "zh": "公约台",
          "ja": "国会議事堂"
        },
        {
          "id": "BrickFireplace",
          "en": "Brick Fireplace",
          "fr": "Cheminée en briques",
          "es": "Chimenea de ladrillos",
          "de": "Backsteinkamin",
          "pt": "Lareira de Tijolos",
          "it": "Camino in Mattoni",
          "tr": "Tuğla Şömine",
          "pl": "Ceglany kominek",
          "ru": "Кирпичный камин",
          "uk": "Цегляний камін",
          "ko": "벽돌 벽난로",
          "zh": "砖壁炉",
          "ja": "レンガ暖炉"
        },
        {
          "id": "BoardOfElections",
          "en": "Board Of Elections",
          "fr": "Bureau des élections",
          "es": "Tablón de elecciones",
          "de": "Wahlvorstand",
          "pt": "Conselho Eleitoral",
          "it": "Consiglio Elettorale",
          "tr": "Seçim Kurulu",
          "pl": "Stanowisko wyborcze",
          "ru": "Избирательная комиссия",
          "uk": "Виборча рада",
          "ko": "선거관리위원회",
          "zh": "推选面板",
          "ja": "選挙管理局"
        },
        {
          "id": "BallotBox",
          "en": "Ballot Box",
          "fr": "Urne électorale",
          "es": "Urna electoral",
          "de": "Wahlurne",
          "pt": "Urna Eleitoral",
          "it": "Urna Elettorale",
          "tr": "Oy Sandığı",
          "pl": "Urna wyborcza",
          "ru": "Урна для голосования",
          "uk": "Урна для голосовуння",
          "ko": "투표함",
          "zh": "选票箱",
          "ja": "投票箱"
        },
        {
          "id": "AshlarStoneTable",
          "en": "Ashlar Stone Table",
          "fr": "Table en pierre taillée",
          "es": "Mesa de piedra (sillar)",
          "de": "Quadersteintisch",
          "pt": "Mesa de Pedra Polida",
          "it": "Tavolo in Pietra Bugnata",
          "tr": "Kesme Taştan Masa",
          "pl": "Ciosany kamienny stół",
          "ru": "Стол из резного камня",
          "uk": "Стіл з обтесаного каменю",
          "ko": "각진 석재 탁자",
          "zh": "方琢石桌",
          "ja": "切石のテーブル"
        },
        {
          "id": "AshlarStoneFireplace",
          "en": "Ashlar Stone Fireplace",
          "fr": "Cheminée en pierre taillée",
          "es": "Chimenea de piedra (sillar)",
          "de": "Quadersteinfeuerstelle",
          "pt": "Lareira de Pedra Polida",
          "it": "Camino in Pietra Bugnata",
          "tr": "Kesme Taştan Şömine",
          "pl": "Ciosany kamienny kominek",
          "ru": "Камин из резного камня",
          "uk": "Камін з обтесаного каменю",
          "ko": "각진 석재 벽난로",
          "zh": "方琢石壁炉",
          "ja": "切石の暖炉"
        },
        {
          "id": "AshlarStoneChair",
          "en": "Ashlar Stone Chair",
          "fr": "Chaise en pierre taillée",
          "es": "Silla de piedra (sillar)",
          "de": "Quadersteinstuhl",
          "pt": "Cadeira de Pedra Polida",
          "it": "Sedia in Pietra Bugnata",
          "tr": "Kesme Taştan Sandalye",
          "pl": "Ciosane kamienne krzesło",
          "ru": "Стул из резного камня",
          "uk": "Стілець з обтесаного каменю",
          "ko": "각진 석재 의자",
          "zh": "方琢石椅",
          "ja": "切石の椅子"
        },
        {
          "id": "AshlarStoneBench",
          "en": "Ashlar Stone Bench",
          "fr": "Banc en pierre taillée",
          "es": "Banco de piedra (sillar)",
          "de": "Quadersteinbank",
          "pt": "Banco de Pedra Polida",
          "it": "Panca in Pietra Bugnata",
          "tr": "Kesme Taş Tezgah",
          "pl": "Ciosana kamienna ławka",
          "ru": "Лавка из резного камня",
          "uk": "Лавка з обтесаного каменю",
          "ko": "각진 석재 벤치",
          "zh": "方琢石凳",
          "ja": "切石のベンチ"
        },
        {
          "id": "AshlarSmallStoneFountain",
          "en": "Ashlar Small Stone Fountain",
          "fr": "Petite fontaine en pierre taillée",
          "es": "Fuente pequeña de piedra (sillar)",
          "de": "Kleiner Quadersteinbrunnen",
          "pt": "Fonte Pequena de Pedra Polida",
          "it": "Piccola Fontana in Pietra Bugnata",
          "tr": "Küçük Kesme Taş Çeşme",
          "pl": "Mała fontanna z ciosanego kamienia",
          "ru": "Маленький фонтан из резного камня",
          "uk": "Малий фонтан з обтесаного каменю",
          "ko": "소형 각진 석재 분수",
          "zh": "小型方琢石喷泉",
          "ja": "切石の小さな噴水"
        },
        {
          "id": "AshlarLargeStoneFountain",
          "en": "Ashlar Large Stone Fountain",
          "fr": "Grande fontaine en pierre taillée",
          "es": "Fuente grande (sillar de piedra)",
          "de": "Großer Steinquaderbrunnen",
          "pt": "Fonte Grande de Pedra Polida",
          "it": "Grande Fontana in Pietra Bugnata",
          "tr": "Büyük Kesme Taş Çeşme",
          "pl": "Duża fontanna z ciosanego kamienia",
          "ru": "Фонтан из резного камня",
          "uk": "Великий фонтан з обтесаного каменю",
          "ko": "대형 각진 석재 분수",
          "zh": "大型方琢型石喷泉",
          "ja": "大きな石の切石の噴水"
        },
        {
          "id": "Arrastra",
          "en": "Arrastra",
          "fr": "Concasseur à meules",
          "es": "Arrastra",
          "de": "Bergbau-Pochmühle",
          "pt": "Arrastra",
          "it": "Arrastra",
          "tr": "Arrastra",
          "pl": "Kamienny młyn",
          "ru": "Аррастра",
          "uk": "Аррастра",
          "ko": "돌 맷돌",
          "zh": "碎金研磨机",
          "ja": "アラストラ"
        },
        {
          "id": "Amendments",
          "en": "Amendments",
          "fr": "Pupitre des amendements",
          "es": "Enmiendas",
          "de": "Verfassungsänderungen",
          "pt": "Emendas",
          "it": "Emendamenti",
          "tr": "Değişiklikler",
          "pl": "Poprawki",
          "ru": "Поправки",
          "uk": "Поправки",
          "ko": "입법부",
          "zh": "修正案",
          "ja": "改正"
        },
        {
          "id": "AdvancedMasonryTable",
          "en": "Advanced Masonry Table",
          "fr": "Établi de maçonnerie avancé",
          "es": "Mesa de mampostería avanzada",
          "de": "Verbesserter Steinmetztisch",
          "pt": "Mesa de alvenaria avançada",
          "it": "Tavolo da Muratura Avanzato",
          "tr": "Gelişmiş Duvarcılık Masası",
          "pl": "Zaawansowany stół kamieniarski",
          "ru": "Продвинутый верстак каменщика",
          "uk": "Покращенний верстак муляра",
          "ko": "고급 석공 작업대",
          "zh": "高级石工台",
          "ja": "高度な石工作業台"
        },
        {
          "id": "AdvancedCarpentryTable",
          "en": "Advanced Carpentry Table",
          "fr": "Établi de menuiserie avancé",
          "es": "Mesa de carpintería avanzada",
          "de": "Verbesserter Schreinerhandwerkstisch",
          "pt": "Mesa de carpintaria avançada",
          "it": "Banco da Carpenteria Avanzato",
          "tr": "Gelişmiş Marangoz Masası",
          "pl": "Zaawansowany stół stolarski",
          "ru": "Продвинутый верстак плотника",
          "uk": "Розширений теслярський стіл",
          "ko": "고급 목공 작업대",
          "zh": "高级木工桌",
          "ja": "高度な木工作業台"
        },
        {
          "id": "AdornedAshlarStoneTable",
          "en": "Adorned Ashlar Stone Table",
          "fr": "Table en pierre taillée ornée",
          "es": "Mesa adornada (sillar de piedra)",
          "de": "Geschmückter Steinquadertisch",
          "pt": "Mesa de Pedra Polida Adornada",
          "it": "Tavolo di Pietra Bugnata Adornato",
          "tr": "Süslenmiş Kesme Taş Masa",
          "pl": "Zdobiony stół z ciosanego kamienia",
          "ru": "Украшенный стол из резного камня",
          "uk": "Прикрашений стіл з різьбленого каменю",
          "ko": "장식된 각진 석재 탁자",
          "zh": "装饰过的方琢石桌",
          "ja": "装飾付き切石のテーブル"
        },
        {
          "id": "AdornedAshlarStoneChair",
          "en": "Adorned Ashlar Stone Chair",
          "fr": "Chaise en pierre taillée ornée",
          "es": "Silla adornada (sillar de piedra)",
          "de": "Geschmückter Steinquaderstuhl",
          "pt": "Cadeira de Pedra Polida Adornada",
          "it": "Sedia in Pietra Bugnata Adornata",
          "tr": "Süslenmiş Kesme Taş Sandalye",
          "pl": "Zdobione krzesło z ciosanego kamienia",
          "ru": "Украшенный стул из резного камня",
          "uk": "Прикрашений стілець з різьбленого каменю",
          "ko": "장식된 각진 석재 의자",
          "zh": "装饰过的方琢石椅",
          "ja": "装飾付き切石の椅子"
        },
        {
          "id": "AdornedAshlarStoneBench",
          "en": "Adorned Ashlar Stone Bench",
          "fr": "Banc en pierre taillée ornée",
          "es": "Banco adornado (sillar de piedra)",
          "de": "Geschmückter Steinquaderbank",
          "pt": "Banco de Pedra Polida Adornada",
          "it": "Panca in Pietra Bugnata Adornata",
          "tr": "Süslenmiş Kesme Taş Tezgah",
          "pl": "Zdobiona ławka z ciosanego kamienia",
          "ru": "Украшенная лавка из резного камня",
          "uk": "Прикрашена лавка з різьбленого каменю",
          "ko": "장식된 각진 석재 벤치",
          "zh": "装饰过的方琢石凳",
          "ja": "装飾付き切石のベンチ"
        },
        {
          "id": "ModernRockDrill",
          "en": "Modern Rock Drill",
          "fr": "Foreuse de roche moderne",
          "es": "Perforadora moderna",
          "de": "Moderner Felsbohrer",
          "pt": "Perfuradora de Rocha Moderna",
          "it": "Trapano da Roccia Moderno",
          "tr": "Modern Kaya Matkabı",
          "pl": "Nowoczesne wiertło skalne",
          "ru": "Современный геологический бур",
          "uk": "Сучасний бур",
          "ko": "현대식 착암기",
          "zh": "现代凿岩机",
          "ja": "近代的な削岩ドリル"
        },
        {
          "id": "IronRockDrill",
          "en": "Iron Rock Drill",
          "fr": "Foreuse de roche en fer",
          "es": "Perforadora de hierro para rocas",
          "de": "Eisenfelsbohrer",
          "pt": "Perfuradora de Rocha de Ferro",
          "it": "Trapano da Roccia in Ferro",
          "tr": "Demir Kaya Matkabı",
          "pl": "Żelazne wiertło skalne",
          "ru": "Железный геологический бур",
          "uk": "Залізний геологічний бур",
          "ko": "철제 착암기",
          "zh": "铁凿岩机",
          "ja": "鉄の削岩ドリル"
        },
        {
          "id": "AmanitaMushroomSpores",
          "en": "Amanita Mushroom Spores",
          "fr": "Spores d\u0027amanite tue-mouches",
          "es": "Esporas de Amanita Muscaria",
          "de": "Sporen (Fliegenpilz)",
          "pt": "Esporos de Cogumelo Amanita",
          "it": "Spore di Ovolo Malefico",
          "tr": "Amanita Mantarı Sporları",
          "pl": "Zarodniki muchomora czerwonego",
          "ru": "Споры мухоморов",
          "uk": "Спори мухомора",
          "ko": "광대버섯 포자",
          "zh": "鹅膏菌孢子",
          "ja": "ベニテングダケの胞子"
        },
        {
          "id": "SteelSawBlade",
          "en": "Steel Saw Blade",
          "fr": "Lame de scie en acier",
          "es": "Sierra circular de acero",
          "de": "Stahlsägeblatt",
          "pt": "Lâmina de Serra de Aço",
          "it": "Lama da Sega in Acciaio",
          "tr": "Çelik Testere Bıçağı",
          "pl": "Stalowe Ostrze Piły",
          "ru": "Стальной пильный диск",
          "uk": "Сталевий пиляльний диск",
          "ko": "강철 톱날",
          "zh": "钢锯片",
          "ja": "鋼のノコ刃"
        },
        {
          "id": "SteelGearbox",
          "en": "Steel Gearbox",
          "fr": "Boîte de vitesses en acier",
          "es": "Caja de engranajes de acero",
          "de": "Stahlgetriebe",
          "pt": "Caixa de Transmissão de Aço",
          "it": "Cambio in Acciaio",
          "tr": "Çelik Dişli Kutusu",
          "pl": "Stalowa Skrzynia Biegów",
          "ru": "Стальная коробка передач",
          "uk": "Сталева коробка передач",
          "ko": "강철 변속장치",
          "zh": "钢齿轮箱",
          "ja": "鋼のギアボックス"
        },
        {
          "id": "RecurveBow",
          "en": "Recurve Bow",
          "fr": "Arc recourbé",
          "es": "Arco recurvo",
          "de": "Recurvebogen",
          "pt": "Arco Recurvo",
          "it": "Arco Ricurvo",
          "tr": "Çekmeli Yay",
          "pl": "Łuk Refleksyjny",
          "ru": "Изогнутый лук",
          "uk": "Вигнутий лук",
          "ko": "곡궁",
          "zh": "反曲弓",
          "ja": "リカーブボウ"
        },
        {
          "id": "IronSawBlade",
          "en": "Iron Saw Blade",
          "fr": "Lame de scie en fer",
          "es": "Sierra circular de hierro",
          "de": "Eisensägeblatt",
          "pt": "Lâmina de Serra de Ferro",
          "it": "Lama da Sega in Ferro",
          "tr": "Demir Testere Bıçağı",
          "pl": "Żelazne ostrze piły",
          "ru": "Железный пильный диск",
          "uk": "Залізний пиляльний диск",
          "ko": "철제 톱날",
          "zh": "铁锯片",
          "ja": "鉄のノコ刃"
        },
        {
          "id": "GoldWiring",
          "en": "Gold Wiring",
          "fr": "Fil d\u0027or",
          "es": "Cables de oro",
          "de": "Goldverdrahtung",
          "pt": "Fiação de Ouro",
          "it": "Cablaggio Dorato",
          "tr": "Altın Kablolama",
          "pl": "Złote okablowanie",
          "ru": "Золотой провод",
          "uk": "Золотий дріт",
          "ko": "금전선",
          "zh": "金接线",
          "ja": "金のワイヤー"
        },
        {
          "id": "AdvancedCircuit",
          "en": "Advanced Circuit",
          "fr": "Circuit avancé",
          "es": "Circuito avanzado",
          "de": "Fortschrittlicher Schaltkreis",
          "pt": "Circuito Avançado",
          "it": "Circuito Avanzato",
          "tr": "Gelişmiş Devre",
          "pl": "Zaawansowany Obwód",
          "ru": "Продвинутая электросхема",
          "uk": "Покращена електросхема",
          "ko": "고급 전자회로",
          "zh": "先进电路",
          "ja": "高度な回路"
        },
        {
          "id": "ToppedPorridge",
          "en": "Topped Porridge",
          "fr": "Porridge garni",
          "es": "Gachas con fruta",
          "de": "Verfeinertes Porridge",
          "pt": "Mingau coberto de frutas",
          "it": "Porridge Decorato",
          "tr": "Kaplı Yulaf Lapası",
          "pl": "Owsianka z owocami",
          "ru": "Каша с добавками",
          "uk": "Каша з добавками",
          "ko": "뭔가 추가된 죽",
          "zh": "稀饭",
          "ja": "具入りのお粥"
        },
        {
          "id": "RootCampfireStew",
          "en": "Root Campfire Stew",
          "fr": "Ragoût de racines cuit au feu de camp",
          "es": "Estofado braseado con raíces",
          "de": "Lagerfeuer Wurzeleintopf",
          "pt": "Ensopado de raiz feito na fogueira",
          "it": "Stufato di Radici da Falò",
          "tr": "Kamp Ateşinde Yahni",
          "pl": "Korzenny gulasz z ogniska",
          "ru": "Рагу из корнеплодов на костре",
          "uk": "Рагу приготоване багатті",
          "ko": "구근 모닥불 스튜",
          "zh": "根篝火炖汤",
          "ja": "野外料理の根菜シチュー"
        },
        {
          "id": "RootCampfireSalad",
          "en": "Root Campfire Salad",
          "fr": "Salade de racines cuite au feu de camp",
          "es": "Ensalada braseada con raíces",
          "de": "Lagerfeuer Wurzelsalat",
          "pt": "Salada de raiz feita na fogueira",
          "it": "Insalata di Radici da Falò",
          "tr": "Kamp Ateşinde Salata",
          "pl": "Korzenna sałatka z grilla",
          "ru": "Салат из корнеплодов на костре",
          "uk": "Салат приготований на багатті",
          "ko": "구근 모닥불 샐러드",
          "zh": "根篝火沙拉",
          "ja": "野外料理の根菜サラダ"
        },
        {
          "id": "PastryDough",
          "en": "Pastry Dough",
          "fr": "Pâte à tarte",
          "es": "Masa de pastelería",
          "de": "Teig",
          "pt": "Massa folhada",
          "it": "Pasta Sfoglia",
          "tr": "Milföy Böreği",
          "pl": "Kruche ciasto",
          "ru": "Кондитерские изделия",
          "uk": "Кондитерське тісто",
          "ko": "페이스트리 반죽",
          "zh": "糕点面团",
          "ja": "ペストリー生地"
        },
        {
          "id": "MeatyStew",
          "en": "Meaty Stew",
          "fr": "Ragoût de viande",
          "es": "Estofado de carne",
          "de": "Lagerfeuer Fleischeintopf",
          "pt": "Ensopado de carne",
          "it": "Stufato di Carne",
          "tr": "Etli Yahni",
          "pl": "Mięsny jeż",
          "ru": "Мясное рагу",
          "uk": "М\u0027ясна рагу",
          "ko": "고기 스튜",
          "zh": "肉炖",
          "ja": "肉のシチュー"
        },
        {
          "id": "LeavenedDough",
          "en": "Leavened Dough",
          "fr": "Pâte au levain",
          "es": "Masa con levadura",
          "de": "Hefeteig",
          "pt": "Massa fermentada",
          "it": "Impasto Lievitato",
          "tr": "Mayalı Hamur İşi",
          "pl": "Ciasto drożdżowe",
          "ru": "Дрожжевое тесто",
          "uk": "Дріжджове тісто",
          "ko": "발효된 반죽",
          "zh": "发酵面团",
          "ja": "発酵生地"
        },
        {
          "id": "JungleCampfireStew",
          "en": "Jungle Campfire Stew",
          "fr": "Ragoût de la jungle cuit au feu de camp",
          "es": "Estofado braseado con madera de jungla",
          "de": "Lagerfeuer Dschungeleintopf",
          "pt": "Ensopado da selva feito na fogueira",
          "it": "Stufato della Foresta al Falò",
          "tr": "Jungle Campfire Stew",
          "pl": "Tropikalny gulasz z ogniska",
          "ru": "Джунглевое рагу на костре",
          "uk": "Рагу",
          "ko": "정글 모닥불 스튜",
          "zh": "丛林篝火炖汤",
          "ja": "野外調理のジャングルシチュー"
        },
        {
          "id": "JungleCampfireSalad",
          "en": "Jungle Campfire Salad",
          "fr": "Salade de la jungle cuite au feu de camp",
          "es": "Ensalada braseada con madera de jungla",
          "de": "Lagerfeuer Dschungelsalat",
          "pt": "Salada da selva feita na fogueira",
          "it": "Insalata della Foresta al Falò",
          "tr": "Jungle Campfire Salad",
          "pl": "Tropikalna sałatka z grilla",
          "ru": "Джунглевый салат на костре",
          "uk": "Салат",
          "ko": "정글 모닥불 샐러드",
          "zh": "丛林篝火沙拉",
          "ja": "野外調理のジャングルサラダ"
        },
        {
          "id": "FruitTart",
          "en": "Fruit Tart",
          "fr": "Tarte aux fruits",
          "es": "Tarta de frutas",
          "de": "Obstkuchen",
          "pt": "Torta de frutas",
          "it": "Crostata di Frutta",
          "tr": "Meyve Turtası",
          "pl": "Tarta owocowa",
          "ru": "Фруктовый тарт",
          "uk": "Фруктовий тарт",
          "ko": "과일 타르트",
          "zh": "水果馅饼",
          "ja": "フルーツのタルト"
        },
        {
          "id": "FruitMuffin",
          "en": "Fruit Muffin",
          "fr": "Muffin aux fruits",
          "es": "Muffin de fruta",
          "de": "Fruchtmuffin",
          "pt": "Muffin de frutas",
          "it": "Muffin di Frutta",
          "tr": "Meyveli Çörek",
          "pl": "Babeczka owocowa",
          "ru": "Фруктовый кекс",
          "uk": "Фруктовий мафін",
          "ko": "과일 머핀",
          "zh": "水果松饼",
          "ja": "フルーツのマフィン"
        },
        {
          "id": "FriedTaro",
          "en": "Fried Taro",
          "fr": "Taro frit",
          "es": "Taro frito",
          "de": "Frittierte Taro",
          "pt": "Inhame frito",
          "it": "Taro Fritto",
          "tr": "Kızarmış Kulkas",
          "pl": "Smażona kolokazja",
          "ru": "Жареный таро",
          "uk": "Смажене Таро",
          "ko": "튀긴 토란",
          "zh": "炸芋头",
          "ja": "揚げたタロイモ"
        },
        {
          "id": "FriedHeartsOfPalm",
          "en": "Fried Hearts Of Palm",
          "fr": "Cœur de palmier frit",
          "es": "Palmitos fritos",
          "de": "Frittierte Palmherzen",
          "pt": "Palmitos fritos",
          "it": "Cuori Di Palma Fritti",
          "tr": "Kızarmış Palmiye Kalbi",
          "pl": "Smażone serca palmy",
          "ru": "Жареные сердцевины пальмы",
          "uk": "Смажені пальмові серцевини",
          "ko": "튀긴 야자심",
          "zh": "棕榈炒心",
          "ja": "揚げたパルミット"
        },
        {
          "id": "FriedFiddleheads",
          "en": "Fried Fiddleheads",
          "fr": "Fougères frits",
          "es": "Brotes de helecho fritos",
          "de": "Frittierte Farnspitzen",
          "pt": "Brotos de samambaia fritos",
          "it": "Germogli di Felce Fritti",
          "tr": "Kızarmış Eğreltiotu Ucu",
          "pl": "Smażone liście młodej paproci",
          "ru": "Жареный папоротник",
          "uk": "Смажена папороть",
          "ko": "튀긴 고사리",
          "zh": "炸羊肠",
          "ja": "揚げたワラビ巻"
        },
        {
          "id": "FriedCamas",
          "en": "Fried Camas",
          "fr": "Camassias frits",
          "es": "Camasia frita",
          "de": "Frittierte Prärielilien",
          "pt": "Camassias fritas",
          "it": "Camassia Fritta",
          "tr": "Kızarmış Cama",
          "pl": "Smażona kamasja",
          "ru": "Жареная камассия",
          "uk": "Смажений Камас",
          "ko": "튀긴 카마스",
          "zh": "炸卡马斯",
          "ja": "揚げたカマシア"
        },
        {
          "id": "FieldCampfireStew",
          "en": "Field Campfire Stew",
          "fr": "Ragoût des prairies cuit au feu de camp",
          "es": "Ensalada braseada campestre",
          "de": "Lagerfeuer Feldeintopf",
          "pt": "Ensopado do campo feito na fogueira",
          "it": "Stufato di Campo al Falò",
          "tr": "Field Campfire Stew",
          "pl": "Chłopski gulasz z ogniska",
          "ru": "Полевое рагу на костре",
          "uk": "Польове рагу",
          "ko": "들판 모닥불 스튜",
          "zh": "野营篝火炖汤",
          "ja": "野外調理の大地のシチュー"
        },
        {
          "id": "FernCampfireSalad",
          "en": "Fern Campfire Salad",
          "fr": "Salade de fougères cuite au feu de camp",
          "es": "Ensalada braseada con helechos",
          "de": "Lagerfeuer Farnspitzensalat",
          "pt": "Salada de samambaia feita na fogueira",
          "it": "Insalata di Felce da Falò",
          "tr": "Fern Campfire Salad",
          "pl": "Paprotna sałatka z grilla",
          "ru": "Салат из папоротника на костре",
          "uk": "Салат із папороті",
          "ko": "고사리 모닥불 샐러드",
          "zh": "蕨篝火沙拉",
          "ja": "野外料理のワラビサラダ"
        },
        {
          "id": "CharredMushrooms",
          "en": "Charred Mushrooms",
          "fr": "Champignons carbonisés",
          "es": "Champiñones carbonizados",
          "de": "Gegrillte Pilze",
          "pt": "Cogumelos tostados",
          "it": "Funghi Carbonizzati",
          "tr": "Güveçte Mantar",
          "pl": "Opiekane grzyby",
          "ru": "Грибы на углях",
          "uk": "Гриби на вугіллі",
          "ko": "그슬린 버섯",
          "zh": "烧焦的蘑菇",
          "ja": "焦げたマッシュルーム"
        },
        {
          "id": "CharredHeartOfPalm",
          "en": "Charred Heart Of Palm",
          "fr": "Cœur de palmier carbonisé",
          "es": "Palmito carbonizado",
          "de": "Gegrillte Palmherzen",
          "pt": "Palmito tostado",
          "it": "Cuore di Palma Carbonizzato",
          "tr": "Charred Heart Of Palm",
          "pl": "Opiekane serce palmy",
          "ru": "Сердцевина пальмы на углях",
          "uk": "Серцевина пальми",
          "ko": "그슬린 야자심",
          "zh": "烧焦的棕榈心",
          "ja": "焦げたパルミット"
        },
        {
          "id": "CharredFireweedShoots",
          "en": "Charred Fireweed Shoots",
          "fr": "Pousses d\u0027épilobe carbonisées",
          "es": "Brotes de epilobio carbonizados",
          "de": "Gegrillte Weidenröschen",
          "pt": "Brotos de fireweed tostados",
          "it": "Germogli di Camenerio Carbonizzati",
          "tr": "Pişmiş Yakı Otu Filizleri",
          "pl": "Opiekane Pędy Wierzbówki",
          "ru": "Иван-чай на углях",
          "uk": "Іван-чай на вуглях",
          "ko": "그슬린 분홍바늘꽃 순",
          "zh": "烧焦的杂草芽",
          "ja": "焦げたヤナギランの新芽"
        },
        {
          "id": "CharredCactusFruit",
          "en": "Charred Cactus Fruit",
          "fr": "Fruit de saguaro carbonisé",
          "es": "Fruto de cactus carbonizado",
          "de": "Gegrillte Kaktusfrucht",
          "pt": "Fruto de cacto tostado",
          "it": "Frutto di Cactus Carbonizzato",
          "tr": "Charred Cactus Fruit",
          "pl": "Opiekany Owoc Kaktusa",
          "ru": "Плод сагуаро на углях",
          "uk": "Опунція",
          "ko": "그슬린 백년초",
          "zh": "烧焦的仙人掌果",
          "ja": "焦げたサボテンの実"
        },
        {
          "id": "CharredBeans",
          "en": "Charred Beans",
          "fr": "Haricots carbonisés",
          "es": "Judías carbonizadas",
          "de": "Gegrillte Bohnen",
          "pt": "Feijões tostados",
          "it": "Fagioli Carbonizzati",
          "tr": "Charred Beans",
          "pl": "Opiekana Fasola",
          "ru": "Бобы на углях",
          "uk": "Квасоля",
          "ko": "그슬린 콩",
          "zh": "烧焦的豆",
          "ja": "焦げた豆"
        },
        {
          "id": "BoiledGrains",
          "en": "Boiled Grains",
          "fr": "Grains bouillis",
          "es": "Granos hervidos",
          "de": "Einfaches Porridge",
          "pt": "Grãos fervidos",
          "it": "Grani Bolliti",
          "tr": "Haşlanmış Tahıl",
          "pl": "Ugotowane ziarna",
          "ru": "Варёные зерна",
          "uk": "Зварене зерно",
          "ko": "삶은 곡물",
          "zh": "水煮谷物",
          "ja": "茹でた穀物"
        },
        {
          "id": "BeetCampfireSalad",
          "en": "Beet Campfire Salad",
          "fr": "Salade de betteraves cuite au feu de camp",
          "es": "Ensalada de remolacha braseada",
          "de": "Lagefeuer Rote Bete Salat",
          "pt": "Salada de beterraba feita na fogueira",
          "it": "Insalata di Bietole sul Falò",
          "tr": "Beet Campfire Salad",
          "pl": "Sałatka z grillowanego buraka",
          "ru": "Свекольный салат на костре",
          "uk": "Буряковий салат",
          "ko": "사탕무 모닥불 샐러드",
          "zh": "甜菜篝火沙拉",
          "ja": "野外料理のビートサラダ"
        },
        {
          "id": "BakedTomato",
          "en": "Baked Tomato",
          "fr": "Tomate au four",
          "es": "Tomate horneado",
          "de": "Gebackene Tomaten",
          "pt": "Tomate assado",
          "it": "Pomodoro Cotto",
          "tr": "Kavrulmuş Domates",
          "pl": "Pieczony pomidor",
          "ru": "Запеченный помидор",
          "uk": "Печений томат",
          "ko": "구운 토마토",
          "zh": "烤番茄",
          "ja": "焼いたトマト"
        },
        {
          "id": "BakedTaro",
          "en": "Baked Taro",
          "fr": "Taro au four",
          "es": "Taro cocinado",
          "de": "Gebackene Taro",
          "pt": "Inhame assado",
          "it": "Taro Cotto",
          "tr": "Kavrulmuş Gölevez",
          "pl": "Pieczona kolokazja",
          "ru": "Запечённый корень таро",
          "uk": "Печений дашин",
          "ko": "구운 토란",
          "zh": "烤芋头",
          "ja": "焼いたタロイモ"
        },
        {
          "id": "BakedHeartOfPalm",
          "en": "Baked Heart Of Palm",
          "fr": "Cœur de palmier au four",
          "es": "Palmito horneado",
          "de": "Gebackene Palmherzen",
          "pt": "Palmito assado",
          "it": "Cuore Di Palma Cotto",
          "tr": "Kavrulmuş Palmiye Kalbi",
          "pl": "Pieczone serce palmy",
          "ru": "Запечённая сердцевина пальмы",
          "uk": "Запечена серцевина пальми",
          "ko": "구운 야자심",
          "zh": "掌心焗",
          "ja": "焼いたパルミット"
        },
        {
          "id": "BakedCorn",
          "en": "Baked Corn",
          "fr": "Maïs au four",
          "es": "Maíz horneado",
          "de": "Gebackener Mais",
          "pt": "Milho assado",
          "it": "Mais Cotto",
          "tr": "Kavrulmuş Mısır",
          "pl": "Pieczona kukurydza",
          "ru": "Запечённая кукуруза",
          "uk": "Запечена кукурудза",
          "ko": "구운 옥수수",
          "zh": "烤玉米",
          "ja": "焼いたトウモロコシ"
        },
        {
          "id": "BakedBeet",
          "en": "Baked Beet",
          "fr": "Betterave au four",
          "es": "Remolacha horneada",
          "de": "Gebackene Rote Bete",
          "pt": "Beterraba assada",
          "it": "Bietola Cotta",
          "tr": "Kavrulmuş Pancar",
          "pl": "Pieczony burak",
          "ru": "Запечённая свекла",
          "uk": "Запечений буряк",
          "ko": "구운 사탕무",
          "zh": "烤甜菜",
          "ja": "焼いたビート"
        },
        {
          "id": "SteelBar",
          "en": "Steel Bar",
          "fr": "Lingot d\u0027acier",
          "es": "Lingote de acero",
          "de": "Stahlbarren",
          "pt": "Barra de aço",
          "it": "Lingotto d\u0027Acciaio",
          "tr": "Çelik Bar",
          "pl": "Sztabka stali",
          "ru": "Стальной брусок",
          "uk": "Стальний брусок",
          "ko": "강철괴",
          "zh": "钢筋",
          "ja": "鋼のインゴット"
        },
        {
          "id": "IronConcentrate",
          "en": "Iron Concentrate",
          "fr": "Concentré de fer",
          "es": "Concentrado de hierro",
          "de": "Eisenkonzentrat",
          "pt": "Concentrado de ferro",
          "it": "Concentrato di Ferro",
          "tr": "Demir Konsantresi",
          "pl": "Koncentrat żelaza",
          "ru": "Концентрат железа",
          "uk": "Концентрат Заліза",
          "ko": "정제된 철광석",
          "zh": "筛选铁矿石",
          "ja": "鉄の精鉱"
        },
        {
          "id": "GoldConcentrate",
          "en": "Gold Concentrate",
          "fr": "Concentré d\u0027or",
          "es": "Concentrado de oro",
          "de": "Goldkonzentrat",
          "pt": "Concentrado de ouro",
          "it": "Concentrato d\u0027Oro",
          "tr": "Altın Konsantresi",
          "pl": "Koncentrat złota",
          "ru": "Концентрат золота",
          "uk": "Концентрат золота",
          "ko": "정제된 금광석",
          "zh": "筛选金矿石",
          "ja": "金の精鉱"
        },
        {
          "id": "CrushedShale",
          "en": "Crushed Shale",
          "fr": "Schiste concassé",
          "es": "Pizarra triturada",
          "de": "Zerkleinerter Schiefer",
          "pt": "Xisto triturado",
          "it": "Scisto Spaccato",
          "tr": "Kırma Kil",
          "pl": "Pokruszony łupek",
          "ru": "Сланцевый щебень",
          "uk": "Подрібнений сланець",
          "ko": "파쇄된 이판암",
          "zh": "破碎页岩",
          "ja": "粉砕した頁岩"
        },
        {
          "id": "CrushedSandstone",
          "en": "Crushed Sandstone",
          "fr": "Grès concassé",
          "es": "Arenisca triturada",
          "de": "Zerkleinerter Sandstein",
          "pt": "Arenito triturado",
          "it": "Arenaria Spaccata",
          "tr": "Kırma Kumtaşı",
          "pl": "Pokruszony piaskowiec",
          "ru": "Щебень из песчаника",
          "uk": "Подрібнений піщаник",
          "ko": "파쇄된 사암",
          "zh": "破碎砂岩",
          "ja": "粉砕した砂岩"
        },
        {
          "id": "CrushedLimestone",
          "en": "Crushed Limestone",
          "fr": "Calcaire concassé",
          "es": "Piedra caliza triturada",
          "de": "Zerkleinerter Kalkstein",
          "pt": "Calcário triturado",
          "it": "Calcare Spaccato",
          "tr": "Kırma Kireç Taşı",
          "pl": "Pokruszony wapień",
          "ru": "Известняковый щебень",
          "uk": "Вапняковий щебінь",
          "ko": "파쇄된 석회암",
          "zh": "破碎石灰岩",
          "ja": "粉砕した石灰岩"
        },
        {
          "id": "CrushedIronOre",
          "en": "Crushed Iron Ore",
          "fr": "Minerai de fer concassé",
          "es": "Mineral de hierro triturado",
          "de": "Zerkleinertes Eisenerz",
          "pt": "Minério de ferro triturado",
          "it": "Ferro Spaccato",
          "tr": "Kırma Demir Cevheri",
          "pl": "Pokruszona ruda żelaza",
          "ru": "Дроблёная железная руда",
          "uk": "Подрібнена залізна руда",
          "ko": "파쇄된 철광석",
          "zh": "破碎铁矿石",
          "ja": "粉砕した鉄鉱石"
        },
        {
          "id": "CrushedGranite",
          "en": "Crushed Granite",
          "fr": "Granite concassé",
          "es": "Granito triturado",
          "de": "Zerkleinerter Granit",
          "pt": "Granito triturado",
          "it": "Granito Spaccato",
          "tr": "Kırma Granit",
          "pl": "Pokruszony granit",
          "ru": "Гранитный щебень",
          "uk": "Подрібнений граніт",
          "ko": "파쇄된 화강암",
          "zh": "破碎花岗岩",
          "ja": "粉砕した花崗岩"
        },
        {
          "id": "CrushedGoldOre",
          "en": "Crushed Gold Ore",
          "fr": "Minerai d\u0027or concassé",
          "es": "Mineral de oro triturado",
          "de": "Zerkleinertes Golderz",
          "pt": "Minério de ouro triturado",
          "it": "Oro Spaccato",
          "tr": "Kırma Altın Cevheri",
          "pl": "Pokruszona ruda złota",
          "ru": "Дроблёная золотая руда",
          "uk": "Подрібнена золота руда",
          "ko": "파쇄된 금광석",
          "zh": "破碎金矿石",
          "ja": "粉砕した金鉱石"
        },
        {
          "id": "CrushedCopperOre",
          "en": "Crushed Copper Ore",
          "fr": "Minerai de cuivre concassé",
          "es": "Mineral de cobre triturado",
          "de": "Zerkleinertes Kupfererz",
          "pt": "Minério de cobre triturado",
          "it": "Rame Spaccato",
          "tr": "Kırma Bakır Cevheri",
          "pl": "Pokruszona ruda miedzi",
          "ru": "Дроблёная медная руда",
          "uk": "Подрібнена мідна руда",
          "ko": "파쇄된 구리 광석",
          "zh": "破碎铜矿石",
          "ja": "粉砕した銅鉱石"
        },
        {
          "id": "CrushedCoal",
          "en": "Crushed Coal",
          "fr": "Charbon concassé",
          "es": "Carbón triturado",
          "de": "Zerkleinerte Kohle",
          "pt": "Carvão Triturado",
          "it": "Carbone Spaccato",
          "tr": "Kırılmış Kömür",
          "pl": "Pokruszony węgiel",
          "ru": "Дроблёный уголь",
          "uk": "Подрібнене вугілля",
          "ko": "파쇄된 석탄",
          "zh": "破碎煤矿石",
          "ja": "粉砕した石炭"
        },
        {
          "id": "CopperConcentrate",
          "en": "Copper Concentrate",
          "fr": "Concentré de cuivre",
          "es": "Concentrado de cobre",
          "de": "Kupferkonzentrat",
          "pt": "Concentrado de cobre",
          "it": "Concentrato di Rame",
          "tr": "Bakır Konsantresi",
          "pl": "Koncentrat miedzi",
          "ru": "Концентрат меди",
          "uk": "Концентрат міді",
          "ko": "정제된 구리 광석",
          "zh": "筛选铜矿石",
          "ja": "銅の精鉱"
        },
        {
          "id": "CompositeLumber",
          "en": "Composite Lumber",
          "fr": "Bois composite",
          "es": "Tronco (composite)",
          "de": "Verbundholz",
          "pt": "Madeira serrada composta",
          "it": "Legname Composito",
          "tr": "Kompozit Kereste",
          "pl": "Kompozytowe drewno",
          "ru": "Композитные пиломатериалы",
          "uk": "Композитні пиломатеріали",
          "ko": "합성 가공된 목재",
          "zh": "复合木材",
          "ja": "複合材"
        },
        {
          "id": "AshlarShale",
          "en": "Ashlar Shale",
          "fr": "Schiste taillé",
          "es": "Pizarra (sillar)",
          "de": "Quader aus Schiefer",
          "pt": "Xisto polido",
          "it": "Scisto Bugnato",
          "tr": "Kesme Kil",
          "pl": "Ciosany łupek",
          "ru": "Резной сланец",
          "uk": "Обтесаний сланець",
          "ko": "각진 이판암",
          "zh": "方琢页岩",
          "ja": "頁岩の切石"
        },
        {
          "id": "AshlarSandstone",
          "en": "Ashlar Sandstone",
          "fr": "Grès taillé",
          "es": "Sillar de arenisca",
          "de": "Quader aus Sandstein",
          "pt": "Arenito polido",
          "it": "Arenaria Bugnata",
          "tr": "Kesme Kumtaşı",
          "pl": "Ciosany piaskowiec",
          "ru": "Резной песчаник",
          "uk": " Обтесаний піщаник",
          "ko": "각진 사암",
          "zh": "方琢砂岩",
          "ja": "砂岩の切石"
        },
        {
          "id": "AshlarLimestone",
          "en": "Ashlar Limestone",
          "fr": "Calcaire taillé",
          "es": "Sillar de piedra caliza",
          "de": "Quader aus Kalkstein",
          "pt": "Calcário polido",
          "it": "Calcare Bugnato",
          "tr": "Kesme Kireç Taşı",
          "pl": "Ciosany wapień",
          "ru": "Резной известняк",
          "uk": "Різьблений Вапняк",
          "ko": "각진 석회암",
          "zh": "方琢石灰石",
          "ja": "石灰岩の切石"
        },
        {
          "id": "AshlarGranite",
          "en": "Ashlar Granite",
          "fr": "Granite taillé",
          "es": "Sillar de granito",
          "de": "Quader aus Granit",
          "pt": "Granito polido",
          "it": "Granito Bugnato",
          "tr": "Kesme Granit",
          "pl": "Ciosany granit",
          "ru": "Резной гранит",
          "uk": "Різьблений Граніт",
          "ko": "각진 화강암",
          "zh": "方琢花岗岩",
          "ja": "花崗岩の切石"
        },
        {
          "id": "AshlarGneiss",
          "en": "Ashlar Gneiss",
          "fr": "Gneiss taillé",
          "es": "Sillar de gneis",
          "de": "Quader aus Gneis",
          "pt": "Gnaisse polido",
          "it": "Gneiss Bugnato",
          "tr": "Kesme Gnays",
          "pl": "Ciosany gnejs",
          "ru": "Резной гнейс",
          "uk": "Різьблений гнейс",
          "ko": "각진 편마암",
          "zh": "方琢片麻岩",
          "ja": "片麻岩の切石"
        },
        {
          "id": "AshlarBasalt",
          "en": "Ashlar Basalt",
          "fr": "Basalte taillé",
          "es": "Sillar de basalto",
          "de": "Quader aus Basalt",
          "pt": "Basalto polido",
          "it": "Basalto Bugnato",
          "tr": "Kesme Bazalt",
          "pl": "Ciosany bazalt",
          "ru": "Резной базальт",
          "uk": "Різьблений Базальт",
          "ko": "각진 현무암",
          "zh": "方琢玄武岩",
          "ja": "玄武岩の切石"
        },
        {
          "id": "Toilet",
          "en": "Toilet",
          "fr": "Toilette",
          "es": "Baño",
          "de": "Toilette",
          "pt": "Vaso Sanitário",
          "it": "Toilet",
          "tr": "Klozet",
          "pl": "Toaleta",
          "ru": "Туалет",
          "uk": "Туалет",
          "ko": "좌변기",
          "zh": "厕所",
          "ja": "Toilet"
        },
        {
          "id": "StuffedWolf",
          "en": "Stuffed Wolf",
          "fr": "Loup empaillé",
          "es": "Lobo disecado",
          "de": "Ausgestopfter Wolf",
          "pt": "Lobo Empalhado",
          "it": "Lupo Impagliato",
          "tr": "Doldurulmuş Kurt",
          "pl": "Wypchany wilk",
          "ru": "Чучело волка",
          "uk": "Опудало вовка",
          "ko": "박제된 늑대",
          "zh": "狼标本",
          "ja": "Stuffed Wolf"
        },
        {
          "id": "StuffedJaguar",
          "en": "Stuffed Jaguar",
          "fr": "Jaguar empaillé",
          "es": "Jaguar disecado",
          "de": "Ausgestopfter Jaguar",
          "pt": "Onça-pintada Empalhada",
          "it": "Giaguaro Impagliato",
          "tr": "Doldurulmuş Jaguar",
          "pl": "Wypchany jaguar",
          "ru": "Чучело ягуара",
          "uk": "Опудало ягуара",
          "ko": "박제된 재규어",
          "zh": "美洲豹标本",
          "ja": "Stuffed Jaguar"
        },
        {
          "id": "StuffedGoat",
          "en": "Stuffed Goat",
          "fr": "Chèvre des montagnes empaillé",
          "es": "Cabra disecada",
          "de": "Ausgestopfte Ziege",
          "pt": "Cabra Empalhada",
          "it": "Capra Impagliata",
          "tr": "Doldurulmuş Keçi",
          "pl": "Wypchana koza",
          "ru": "Чучело козы",
          "uk": "Опудало кози",
          "ko": "박제된 염소",
          "zh": "山羊标本",
          "ja": "Stuffed Goat"
        },
        {
          "id": "StuffedBison",
          "en": "Stuffed Bison",
          "fr": "Bison empaillé",
          "es": "Bisón disecado",
          "de": "Ausgestopftes Bison",
          "pt": "Bisão Empalhado",
          "it": "Bisonte Impagliato",
          "tr": "Doldurulmuş Bufalo",
          "pl": "Wypchany żubr",
          "ru": "Чучело бизона",
          "uk": "Опудало бізона",
          "ko": "박제된 들소",
          "zh": "野牛标本",
          "ja": "Stuffed Bison"
        },
        {
          "id": "StuffedAlligator",
          "en": "Stuffed Alligator",
          "fr": "Alligator empaillé",
          "es": "Caimán disecado",
          "de": "Ausgestopfter Alligator",
          "pt": "Jacaré Empalhado",
          "it": "Alligatore Impagliato",
          "tr": "Doldurulmuş Timsah",
          "pl": "Wypchany aligator",
          "ru": "Чучело аллигатора",
          "uk": "Опудало алігатора",
          "ko": "박제된 악어",
          "zh": "鳄鱼标本",
          "ja": "Stuffed Alligator"
        },
        {
          "id": "SmallStandingMortaredStoneSign",
          "en": "Small Standing Mortared Stone Sign",
          "fr": "Petit panneau sur pied en pierre cimenté",
          "es": "Letrero pequeño (piedra con mortero)",
          "de": "Steinziegelschild (klein",
          "pt": "소형 모르타르 마감 석재 간판",
          "it": "Маленькая табличка из строительного камня",
          "tr": "Small Standing Mortared Stone Sign",
          "pl": "Small Standing Mortared Stone Sign",
          "ru": "小型立式砂浆石标志",
          "uk": "Small Standing Mortared Stone Sign",
          "ko": " stehend)",
          "zh": "Placa de Pedra Argamassada Pequena em Pé",
          "ja": "Small Standing Mortared Stone Sign"
        },
        {
          "id": "SmallStandingAshlarStoneSign",
          "en": "Small Standing Ashlar Stone Sign",
          "fr": "Petit panneau sur pied en pierre taillé",
          "es": "Letrero pequeño (sillar de piedra)",
          "de": "Steinquaderschild (klein",
          "pt": "소형 각진 석재 간판",
          "it": "Маленькая табличка из резного камня",
          "tr": "Small Standing Ashlar Stone Sign",
          "pl": "Small Standing Ashlar Stone Sign",
          "ru": "小型立式方琢石标志",
          "uk": "Small Standing Ashlar Stone Sign",
          "ko": " stehend)",
          "zh": "Placa de Pedra Polida Pequena em Pé",
          "ja": "Small Standing Ashlar Stone Sign"
        },
        {
          "id": "SmallSink",
          "en": "Small Sink",
          "fr": "Petit lavabo",
          "es": "Fregadero pequeño",
          "de": "Kleines Waschbecken",
          "pt": "Pia Pequena",
          "it": "Piccolo Scarico",
          "tr": "Ufak Lavabo",
          "pl": "Mały zlew",
          "ru": "Маленькая раковина",
          "uk": "Мала раковина",
          "ko": "작은 개수대",
          "zh": "小水槽",
          "ja": "Small Sink"
        },
        {
          "id": "SmallHangingMortaredStoneSign",
          "en": "Small Hanging Mortared Stone Sign",
          "fr": "Petit panneau suspendu en pierre cimentée",
          "es": "Letrero colgante pequeño (mortero)",
          "de": "Steinziegelschild (klein",
          "pt": "소형 모르타르 마감 석재 간판",
          "it": "Маленькая вывеска из строительного камня",
          "tr": "Small Hanging Mortared Stone Sign",
          "pl": "Small Hanging Mortared Stone Sign",
          "ru": "小型悬挂砂浆石标志",
          "uk": "Small Hanging Mortared Stone Sign",
          "ko": " hängend)",
          "zh": "Placa de Pedra Argamassada Pequena Pendurada",
          "ja": "Small Hanging Mortared Stone Sign"
        },
        {
          "id": "SmallHangingAshlarStoneSign",
          "en": "Small Hanging Ashlar Stone Sign",
          "fr": "Petit panneau suspendu en pierre taillé",
          "es": "Letrero colgante pequeño (sillar de piedra)",
          "de": "Steinquaderschild (klein",
          "pt": "소형 각진 석재 현판",
          "it": "Маленькая вывеска из резного камня",
          "tr": "Small Hanging Ashlar Stone Sign",
          "pl": "Small Hanging Ashlar Stone Sign",
          "ru": "小型悬挂方琢标志",
          "uk": "Small Hanging Ashlar Stone Sign",
          "ko": " hängend)",
          "zh": "Placa de Pedra Polida Pequena Pendurada",
          "ja": "Small Hanging Ashlar Stone Sign"
        },
        {
          "id": "SheepMount",
          "en": "Sheep Mount",
          "fr": "Trophée de mouflon",
          "es": "Montura de borrego",
          "de": "Ausgestopftes Bergschaf",
          "pt": "Cabeça de Carneiro",
          "it": "Pecora",
          "tr": "Koyun Binek",
          "pl": "Owcza Góra",
          "ru": "Голова барана",
          "uk": "Голова барана",
          "ko": "박제된 양 벽걸이",
          "zh": "羊山",
          "ja": "Sheep Mount"
        },
        {
          "id": "MortaredStoneDoor",
          "en": "Mortared Stone Door",
          "fr": "Porte en pierre cimentée",
          "es": "Puerta de piedra con mortero",
          "de": "Steinziegeltür",
          "pt": "Porta de Pedra Argamassada",
          "it": "Pietra in Pietra Pestata",
          "tr": "Harçlı Taştan Kapı",
          "pl": "Cementowane kamienne drzwi",
          "ru": "Дверь из строительного камня",
          "uk": "Двері з будівельного каміння",
          "ko": "모르타르 마감 석재 문",
          "zh": "砂浆石门",
          "ja": "Mortared Stone Door"
        },
        {
          "id": "LimestoneWolfStatue",
          "en": "Limestone Wolf Statue",
          "fr": "Statue de loup en calcaire",
          "es": "Estatura de lobo (piedra caliza)",
          "de": "Kalksteinstatue Wolf",
          "pt": "Estátua de Lobo de Calcário",
          "it": "Statua in Calcare del Lupo",
          "tr": "Kireç Taşından Kurt Heykeli",
          "pl": "Wapienna statua wilka",
          "ru": "Статуя волка из известняка",
          "uk": "Статуя вовка з вапняку",
          "ko": "석회암 늑대 조각상",
          "zh": "石灰石狼雕像",
          "ja": "オオカミの石像「石灰岩」"
        },
        {
          "id": "LimestoneOwlStatue",
          "en": "Limestone Owl Statue",
          "fr": "Statue de hibou en calcaire",
          "es": "Estatura de búho (piedra caliza)",
          "de": "Kalksteinstatue Eule",
          "pt": "Estátua de Coruja de Calcário",
          "it": "Statua in Calcare del Gufo",
          "tr": "Kireç Taşından Baykuş Heykeli",
          "pl": "Wapienna statua sowy",
          "ru": "Статуя совы из известняка",
          "uk": "Статуя сови з вапняку",
          "ko": "석회암 부엉이 조각상",
          "zh": "石灰石猫头鹰雕像",
          "ja": "フクロウの石像「石灰岩」"
        },
        {
          "id": "LimestoneOtterStatue",
          "en": "Limestone Otter Statue",
          "fr": "Statue de loutre en calcaire",
          "es": "Estatua de nutria (piedra caliza)",
          "de": "Kalksteinstatue Otter",
          "pt": "Estátua de Lontra de Calcário",
          "it": "Statua in Calcare della Lontra",
          "tr": "Kireç Taşından Su Samuru Heykeli",
          "pl": "Wapienna statua wydry",
          "ru": "Статуя выдры из известняка",
          "uk": "Статуя видри з вапняку",
          "ko": "석회암 수달 조각상",
          "zh": "石灰石水獭雕像",
          "ja": "カワウソの石像「石灰岩」"
        },
        {
          "id": "LimestoneBisonStatue",
          "en": "Limestone Bison Statue",
          "fr": "Statue de bison en calcaire",
          "es": "Estatua de bisonte (piedra caliza)",
          "de": "Kalksteinstatue Bison",
          "pt": "Estátua de Bisão de Calcário",
          "it": "Statua in Calcare del Bisonte",
          "tr": "Kireç Taşından Bufalo Heykeli",
          "pl": "Wapienna statua bizona",
          "ru": "Статуя бизона из известняка",
          "uk": "Статуя бізона з вапняку",
          "ko": "석회암 들소 조각상",
          "zh": "石灰石野牛雕像",
          "ja": "バイソンの石像「石灰岩」"
        },
        {
          "id": "LargeStandingMortaredStoneSign",
          "en": "Large Standing Mortared Stone Sign",
          "fr": "Grand panneau sur pied en pierre cimentée",
          "es": "Letrero grande (piedra con mortero)",
          "de": "Steinziegelschild (Groß",
          "pt": "대형 모르타르 마감 석재 간판",
          "it": "Большая табличка из строительного камня",
          "tr": "Large Standing Mortared Stone Sign",
          "pl": "Large Standing Mortared Stone Sign",
          "ru": "大型立式砂浆石标志",
          "uk": "Large Standing Mortared Stone Sign",
          "ko": " stehend)",
          "zh": "Placa de Pedra Argamassada Grande em Pé",
          "ja": "Large Standing Mortared Stone Sign"
        },
        {
          "id": "LargeStandingAshlarStoneSign",
          "en": "Large Standing Ashlar Stone Sign",
          "fr": "Grand panneau sur pied en pierre taillée",
          "es": "Letrero grande (sillar de piedra)",
          "de": "Steinquaderschild (Groß",
          "pt": "대형 각진 석재 현판",
          "it": "Большая табличка из резного камня",
          "tr": "Large Standing Ashlar Stone Sign",
          "pl": "Large Standing Ashlar Stone Sign",
          "ru": "大型立方琢石标志",
          "uk": "Large Standing Ashlar Stone Sign",
          "ko": " stehend)",
          "zh": "Placa de Pedra Polida Grande em Pé",
          "ja": "Large Standing Ashlar Stone Sign"
        },
        {
          "id": "LargeHangingMortaredStoneSign",
          "en": "Large Hanging Mortared Stone Sign",
          "fr": "Grand panneau suspendu en pierre cimentée",
          "es": "Letrero colgante grande (piedra con mortero)",
          "de": "Steinziegelschild (Groß",
          "pt": "대형 모르타르 마감 석재 현판",
          "it": "Большая вывеска из строительного камня",
          "tr": "Large Hanging Mortared Stone Sign",
          "pl": "Large Hanging Mortared Stone Sign",
          "ru": "大型悬挂砂浆石标志",
          "uk": "Large Hanging Mortared Stone Sign",
          "ko": " hängend)",
          "zh": "Placa de Pedra Argamassada Grande Pendurada",
          "ja": "Large Hanging Mortared Stone Sign"
        },
        {
          "id": "LargeHangingAshlarStoneSign",
          "en": "Large Hanging Ashlar Stone Sign",
          "fr": "Grand panneau suspendu en pierre taillée",
          "es": "Letrero colgante grande (sillar de piedra)",
          "de": "Steinquaderschild (Groß",
          "pt": "대형 각진 석재 현판",
          "it": "Большая вывеска из резного камня",
          "tr": "Large Hanging Ashlar Stone Sign",
          "pl": "Large Hanging Ashlar Stone Sign",
          "ru": "大型吊石板标志",
          "uk": "Large Hanging Ashlar Stone Sign",
          "ko": " hängend)",
          "zh": "Placa de Pedra Polida Grande Pendurada",
          "ja": "Large Hanging Ashlar Stone Sign"
        },
        {
          "id": "GoatMount",
          "en": "Goat Mount",
          "fr": "Trophée de chèvre des montagnes",
          "es": "Montura para cabra",
          "de": "Ausgestopfte Bergziege",
          "pt": "Cabeça de Cabra",
          "it": "Capra",
          "tr": "Keçi Binek",
          "pl": "Kozia Góra",
          "ru": "Голова козы",
          "uk": "Голова кози",
          "ko": "박제된 염소 벽걸이",
          "zh": "山羊山",
          "ja": "Goat Mount"
        },
        {
          "id": "Bathtub",
          "en": "Bathtub",
          "fr": "Baignoire",
          "es": "Bañera",
          "de": "Badewanne",
          "pt": "Banheira",
          "it": "Vasca da Bagno",
          "tr": "Banyo",
          "pl": "Wanna",
          "ru": "Ванна",
          "uk": "Ванна",
          "ko": "욕조",
          "zh": "浴缸",
          "ja": "Bathtub"
        },
        {
          "id": "AshlarStoneDoor",
          "en": "Ashlar Stone Door",
          "fr": "Porte en pierre taillée",
          "es": "Puerta (sillar de piedra)",
          "de": "Quadersteintür",
          "pt": "Porta de Pedra Polida",
          "it": "Porta di Pietra Bugnata",
          "tr": "Kesme Taştan Kapı",
          "pl": "Drzwi z ciosanego kamienia",
          "ru": "Дверь из резного камня",
          "uk": "Двері з обтесаного каменю",
          "ko": "각진 석재 문",
          "zh": "方琢石门",
          "ja": "切石のドア"
        },
        {
          "id": "WoodenBow",
          "en": "Wooden Bow",
          "fr": "Arc en bois",
          "es": "Arco de madera",
          "de": "Holzbogen",
          "pt": "Arco de Madeira",
          "it": "Arco di Legno",
          "tr": "Ahşap Yay",
          "pl": "Drewniany łuk",
          "ru": "Деревянный лук",
          "uk": "Дерев\u0027яний лук",
          "ko": "나무 활",
          "zh": "木弓",
          "ja": "木の弓"
        },
        {
          "id": "DirtRampBasic",
          "en": "Dirt Ramp Basic",
          "fr": "Rampe en terre basique",
          "es": "Rampa de tierra (básica)",
          "de": "Normale Erdrampe",
          "pt": "Rampa Básica de Terra",
          "it": "Rampa di Terra di Base",
          "tr": "Temel Çamur Rampası",
          "pl": "Podstawowa rampa z ziemii",
          "ru": "Земляная рампа - базовая",
          "uk": "Базова земляна рампа",
          "ko": "흙 경사로 기본",
          "zh": "土坡道基础",
          "ja": "土のランプ(基本)"
        },
        {
          "id": "CulinaryResearchPaperBasicMeat",
          "en": "Culinary Research Paper Basic Meat",
          "fr": "Papier de recherche : Culinaire viande basique",
          "es": "Trabajo de investigación culinaria sobre carne (básico)",
          "de": "Grundlegendes Forschungspapier: Kochkunst mit Fleisch",
          "pt": "Documento de Pesquisa Básico de Culinária (Carne)",
          "it": "Documento di Ricerca Base di Culinaria sulla Carne",
          "tr": "Aşçılık Araştırma Makalesi Temel Et Yapımı",
          "pl": "Podstawowy papier badawczy Rzeźnictwa",
          "ru": "Исследование по базовой кулинарии - мясо",
          "uk": "Дослідження базової кулінарії - м\u0027ясо",
          "ko": "기초 고기 요리 연구지",
          "zh": "基础肉类烹饪研究论文",
          "ja": "料理の基礎研究書(肉)"
        },
        {
          "id": "CrushedSlagLv3",
          "en": "Crushed Slag Lv3",
          "fr": "Scories concassées nv. 3",
          "es": "Escoria triturada (niv. 3)",
          "de": "Zerkleinerte Schlacke Lv3",
          "pt": "Escória Triturada Nível 3",
          "it": "Scorie Spaccate Lv3",
          "tr": "Kırma Cüruf Sv3",
          "pl": "Pokruszony żużel Poz3",
          "ru": "Дробление шлака Ур.3",
          "uk": "Подрібнений шлак Рів. 3",
          "ko": "파쇄된 광물 찌꺼기 Lv3",
          "zh": "粉碎矿渣 等级3",
          "ja": "Crushed Slag Lv3"
        },
        {
          "id": "CrushedSlagLv2",
          "en": "Crushed Slag Lv2",
          "fr": "Scories concassées nv. 2",
          "es": "Escoria triturada (niv. 2)",
          "de": "Zerkleinerte Schlacke Lv2",
          "pt": "Escória Triturada Nível 2",
          "it": "Scorie Spaccate Lv2",
          "tr": "Kırma Cüruf Sv2",
          "pl": "Pokruszony żużel Poz2",
          "ru": "Дробление шлака Ур.2",
          "uk": "Подрібнений шлак Рів. 2",
          "ko": "파쇄된 광물 찌꺼기 Lv2",
          "zh": "捣碎矿渣 等级2",
          "ja": "Crushed Slag Lv2"
        },
        {
          "id": "CrushedShaleLv3",
          "en": "Crushed Shale Lv3",
          "fr": "Schiste concassé nv. 3",
          "es": "Pizarra triturada (niv. 3)",
          "de": "Zerkleinertes Schiefer Lv3",
          "pt": "Xisto Triturado Nível 3",
          "it": "Scisto Spaccato Lv3",
          "tr": "Kırma Kil Sv3",
          "pl": "Pokruszony łupek Poz3",
          "ru": "Дробление сланца Ур.3",
          "uk": "Подрібнений сланець Рів. 3",
          "ko": "파쇄된 이판암 Lv3",
          "zh": "粉碎页岩 等级3",
          "ja": "Crushed Shale Lv3"
        },
        {
          "id": "CrushedShaleLv2",
          "en": "Crushed Shale Lv2",
          "fr": "Schiste concassé nv. 2",
          "es": "Pizarra triturada (niv. 2)",
          "de": "Zerkleinertes Schiefer Lv2",
          "pt": "Xisto Triturado Nível 2",
          "it": "Scisto Spaccato Lv2",
          "tr": "Kırma Kil Sv2",
          "pl": "Pokruszony łupek Poz2",
          "ru": "Дробление сланца Ур.2",
          "uk": "Подрібнений сланець Рів. 2",
          "ko": "파쇄된 이판암 Lv2",
          "zh": "捣碎页岩 等级2",
          "ja": "Crushed Shale Lv2"
        },
        {
          "id": "CrushedSandstoneLv3",
          "en": "Crushed Sandstone Lv3",
          "fr": "Grès concassé nv. 3",
          "es": "Arenisca triturada (niv. 3)",
          "de": "Zerkleinerter Sandstein Lv3",
          "pt": "Arenito Triturado Nível 3",
          "it": "Arenaria Spaccata Lv3",
          "tr": "Kırma Kumtaşı Sv3",
          "pl": "Pokruszony piaskowiec Poz3",
          "ru": "Дробление песчаника Ур.3",
          "uk": "Подрібнений піщаник Рів. 3",
          "ko": "파쇄된 사암 Lv3",
          "zh": "粉碎砂岩 等级3",
          "ja": "Crushed Sandstone Lv3"
        },
        {
          "id": "CrushedSandstoneLv2",
          "en": "Crushed Sandstone Lv2",
          "fr": "Grès concassé nv. 2",
          "es": "Arenisca triturada (niv. 2)",
          "de": "Zerkleinerter Sandstein Lv2",
          "pt": "Arenito Triturado Nível 2",
          "it": "Arenaria Spaccata Lv2",
          "tr": "Kırma Kumtaşı Sv2",
          "pl": "Pokruszony piaskowiec Poz2",
          "ru": "Дробление песчаника Ур.2",
          "uk": "Подрібнений піщаник Рів. 2",
          "ko": "파쇄된 사암 2Lv",
          "zh": "捣碎砂岩 等级2",
          "ja": "Crushed Sandstone Lv2"
        },
        {
          "id": "CrushedLimestoneLv3",
          "en": "Crushed Limestone Lv3",
          "fr": "Calcaire concassé nv. 3",
          "es": "Piedra caliza triturada (niv. 3)",
          "de": "Zerkleinerter Kalkstein Lv3",
          "pt": "Calcário Triturado Nível 3",
          "it": "Calcare Spaccato Lv3",
          "tr": "Kırma Kireç Taşı Sv3",
          "pl": "Pokruszony wapień Poz3",
          "ru": "Дробление известняка Ур.3",
          "uk": "Подрібнений вапняк Рів. 3",
          "ko": "파쇄된 석회암 Lv3",
          "zh": "粉碎石灰石 等级3",
          "ja": "砕いた石灰岩　Lv3"
        },
        {
          "id": "CrushedLimestoneLv2",
          "en": "Crushed Limestone Lv2",
          "fr": "Calcaire concassé nv. 2",
          "es": "Arenisca triturada (niv. 2)",
          "de": "Zerkleinerter Kalkstein Lv2",
          "pt": "Calcário Triturado Nível 2",
          "it": "Calcare Spaccato Lv2",
          "tr": "Kırma Kireç Taşı Sv2",
          "pl": "Pokruszony wapień Poz2",
          "ru": "Дробление известняка Ур.2",
          "uk": "Подрібнений вапняк Рів. 2",
          "ko": "파쇄된 석회암 2Lv",
          "zh": "捣碎石灰石 等级2",
          "ja": "砕いた石灰岩　Lv2"
        },
        {
          "id": "CrushedIronLv3",
          "en": "Crushed Iron Lv3",
          "fr": "Minerai de fer concassé nv. 3",
          "es": "Hierro triturado (niv. 3)",
          "de": "Zerkleinertes Eisen Lv3",
          "pt": "Ferro Triturado Nível 3",
          "it": "Ferro Spaccato Lv3",
          "tr": "Kırma Demir Sv3",
          "pl": "Pokruszone żelazo Poz3",
          "ru": "Дробление железа Ур.3",
          "uk": "Подрібнена залізна руда Рів. 3",
          "ko": "파쇄된 철 3Lv",
          "zh": "粉碎铁矿石 等级3",
          "ja": "Crushed Iron Lv3"
        },
        {
          "id": "CrushedIronLv2",
          "en": "Crushed Iron Lv2",
          "fr": "Minerai de fer concassé nv. 2",
          "es": "Hierro triturado (niv. 2)",
          "de": "Zerkleinertes Eisen Lv2",
          "pt": "Ferro Triturado Nível 2",
          "it": "Ferro Spaccato Lv2",
          "tr": "Kırma Demir Sv2",
          "pl": "Pokruszone żelazo Poz2",
          "ru": "Дробление железа Ур.2",
          "uk": "Подрібнена залізна руда Рів. 2",
          "ko": "파쇄된 철 2Lv",
          "zh": "捣碎铁矿石 等级2",
          "ja": "Crushed Iron Lv2"
        },
        {
          "id": "CrushedGraniteLv3",
          "en": "Crushed Granite Lv3",
          "fr": "Granite concassé nv. 3",
          "es": "Granito triturado (niv. 3)",
          "de": "Zerkleinerter Granit Lv3",
          "pt": "Granito Triturado Nível 3",
          "it": "Granito Spaccato Lv3",
          "tr": "Kırma Granit Sv3",
          "pl": "Pokruszony granit Poz3",
          "ru": "Дробление гранита Ур.3",
          "uk": "Подрібнений граніт Рів. 3",
          "ko": "파쇄된 화강암 Lv3",
          "zh": "粉碎花岗岩 等级3",
          "ja": "Crushed Granite Lv3"
        },
        {
          "id": "CrushedGraniteLv2",
          "en": "Crushed Granite Lv2",
          "fr": "Granite concassé nv. 2",
          "es": "Granito triturado (niv. 2)",
          "de": "Zerkleinerter Granit Lv2",
          "pt": "Granito Triturado Nível 2",
          "it": "Granito Spaccato Lv2",
          "tr": "Kırma Granit Sv2",
          "pl": "Pokruszony granit Poz2",
          "ru": "Дробление гранита Ур.2",
          "uk": "Подрібнений граніт Рів. 2",
          "ko": "파쇄된 화강암 Lv2",
          "zh": "捣碎花岗岩 等级2",
          "ja": "Crushed Granite Lv2"
        },
        {
          "id": "CrushedGoldLv3",
          "en": "Crushed Gold Lv3",
          "fr": "Minerai d\u0027or concassé nv. 3",
          "es": "Oro triturado (niv. 3)",
          "de": "Zerkleinertes Gold Lv3",
          "pt": "Ouro Triturado Nível 3",
          "it": "Oro Spaccato Lv3",
          "tr": "Kırma Altın Sv3",
          "pl": "Pokruszone złoto Poz3",
          "ru": "Дробление Золота Ур.3",
          "uk": "Подрібнена золота руда Рів. 3",
          "ko": "파쇄된 금 Lv3",
          "zh": "粉碎金矿石 等级3",
          "ja": "Crushed Gold Lv3"
        },
        {
          "id": "CrushedGoldLv2",
          "en": "Crushed Gold Lv2",
          "fr": "Minerai d\u0027or concassé nv. 2",
          "es": "Oro triturado (niv. 2)",
          "de": "Zerkleinertes Gold Lv2",
          "pt": "Ouro Triturado Nível 2",
          "it": "Oro Spaccato Lv2",
          "tr": "Kırma Altın Sv2",
          "pl": "Pokruszone złoto Poz2",
          "ru": "Дробление Золота Ур.2",
          "uk": "Подрібнена золота руда Рів. 2",
          "ko": "파쇄된 금 Lv2",
          "zh": "捣碎金矿石 等级2",
          "ja": "Crushed Gold Lv2"
        },
        {
          "id": "CrushedGneissLv3",
          "en": "Crushed Gneiss Lv3",
          "fr": "Gneiss concassé nv. 3",
          "es": "Gneis triturado (niv. 3)",
          "de": "Zerkleinertes Gneis Lv3",
          "pt": "Gneisse Triturado Nível 3",
          "it": "Gneiss Spaccato Lv3",
          "tr": "Kırma Gnays Sv3",
          "pl": "Pokruszony gnejs Poz3",
          "ru": "Дробление гнейса Ур.3",
          "uk": "Подрібнений гнейс Рів. 3",
          "ko": "파쇄된 편마암 Lv3",
          "zh": "粉碎片麻岩 等级3",
          "ja": "Crushed Gneiss Lv3"
        },
        {
          "id": "CrushedGneissLv2",
          "en": "Crushed Gneiss Lv2",
          "fr": "Gneiss concassé nv. 2",
          "es": "Gneis triturado (niv. 2)",
          "de": "Zerkleinertes Gneis Lv2",
          "pt": "Gneisse Triturado Nível 2",
          "it": "Gneiss Spaccato Lv2",
          "tr": "Kırma Gnays Sv2",
          "pl": "Pokruszony gnejs Poz2",
          "ru": "Дробление гнейса Ур.2",
          "uk": "Подрібнений гнейс Рів. 2",
          "ko": "파쇄된 편마암 2Lv",
          "zh": "捣碎片麻岩 等级2",
          "ja": "Crushed Gneiss Lv2"
        },
        {
          "id": "CrushedCopperLv3",
          "en": "Crushed Copper Lv3",
          "fr": "Minerai de cuivre concassé nv. 3",
          "es": "Cobre triturado (niv. 3)",
          "de": "Zerkleinertes Kupfer Lv3",
          "pt": "Cobre Triturado Nível 3",
          "it": "Rame Spaccato Lv3",
          "tr": "Kırma Bakır Sv3",
          "pl": "Pokruszona miedź Poz3",
          "ru": "Дробление меди Ур.3",
          "uk": "Подрібнена мідна руда Рів. 3",
          "ko": "파쇄된 구리 3Lv",
          "zh": "磨碎铜矿石 等级3",
          "ja": "Crushed Copper Lv3"
        },
        {
          "id": "CrushedCopperLv2",
          "en": "Crushed Copper Lv2",
          "fr": "Minerai de cuivre concassé nv. 2",
          "es": "Cobre triturado (niv. 2)",
          "de": "Zerkleinertes Kupfer Lv2",
          "pt": "Cobre Triturado Nível 2",
          "it": "Rame Spaccato Lv2",
          "tr": "Kırma Bakır Sv2",
          "pl": "Pokruszona miedź Poz2",
          "ru": "Дробление меди Ур.2",
          "uk": "Подрібнена мідна руда Рів. 2",
          "ko": "파쇄된 구리 Lv2",
          "zh": "捣碎铜矿石 等级2",
          "ja": "Crushed Copper Lv2"
        },
        {
          "id": "CrushedBasaltLv3",
          "en": "Crushed Basalt Lv3",
          "fr": "Basalte concassé nv. 3",
          "es": "Basalto triturado (niv. 3)",
          "de": "Zerkleinerter Basalt Lv3",
          "pt": "Basalto Triturado Nível 3",
          "it": "Basalto Spaccato Lv3",
          "tr": "Kırma Bazalt Sv3",
          "pl": "Pokruszony bazalt Poz3",
          "ru": "Дробление базальта Ур.3",
          "uk": "Подрібнений базальт Рів. 3",
          "ko": "파쇄된 현무암 Lv3",
          "zh": "磨碎玄武岩 等级3",
          "ja": "Crushed Basalt Lv3"
        },
        {
          "id": "CrushedBasaltLv2",
          "en": "Crushed Basalt Lv2",
          "fr": "Basalte concassé nv. 2",
          "es": "Basalto triturado (niv. 2)",
          "de": "Zerkleinerter Basalt Lv2",
          "pt": "Basalto Triturado Nível 2",
          "it": "Basalto Spaccato Lv2",
          "tr": "Kırma Bazalt Sv2",
          "pl": "Pokruszony bazalt Poz2",
          "ru": "Дробление базальта Ур.2",
          "uk": "Подрібнений базальт Рів. 2",
          "ko": "파쇄된 현무암 Lv2",
          "zh": "捣碎玄武岩 等级2",
          "ja": "Crushed Basalt Lv2"
        },
        {
          "id": "ConcentrateIronLv2",
          "en": "Concentrate Iron Lv2",
          "fr": "Concentré de fer nv. 2",
          "es": "Concentrado de hierro (niv. 2)",
          "de": "Eisenkonzentrat Lv2",
          "pt": "Concentrado de Ferro Nível 2",
          "it": "Ferro Concentrato Lv2",
          "tr": "Konsantre Demir Svy2",
          "pl": "Koncentrat żelaza Poz2",
          "ru": "Концентрировать железо Ур.2",
          "uk": "Концентрування заліза Рів. 2",
          "ko": "정제된 철광석 Lv2",
          "zh": "浮选铁矿石 等级2",
          "ja": "Concentrate Iron Lv2"
        },
        {
          "id": "ConcentrateGoldLv2",
          "en": "Concentrate Gold Lv2",
          "fr": "Concentré d\u0027or nv. 2",
          "es": "Concentrado de oro (niv. 2)",
          "de": "Goldkonzentrat Lv2",
          "pt": "Concentrado de Ouro Nível 2",
          "it": "Oro Concentrato Lv2",
          "tr": "Konsantre Altın Svy2",
          "pl": "Koncentrat złota Poz2",
          "ru": "Концентрировать золото Ур.2",
          "uk": "Концентрування золота Рів. 2",
          "ko": "정제된 금광석 Lv2",
          "zh": "浮选金矿石 等级2",
          "ja": "Concentrate Gold Lv2"
        },
        {
          "id": "ConcentrateDryIronLv2",
          "en": "Concentrate Dry Iron Lv2",
          "fr": "Concentré de fer sec nv. 2",
          "es": "Concentrado de hierro seco (niv. 2)",
          "de": "Eisenkonzentrat Lv2",
          "pt": "Concentrado de Ferro Seco Nível 2",
          "it": "Ferro Secco Concentrato Lv2",
          "tr": "Konsantre Buharsız Ütü Svy2",
          "pl": "Koncentrat suchego żelaza Poz2",
          "ru": "Сухое концентрирование железа Ур.2",
          "uk": "Сухе концентрування заліза Рів. 2",
          "ko": "건식 정제된 철광석 Lv2",
          "zh": "筛选干铁矿石 等级2",
          "ja": "Concentrate Dry Iron Lv2"
        },
        {
          "id": "ConcentrateDryIron",
          "en": "Concentrate Dry Iron",
          "fr": "Concentré de fer sec",
          "es": "Concentrado de hierro seco",
          "de": "Eisenkonzentrat",
          "pt": "Concentrado de Ferro Seco",
          "it": "Ferro Secco Concentrato",
          "tr": "Konsantre Buharsız Ütü",
          "pl": "Koncentrat suchego żelaza",
          "ru": "Сухое концентрирование железа",
          "uk": "Сухе концентрування заліза",
          "ko": "건식 정제된 철광석",
          "zh": "筛选干铁矿石",
          "ja": "Concentrate Dry Iron"
        },
        {
          "id": "ConcentrateCopperLv2",
          "en": "Concentrate Copper Lv2",
          "fr": "Concentré de cuivre nv. 2",
          "es": "Concentrado de cobre (niv. 2)",
          "de": "Kupferkonzentrat Lv2",
          "pt": "Concentrado de Cobre Nível 2",
          "it": "Rame Concentrato Lv2",
          "tr": "Konsantre Bakır Svy2",
          "pl": "Koncentrat miedzi Poz2",
          "ru": "Концентрировать медь Ур.2",
          "uk": "Концентрування міді Рів. 2",
          "ko": "정제된 구리 광석 Lv2",
          "zh": "浮选铜矿石 等级2",
          "ja": "Concentrate Copper Lv2"
        },
        {
          "id": "CleanPacificSardine",
          "en": "Clean Pacific Sardine",
          "fr": "Vider la sardine du Pacifique",
          "es": "Sardina del Pacífico limpia",
          "de": "Saubere Pazifische Sardine",
          "pt": "Limpar Sardinha do Pacífico",
          "it": "Sardine del Pacifico Pulite",
          "tr": "Konsantre Pasifik Sardalyası",
          "pl": "Czysta pacyficzna sardynka",
          "ru": "Почистить перуанскую сардину",
          "uk": "Почистити перуанську сардину",
          "ko": "태평양 정어리 손질법",
          "zh": "清洁太平洋沙丁鱼",
          "ja": "Clean Pacific Sardine"
        },
        {
          "id": "CampfirePacificSardine",
          "en": "Campfire Pacific Sardine",
          "fr": "Sardine du Pacifique cuite au feu de camp",
          "es": "Sardina del Pacífico braseada",
          "de": "Gegrillte Pazifische Sardine",
          "pt": "Sardinha do Pacífico Feita na Fogueira",
          "it": "Sardina del Pacifico al Falò",
          "tr": "Güveçte Pasifik Sardalyası",
          "pl": "Pacyficzna sardynka z ogniska",
          "ru": "Жареная на костре перуанская сардина",
          "uk": "Перуанська сардина на багатті",
          "ko": "태평양 정어리 모닥불 요리",
          "zh": "篝火太平洋沙丁鱼",
          "ja": "Campfire Pacific Sardine"
        },
        {
          "id": "Nail",
          "en": "Nail",
          "fr": "Clou",
          "es": "Clavo",
          "de": "Nagel",
          "pt": "Prego",
          "it": "Chiodo",
          "tr": "Çivi",
          "pl": "Gwóźdź",
          "ru": "Гвоздь",
          "uk": "Цвях",
          "ko": "못",
          "zh": "钉",
          "ja": "Nail"
        },
        {
          "id": "MetallurgyResearchPaperBasic",
          "en": "Metallurgy Research Paper Basic",
          "fr": "Papier de recherche : Métallurgie basique",
          "es": "Trabajo de investigación en metalurgia (básico)",
          "de": "Grundlegendes Forschungspapier: Metallurgie",
          "pt": "Documento de Pesquisa Básico de Metalurgia",
          "it": "Documento di Ricerca Base di Metallurgia",
          "tr": "Madencilik Araştırma Makalesi Temeller",
          "pl": "Podstawowy artykuł badawczy Metalurgii",
          "ru": "Исследование по базовой металлургии",
          "uk": "Дослідження базової металургії",
          "ko": "기초 금속공학 연구지",
          "zh": "基础冶金研究论文",
          "ja": "精錬の基礎研究書"
        },
        {
          "id": "MetallurgyResearchPaperAdvanced",
          "en": "Metallurgy Research Paper Advanced",
          "fr": "Papier de recherche : Métallurgie avancée",
          "es": "Trabajo de investigación en metalurgia (avanzado)",
          "de": "Fortgeschrittenes Forschungspapier: Metallurgie",
          "pt": "Documento de Pesquisa Avançado de Metalurgia",
          "it": "Documento di Ricerca Avanzato di Metallurgia",
          "tr": "Madencilik Araştırma Makalesi İleri Seviye",
          "pl": "Zaawansowany artykuł badawczy Metalurgii",
          "ru": "Исследование по продвинутой металлургии",
          "uk": "Дослідження вдосконаленої металургії",
          "ko": "고급 금속공학 연구지",
          "zh": "高级冶金研究论文",
          "ja": "精錬の応用研究書"
        },
        {
          "id": "GeologyResearchPaperModern",
          "en": "Geology Research Paper Modern",
          "fr": "Papier de recherche : Géologie moderne",
          "es": "Trabajo de investigación en geología (moderno)",
          "de": "Modernes Forschungspapier: Geologie",
          "pt": "Documento de Pesquisa Moderno de Geologia",
          "it": "Documento di Ricerca Moderno di Geologia",
          "tr": "Yer Bilimi Araştırma Makalesi Modern",
          "pl": "Nowoczesny artykuł badawczy Geologii",
          "ru": "Исследование по современной геологии",
          "uk": "Дослідження сучасної геології",
          "ko": "현대식 지질학 연구지",
          "zh": "现代地质学研究论文",
          "ja": "地質学の最先端研究書"
        },
        {
          "id": "GeologyResearchPaperBasic",
          "en": "Geology Research Paper Basic",
          "fr": "Papier de recherche : Géologie basique",
          "es": "Trabajo de investigación en geología (básico)",
          "de": "Grundlegendes Forschungspapier: Geologie",
          "pt": "Documento de Pesquisa Básico de Geologia",
          "it": "Documento di Ricerca Base di Geologia",
          "tr": "Yer Bilimi Araştırma Makalesi Temeller",
          "pl": "Podstawowy artykuł badawczy Geologii",
          "ru": "Исследование по базовой геологии",
          "uk": "Дослідження базової геології",
          "ko": "기초 지질학 연구지",
          "zh": "基础地质学研究论文",
          "ja": "地質学の基礎研究書"
        },
        {
          "id": "GeologyResearchPaperAdvanced",
          "en": "Geology Research Paper Advanced",
          "fr": "Papier de recherche : Géologie avancée",
          "es": "Trabajo de investigación en geología (avanzado)",
          "de": "Fortgeschrittenes Forschungspapier: Geologie",
          "pt": "Documento de Pesquisa Avançado de Geologia",
          "it": "Documento di Ricerca Avanzato di Geologia",
          "tr": "Yer Bilimi Araştırma Makalesi İleri Seviye",
          "pl": "Zaawansowany artykuł badawczy Geologii",
          "ru": "Исследование по продвинутой геологии",
          "uk": "Дослідження вдосконаленої геології",
          "ko": "고급 지질학 연구지",
          "zh": "高级地质学研究论文",
          "ja": "地質学の応用研究書"
        },
        {
          "id": "GatheringResearchPaperBasic",
          "en": "Gathering Research Paper Basic",
          "fr": "Papier de recherche : Récolte basique",
          "es": "Trabajo de investigación en recolección (básico)",
          "de": "Grundlegendes Forschungspapier: Sammeln",
          "pt": "Documento de Pesquisa Básico de Coleta",
          "it": "Documento di Ricerca Base di Raccolta",
          "tr": "Toplayıcılık Araştırma Makalesi Temeller",
          "pl": "Podstawowy artykuł badawczy Zbieractwa",
          "ru": "Исследование по базовому собирательству",
          "uk": "Базове дослідження збирання",
          "ko": "기초 채집 연구지",
          "zh": "基础收集研究论文",
          "ja": "採集の基礎研究書"
        },
        {
          "id": "EngineeringResearchPaperModern",
          "en": "Engineering Research Paper Modern",
          "fr": "Papier de recherche : Ingénierie moderne",
          "es": "Trabajo de investigación en ingeniería (moderno)",
          "de": "Modernes Forschungspapier: Ingenieurswesen",
          "pt": "Documento de Pesquisa Moderno de Engenharia",
          "it": "Documento di Ricerca Moderno di Ingegneria",
          "tr": "Mühendislik Araştırma Makalesi Modern",
          "pl": "Nowoczesny artykuł badawczy Inżynierii",
          "ru": "Исследование по современному инженерному делу",
          "uk": "Дослідження сучасної інженерії",
          "ko": "현대식 기계공학 연구지",
          "zh": "现代工程学研究论文",
          "ja": "工学の最先端研究書"
        },
        {
          "id": "EngineeringResearchPaperAdvanced",
          "en": "Engineering Research Paper Advanced",
          "fr": "Papier de recherche : Ingénierie avancée",
          "es": "Trabajo de investigación en ingeniería (avanzado)",
          "de": "Fortgeschrittenes Forschungspapier: Ingenieurswesen",
          "pt": "Documento de Pesquisa Avançado de Engenharia",
          "it": "Documento di Ricerca Avanzato di Ingegneria",
          "tr": "Mühendislik Araştırma Makalesi İleri Seviye",
          "pl": "Zaawansowany artykuł badawczy Inżynierii",
          "ru": "Исследование по продвинутому инженерному делу",
          "uk": "Дослідження вдосконаленої інженерії",
          "ko": "고급 기계공학 연구지",
          "zh": "高级工程学研究论文",
          "ja": "工学の応用研究書"
        },
        {
          "id": "DendrologyResearchPaperModern",
          "en": "Dendrology Research Paper Modern",
          "fr": "Papier de recherche : Dendrologie moderne",
          "es": "Trabajo de investigación en dendrología (moderno)",
          "de": "Modernes Forschungspapier: Dendrologie",
          "pt": "Documento de Pesquisa Moderno de Dendrologia",
          "it": "Documento di Ricerca Moderno di Dendrologia",
          "tr": "Ağaç Bilimi Araştırma Makalesi Modern",
          "pl": "Nowoczesny artykuł badawczy Dendrologii",
          "ru": "Исследование по современной дендрологии",
          "uk": "Дослідження сучасної дендрології",
          "ko": "현대식 산림학 연구지",
          "zh": "现代树木学研究论文",
          "ja": "樹木学の最先端研究書"
        },
        {
          "id": "DendrologyResearchPaperBasic",
          "en": "Dendrology Research Paper Basic",
          "fr": "Papier de recherche : Dendrologie basique",
          "es": "Trabajo de investigación en dendrología (básico)",
          "de": "Grundlegendes Forschungspapier: Dendrologie",
          "pt": "Documento de Pesquisa Básico de Dendrologia",
          "it": "Documento di Ricerca Base di Dendrologia",
          "tr": "Ağaç Bilimi Araştırma Makalesi Temeller",
          "pl": "Podstawowy artykuł badawczy Drzewoznawstwa",
          "ru": "Исследование по базовой дендрологии",
          "uk": "Дослідження базової дендрології",
          "ko": "기초 산림학 연구지",
          "zh": "基础树木学研究论文",
          "ja": "樹木学の基礎研究書"
        },
        {
          "id": "DendrologyResearchPaperAdvanced",
          "en": "Dendrology Research Paper Advanced",
          "fr": "Papier de recherche : Dendrologie avancée",
          "es": "Trabajo de investigación en dendrología (avanzado)",
          "de": "Fortgeschrittenes Forschungspapier: Dendrologie",
          "pt": "Documento de Pesquisa Avançado de Dendrologia",
          "it": "Documento di Ricerca Avanzato di Dendrologia",
          "tr": "Ağaç Bilimi Araştırma Makalesi İleri Seviye",
          "pl": "Zaawansowany artykuł badawczy Drzewoznawstwa",
          "ru": "Исследование по продвинутой дендрологии",
          "uk": "Дослідження вдосконаленої дендрології",
          "ko": "고급 산림학 연구지",
          "zh": "高级树木学研究论文",
          "ja": "樹木学の応用研究書"
        },
        {
          "id": "CulinaryResearchPaperModern",
          "en": "Culinary Research Paper Modern",
          "fr": "Papier de recherche : Culinaire moderne",
          "es": "Trabajo de investigación culinaria (moderno)",
          "de": "Modernes Forschungspapier: Kochkunst",
          "pt": "Documento de Pesquisa Moderno de Culinária",
          "it": "Documento di Ricerca Moderno di Culinaria",
          "tr": "Aşçılık Araştırma Makalesi Modern",
          "pl": "Nowoczesny artykuł badawczy Kulinariów",
          "ru": "Исследование по современной кулинарии",
          "uk": "Дослідження сучасної кулінарії",
          "ko": "현대식 요리 연구지",
          "zh": "现代烹饪研究论文",
          "ja": "料理の最先端研究書"
        },
        {
          "id": "CulinaryResearchPaperBasic",
          "en": "Culinary Research Paper Basic",
          "fr": "Papier de recherche : Culinaire basique",
          "es": "Trabajo de investigación culinaria (básico)",
          "de": "Grundlegendes Forschungspapier: Kochkunst",
          "pt": "Documento de Pesquisa Básico de Culinária",
          "it": "Documento di Ricerca Base di Culinaria",
          "tr": "Aşçılık Araştırma Makalesi Temeller",
          "pl": "Podstawowy papier badawczy Kulinariów",
          "ru": "Исследование по базовой кулинарии",
          "uk": "Дослідження базової кулінарії",
          "ko": "기초 요리 연구지",
          "zh": "基础烹饪研究论文",
          "ja": "料理の基礎研究書"
        },
        {
          "id": "CulinaryResearchPaperAdvanced",
          "en": "Culinary Research Paper Advanced",
          "fr": "Papier de recherche : Culinaire avancé",
          "es": "Trabajo de investigación culinaria (avanzado)",
          "de": "Fortgeschrittenes Forschungspapier: Kochkunst",
          "pt": "Documento de Pesquisa Avançado de Culinária",
          "it": "Documento di Ricerca Avanzato di Culinaria",
          "tr": "Aşçılık Araştırma Makalesi İleri Seviye",
          "pl": "Zaawansowany papier badawczy Kulinarii",
          "ru": "Исследование по продвинутой кулинарии",
          "uk": "Дослідження вдосконаленої кулінарії",
          "ko": "고급 요리 연구지",
          "zh": "高级烹饪研究论文",
          "ja": "料理の応用研究書"
        },
        {
          "id": "BasicCircuit",
          "en": "Basic Circuit",
          "fr": "Circuit basique",
          "es": "Circuito básico",
          "de": "Einfacher Schaltkreis",
          "pt": "Circuito Básico",
          "it": "Circuito di Base",
          "tr": "Basit Devre",
          "pl": "Podstawowy obwód",
          "ru": "Базовая электросхема",
          "uk": "Базова електросхема",
          "ko": "기초 회로",
          "zh": "基础电路",
          "ja": "Basic Circuit"
        },
        {
          "id": "AgricultureResearchPaperModern",
          "en": "Agriculture Research Paper Modern",
          "fr": "Papier de recherche : Agriculture moderne",
          "es": "Trabajo de investigación en agricultura (moderno)",
          "de": "Modernes Forschungspapier: Landwirtschaft",
          "pt": "Documento de Pesquisa Moderno de Agricultura",
          "it": "Documento di Ricerca Moderno di Agricoltura",
          "tr": "Tarımcılık Araştırma Makalesi Modern",
          "pl": "Nowoczesny artykuł badawczy Agrokultury",
          "ru": "Исследование по современному сельскому хозяйству",
          "uk": "Дослідження сучасного сільського господарства",
          "ko": "현대식 농업 연구지",
          "zh": "现代农业研究论文",
          "ja": "農業の最先端研究書"
        },
        {
          "id": "AgricultureResearchPaperAdvanced",
          "en": "Agriculture Research Paper Advanced",
          "fr": "Papier de recherche : Agriculture avancée",
          "es": "Trabajo de investigación en agricultura (avanzado)",
          "de": "Fortgeschrittenes Forschungspapier: Landwirtschaft",
          "pt": "Documento de Pesquisa Avançado de Agricultura",
          "it": "Documento di Ricerca Avanzato di Agricoltura",
          "tr": "Tarımcılık Araştırma Makalesi İleri Seviye",
          "pl": "Zaawansowany artykuł badawczy Agrokultury",
          "ru": "Исследование по продвинутому сельскому хозяйству",
          "uk": "Дослідження вдосконаленого сільського господарства",
          "ko": "고급 농업 연구지",
          "zh": "高级农业研究论文",
          "ja": "農業の応用研究書"
        },
        {
          "id": "Shorts",
          "en": "Shorts",
          "fr": "Short",
          "es": "Pantalones cortos",
          "de": "Kurze Hose",
          "pt": "Bermuda",
          "it": "Pantaloncini",
          "tr": "Kısa Pantalon",
          "pl": "Spodenki",
          "ru": "Шорты",
          "uk": "Шорти",
          "ko": "반바지",
          "zh": "短裤",
          "ja": "Shorts"
        },
        {
          "id": "ClothCape",
          "en": "Cloth Cape",
          "fr": "Cape en tissu",
          "es": "Capa de tela",
          "de": "Stoffumhang",
          "pt": "Capa de Tecido",
          "it": "Mantello di Stoffa",
          "tr": "Kumaş Pelerin",
          "pl": "Płaszcz z tkaniny",
          "ru": "Тканевая накидка",
          "uk": "Тканинна накидка",
          "ko": "천 망토",
          "zh": "布斗篷",
          "ja": "Cloth Cape"
        },
        {
          "id": "ClothBelt",
          "en": "Cloth Belt",
          "fr": "Ceinture en tissu",
          "es": "Cinturón de tela",
          "de": "Gürtel",
          "pt": "Cinto de Tecido",
          "it": "Cintura di Tessuto",
          "tr": "Kumaş Kemer",
          "pl": "Bluza na pasie",
          "ru": "Тканый пояс",
          "uk": "Тканинний ремінь",
          "ko": "천 벨트",
          "zh": "布带",
          "ja": "Cloth Belt"
        },
        {
          "id": "Bandana",
          "en": "Bandana",
          "fr": "Bandana",
          "es": "Bandana",
          "de": "Bandana",
          "pt": "Bandana",
          "it": "Bandana",
          "tr": "Bandana",
          "pl": "Bandana",
          "ru": "Бандана",
          "uk": "Бандана",
          "ko": "반다나",
          "zh": "头巾",
          "ja": "Bandana"
        },
        {
          "id": "LumberStockpile",
          "en": "Lumber Stockpile",
          "fr": "Réserve en bois d\u0027œuvre",
          "es": "Pila de almacenamiento para troncos",
          "de": "Bauholzlager",
          "pt": "Estoque em pilha de madeira serrada",
          "it": "Pila di Legname",
          "tr": "Keresteden Stok Yeri",
          "pl": "Skład drewna",
          "ru": "Склад из пиломатериалов",
          "uk": "Склад з пиломатеріалів",
          "ko": "가공목 자재창고",
          "zh": "木制料堆",
          "ja": "Lumber Stockpile"
        },
        {
          "id": "LargeLumberStockpile",
          "en": "Large Lumber Stockpile",
          "fr": "Réserve de grande taille en bois d\u0027oeuvre",
          "es": "Pila grande de troncos",
          "de": "Bauholzlager (Groß)",
          "pt": "Estoque em pilha grande de madeira serrada",
          "it": "Grande Pila di Legname",
          "tr": "Keresteden Geniş Stok Yeri",
          "pl": "Duży Skład Drewna",
          "ru": "Большой склад из пиломатериалов",
          "uk": "Великий склад з пиломатеріалів",
          "ko": "대형 가공목 자재 창고",
          "zh": "大型木制料堆",
          "ja": "Large Lumber Stockpile"
        },
        {
          "id": "SandConcentrate",
          "en": "Sand Concentrate",
          "fr": "Concentré de sable",
          "es": "Concentrado de arena",
          "de": "Sand",
          "pt": "Concentrado de Areia",
          "it": "Concentrato di Sabbia",
          "tr": "Kum Konsantresi",
          "pl": "Piaskowy koncentrat",
          "ru": "Получить песок",
          "uk": "Отримати пісок",
          "ko": "정제된 모래",
          "zh": "筛选沙子",
          "ja": "Sand Concentrate"
        },
        {
          "id": "HewnDoor",
          "en": "Hewn Door",
          "fr": "Porte en rondins taillés",
          "es": "Puerta tallada",
          "de": "Massivholztür",
          "pt": "Porta de Madeira Cortada",
          "it": "Porta Scolpita",
          "tr": "Yontma Odun Kapı",
          "pl": "Ociosane drzwi",
          "ru": "Дверь из обтёсанного дерева",
          "uk": "Двері з обтісаних досок",
          "ko": "다듬은 문",
          "zh": "凿门",
          "ja": "丸太材のドア"
        },
        {
          "id": "CulinaryResearchPaperAdvancedMeat",
          "en": "Culinary Research Paper Advanced Meat",
          "fr": "Papier de recherche : Culinaire viande avancée",
          "es": "Trabajo de investigación culinaria sobre carne (avanzado)",
          "de": "Fortgeschrittenes Forschungspapier: Kochkunst mit Fleisch",
          "pt": "Documento de Pesquisa Avançado de Culinária (Carne)",
          "it": "Documento di Ricerca Avanzato di Culinaria sulla Carne",
          "tr": "Aşçılık Araştırma Makalesi İleri Seviye Et Yapımı",
          "pl": "Zaawansowany papier badawczy mięsnej Kulinarii",
          "ru": "Исследование по продвинутой кулинарии - мясо",
          "uk": "Дослідження вдосконаленої кулінарії - м\u0027ясо",
          "ko": "고급 고기 요리 연구지",
          "zh": "高级肉类烹饪研究论文",
          "ja": "料理の応用研究書(肉)"
        },
        {
          "id": "CampfireAnimalTiny",
          "en": "Campfire Animal Tiny",
          "fr": "Animal minuscule cuit au feu de camp",
          "es": "Solomillo a la brasa (animal diminuto)",
          "de": "Gegrilltes Tierfleisch - winzig",
          "pt": "Animal Minúsculo Feito na Fogueira",
          "it": "Falò Minuscolo Animale",
          "tr": "Güveçte Hayvan Eti Minik",
          "pl": "Malutkiego rozmiaru pieczone zwierzę",
          "ru": "Жареное на костре крошечное животное",
          "uk": "Крихітна тварина на вогнищі",
          "ko": "극소형 동물 모닥불 구이",
          "zh": "篝火动物（迷你）",
          "ja": "ちっぽけな肉の野外料理"
        },
        {
          "id": "CampfireAnimalSmall",
          "en": "Campfire Animal Small",
          "fr": "Animal petit cuit au feu de camp",
          "es": "Solomillo a la brasa (animal pequeño)",
          "de": "Gegrilltes Tierfleisch - klein",
          "pt": "Animal Pequeno Feito na Fogueira",
          "it": "Falò Piccolo Animale",
          "tr": "Güveçte Hayvan Eti Ufak",
          "pl": "Małego rozmiaru pieczone zwierzę",
          "ru": "Жареное на костре маленькое животное",
          "uk": "Мала тварина на вогнищі",
          "ko": "소형 동물 모닥불 구이",
          "zh": "篝火动物（小型）",
          "ja": "小さな肉の野外料理"
        },
        {
          "id": "CampfireAnimalMedium",
          "en": "Campfire Animal Medium",
          "fr": "Animal moyen cuit au feu de camp",
          "es": "Solomillo a la brasa (animal mediano)",
          "de": "Gegrilltes Tierfleisch - normal",
          "pt": "Animal Médio Feito na Fogueira",
          "it": "Falò Animale Medio",
          "tr": "Güveçte Hayvan Eti Orta",
          "pl": "Średniego rozmiaru pieczone zwierzę",
          "ru": "Жареное на костре среднее животное",
          "uk": "Середня тварина на вогнищі",
          "ko": "중형 동물 모닥불 구이",
          "zh": "篝火动物（中型）",
          "ja": "中ぐらいな肉の野外料理"
        },
        {
          "id": "ButcherSmallAnimal",
          "en": "Butcher Small Animal",
          "fr": "Dépecer le petit animal",
          "es": "Descuartizar animal pequeño",
          "de": "Kleines Tier schlachten",
          "pt": "Carnear Animal Pequeno",
          "it": "Macella Piccolo Animale",
          "tr": "Kasap Ufak Hayvan",
          "pl": "Przerób małe zwierzę",
          "ru": "Разделать маленькое животное",
          "uk": "Різництво малої тварини",
          "ko": "소형 동물 도축법",
          "zh": "加工小型动物",
          "ja": "Butcher Small Animal"
        },
        {
          "id": "ButcherMediumAnimal",
          "en": "Butcher Medium Animal",
          "fr": "Dépecer l\u0027animal de taille moyenne",
          "es": "Descuartizar animal mediano",
          "de": "Mittleres Tier schlachten",
          "pt": "Carnear Animal Médio",
          "it": "Macella Animale Medio",
          "tr": "Kasap Orta Hayvan",
          "pl": "Przerób średnie zwierzę",
          "ru": "Разделать среднее животное",
          "uk": "Різництво середньої тварини",
          "ko": "중형 동물 도축법",
          "zh": "加工中型动物",
          "ja": "Butcher Medium Animal"
        },
        {
          "id": "SmeltingUpgrade",
          "en": "Smelting Upgrade",
          "fr": "Amélioration avancée : Fonte",
          "es": "Mejora: Fundición",
          "de": "Fortgeschrittenes Upgrade: Schmelzen",
          "pt": "Melhoria de Fundição",
          "it": "Aggiornamento Fusione",
          "tr": "Eritmecilik Geliştirmesi",
          "pl": "Ulepszenie Wytapiania",
          "ru": "Улучшение для выплавки",
          "uk": "Покращення виплавки",
          "ko": "제련 업그레이드",
          "zh": "冶炼升级",
          "ja": "製錬アップグレード"
        },
        {
          "id": "PotteryUpgrade",
          "en": "Pottery Upgrade",
          "fr": "Amélioration avancée : Poterie",
          "es": "Mejora: Cerámica",
          "de": "Fortgeschrittenes Upgrade: Töpfern",
          "pt": "Melhoria de Cerâmica",
          "it": "Aggiornamento Ceramica",
          "tr": "Çömlekçilik Geliştirmesi",
          "pl": "Ulepszenie Garncarstwa",
          "ru": "Улучшение для гончарного ремесла",
          "uk": "Покращення гончарства",
          "ko": "도기 업그레이드",
          "zh": "陶艺升级",
          "ja": "陶芸アップグレード"
        },
        {
          "id": "PaperMillingUpgrade",
          "en": "Paper Milling Upgrade",
          "fr": "Amélioration basique : Production de papier",
          "es": "Mejora: Molienda de papel",
          "de": "Fortgeschrittenes Upgrade: Papierherstellung",
          "pt": "Melhoria de Fabricação de Papel",
          "it": "Aggiornamento Cartiera",
          "tr": "Kağıt İşleme Geliştirmesi",
          "pl": "Ulepszenie Papierni",
          "ru": "Улучшение для производства бумаги",
          "uk": "Покращення виготовлення паперу",
          "ko": "제지 가공 업그레이드",
          "zh": "造纸升级",
          "ja": "紙すきアップグレード"
        },
        {
          "id": "OilDrillingUpgrade",
          "en": "Oil Drilling Upgrade",
          "fr": "Amélioration moderne : Forage pétrolier",
          "es": "Mejora: Prospección de petróleo",
          "de": "Modernes Upgrade: Ölgewinnung",
          "pt": "Melhoria de Perfuração de Petróleo",
          "it": "Aggiornamento Trivellazione Petrolifera",
          "tr": "Petrol Çıkarma Geliştirmesi",
          "pl": "Ulepszenie Wydobycia Ropy",
          "ru": "Улучшение для добычи нефти",
          "uk": "Покращення буріння",
          "ko": "유정 굴착 업그레이드",
          "zh": "石油钻探升级",
          "ja": "Oil Drilling Upgrade"
        },
        {
          "id": "MillingUpgrade",
          "en": "Milling Upgrade",
          "fr": "Amélioration avancée : Mouture",
          "es": "Mejora: Molienda",
          "de": "Fortschrittliches Upgrade: Mahlen",
          "pt": "Melhoria de Moagem",
          "it": "Aggiornamento Fresatura",
          "tr": "Değirmencilik Geliştirmesi",
          "pl": "Ulepszenie Młynarstwa",
          "ru": "Улучшение для мельничного дела",
          "uk": "Покращення млинарства",
          "ko": "제분 업그레이드",
          "zh": "铣削升级",
          "ja": "Milling Upgrade"
        },
        {
          "id": "IndustryUpgrade",
          "en": "Industry Upgrade",
          "fr": "Amélioration moderne : Industrie",
          "es": "Mejora: Industria",
          "de": "Upgrade Industrie",
          "pt": "Melhoria de Indústria",
          "it": "Aggiornamento Industria",
          "tr": "Sanayi Geliştirmesi",
          "pl": "Ulepszenie Przemysłu",
          "ru": "Улучшение для промышленности",
          "uk": "Покращення промисловості",
          "ko": "산업 업그레이드",
          "zh": "产业升级",
          "ja": "Industry Upgrade"
        },
        {
          "id": "FertilizersUpgrade",
          "en": "Fertilizers Upgrade",
          "fr": "Amélioration basique : Engrais",
          "es": "Mejora: Fertilizantes",
          "de": "Upgrade Dünger",
          "pt": "Melhoria de Fertilizantes",
          "it": "Aggiornamento Fertilizzanti",
          "tr": "Gübreleme Geliştirmesi",
          "pl": "Ulepszenie Nawozów",
          "ru": "Улучшение для производства удобрений",
          "uk": "Покращення виготовлення добрив",
          "ko": "비료 제조 업그레이드",
          "zh": "肥料升级",
          "ja": "Fertilizers Upgrade"
        },
        {
          "id": "FarmingUpgrade",
          "en": "Farming Upgrade",
          "fr": "Amélioration basique : Agriculture",
          "es": "Mejora: Agricultura",
          "de": "Upgrade Landwirtschaft",
          "pt": "Melhoria de Agricultura",
          "it": "Aggiornamento Agricoltura",
          "tr": "Çiftçilik Geliştirmesi",
          "pl": "Moduł modernizacji rolnictwa",
          "ru": "Улучшение для фермерского дела",
          "uk": "Покращення фермерства",
          "ko": "농업 업그레이드",
          "zh": "农业升级",
          "ja": "Farming Upgrade"
        },
        {
          "id": "ElectronicsUpgrade",
          "en": "Electronics Upgrade",
          "fr": "Amélioration moderne : Électronique",
          "es": "Mejora: Electrónica",
          "de": "Upgrade Elektronik",
          "pt": "Melhoria de Eletrônica",
          "it": "Aggiornamento Elettronica",
          "tr": "Elektronik Geliştirmesi",
          "pl": "Ulepszenie Elektroniki",
          "ru": "Улучшение для электроники",
          "uk": "Покращення електроніки",
          "ko": "전자공학 업그레이드",
          "zh": "电子升级",
          "ja": "Electronics Upgrade"
        },
        {
          "id": "CuttingEdgeCookingUpgrade",
          "en": "Cutting Edge Cooking Upgrade",
          "fr": "Amélioration moderne : Cuisine moléculaire",
          "es": "Mejora: Cocina innovadora",
          "de": "Upgrade Innovatives Kochen",
          "pt": "Melhoria de Cozimento de Ponta",
          "it": "Aggiornamento Cucina d\u0027Avanguardia",
          "tr": "Çağdaş Aşçılık Geliştirmesi",
          "pl": "Ulepszenie Nowoczesnego Gotowania",
          "ru": "Улучшение для передовой кулинарии",
          "uk": "Покращення сучасної кухні",
          "ko": "식품공학 업그레이드",
          "zh": "尖端烹饪升级",
          "ja": "Cutting Edge Cooking Upgrade"
        },
        {
          "id": "CookingUpgrade",
          "en": "Cooking Upgrade",
          "fr": "Amélioration avancée : Cuisine",
          "es": "Mejora: Cocina",
          "de": "Fortschrittliches Upgrade: Kochen",
          "pt": "Melhoria de Cozimento",
          "it": "Aggiornamento Cucina",
          "tr": "Aşçılık Geliştirmesi",
          "pl": "Ulepszenie Gotowania",
          "ru": "Улучшение для готовки",
          "uk": "Покращення приготування їжі",
          "ko": "요리 업그레이드",
          "zh": "烹饪升级",
          "ja": "Cooking Upgrade"
        },
        {
          "id": "CompositesUpgrade",
          "en": "Composites Upgrade",
          "fr": "Amélioration moderne : Composites",
          "es": "Mejora: Composites",
          "de": "Upgrade Verbundhölzer",
          "pt": "Melhoria de Compósitos",
          "it": "Aggiornamento Materiali Compositi",
          "tr": "Kompozit Geliştirmesi",
          "pl": "Ulepszenie Kompozytów",
          "ru": "Улучшение для изготовления композитов",
          "uk": "Покращення сполук",
          "ko": "복합 목재 업그레이드",
          "zh": "复合材料升级",
          "ja": "複合材アップグレード"
        },
        {
          "id": "CampfireCookingUpgrade",
          "en": "Campfire Cooking Upgrade",
          "fr": "Amélioration basique : Cuisine au feu de camp",
          "es": "Mejora: Cocina con fogata",
          "de": "Grundlegendes Upgrade: Lagerfeuerkochen",
          "pt": "Melhoria de Cozimento com Fogueira",
          "it": "Aggiornamento Cucina da falò",
          "tr": "Güveçte Pişirme Geliştirmesi",
          "pl": "Ulepszenie Gotowania Na Ognisku",
          "ru": "Улучшение для готовки на костре",
          "uk": "Покращення приготування їжі на багатті",
          "ko": "모닥불 요리 업그레이드",
          "zh": "篝火烹饪升级",
          "ja": "野外料理アップグレード"
        },
        {
          "id": "ButcheryUpgrade",
          "en": "Butchery Upgrade",
          "fr": "Amélioration basique : Boucherie",
          "es": "Mejora: Carnicería",
          "de": "Grundlegendes Upgrade: Metzgerei",
          "pt": "Melhoria de Açougue",
          "it": "Aggiornamento Macelleria",
          "tr": "Kasaplık Geliştirmesi",
          "pl": "Ulepszenie Rzeźnictwa",
          "ru": "Улучшение разделки",
          "uk": "Покращення різництва",
          "ko": "도축 업그레이드",
          "zh": "加工升级组件",
          "ja": "Butchery Upgrade"
        },
        {
          "id": "BasicEngineeringUpgrade",
          "en": "Basic Engineering Upgrade",
          "fr": "Amélioration basique : Ingénierie basique",
          "es": "Mejora básica: Ingeniería",
          "de": "Grundlegendes Upgrade: Grundlegende Technik",
          "pt": "Melhoria Básica de Engenharia",
          "it": "Aggiornamento Ingegneria Base",
          "tr": "Basit Mühendislik Geliştirmesi",
          "pl": "Podstawowe ulepszenie Inżynierii",
          "ru": "Улучшение для основ инженерного дела",
          "uk": "Базове покращення інженерії",
          "ko": "기초 기계공학 업그레이드",
          "zh": "基础工程升级",
          "ja": "Basic Engineering Upgrade"
        },
        {
          "id": "BakingUpgrade",
          "en": "Baking Upgrade",
          "fr": "Amélioration avancée : Boulangerie",
          "es": "Mejora: Horneado",
          "de": "Fortschrittliches Upgrade: Backen",
          "pt": "Melhoria de Assados",
          "it": "Aggiornamento Cottura al forno",
          "tr": "Fırınlama Geliştirmesi",
          "pl": "Ulepszenie Pieczenia",
          "ru": "Улучшение для выпечки",
          "uk": "Покращення випічки",
          "ko": "제빵 업그레이드",
          "zh": "烘烤升级",
          "ja": "Baking Upgrade"
        },
        {
          "id": "AdvancedSmeltingUpgrade",
          "en": "Advanced Smelting Upgrade",
          "fr": "Amélioration avancée : Fonte avancée",
          "es": "Mejora avanzada: Fundición",
          "de": "Fortschrittliches Upgrade: Schmelzen",
          "pt": "Melhoria Avançada de Fundição",
          "it": "Aggiornamento Avanzato Fusione",
          "tr": "İleri Seviye Eritme Geliştirmesi",
          "pl": "Zaawansowane ulepszenie Wytapiania",
          "ru": "Улучшение для продвинутой выплавки",
          "uk": "Просунуте покращення виплавки",
          "ko": "고급 제련 업그레이드",
          "zh": "高级冶炼升级",
          "ja": "Advanced Smelting Upgrade"
        },
        {
          "id": "AdvancedMasonryUpgrade",
          "en": "Advanced Masonry Upgrade",
          "fr": "Amélioration moderne : Maçonnerie avancée",
          "es": "Mejora: Mampostería avanzada",
          "de": "Fortschrittliches Upgrade: Steinmetz",
          "pt": "Melhoria de Alvenaria Avançada",
          "it": "Aggiornamento Avanzato Muratura",
          "tr": "İleri Seviye Duvarcılık Geliştirmesi",
          "pl": "Zaawansowane ulepszenie Kamieniarstwa",
          "ru": "Улучшение для продвинутой каменной кладки",
          "uk": "Просунуте покращення кладки",
          "ko": "고급 석조 업그레이드",
          "zh": "高级石工升级组件",
          "ja": "高度な石工アップグレード"
        },
        {
          "id": "AdvancedCookingUpgrade",
          "en": "Advanced Cooking Upgrade",
          "fr": "Amélioration avancée : Cuisine avancée",
          "es": "Mejora avanzada: Cocina",
          "de": "Fortschrittliches Upgrade: Kochen",
          "pt": "Melhoria Avançada de Cozimento",
          "it": "Aggiornamento Avanzato Cucina",
          "tr": "İleri Seviye Aşçılık Geliştirmesi",
          "pl": "Zaawansowane ulepszenie Gotowania",
          "ru": "Улучшение для продвинутой кулинарии",
          "uk": "Просунуте покращення приготування їжі",
          "ko": "고급 요리 업그레이드",
          "zh": "高级烹饪升级",
          "ja": "Advanced Cooking Upgrade"
        },
        {
          "id": "AdvancedBakingUpgrade",
          "en": "Advanced Baking Upgrade",
          "fr": "Amélioration avancée : Boulangerie avancée",
          "es": "Mejora avanzada: Horneado",
          "de": "Fortschrittliches Upgrade: Backen",
          "pt": "Melhoria Avançada de Assados",
          "it": "Aggiornamento Avanzato Cottura al forno",
          "tr": "İleri Seviye Fırınlama Geliştirmesi",
          "pl": "Ulepszenie Zaawansowanego Pieczenia",
          "ru": "Улучшение для продвинутой выпечки",
          "uk": "Просунуте покращення випічки",
          "ko": "고급 제빵 업그레이드",
          "zh": "高级烘烤升级",
          "ja": "Advanced Baking Upgrade"
        },
        {
          "id": "MetallurgyResearchPaperModern",
          "en": "Metallurgy Research Paper Modern",
          "fr": "Papier de recherche : Métallurgie moderne",
          "es": "Trabajo de investigación en metalurgia (moderno)",
          "de": "Modernes Forschungspapier: Metallurgie",
          "pt": "Documento de Pesquisa Moderno de Metalurgia",
          "it": "Documento di Ricerca Moderno di Metallurgia",
          "tr": "Madencilik Araştırma Makalesi Modern",
          "pl": "Nowoczesny artykuł badawczy Metalurgii",
          "ru": "Исследование по современной металлургии",
          "uk": "Дослідження сучасної металургії",
          "ko": "현대식 금속공학 연구지",
          "zh": "现代冶金研究论文",
          "ja": "精錬の最先端な研究書"
        },
        {
          "id": "Pirozhok",
          "en": "Pirozhok",
          "fr": "Pirozhok",
          "es": "Pirozhok",
          "de": "Pirozhok",
          "pt": "Pirozhok",
          "it": "Pirozhoki",
          "tr": "Pirozhok",
          "pl": "Kulebiak",
          "ru": "Пирожок",
          "uk": "Пиріжок",
          "ko": "피로시키",
          "zh": "皮罗佐克",
          "ja": "Pirozhok"
        },
        {
          "id": "ButcherTinyLeatherAnimal",
          "en": "Butcher Tiny Leather Animal",
          "fr": "Dépecer le minuscule animal à peau",
          "es": "Descuartizar animal minúsculo (cuero)",
          "de": "Winziges Ledertier schlachten",
          "pt": "Carnear Couro de Animal Minúsculo",
          "it": "Macella Minuscolo Animale di Pelle",
          "tr": "Küçük Derili Hayvanı Kes",
          "pl": "Przerób malutkie skórzaste zwierzę",
          "ru": "Разделать крошечное животное с ценной кожей",
          "uk": "Різництво маленької тварини зі шкірою",
          "ko": "초소형 털달린 사체 도축법",
          "zh": "加工微型毛皮动物",
          "ja": "Butcher Tiny Leather Animal"
        },
        {
          "id": "ButcherTinyFurAnimal",
          "en": "Butcher Tiny Fur Animal",
          "fr": "Dépecer le minuscule animal à fourrure",
          "es": "Descuartizar animal minúsculo (pelaje)",
          "de": "Winziges Felltier schlachten",
          "pt": "Carnear Animal Peludo Minúsculo",
          "it": "Macella Minuscolo Animale di Pelliccia",
          "tr": "Küçük Kürklü Hayvanı Kes",
          "pl": "Przerób malutkie furzaste zwierzę",
          "ru": "Разделать крошечное меховое животное",
          "uk": "Різництво маленької тварини з хутром",
          "ko": "초소형 모피달린 사체 도축법",
          "zh": "加工微型皮革动物",
          "ja": "Butcher Tiny Fur Animal"
        },
        {
          "id": "IronSickle",
          "en": "Iron Sickle",
          "fr": "Faucille en fer",
          "es": "Hoz de hierro",
          "de": "Eisensichel",
          "pt": "Foice de Ferro",
          "it": "Falce di Ferro",
          "tr": "Demir Orak",
          "pl": "Żelazny Sierp",
          "ru": "Железный серп",
          "uk": "Залізний серп",
          "ko": "철 낫",
          "zh": "铁镰",
          "ja": "Iron Sickle"
        },
        {
          "id": "StreetSign",
          "en": "Street Sign",
          "fr": "Panneau de rue",
          "es": "Letrero de calle",
          "de": "Straßenschild",
          "pt": "Placa de Rua",
          "it": "Cartello Stradale",
          "tr": "Sokak Tabelası",
          "pl": "Znak Uliczny",
          "ru": "Уличный указатель",
          "uk": "Вуличний знак",
          "ko": "거리 표지판",
          "zh": "街道路标",
          "ja": "道路標識"
        },
        {
          "id": "StopSign",
          "en": "Stop Sign",
          "fr": "Panneau stop",
          "es": "Señal de STOP",
          "de": "Stoppschild",
          "pt": "Placa de Pare",
          "it": "Segnale di Stop",
          "tr": "Dur Tabelası",
          "pl": "Znak stop",
          "ru": "Знак Стоп",
          "uk": "Знак стоп",
          "ko": "일단정지 표지판",
          "zh": "停止标志",
          "ja": "停止標識"
        },
        {
          "id": "ModernStreetLight",
          "en": "Modern Street Light",
          "fr": "Lampadaire moderne",
          "es": "Farola moderna",
          "de": "Moderne Straßenlaterne",
          "pt": "Poste de Luz Moderno",
          "it": "Lampione Moderno",
          "tr": "Modern Sokak Lambası",
          "pl": "Nowoczesna lampa uliczna",
          "ru": "Современный уличный фонарь",
          "uk": "Сучасний вуличний ліхтар",
          "ko": "현대식 가로등",
          "zh": "现代路灯",
          "ja": "Modern Street Light"
        },
        {
          "id": "ModernDoubleStreetLight",
          "en": "Modern Double Street Light",
          "fr": "Lampadaire moderne à deux bras",
          "es": "Farola doble moderna",
          "de": "Moderne zweiarmige Straßenlaterne",
          "pt": "Poste de Luz Duplo Moderno",
          "it": "Doppio Lampione Moderno",
          "tr": "Modern İkili Sokak Lambası",
          "pl": "Nowoczesna podwójna lampa uliczna",
          "ru": "Современный двойной уличный фонарь",
          "uk": "Сучасний подвійний вуличний ліхтар",
          "ko": "현대식 이중 가로등",
          "zh": "现代双路灯",
          "ja": "Modern Double Street Light"
        },
        {
          "id": "ShredKelp",
          "en": "Shred Kelp",
          "fr": "Effilocher le varech",
          "es": "Algas trituradas",
          "de": "Seetang zerkleinern",
          "pt": "Alga Desfiada",
          "it": "Trita Alga",
          "tr": "Dilimlenmiş Yosun",
          "pl": "Postrzępione wodorosty",
          "ru": "Нарезать ламинарию",
          "uk": "Нарізати ламінарію",
          "ko": "다시마 썰기",
          "zh": "海带丝",
          "ja": "昆布を細かく切る"
        },
        {
          "id": "MiningModernUpgrade",
          "en": "Mining Modern Upgrade",
          "fr": "Amélioration moderne : Minage",
          "es": "Mejora moderna: Minería",
          "de": "Modernes Upgrade: Bergbau",
          "pt": "Melhoria Moderna de Mineração",
          "it": "Aggiornamento Moderno Estrazione Mineraria",
          "tr": "Madencilik Modern Geliştirme",
          "pl": "Nowoczesne ulepszenie Górnictwa",
          "ru": "Современное улучшение для горного дела",
          "uk": "Новітнє покращення видобутку",
          "ko": "현대식 채광 업그레이드",
          "zh": "采矿现代化升级",
          "ja": "Mining Modern Upgrade"
        },
        {
          "id": "MiningBasicUpgrade",
          "en": "Mining Basic Upgrade",
          "fr": "Amélioration basique : Minage",
          "es": "Mejora básica: Minería",
          "de": "Grundlegendes Upgrade: Bergbau",
          "pt": "Melhoria Básica de Mineração",
          "it": "Aggiornamento Base Estrazione Mineraria",
          "tr": "Madencilik Temel Geliştirme",
          "pl": "Podstawowe ulepszenie Górnictwa",
          "ru": "Базовое улучшение для горного дела",
          "uk": "Базове покращення видобутку",
          "ko": "기초 채광 업그레이드",
          "zh": "采矿基础升级",
          "ja": "Mining Basic Upgrade"
        },
        {
          "id": "MiningAdvancedUpgrade",
          "en": "Mining Advanced Upgrade",
          "fr": "Amélioration avancée : Minage",
          "es": "Mejora avanzada: Minería",
          "de": "Fortschrittliches Upgrade: Bergbau",
          "pt": "Melhoria Avançada de Mineração",
          "it": "Aggiornamento Avanzato Estrazione Mineraria",
          "tr": "Madencilik İleri Seviye Geliştirme",
          "pl": "Zaawansowane ulepszenie Górnictwa",
          "ru": "Продвинутое улучшение для горного дела",
          "uk": "Просунуте покращення видобутку",
          "ko": "고급 채광 업그레이드",
          "zh": "采矿高级升级",
          "ja": "Mining Advanced Upgrade"
        },
        {
          "id": "MechanicsModernUpgrade",
          "en": "Mechanics Modern Upgrade",
          "fr": "Amélioration moderne : Mécaniques",
          "es": "Mejora moderna: Mecánica",
          "de": "Modernes Upgrade: Mechanik",
          "pt": "Melhoria Moderna de Mecânica",
          "it": "Aggiornamento Moderno Meccanica",
          "tr": "Mekanik Modern Geliştirme",
          "pl": "Nowoczesne ulepszenie Mechaniki",
          "ru": "Современное улучшение для механики",
          "uk": "Новітнє покращення механіки",
          "ko": "현대식 기계정비 업그레이드",
          "zh": "机械现代升级",
          "ja": "Mechanics Modern Upgrade"
        },
        {
          "id": "MechanicsAdvancedUpgrade",
          "en": "Mechanics Advanced Upgrade",
          "fr": "Amélioration avancée : Mécaniques",
          "es": "Mejora avanzada: Mecánica",
          "de": "Fortschrittliches Upgrade: Mechanik",
          "pt": "Melhoria Avançada de Mecânica",
          "it": "Aggiornamento Avanzato Meccanica",
          "tr": "Mekanik İleri Seviye Geliştirme",
          "pl": "Zaawansowane ulepszenie Mechaniki",
          "ru": "Продвинутое улучшение для механики",
          "uk": "Mechanics Advanced Upgrade",
          "ko": "고급 기계정비 업그레이드",
          "zh": "机械高级升级",
          "ja": "Mechanics Advanced Upgrade"
        },
        {
          "id": "MasonryBasicUpgrade",
          "en": "Masonry Basic Upgrade",
          "fr": "Amélioration basique : Maçonnerie",
          "es": "Mejora básica: Mampostería",
          "de": "Grundlegendes Upgrade: Steinmetz",
          "pt": "Melhoria Básica de Alvenaria",
          "it": "Aggiornamento Base Muratura",
          "tr": "Duvarcılık Temel Geliştirme",
          "pl": "Podstawowe ulepszenie Kamieniarstwa",
          "ru": "Базовое улучшение для каменной кладки",
          "uk": "Masonry Basic Upgrade",
          "ko": "기초 석조 업그레이드",
          "zh": "基础石工升级组件",
          "ja": "石工の基礎アップグレード"
        },
        {
          "id": "LoggingBasicUpgrade",
          "en": "Logging Basic Upgrade",
          "fr": "Amélioration basique : Abattage",
          "es": "Mejora básica: Tala",
          "de": "Grundlegendes Upgrade: Holzfäller",
          "pt": "Melhoria Básica de Extração de Madeira",
          "it": "Aggiornamento Base Tagliare Tronchi",
          "tr": "Odunculuk Temel Geliştirme",
          "pl": "Podstawowe ulepszenie Wyrębu Drzew",
          "ru": "Базовое улучшение для заготовки леса",
          "uk": "Logging Basic Upgrade",
          "ko": "기초 벌목 업그레이드",
          "zh": "伐木基础升级",
          "ja": "Logging Basic Upgrade"
        },
        {
          "id": "LoggingAdvancedUpgrade",
          "en": "Logging Advanced Upgrade",
          "fr": "Amélioration avancée : Abattage",
          "es": "Mejora avanzada: Tala",
          "de": "Fortschrittliches Upgrade: Holzfäller",
          "pt": "Melhoria Avançada de Extração de Madeira",
          "it": "Aggiornamento Avanzato Tagliare Tronchi",
          "tr": "Odunculuk İleri Seviye Geliştirme",
          "pl": "Zaawansowane ulepszenie Wyrębu Drzew",
          "ru": "Продвинутое улучшение для заготовки леса",
          "uk": "Logging Advanced Upgrade",
          "ko": "고급 벌목 업그레이드",
          "zh": "伐木高级升级",
          "ja": "Logging Advanced Upgrade"
        },
        {
          "id": "GlassworkingModernUpgrade",
          "en": "Glassworking Modern Upgrade",
          "fr": "Amélioration moderne : Travail du verre",
          "es": "Mejora moderna: Artesanía del cristal",
          "de": "Modernes Upgrade: Glasverarbeitung",
          "pt": "Melhoria Moderna de Trabalho com Vidro",
          "it": "Aggiornamento Moderno Lavorazione del Vetro",
          "tr": "Cam İşleme Modern Geliştirme",
          "pl": "Nowoczesne ulepszenie Obróbki Szkła",
          "ru": "Современное улучшение для обработки стекла",
          "uk": "Новітнє покращення обробки скла",
          "ko": "현대식 유리 제조 업그레이드",
          "zh": "玻璃加工现代升级",
          "ja": "Glassworking Modern Upgrade"
        },
        {
          "id": "GlassworkingAdvancedUpgrade",
          "en": "Glassworking Advanced Upgrade",
          "fr": "Amélioration avancée : Travail du verre",
          "es": "Mejora avanzada: Artesanía de cristal",
          "de": "Fortschrittliches Upgrade: Glasverarbeitung",
          "pt": "Melhoria Avançada de Trabalho com Vidro",
          "it": "Aggiornamento Avanzato Lavorazione del Vetro",
          "tr": "Cam İşleme İleri Seviye Geliştirme",
          "pl": "Zaawansowane ulepszenie Obróbki Szkła",
          "ru": "Продвинутое улучшение для стеклообработки",
          "uk": "Glassworking Advanced Upgrade",
          "ko": "고급 유리 제조 업그레이드",
          "zh": "玻璃加工高级升级",
          "ja": "Glassworking Advanced Upgrade"
        },
        {
          "id": "CarpentryBasicUpgrade",
          "en": "Carpentry Basic Upgrade",
          "fr": "Amélioration basique : Menuiserie",
          "es": "Mejora básica: Carpintería",
          "de": "Grundlegendes Upgrade: Schreinerei",
          "pt": "Melhoria Básica de Carpintaria",
          "it": "Aggiornamento Base Carpenteria",
          "tr": "Marangozluk Temel Geliştirme",
          "pl": "Podstawowe ulepszenie Stolarstwa",
          "ru": "Базовое улучшение для плотницкого дела",
          "uk": "Carpentry Basic Upgrade",
          "ko": "기초 목공 업그레이드",
          "zh": "木工基础升级",
          "ja": "Carpentry Basic Upgrade"
        },
        {
          "id": "CarpentryAdvancedUpgrade",
          "en": "Carpentry Advanced Upgrade",
          "fr": "Amélioration avancée : Menuiserie",
          "es": "Mejora avanzada: Carpintería",
          "de": "Fortschrittliches Upgrade: Schreinerei",
          "pt": "Melhoria Avançada de Carpintaria",
          "it": "Aggiornamento Avanzato Carpenteria",
          "tr": "Marangozluk İleri Seviye Geliştirme",
          "pl": "Zaawansowane ulepszenie Stolarstwa",
          "ru": "Продвинутое улучшение для плотницкого дела",
          "uk": "Carpentry Advanced Upgrade",
          "ko": "고급 목공 업그레이드",
          "zh": "木工高级升级",
          "ja": "Carpentry Advanced Upgrade"
        },
        {
          "id": "CamasAshFertilizer",
          "en": "Camas ash fertilizer",
          "fr": " is a great source of potassium.",
          "es": "",
          "de": "L\u0027engrais aux cendres de camassia",
          "pt": " est une bonne source de potassium.",
          "it": "Prärielilien Aschedünger ist zwar nicht sehr stark",
          "tr": " though not very potent",
          "pl": " embora não muito potente",
          "ru": " es una buena fuente de potasio.",
          "uk": "Il fertilizzante di polvere di Cama",
          "ko": " bien que peu puissant",
          "zh": "Fertilizante de cenizas de camasia. Aunque no es muy potente",
          "ja": " 엄청 좋은 건 아니어도 훌륭한 칼륨 공급원이다."
        },
        {
          "id": "AsphaltConcrete",
          "en": "Asphalt Concrete",
          "fr": "Route en asphalte",
          "es": "Hormigón asfáltico",
          "de": "Asphaltbeton",
          "pt": "Concreto asfáltico",
          "it": "Asfalto",
          "tr": "Beton Asfalt",
          "pl": "Asfaltobeton",
          "ru": "Асфальтобетон",
          "uk": "Asphalt Concrete",
          "ko": "아스팔트 콘크리트",
          "zh": "沥青混凝土",
          "ja": "Asphalt Concrete"
        },
        {
          "id": "HandPlow",
          "en": "Hand Plow",
          "fr": "Charrue à main",
          "es": "Arado manual",
          "de": "Handpflug",
          "pt": "Arado Manual",
          "it": "Aratro Manuale",
          "tr": "El Sabanı",
          "pl": "Hand Plow",
          "ru": "Ручной плуг",
          "uk": "Ручний плуг",
          "ko": "손쟁기",
          "zh": "手犁",
          "ja": "手鋤"
        },
        {
          "id": "CompositeBow",
          "en": "Composite Bow",
          "fr": "Arc composite",
          "es": "Arco de madera de composite",
          "de": "Kompositbogen",
          "pt": "Arco Composto",
          "it": "Arco Composito",
          "tr": "Kompozit Yay",
          "pl": "Łuk kompozytowy",
          "ru": "Композитный лук",
          "uk": "Composite Bow",
          "ko": "합성 활",
          "zh": "复合弓",
          "ja": "Composite Bow"
        },
        {
          "id": "ModernUpgradeLvl4",
          "en": "Modern Upgrade 4",
          "fr": "Amélioration moderne nv. 4",
          "es": "Mejora moderna 4",
          "de": "Modernes Upgrade 4",
          "pt": "Melhoria Moderna 4",
          "it": "Aggiornamento Moderno 4",
          "tr": "Modern Geliştirme 4",
          "pl": "Nowoczesne ulepszenie 4",
          "ru": "Современное улучшение 4",
          "uk": "Новітнє покращення 4",
          "ko": "현대식 업그레이드 4",
          "zh": "现代升级4",
          "ja": "近代アップグレード4"
        },
        {
          "id": "ModernUpgradeLvl3",
          "en": "Modern Upgrade 3",
          "fr": "Amélioration moderne nv. 3",
          "es": "Mejora moderna 3",
          "de": "Modernes Upgrade 3",
          "pt": "Melhoria Moderna 3",
          "it": "Aggiornamento Moderno 3",
          "tr": "Modern Geliştirme 3",
          "pl": "Nowoczesne ulepszenie 3",
          "ru": "Современное улучшение 3",
          "uk": "Новітнє покращення 3",
          "ko": "현대식 업그레이드 3",
          "zh": "现代升级3",
          "ja": "近代アップグレード3"
        },
        {
          "id": "ModernUpgradeLvl2",
          "en": "Modern Upgrade 2",
          "fr": "Amélioration moderne nv. 2",
          "es": "Mejora moderna 2",
          "de": "Modernes Upgrade 2",
          "pt": "Melhoria Moderna 2",
          "it": "Aggiornamento Moderno 2",
          "tr": "Modern Geliştirme 2",
          "pl": "Nowoczesne ulepszenie 2",
          "ru": "Современное улучшение 2",
          "uk": "Новітнє покращення 2",
          "ko": "현대식 업그레이드 2",
          "zh": "现代升级2",
          "ja": "近代アップグレード2"
        },
        {
          "id": "ModernUpgradeLvl1",
          "en": "Modern Upgrade 1",
          "fr": "Amélioration moderne nv. 1",
          "es": "Mejora moderna 1",
          "de": "Modernes Upgrade 1",
          "pt": "Melhoria Moderna 1",
          "it": "Aggiornamento Moderno 1",
          "tr": "Modern Geliştirme 1",
          "pl": "Nowoczesne ulepszenie 1",
          "ru": "Современное улучшение 1",
          "uk": "Новітнє покращення 1",
          "ko": "현대식 업그레이드 1",
          "zh": "现代升级1",
          "ja": "近代アップグレード1"
        },
        {
          "id": "BasicUpgradeLvl4",
          "en": "Basic Upgrade 4",
          "fr": "Amélioration basique nv. 4",
          "es": "Mejora básica 4",
          "de": "Grundlegendes Upgrade 4",
          "pt": "Melhoria Básica 4",
          "it": "Aggiornamento Base 4",
          "tr": "Temel Geliştirme 4",
          "pl": "Podstawowe ulepszenie 4",
          "ru": "Базовое улучшение 4",
          "uk": "Базове покращення 4",
          "ko": "기초 업그레이드 4",
          "zh": "基础升级4",
          "ja": "基礎アップグレード4"
        },
        {
          "id": "BasicUpgradeLvl3",
          "en": "Basic Upgrade 3",
          "fr": "Amélioration basique nv. 3",
          "es": "Mejora básica 3",
          "de": "Grundlegendes Upgrade 3",
          "pt": "Melhoria Básica 3",
          "it": "Aggiornamento Base 3",
          "tr": "Temel Geliştirme 3",
          "pl": "Podstawowe ulepszenie 3",
          "ru": "Базовое улучшение 3",
          "uk": "Базове покращення 3",
          "ko": "기초 업그레이드 3",
          "zh": "基础升级3",
          "ja": "基礎アップグレード3"
        },
        {
          "id": "BasicUpgradeLvl2",
          "en": "Basic Upgrade 2",
          "fr": "Amélioration basique nv. 2",
          "es": "Mejora básica 2",
          "de": "Grundlegendes Upgrade 2",
          "pt": "Melhoria Básica 2",
          "it": "Aggiornamento Base 2",
          "tr": "Temel Geliştirme 2",
          "pl": "Podstawowe ulepszenie 2",
          "ru": "Базовое улучшение 2",
          "uk": "Базове покращення 2",
          "ko": "기초 업그레이드 2",
          "zh": "基础升级2",
          "ja": "基礎アップグレード2"
        },
        {
          "id": "BasicUpgradeLvl1",
          "en": "Basic Upgrade 1",
          "fr": "Amélioration basique nv. 1",
          "es": "Mejora básica 1",
          "de": "Grundlegendes Upgrade 1",
          "pt": "Melhoria Básica 1",
          "it": "Aggiornamento Base 1",
          "tr": "Temel Geliştirme 1",
          "pl": "Podstawowe ulepszenie 1",
          "ru": "Базовое улучшение 1",
          "uk": "Базове покращення 1",
          "ko": "기초 업그레이드 1",
          "zh": "基础升级1",
          "ja": "基礎アップグレード1"
        },
        {
          "id": "AdvancedUpgradeLvl4",
          "en": "Advanced Upgrade 4",
          "fr": "Amélioration avancée nv. 4",
          "es": "Mejora avanzada 4",
          "de": "Fortschrittliches Upgrade 4",
          "pt": "Melhoria Avançada 4",
          "it": "Aggiornamento Avanzato 4",
          "tr": "İleri Seviye Geliştirme 4",
          "pl": "Zaawansowane ulepszenie 4",
          "ru": "Продвинутое улучшение 4",
          "uk": "Просунуте покращення 4",
          "ko": "고급 업그레이드 4",
          "zh": "高级升级4",
          "ja": "Advanced Upgrade 4"
        },
        {
          "id": "AdvancedUpgradeLvl3",
          "en": "Advanced Upgrade 3",
          "fr": "Amélioration avancée nv. 3",
          "es": "Mejora avanzada 3",
          "de": "Fortschrittliches Upgrade 3",
          "pt": "Melhoria Avançada 3",
          "it": "Aggiornamento Avanzato 3",
          "tr": "İleri Seviye Geliştirme 3",
          "pl": "Zaawansowane ulepszenie 3",
          "ru": "Продвинутое улучшение 3",
          "uk": "Просунуте покращення 3",
          "ko": "고급 업그레이드 3",
          "zh": "高级升级3",
          "ja": "Advanced Upgrade 3"
        },
        {
          "id": "AdvancedUpgradeLvl2",
          "en": "Advanced Upgrade 2",
          "fr": "Amélioration avancée nv. 2",
          "es": "Mejora avanzada 2",
          "de": "Fortschrittliches Upgrade 2",
          "pt": "Melhoria Avançada 2",
          "it": "Aggiornamento Avanzato 2",
          "tr": "İleri Seviye Geliştirme 2",
          "pl": "Zaawansowane ulepszenie 2",
          "ru": "Продвинутое улучшение 2",
          "uk": "Просунуте покращення 2",
          "ko": "고급 업그레이드 2",
          "zh": "高级升级2",
          "ja": "Advanced Upgrade 2"
        },
        {
          "id": "AdvancedUpgradeLvl1",
          "en": "Advanced Upgrade 1",
          "fr": "Amélioration avancée nv. 1",
          "es": "Mejora avanzada 1",
          "de": "Fortschrittliches Upgrade 1",
          "pt": "Melhoria Avançada 1",
          "it": "Aggiornamento Avanzato 1",
          "tr": "İleri Seviye Geliştirme 1",
          "pl": "Zaawansowane ulepszenie 1",
          "ru": "Продвинутое улучшение 1",
          "uk": "Просунуте покращення 1",
          "ko": "고급 업그레이드 1",
          "zh": "高级升级1",
          "ja": "Advanced Upgrade 1"
        },
        {
          "id": "SteamTractorPlow",
          "en": "Steam Tractor Plow",
          "fr": "Charrue pour tracteur à vapeur",
          "es": "Arado con tractor a vapor",
          "de": "Dampftraktor-Pflug",
          "pt": "Trator Arador à Vapor",
          "it": "Aratro del Trattore A Vapore",
          "tr": "Buharlı Traktör Sabanı",
          "pl": "Steam Tractor Plow",
          "ru": "Плуг парового трактора",
          "uk": "Steam Tractor Plow",
          "ko": "증기기관 트랙터 쟁기",
          "zh": "蒸汽拖拉机犁",
          "ja": "Steam Tractor Plow"
        },
        {
          "id": "TailoringBasicUpgrade",
          "en": "Tailoring Basic Upgrade",
          "fr": "Amélioration basique : Couture",
          "es": "Mejora básica: Sastrería",
          "de": "Grundlegendes Upgrade: Schneidern",
          "pt": "Melhoria Básica de Alfaiataria",
          "it": "Aggiornamento Base Sartoria",
          "tr": "Terzicilik Temel Geliştirme",
          "pl": "Podstawowe ulepszenie Krawiectwa",
          "ru": "Базовое улучшение для портняжного дела",
          "uk": "Tailoring Basic Upgrade",
          "ko": "기초 재단 업그레이드",
          "zh": "裁缝基础升级",
          "ja": "Tailoring Basic Upgrade"
        },
        {
          "id": "MasonryAdvancedUpgrade",
          "en": "Masonry Advanced Upgrade",
          "fr": "Amélioration avancée : Maçonnerie",
          "es": "Mejora avanzada: Mampostería",
          "de": "Fortschrittliches Upgrade: Steinmetz",
          "pt": "Melhoria Avançada de Alvenaria",
          "it": "Aggiornamento Avanzato Muratura",
          "tr": "Marangozluk İleri Seviye Geliştirme",
          "pl": "Zaawansowane ulepszenie Kamieniarstwa",
          "ru": "Продвинутое улучшение для каменной кладки",
          "uk": "Masonry Advanced Upgrade",
          "ko": "고급 석조 업그레이드",
          "zh": "高级石工升级组件",
          "ja": "石工の応用アップグレード"
        },
        {
          "id": "FlatSteelDoor",
          "en": "Flat Steel Door",
          "fr": "Porte en acier lisse",
          "es": "Puerta plana de acero",
          "de": "Wohnungstüre aus Stahl",
          "pt": "Porta de Aço Plano",
          "it": "Porta in acciaio Piatta",
          "tr": "Flat Steel Door",
          "pl": "Drzwi z blachy stalowej",
          "ru": "Дверь из листовой стали",
          "uk": "Flat Steel Door",
          "ko": "평철 문",
          "zh": "扁平铁门",
          "ja": "Flat Steel Door"
        },
        {
          "id": "IndustrialElevator",
          "en": "Industrial Elevator",
          "fr": "Ascenseur industriel",
          "es": "Montacargas industrial",
          "de": "Industrieaufzug",
          "pt": "Elevador Industrial",
          "it": "Ascensore industriale",
          "tr": "Endüstriyel Asansör",
          "pl": "Industrial Elevator",
          "ru": "Промышленный лифт",
          "uk": "Industrial Elevator",
          "ko": "공업용 승강기",
          "zh": "工业化升降机",
          "ja": "Industrial Elevator"
        },
        {
          "id": "StorageSilo",
          "en": "Storage Silo",
          "fr": "Silo de stockage",
          "es": "Silo de almacenamiento",
          "de": "Hölzernes Vorratssilo",
          "pt": "Silo de Armazenamento",
          "it": "Silo di Stoccaggio",
          "tr": "Storage Silo",
          "pl": "Silos magazynowy",
          "ru": "Силосная башня",
          "uk": "Storage Silo",
          "ko": "사일로",
          "zh": "储料仓",
          "ja": "Storage Silo"
        },
        {
          "id": "StandingSteelBrickSign",
          "en": "Standing Steel Brick Sign",
          "fr": "Panneau sur pied de brique et d\u0027acier",
          "es": "Letrero de acero (ladrillos)",
          "de": "Stahlschild mit Ziegelsteinfundament (stehend)",
          "pt": "Placa de Tijolos de Aço em Pé",
          "it": "Segnale Verticale in Mattoni d\u0027Acciaio",
          "tr": "Standing Steel Brick Sign",
          "pl": "Standing Steel Brick Sign",
          "ru": "Стальная стела на кирпичном основании",
          "uk": "Standing Steel Brick Sign",
          "ko": "강철 벽돌 간판",
          "zh": "钢砖标志",
          "ja": "鋼の立て看板（レンガ）"
        },
        {
          "id": "StandingLongSteelSign",
          "en": "Standing Long Steel Sign",
          "fr": "Long panneau sur pied en acier",
          "es": "Letrero largo (acero)",
          "de": "Stahlschild (lang",
          "pt": "강철 긴 간판",
          "it": "Стальная длинная стела",
          "tr": "Standing Long Steel Sign",
          "pl": "Standing Long Steel Sign",
          "ru": "长条钢制标志",
          "uk": "Standing Long Steel Sign",
          "ko": " stehend)",
          "zh": "Placa Longa de Aço em Pé",
          "ja": "Standing Long Steel Sign"
        },
        {
          "id": "StandingGlassSign",
          "en": "Standing Glass Sign",
          "fr": "Grand panneau sur pied en verre",
          "es": "Letrero de vidrio",
          "de": "Glasschild (stehend)",
          "pt": "Placa de Vidro em Pé",
          "it": "Segnale Verticale in Vetro",
          "tr": "Standing Glass Sign",
          "pl": "Standing Glass Sign",
          "ru": "Стеклянная табличка",
          "uk": "Standing Glass Sign",
          "ko": "유리 간판",
          "zh": "玻璃标志",
          "ja": "ガラスの立て看板"
        },
        {
          "id": "PoweredStorageSilo",
          "en": "Powered Storage Silo",
          "fr": "Silo de stockage électrique",
          "es": "Silo de almacenamiento eléctronico",
          "de": "Modernes Lagersilo",
          "pt": "Silo de Armazenamento Elétrico",
          "it": "Silo di Stoccaggio Alimentato",
          "tr": "Powered Storage Silo",
          "pl": "Silos napędzany energią elektryczną",
          "ru": "Электрическая Силосная башня",
          "uk": "Powered Storage Silo",
          "ko": "전기식 사일로",
          "zh": "已充电储料仓",
          "ja": "Powered Storage Silo"
        },
        {
          "id": "HangingSteelShopSign",
          "en": "Hanging Steel Shop Sign",
          "fr": "Panneau suspendu en acier pour magasin",
          "es": "Letrero colgante de tienda (acero)",
          "de": "Stahlschild für Geschäft (hängend)",
          "pt": "Placa de Loja de Aço Pendurada",
          "it": "Cartellone da Negozio Appeso in Acciaio",
          "tr": "Hanging Steel Shop Sign",
          "pl": "Hanging Steel Shop Sign",
          "ru": "Стальная магазинная вывеска",
          "uk": "Hanging Steel Shop Sign",
          "ko": "강철 가게 현판",
          "zh": "钢制商店悬挂标志",
          "ja": "鋼の掛け看板（店舗）"
        },
        {
          "id": "HangingSteelPlainSign",
          "en": "Hanging Steel Plain Sign",
          "fr": "Panneau suspendu en acier épuré",
          "es": "Letrero colgante (acero)",
          "de": "Stahlschild (glatt",
          "pt": "강철 평평한 현판",
          "it": "Стальная обычная вывеска",
          "tr": "Hanging Steel Plain Sign",
          "pl": "Hanging Steel Plain Sign",
          "ru": "钢制平整悬挂标志",
          "uk": "Hanging Steel Plain Sign",
          "ko": " hängend)",
          "zh": "Placa Plana de Aço Pendurada",
          "ja": "Hanging Steel Plain Sign"
        },
        {
          "id": "HangingSteelMineSign",
          "en": "Hanging Steel Mine Sign",
          "fr": "Panneau suspendu en acier pour mine",
          "es": "Letrero colgante de mina (acero)",
          "de": "Stahlschild für Minen (hängend)",
          "pt": "Placa de Mina de Aço Pendurada",
          "it": "Cartellone da Miniera in Acciaio Appeso",
          "tr": "Hanging Steel Mine Sign",
          "pl": "Hanging Steel Mine Sign",
          "ru": "Стальная вывеска для шахты",
          "uk": "Hanging Steel Mine Sign",
          "ko": "강철 광산 현판",
          "zh": "矿用钢悬挂标志",
          "ja": "鋼の掛け看板（採掘）"
        },
        {
          "id": "HangingSteelFramedSign",
          "en": "Hanging Steel Framed Sign",
          "fr": "Grand panneau suspendu encadré en acier",
          "es": "Letrero colgante con marco (acero)",
          "de": "Stahlschild (gerahmt",
          "pt": "강철 액자식 현판",
          "it": "Стальная обрамлённая вывеска",
          "tr": "Hanging Steel Framed Sign",
          "pl": "Hanging Steel Framed Sign",
          "ru": "钢制框式悬挂标志",
          "uk": "Hanging Steel Framed Sign",
          "ko": " hängend)",
          "zh": "Placa Emoldurada de Aço Pendurada",
          "ja": "Hanging Steel Framed Sign"
        },
        {
          "id": "HangingLongSteelSign",
          "en": "Hanging Long Steel Sign",
          "fr": "Long panneau suspendu en acier",
          "es": "Letrero colgante largo (acero)",
          "de": "Stahlschild (lang",
          "pt": "강철 기다란 현판",
          "it": "Стальная длинная вывеска",
          "tr": "Hanging Long Steel Sign",
          "pl": "Hanging Long Steel Sign",
          "ru": "长条钢制悬挂标志",
          "uk": "Hanging Long Steel Sign",
          "ko": " hängend)",
          "zh": "Placa Longa de Aço Pendurada",
          "ja": "Hanging Long Steel Sign"
        },
        {
          "id": "CorrugatedSteelFenceDoor",
          "en": "Corrugated Steel Fence Door",
          "fr": "Porte en acier ondulé à croisillons",
          "es": "Puerta de valla (acero corrugado)",
          "de": "Wellstahl Gittertür",
          "pt": "Porta de Cerca de Aço Corrugado",
          "it": "Porta Recinzione in Acciaio Ondulato",
          "tr": "Corrugated Steel Fence Door",
          "pl": "Furtka ze stali ryflowanej",
          "ru": "Дверь из решетки гофрированной стали",
          "uk": "Corrugated Steel Fence Door",
          "ko": "골강판 울타리 문",
          "zh": "波纹钢制栅栏门",
          "ja": "Corrugated Steel Fence Door"
        },
        {
          "id": "CorrugatedSteelDoor",
          "en": "Corrugated Steel Door",
          "fr": "Porte en acier ondulé",
          "es": "Puerta (acero corrugado)",
          "de": "Wellstahltür",
          "pt": "Porta de Aço Corrugado",
          "it": "Porta in Acciaio Ondulato",
          "tr": "Corrugated Steel Door",
          "pl": "Drzwi ze stali ryflowanej",
          "ru": "Дверь из гофрированной стали",
          "uk": "Corrugated Steel Door",
          "ko": "골강판 문",
          "zh": "波纹钢制门",
          "ja": "Corrugated Steel Door"
        },
        {
          "id": "QuicklimeGlass",
          "en": "Quicklime Glass",
          "fr": "Verre en chaux vive",
          "es": "Vidrio de cal viva",
          "de": "Glas aus Branntkalk",
          "pt": "Vidro de Cal Viva",
          "it": "Vetro di Calce Viva",
          "tr": "Quicklime Glass",
          "pl": "Quicklime Glass",
          "ru": "Стекло из негашеной извести",
          "uk": "Quicklime Glass",
          "ko": "생석회 유리",
          "zh": "生石灰玻璃",
          "ja": "Quicklime Glass"
        },
        {
          "id": "SpinMelter",
          "en": "Spin Melter",
          "fr": "Extrudeuse",
          "es": "Torno de fusión",
          "de": "Schmelzschleuderer",
          "pt": "Máquina de fiação",
          "it": "Tornio A Fusione",
          "tr": "Spin Melter",
          "pl": "Spin Melter",
          "ru": "Прядильная машина",
          "uk": "Spin Melter",
          "ko": "용융 방사기",
          "zh": "旋转熔炉",
          "ja": "Spin Melter"
        },
        {
          "id": "PrintingPress",
          "en": "Printing Press",
          "fr": "Presse à imprimer",
          "es": "Imprenta",
          "de": "Druckerpresse",
          "pt": "Máquina de Impressão",
          "it": "Stampante",
          "tr": "Printing Press",
          "pl": "Printing Press",
          "ru": "Печатный станок",
          "uk": "Printing Press",
          "ko": "인쇄기",
          "zh": "印刷机",
          "ja": "Printing Press"
        },
        {
          "id": "Loom",
          "en": "Loom",
          "fr": "Métier à tisser",
          "es": "Telar",
          "de": "Webstuhl",
          "pt": "Tear",
          "it": "Telaio",
          "tr": "Loom",
          "pl": "Krosno tkackie",
          "ru": "Ткацкий станок",
          "uk": "Loom",
          "ko": "직조기",
          "zh": "织布机",
          "ja": "織機"
        },
        {
          "id": "InjectionMoldMachine",
          "en": "Injection Mold Machine",
          "fr": "Presse à injection",
          "es": "Máquina de moldeo por inyección",
          "de": "Spritzgußmaschine",
          "pt": "Máquina de Moldagem por Injeção",
          "it": "Macchina di Iniezione Muffa",
          "tr": "Injection Mold Machine",
          "pl": "Injection Mold Machine",
          "ru": "Термопластавтомат",
          "uk": "Injection Mold Machine",
          "ko": "사출 금형 기계",
          "zh": "模具注塑机",
          "ja": "Injection Mold Machine"
        },
        {
          "id": "IndustrialRefrigerator",
          "en": "Industrial Refrigerator",
          "fr": "Réfrigérateur industriel",
          "es": "Nevera industrial",
          "de": "Industrieller Kühlschrank",
          "pt": "Refrigerador Industrial",
          "it": "Frigorifero Industriale",
          "tr": "Industrial Refrigerator",
          "pl": "Industrial Refrigerator",
          "ru": "Промышленный Холодильник",
          "uk": "Industrial Refrigerator",
          "ko": "공업용 냉장고",
          "zh": "工业冷藏库",
          "ja": "Industrial Refrigerator"
        },
        {
          "id": "Easel",
          "en": "Easel",
          "fr": "Chevalet",
          "es": "Caballete",
          "de": "Staffelei",
          "pt": "Cavalete",
          "it": "Cavalletto",
          "tr": "Easel",
          "pl": "Easel",
          "ru": "Мольберт",
          "uk": "Easel",
          "ko": "이젤",
          "zh": "画架",
          "ja": "Easel"
        },
        {
          "id": "CrabPot",
          "en": "Crab Pot",
          "fr": "Casier à crabes",
          "es": "Cazuela de cangrejo",
          "de": "Krabbentopf",
          "pt": "Armadilha de Caranguejo",
          "it": "Casseruola del Granchio",
          "tr": "Crab Pot",
          "pl": "Crab Pot",
          "ru": "Ловушка для крабов",
          "uk": "Crab Pot",
          "ko": "게 통발",
          "zh": "蟹笼",
          "ja": "カニ用の罠"
        },
        {
          "id": "AutomaticLoom",
          "en": "Automatic Loom",
          "fr": "Métier à tisser automatique",
          "es": "Telar mecánico",
          "de": "Automatischer Webstuhl",
          "pt": "Tear automático",
          "it": "Impilatore Automatico",
          "tr": "Automatic Loom",
          "pl": "Zautomatyzowane Krosno tkackie",
          "ru": "Автоматический ткацкий станок",
          "uk": "Automatic Loom",
          "ko": "자동 직조기",
          "zh": "自动织布机",
          "ja": "自動織機"
        },
        {
          "id": "AdvancedTailoringTable",
          "en": "Advanced Tailoring Table",
          "fr": "Établi de couture avancé",
          "es": "Mesa de sastrería avanzada",
          "de": "Verbesserter Schneidertisch",
          "pt": "Mesa de alfaiataria avançada",
          "it": "Banco di Sartoria Avanzato",
          "tr": "Advanced Tailoring Table",
          "pl": "Zaawansowany stół krawiecki",
          "ru": "Продвинутый Стол Портного",
          "uk": "Advanced Tailoring Table",
          "ko": "고급 재단 작업대",
          "zh": "高级裁缝台",
          "ja": "Advanced Tailoring Table"
        },
        {
          "id": "CottonSeed",
          "en": "Cotton Seed",
          "fr": "Graine de coton",
          "es": "Semilla de algodón",
          "de": "Samen (Baumwollpflanze)",
          "pt": "Semente de Algodão",
          "it": "Semi di Cotone",
          "tr": "Cotton Seed",
          "pl": "Nasiono bawełny",
          "ru": "Семечко хлопка",
          "uk": "Cotton Seed",
          "ko": "목화씨",
          "zh": "棉花种子",
          "ja": "Cotton Seed"
        },
        {
          "id": "WeaveWoolFabric",
          "en": "Weave Wool Fabric",
          "fr": "Tissu en laine à tisser",
          "es": "Tela de lana",
          "de": "Wollstoff Weben",
          "pt": "Tecelagem de Tecido de Lã",
          "it": "Tessi Tessuto in Lana",
          "tr": "Weave Wool Fabric",
          "pl": "Weave Wool Fabric",
          "ru": "Ткать Шерстяную Ткань",
          "uk": "Weave Wool Fabric",
          "ko": "모직물 짜기",
          "zh": "编织呢绒",
          "ja": "Weave Wool Fabric"
        },
        {
          "id": "WeaveNylonFabric",
          "en": "Weave Nylon Fabric",
          "fr": "Tissu en nylon à tisser",
          "es": "Tela de nailon",
          "de": "Nylonstoff Weben",
          "pt": "Tecelagem de Tecido de Náilon",
          "it": "Tessi Tessuto in Nylon",
          "tr": "Weave Nylon Fabric",
          "pl": "Weave Nylon Fabric",
          "ru": "Ткать Нейлоновую Ткань",
          "uk": "Weave Nylon Fabric",
          "ko": "나일론 원단 짜기",
          "zh": "编织尼龙织物",
          "ja": "Weave Nylon Fabric"
        },
        {
          "id": "WeaveCottonFabric",
          "en": "Weave Cotton Fabric",
          "fr": "Tissu en coton à tisser",
          "es": "Tela de algodón",
          "de": "Baumwollstoff Weben",
          "pt": "Tecelagem de Tecido de Algodão",
          "it": "Tessi Tessuto in Cotone",
          "tr": "Weave Cotton Fabric",
          "pl": "Utkaj tkaninę bawełnianą",
          "ru": "Ткать Хлопковую Ткань",
          "uk": "Weave Cotton Fabric",
          "ko": "면직물 짜기",
          "zh": "编织棉花织物",
          "ja": "Weave Cotton Fabric"
        },
        {
          "id": "SpinWoolYarn",
          "en": "Spin Wool Yarn",
          "fr": "Filage de laine",
          "es": "Hilar lana",
          "de": "Wollgarn Spinnen",
          "pt": "Enrolar Fios de Lã",
          "it": "Gira Filo di Lana",
          "tr": "Spin Wool Yarn",
          "pl": "Spin Wool Yarn",
          "ru": "Пряжа из шерсти",
          "uk": "Spin Wool Yarn",
          "ko": "방적사",
          "zh": "纺织毛纱",
          "ja": "Spin Wool Yarn"
        },
        {
          "id": "FishStew",
          "en": "Fish Stew",
          "fr": "Ragoût de poisson",
          "es": "Estofado de pescado",
          "de": "Lagerfeuer Fischeintopf",
          "pt": "Ensopado de Peixe",
          "it": "Stufato di Pesce",
          "tr": "Fish Stew",
          "pl": "Gulasz rybny",
          "ru": "Рыбное рагу",
          "uk": "Fish Stew",
          "ko": "생선 스튜",
          "zh": "鱼汤",
          "ja": "Fish Stew"
        },
        {
          "id": "CulinaryResearchPaperBasicFish",
          "en": "Culinary Research Paper Basic Fish",
          "fr": "Papier de recherche : Culinaire poisson basique",
          "es": "Trabajo de investigación culinaria sobre pescado (básico)",
          "de": "Grundlegendes Forschungspapier: Kochkunst mit Fisch",
          "pt": "Documento de Pesquisa Básico de Culinária (Peixe)",
          "it": "Documento di Ricerca Base di Culinaria sul Pesce",
          "tr": "Culinary Research Paper Basic Fish",
          "pl": "Podstawowy papier badawczy rybnej Kulinarii",
          "ru": "Исследование по базовой кулинарии - рыба",
          "uk": "Culinary Research Paper Basic Fish",
          "ko": "기초 생선 요리 연구지",
          "zh": "基础鱼类烹饪研究论文",
          "ja": "料理の基礎研究書(魚)"
        },
        {
          "id": "WoolYarn",
          "en": "Wool Yarn",
          "fr": "Fil de laine",
          "es": "Hilo de lana",
          "de": "Wollgarn",
          "pt": "Fios de Lã",
          "it": "Filo di Lana",
          "tr": "Wool Yarn",
          "pl": "Wool Yarn",
          "ru": "Шерстяная пряжа",
          "uk": "Wool Yarn",
          "ko": "양모사",
          "zh": "毛纱",
          "ja": "Wool Yarn"
        },
        {
          "id": "WoolFabric",
          "en": "Wool Fabric",
          "fr": "Tissu en laine",
          "es": "Tela de lana",
          "de": "Wollstoff",
          "pt": "Tecido de Lã",
          "it": "Tessuto di Lana",
          "tr": "Wool Fabric",
          "pl": "Tkanina wełniana",
          "ru": "Шерстяная ткань",
          "uk": "Wool Fabric",
          "ko": "모직물",
          "zh": "呢绒",
          "ja": "Wool Fabric"
        },
        {
          "id": "NylonThread",
          "en": "Nylon Thread",
          "fr": "Fil de nylon",
          "es": "Fibra de nailon",
          "de": "Nylonfaden",
          "pt": "Fio de Náilon",
          "it": "Filo di Nylon",
          "tr": "Nylon Thread",
          "pl": "Nić nylonowa",
          "ru": "Нейлоновая нить",
          "uk": "Nylon Thread",
          "ko": "나일론 실",
          "zh": "尼龙线",
          "ja": "ナイロン糸"
        },
        {
          "id": "Nylon",
          "en": "Nylon",
          "fr": "Nylon",
          "es": "Nailon",
          "de": "Nylon",
          "pt": "Náilon",
          "it": "Nylon",
          "tr": "Nylon",
          "pl": "Nylon",
          "ru": "Нейлон",
          "uk": "Nylon",
          "ko": "나일론",
          "zh": "尼龙",
          "ja": "ナイロン"
        },
        {
          "id": "CottonThread",
          "en": "Cotton Thread",
          "fr": "Fil de coton",
          "es": "Fibra de algodón",
          "de": "Baumwollfaden",
          "pt": "Fio de Algodão",
          "it": "Filo di Cotone",
          "tr": "Cotton Thread",
          "pl": "Nici bawełniane",
          "ru": "Хлопковая нить",
          "uk": "Cotton Thread",
          "ko": "면사",
          "zh": "棉线",
          "ja": "Cotton Thread"
        },
        {
          "id": "CottonFabric",
          "en": "Cotton Fabric",
          "fr": "Tissu en coton",
          "es": "Tela de algodón",
          "de": "Baumwollstoff",
          "pt": "Tecido de Algodão",
          "it": "Tessuto di Cotone",
          "tr": "Cotton Fabric",
          "pl": "Tkanina bawełniana",
          "ru": "Хлопковая ткань",
          "uk": "Cotton Fabric",
          "ko": "면직물",
          "zh": "棉织物",
          "ja": "Cotton Fabric"
        },
        {
          "id": "TailorShoes",
          "en": "Tailor Shoes",
          "fr": "Ensemble de tailleur : Chaussures",
          "es": "Zapatos de sastre",
          "de": "Schneiderschuhe",
          "pt": "Sapatos de Alfaiate",
          "it": "Scarpe del Sarto",
          "tr": "Tailor Shoes",
          "pl": "Buty krawca",
          "ru": "Ботинки Портного",
          "uk": "Tailor Shoes",
          "ko": "재단사 신발",
          "zh": "裁缝的鞋子",
          "ja": "Tailor Shoes"
        },
        {
          "id": "TailorShirt",
          "en": "Tailor Shirt",
          "fr": "Ensemble de tailleur : Chemise",
          "es": "Camisa de sastre",
          "de": "Schneiderhemd",
          "pt": "Camisa de Alfaiate",
          "it": "Camicia del Sarto",
          "tr": "Tailor Shirt",
          "pl": "Koszula Krawca",
          "ru": "Рубашка Портного",
          "uk": "Tailor Shirt",
          "ko": "재단사 셔츠",
          "zh": "裁缝的衬衫",
          "ja": "Tailor Shirt"
        },
        {
          "id": "TailorPants",
          "en": "Tailor Pants",
          "fr": "Ensemble de tailleur : Pantalon",
          "es": "Pantalones de sastre",
          "de": "Schneiderhose",
          "pt": "Calça de Alfaiate",
          "it": "Pantaloni del Sarto",
          "tr": "Tailor Pants",
          "pl": "Spodnie krawca",
          "ru": "Штаны Портного",
          "uk": "Tailor Pants",
          "ko": "재단사 바지",
          "zh": "裁缝的裤子",
          "ja": "Tailor Pants"
        },
        {
          "id": "TailorBowlerHat",
          "en": "Tailor Bowler Hat",
          "fr": "Ensemble de tailleur : Chapeau melon",
          "es": "Bombín de sastre",
          "de": "Schneidermelone",
          "pt": "Chapéu-coco de Alfaiate",
          "it": "Bombetta del Sarto",
          "tr": "Tailor Bowler Hat",
          "pl": "Melonik krawca",
          "ru": "Шляпа-котелок Портного",
          "uk": "Tailor Bowler Hat",
          "ko": "재단사 중산모",
          "zh": "裁缝的圆顶礼帽",
          "ja": "Tailor Bowler Hat"
        },
        {
          "id": "SmithPants",
          "en": "Smith Pants",
          "fr": "Ensemble de forgeron : Pantalon",
          "es": "Pantalones de herrero",
          "de": "Schmiedhose",
          "pt": "Calça de Ferreiro",
          "it": "Pantaloni del Fabbro",
          "tr": "Smith Pants",
          "pl": "Spodnie kowala",
          "ru": "Штаны Кузнеца",
          "uk": "Smith Pants",
          "ko": "대장장이 바지",
          "zh": "铁匠的裤子",
          "ja": "Smith Pants"
        },
        {
          "id": "SmithGloves",
          "en": "Smith Gloves",
          "fr": "Ensemble de forgeron : Gants",
          "es": "Guantes de herrero",
          "de": "Schmiedhandschuhe",
          "pt": "Luvas de Ferreiro",
          "it": "Guanti del Fabbro",
          "tr": "Smith Gloves",
          "pl": "Rękawice kowala",
          "ru": "Перчатки Кузнеца",
          "uk": "Smith Gloves",
          "ko": "대장장이 장갑",
          "zh": "铁匠的手套",
          "ja": "Smith Gloves"
        },
        {
          "id": "SmithBoots",
          "en": "Smith Boots",
          "fr": "Ensemble de forgeron : Bottes",
          "es": "Botas de herrero",
          "de": "Schmiedstiefel",
          "pt": "Botas de Ferreiro",
          "it": "Stivali del Fabbro",
          "tr": "Smith Boots",
          "pl": "Buty kowala",
          "ru": "Ботинки Кузнеца",
          "uk": "Smith Boots",
          "ko": "대장장이 부츠",
          "zh": "铁匠的靴子",
          "ja": "Smith Boots"
        },
        {
          "id": "SmithBandana",
          "en": "Smith Bandana",
          "fr": "Ensemble de forgeron : Bandana",
          "es": "Pañuelo de herrero",
          "de": "Schmiedbandana",
          "pt": "Bandana de Ferreiro",
          "it": "Bandana del Fabbro",
          "tr": "Smith Bandana",
          "pl": "Bandana kowala",
          "ru": "Бандана Кузнеца",
          "uk": "Smith Bandana",
          "ko": "대장장이 반다나",
          "zh": "铁匠的头巾",
          "ja": "Smith Bandana"
        },
        {
          "id": "SmithApron",
          "en": "Smith Apron",
          "fr": "Ensemble de forgeron : Tablier",
          "es": "Delantal de herrero",
          "de": "Schmiedeschürze",
          "pt": "Avental de Ferreiro",
          "it": "Grembiule del Fabbro",
          "tr": "Smith Apron",
          "pl": "Fartuch kowala",
          "ru": "Фартук Кузнеца",
          "uk": "Smith Apron",
          "ko": "대장장이 앞치마",
          "zh": "铁匠的围裙",
          "ja": "Smith Apron"
        },
        {
          "id": "FarmerShirt",
          "en": "Farmer Shirt",
          "fr": "Ensemble de fermier : Chemise",
          "es": "Camisa de granjero",
          "de": "Farmerhemd",
          "pt": "Camisa de Agricultor",
          "it": "Camicia dell\u0027Agricoltore",
          "tr": "Farmer Shirt",
          "pl": "Koszula Rolnika",
          "ru": "Рубашка Фермера",
          "uk": "Farmer Shirt",
          "ko": "농부 셔츠",
          "zh": "农民的衬衫",
          "ja": "Farmer Shirt"
        },
        {
          "id": "FarmerOveralls",
          "en": "Farmer Overalls",
          "fr": "Ensemble de fermier : Salopette",
          "es": "Mono de granjero",
          "de": "Farmeroveralls",
          "pt": "Macacão de Agricultor",
          "it": "Salopette dell\u0027Agricoltore",
          "tr": "Farmer Overalls",
          "pl": "Kombinezon Rolnika",
          "ru": "Комбинезон Фермера",
          "uk": "Farmer Overalls",
          "ko": "농부 작업복",
          "zh": "农民的工装裤",
          "ja": "Farmer Overalls"
        },
        {
          "id": "FarmerHat",
          "en": "Farmer Hat",
          "fr": "Ensemble de fermier : Chapeau",
          "es": "Sombrero de granjero",
          "de": "Farmerhut",
          "pt": "Chapéu de Agricultor",
          "it": "Cappello dell\u0027Agricoltore",
          "tr": "Farmer Hat",
          "pl": "Kapelusz Rolnika",
          "ru": "Шляпа Фермера",
          "uk": "Farmer Hat",
          "ko": "농부 모자",
          "zh": "农民的帽子",
          "ja": "Farmer Hat"
        },
        {
          "id": "FarmerGloves",
          "en": "Farmer Gloves",
          "fr": "Ensemble de fermier : Gants",
          "es": "Guantes de granjero",
          "de": "Farmerhandschuhe",
          "pt": "Luvas de Agricultor",
          "it": "Guanti dell\u0027Agricoltore",
          "tr": "Farmer Gloves",
          "pl": "Rękawice Rolnika",
          "ru": "Перчатки Фермера",
          "uk": "Farmer Gloves",
          "ko": "농부 장갑",
          "zh": "农民的手套",
          "ja": "Farmer Gloves"
        },
        {
          "id": "FarmerBoots",
          "en": "Farmer Boots",
          "fr": "Ensemble de fermier : Bottes",
          "es": "Botas de granjero",
          "de": "Farmerstiefel",
          "pt": "Botas de Agricultor",
          "it": "Stivali dell\u0027Agricoltore",
          "tr": "Farmer Boots",
          "pl": "Buty Rolnika",
          "ru": "Ботинки Фермера",
          "uk": "Farmer Boots",
          "ko": "농부 부츠",
          "zh": "农民的靴子",
          "ja": "Farmer Boots"
        },
        {
          "id": "BuilderShirt",
          "en": "Builder Shirt",
          "fr": "Ensemble de chantier : Chemise",
          "es": "Camisa de constructor",
          "de": "Baumeisterhemd",
          "pt": "Camisa de Construtor",
          "it": "Camicia del Costruttore",
          "tr": "Builder Shirt",
          "pl": "Koszula Budowniczego",
          "ru": "Рубашка Строителя",
          "uk": "Builder Shirt",
          "ko": "건축가 셔츠",
          "zh": "建筑工的衬衫",
          "ja": "Builder Shirt"
        },
        {
          "id": "BuilderOveralls",
          "en": "Builder Overalls",
          "fr": "Ensemble de chantier : Salopette",
          "es": "Mono de constructor",
          "de": "Baumeisteroverall",
          "pt": "Macacão de Construtor",
          "it": "Salopette del Costruttore",
          "tr": "Builder Overalls",
          "pl": "Kombinezon Budowniczego",
          "ru": "Комбинезон Строителя",
          "uk": "Builder Overalls",
          "ko": "건축가 작업복",
          "zh": "建筑工的工装裤",
          "ja": "Builder Overalls"
        },
        {
          "id": "BuilderHelmet",
          "en": "Builder Helmet",
          "fr": "Ensemble de chantier : Casque",
          "es": "Casco de constructor",
          "de": "Baumeisterhelm",
          "pt": "Capacete de Construtor",
          "it": "Casco del Costruttore",
          "tr": "Builder Helmet",
          "pl": "Kapelusz Budowniczego",
          "ru": "Каска Строителя",
          "uk": "Builder Helmet",
          "ko": "건축가 헬멧",
          "zh": "建筑工的安全帽",
          "ja": "建築者のヘルメット"
        },
        {
          "id": "BuilderGloves",
          "en": "Builder Gloves",
          "fr": "Ensemble de chantier : Gants",
          "es": "Guantes de constructor",
          "de": "Baumeisterhandschuhe",
          "pt": "Luvas de Construtor",
          "it": "Guanti del Costruttore",
          "tr": "Builder Gloves",
          "pl": "Rękawice Budowniczego",
          "ru": "Перчатки Строителя",
          "uk": "Builder Gloves",
          "ko": "건축가 장갑",
          "zh": "建筑工的手套",
          "ja": "建築者のグローブ"
        },
        {
          "id": "BuilderBoots",
          "en": "Builder Boots",
          "fr": "Ensemble de chantier : Bottes",
          "es": "Botas de constructor",
          "de": "Baumeisterstiefel",
          "pt": "Botas de Construtor",
          "it": "Stivali del Costruttore",
          "tr": "Builder Boots",
          "pl": "Buty Budowniczego",
          "ru": "Ботинки Строителя",
          "uk": "Builder Boots",
          "ko": "건축가 부츠",
          "zh": "建筑工的靴子",
          "ja": "Builder Boots"
        },
        {
          "id": "WoolCurtains",
          "en": "Wool Curtains",
          "fr": "Rideaux en laine",
          "es": "Cortinas de lana",
          "de": "Wollvorhänge",
          "pt": "Cortinas de lã",
          "it": "Tende in Lana",
          "tr": "Wool Curtains",
          "pl": "Wool Curtains",
          "ru": "Шерстяные Шторы",
          "uk": "Wool Curtains",
          "ko": "양모 커튼",
          "zh": "羊毛窗帘",
          "ja": "Wool Curtains"
        },
        {
          "id": "NylonCarpet",
          "en": "Nylon Carpet",
          "fr": "Moquette en nylon",
          "es": "Alfombra de nailon",
          "de": "Nylonteppich",
          "pt": "Tapete de náilon",
          "it": "Tappeto in Nylon",
          "tr": "Nylon Carpet",
          "pl": "Dywan z nylonu",
          "ru": "Нейлоновый ковер",
          "uk": "Nylon Carpet",
          "ko": "나일론 카펫",
          "zh": "尼龙地毯",
          "ja": "Nylon Carpet"
        },
        {
          "id": "WoolCarpet",
          "en": "Wool Carpet",
          "fr": "Moquette en laine",
          "es": "Alfombra de lana",
          "de": "Wollteppich",
          "pt": "Tapete de lã",
          "it": "Tappeto in Lana",
          "tr": "Wool Carpet",
          "pl": "Wool Carpet",
          "ru": "Шерстяной ковер",
          "uk": "Wool Carpet",
          "ko": "양모 카펫",
          "zh": "羊毛地毯",
          "ja": "Wool Carpet"
        },
        {
          "id": "CottonCurtains",
          "en": "Cotton Curtains",
          "fr": "Rideaux en coton",
          "es": "Cortinas de algodón",
          "de": "Baumwollvorhänge",
          "pt": "Cortinas de algodão",
          "it": "Tende in Cotone",
          "tr": "Cotton Curtains",
          "pl": "Bawełniane zasłony",
          "ru": "Хлопковые шторы",
          "uk": "Cotton Curtains",
          "ko": "면 커튼",
          "zh": "棉制窗帘",
          "ja": "Cotton Curtains"
        },
        {
          "id": "CottonCarpet",
          "en": "Cotton Carpet",
          "fr": "Moquette en coton",
          "es": "Alfombra de algodón",
          "de": "Baumwollteppich",
          "pt": "Tapete de algodão",
          "it": "Tappeto in Cotone",
          "tr": "Cotton Carpet",
          "pl": "Bawełniany dywan",
          "ru": "Хлопковый ковер",
          "uk": "Cotton Carpet",
          "ko": "면 카펫",
          "zh": "棉制地毯",
          "ja": "Cotton Carpet"
        },
        {
          "id": "BoardOfElections",
          "en": "Board of Elections",
          "fr": "Bureau des élections",
          "es": "Tablón de elecciones",
          "de": "Wahlvorstand",
          "pt": "Conselho Eleitoral",
          "it": "Consiglio Elettorale",
          "tr": "Board of Elections",
          "pl": "Board of Elections",
          "ru": "Избирательная комиссия",
          "uk": "Board of Elections",
          "ko": "선거관리위원회",
          "zh": "推选面板",
          "ja": "Board of Elections"
        },
        {
          "id": "ExecutiveOffice",
          "en": "Executive office",
          "fr": "Bureau de l\u0027exécutif",
          "es": "Oficina ejecutiva",
          "de": "Hauptamt",
          "pt": "Escritório executivo",
          "it": "Ufficio esecutivo",
          "tr": "Executive office",
          "pl": "Executive office",
          "ru": "Исполнительный офис",
          "uk": "Executive office",
          "ko": "행정실",
          "zh": "行政办公室",
          "ja": "行政府オフィス"
        },
        {
          "id": "ExplorerShirt",
          "en": "Explorer Shirt",
          "fr": "Ensemble d\u0027explorateur : Chemise",
          "es": "Camisa de explorador",
          "de": "Forscherhemd",
          "pt": "Camisa de Explorador",
          "it": "Camicia dell\u0027Esploratore",
          "tr": "Explorer Shirt",
          "pl": "Koszula Odkrywcy",
          "ru": "Китель Исследователя",
          "uk": "Explorer Shirt",
          "ko": "탐험가 셔츠",
          "zh": "探索者的衬衫",
          "ja": "Explorer Shirt"
        },
        {
          "id": "ExplorerPants",
          "en": "Explorer Pants",
          "fr": "Ensemble d\u0027explorateur : Pantalon",
          "es": "Pantalones de explorador",
          "de": "Forscherhose",
          "pt": "Calças de Explorador",
          "it": "Pantaloni dell\u0027Esploratore",
          "tr": "Explorer Pants",
          "pl": "Spodnie Odkrywcy",
          "ru": "Штаны Исследователя",
          "uk": "Explorer Pants",
          "ko": "탐험가 바지",
          "zh": "探索者的裤子",
          "ja": "Explorer Pants"
        },
        {
          "id": "ExplorerHat",
          "en": "Explorer Hat",
          "fr": "Ensemble d\u0027explorateur : Chapeau",
          "es": "Gorro de explorador",
          "de": "Forscherhut",
          "pt": "Chapéu de Explorador",
          "it": "Cappello dell\u0027Esploratore",
          "tr": "Explorer Hat",
          "pl": "Kapelusz odkrywcy",
          "ru": "Пробковый шлем",
          "uk": "Explorer Hat",
          "ko": "탐험가 모자",
          "zh": "探索者的帽子",
          "ja": "Explorer Hat"
        },
        {
          "id": "ExplorerGloves",
          "en": "Explorer Gloves",
          "fr": "Ensemble d\u0027explorateur : Gants",
          "es": "Guantes de explorador",
          "de": "Forscherhandschuhe",
          "pt": "Luvas de Explorador",
          "it": "Guanti dell\u0027Esploratore",
          "tr": "Explorer Gloves",
          "pl": "Rękawice Odkrywcy",
          "ru": "Перчатки Исследователя",
          "uk": "Explorer Gloves",
          "ko": "탐험가 장갑",
          "zh": "探索者的手套",
          "ja": "Explorer Gloves"
        },
        {
          "id": "ChefShoes",
          "en": "Chef Shoes",
          "fr": "Ensemble de cuisinier : Chaussures",
          "es": "Zapatos de cocinero",
          "de": "Kochschuhe",
          "pt": "Sapatos de Chefe de Cozinha",
          "it": "Scarpe del Cuoco",
          "tr": "Chef Shoes",
          "pl": "Buty kuchmistrza",
          "ru": "Ботинки Повара",
          "uk": "Chef Shoes",
          "ko": "요리사 신발",
          "zh": "厨师的鞋子",
          "ja": "Chef Shoes"
        },
        {
          "id": "ChefShirt",
          "en": "Chef Shirt",
          "fr": "Ensemble de cuisinier : Veste",
          "es": "Camisa de cocinero",
          "de": "Kochhemd",
          "pt": "Camisa de Chefe de Cozinha",
          "it": "Camicia del Cuoco",
          "tr": "Chef Shirt",
          "pl": "Koszula kuchmistrza",
          "ru": "Китель Повара",
          "uk": "Chef Shirt",
          "ko": "요리사 셔츠",
          "zh": "厨师的衬衫",
          "ja": "Chef Shirt"
        },
        {
          "id": "ChefPants",
          "en": "Chef Pants",
          "fr": "Ensemble de cuisinier : Pantalon",
          "es": "Pantalones de cocinero",
          "de": "Kochhosen",
          "pt": "Calças de Chefe de Cozinha",
          "it": "Pantaloni del Cuoco",
          "tr": "Chef Pants",
          "pl": "Spodnie kuchmistrza",
          "ru": "Штаны Повара",
          "uk": "Chef Pants",
          "ko": "요리사 바지",
          "zh": "厨师的裤子",
          "ja": "Chef Pants"
        },
        {
          "id": "ChefHat",
          "en": "Chef Hat",
          "fr": "Ensemble de cuisinier : Toque",
          "es": "Gorro de cocinero",
          "de": "Kochmütze",
          "pt": "Chapéu de Chefe de Cozinha",
          "it": "Cappello del Cuoco",
          "tr": "Chef Hat",
          "pl": "Czapka kuchmistrza",
          "ru": "Колпак Повара",
          "uk": "Chef Hat",
          "ko": "요리사 모자",
          "zh": "厨师的帽子",
          "ja": "Chef Hat"
        },
        {
          "id": "ExplorerBoots",
          "en": "Explorer Boots",
          "fr": "Ensemble d\u0027explorateur : Bottes",
          "es": "Botas de explorador",
          "de": "Forscherstiefel",
          "pt": "Botas de Explorador",
          "it": "Stivali da Esploratore",
          "tr": "Explorer Boots",
          "pl": "Buty Odkrywcy",
          "ru": "Ботинки Исследователя",
          "uk": "Explorer Boots",
          "ko": "탐험가 부츠",
          "zh": "探索者的靴子",
          "ja": "探検者のブーツ"
        },
        {
          "id": "TailoringModernUpgrade",
          "en": "Tailoring Modern Upgrade",
          "fr": "Amélioration moderne : Couture",
          "es": "Mejora moderna: Sastrería",
          "de": "Modernes Upgrade: Schneidern",
          "pt": "Melhoria Moderna de Compósitos",
          "it": "Aggiornamento Moderno Sartoria",
          "tr": "Tailoring Modern Upgrade",
          "pl": "Nowoczesne ulepszenie Krawiectwa",
          "ru": "Современное улучшение для портняжного дела",
          "uk": "Tailoring Modern Upgrade",
          "ko": "현대식 재단 업그레이드",
          "zh": "裁缝现代化升级",
          "ja": "Tailoring Modern Upgrade"
        },
        {
          "id": "CastIronBed",
          "en": "Cast Iron Bed",
          "fr": "Lit en fer forgé",
          "es": "Cama de hierro fundido",
          "de": "Gusseisernes Bett",
          "pt": "Cama de Ferro Fundido",
          "it": "Letto in Ghisa",
          "tr": "Cast Iron Bed",
          "pl": "Żeliwne łóżko",
          "ru": "Чугунная кровать",
          "uk": "Cast Iron Bed",
          "ko": "무쇠 침대",
          "zh": "铸铁床",
          "ja": "Cast Iron Bed"
        },
        {
          "id": "CastIronBench",
          "en": "Cast Iron Bench",
          "fr": "Banc en fer forgé",
          "es": "Banco de hierro fundido",
          "de": "Gusseiserne Bank",
          "pt": "Banco de Ferro Fundido",
          "it": "Panca in Ghisa",
          "tr": "Cast Iron Bench",
          "pl": "Żeliwna ławka",
          "ru": "Чугунная лавка",
          "uk": "Cast Iron Bench",
          "ko": "무쇠 벤치",
          "zh": "铸铁长凳",
          "ja": "鋳鉄のベンチ"
        },
        {
          "id": "CastIronChair",
          "en": "Cast Iron Chair",
          "fr": "Chaise en fer forgé",
          "es": "Silla de hierro fundido",
          "de": "Gusseiserner Stuhl",
          "pt": "Cadeira de Ferro Fundido",
          "it": "Sedia in Ghisa",
          "tr": "Cast Iron Chair",
          "pl": "Żeliwne krzesło",
          "ru": "Чугунный стул",
          "uk": "Cast Iron Chair",
          "ko": "무쇠 의자",
          "zh": "铸铁椅子",
          "ja": "鋳鉄の椅子"
        },
        {
          "id": "CastIronRoyalBed",
          "en": "Cast Iron Royal Bed",
          "fr": "Lit royal en fer forgé",
          "es": "Cama de lujo de hierro fundido",
          "de": "Gusseisernes Königliches Bett",
          "pt": "Cama Real de Ferro Fundido",
          "it": "Letto Reale in Ghisa",
          "tr": "Cast Iron Royal Bed",
          "pl": "Żeliwne łoże królewskie",
          "ru": "Чугунная Королевская Кровать",
          "uk": "Cast Iron Royal Bed",
          "ko": "무쇠 로얄 침대",
          "zh": "铸铁皇家床",
          "ja": "Cast Iron Royal Bed"
        },
        {
          "id": "CastIronTable",
          "en": "Cast Iron Table",
          "fr": "Table en fer forgé",
          "es": "Mesa de hierro fundido",
          "de": "Gusseiserner Tisch",
          "pt": "Mesa de Ferro Fundido",
          "it": "Tavolo in Ghisa",
          "tr": "Cast Iron Table",
          "pl": "Żeliwny stół",
          "ru": "Чугунный стол",
          "uk": "Cast Iron Table",
          "ko": "무쇠 테이블",
          "zh": "铸铁桌子",
          "ja": "Cast Iron Table"
        },
        {
          "id": "ElevatorCallPost",
          "en": "Elevator Call Post",
          "fr": "Bouton d\u0027appel d\u0027ascenseur",
          "es": "Punto de llamada del ascensor",
          "de": "Holzaufzug-Rufposten",
          "pt": "Posto de Chamada de Elevador",
          "it": "Punto di Chiamata Ascensore",
          "tr": "Elevator Call Post",
          "pl": "Elevator Call Post",
          "ru": "Пульт управления лифтом",
          "uk": "Elevator Call Post",
          "ko": "승강기 호출판",
          "zh": "电梯呼叫站",
          "ja": "Elevator Call Post"
        },
        {
          "id": "HewnDresser",
          "en": "Hewn Dresser",
          "fr": "Commode taillée",
          "es": "Vestidor tallado",
          "de": "Massivholz Kommode",
          "pt": "Cômoda de Madeira Cortada",
          "it": "Comò Scolpito",
          "tr": "Hewn Dresser",
          "pl": "Hewn Dresser",
          "ru": "Комод из тесаного дерева",
          "uk": "Hewn Dresser",
          "ko": "다듬은 원목 옷장",
          "zh": "锯木化妆台",
          "ja": "粗削りのドレッサー"
        },
        {
          "id": "HewnNightstand",
          "en": "Hewn Nightstand",
          "fr": "Table de chevet en bois taillé",
          "es": "Mesa de noche tallada",
          "de": "Massivholz Nachttisch",
          "pt": "Criado-mudo",
          "it": "Comodino Scolpito",
          "tr": "Hewn Nightstand",
          "pl": "Hewn Nightstand",
          "ru": "Тумбочка из тесаного дерева",
          "uk": "Hewn Nightstand",
          "ko": "다듬은 원목 협탁",
          "zh": "锯木床头柜",
          "ja": "粗削りのナイトスタンド"
        },
        {
          "id": "HugeBannerSign",
          "en": "Huge Banner Sign",
          "fr": "Grande enseigne en toile",
          "es": "Pancarta enorme",
          "de": "Riesiges Bannerschild",
          "pt": "Placa Banner Enorme",
          "it": "Cartello Banner Gigante",
          "tr": "Huge Banner Sign",
          "pl": "Huge Banner Sign",
          "ru": "Огромная вывеска",
          "uk": "Huge Banner Sign",
          "ko": "거대한 횡단막 표지판",
          "zh": "巨型横幅标志",
          "ja": "Huge Banner Sign"
        },
        {
          "id": "HugeIronBannerSign",
          "en": "Huge Iron Banner Sign",
          "fr": "Grande enseigne sur pied en fer",
          "es": "Pancarta enorme (hierro)",
          "de": "Riesiges eisernes Bannerschild",
          "pt": "Placa Banner de Ferro Enorme",
          "it": "Cartello Banner Gigante di Ferro",
          "tr": "Huge Iron Banner Sign",
          "pl": "Huge Iron Banner Sign",
          "ru": "Огромная железная вывеска",
          "uk": "Huge Iron Banner Sign",
          "ko": "거대한 철제 횡단막 표지판",
          "zh": "巨型铁质横幅标志",
          "ja": "Huge Iron Banner Sign"
        },
        {
          "id": "HugeIronSign",
          "en": "Huge Iron Sign",
          "fr": "Grande enseigne en fer",
          "es": "Letrero enorme (hierro)",
          "de": "Riesiges Eisenschild",
          "pt": "Placa Enorme de Ferro",
          "it": "Cartello di Ferro Gigante",
          "tr": "Huge Iron Sign",
          "pl": "Huge Iron Sign",
          "ru": "Огромный железный знак",
          "uk": "Huge Iron Sign",
          "ko": "거대한 철제 표지판",
          "zh": "巨型铁质标志",
          "ja": "Huge Iron Sign"
        },
        {
          "id": "HugeSteelBannerSign",
          "en": "Huge Steel Banner Sign",
          "fr": "Grande enseigne sur pied en acier",
          "es": "Pancarta enorme (acero)",
          "de": "Riesiges stählernes Bannerschild",
          "pt": "Placa Banner de Aço Enorme",
          "it": "Cartello Banner d\u0027Acciaio Gigante",
          "tr": "Huge Steel Banner Sign",
          "pl": "Ogromny stalowy znak banerowy",
          "ru": "Огромная стальная вывеска",
          "uk": "Huge Steel Banner Sign",
          "ko": "거대한 강철 횡단막 표지판",
          "zh": "巨型钢铁横幅标志",
          "ja": "Huge Steel Banner Sign"
        },
        {
          "id": "HugeSteelSign",
          "en": "Huge Steel Sign",
          "fr": "Grande enseigne en acier",
          "es": "Letrero enorme (acero)",
          "de": "Riesiges Stahlschild",
          "pt": "Placa Enorme de Aço",
          "it": "Cartello d\u0027Acciaio Gigante",
          "tr": "Huge Steel Sign",
          "pl": "Ogromny stalowy znak",
          "ru": "Огромный стальной знак",
          "uk": "Huge Steel Sign",
          "ko": "거대한 강철 표지판",
          "zh": "巨型钢铁标志",
          "ja": "Huge Steel Sign"
        },
        {
          "id": "HugeWoodenBannerSign",
          "en": "Huge Wooden Banner Sign",
          "fr": "Grande enseigne sur pied en bois",
          "es": "Pancarta enorme (madera)",
          "de": "Riesiges hölzernes Bannerschild",
          "pt": "Placa Banner de Madeira Enorme",
          "it": "Cartello Banner Gigante in Legno",
          "tr": "Huge Wooden Banner Sign",
          "pl": "Huge Wooden Banner Sign",
          "ru": "Огромная деревянная вывеска",
          "uk": "Huge Wooden Banner Sign",
          "ko": "거대한 목제 횡단막 표지판",
          "zh": "巨型木质横幅标志",
          "ja": "Huge Wooden Banner Sign"
        },
        {
          "id": "PotteryTable",
          "en": "Pottery Table",
          "fr": "Table de poterie",
          "es": "Mesa del té",
          "de": "Töpfertisch",
          "pt": "Mesa de Cerâmica",
          "it": "Tavolo in Ceramica",
          "tr": "Pottery Table",
          "pl": "Stół garncarski",
          "ru": "Гончарный круг",
          "uk": "Pottery Table",
          "ko": "도자기 테이블",
          "zh": "制陶工作台",
          "ja": "Pottery Table"
        },
        {
          "id": "SteelAbstractFixture",
          "en": "Steel Abstract Fixture",
          "fr": "Plafonnier abstrait en acier",
          "es": "Accesorio abstracto (acero)",
          "de": "Stählerne abstrakte Vorrichtung",
          "pt": "Luminária Abstrata de Aço",
          "it": "Fissaggio Astratto in Acciaio",
          "tr": "Steel Abstract Fixture",
          "pl": "Stalowa abstrakcyjna oprawa",
          "ru": "Стальной абстрактный светильник",
          "uk": "Steel Abstract Fixture",
          "ko": "강철 추상 고정등",
          "zh": "钢制抽象灯具",
          "ja": "Steel Abstract Fixture"
        },
        {
          "id": "SteelHangingLamp",
          "en": "Steel Hanging Lamp",
          "fr": "Plafonnier suspendu en acier",
          "es": "Lámpara colgante (acero)",
          "de": "Stählerne Hängelampe",
          "pt": "Lâmpada Suspensa de Aço",
          "it": "Lampada da Soffitto in Acciaio",
          "tr": "Steel Hanging Lamp",
          "pl": "Stalowa wisząca lampa",
          "ru": "Стальная подвесная лампа",
          "uk": "Steel Hanging Lamp",
          "ko": "강철 매달린 전등",
          "zh": "钢制悬挂式灯",
          "ja": "Steel Hanging Lamp"
        },
        {
          "id": "SteelKitchenLamp",
          "en": "Steel Kitchen Lamp",
          "fr": "Lustre de cuisine en acier",
          "es": "Lámpara de cocina (acero)",
          "de": "Stählerne Küchenlampe",
          "pt": "Lâmpada de Cozinha de Aço",
          "it": "Lampada da Cucina in Acciaio",
          "tr": "Steel Kitchen Lamp",
          "pl": "Stalowa lampa kuchenna",
          "ru": "Стальная кухонная лампа",
          "uk": "Steel Kitchen Lamp",
          "ko": "강철 주방 전등",
          "zh": "钢制厨房灯",
          "ja": "Steel Kitchen Lamp"
        },
        {
          "id": "SteelSearchlight",
          "en": "Steel Searchlight",
          "fr": "Projecteur en acier",
          "es": "Reflector (acero)",
          "de": "Stählerner Suchscheinwerver",
          "pt": "Holofote de Aço",
          "it": "Faro in Acciaio",
          "tr": "Steel Searchlight",
          "pl": "Steel Searchlight",
          "ru": "Стальной прожектор",
          "uk": "Steel Searchlight",
          "ko": "강철 탐조등",
          "zh": "钢制探照灯",
          "ja": "Steel Searchlight"
        },
        {
          "id": "CleanMediumFish",
          "en": "Clean Medium Fish",
          "fr": "Vider le poisson moyen",
          "es": "Pescado mediano sin espinas",
          "de": "Säubere Mittelgroßen Fisch",
          "pt": "Limpar Peixe Médio",
          "it": "Pesce Medio Pulito",
          "tr": "Clean Medium Fish",
          "pl": "Czysta średnia ryba",
          "ru": "Почистить среднюю рыбу",
          "uk": "Clean Medium Fish",
          "ko": "중형 생선 손질",
          "zh": "清理中型的鱼",
          "ja": "Clean Medium Fish"
        },
        {
          "id": "CleanLargeFish",
          "en": "Clean Large Fish",
          "fr": "Vider le grand poisson",
          "es": "Pescado grande sin espinas",
          "de": "Säubere Großen Fisch",
          "pt": "Limpar Peixe Grande",
          "it": "Pulisci Pesce Grande",
          "tr": "Clean Large Fish",
          "pl": "Oczyść dużą rybę",
          "ru": "Почистить большую рыбу",
          "uk": "Clean Large Fish",
          "ko": "대형 생선 손질",
          "zh": "清理大型的鱼",
          "ja": "Clean Large Fish"
        },
        {
          "id": "CampfireFishMedium",
          "en": "Campfire Fish Medium",
          "fr": "Poisson de taille moyenne cuit au feu de camp",
          "es": "Pescado a la brasa (animal mediano)",
          "de": "Gegrillter Fisch - normal",
          "pt": "Peixe Médio Feito na Fogueira",
          "it": "Pesce Medio al Falò",
          "tr": "Campfire Fish Medium",
          "pl": "Średnia ryba z ogniska",
          "ru": "Пожарить среднюю рыбу",
          "uk": "Campfire Fish Medium",
          "ko": "중형 생선 모닥불 구이",
          "zh": "篝火慢烤鱼（中型）",
          "ja": "中ぐらいな魚の野外料理"
        },
        {
          "id": "CampfireFishLarge",
          "en": "Campfire Fish Large",
          "fr": "Poisson de grande taille cuit au feu de camp",
          "es": "Pescado a la brasa (animal grande)",
          "de": "Gegrillter Fisch - groß",
          "pt": "Peixe Grande Feito na Fogueira",
          "it": "Pesce Grande al Falò",
          "tr": "Campfire Fish Large",
          "pl": "Duża ryba z ogniska",
          "ru": "Пожарить большую рыбу",
          "uk": "Campfire Fish Large",
          "ko": "대형 생선 모닥불 구이",
          "zh": "篝火慢烤鱼（大型）",
          "ja": "大きな魚の野外料理"
        },
        {
          "id": "ButcherMediumWoolyAnimal",
          "en": "Butcher Medium Wooly Animal",
          "fr": "Dépecer l\u0027animal de taille moyenne à laine",
          "es": "Descuartizar animal mediano (con lana)",
          "de": "Mittleres Wolltier schlachten",
          "pt": "Carnear Animal Lanoso Médio",
          "it": "Macella Animale Lanoso Medio",
          "tr": "Butcher Medium Wooly Animal",
          "pl": "Przerób średnie wełniane zwierzę",
          "ru": "Разделать среднее шерстяное животное",
          "uk": "Butcher Medium Wooly Animal",
          "ko": "정육점 중간 양털 동물",
          "zh": "加工中型毛茸茸的动物",
          "ja": "Butcher Medium Wooly Animal"
        },
        {
          "id": "AgoutiEnchiladas",
          "en": "Agouti Enchiladas",
          "fr": "Enchiladas d\u0027agouti",
          "es": "Enchiladas de agutí",
          "de": "Agouti Enchiladas",
          "pt": "Enchiladas de cutia",
          "it": "Enchilada d\u0027Agouti",
          "tr": "Agouti Enchiladas",
          "pl": "Enchilady z Aguti",
          "ru": "Энчиладас с агути",
          "uk": "Agouti Enchiladas",
          "ko": "아구티 엔칠라다스",
          "zh": "刺鼠玉米卷",
          "ja": "Agouti Enchiladas"
        },
        {
          "id": "AutumnStew",
          "en": "Autumn Stew",
          "fr": "Ragoût d\u0027automne",
          "es": "Estofado otoñal",
          "de": "Herbsteintopf",
          "pt": "Ensopado outonal",
          "it": "Stufato Autunnale",
          "tr": "Autumn Stew",
          "pl": "Gulasz dyniowy",
          "ru": "Осеннее рагу",
          "uk": "Autumn Stew",
          "ko": "가을 스튜",
          "zh": "秋季炖汤",
          "ja": "Autumn Stew"
        },
        {
          "id": "BanhXeo",
          "en": "Banh Xeo",
          "fr": "Banh Xeo",
          "es": "Banh Xeo",
          "de": "Banh Xeo",
          "pt": "Banh xeo",
          "it": "Banh Xeo",
          "tr": "Banh Xeo",
          "pl": "Banh Xeo",
          "ru": "Блинчики Бан Хео",
          "uk": "Banh Xeo",
          "ko": "반 세오",
          "zh": "越南煎饼",
          "ja": "バインセオ"
        },
        {
          "id": "BeanSprout",
          "en": "Bean Sprout",
          "fr": "Pousses de haricots",
          "es": "Germinado de Judías",
          "de": "Bohnensprosse",
          "pt": "Broto de feijão",
          "it": "Germoglio di Fagiolo",
          "tr": "Bean Sprout",
          "pl": "Bean Sprout",
          "ru": "Бобовый росток",
          "uk": "Bean Sprout",
          "ko": "콩 새싹",
          "zh": "豆芽菜",
          "ja": "Bean Sprout"
        },
        {
          "id": "BisonChowFun",
          "en": "Bison Chow Fun",
          "fr": "Chow Fun au bison",
          "es": "Chow Fun de Bisonte",
          "de": "Bison Kau-Genuß",
          "pt": "Chow fun de bisão",
          "it": "Chow Fun di Bisonte",
          "tr": "Bison Chow Fun",
          "pl": "Chow fun z żubra",
          "ru": "Фан-чау из бизона",
          "uk": "Bison Chow Fun",
          "ko": "바이슨 쵸우 펀",
          "zh": "野牛炒粉",
          "ja": "Bison Chow Fun"
        },
        {
          "id": "ClamChowder",
          "en": "Clam Chowder",
          "fr": "Chaudrée de palourdes",
          "es": "Sopa de mariscos",
          "de": "Suppe mit Muscheln",
          "pt": "Sopa de molusco",
          "it": "Zuppa di Vongole",
          "tr": "Clam Chowder",
          "pl": "Chowder z małży",
          "ru": "Похлебка из моллюсков",
          "uk": "Clam Chowder",
          "ko": "클램 차우더",
          "zh": "蛤蜊汤",
          "ja": "Clam Chowder"
        },
        {
          "id": "FantasticForestPizza",
          "en": "Fantastic Forest Pizza",
          "fr": "Pizza fantastique de la forêt",
          "es": "Pizza del Bosque Fantástico",
          "de": "Pizza Wald Fantastica",
          "pt": "Pizza fantástica da floresta",
          "it": "Pizza Forestale Fantastica",
          "tr": "Fantastic Forest Pizza",
          "pl": "Fantastyczna leśna pizza",
          "ru": "Фантастическая лесная пицца",
          "uk": "Fantastic Forest Pizza",
          "ko": "환상의 숲 피자",
          "zh": "奇幻森林比萨",
          "ja": "Fantastic Forest Pizza"
        },
        {
          "id": "FishNChips",
          "en": "Fish N Chips",
          "fr": "Fish and Chips",
          "es": "Fish N Chips",
          "de": "Fish N Chips",
          "pt": "Peixe e fritas",
          "it": "Fish N Chips",
          "tr": "Fish N Chips",
          "pl": "Fish N Chips",
          "ru": "Рыбные чипсы",
          "uk": "Fish N Chips",
          "ko": "피쉬 앤 칩스",
          "zh": "炸鱼薯条",
          "ja": "Fish N Chips"
        },
        {
          "id": "HeartyHometownPizza",
          "en": "Hearty Hometown Pizza",
          "fr": "Pizza copieuse de mon enfance",
          "es": "Pizza de la Ciudad Natal",
          "de": "Pizza Home Sweet Home",
          "pt": "Pizza calorosa da cidade natal",
          "it": "Pizza Cordiale della Città Natia",
          "tr": "Hearty Hometown Pizza",
          "pl": "Sycąca domowa pizza",
          "ru": "Пицца в форме сердца",
          "uk": "Hearty Hometown Pizza",
          "ko": "따뜻한 고향 피자",
          "zh": "温馨故乡比萨",
          "ja": "Hearty Hometown Pizza"
        },
        {
          "id": "Hosomaki",
          "en": "Hosomaki",
          "fr": "Hosomaki",
          "es": "Hosomaki",
          "de": "Hosomaki",
          "pt": "Hosomaki",
          "it": "Hosomaki",
          "tr": "Hosomaki",
          "pl": "Hosomaki",
          "ru": "Хосомаки",
          "uk": "Hosomaki",
          "ko": "김초밥",
          "zh": "手握寿司",
          "ja": "Hosomaki"
        },
        {
          "id": "HuckleberryFritter",
          "en": "Huckleberry Fritter",
          "fr": "Beignet aux myrtilles",
          "es": "Buñuelo de Arándanos",
          "de": "Gebackene Heidelbeeren",
          "pt": "Bolinho de mirtilo",
          "it": "Frittele di Mirtilli",
          "tr": "Huckleberry Fritter",
          "pl": "Huckleberry Fritter",
          "ru": "Черничные Оладьи",
          "uk": "Huckleberry Fritter",
          "ko": "월귤전",
          "zh": "越橘油炸馅饼",
          "ja": "Huckleberry Fritter"
        },
        {
          "id": "KelpyCrabRoll",
          "en": "Kelpy Crab Roll",
          "fr": "Maki au crabe",
          "es": "Rollo de Cangrejo con Algas",
          "de": "Krabbenrolle mit Algen",
          "pt": "Rolo de caranguejo com algas",
          "it": "Rotolo di Granchio Algoso",
          "tr": "Kelpy Crab Roll",
          "pl": "Wodorostowa rolka z krabem",
          "ru": "Ролл Краб в ламинарии",
          "uk": "Kelpy Crab Roll",
          "ko": "다시마 게 초밥",
          "zh": "苏格兰蟹肉卷",
          "ja": "Kelpy Crab Roll"
        },
        {
          "id": "LoadedTaroFries",
          "en": "Loaded Taro Fries",
          "fr": "Frites de taro garnies",
          "es": "Patatas fritas de Taro Cargadas",
          "de": "Überbackene Taro-Fritten",
          "pt": "Batatas fritas de inhame",
          "it": "Patatine Fritte di Taro",
          "tr": "Loaded Taro Fries",
          "pl": "Frytki na bogato",
          "ru": "Заправленный Таро фри",
          "uk": "Loaded Taro Fries",
          "ko": "토란 튀김 곱빼기",
          "zh": "油炸芋头",
          "ja": "Loaded Taro Fries"
        },
        {
          "id": "MillionairesSalad",
          "en": "Millionaires Salad",
          "fr": "Salade du millionnaire",
          "es": "Ensalada del millionario",
          "de": "Millionär-Salat",
          "pt": "Salada milionária",
          "it": "Insalata dei Miliardari",
          "tr": "Millionaires Salad",
          "pl": "Sałatka Milionerów",
          "ru": "Салат Миллионера",
          "uk": "Millionaires Salad",
          "ko": "백만장자 샐러드",
          "zh": "百万富翁沙拉",
          "ja": "Millionaires Salad"
        },
        {
          "id": "Mochi",
          "en": "Mochi",
          "fr": "Mochi",
          "es": "Mochi",
          "de": "Mochi",
          "pt": "Mochi",
          "it": "Mochi",
          "tr": "Mochi",
          "pl": "Mochi",
          "ru": "Моти",
          "uk": "Mochi",
          "ko": "모찌",
          "zh": "糯米团",
          "ja": "Mochi"
        },
        {
          "id": "PhadThai",
          "en": "Phad Thai",
          "fr": "Phad Thai",
          "es": "Phad Thai",
          "de": "Phad Thai",
          "pt": "Phad thai",
          "it": "Phad Thai",
          "tr": "Phad Thai",
          "pl": "Pad Thai",
          "ru": "Пад-тай",
          "uk": "Phad Thai",
          "ko": "팟 타이",
          "zh": "泰式炒河粉",
          "ja": "Phad Thai"
        },
        {
          "id": "PokeBowl",
          "en": "Poke Bowl",
          "fr": "Poke Bowl",
          "es": "Poke",
          "de": "Gemüse-Bowle",
          "pt": "Poke bowl",
          "it": "Poke Bowl",
          "tr": "Poke Bowl",
          "pl": "Poke Bowl",
          "ru": "Поке Боул",
          "uk": "Poke Bowl",
          "ko": "포케",
          "zh": "冲浪碗",
          "ja": "Poke Bowl"
        },
        {
          "id": "Pupusas",
          "en": "Pupusas",
          "fr": "Pupusas",
          "es": "Pupusas",
          "de": "Pupusas",
          "pt": "Pupusas",
          "it": "Pupusa",
          "tr": "Pupusas",
          "pl": "Pupusas",
          "ru": "Пупусас",
          "uk": "Pupusas",
          "ko": "푸푸사스",
          "zh": "奶酪猪肉玉米饼",
          "ja": "Pupusas"
        },
        {
          "id": "RiceFlour",
          "en": "Rice Flour",
          "fr": "Farine de riz",
          "es": "Harina de arroz",
          "de": "Reismehl",
          "pt": "Farinha de arroz",
          "it": "Farina di Riso",
          "tr": "Rice Flour",
          "pl": "Mąka Ryżowa",
          "ru": "Рисовая мука",
          "uk": "Rice Flour",
          "ko": "쌀가루",
          "zh": "米粉",
          "ja": "Rice Flour"
        },
        {
          "id": "RiceNoodles",
          "en": "Rice Noodles",
          "fr": "Nouilles de riz",
          "es": "Fideos de arroz",
          "de": "Reisnudeln",
          "pt": "Macarrão de arroz",
          "it": "Noodles di Riso",
          "tr": "Rice Noodles",
          "pl": "Makaron Ryżowy",
          "ru": "Рисовая лапша",
          "uk": "Rice Noodles",
          "ko": "쌀 면",
          "zh": "米线",
          "ja": "Rice Noodles"
        },
        {
          "id": "RoastPumpkin",
          "en": "Roast Pumpkin",
          "fr": "Citrouille cuite",
          "es": "Calabaza asada",
          "de": "Gerösteter Kürbis",
          "pt": "Abóbora assada",
          "it": "Zucca Arrosto",
          "tr": "Roast Pumpkin",
          "pl": "Roast Pumpkin",
          "ru": "Жареная тыква",
          "uk": "Roast Pumpkin",
          "ko": "구운 호박",
          "zh": "烤南瓜",
          "ja": "Roast Pumpkin"
        },
        {
          "id": "SeededCamasRoll",
          "en": "Seeded Camas Roll",
          "fr": "Rouleau aux graines de camassia",
          "es": "Rollos de Camas con Semillas",
          "de": "Bestreute Prärielilienrolle",
          "pt": "Rolo de sementes de camassia",
          "it": "Involtini di Camas Con Semi",
          "tr": "Seeded Camas Roll",
          "pl": "Seeded Camas Roll",
          "ru": "Ролл с семенами Камассии",
          "uk": "Seeded Camas Roll",
          "ko": "씨 있는 카마스 롤",
          "zh": "去籽卡马斯卷",
          "ja": "Seeded Camas Roll"
        },
        {
          "id": "SensuousSeaPizza",
          "en": "Sensuous Sea Pizza",
          "fr": "Pizza sensuelle de la mer",
          "es": "Pizza de Mar Agradable a los Sentidos",
          "de": "Pizza di Mare Fantastico",
          "pt": "Pizza do mar sensuoso",
          "it": "Pizza di Mare Piacevole ai Sensi",
          "tr": "Sensuous Sea Pizza",
          "pl": "Smakowita morska pizza",
          "ru": "Морская Пицца",
          "uk": "Sensuous Sea Pizza",
          "ko": "바다 내음 피자",
          "zh": "悠扬之海比萨",
          "ja": "Sensuous Sea Pizza"
        },
        {
          "id": "SharkFilletSoup",
          "en": "Shark Fillet Soup",
          "fr": "Soupe d\u0027ailerons de requin",
          "es": "Sopa de Filete de Tiburón",
          "de": "Suppe aus Haifilet",
          "pt": "Sopa de filé de tubarão",
          "it": "Zuppa di Filetto di Squalo",
          "tr": "Shark Fillet Soup",
          "pl": "Zupa z płetwy rekina",
          "ru": "Суп из филе акулы",
          "uk": "Shark Fillet Soup",
          "ko": "상어 지느러미 수프",
          "zh": "鲨鱼片汤",
          "ja": "Shark Fillet Soup"
        },
        {
          "id": "SmoothGutNoodleRoll",
          "en": "Smooth Gut Noodle Roll",
          "fr": "Rouleau de nouilles à la viande",
          "es": "Rollo de Fideos e Intestino Delgado",
          "de": "Canelloni mit Hackfleisch",
          "pt": "Rolo de macarrão liso",
          "it": "Involtino di Noodle e Intestino Tenue",
          "tr": "Smooth Gut Noodle Roll",
          "pl": "Aksamitne sajgonki",
          "ru": "Ролл из гладкой кишки с лапшой",
          "uk": "Smooth Gut Noodle Roll",
          "ko": "부드러운 위장 누들 롤",
          "zh": "肠粉卷",
          "ja": "Smooth Gut Noodle Roll"
        },
        {
          "id": "SpikyRoll",
          "en": "Spiky Roll",
          "fr": "Maki hérissé",
          "es": "Rollo Puntiagudo",
          "de": "Stachelige Rolle",
          "pt": "Rolo espinhoso",
          "it": "Involtino Appuntito",
          "tr": "Spiky Roll",
          "pl": "Spiky Roll",
          "ru": "Колючий ролл",
          "uk": "Spiky Roll",
          "ko": "성게 초밥",
          "zh": "穗状花卷",
          "ja": "Spiky Roll"
        },
        {
          "id": "SunCheese",
          "en": "Sun Cheese",
          "fr": "Fromage de tournesol",
          "es": "Queso solar",
          "de": "Sonnenblumenkäse",
          "pt": "Queijo sol",
          "it": "Formaggio di Girasole",
          "tr": "Sun Cheese",
          "pl": "Sun Cheese",
          "ru": "Сыр из семечек подсолнуха",
          "uk": "Sun Cheese",
          "ko": "치즈",
          "zh": "向日葵奶酪",
          "ja": "Sun Cheese"
        },
        {
          "id": "TaroFries",
          "en": "Taro Fries",
          "fr": "Frites de taro",
          "es": "Patatas fritas de taro",
          "de": "Taro-Fritten",
          "pt": "Fritas de inhame",
          "it": "Patatine di Taro",
          "tr": "Taro Fries",
          "pl": "Frytki z kolokazji",
          "ru": "Таро Фри",
          "uk": "Taro Fries",
          "ko": "토란 튀김",
          "zh": "芋头炸薯条",
          "ja": "Taro Fries"
        },
        {
          "id": "TastyTropicalPizza",
          "en": "Tasty Tropical Pizza",
          "fr": "Pizza tropicale savoureuse",
          "es": "Pizza tropical",
          "de": "Pizza Tropica",
          "pt": "Pizza tropical saborosa",
          "it": "Saporita Pizza Tropicale",
          "tr": "Tasty Tropical Pizza",
          "pl": "Pyszna pizza tropikalna",
          "ru": "Вкусная Тропическая Пицца",
          "uk": "Tasty Tropical Pizza",
          "ko": "하와이안 피자",
          "zh": "可口热带比萨",
          "ja": "Tasty Tropical Pizza"
        },
        {
          "id": "WorldlyDonut",
          "en": "Worldly Donut",
          "fr": "Beignet mondain",
          "es": "Donut del mundo",
          "de": "Schmackhafter Donut",
          "pt": "Rosquinha mundana",
          "it": "Ciambella Mondana",
          "tr": "Worldly Donut",
          "pl": "Worldly Donut",
          "ru": "Пончик Мира",
          "uk": "Worldly Donut",
          "ko": "월들리 도넛",
          "zh": "惊世甜甜圈",
          "ja": "Worldly Donut"
        },
        {
          "id": "LargeBathMat",
          "en": "Large Bath Mat",
          "fr": "Grand tapis de bain",
          "es": "Alfombrilla de baño grande",
          "de": "Große Badematte",
          "pt": "Tapete de Banho Grande",
          "it": "Grande Tappetino da Bagno",
          "tr": "Large Bath Mat",
          "pl": "Duża Mata Łazienkowa",
          "ru": "Большой коврик для ванной",
          "uk": "Large Bath Mat",
          "ko": "대형 욕실 매트",
          "zh": "大型浴室防滑垫",
          "ja": "大きいバスマット"
        },
        {
          "id": "NylonFutonBed",
          "en": "Nylon Futon Bed",
          "fr": "Lit futon en nylon",
          "es": "Cama-futón con funda de nailon",
          "de": "Nylon Futon Bett",
          "pt": "Cama Futon de Náilon",
          "it": "Letto Futon in Nylon",
          "tr": "Nylon Futon Bed",
          "pl": "Nylonowe łóżko Futon",
          "ru": "Кровать с нейлоновым футоном",
          "uk": "Nylon Futon Bed",
          "ko": "나일론 깔개 침대",
          "zh": "尼龙沙发床",
          "ja": "Nylon Futon Bed"
        },
        {
          "id": "NylonFutonCouch",
          "en": "Nylon Futon Couch",
          "fr": "Canapé futon en nylon",
          "es": "Futón con funda de nailon",
          "de": "Nylon Futon Couch",
          "pt": "Sofá-cama de Náilon",
          "it": "Divano Futon in Nylon",
          "tr": "Nylon Futon Couch",
          "pl": "Nylonowa Kanapa Futon",
          "ru": "Диван с нейлоновым футоном",
          "uk": "Nylon Futon Couch",
          "ko": "나일론 깔개 소파",
          "zh": "尼龙蒲团沙发",
          "ja": "Nylon Futon Couch"
        },
        {
          "id": "SmallBathMat",
          "en": "Small Bath Mat",
          "fr": "Petit tapis de bain",
          "es": "Alfombrilla de baño pequeña",
          "de": "Kleine Badematte",
          "pt": "Tapete de Banho Pequeno",
          "it": "Piccolo Tappetino da Bagno",
          "tr": "Small Bath Mat",
          "pl": "Small Bath Mat",
          "ru": "Небольшой Коврик для ванной",
          "uk": "Small Bath Mat",
          "ko": "소형 욕실 매트",
          "zh": "小型浴室防滑垫",
          "ja": "小さいバスマット"
        },
        {
          "id": "TowelRack",
          "en": "Towel Rack",
          "fr": "Porte-serviettes",
          "es": "Colgador de toalla",
          "de": "Handtuchständer",
          "pt": "Toalheiro",
          "it": "Portasciugamani",
          "tr": "Towel Rack",
          "pl": "Towel Rack",
          "ru": "Вешалка для полотенец",
          "uk": "Towel Rack",
          "ko": "수건걸이",
          "zh": "毛巾架",
          "ja": "Towel Rack"
        },
        {
          "id": "UpholsteredChair",
          "en": "Upholstered Chair",
          "fr": "Fauteuil rembourré",
          "es": "Silla tapizada",
          "de": "Gepolsteter Stuhl",
          "pt": "Cadeira Estofada",
          "it": "Sedia Imbottita",
          "tr": "Upholstered Chair",
          "pl": "Tapiecerowane krzesło",
          "ru": "Стул с обивкой",
          "uk": "Upholstered Chair",
          "ko": "푹신한 의자",
          "zh": "铺软垫的椅子",
          "ja": "布張りの椅子"
        },
        {
          "id": "UpholsteredCouch",
          "en": "Upholstered Couch",
          "fr": "Canapé rembourré",
          "es": "Sofá tapizado",
          "de": "Gepolsterte Couch",
          "pt": "Sofá Estofado",
          "it": "Divano Imbottito",
          "tr": "Upholstered Couch",
          "pl": "Tapicerowana kanapa",
          "ru": "Диван с обивкой",
          "uk": "Upholstered Couch",
          "ko": "푹신한 소파",
          "zh": "铺软垫的沙发",
          "ja": "Upholstered Couch"
        },
        {
          "id": "SunflowerOil",
          "en": "Sunflower Oil",
          "fr": "Huile de tournesol",
          "es": "Aceite de girasol",
          "de": "Sonnenblumenöl",
          "pt": "Óleo de Girassol",
          "it": "Olio di Girasole",
          "tr": "Sunflower Oil",
          "pl": "Olej słonecznikowy",
          "ru": "Подсолнечное масло",
          "uk": "Sunflower Oil",
          "ko": "해바라기씨유",
          "zh": "葵花籽油",
          "ja": "Sunflower Oil"
        },
        {
          "id": "SandConcentrateLv3",
          "en": "Sand Concentrate Lv3",
          "fr": "Concentré de sable nv. 3",
          "es": "Concentrado de arena (niv. 3)",
          "de": "Sand Lv3",
          "pt": "Concentrado de Areia Nível 3",
          "it": "Concentrato di Sabbia Lv3",
          "tr": "Sand Concentrate Lv3",
          "pl": "Sand Concentrate Lv3",
          "ru": "Получить песок Ур.3",
          "uk": "Sand Concentrate Lv3",
          "ko": "정제된 모래 Lv3",
          "zh": "筛选沙子 等级3",
          "ja": "Sand Concentrate Lv3"
        },
        {
          "id": "SandConcentrateLv2",
          "en": "Sand Concentrate Lv2",
          "fr": "Concentré de sable nv. 2",
          "es": "Concentrado de arena (niv. 2)",
          "de": "Sand Lv2",
          "pt": "Concentrado de Areia Nível 2",
          "it": "Concentrato di Sabbia Lv2",
          "tr": "Sand Concentrate Lv2",
          "pl": "Sand Concentrate Lv2",
          "ru": "Получить песок Ур.2",
          "uk": "Sand Concentrate Lv2",
          "ko": "정제된 모래 Lv2",
          "zh": "筛选沙子 等级2",
          "ja": "Sand Concentrate Lv2"
        },
        {
          "id": "CleanMoonJellyfish",
          "en": "Clean Moon Jellyfish",
          "fr": "Préparer la méduse lune",
          "es": "Medusa Luna Limpia",
          "de": "Reine Mondqualle",
          "pt": "Limpar Medusa-da-lua",
          "it": "Pulisci Medusa Quadrifoglio",
          "tr": "Clean Moon Jellyfish",
          "pl": "Czysta meduza księżycowa",
          "ru": "Очистить Ушастую аурелию",
          "uk": "Clean Moon Jellyfish",
          "ko": "보름달 물해파리 손질하기",
          "zh": "清洗月亮水母",
          "ja": "Clean Moon Jellyfish"
        },
        {
          "id": "WheatEthanol",
          "en": "Wheat Ethanol",
          "fr": "Éthanol de blé",
          "es": "Etanol de Trigo",
          "de": "Weizen Ethanol",
          "pt": "Etanol de Trigo",
          "it": "Etanolo da Cereali",
          "tr": "Wheat Ethanol",
          "pl": "Etanol pszeniczny",
          "ru": "Этанол из пшеницы",
          "uk": "Пшеничний етанол",
          "ko": "Wheat Ethanol",
          "zh": "小麦乙醇",
          "ja": "Wheat Ethanol"
        },
        {
          "id": "WeaveWoolCurtains",
          "en": "Weave Wool Curtains",
          "fr": "Tisser des rideaux en laine",
          "es": "Cortinas de Lana Tejida",
          "de": "Webe Wollvorhänge",
          "pt": "Tecelagem de Cortinas de Lã",
          "it": "Tende in Lana Intrecciata",
          "tr": "Weave Wool Curtains",
          "pl": "Weave Wool Curtains",
          "ru": "Ткать Шерстяные шторы",
          "uk": "Weave Wool Curtains",
          "ko": "양모 커튼 짜기",
          "zh": "纺织毛线窗帘",
          "ja": "Weave Wool Curtains"
        },
        {
          "id": "WeaveSmallBathMat",
          "en": "Weave Small Bath Mat",
          "fr": "Tisser un petit tapis de bain",
          "es": "Alfombra de Baño Tejida Pequeña",
          "de": "Kleine Badematte weben",
          "pt": "Tecelagem de Tapete de Banho Pequeno",
          "it": "Tessi Piccolo Tappetino da Bagno",
          "tr": "Weave Small Bath Mat",
          "pl": "Weave Small Bath Mat",
          "ru": "Ткать Небольшой Коврик для ванной",
          "uk": "Weave Small Bath Mat",
          "ko": "소형 욕실 매트 짜기",
          "zh": "纺织小号浴室地垫",
          "ja": "Weave Small Bath Mat"
        },
        {
          "id": "WeaveNylonCurtains",
          "en": "Weave Nylon Curtains",
          "fr": "Tisser des rideaux en nylon",
          "es": "Cortinas de nailon",
          "de": "Webe Nylonvorhänge",
          "pt": "Tecelagem de Cortinas de Náilon",
          "it": "Tessi Tende in Nylon",
          "tr": "Weave Nylon Curtains",
          "pl": "Weave Nylon Curtains",
          "ru": "Ткать Нейлоновые шторы",
          "uk": "Weave Nylon Curtains",
          "ko": "나일론 커튼 짜기",
          "zh": "纺织尼龙窗帘",
          "ja": "Weave Nylon Curtains"
        },
        {
          "id": "WeaveLargeBathMat",
          "en": "Weave Large Bath Mat",
          "fr": "Tisser un grand tapis de bain",
          "es": "Alfombra Grande de Baño Tejida",
          "de": "Große Badematte weben",
          "pt": "Tecelagem de Tapete de Banho Grande",
          "it": "Tessi Tappetino da Bagno Grande",
          "tr": "Weave Large Bath Mat",
          "pl": "Tkanie Dużej Maty Łazienkowej",
          "ru": "Ткать Большой коврик для ванной",
          "uk": "Weave Large Bath Mat",
          "ko": "대형 욕실 매트 짜기",
          "zh": "纺织大号浴室地垫",
          "ja": "Weave Large Bath Mat"
        },
        {
          "id": "WeaveCottonCurtains",
          "en": "Weave Cotton Curtains",
          "fr": "Tisser des rideaux en coton",
          "es": "Cortinas de Algodón Tejidas",
          "de": "Webe Baumwollvorhänge",
          "pt": "Tecelagem de Cortinas de Algodão",
          "it": "Tessi Tende in Cotone",
          "tr": "Weave Cotton Curtains",
          "pl": "Utkaj bawełniane zasłony",
          "ru": "Ткать Хлопковые шторы",
          "uk": "Weave Cotton Curtains",
          "ko": "면 커튼 짜기",
          "zh": "纺织棉窗帘",
          "ja": "Weave Cotton Curtains"
        },
        {
          "id": "MeltingFat",
          "en": "Melting Fat",
          "fr": "Fondre la graisse",
          "es": "Grasa fundida",
          "de": "Schmelzfett",
          "pt": "Derretimento de Gordura",
          "it": "Sciogliere il Grasso",
          "tr": "Melting Fat",
          "pl": "Melting Fat",
          "ru": "Плавить Жир",
          "uk": "Витопити жир",
          "ko": "지방 녹이기",
          "zh": "炼制脂肪",
          "ja": "Melting Fat"
        },
        {
          "id": "CornEthanol",
          "en": "Corn Ethanol",
          "fr": "Éthanol de maïs",
          "es": "Etanol de maíz",
          "de": "Mais Ethanol",
          "pt": "Etanol de Milho",
          "it": "Etanolo di Mais",
          "tr": "Corn Ethanol",
          "pl": "Etanol z kukurydzy",
          "ru": "Этанол из кукурузы",
          "uk": "Кукурудзяний етанол",
          "ko": "Corn Ethanol",
          "zh": "玉米乙醇",
          "ja": "Corn Ethanol"
        },
        {
          "id": "CleanCrab",
          "en": "Clean Crab",
          "fr": "Vider le crabe",
          "es": "Cangrejo limpio",
          "de": "Saubere Krabbe",
          "pt": "Limpar Caranguejo",
          "it": "Pulisci Granchio",
          "tr": "Clean Crab",
          "pl": "Czysty krab",
          "ru": "Очистить краба",
          "uk": "Почистити краба",
          "ko": "게 손질법",
          "zh": "清洗螃蟹",
          "ja": "Clean Crab"
        },
        {
          "id": "CampfireFishSmall",
          "en": "Campfire Fish Small",
          "fr": "Poisson de petite taille cuit au feu de camp",
          "es": "Pescado pequeño a la brasa",
          "de": "Lagerfeuer Fisch (klein)",
          "pt": "Peixe Pequeno Feito na Fogueira",
          "it": "Piccolo Pesce al Falò",
          "tr": "Campfire Fish Small",
          "pl": "Mała ryba z ogniska",
          "ru": "Пожарить маленькую рыбу",
          "uk": "Мала риба на вогнищі",
          "ko": "소형 생선 모닥불 구이",
          "zh": "篝火慢烤鱼（小型）",
          "ja": "小さな魚の野外料理"
        },
        {
          "id": "WoodenBarge",
          "en": "Wooden Barge",
          "fr": "Bac en bois",
          "es": "Barcaza de Madera",
          "de": "Hölzerner Kahn",
          "pt": "Barcaça de Madeira",
          "it": "Chiatta in Legno",
          "tr": "Wooden Barge",
          "pl": "Drewniana barka",
          "ru": "Деревянная баржа",
          "uk": "Дерев\u0027яна баржа",
          "ko": "목제 바지선",
          "zh": "木质驳船",
          "ja": "Wooden Barge"
        },
        {
          "id": "SmallWoodenBoat",
          "en": "Small Wooden Boat",
          "fr": "Petit bateau en bois",
          "es": "Pequeño Barco de Madera",
          "de": "Holzboot (klein)",
          "pt": "Barco de Madeira Pequeno",
          "it": "Piccola Barca in Legno",
          "tr": "Small Wooden Boat",
          "pl": "Mała drewniana łódka",
          "ru": "Маленькая деревянная лодка",
          "uk": "Малий дерев’яний човен",
          "ko": "소형 목제 보트",
          "zh": "小木船",
          "ja": "Small Wooden Boat"
        },
        {
          "id": "LumberDresser",
          "en": "Lumber Dresser",
          "fr": "Commode en bois d\u0027œuvre",
          "es": "Cómoda de madera",
          "de": "Bauholzkommode",
          "pt": "Cômoda de Madeira Serrada",
          "it": "Credenza in Legno",
          "tr": "Lumber Dresser",
          "pl": "Drewniana komoda",
          "ru": "Комод из пиломатериалов",
          "uk": "Lumber Dresser",
          "ko": "가공된 목재 옷장",
          "zh": "木衣柜",
          "ja": "Lumber Dresser"
        },
        {
          "id": "CrushedStoneRoadLv2",
          "en": "Crushed Stone Road Lv2",
          "fr": "Route en pierre concassée nv. 2",
          "es": "Camino de piedra triturada (niv. 2)",
          "de": "Zerkleinerte Steinstraße Stufe 2",
          "pt": "Estrada de Pedra Triturada Nível 2",
          "it": "Strada di Pietra Spaccata Lv2",
          "tr": "Crushed Stone Road Lv2",
          "pl": "Droga z kruszonych kamieni Poziom 2",
          "ru": "Дробление Каменной дороги Ур.2",
          "uk": "Crushed Stone Road Lv2",
          "ko": "파쇄된 돌 길 Lv2",
          "zh": "碎石路 等级2",
          "ja": "Crushed Stone Road Lv2"
        },
        {
          "id": "CrushedStoneRoad",
          "en": "Crushed Stone Road",
          "fr": "Route en pierre concassée",
          "es": "Camino de piedra triturada",
          "de": "Zerkleinerte Steinstraße",
          "pt": "Estrada de Pedra Triturada",
          "it": "Strada di Pietra Spaccata",
          "tr": "Crushed Stone Road",
          "pl": "Droga z kruszonych kamieni",
          "ru": "Дробление Каменной дороги",
          "uk": "Crushed Stone Road",
          "ko": "파쇄된 돌 길",
          "zh": "碎石路",
          "ja": "Crushed Stone Road"
        },
        {
          "id": "CrushedMortaredStoneLv2",
          "en": "Crushed Mortared Stone Lv2",
          "fr": "Pierre cimentée concassée nv. 2",
          "es": "Piedra triturada con mortero (niv. 2)",
          "de": "Zerkleinerte Steinziegel Lv2",
          "pt": "Pedra de Argamassa Triturada Nível 2",
          "it": "Pietra Spaccata Macinata Lv2",
          "tr": "Crushed Mortared Stone Lv2",
          "pl": "Droga z kamieni z zaprawą Poziom 2",
          "ru": "Дробление Строительного камня Ур.2",
          "uk": "Crushed Mortared Stone Lv2",
          "ko": "파쇄된 모르타르 돌 Lv2",
          "zh": "砂浆碎石 等级2",
          "ja": "Crushed Mortared Stone Lv2"
        },
        {
          "id": "CrushedMortaredStone",
          "en": "Crushed Mortared Stone",
          "fr": "Pierre cimentée concassée",
          "es": "Piedra triturada con mortero",
          "de": "Zerkleinerte Steinziegel",
          "pt": "Pedra de Argamassa Triturada",
          "it": "Pietra Spaccata Macinata",
          "tr": "Crushed Mortared Stone",
          "pl": "Droga z kamieni z zaprawą",
          "ru": "Дробление Строительного камня",
          "uk": "Crushed Mortared Stone",
          "ko": "파쇄된 모르타르 돌",
          "zh": "砂浆碎石",
          "ja": "Crushed Mortared Stone"
        },
        {
          "id": "WoodShopCart",
          "en": "Wood Shop Cart",
          "fr": "Boutique itinérante en bois",
          "es": "Carro de Compras de Madera",
          "de": "Holzladenwagen",
          "pt": "Carrinho de Madeira com Loja",
          "it": "Carrello della Spesa in Legno",
          "tr": "Ahşap Dükkanı Sepeti",
          "pl": "Wood Shop Cart",
          "ru": "Передвижной деревянный магазин",
          "uk": "Wood Shop Cart",
          "ko": "포장마차",
          "zh": "木质购物车",
          "ja": "Wood Shop Cart"
        },
        {
          "id": "Macarons",
          "en": "Macarons",
          "fr": "Macarons",
          "es": "Macarones",
          "de": "Makaronen",
          "pt": "Macaron",
          "it": "Macaron",
          "tr": "Macarons",
          "pl": "Macarons",
          "ru": "Макарон",
          "uk": "Macarons",
          "ko": "마카롱",
          "zh": "马卡龙",
          "ja": "Macarons"
        },
        {
          "id": "FlaxFiber",
          "en": "Flax Fiber",
          "fr": "Fibre de lin",
          "es": "Fibra de lino",
          "de": "Flachsfaser",
          "pt": "Fibra de Linho",
          "it": "Fibra di lino",
          "tr": "Flax Fiber",
          "pl": "Włókno lniane",
          "ru": "Льняное волокно",
          "uk": "Flax Fiber",
          "ko": "아마 섬유",
          "zh": "亚麻纤维",
          "ja": "亜麻繊維"
        },
        {
          "id": "LinenFabric",
          "en": "Linen Fabric",
          "fr": "Tissu de lin",
          "es": "Tela de lino",
          "de": "Leinenstoff",
          "pt": "Tecido de Linho",
          "it": "Tessuto di lino",
          "tr": "Linen Fabric",
          "pl": "Tkanina lniana",
          "ru": "Льняная ткань",
          "uk": "Linen Fabric",
          "ko": "아마포",
          "zh": "亚麻织物",
          "ja": "Linen Fabric"
        },
        {
          "id": "LinenYarn",
          "en": "Linen Yarn",
          "fr": "Fil de lin",
          "es": "Hilo de lino",
          "de": "Leinengarn",
          "pt": "Fio de Linho",
          "it": "Filato di lino",
          "tr": "Linen Yarn",
          "pl": "Linen Yarn",
          "ru": "Льняная пряжа",
          "uk": "Linen Yarn",
          "ko": "아마 실타래",
          "zh": "亚麻纱",
          "ja": "Linen Yarn"
        },
        {
          "id": "FlaxSeed",
          "en": "Flax Seed",
          "fr": "Graine de lin",
          "es": "Semilla de lino",
          "de": "Flachssaat",
          "pt": "Semente de Linho",
          "it": "Seme di lino",
          "tr": "Flax Seed",
          "pl": "Nasiono lnu",
          "ru": "Семечко льна",
          "uk": "Flax Seed",
          "ko": "아마씨",
          "zh": "亚麻种子",
          "ja": "Flax Seed"
        },
        {
          "id": "FiberScutchingStation",
          "en": "Fiber Scutching Station",
          "fr": "Établi de teillage de fibres",
          "es": "Estación de espaldillado de fibras",
          "de": "Flachsschwinge",
          "pt": "Estação de corte de fibra",
          "it": "Stazione di gramolatura delle fibre",
          "tr": "Fiber Scutching Station",
          "pl": "Fiber Scutching Station",
          "ru": "Прядильный станок",
          "uk": "Fiber Scutching Station",
          "ko": "섬유 타면기",
          "zh": "纤维脱胶台",
          "ja": "Fiber Scutching Station"
        },
        {
          "id": "WoodenKitchenLamp",
          "en": "Wooden Kitchen Lamp",
          "fr": "Lustre de cuisine en bois d\u0027œuvre",
          "es": "Lámpara de cocina (madera)",
          "de": "Hölzerne Küchenlampe",
          "pt": "Lâmpada de Cozinha de Madeira",
          "it": "Lampada da Cucina in Legno",
          "tr": "Wooden Kitchen Lamp",
          "pl": "Drewniana lampa kuchenna",
          "ru": "Деревянная кухонная лампа",
          "uk": "Дерев\u0027яна кухонна лампа",
          "ko": "목제 주방 전등",
          "zh": "木制厨房灯",
          "ja": "Wooden Kitchen Lamp"
        },
        {
          "id": "Stockpile",
          "en": "STOCKPILE",
          "fr": "RÉSERVE",
          "es": "PILA DE ALMACENAMIENTO",
          "de": "LAGERBESTAND",
          "pt": "ESTOQUE EM PILHA",
          "it": "SCORTA",
          "tr": "STOCKPILE",
          "pl": "SKŁADOWISKO",
          "ru": "СКЛАД",
          "uk": "STOCKPILE",
          "ko": "STOCKPILE",
          "zh": "STOCKPILE",
          "ja": "STOCKPILE"
        },
        {
          "id": "StorageChest",
          "en": "STORAGE CHEST",
          "fr": "COFFRE",
          "es": "COFRE DE ALMACENAMIENTO",
          "de": "TRUHE",
          "pt": "BAÚ DE ARMAZENAMENTO",
          "it": "CASSAPANCA",
          "tr": "STORAGE CHEST",
          "pl": "SKRZYNIA",
          "ru": "СУНДУК",
          "uk": "STORAGE CHEST",
          "ko": "STORAGE CHEST",
          "zh": "储物箱",
          "ja": "STORAGE CHEST"
        },
        {
          "id": "ImmigrationDesk",
          "en": "Immigration Desk",
          "fr": "Bureau de l’immigration",
          "es": "Oficina de inmigración",
          "de": "Einwanderungsbehörde",
          "pt": "Mesa de imigração",
          "it": "Tavolo d\u0027immigrazione",
          "tr": "Immigration Desk",
          "pl": "Immigration Desk",
          "ru": "Иммиграционная служба",
          "uk": "Immigration Desk",
          "ko": "출입국관리 책상",
          "zh": "Immigration Desk",
          "ja": "Immigration Desk"
        },
        {
          "id": "TownFoundation",
          "en": "Town Foundation",
          "fr": "Fondation municipale",
          "es": "Fundación de un pueblo",
          "de": "Stadtgründung",
          "pt": "Fundação da cidade",
          "it": "Fondazione del villaggio",
          "tr": "Town Foundation",
          "pl": "Town Foundation",
          "ru": "Закладной камень города",
          "uk": "Town Foundation",
          "ko": "마을 설립",
          "zh": "Town Foundation",
          "ja": "Town Foundation"
        },
        {
          "id": "CountryFoundation",
          "en": "Country Foundation",
          "fr": "Fondation nationale",
          "es": "Fundación de un país",
          "de": "Landesgründung",
          "pt": "Fundação do país",
          "it": "Fondazione del Paese",
          "tr": "Country Foundation",
          "pl": "Country Foundation",
          "ru": "Закладной камень Страны",
          "uk": "Country Foundation",
          "ko": "나라 설립",
          "zh": "Country Foundation",
          "ja": "Country Foundation"
        },
        {
          "id": "FederationFoundation",
          "en": "Federation Foundation",
          "fr": "Fondation fédérale",
          "es": "Fundación de una federación",
          "de": "Föderationsgründung",
          "pt": "Fundação da Federação",
          "it": "Fondazione della federazione",
          "tr": "Federation Foundation",
          "pl": "Federation Foundation",
          "ru": "Закладной камень Федерации",
          "uk": "Federation Foundation",
          "ko": "연방 설립",
          "zh": "Federation Foundation",
          "ja": "Federation Foundation"
        },
        {
          "id": "CopperPlate",
          "en": "Copper Plate",
          "fr": "Plaque de cuivre",
          "es": "Placa de cobre",
          "de": "Kupferplatte",
          "pt": "Placa de Cobre",
          "it": "Piatto di rame",
          "tr": "Copper Plate",
          "pl": "Copper Plate",
          "ru": "Медная пластина",
          "uk": "Copper Plate",
          "ko": "구리판",
          "zh": "铜管",
          "ja": "銅板"
        },
        {
          "id": "CottonLint",
          "en": "Cotton Lint",
          "fr": "Bourre de coton",
          "es": "Hilacha de algodón",
          "de": "Baumwollflusen",
          "pt": "Fiapos de Algodão",
          "it": "Lanugine di cotone",
          "tr": "Cotton Lint",
          "pl": "Włókno bawełniane",
          "ru": "Хлопковое волокно",
          "uk": "Cotton Lint",
          "ko": "목화 보푸라기",
          "zh": "棉絮",
          "ja": "Cotton Lint"
        },
        {
          "id": "FlaxTrawlerNet",
          "en": "Flax Trawler Net",
          "fr": "Filet de chalutier en lin",
          "es": "Red de arrastre de lino",
          "de": "Flachs-Trawlernetz",
          "pt": "Rede de arrasto de linho",
          "it": "Rete di peschereccio in lino",
          "tr": "Flax Trawler Net",
          "pl": "Lniana sieć rybacka",
          "ru": "Льняная сеть Траулера",
          "uk": "Flax Trawler Net",
          "ko": "아마 저인망",
          "zh": "亚麻拖网",
          "ja": "亜麻のトロール網"
        },
        {
          "id": "GlassLens",
          "en": "Glass Lens",
          "fr": "Lentille en verre",
          "es": "Lente de vidrio",
          "de": "Glaslinse",
          "pt": "Lente de vidro",
          "it": "Lenti di vetro",
          "tr": "Glass Lens",
          "pl": "Glass Lens",
          "ru": "Стеклянная линза",
          "uk": "Glass Lens",
          "ko": "유리 렌즈",
          "zh": "玻璃",
          "ja": "Glass Lens"
        },
        {
          "id": "CourtChair",
          "en": "Court Chair",
          "fr": "Chaise du tribunal",
          "es": "Silla de tribunal",
          "de": "Gerichtsstuhl",
          "pt": "Cadeira de Tribunal",
          "it": "Sedia da tribunale",
          "tr": "Court Chair",
          "pl": "Court Chair",
          "ru": "Судебный стул",
          "uk": "Court Chair",
          "ko": "법정 의자",
          "zh": "Court Chair",
          "ja": "法廷の椅子"
        },
        {
          "id": "CourtTable",
          "en": "Court Table",
          "fr": "Table du tribunal",
          "es": "Mesa de tribunal",
          "de": "Gerichtstisch",
          "pt": "Mesa de Tribunal",
          "it": "Tavolo da tribunale",
          "tr": "Court Table",
          "pl": "Court Table",
          "ru": "Судебный стол",
          "uk": "Court Table",
          "ko": "법원 탁자",
          "zh": "法庭桌",
          "ja": "Court Table"
        },
        {
          "id": "EmbassyDesk",
          "en": "Embassy Desk",
          "fr": "Bureau de l\u0027ambassade",
          "es": "Oficina de embajada",
          "de": "Botschaftsbüro",
          "pt": "Escritório da Embaixada",
          "it": "Ufficio dell\u0027Ambasciata",
          "tr": "Embassy Desk",
          "pl": "Biurko ambasady",
          "ru": "Посольство",
          "uk": "Embassy Desk",
          "ko": "대사관 책상",
          "zh": "Embassy Desk",
          "ja": "Embassy Desk"
        },
        {
          "id": "GalaxyVase",
          "en": "Galaxy Vase",
          "fr": "Vase galaxie",
          "es": "Jarrón galáctico",
          "de": "Galaxie-Vase",
          "pt": "Vaso galáxia",
          "it": "Vaso con galassia",
          "tr": "Galaxy Vase",
          "pl": "Galaxy Vase",
          "ru": "Галактическая ваза",
          "uk": "Galaxy Vase",
          "ko": "은하수 화병",
          "zh": "Galaxy Vase",
          "ja": "Galaxy Vase"
        },
        {
          "id": "Glassworks",
          "en": "Glassworks",
          "fr": "Fourneau de verrerie",
          "es": "Materiales de vidrio",
          "de": "Glasfabrik",
          "pt": "Forno de vidro",
          "it": "Vetreria",
          "tr": "Glassworks",
          "pl": "Glassworks",
          "ru": "Стекольная мастерская",
          "uk": "Glassworks",
          "ko": "유리 제작용 가마",
          "zh": "Glassworks",
          "ja": "Glassworks"
        },
        {
          "id": "OrangeVase",
          "en": "Orange Vase",
          "fr": "Vase orange",
          "es": "Jarrón naranja",
          "de": "Orangefarbene Vase",
          "pt": "Vaso laranja",
          "it": "Vaso arancione",
          "tr": "Orange Vase",
          "pl": "Orange Vase",
          "ru": "Оранжевая ваза",
          "uk": "Orange Vase",
          "ko": "주황색 화병",
          "zh": "橙色花瓶",
          "ja": "Orange Vase"
        },
        {
          "id": "OutpostNetting",
          "en": "Outpost Netting",
          "fr": "Stockage d\u0027avant-poste",
          "es": "Redes de puesto avanzado",
          "de": "Außenpostennetz",
          "pt": "Rede de posto avançado",
          "it": "Rete dell\u0027avamposto",
          "tr": "Outpost Netting",
          "pl": "Outpost Netting",
          "ru": "Потолочная сетка",
          "uk": "Outpost Netting",
          "ko": "Outpost Netting",
          "zh": "Outpost Netting",
          "ja": "Outpost Netting"
        },
        {
          "id": "OutpostTable",
          "en": "Outpost Table",
          "fr": "Table de l\u0027avant-poste",
          "es": "Mesa de puesto avanzado",
          "de": "Außenposten Tisch",
          "pt": "Mesa de posto avançado",
          "it": "Tavolo dell\u0027avamposto",
          "tr": "Outpost Table",
          "pl": "Outpost Table",
          "ru": "Стол аванпоста",
          "uk": "Outpost Table",
          "ko": "출장소",
          "zh": "探险桌",
          "ja": "Outpost Table"
        },
        {
          "id": "PlantVase",
          "en": "Plant Vase",
          "fr": "Vase fleur",
          "es": "Jarrón para planta",
          "de": "Blumenvase",
          "pt": "Vaso de planta",
          "it": "Vaso con pianta decorata",
          "tr": "Plant Vase",
          "pl": "Plant Vase",
          "ru": "Ваза для растений",
          "uk": "Plant Vase",
          "ko": "초록빛 화병",
          "zh": "Plant Vase",
          "ja": "Plant Vase"
        },
        {
          "id": "PurpleVase",
          "en": "Purple Vase",
          "fr": "Vase violet",
          "es": "Jarrón púrpura",
          "de": "Lila Vase",
          "pt": "Vaso violeta",
          "it": "Vaso viola",
          "tr": "Purple Vase",
          "pl": "Purple Vase",
          "ru": "Фиолетовая ваза",
          "uk": "Purple Vase",
          "ko": "보라색 화병",
          "zh": "紫色花瓶",
          "ja": "Purple Vase"
        },
        {
          "id": "RedVase",
          "en": "Red Vase",
          "fr": "Vase rouge",
          "es": "Jarrón rojo",
          "de": "Rote Vase",
          "pt": "Vaso vermelho",
          "it": "Vaso rosso",
          "tr": "Red Vase",
          "pl": "Red Vase",
          "ru": "Красная ваза",
          "uk": "Red Vase",
          "ko": "빨간색 화병",
          "zh": "Red Vase",
          "ja": "Red Vase"
        },
        {
          "id": "SteelMooragePost",
          "en": "Steel Moorage Post",
          "fr": "Bollard en acier",
          "es": "Poste de amarre de acero",
          "de": "Stahl Ankerplatz",
          "pt": "Posto de Amarração de Aço",
          "it": "Palo d\u0027ormeggio d\u0027acciaio",
          "tr": "Steel Moorage Post",
          "pl": "Steel Moorage Post",
          "ru": "Стальной Причальный столб",
          "uk": "Steel Moorage Post",
          "ko": "강철 계선주",
          "zh": "Steel Moorage Post",
          "ja": "Steel Moorage Post"
        },
        {
          "id": "StenographersTable",
          "en": "Stenographers Table",
          "fr": "Table des sténographes",
          "es": "Mesa de taquígrafo",
          "de": "Stenographentisch",
          "pt": "Mesa de Estenógrafos",
          "it": "Tavolo degli stenografi",
          "tr": "Stenographers Table",
          "pl": "Stenographers Table",
          "ru": "Стол стенографиста",
          "uk": "Stenographers Table",
          "ko": "속기사의 책상",
          "zh": "速记员桌",
          "ja": "Stenographers Table"
        },
        {
          "id": "SwirlVase",
          "en": "Swirl Vase",
          "fr": "Vase tourbillonnant",
          "es": "Jarrón en espiral",
          "de": "Strudelvase",
          "pt": "Vaso em Espiral",
          "it": "Vaso a onde",
          "tr": "Swirl Vase",
          "pl": "Swirl Vase",
          "ru": "Вихревая ваза",
          "uk": "Swirl Vase",
          "ko": "소용돌이 화병",
          "zh": "Swirl Vase",
          "ja": "Swirl Vase"
        },
        {
          "id": "WoodenMooragePost",
          "en": "Wooden Moorage Post",
          "fr": "Bollard en bois",
          "es": "Poste de amarre de madera",
          "de": "Hölzerner Ankerplatz",
          "pt": "Posto de Amarração de Madeira",
          "it": "Palo d\u0027ormeggio in legno",
          "tr": "Wooden Moorage Post",
          "pl": "Wooden Moorage Post",
          "ru": "Деревянный Причальный столб",
          "uk": "Wooden Moorage Post",
          "ko": "목제 계선주",
          "zh": "木制停泊墩",
          "ja": "Wooden Moorage Post"
        },
        {
          "id": "HomesteadClaimStake",
          "en": "Homestead Claim Stake",
          "fr": "Piquet de revendication privée",
          "es": "Poste para reclamo de granja",
          "de": "Heimatstätten-Anspruchsanteil",
          "pt": "Estaca de reivindicação de fazenda",
          "it": "Paletto di rivendicazione della tenuta",
          "tr": "Homestead Claim Stake",
          "pl": "Homestead Claim Stake",
          "ru": "Колышек землемера Усадьбы",
          "uk": "Homestead Claim Stake",
          "ko": "집터 소유 말뚝",
          "zh": "家园领地木桩",
          "ja": "土地請求用の杭"
        },
        {
          "id": "MediumShipyard",
          "en": "Medium Shipyard",
          "fr": "Chantier naval de taille moyenne",
          "es": "Astillero mediano",
          "de": "Mittelgroße Werft",
          "pt": "Medium Shipyard",
          "it": "Cantiere navale medio",
          "tr": "Medium Shipyard",
          "pl": "Średnia Stocznia",
          "ru": "Средняя Верфь",
          "uk": "Середня корабельня",
          "ko": "중형 조선소",
          "zh": "中型船坞",
          "ja": "Medium Shipyard"
        },
        {
          "id": "LargeCourt",
          "en": "Large Court",
          "fr": "Grand tribunal",
          "es": "Large Court",
          "de": "Großes Gericht",
          "pt": "Large Court",
          "it": "Grande tribunale",
          "tr": "Large Court",
          "pl": "Duży Sąd",
          "ru": "Большой Суд",
          "uk": "Великий суд",
          "ko": "큰 법원",
          "zh": "Large Court",
          "ja": "Large Court"
        },
        {
          "id": "SmallCourt",
          "en": "Small Court",
          "fr": "Petit tribunal",
          "es": "Small Court",
          "de": "Kleines Gericht",
          "pt": "Small Court",
          "it": "Piccolo tribunale",
          "tr": "Small Court",
          "pl": "Small Court",
          "ru": "Маленький Суд",
          "uk": "Малий суд",
          "ko": "작은 법원",
          "zh": "Small Court",
          "ja": "Small Court"
        },
        {
          "id": "CarbideHelmetLamp",
          "en": "Carbide Helmet Lamp",
          "fr": "Casque en carbure avec lampe",
          "es": "Carbide Helmet Lamp",
          "de": "Hartmetall-Helmlampe",
          "pt": "Carbide Helmet Lamp",
          "it": "Lampada a carburo da casco",
          "tr": "Carbide Helmet Lamp",
          "pl": "Karbidowa lampka nahełmowa",
          "ru": "Карбидная лампа для шлема",
          "uk": "Карбідна шоломна лампа",
          "ko": "카바이드 안전등",
          "zh": "Carbide Helmet Lamp",
          "ja": "Carbide Helmet Lamp"
        },
        {
          "id": "OilHeadLamp",
          "en": "Oil Head Lamp",
          "fr": "Lampe à huile frontale",
          "es": "Oil Head Lamp",
          "de": "Öl-Kopfscheinwerfer",
          "pt": "Oil Head Lamp",
          "it": "Lampada a olio frontale",
          "tr": "Oil Head Lamp",
          "pl": "Olejowa lampka czołowa",
          "ru": "Масляная фара",
          "uk": "Масляна шоломна лампа",
          "ko": "등유 안전등",
          "zh": "油灯头盔",
          "ja": "Oil Head Lamp"
        },
        {
          "id": "Sandals",
          "en": "Sandals",
          "fr": "Sandales",
          "es": "Sandalias",
          "de": "Sandalen",
          "pt": "Sandals",
          "it": "Sandali",
          "tr": "Sandals",
          "pl": "Sandały",
          "ru": "Сандалии",
          "uk": "Сандалі",
          "ko": "샌들",
          "zh": "Sandals",
          "ja": "Sandals"
        },
        {
          "id": "ShipwrightHat",
          "en": "Shipwright Hat",
          "fr": "Ensemble de charpentier naval : Chapeau",
          "es": "Shipwright Hat",
          "de": "Schiffsbauer-Hut",
          "pt": "Shipwright Hat",
          "it": "Cappello da Carpentiere Navale",
          "tr": "Shipwright Hat",
          "pl": "Kapelusz Szkutnika",
          "ru": "Фуражка кораблестроителя",
          "uk": "Капелюх корабельника",
          "ko": "조선공의 모자",
          "zh": "船工帽",
          "ja": "船大工の帽子"
        },
        {
          "id": "ShipwrightSandals",
          "en": "Shipwright Sandals",
          "fr": "Ensemble de charpentier naval : Sandales",
          "es": "Shipwright Sandals",
          "de": "Schiffsbauer-Sandalen",
          "pt": "Shipwright Sandals",
          "it": "Sandali da Carpentiere Navale",
          "tr": "Shipwright Sandals",
          "pl": "Sandały Szkutnika",
          "ru": "Сандалии кораблестроителя",
          "uk": "Сандалі корабельника",
          "ko": "조선공의 샌들",
          "zh": "船工凉鞋",
          "ja": "船大工のサンダル"
        },
        {
          "id": "ShipwrightShirt",
          "en": "Shipwright Shirt",
          "fr": "Ensemble de charpentier naval : Chemise",
          "es": "Shipwright Shirt",
          "de": "Schiffsbauer-Oberteil",
          "pt": "Shipwright Shirt",
          "it": "Camicia da Carpentiere Navale",
          "tr": "Shipwright Shirt",
          "pl": "Koszula Szkutnika",
          "ru": "Тельняшка",
          "uk": "Сорочка корабельника",
          "ko": "조선공의 셔츠",
          "zh": "船工衬衫",
          "ja": "船大工のシャツ"
        },
        {
          "id": "SmithShirt",
          "en": "Smith Shirt",
          "fr": "Ensemble de forgeron : Chemise",
          "es": "Smith Shirt",
          "de": "Schmied-Oberteil",
          "pt": "Smith Shirt",
          "it": "Camicia da fabbro",
          "tr": "Smith Shirt",
          "pl": "Koszula Kowala",
          "ru": "Рубашка кузнеца",
          "uk": "Сорочка коваля",
          "ko": "대장장이 셔츠",
          "zh": "Smith Shirt",
          "ja": "Smith Shirt"
        },
        {
          "id": "ClaimTool",
          "en": "Claim Tool",
          "fr": "Outil de revendication",
          "es": "Herramienta de reclamo",
          "de": "Grundstückswerkzeug",
          "pt": "Claim Tool",
          "it": "Strumento di rivendicazione",
          "tr": "Claim Tool",
          "pl": "Claim Tool",
          "ru": "Инструмент землемера",
          "uk": "Інструмент подання претензій",
          "ko": "토지 소유 도구",
          "zh": "认领工具",
          "ja": "Claim Tool"
        },
        {
          "id": "HempMooringRope",
          "en": "Hemp Mooring Rope",
          "fr": "Corde d\u0027amarrage en chanvre",
          "es": "Hemp Mooring Rope",
          "de": "Hanftau",
          "pt": "Hemp Mooring Rope",
          "it": "Corda d\u0027ormeggio in canapa",
          "tr": "Hemp Mooring Rope",
          "pl": "Konopna cuma",
          "ru": "Конопляный причальный канат",
          "uk": "Конопляний швартовий трос",
          "ko": "삼베 계선 밧줄",
          "zh": "Hemp Mooring Rope",
          "ja": "Hemp Mooring Rope"
        },
        {
          "id": "IronAnchor",
          "en": "Iron Anchor",
          "fr": "Ancre en fer",
          "es": "Ancla de hierro",
          "de": "Eisenanker",
          "pt": "Iron Anchor",
          "it": "Ancora di ferro",
          "tr": "Iron Anchor",
          "pl": "Żelazna kotwica",
          "ru": "Железный якорь",
          "uk": "Залізний якір",
          "ko": "철제 닻",
          "zh": "Iron Anchor",
          "ja": "Iron Anchor"
        },
        {
          "id": "IronHullSheet",
          "en": "Iron Hull Sheet",
          "fr": "Coque en plaque de fer",
          "es": "Iron Hull Sheet",
          "de": "Eisenrumpfblech",
          "pt": "Iron Hull Sheet",
          "it": "Lamiera dello scafo in ferro",
          "tr": "Iron Hull Sheet",
          "pl": "Żelazna płyta poszycia",
          "ru": "Железные листы обшивки корпуса",
          "uk": "Залізний лист корпусу",
          "ko": "철제 선각",
          "zh": "Iron Hull Sheet",
          "ja": "Iron Hull Sheet"
        },
        {
          "id": "LargeMetalShipFrame",
          "en": "Large Metal Ship Frame",
          "fr": "Structure de bateau grande en acier",
          "es": "Large Metal Ship Frame",
          "de": "Großer Metallschiffsrahmen",
          "pt": "Large Metal Ship Frame",
          "it": "Grande telaio da nave in metallo",
          "tr": "Large Metal Ship Frame",
          "pl": "Duża metalowa rama statku",
          "ru": "Большой металлический каркас корабля",
          "uk": "Великий металевий каркас корабля",
          "ko": "대형 철제 늑골",
          "zh": "Large Metal Ship Frame",
          "ja": "Large Metal Ship Frame"
        },
        {
          "id": "LargeWoodenShipFrame",
          "en": "Large Wooden Ship Frame",
          "fr": "Structure de bateau grande en bois",
          "es": "Large Wooden Ship Frame",
          "de": "Großer Holzschiffsrahmen",
          "pt": "Large Wooden Ship Frame",
          "it": "Grande telaio da nave in legno",
          "tr": "Large Wooden Ship Frame",
          "pl": "Duża drewniana rama statku",
          "ru": "Большой деревянный каркас корабля",
          "uk": "Великий дерев\u0027яний каркас корабля",
          "ko": "대형 목제 늑골",
          "zh": "大型木船龙骨",
          "ja": "Large Wooden Ship Frame"
        },
        {
          "id": "MediumMetalShipFrame",
          "en": "Medium Metal Ship Frame",
          "fr": "Structure de bateau moyenne en fer",
          "es": "Medium Metal Ship Frame",
          "de": "Mittelgroßer Metallschiffsrahmen",
          "pt": "Medium Metal Ship Frame",
          "it": "Telaio medio da nave in metallo",
          "tr": "Medium Metal Ship Frame",
          "pl": "Średnia metalowa rama statku",
          "ru": "Средний металлический каркас корабля",
          "uk": "Середній металевий каркас корабля",
          "ko": "중형 철제 늑골",
          "zh": "Medium Metal Ship Frame",
          "ja": "Medium Metal Ship Frame"
        },
        {
          "id": "MediumWoodenShipFrame",
          "en": "Medium Wooden Ship Frame",
          "fr": "Structure de bateau moyenne en bois",
          "es": "Medium Wooden Ship Frame",
          "de": "Großer Holzschiffsrahmen",
          "pt": "Medium Wooden Ship Frame",
          "it": "Telaio medio da nave in legno",
          "tr": "Medium Wooden Ship Frame",
          "pl": "Średnia drewniana rama statku",
          "ru": "Средний деревянный каркас корабля",
          "uk": "Середній дерев\u0027яний каркас корабля",
          "ko": "중형 목제 늑골",
          "zh": "中型木船龙骨",
          "ja": "Medium Wooden Ship Frame"
        },
        {
          "id": "MetalKeel",
          "en": "Metal Keel",
          "fr": "Quille en fer",
          "es": "Quilla de metal",
          "de": "Metallkiel",
          "pt": "Metal Keel",
          "it": "Chiglia in metallo",
          "tr": "Metal Keel",
          "pl": "Metalowy kil",
          "ru": "Металлический киль",
          "uk": "Металевий кіль",
          "ko": "철제 용골",
          "zh": "Metal Keel",
          "ja": "Metal Keel"
        },
        {
          "id": "MetalRudder",
          "en": "Metal Rudder",
          "fr": "Gouvernail en fer",
          "es": "Timón de metal",
          "de": "Ruder aus Metall",
          "pt": "Metal Rudder",
          "it": "Timone in metallo",
          "tr": "Metal Rudder",
          "pl": "Metalowy ster",
          "ru": "Металлический руль",
          "uk": "Металеве стерно",
          "ko": "철제 방향키",
          "zh": "Metal Rudder",
          "ja": "Metal Rudder"
        },
        {
          "id": "NylonMooringRope",
          "en": "Nylon Mooring Rope",
          "fr": "Corde d\u0027amarrage en nylon",
          "es": "Nylon Mooring Rope",
          "de": "Nylontau",
          "pt": "Nylon Mooring Rope",
          "it": "Corda d\u0027ormeggio in nylon",
          "tr": "Nylon Mooring Rope",
          "pl": "Nylonowa cuma",
          "ru": "Нейлоновый причальный канат",
          "uk": "Нейлоновий швартовий трос",
          "ko": "나일론 계선 밧줄",
          "zh": "Nylon Mooring Rope",
          "ja": "Nylon Mooring Rope"
        },
        {
          "id": "SmallWoodenShipFrame",
          "en": "Small Wooden Ship Frame",
          "fr": "Structure de bateau petite en bois",
          "es": "Small Wooden Ship Frame",
          "de": "Kleiner Holzschiffsrahmen",
          "pt": "Small Wooden Ship Frame",
          "it": "Piccolo telaio da nave in legno",
          "tr": "Small Wooden Ship Frame",
          "pl": "Mała drewniana rama statku",
          "ru": "Маленький деревянный каркас корабля",
          "uk": "Малий дерев\u0027яний каркас корабля",
          "ko": "소형 목제 늑골",
          "zh": "小型木船龙骨",
          "ja": "Small Wooden Ship Frame"
        },
        {
          "id": "WoodenHullPlanks",
          "en": "Wooden Hull Planks",
          "fr": "Coque en bois",
          "es": "Wooden Hull Planks",
          "de": "Holzrumpfplanken",
          "pt": "Wooden Hull Planks",
          "it": "Assi dello scafo in legna",
          "tr": "Wooden Hull Planks",
          "pl": "Drewniane klepki poszycia",
          "ru": "Деревянные доски обшивки корпуса",
          "uk": "Дерев\u0027яні дошки корпусу",
          "ko": "목제 선각",
          "zh": "船身木板",
          "ja": "Wooden Hull Planks"
        },
        {
          "id": "WoodenKeel",
          "en": "Wooden Keel",
          "fr": "Quille en bois",
          "es": "Quilla de madera",
          "de": "Holzkiel",
          "pt": "Wooden Keel",
          "it": "Chiglia in legno",
          "tr": "Wooden Keel",
          "pl": "Drewniany kil",
          "ru": "Деревянный Киль",
          "uk": "Дерев’яний кіль",
          "ko": "목제 용골",
          "zh": "木制龙骨",
          "ja": "Wooden Keel"
        },
        {
          "id": "WoodenOar",
          "en": "Wooden Oar",
          "fr": "Rame en bois",
          "es": "Wooden Oar",
          "de": "Holzruder",
          "pt": "Wooden Oar",
          "it": "Remo in legno",
          "tr": "Wooden Oar",
          "pl": "Drewniane wiosło",
          "ru": "Деревянное весло",
          "uk": "Дерев’яне весло",
          "ko": "목제 노",
          "zh": "木桨",
          "ja": "Wooden Oar"
        },
        {
          "id": "WoodenRudder",
          "en": "Wooden Rudder",
          "fr": "Gouvernail en bois",
          "es": "Timón de madera",
          "de": "Holzruder",
          "pt": "Wooden Rudder",
          "it": "Timone in legno",
          "tr": "Wooden Rudder",
          "pl": "Drewniany ster",
          "ru": "Деревянный руль",
          "uk": "Дерев’яне стерно",
          "ko": "목제 방향키",
          "zh": "木制尾舵",
          "ja": "Wooden Rudder"
        },
        {
          "id": "ShipwrightAdvancedUpgrade",
          "en": "Shipwright Advanced Upgrade",
          "fr": "Amélioration avancée : Construction navale",
          "es": "Shipwright Advanced Upgrade",
          "de": "Fortgeschrittenes Werft-Upgrade",
          "pt": "Shipwright Advanced Upgrade",
          "it": "Aggiornamento avanzato del carpentiere navale",
          "tr": "Shipwright Advanced Upgrade",
          "pl": "Zaawansowane ulepszenie Szkutnictwa",
          "ru": "Продвинутое улучшение для кораблестроения",
          "uk": "Просунуте покращення корабельництва",
          "ko": "고급 조선 업그레이드",
          "zh": "造船高级升级",
          "ja": "船大工の応用アップグレード"
        },
        {
          "id": "ShipwrightBasicUpgrade",
          "en": "Shipwright Basic Upgrade",
          "fr": "Amélioration basique : Construction navale",
          "es": "Shipwright Basic Upgrade",
          "de": "Grundlegendes Werft-Upgrade",
          "pt": "Shipwright Basic Upgrade",
          "it": "Aggiornamento di base del carpentiere navale",
          "tr": "Shipwright Basic Upgrade",
          "pl": "Podstawowe ulepszenie Szkutnictwa",
          "ru": "Базовое улучшение для кораблестроения",
          "uk": "Базове покращення корабельництва",
          "ko": "기초 조선 업그레이드",
          "zh": "造船基础升级",
          "ja": "船大工の基礎アップグレード"
        },
        {
          "id": "HandheldCamera",
          "en": "Handheld Camera",
          "fr": "Appareil photo de poche",
          "es": "Handheld Camera",
          "de": "Handkamera",
          "pt": "Handheld Camera",
          "it": "Fotocamera portatile",
          "tr": "Handheld Camera",
          "pl": "Handheld Camera",
          "ru": "Портативная камера",
          "uk": "Ручна камера",
          "ko": "휴대용 카메라",
          "zh": "手持相机",
          "ja": "Handheld Camera"
        },
        {
          "id": "IronRoadTool",
          "en": "Iron Road Tool",
          "fr": "Outil de route en fer",
          "es": "Iron Road Tool",
          "de": "Eisen-Straßenwerkzeug",
          "pt": "Iron Road Tool",
          "it": "Strumento stradale in ferro",
          "tr": "Iron Road Tool",
          "pl": "Iron Road Tool",
          "ru": "Железная трамбовка",
          "uk": "Залізний дорожній інструмент",
          "ko": "철제 도로정비 도구",
          "zh": "Iron Road Tool",
          "ja": "Iron Road Tool"
        },
        {
          "id": "TripodCamera",
          "en": "Tripod Camera",
          "fr": "Appareil photo à trépied",
          "es": "Tripod Camera",
          "de": "Stativ-Kamera",
          "pt": "Tripod Camera",
          "it": "Telecamera treppiede",
          "tr": "Tripod Camera",
          "pl": "Tripod Camera",
          "ru": "Камера на штативе",
          "uk": "Камера на штативі",
          "ko": "삼각대 카메라",
          "zh": "三脚架相机",
          "ja": "Tripod Camera"
        },
        {
          "id": "IndustrialBarge",
          "en": "Industrial Barge",
          "fr": "Bac industriel",
          "es": "Industrial Barge",
          "de": "Industriekahn",
          "pt": "Industrial Barge",
          "it": "Chiatta industriale",
          "tr": "Industrial Barge",
          "pl": "Industrial Barge",
          "ru": "Промышленная Баржа",
          "uk": "Промислова баржа",
          "ko": "공업용 바지선",
          "zh": "Industrial Barge",
          "ja": "Industrial Barge"
        },
        {
          "id": "LargeCanoe",
          "en": "Large Canoe",
          "fr": "Grand canoë",
          "es": "Large Canoe",
          "de": "Großes Kanu",
          "pt": "Large Canoe",
          "it": "Canoa grande",
          "tr": "Large Canoe",
          "pl": "Duży kajak",
          "ru": "Большое Каноэ",
          "uk": "Велике каное",
          "ko": "대형 카누",
          "zh": "Large Canoe",
          "ja": "Large Canoe"
        },
        {
          "id": "MediumFishingTrawler",
          "en": "Medium Fishing Trawler",
          "fr": "Chalutier de pêche de taille moyenne",
          "es": "Medium Fishing Trawler",
          "de": "Mittelgroßer Schleppnetzfischer",
          "pt": "Medium Fishing Trawler",
          "it": "Peschereccio medio",
          "tr": "Medium Fishing Trawler",
          "pl": "Średni kuter rybacki",
          "ru": "Средний рыболовный траулер",
          "uk": "Середній рибальський траулер",
          "ko": "중형 저인망 어선",
          "zh": "Medium Fishing Trawler",
          "ja": "Medium Fishing Trawler"
        },
        {
          "id": "SmallCanoe",
          "en": "Small Canoe",
          "fr": "Petit canoë",
          "es": "Small Canoe",
          "de": "Kleines Kanu",
          "pt": "Small Canoe",
          "it": "Canoa piccola",
          "tr": "Small Canoe",
          "pl": "Small Canoe",
          "ru": "Маленькое Каноэ",
          "uk": "Мале каное",
          "ko": "소형 카누",
          "zh": "小独木舟",
          "ja": "小さなカヌー"
        },
        {
          "id": "WoodenTransportShip",
          "en": "Wooden Transport Ship",
          "fr": "Bateau de transport en bois",
          "es": "Wooden Transport Ship",
          "de": "Holztransportschiff",
          "pt": "Wooden Transport Ship",
          "it": "Nave da trasporto in legno",
          "tr": "Wooden Transport Ship",
          "pl": "Drewniany statek transportowy",
          "ru": "Деревянный Транспортный Корабль",
          "uk": "Дерев\u0027яний транспортний корабель",
          "ko": "목제 수송선",
          "zh": "木制运输船",
          "ja": "Wooden Transport Ship"
        },
        {
          "id": "CopperFrameWide",
          "en": "Copper Frame Wide",
          "fr": "Cadre grand paysage en cuivre",
          "es": "Copper Frame Wide",
          "de": "Kupferrahmen: Breit",
          "pt": "Copper Frame Wide",
          "it": "Cornice ampia in rame",
          "tr": "Copper Frame Wide",
          "pl": "Copper Frame Wide",
          "ru": "Широкая медная рамка",
          "uk": "Широка мідна рамка",
          "ko": "동테 넓은 액자",
          "zh": "Copper Frame Wide",
          "ja": "Copper Frame Wide"
        },
        {
          "id": "CottonStreamerStars",
          "en": "Cotton Streamer Stars",
          "fr": "Banderole étoilée en coton",
          "es": "Cotton Streamer Stars",
          "de": "Cotton Streamer Stars",
          "pt": "Cotton Streamer Stars",
          "it": "Stelle filanti di cotone",
          "tr": "Cotton Streamer Stars",
          "pl": "Cotton Streamer Stars",
          "ru": "Хлопковая лента флажков со звездами",
          "uk": "Зоряний бавовняний банер",
          "ko": "별이 그려진 면직물 현수막",
          "zh": "Cotton Streamer Stars",
          "ja": "Cotton Streamer Stars"
        },
        {
          "id": "CottonStreamerStripes",
          "en": "Cotton Streamer Stripes",
          "fr": "Banderole à rayures en coton",
          "es": "Cotton Streamer Stripes",
          "de": "Cotton Streamer Stripes",
          "pt": "Cotton Streamer Stripes",
          "it": "Strisce filanti di cotone",
          "tr": "Cotton Streamer Stripes",
          "pl": "Cotton Streamer Stripes",
          "ru": "Хлопковая лента флажков с полосками",
          "uk": "Смугастий бавовняний банер",
          "ko": "줄이 그려진 면직물 현수막",
          "zh": "Cotton Streamer Stripes",
          "ja": "Cotton Streamer Stripes"
        },
        {
          "id": "DecorativeAnchor",
          "en": "Decorative Anchor",
          "fr": "Ancre décorative",
          "es": "Decorative Anchor",
          "de": "Dekorativer Anker",
          "pt": "Decorative Anchor",
          "it": "Ancora decorativa",
          "tr": "Decorative Anchor",
          "pl": "Decorative Anchor",
          "ru": "Декоративный якорь",
          "uk": "Декоративний якір",
          "ko": "장식용 닻",
          "zh": "Decorative Anchor",
          "ja": "Decorative Anchor"
        },
        {
          "id": "DecorativeGlassBuoyBlue",
          "en": "Decorative Glass Buoy Blue",
          "fr": "Flotteur décoratif en verre bleu",
          "es": "Boya azul decorativa de cristal",
          "de": "Dekorative blaue Glasboje",
          "pt": "Decorative Glass Buoy Blue",
          "it": "Boa di vetro decorativa blu",
          "tr": "Decorative Glass Buoy Blue",
          "pl": "Decorative Glass Buoy Blue",
          "ru": "Декоративный стеклянный синий буй",
          "uk": "Декоративний скляний синій буй",
          "ko": "장식용 파란색 유리 부표",
          "zh": "Decorative Glass Buoy Blue",
          "ja": "Decorative Glass Buoy Blue"
        },
        {
          "id": "DecorativeHangingBuoy",
          "en": "Decorative Hanging Buoy",
          "fr": "Flotteurs décoratifs suspendus",
          "es": "Boya colgante decorativa",
          "de": "Dekorative Hängeboje",
          "pt": "Decorative Hanging Buoy",
          "it": "Boa decorativa appesa",
          "tr": "Decorative Hanging Buoy",
          "pl": "Decorative Hanging Buoy",
          "ru": "Декоративный подвесной буй",
          "uk": "Декоративний підвісний буй",
          "ko": "장식용 내건 부표",
          "zh": "Decorative Hanging Buoy",
          "ja": "Decorative Hanging Buoy"
        },
        {
          "id": "DecorativeLifePreserver",
          "en": "Decorative Life Preserver",
          "fr": "Bouée de sauvetage décorative",
          "es": "Decorative Life Preserver",
          "de": "Dekorativer Lebensretter",
          "pt": "Decorative Life Preserver",
          "it": "Salvagente decorativo",
          "tr": "Decorative Life Preserver",
          "pl": "Decorative Life Preserver",
          "ru": "Декоративный спасательный круг",
          "uk": "Декоративний рятувальний круг",
          "ko": "장식용 구명 튜브",
          "zh": "Decorative Life Preserver",
          "ja": "Decorative Life Preserver"
        },
        {
          "id": "DecorativeShipWheel",
          "en": "Decorative Ship Wheel",
          "fr": "Barre de bateau décorative",
          "es": "Decorative Ship Wheel",
          "de": "Dekoratives Steuerrad",
          "pt": "Decorative Ship Wheel",
          "it": "Timone decorativo",
          "tr": "Decorative Ship Wheel",
          "pl": "Decorative Ship Wheel",
          "ru": "Декоративный штурвал",
          "uk": "Декоративний штурвал",
          "ko": "장식용 조타기",
          "zh": "Decorative Ship Wheel",
          "ja": "Decorative Ship Wheel"
        },
        {
          "id": "FishRack",
          "en": "Fish Rack",
          "fr": "Séchoir à poissons",
          "es": "Fish Rack",
          "de": "Fischregal",
          "pt": "Fish Rack",
          "it": "Scaffale per pesci",
          "tr": "Fish Rack",
          "pl": "Fish Rack",
          "ru": "Стойка для рыбы",
          "uk": "Рибна стійка",
          "ko": "건조용 생선 걸개",
          "zh": "Fish Rack",
          "ja": "Fish Rack"
        },
        {
          "id": "GoldFrameWide",
          "en": "Gold Frame Wide",
          "fr": "Cadre grand paysage en or",
          "es": "Gold Frame Wide",
          "de": "Goldrahmen: Breit",
          "pt": "Gold Frame Wide",
          "it": "Cornice ampia d\u0027oro",
          "tr": "Gold Frame Wide",
          "pl": "Gold Frame Wide",
          "ru": "Широкая золотая рамка",
          "uk": "Широка золота рамка",
          "ko": "금테 넓은 액자",
          "zh": "Gold Frame Wide",
          "ja": "Gold Frame Wide"
        },
        {
          "id": "IronFrameWide",
          "en": "Iron Frame Wide",
          "fr": "Cadre grand paysage en fer",
          "es": "Iron Frame Wide",
          "de": "Eisenrahmen: Breit",
          "pt": "Iron Frame Wide",
          "it": "Cornice ampia in ferro",
          "tr": "Iron Frame Wide",
          "pl": "Iron Frame Wide",
          "ru": "Широкая железная рамка",
          "uk": "Широка залізна рамка",
          "ko": "철테 넓은 액자",
          "zh": "Iron Frame Wide",
          "ja": "Iron Frame Wide"
        },
        {
          "id": "LargeCottonBuntingRed",
          "en": "Large Cotton Bunting Red",
          "fr": "Grande guirlande rouge en coton",
          "es": "Large Cotton Bunting Red",
          "de": "Große rote Baumwoll-Wimpelkette",
          "pt": "Large Cotton Bunting Red",
          "it": "Bandierina rossa in cotone grande",
          "tr": "Large Cotton Bunting Red",
          "pl": "Duża czerwona girlanda z bawełny",
          "ru": "Большой хлопковый красный флаг",
          "uk": "Великий червоний прапор з бавовни",
          "ko": "대형 빨간색 면직물 깃발",
          "zh": "Large Cotton Bunting Red",
          "ja": "Large Cotton Bunting Red"
        },
        {
          "id": "LargeFestivePaperLantern",
          "en": "Large Festive Paper Lantern",
          "fr": "Grande lanterne festive en papier",
          "es": "Large Festive Paper Lantern",
          "de": "Große festliche Papierlaterne",
          "pt": "Large Festive Paper Lantern",
          "it": "Grande lanterna di carta festiva",
          "tr": "Large Festive Paper Lantern",
          "pl": "Duży świąteczny lampion z papieru",
          "ru": "Большой праздничный бумажный фонарь",
          "uk": "Великий святковий паперовий ліхтарик",
          "ko": "대형 축제용 종이 제등",
          "zh": "Large Festive Paper Lantern",
          "ja": "Large Festive Paper Lantern"
        },
        {
          "id": "LargeNylonBuntingGreen",
          "en": "Large Nylon Bunting Green",
          "fr": "Grande guirlande verte en nylon",
          "es": "Large Nylon Bunting Green",
          "de": "Große grüne Nylon-Wimpelkette",
          "pt": "Large Nylon Bunting Green",
          "it": "Grande bandierina verde in nylon",
          "tr": "Large Nylon Bunting Green",
          "pl": "Duża nylonowa girlanda w kolorze zielonym",
          "ru": "Большой нейлоновый зеленый флаг",
          "uk": "Великий зелений прапор з нейлону",
          "ko": "대형 연두색 나일론 깃발",
          "zh": "Large Nylon Bunting Green",
          "ja": "Large Nylon Bunting Green"
        },
        {
          "id": "LargePaperLantern",
          "en": "Large Paper Lantern",
          "fr": "Grande lanterne en papier",
          "es": "Large Paper Lantern",
          "de": "Großer Papierlaterne",
          "pt": "Large Paper Lantern",
          "it": "Grande lanterna di carta",
          "tr": "Large Paper Lantern",
          "pl": "Duży lampion z papieru",
          "ru": "Большой бумажный фонарь",
          "uk": "Великий паперовий ліхтар",
          "ko": "대형 종이 제등",
          "zh": "Large Paper Lantern",
          "ja": "Large Paper Lantern"
        },
        {
          "id": "OrnateGoldFrameWide",
          "en": "Ornate Gold Frame Wide",
          "fr": "Cadre grand paysage orné en or",
          "es": "Ornate Gold Frame Wide",
          "de": "Kunstvoller Goldrahmen: Breit",
          "pt": "Ornate Gold Frame Wide",
          "it": "Cornice ampia ornata in oro",
          "tr": "Ornate Gold Frame Wide",
          "pl": "Ornate Gold Frame Wide",
          "ru": "Изящная золотая широкая рамка",
          "uk": "Широка оздоблена золота рамка",
          "ko": "장식된 금테 넓은 액자",
          "zh": "Ornate Gold Frame Wide",
          "ja": "Ornate Gold Frame Wide"
        },
        {
          "id": "OrnateIronFrameWide",
          "en": "Ornate Iron Frame Wide",
          "fr": "Cadre grand paysage orné en fer",
          "es": "Ornate Iron Frame Wide",
          "de": "Kunstvoller Eisenrahmen: Breit",
          "pt": "Ornate Iron Frame Wide",
          "it": "Cornice ampia ornata in ferro",
          "tr": "Ornate Iron Frame Wide",
          "pl": "Ornate Iron Frame Wide",
          "ru": "Изящная железная широкая рамка",
          "uk": "Широка оздоблена залізна рамка",
          "ko": "장식된 철테 넓은 액자",
          "zh": "Ornate Iron Frame Wide",
          "ja": "Ornate Iron Frame Wide"
        },
        {
          "id": "OrnateWoodenFrameWide",
          "en": "Ornate Wooden Frame Wide",
          "fr": "Cadre grand paysage orné en bois",
          "es": "Ornate Wooden Frame Wide",
          "de": "Kunstvoller Holzrahmen: Breit",
          "pt": "Ornate Wooden Frame Wide",
          "it": "Cornice ampia ornata in legno",
          "tr": "Ornate Wooden Frame Wide",
          "pl": "Ornate Wooden Frame Wide",
          "ru": "Изящная деревянная широкая рамка",
          "uk": "Ornate Wooden Frame Wide",
          "ko": "장식된 원목 넓은 액자",
          "zh": "横向华丽木框",
          "ja": "Ornate Wooden Frame Wide"
        },
        {
          "id": "PlasticBuoy",
          "en": "Plastic Buoy",
          "fr": "Balise en plastique",
          "es": "Boya de plástico",
          "de": "Boje aus Plastik",
          "pt": "Plastic Buoy",
          "it": "Boa di plastica",
          "tr": "Plastic Buoy",
          "pl": "Plastic Buoy",
          "ru": "Пластиковый буй",
          "uk": "Пластиковий буй",
          "ko": "플라스틱 부표",
          "zh": "Plastic Buoy",
          "ja": "Plastic Buoy"
        },
        {
          "id": "SmallCottonBuntingRed",
          "en": "Small Cotton Bunting Red",
          "fr": "Petite guirlande rouge en coton",
          "es": "Banderín rojo pequeño de algodón",
          "de": "Kleine rote Baumwoll-Wimpelkette",
          "pt": "Small Cotton Bunting Red",
          "it": "Bandierina rossa in cotone piccola",
          "tr": "Small Cotton Bunting Red",
          "pl": "Mała czerwona girlanda z bawełny",
          "ru": "Маленький хлопковый красный флаг",
          "uk": "Small Cotton Bunting Red",
          "ko": "소형 빨간색 면직물 깃발",
          "zh": "Small Cotton Bunting Red",
          "ja": "Small Cotton Bunting Red"
        },
        {
          "id": "SmallNylonBuntingGreen",
          "en": "Small Nylon Bunting Green",
          "fr": "Petite guirlande verte en nylon",
          "es": "Small Nylon Bunting Green",
          "de": "Kleine grüne Nylon-Wimpelkette",
          "pt": "Small Nylon Bunting Green",
          "it": "Piccola bandierina verde in nylon",
          "tr": "Small Nylon Bunting Green",
          "pl": "Mała nylonowa girlanda w kolorze zielonym",
          "ru": "Маленький нейлоновый зеленый флаг",
          "uk": "Small Nylon Bunting Green",
          "ko": "소형 연두색 나일론 깃발",
          "zh": "Small Nylon Bunting Green",
          "ja": "Small Nylon Bunting Green"
        },
        {
          "id": "SmallPaperLantern",
          "en": "Small Paper Lantern",
          "fr": "Petite lanterne en papier",
          "es": "Small Paper Lantern",
          "de": "Kleine Papierlaterne",
          "pt": "Small Paper Lantern",
          "it": "Piccola lanterna di carta",
          "tr": "Small Paper Lantern",
          "pl": "Mały lampion z papieru",
          "ru": "Маленький бумажный фонарь",
          "uk": "Малий паперовий ліхтар",
          "ko": "소형 종이 제등",
          "zh": "Small Paper Lantern",
          "ja": "Small Paper Lantern"
        },
        {
          "id": "SmallPaperMachine",
          "en": "Small Paper Machine",
          "fr": "Petite machine à papier",
          "es": "Small Paper Machine",
          "de": "Kleine Papiermaschine",
          "pt": "Small Paper Machine",
          "it": "Piccola macchina per la carta",
          "tr": "Small Paper Machine",
          "pl": "Mała maszyna do papieru",
          "ru": "Маленькая бумагоделательная машина",
          "uk": "Small Paper Machine",
          "ko": "소형 제지 기계",
          "zh": "Small Paper Machine",
          "ja": "Small Paper Machine"
        },
        {
          "id": "SmallShipyard",
          "en": "Small Shipyard",
          "fr": "Petit chantier naval",
          "es": "Astillero pequeño",
          "de": "Kleine Werft",
          "pt": "Small Shipyard",
          "it": "Piccolo cantiere",
          "tr": "Small Shipyard",
          "pl": "Mała stocznia",
          "ru": "Маленькая верфь",
          "uk": "Мала корабельня",
          "ko": "소형 조선소",
          "zh": "小型船坞",
          "ja": "Small Shipyard"
        },
        {
          "id": "SteelBuoy",
          "en": "Steel Buoy",
          "fr": "Balise en acier",
          "es": "Boya de acero",
          "de": "Stahlboje",
          "pt": "Steel Buoy",
          "it": "Boa d\u0027acciaio",
          "tr": "Steel Buoy",
          "pl": "Stalowa boja",
          "ru": "Стальной буй",
          "uk": "Сталевий буй",
          "ko": "강철 부표",
          "zh": "Steel Buoy",
          "ja": "Steel Buoy"
        },
        {
          "id": "WoodenFrameWide",
          "en": "Wooden Frame Wide",
          "fr": "Cadre grand paysage en bois",
          "es": "Wooden Frame Wide",
          "de": "Holzrahmen: Breit",
          "pt": "Wooden Frame Wide",
          "it": "Cornice ampia in legno",
          "tr": "Wooden Frame Wide",
          "pl": "Wooden Frame Wide",
          "ru": "Широкая деревянная рамка",
          "uk": "Широка дерев\u0027яна рамка",
          "ko": "원목 넓은 액자",
          "zh": "横向木框",
          "ja": "Wooden Frame Wide"
        },
        {
          "id": "WeaveSmallCottonBuntingRed",
          "en": "Weave Small Cotton Bunting Red",
          "fr": "Tisser une petite guirlande rouge en coton",
          "es": "Weave Small Cotton Bunting Red",
          "de": "Kleine rote Baumwoll-Wimpelkette weben",
          "pt": "Weave Small Cotton Bunting Red",
          "it": "Intreccia bandierina rossa piccola in cotone",
          "tr": "Weave Small Cotton Bunting Red",
          "pl": "Utkaj małą czerwoną girlandę z bawełny",
          "ru": "Соткать Маленький красный флаг из хлопка",
          "uk": "Weave Small Cotton Bunting Red",
          "ko": "소형 빨간색 면직물 깃발 짜기",
          "zh": "Weave Small Cotton Bunting Red",
          "ja": "Weave Small Cotton Bunting Red"
        },
        {
          "id": "WeaveLargeCottonBuntingRed",
          "en": "Weave Large Cotton Bunting Red",
          "fr": "Tisser une grande guirlande rouge en coton",
          "es": "Weave Large Cotton Bunting Red",
          "de": "Große rote Baumwoll-Wimpelkette weben",
          "pt": "Weave Large Cotton Bunting Red",
          "it": "Intreccia bandierina rossa grande in cotone",
          "tr": "Weave Large Cotton Bunting Red",
          "pl": "Utkaj dużą czerwoną girlandę z bawełny",
          "ru": "Соткать Большой хлопковый красный флаг",
          "uk": "Weave Large Cotton Bunting Red",
          "ko": "대형 빨간색 면직물 깃발 짜기",
          "zh": "Weave Large Cotton Bunting Red",
          "ja": "Weave Large Cotton Bunting Red"
        },
        {
          "id": "RecycleHewnLog",
          "en": "Recycle Hewn Log",
          "fr": "Recyclage de rondins taillés",
          "es": "Recycle Hewn Log",
          "de": "Massivholz wiederverwerten",
          "pt": "Recycle Hewn Log",
          "it": "Ricicla legno scolpito",
          "tr": "Recycle Hewn Log",
          "pl": "Recycle Hewn Log",
          "ru": "Переработать тёсаные бревна",
          "uk": "Recycle Hewn Log",
          "ko": "Recycle Hewn Log",
          "zh": "回收原木",
          "ja": "リサイクルした丸太材"
        },
        {
          "id": "ParticleBoards",
          "en": "Particle Boards",
          "fr": "Planches agglomérées",
          "es": "Particle Boards",
          "de": "Spanplatten",
          "pt": "Particle Boards",
          "it": "Pannelli di truciolato",
          "tr": "Particle Boards",
          "pl": "Particle Boards",
          "ru": "Доски из опилок",
          "uk": "Particle Boards",
          "ko": "Particle Boards",
          "zh": "Particle Boards",
          "ja": "合板"
        },
        {
          "id": "CameraFilm",
          "en": "Camera Film",
          "fr": "Pellicule",
          "es": "Camera Film",
          "de": "Kamera-Film",
          "pt": "Camera Film",
          "it": "Rullino della videocamera",
          "tr": "Camera Film",
          "pl": "Klisza do aparatu",
          "ru": "Пленка камеры",
          "uk": "Camera Film",
          "ko": "카메라 필름",
          "zh": "Camera Film",
          "ja": "Camera Film"
        },
        {
          "id": "FlaxseedOil",
          "en": "Flaxseed Oil",
          "fr": "Huile de lin",
          "es": "Flaxseed Oil",
          "de": "Flaxseed Oil",
          "pt": "Flaxseed Oil",
          "it": "Olio di semi di lino",
          "tr": "Flaxseed Oil",
          "pl": "Olej z siemienia lnianego",
          "ru": "Льняное масло",
          "uk": "Flaxseed Oil",
          "ko": "아마씨유",
          "zh": "亚麻籽油",
          "ja": "フラックスオイル"
        },
        {
          "id": "ArtSupplies",
          "en": "Art Supplies",
          "fr": "Nécessaire d\u0027art",
          "es": "Art Supplies",
          "de": "Art Supplies",
          "pt": "Art Supplies",
          "it": "Materiali Artistici",
          "tr": "Art Supplies",
          "pl": "Przybory do sztuki",
          "ru": "Набор художника",
          "uk": "Art Supplies",
          "ko": "미술 용품",
          "zh": "美术用具",
          "ja": "Art Supplies"
        },
        {
          "id": "ColoredPowder",
          "en": "Colored Powder",
          "fr": "Poudre colorée",
          "es": "Polvo coloreado",
          "de": "Farbiges Puder",
          "pt": "Colored Powder",
          "it": "Polvere colorata",
          "tr": "Colored Powder",
          "pl": "Colored Powder",
          "ru": "Цветной порошок",
          "uk": "Colored Powder",
          "ko": "가루 안료",
          "zh": "彩色粉末",
          "ja": "Colored Powder"
        },
        {
          "id": "NylonTrawlerNet",
          "en": "Nylon Trawler Net",
          "fr": "Filet de chalutier en nylon",
          "es": "Nylon Trawler Net",
          "de": "Nylon Trawler Net",
          "pt": "Nylon Trawler Net",
          "it": "Rete da peschereccio in nylon",
          "tr": "Nylon Trawler Net",
          "pl": "Nylonowa sieć rybacka",
          "ru": "Нейлоновая сеть Траулера",
          "uk": "Nylon Trawler Net",
          "ko": "나일론 저인망",
          "zh": "Nylon Trawler Net",
          "ja": "Nylon Trawler Net"
        },
        {
          "id": "OilPaint",
          "en": "Oil Paint",
          "fr": "Peinture à l\u0027huile",
          "es": "Oil Paint",
          "de": "Ölfarbe",
          "pt": "Oil Paint",
          "it": "Dipinto a olio",
          "tr": "Oil Paint",
          "pl": "Farba olejna",
          "ru": "Масляная краска",
          "uk": "Oil Paint",
          "ko": "유성 페인트",
          "zh": "油画颜料",
          "ja": "Oil Paint"
        },
        {
          "id": "GatheringBasicUpgrade",
          "en": "Gathering Basic Upgrade",
          "fr": "Amélioration basique : Récolte",
          "es": "Gathering Basic Upgrade",
          "de": "Gathering Basic Upgrade",
          "pt": "Gathering Basic Upgrade",
          "it": "Aggiornamento Base Raccolta",
          "tr": "Gathering Basic Upgrade",
          "pl": "Gathering Basic Upgrade",
          "ru": "Базовое улучшение для собирательства",
          "uk": "Gathering Basic Upgrade",
          "ko": "기초 채집 업그레이드",
          "zh": "采集基础升级",
          "ja": "Gathering Basic Upgrade"
        },
        {
          "id": "IndustrialGenerator",
          "en": "Industrial Generator",
          "fr": "Générateur électrique industriel",
          "es": "Generador industrial",
          "de": "Industrial Generator",
          "pt": "Industrial Generator",
          "it": "Generatore industriale",
          "tr": "Industrial Generator",
          "pl": "Industrial Generator",
          "ru": "Промышленный генератор",
          "uk": "Industrial Generator",
          "ko": "공업용 발전기",
          "zh": "Industrial Generator",
          "ja": "Industrial Generator"
        },
        {
          "id": "WeaveLinenFabric",
          "en": "Weave Linen Fabric",
          "fr": "Tissu en lin à tisser",
          "es": "Weave Linen Fabric",
          "de": "Weave Linen Fabric",
          "pt": "Weave Linen Fabric",
          "it": "Intreccia tessuto di lino",
          "tr": "Weave Linen Fabric",
          "pl": "Weave Linen Fabric",
          "ru": "Ткать Льняную Ткань",
          "uk": "Weave Linen Fabric",
          "ko": "아마 포 짜기",
          "zh": "Weave Linen Fabric",
          "ja": "Weave Linen Fabric"
        },
        {
          "id": "WeaveLinenCanvas",
          "en": "Weave Linen Canvas",
          "fr": "Tisser une toile en lin",
          "es": "Weave Linen Canvas",
          "de": "Weave Linen Canvas",
          "pt": "Weave Linen Canvas",
          "it": "Intreccia tele di lino",
          "tr": "Weave Linen Canvas",
          "pl": "Weave Linen Canvas",
          "ru": "Ткать льняной холст",
          "uk": "Weave Linen Canvas",
          "ko": "아마 캔버스 짜기",
          "zh": "Weave Linen Canvas",
          "ja": "Weave Linen Canvas"
        },
        {
          "id": "WeaveCottonCanvas",
          "en": "Weave Cotton Canvas",
          "fr": "Tisser une toile en coton",
          "es": "Weave Cotton Canvas",
          "de": "Weave Cotton Canvas",
          "pt": "Weave Cotton Canvas",
          "it": "Intreccia tele di cotone",
          "tr": "Weave Cotton Canvas",
          "pl": "Utkaj płótno bawełniane",
          "ru": "Ткать хлопковый холст",
          "uk": "Weave Cotton Canvas",
          "ko": "목화 캔버스 짜기",
          "zh": "Weave Cotton Canvas",
          "ja": "Weave Cotton Canvas"
        },
        {
          "id": "RiceMortar",
          "en": "Rice Mortar",
          "fr": "Mortier de riz",
          "es": "Rice Mortar",
          "de": "Reismörtel",
          "pt": "Rice Mortar",
          "it": "Malta di riso",
          "tr": "Rice Mortar",
          "pl": "Rice Mortar",
          "ru": "Раствор из риса",
          "uk": "Rice Mortar",
          "ko": "쌀 모르타르",
          "zh": "Rice Mortar",
          "ja": "Rice Mortar"
        },
        {
          "id": "CottonseedOil",
          "en": "Cottonseed Oil",
          "fr": "Huile de coton",
          "es": "Cottonseed Oil",
          "de": "Baumwollsamen-Öl",
          "pt": "Cottonseed Oil",
          "it": "Olio di semi di cotone",
          "tr": "Cottonseed Oil",
          "pl": "Olej z nasion bawełny",
          "ru": "Хлопковое масло",
          "uk": "Cottonseed Oil",
          "ko": "면실유",
          "zh": "棉籽油",
          "ja": "Cottonseed Oil"
        },
        {
          "id": "CottonCanvas",
          "en": "Cotton Canvas",
          "fr": "Toile en coton",
          "es": "Cotton Canvas",
          "de": "Cotton Canvas",
          "pt": "Cotton Canvas",
          "it": "Tele di cotone",
          "tr": "Cotton Canvas",
          "pl": "Płótno bawełniane",
          "ru": "Хлопковый холст",
          "uk": "Cotton Canvas",
          "ko": "목화 캔버스",
          "zh": "Cotton Canvas",
          "ja": "Cotton Canvas"
        },
        {
          "id": "CompostSpoiledFood",
          "en": "Compost Spoiled Food",
          "fr": "Composter la nourriture avariée",
          "es": "Compost Spoiled Food",
          "de": "Compost Spoiled Food",
          "pt": "Compost Spoiled Food",
          "it": "Composta alimenti avariati",
          "tr": "Compost Spoiled Food",
          "pl": "Kompostuj zepsute jedzenie",
          "ru": "Компостировать испорченную еду",
          "uk": "Compost Spoiled Food",
          "ko": "음식물 쓰레기 비료",
          "zh": "变质食物堆肥",
          "ja": "Compost Spoiled Food"
        },
        {
          "id": "WetBrick",
          "en": "Wet Brick",
          "fr": "Brique humide",
          "es": "Wet Brick",
          "de": "Nasser Ziegel",
          "pt": "Wet Brick",
          "it": "Mattone umido",
          "tr": "Wet Brick",
          "pl": "Mokra cegła",
          "ru": "Сырой кирпич",
          "uk": "Wet Brick",
          "ko": "축축한 벽돌",
          "zh": "Wet Brick",
          "ja": "Wet Brick"
        },
        {
          "id": "WoodenMold",
          "en": "Wooden Mold",
          "fr": "Moule en bois",
          "es": "Wooden Mold",
          "de": "Holzform",
          "pt": "Wooden Mold",
          "it": "Stampo in legno",
          "tr": "Wooden Mold",
          "pl": "Drewniana forma",
          "ru": "Деревянная форма",
          "uk": "Wooden Mold",
          "ko": "목제 틀",
          "zh": "木制模具",
          "ja": "Wooden Mold"
        },
        {
          "id": "CrushedCoalLv3",
          "en": "Crushed Coal Lv3",
          "fr": "Charbon concassé nv. 3",
          "es": "Crushed Coal Lv3",
          "de": "Zerkleinerte Kohle Lv3",
          "pt": "Crushed Coal Lv3",
          "it": "Carbone spaccato Lv3",
          "tr": "Crushed Coal Lv3",
          "pl": "Crushed Coal Lv3",
          "ru": "Дробление угля Ур.3",
          "uk": "Crushed Coal Lv3",
          "ko": "파쇄된 석탄 Lv3",
          "zh": "Crushed Coal Lv3",
          "ja": "Crushed Coal Lv3"
        },
        {
          "id": "CrushedCoalLv2",
          "en": "Crushed Coal Lv2",
          "fr": "Charbon concassé nv. 2",
          "es": "Crushed Coal Lv2",
          "de": "Zerkleinertes Kohle Lv2",
          "pt": "Crushed Coal Lv2",
          "it": "Carbone spaccato Lv2",
          "tr": "Crushed Coal Lv2",
          "pl": "Crushed Coal Lv2",
          "ru": "Дробление угля Ур.2",
          "uk": "Crushed Coal Lv2",
          "ko": "파쇄된 석탄 Lv2",
          "zh": "Crushed Coal Lv2",
          "ja": "Crushed Coal Lv2"
        },
        {
          "id": "ShipwrightOveralls",
          "en": "Shipwright Overalls",
          "fr": "Ensemble de charpentier naval : Salopette",
          "es": "Shipwright Overalls",
          "de": "Shipwright Overalls",
          "pt": "Shipwright Overalls",
          "it": "Tuta da Carpentiere Navale",
          "tr": "Shipwright Overalls",
          "pl": "Shipwright Overalls",
          "ru": "Комбинезон кораблестроителя",
          "uk": "Shipwright Overalls",
          "ko": "조선공의 작업복",
          "zh": "造船工工作服",
          "ja": "Shipwright Overalls"
        },
        {
          "id": "HuntingUpgrade",
          "en": "Hunting Upgrade",
          "fr": "Amélioration basique : Chasse",
          "es": "Hunting Upgrade",
          "de": "Hunting Upgrade",
          "pt": "Hunting Upgrade",
          "it": "Aggiornamento di caccia",
          "tr": "Hunting Upgrade",
          "pl": "Hunting Upgrade",
          "ru": "Улучшение для охоты",
          "uk": "Hunting Upgrade",
          "ko": "Hunting Upgrade",
          "zh": "Hunting Upgrade",
          "ja": "Hunting Upgrade"
        },
        {
          "id": "SettlementCraftingTable",
          "en": "Settlement Crafting Table",
          "fr": "Établi de la colonie",
          "es": "Settlement Crafting Table",
          "de": "Settlement Crafting Table",
          "pt": "Settlement Crafting Table",
          "it": "Banco da lavoro dell\u0027insediamento",
          "tr": "Settlement Crafting Table",
          "pl": "Settlement Crafting Table",
          "ru": "Стол создания поселения",
          "uk": "Settlement Crafting Table",
          "ko": "Settlement Crafting Table",
          "zh": "定居点工作台",
          "ja": "Settlement Crafting Table"
        },
        {
          "id": "SweetJerky",
          "en": "Sweet Jerky",
          "fr": "Viande séché sucré",
          "es": "Sweet Jerky",
          "de": "Sweet Jerky",
          "pt": "Sweet Jerky",
          "it": "Carne essiccata dolce",
          "tr": "Sweet Jerky",
          "pl": "Sweet Jerky",
          "ru": "Сладкое вяленое мясо",
          "uk": "Sweet Jerky",
          "ko": "Sweet Jerky",
          "zh": "Sweet Jerky",
          "ja": "Sweet Jerky"
        },
        {
          "id": "RefineHeartOfPalm",
          "en": "Refine Heart Of Palm",
          "fr": "Cœur de palmier carbonisé",
          "es": "Refine Heart Of Palm",
          "de": "Refine Heart Of Palm",
          "pt": "Refine Heart Of Palm",
          "it": "Raffina cuore di palma",
          "tr": "Refine Heart Of Palm",
          "pl": "Refine Heart Of Palm",
          "ru": "Вырезать сердцевину пальмы",
          "uk": "Refine Heart Of Palm",
          "ko": "Refine Heart Of Palm",
          "zh": "Refine Heart Of Palm",
          "ja": "Refine Heart Of Palm"
        },
        {
          "id": "GeologyResearchPaperModernGlass",
          "en": "Geology Research Paper Modern Glass",
          "fr": "Papier de recherche : Verre avancé",
          "es": "Geology Research Paper Modern Glass",
          "de": "Geology Research Paper Modern Glass",
          "pt": "Geology Research Paper Modern Glass",
          "it": "Documento di ricerca di geologia: Vetro moderno",
          "tr": "Geology Research Paper Modern Glass",
          "pl": "Geology Research Paper Modern Glass",
          "ru": "Исследование по современной геологии стекольное",
          "uk": "Geology Research Paper Modern Glass",
          "ko": "현대식 유리 지질학 연구지",
          "zh": "Geology Research Paper Modern Glass",
          "ja": "Geology Research Paper Modern Glass"
        },
        {
          "id": "DryMeat",
          "en": "Dry Meat",
          "fr": "Viande séchée",
          "es": "Dry Meat",
          "de": "Trockenes Fleisch",
          "pt": "Dry Meat",
          "it": "Carne secca",
          "tr": "Dry Meat",
          "pl": "Dry Meat",
          "ru": "Сушеное мясо",
          "uk": "Dry Meat",
          "ko": "Dry Meat",
          "zh": "Dry Meat",
          "ja": "Dry Meat"
        },
        {
          "id": "DryFish",
          "en": "Dry Fish",
          "fr": "Poisson séché",
          "es": "Dry Fish",
          "de": "Trockener Fisch",
          "pt": "Dry Fish",
          "it": "Pesce secco",
          "tr": "Dry Fish",
          "pl": "Dry Fish",
          "ru": "Сушеная рыба",
          "uk": "Dry Fish",
          "ko": "Dry Fish",
          "zh": "Dry Fish",
          "ja": "Dry Fish"
        },
        {
          "id": "CharcoalSteel",
          "en": "Charcoal Steel",
          "fr": "Acier à base de charbon de bois",
          "es": "Acero al Carbono",
          "de": "Stahl",
          "pt": "Aço de Carvão",
          "it": "Acciaio Carbone",
          "tr": "Kömür Metali",
          "pl": "Stal Węglowa",
          "ru": "Сталь с древесным углём",
          "uk": "Сталь з вугіллям",
          "ko": "숯 강철괴 제조법",
          "zh": "木炭钢",
          "ja": "木炭鉄"
        },
        {
          "id": "TownBell",
          "en": "Town Bell",
          "fr": "Cloche municipale",
          "es": "Town Bell",
          "de": "Town Bell",
          "pt": "Town Bell",
          "it": "Town Bell",
          "tr": "Town Bell",
          "pl": "Town Bell",
          "ru": "Городской колокол",
          "uk": "Town Bell",
          "ko": "Town Bell",
          "zh": "Town Bell",
          "ja": "Town Bell"
        },
        {
          "id": "CeramicMold",
          "en": "Ceramic Mold",
          "fr": "Moule en céramique",
          "es": "Ceramic Mold",
          "de": "Ceramic Mold",
          "pt": "Ceramic Mold",
          "it": "Ceramic Mold",
          "tr": "Ceramic Mold",
          "pl": "Ceramic Mold",
          "ru": "Керамическая форма",
          "uk": "Ceramic Mold",
          "ko": "Ceramic Mold",
          "zh": "Ceramic Mold",
          "ja": "Ceramic Mold"
        },
        {
          "id": "ClayMold",
          "en": "Clay Mold",
          "fr": "Moule en argile",
          "es": "Clay Mold",
          "de": "Clay Mold",
          "pt": "Clay Mold",
          "it": "Clay Mold",
          "tr": "Clay Mold",
          "pl": "Clay Mold",
          "ru": "Глиняная форма",
          "uk": "Clay Mold",
          "ko": "Clay Mold",
          "zh": "Clay Mold",
          "ja": "Clay Mold"
        },
        {
          "id": "Ink",
          "en": "Ink",
          "fr": "Encre",
          "es": "Ink",
          "de": "Ink",
          "pt": "Ink",
          "it": "Ink",
          "tr": "Ink",
          "pl": "Ink",
          "ru": "Чернила",
          "uk": "Ink",
          "ko": "Ink",
          "zh": "Ink",
          "ja": "Ink"
        },
        {
          "id": "PrintingSupplies",
          "en": "Printing Supplies",
          "fr": "Nécessaire d\u0027impression",
          "es": "Printing Supplies",
          "de": "Printing Supplies",
          "pt": "Printing Supplies",
          "it": "Printing Supplies",
          "tr": "Printing Supplies",
          "pl": "Printing Supplies",
          "ru": "Printing Supplies",
          "uk": "Printing Supplies",
          "ko": "인쇄 용품",
          "zh": "Printing Supplies",
          "ja": "Printing Supplies"
        },
        {
          "id": "BlacksmithAdvancedUpgrade",
          "en": "Blacksmith Advanced Upgrade",
          "fr": "Amélioration avancée : Forgeron",
          "es": "Blacksmith Advanced Upgrade",
          "de": "Blacksmith Advanced Upgrade",
          "pt": "Blacksmith Advanced Upgrade",
          "it": "Blacksmith Advanced Upgrade",
          "tr": "Blacksmith Advanced Upgrade",
          "pl": "Blacksmith Advanced Upgrade",
          "ru": "Продвинутое улучшение для ковки",
          "uk": "Blacksmith Advanced Upgrade",
          "ko": "Blacksmith Advanced Upgrade",
          "zh": "Blacksmith Advanced Upgrade",
          "ja": "Blacksmith Advanced Upgrade"
        },
        {
          "id": "BlacksmithUpgrade",
          "en": "Blacksmith Upgrade",
          "fr": "Amélioration basique : Forgeron",
          "es": "Blacksmith Upgrade",
          "de": "Blacksmith Upgrade",
          "pt": "Blacksmith Upgrade",
          "it": "Blacksmith Upgrade",
          "tr": "Blacksmith Upgrade",
          "pl": "Blacksmith Upgrade",
          "ru": "Улучшение для ковки",
          "uk": "Blacksmith Upgrade",
          "ko": "Blacksmith Upgrade",
          "zh": "Blacksmith Upgrade",
          "ja": "Blacksmith Upgrade"
        },
        {
          "id": "GatheringAdvancedUpgrade",
          "en": "Gathering Advanced Upgrade",
          "fr": "Amélioration avancée : Récolte",
          "es": "Gathering Advanced Upgrade",
          "de": "Gathering Advanced Upgrade",
          "pt": "Gathering Advanced Upgrade",
          "it": "Gathering Advanced Upgrade",
          "tr": "Gathering Advanced Upgrade",
          "pl": "Gathering Advanced Upgrade",
          "ru": "Gathering Advanced Upgrade",
          "uk": "Gathering Advanced Upgrade",
          "ko": "Gathering Advanced Upgrade",
          "zh": "Gathering Advanced Upgrade",
          "ja": "Gathering Advanced Upgrade"
        },
        {
          "id": "SmeltingBasicUpgrade",
          "en": "Smelting Basic Upgrade",
          "fr": "Amélioration basique : Fonte",
          "es": "Smelting Basic Upgrade",
          "de": "Smelting Basic Upgrade",
          "pt": "Smelting Basic Upgrade",
          "it": "Smelting Basic Upgrade",
          "tr": "Smelting Basic Upgrade",
          "pl": "Smelting Basic Upgrade",
          "ru": "Smelting Basic Upgrade",
          "uk": "Smelting Basic Upgrade",
          "ko": "Smelting Basic Upgrade",
          "zh": "Smelting Basic Upgrade",
          "ja": "Smelting Basic Upgrade"
        },
        {
          "id": "BlacksmithTable",
          "en": "Blacksmith Table",
          "fr": "Établi de forgeron",
          "es": "Blacksmith Table",
          "de": "Blacksmith Table",
          "pt": "Blacksmith Table",
          "it": "Blacksmith Table",
          "tr": "Blacksmith Table",
          "pl": "Blacksmith Table",
          "ru": "Кузнечный стол",
          "uk": "Blacksmith Table",
          "ko": "Blacksmith Table",
          "zh": "Blacksmith Table",
          "ja": "Blacksmith Table"
        },
        {
          "id": "FletchingTable",
          "en": "Fletching Table",
          "fr": "Établi d\u0027empennage",
          "es": "Fletching Table",
          "de": "Fletching Table",
          "pt": "Fletching Table",
          "it": "Fletching Table",
          "tr": "Fletching Table",
          "pl": "Fletching Table",
          "ru": "Fletching Table",
          "uk": "Fletching Table",
          "ko": "Fletching Table",
          "zh": "Fletching Table",
          "ja": "Fletching Table"
        },
        {
          "id": "Grindstone",
          "en": "Grindstone",
          "fr": "Meule d\u0027affûtage",
          "es": "Grindstone",
          "de": "Grindstone",
          "pt": "Grindstone",
          "it": "Grindstone",
          "tr": "Grindstone",
          "pl": "Grindstone",
          "ru": "Grindstone",
          "uk": "Grindstone",
          "ko": "Grindstone",
          "zh": "Grindstone",
          "ja": "Grindstone"
        },
        {
          "id": "LighthouseLamp",
          "en": "Lighthouse Lamp",
          "fr": "Lampe de phare",
          "es": "Lighthouse Lamp",
          "de": "Lighthouse Lamp",
          "pt": "Lighthouse Lamp",
          "it": "Lighthouse Lamp",
          "tr": "Lighthouse Lamp",
          "pl": "Lighthouse Lamp",
          "ru": "Lighthouse Lamp",
          "uk": "Lighthouse Lamp",
          "ko": "Lighthouse Lamp",
          "zh": "Lighthouse Lamp",
          "ja": "Lighthouse Lamp"
        },
        {
          "id": "PowerHammer",
          "en": "Power Hammer",
          "fr": "Marteau-pilon",
          "es": "Power Hammer",
          "de": "Power Hammer",
          "pt": "Power Hammer",
          "it": "Power Hammer",
          "tr": "Power Hammer",
          "pl": "Power Hammer",
          "ru": "Power Hammer",
          "uk": "Power Hammer",
          "ko": "Power Hammer",
          "zh": "Power Hammer",
          "ja": "Power Hammer"
        },
        {
          "id": "TanningLeather",
          "en": "Tanning Leather",
          "fr": "Tannage du cuir",
          "es": "Tanning Leather",
          "de": "Tanning Leather",
          "pt": "Tanning Leather",
          "it": "Tanning Leather",
          "tr": "Tanning Leather",
          "pl": "Tanning Leather",
          "ru": "Tanning Leather",
          "uk": "Tanning Leather",
          "ko": "Tanning Leather",
          "zh": "Tanning Leather",
          "ja": "Tanning Leather"
        },
        {
          "id": "FishStock",
          "en": "Fish Stock",
          "fr": "Bouillon de poissons",
          "es": "Fish Stock",
          "de": "Fish Stock",
          "pt": "Fish Stock",
          "it": "Fish Stock",
          "tr": "Fish Stock",
          "pl": "Fish Stock",
          "ru": "Fish Stock",
          "uk": "Fish Stock",
          "ko": "Fish Stock",
          "zh": "Fish Stock",
          "ja": "Fish Stock"
        },
        {
          "id": "FishOil",
          "en": "Fish Oil",
          "fr": "Huile de poisson",
          "es": "Fish Oil",
          "de": "Fish Oil",
          "pt": "Fish Oil",
          "it": "Fish Oil",
          "tr": "Fish Oil",
          "pl": "Fish Oil",
          "ru": "Fish Oil",
          "uk": "Fish Oil",
          "ko": "Fish Oil",
          "zh": "Fish Oil",
          "ja": "Fish Oil"
        },
        {
          "id": "DenseCharcoal",
          "en": "Dense Charcoal",
          "fr": "Charbon dense",
          "es": "Dense Charcoal",
          "de": "Dense Charcoal",
          "pt": "Dense Charcoal",
          "it": "Dense Charcoal",
          "tr": "Dense Charcoal",
          "pl": "Dense Charcoal",
          "ru": "Dense Charcoal",
          "uk": "Dense Charcoal",
          "ko": "Dense Charcoal",
          "zh": "Dense Charcoal",
          "ja": "Dense Charcoal"
        },
        {
          "id": "ArrowBundle",
          "en": "Arrow Bundle",
          "fr": "Ensemble de flèches",
          "es": "Arrow Bundle",
          "de": "Arrow Bundle",
          "pt": "Arrow Bundle",
          "it": "Arrow Bundle",
          "tr": "Arrow Bundle",
          "pl": "Arrow Bundle",
          "ru": "Arrow Bundle",
          "uk": "Arrow Bundle",
          "ko": "Arrow Bundle",
          "zh": "Arrow Bundle",
          "ja": "Arrow Bundle"
        }
      ]
    },
    {
      "type": "skills",
      "entries": [
        {
          "id": "AdvancedBakingSkill",
          "en": "Advanced Baking",
          "fr": "Boulangerie avancée",
          "es": "Horneado Avanzado",
          "de": "Fortgeschrittenes Backen",
          "pt": "Assados Avançado",
          "it": "Cottura al forno Avanzata",
          "tr": "İleri Seviye Fırınlama",
          "pl": "Zaawansowane Pieczenie",
          "ru": "Продвинутая выпечка",
          "uk": "Розвинена випічка",
          "ko": "고급 제빵 기술",
          "zh": "高级烘烤",
          "ja": "高度な焼き料理"
        },
        {
          "id": "AdvancedCookingSkill",
          "en": "Advanced Cooking",
          "fr": "Cuisine avancée",
          "es": "Cocina Avanzada",
          "de": "Fortgeschrittenes Kochen",
          "pt": "Cozimento Avançado",
          "it": "Cucina Avanzata",
          "tr": "İleri Seviye Aşçılık",
          "pl": "Zaawansowane Gotowanie",
          "ru": "Продвинутая кулинария",
          "uk": "Розвинена готівля",
          "ko": "고급 요리 기술",
          "zh": "高级烹饪",
          "ja": "高度な料理"
        },
        {
          "id": "AdvancedSmeltingSkill",
          "en": "Advanced Smelting",
          "fr": "Fonte avancée",
          "es": "Fundición Avanzada",
          "de": "Fortgeschrittenes Schmelzen",
          "pt": "Fundição Avançada",
          "it": "Fusione Avanzata",
          "tr": "İleri Seviye Eritme",
          "pl": "Zaawansowane Hutnictwo",
          "ru": "Продвинутая выплавка",
          "uk": "Розвинене плавлення",
          "ko": "고급 제련 기술",
          "zh": "高级冶炼",
          "ja": "高度な精錬"
        },
        {
          "id": "BakingSkill",
          "en": "Baking",
          "fr": "Boulangerie",
          "es": "Horneado",
          "de": "Backen",
          "pt": "Assados",
          "it": "Cottura al forno",
          "tr": "Fırınlama",
          "pl": "Piekarstwo",
          "ru": "Выпечка",
          "uk": "Випічка",
          "ko": "제빵 기술",
          "zh": "烘烤",
          "ja": "焼成"
        },
        {
          "id": "BasicEngineeringSkill",
          "en": "Basic Engineering",
          "fr": "Ingénierie basique",
          "es": "Ingeniería Básica",
          "de": "Grundlegende Technik",
          "pt": "Engenharia Básica",
          "it": "Ingegneria di base",
          "tr": "Basit Mühendislik",
          "pl": "Podstawy Inżynierii",
          "ru": "Основы инженерного дела",
          "uk": "Основи інженерії",
          "ko": "기초 기계공학 기술",
          "zh": "基础工程",
          "ja": "基礎工学"
        },
        {
          "id": "ButcherySkill",
          "en": "Butchery",
          "fr": "Boucherie",
          "es": "Carnicería",
          "de": "Metzgerhandwerk",
          "pt": "Açougue",
          "it": "Macelleria",
          "tr": "Kasaplık",
          "pl": "Rzeźnictwo",
          "ru": "Разделка животных",
          "uk": "Різництво",
          "ko": "도축 기술",
          "zh": "肉加工",
          "ja": "食肉加工"
        },
        {
          "id": "CampfireCookingSkill",
          "en": "Campfire Cooking",
          "fr": "Cuisine au feu de camp",
          "es": "Cocina con Fogata",
          "de": "Lagerfeuerkochen",
          "pt": "Cozimento com Fogueira",
          "it": "Cucina da falò",
          "tr": "Güveçte Pişirme",
          "pl": "Gotowanie na Ognisku",
          "ru": "Готовка на костре",
          "uk": "Приготування їжі на багатті",
          "ko": "모닥불 요리 기술",
          "zh": "篝火烹饪",
          "ja": "野外簡易料理"
        },
        {
          "id": "CookingSkill",
          "en": "Cooking",
          "fr": "Cuisine",
          "es": "Cocina",
          "de": "Kochen",
          "pt": "Cozimento",
          "it": "Cucina",
          "tr": "Aşçılık",
          "pl": "Gotowanie",
          "ru": "Готовка",
          "uk": "Приготування їжі",
          "ko": "요리 기술",
          "zh": "烹饪",
          "ja": "料理"
        },
        {
          "id": "CuttingEdgeCookingSkill",
          "en": "Cutting Edge Cooking",
          "fr": "Cuisine moléculaire",
          "es": "Cocina Innovadora",
          "de": "Innovatives Kochen",
          "pt": "Cozimento de Ponta",
          "it": "Cucina all\u0027avanguardia",
          "tr": "Çağdaş Aşçılık",
          "pl": "Nowoczesne Gotowanie",
          "ru": "Передовая кулинария",
          "uk": "Сучасна кулінарія",
          "ko": "식품공학 기술",
          "zh": "尖端烹饪",
          "ja": "最先端料理"
        },
        {
          "id": "ElectronicsSkill",
          "en": "Electronics",
          "fr": "Électroniques",
          "es": "Electrónica",
          "de": "Elektronik",
          "pt": "Eletrônica",
          "it": "Elettronica",
          "tr": "Elektronik",
          "pl": "Elektronika",
          "ru": "Электроника",
          "uk": "Електроніка",
          "ko": "전자공학 기술",
          "zh": "电气",
          "ja": "電子工学"
        },
        {
          "id": "FarmingSkill",
          "en": "Farming",
          "fr": "Agriculture",
          "es": "Agricultura",
          "de": "Landwirtschaft",
          "pt": "Agricultura",
          "it": "Agricoltura",
          "tr": "Çiftçilik",
          "pl": "Rolnictwo",
          "ru": "Фермерство",
          "uk": "Фермерство",
          "ko": "농업 기술",
          "zh": "农业",
          "ja": "農業"
        },
        {
          "id": "FertilizersSkill",
          "en": "Fertilizers",
          "fr": "Engrais",
          "es": "Fertilizantes",
          "de": "Dünger",
          "pt": "Fertilizantes",
          "it": "Fertilizzanti",
          "tr": "Gübreleme",
          "pl": "Nawozy",
          "ru": "Удобрения",
          "uk": "Добрива",
          "ko": "비료제조 기술",
          "zh": "化肥",
          "ja": "肥料"
        },
        {
          "id": "GatheringSkill",
          "en": "Gathering",
          "fr": "Récolte",
          "es": "Recolección",
          "de": "Sammeln",
          "pt": "Coleta",
          "it": "Raccolta",
          "tr": "Toplayıcılık",
          "pl": "Zbieractwo",
          "ru": "Собирательство",
          "uk": "Збирання",
          "ko": "채집 기술",
          "zh": "采集",
          "ja": "採集"
        },
        {
          "id": "GlassworkingSkill",
          "en": "Glassworking",
          "fr": "Travail du verre",
          "es": "Vidriería",
          "de": "Glasverarbeitung",
          "pt": "Trabalho com Vidro",
          "it": "Lavorazione del vetro",
          "tr": "Cam İşleme",
          "pl": "Obróbka szkła",
          "ru": "Обработка стекла",
          "uk": "Обробка скла",
          "ko": "유리 제조 기술",
          "zh": "玻璃加工",
          "ja": "ガラス加工"
        },
        {
          "id": "HuntingSkill",
          "en": "Hunting",
          "fr": "Chasse",
          "es": "Caza",
          "de": "Jagen",
          "pt": "Caça",
          "it": "Caccia",
          "tr": "Avcılık",
          "pl": "Łowiectwo",
          "ru": "Охота",
          "uk": "Полювання",
          "ko": "사냥 기술",
          "zh": "狩猎",
          "ja": "狩猟"
        },
        {
          "id": "IndustrySkill",
          "en": "Industry",
          "fr": "Industrie",
          "es": "Industria",
          "de": "Industrie",
          "pt": "Indústria",
          "it": "Industria",
          "tr": "Sanayi",
          "pl": "Przemysł",
          "ru": "Промышленность",
          "uk": "Промисловість",
          "ko": "산업 기술",
          "zh": "工业",
          "ja": "産業"
        },
        {
          "id": "LoggingSkill",
          "en": "Logging",
          "fr": "Abattage",
          "es": "Tala",
          "de": "Holzfällen",
          "pt": "Extração de Madeira",
          "it": "Tagliare Tronchi",
          "tr": "Odunculuk",
          "pl": "Wyrąb drzew",
          "ru": "Заготовка леса",
          "uk": "Заготівля лісу",
          "ko": "벌목 기술",
          "zh": "伐木",
          "ja": "木こり"
        },
        {
          "id": "MechanicsSkill",
          "en": "Mechanics",
          "fr": "Mécaniques",
          "es": "Mecánica",
          "de": "Mechanik",
          "pt": "Mecânica",
          "it": "Meccanica",
          "tr": "Makine Bilimi",
          "pl": "Mechanika",
          "ru": "Механика",
          "uk": "Механіка",
          "ko": "기계정비 기술",
          "zh": "机械",
          "ja": "機械"
        },
        {
          "id": "MillingSkill",
          "en": "Milling",
          "fr": "Mouture",
          "es": "Molinería",
          "de": "Mahlen",
          "pt": "Moagem",
          "it": "Fresatura",
          "tr": "Değirmencilik",
          "pl": "Młynarstwo",
          "ru": "Мельничное дело",
          "uk": "Млинарство",
          "ko": "제분 기술",
          "zh": "研磨",
          "ja": "製粉"
        },
        {
          "id": "MiningSkill",
          "en": "Mining",
          "fr": "Minage",
          "es": "Minería",
          "de": "Bergbau",
          "pt": "Mineração",
          "it": "Estrazione Mineraria",
          "tr": "Madencilik",
          "pl": "Górnictwo",
          "ru": "Горное дело",
          "uk": "Гірництво",
          "ko": "채광 기술",
          "zh": "采矿",
          "ja": "採掘"
        },
        {
          "id": "OilDrillingSkill",
          "en": "Oil Drilling",
          "fr": "Forage pétrolier",
          "es": "Perforación de Petróleo",
          "de": "Ölbohrung",
          "pt": "Perfuração de Petróleo",
          "it": "Trivellazione petrolifera",
          "tr": "Petrol Çıkarma",
          "pl": "Wydobycie Ropy",
          "ru": "Добыча нефти",
          "uk": "Добування нафти",
          "ko": "유정 굴착 기술",
          "zh": "石油钻探",
          "ja": "石油掘削"
        },
        {
          "id": "PaperMillingSkill",
          "en": "Paper Milling",
          "fr": "Production de papier",
          "es": "Molienda de Papel",
          "de": "Papierherstellung",
          "pt": "Fabricação de Papel",
          "it": "Fresatura della Carta",
          "tr": "Kağıt İşleme",
          "pl": "Papiernia",
          "ru": "Производство бумаги",
          "uk": "Папірництво",
          "ko": "제지 가공 기술",
          "zh": "造纸",
          "ja": "製紙"
        },
        {
          "id": "SelfImprovementSkill",
          "en": "Self Improvement",
          "fr": "Amélioration personnelle",
          "es": "Automejora",
          "de": "Selbstverbesserung",
          "pt": "Auto-aperfeiçoamento",
          "it": "Migliorare se stessi",
          "tr": "Kişisel Gelişim",
          "pl": "Samodoskonalenie",
          "ru": "Самосовершенствование",
          "uk": "Самовдосконалення",
          "ko": "자기 개선",
          "zh": "自我提升",
          "ja": "自己改善"
        },
        {
          "id": "SmeltingSkill",
          "en": "Smelting",
          "fr": "Fonte",
          "es": "Fundición",
          "de": "Schmelzen",
          "pt": "Fundição",
          "it": "Fusione",
          "tr": "Eritme",
          "pl": "Hutnictwo",
          "ru": "Выплавка",
          "uk": "Плавлення",
          "ko": "제련 기술",
          "zh": "冶炼",
          "ja": "精錬"
        },
        {
          "id": "TailoringSkill",
          "en": "Tailoring",
          "fr": "Couture",
          "es": "Sastrería",
          "de": "Schneidern",
          "pt": "Alfaiataria",
          "it": "Sartoria",
          "tr": "Terzilik",
          "pl": "Krawiectwo",
          "ru": "Портняжное дело",
          "uk": "Кравецтво",
          "ko": "재단 기술",
          "zh": "裁缝",
          "ja": "裁縫"
        },
        {
          "id": "CompositesSkill",
          "en": "Composites",
          "fr": "Composites",
          "es": "Composites",
          "de": "Verbundholzstoffe",
          "pt": "Compósitos",
          "it": "Materiali Compositi",
          "tr": "Kompozitler",
          "pl": "Kompozyty",
          "ru": "Композиты",
          "uk": "Композити",
          "ko": "복합 목재 기술",
          "zh": "复合材料",
          "ja": "複合材"
        },
        {
          "id": "AdvancedMasonrySkill",
          "en": "Advanced Masonry",
          "fr": "Maçonnerie Avancée",
          "es": "Mampostería avanzada",
          "de": "Verbesserter Steinmetz",
          "pt": "Alvenaria Avançada",
          "it": "Muratura Avanzata",
          "tr": "İleri Seviye Duvarcılık",
          "pl": "Zaawansowane Kamieniarstwo",
          "ru": "Продвинутая каменная кладка",
          "uk": "Покращена кам\u0027яна кладка",
          "ko": "고급 석조 기술",
          "zh": "高级石工",
          "ja": "高度な石工"
        },
        {
          "id": "PotterySkill",
          "en": "Pottery",
          "fr": "Poterie",
          "es": "Cerámica",
          "de": "Töpfern",
          "pt": "Cerâmica",
          "it": "Ceramica",
          "tr": "Çömlekçilik",
          "pl": "Garncarstwo",
          "ru": "Гончарство",
          "uk": "Гончарна справа",
          "ko": "도기 기술",
          "zh": "陶器",
          "ja": "陶芸"
        },
        {
          "id": "MasonrySkill",
          "en": "Masonry",
          "fr": "Maçonnerie",
          "es": "Mampostería",
          "de": "Steinmetz",
          "pt": "Alvenaria",
          "it": "Muratura",
          "tr": "Duvarcılık",
          "pl": "Kamieniarstwo",
          "ru": "Каменная кладка",
          "uk": "Кам\u0027яна кладка",
          "ko": "석조 기술",
          "zh": "石工",
          "ja": "石工"
        },
        {
          "id": "CarpentrySkill",
          "en": "Carpentry",
          "fr": "Menuiserie",
          "es": "Carpintería",
          "de": "Schreinerei",
          "pt": "Carpintaria",
          "it": "Carpenteria",
          "tr": "Marangozluk",
          "pl": "Stolarstwo",
          "ru": "Плотницкое дело",
          "uk": "Теслярська справа",
          "ko": "목공 기술",
          "zh": "木工",
          "ja": "大工"
        },
        {
          "id": "ShipwrightSkill",
          "en": "Shipwright",
          "fr": "Construction navale",
          "es": "Shipwright",
          "de": "Schiffsbauer",
          "pt": "Shipwright",
          "it": "Carpentiere Navale",
          "tr": "Shipwright",
          "pl": "Szkutnik",
          "ru": "Кораблестроение",
          "uk": "Кораблебудування",
          "ko": "조선",
          "zh": "造船",
          "ja": "船大工"
        },
        {
          "id": "BlacksmithSkill",
          "en": "Blacksmith",
          "fr": "Forgeron",
          "es": "Blacksmith",
          "de": "Blacksmith",
          "pt": "Blacksmith",
          "it": "Blacksmith",
          "tr": "Blacksmith",
          "pl": "Blacksmith",
          "ru": "Ковка",
          "uk": "Blacksmith",
          "ko": "Blacksmith",
          "zh": "Blacksmith",
          "ja": "Blacksmith"
        }
      ]
    },
    {
      "type": "tables",
      "entries": [
        {
          "id": "AnvilObject",
          "en": "Anvil",
          "fr": "Enclume",
          "es": "Yunque",
          "de": "Amboss",
          "pt": "Bigorna",
          "it": "Incudine",
          "tr": "Örs",
          "pl": "Kowadło",
          "ru": "Наковальня",
          "uk": "Ковадло",
          "ko": "모루",
          "zh": "铁砧",
          "ja": "金床"
        },
        {
          "id": "BakeryOvenObject",
          "en": "Bakery Oven",
          "fr": "Four à pain",
          "es": "Horno de Panadería",
          "de": "Bäckereiofen",
          "pt": "Forno de Padaria",
          "it": "Forno per panetteria",
          "tr": "Ekmek Fırını",
          "pl": "Piec piekarniczy",
          "ru": "Печь для выпечки",
          "uk": "Піч для випічки",
          "ko": "제빵 화덕",
          "zh": "烤炉",
          "ja": "ベーカリーオーブン"
        },
        {
          "id": "BlastFurnaceObject",
          "en": "Blast Furnace",
          "fr": "Haut fourneau",
          "es": "Alto Horno",
          "de": "Hochofen",
          "pt": "Alto-forno",
          "it": "Altoforno",
          "tr": "Maden Eritme Ocağı",
          "pl": "Piec hutniczy",
          "ru": "Доменная печь",
          "uk": "Домна",
          "ko": "용광로",
          "zh": "高炉",
          "ja": "高炉"
        },
        {
          "id": "BloomeryObject",
          "en": "Bloomery",
          "fr": "Bas fourneau",
          "es": "Horno de fundición",
          "de": "Schmelzofen",
          "pt": "Forja catalã",
          "it": "Forno per Metalli",
          "tr": "Demirci Ocağı",
          "pl": "Dymarka",
          "ru": "Сыродутная печь",
          "uk": "Сиродутне горно",
          "ko": "괴철로",
          "zh": "锻铁炉",
          "ja": "塊鉄炉"
        },
        {
          "id": "ButcheryTableObject",
          "en": "Butchery Table",
          "fr": "Table de boucherie",
          "es": "Mesa de carnicería",
          "de": "Metzgertisch",
          "pt": "Mesa de Açougue",
          "it": "Tavolo da Macellaio",
          "tr": "Kasap Tezgahı",
          "pl": "Stół rzeźnicki",
          "ru": "Разделочный стол",
          "uk": "Різницький стіл",
          "ko": "도축 작업대",
          "zh": "肉加工工作台",
          "ja": "食肉加工台"
        },
        {
          "id": "CampfireObject",
          "en": "Campfire",
          "fr": "Feu de camp",
          "es": "Fogata",
          "de": "Lagerfeuer",
          "pt": "Fogueira",
          "it": "Falò",
          "tr": "Kamp Ateşi",
          "pl": "Ognisko",
          "ru": "Костёр",
          "uk": "Багаття",
          "ko": "모닥불",
          "zh": "篝火",
          "ja": "焚き火"
        },
        {
          "id": "CarpentryTableObject",
          "en": "Carpentry Table",
          "fr": "Établi de menuiserie",
          "es": "Mesa de carpintería",
          "de": "Zimmermanntisch",
          "pt": "Mesa de carpintaria",
          "it": "Tavolo da carpentiere",
          "tr": "Marangoz Masası",
          "pl": "Stół Stolarski",
          "ru": "Плотницкий верстак",
          "uk": "Стіл теслі",
          "ko": "목공 작업대",
          "zh": "木工工作台",
          "ja": "木工作業台"
        },
        {
          "id": "CastIronStoveObject",
          "en": "Cast Iron Stove",
          "fr": "Poêle en fonte",
          "es": "Estufa de hierro fundido",
          "de": "Gusseiserner Ofen",
          "pt": "Fogão de Ferro Fundido",
          "it": "Stufa in ghisa",
          "tr": "Dökme Demir Ocak",
          "pl": "Żeliwna kuchnia",
          "ru": "Чугунная плита",
          "uk": "Чавунна піч",
          "ko": "철재 화덕",
          "zh": "铸铁火炉",
          "ja": "鋳鉄のストーブ"
        },
        {
          "id": "CementKilnObject",
          "en": "Cement Kiln",
          "fr": "Four à ciment",
          "es": "Horno de Cemento",
          "de": "Zementbrennofen",
          "pt": "Forno de cimento",
          "it": "Forno da cemento",
          "tr": "Çimento Fırını",
          "pl": "Cementownia",
          "ru": "Барабанная печь",
          "uk": "Піч для цементу",
          "ko": "시멘트 가마",
          "zh": "水泥窑",
          "ja": "セメントのかまど"
        },
        {
          "id": "ElectronicsAssemblyObject",
          "en": "Electronics Assembly",
          "fr": "Établi d\u0027assemblage électronique",
          "es": "Sección de ensamblaje electrónico",
          "de": "Elektronikfertigung",
          "pt": "Montagem eletrônica",
          "it": "Assemblaggi elettronici",
          "tr": "Elektronik Montaj",
          "pl": "Montaż Elektroniki",
          "ru": "Сборщик электроники",
          "uk": "Збирач електроніки",
          "ko": "전자 공학 작업대",
          "zh": "电子装配套装",
          "ja": "電子機器組立機"
        },
        {
          "id": "FarmersTableObject",
          "en": "Farmers Table",
          "fr": "Atelier d\u0027agriculture",
          "es": "Mesa de Agricultor",
          "de": "Landwirttisch",
          "pt": "Mesa de agricultor",
          "it": "Tavolo da Contadino",
          "tr": "Çiftçi Masası",
          "pl": "Stół rolniczy",
          "ru": "Фермерский стол",
          "uk": "Фермерський стіл",
          "ko": "농업 작업대",
          "zh": "农业工作台",
          "ja": "園芸作業台"
        },
        {
          "id": "FisheryObject",
          "en": "Fishery",
          "fr": "Atelier de pêche",
          "es": "Pesquería",
          "de": "Fischereitisch",
          "pt": "Mesa de pesca",
          "it": "Tavolo da Pescatore",
          "tr": "Balıkçılık",
          "pl": "Rybołóstwo",
          "ru": "Шкаф рыбака",
          "uk": "Шафка рибалки",
          "ko": "어업 작업대",
          "zh": "渔具",
          "ja": "釣り具作業台"
        },
        {
          "id": "KilnObject",
          "en": "Kiln",
          "fr": "Four à céramique",
          "es": "Horno",
          "de": "Brennofen",
          "pt": "Forno",
          "it": "Forno",
          "tr": "Fırın",
          "pl": "Piec do Wypalania",
          "ru": "Печь для обжига",
          "uk": "Промислова піч",
          "ko": "가마",
          "zh": "窑",
          "ja": "かまど"
        },
        {
          "id": "LaboratoryObject",
          "en": "Laboratory",
          "fr": "Laboratoire",
          "es": "Laboratorio",
          "de": "Laboratorium",
          "pt": "Laboratório",
          "it": "Laboratorio",
          "tr": "Laboratuvar",
          "pl": "Laboratorium",
          "ru": "Лаборатория",
          "uk": "Лабораторія",
          "ko": "연구대",
          "zh": "实验室",
          "ja": "研究所"
        },
        {
          "id": "MasonryTableObject",
          "en": "Masonry Table",
          "fr": "Établi de maçonnerie",
          "es": "Mesa de mampostería",
          "de": "Steinmetztisch",
          "pt": "Mesa de alvenaria",
          "it": "Tavolo da Muratore",
          "tr": "Duvarcılık Masası",
          "pl": "Stół murarski",
          "ru": "Верстак каменщика",
          "uk": "Каменярський стіл",
          "ko": "석조 작업대",
          "zh": "石匠工作台",
          "ja": "石工作業台"
        },
        {
          "id": "MillObject",
          "en": "Mill",
          "fr": "Meule",
          "es": "Molino",
          "de": "Mahlwerk",
          "pt": "Moedor",
          "it": "Mulino",
          "tr": "Değirmen",
          "pl": "Młyn",
          "ru": "Мельница",
          "uk": "Млин",
          "ko": "맷돌",
          "zh": "磨坊",
          "ja": "製粉機"
        },
        {
          "id": "OilRefineryObject",
          "en": "Oil Refinery",
          "fr": "Raffinerie de pétrole",
          "es": "Refinería de Petróleo",
          "de": "Raffinerie",
          "pt": "Refinaria de petróleo",
          "it": "Raffineria di petrolio",
          "tr": "Petrol Rafinerisi",
          "pl": "Rafineria",
          "ru": "Нефтеперерабатывающий завод",
          "uk": "Нафтопереробний завод",
          "ko": "정유소",
          "zh": "炼油厂",
          "ja": "石油精製所"
        },
        {
          "id": "PumpJackObject",
          "en": "Pump Jack",
          "fr": "Chevalet de pompage",
          "es": "Unidad de Bombeo",
          "de": "Ölbohrturm",
          "pt": "Bomba petrolífera",
          "it": "Pompa Petrolifera",
          "tr": "Atbaşı Pompa",
          "pl": "Kiwak",
          "ru": "Нефтяная вышка",
          "uk": "Нафтовий насос",
          "ko": "석유 시추기",
          "zh": "油压机",
          "ja": "ポンプジャッキ"
        },
        {
          "id": "ResearchTableObject",
          "en": "Research Table",
          "fr": "Table de recherche",
          "es": "Mesa de investigación",
          "de": "Forschungstisch",
          "pt": "Mesa de pesquisa",
          "it": "Tabella di ricerca",
          "tr": "Araştırma Masası",
          "pl": "Stół badawczy",
          "ru": "Стол для исследований",
          "uk": "Дослідницький стіл",
          "ko": "연구 작업대",
          "zh": "研究工作台",
          "ja": "リサーチテーブル"
        },
        {
          "id": "RollingMillObject",
          "en": "Rolling Mill",
          "fr": "Laminoir",
          "es": "Molino de laminado",
          "de": "Walzwerk",
          "pt": "Rolo de laminação",
          "it": "Laminatoio",
          "tr": "Hadde Makinesi",
          "pl": "Walcownia",
          "ru": "Прокатный стан",
          "uk": "Стан прокатний",
          "ko": "압연기",
          "zh": "轧机",
          "ja": "圧延機"
        },
        {
          "id": "SawmillObject",
          "en": "Sawmill",
          "fr": "Scierie",
          "es": "Aserradero",
          "de": "Sägewerk",
          "pt": "Serraria",
          "it": "Segheria",
          "tr": "Bıçkıhane",
          "pl": "Tartak",
          "ru": "Лесопилка",
          "uk": "Лісопилка",
          "ko": "제재대",
          "zh": "锯木台",
          "ja": "製材機"
        },
        {
          "id": "StoveObject",
          "en": "Stove",
          "fr": "Cuisinière",
          "es": "Estufa",
          "de": "Herd",
          "pt": "Fogão",
          "it": "Stufa",
          "tr": "Ocak",
          "pl": "Kuchnia",
          "ru": "Плита",
          "uk": "Плита",
          "ko": "화덕",
          "zh": "火炉",
          "ja": "ストーブ"
        },
        {
          "id": "TailoringTableObject",
          "en": "Tailoring Table",
          "fr": "Atelier de couture",
          "es": "Mesa de sastrería",
          "de": "Schneidertisch",
          "pt": "Mesa de alfaiataria",
          "it": "Tavolo da Sarto",
          "tr": "Terzi Masası",
          "pl": "Stacja Krawiecka",
          "ru": "Стол портного",
          "uk": "Кравецький стіл",
          "ko": "재단 작업대",
          "zh": "裁缝工作台",
          "ja": "裁縫作業台"
        },
        {
          "id": "WainwrightTableObject",
          "en": "Wainwright Table",
          "fr": "Établi d\u0027ingénierie routière",
          "es": "Mesa de carretero",
          "de": "Wagenmachertisch",
          "pt": "Mesa reta",
          "it": "Tavolo dei Trasporti",
          "tr": "Vagon Tamircisi Masası",
          "pl": "Stół Powoźniczy",
          "ru": "Верстак колесника",
          "uk": "Стіл стельмаха",
          "ko": "짐수레 작업대",
          "zh": "车匠工作台",
          "ja": "荷車作業台"
        },
        {
          "id": "WorkbenchObject",
          "en": "Workbench",
          "fr": "Établi de bricolage",
          "es": "Mesa de Trabajo",
          "de": "Werkbank",
          "pt": "Bancada de trabalho",
          "it": "Banco da lavoro",
          "tr": "Çalışma tezgahı",
          "pl": "Stół Roboczy",
          "ru": "Верстак",
          "uk": "Верстат",
          "ko": "작업대",
          "zh": "工作台",
          "ja": "作業台"
        },
        {
          "id": "AssemblyLineObject",
          "en": "Assembly Line",
          "fr": "Ligne de montage",
          "es": "Línea de Ensamblaje",
          "de": "Mechanische Fertigungsstraße",
          "pt": "Linha de montagem",
          "it": "Catena di montaggio",
          "tr": "Seri Üretim Hattı",
          "pl": "Linia Produkcyjna",
          "ru": "Сборочная линия",
          "uk": "Лінія для збору",
          "ko": "조립 라인",
          "zh": "装配线",
          "ja": "組立ライン"
        },
        {
          "id": "CampsiteObject",
          "en": "Campsite",
          "fr": "Camping",
          "es": "Campamento",
          "de": "Campingplatz",
          "pt": "Acampamento",
          "it": "Campo",
          "tr": "Kamp alanı",
          "pl": "Obóz",
          "ru": "Палатка",
          "uk": "Кемпінг",
          "ko": "야영지",
          "zh": "营地",
          "ja": "キャンプサイト"
        },
        {
          "id": "ElectricLatheObject",
          "en": "Electric Lathe",
          "fr": "Tour électrique",
          "es": "Torno eléctrico",
          "de": "Elektrische Drehmaschine",
          "pt": "Torno elétrico",
          "it": "Tornio Elettrico",
          "tr": "Elektrikli Torna Tezgahı",
          "pl": "Tokarka Elektryczna",
          "ru": "Электрический токарный станок",
          "uk": "Електричний токарний верстат",
          "ko": "전동식 선반",
          "zh": "电动车床",
          "ja": "電気旋盤"
        },
        {
          "id": "ElectricMachinistTableObject",
          "en": "Electric Machinist Table",
          "fr": "Établi électrique",
          "es": "Mesa eléctrica de maquinista",
          "de": "Elektrischer Montagetisch",
          "pt": "Mesa elétrica de maquinista",
          "it": "Banco Elettrico da Macchinista",
          "tr": "Elektrik Ustası Tezgahı",
          "pl": "Elektryczny Stół Maszynowy",
          "ru": "Электрический слесарный верстак",
          "uk": "Стіл електромашиніста",
          "ko": "전동식 기계 정비공 작업대",
          "zh": "电动机械师工作台",
          "ja": "電気工作機械台"
        },
        {
          "id": "ElectricPlanerObject",
          "en": "Electric Planer",
          "fr": "Fraiseuse électrique",
          "es": "Cepilladora eléctrica",
          "de": "Elektrische Hobelmaschine",
          "pt": "Plaina elétrica",
          "it": "Pialla Elettrica",
          "tr": "Elektrikli Rendeleme Tezgahı",
          "pl": "Strug Elektryczny",
          "ru": "Электрический строгальный станок",
          "uk": "Електричний стругальний верстат",
          "ko": "전동식 대패",
          "zh": "电动刨床",
          "ja": "電気かんな盤"
        },
        {
          "id": "ElectricStampingPressObject",
          "en": "Electric Stamping Press",
          "fr": "Presse électrique",
          "es": "Prensa de Estampado Hidráulica",
          "de": "Elektrische Stanzpresse",
          "pt": "Prensa de estampagem elétrica",
          "it": "Pressa per Stampaggio Elettrica",
          "tr": "Elektrikli Çelik İşleme Aleti",
          "pl": "Elektryczna prasa do tłoczenia",
          "ru": "Электрический пресс",
          "uk": "Електричний прес",
          "ko": "전동식 금속 가공기",
          "zh": "电动冲床",
          "ja": "電気スタンピングプレス機"
        },
        {
          "id": "KitchenObject",
          "en": "Kitchen",
          "fr": "Cuisine",
          "es": "Cocina",
          "de": "Küche",
          "pt": "Cozinha",
          "it": "Cucina",
          "tr": "Mutfak",
          "pl": "Kuchnia",
          "ru": "Кухня",
          "uk": "Кухня",
          "ko": "주방",
          "zh": "厨房",
          "ja": "キッチン"
        },
        {
          "id": "LatheObject",
          "en": "Lathe",
          "fr": "Tour",
          "es": "Torno",
          "de": "Drehmaschine",
          "pt": "Torno",
          "it": "Tornio",
          "tr": "Torna",
          "pl": "Tokarka",
          "ru": "Токарный станок",
          "uk": "Токарний верстат",
          "ko": "선반",
          "zh": "车床",
          "ja": "旋盤"
        },
        {
          "id": "MachinistTableObject",
          "en": "Machinist Table",
          "fr": "Établi de mécanicien",
          "es": "Mesa de maquinista",
          "de": "Mechanikertisch",
          "pt": "Mesa de maquinista",
          "it": "Banco del Macchinista",
          "tr": "Makinist Tezgahı",
          "pl": "Stół mechanika",
          "ru": "Слесарный верстак",
          "uk": "Стіл машиніста",
          "ko": "기계공 작업대",
          "zh": "机械师工作台",
          "ja": "機械工のテーブル"
        },
        {
          "id": "RoboticAssemblyLineObject",
          "en": "Robotic Assembly Line",
          "fr": "Ligne de montage robotisée",
          "es": "Línea de Ensamblaje Robótica",
          "de": "Robotische Fertigungsstraße",
          "pt": "Linha de montagem robótica",
          "it": "Catena di Montaggio Robotica",
          "tr": "Robotlu Seri Üretim Hattı",
          "pl": "Zrobotyzowana linia produkcyjna",
          "ru": "Роботизированная сборочная линия",
          "uk": "Роботизована лінія для збору",
          "ko": "자동화 조립 라인",
          "zh": "机器人装配线",
          "ja": "ロボット組立ライン"
        },
        {
          "id": "ScrewPressObject",
          "en": "Screw Press",
          "fr": "Presse à vis",
          "es": "Prensa de tornillos",
          "de": "Spindelpresse",
          "pt": "Prensa de rosca",
          "it": "Pressa a Vite",
          "tr": "Vidalı Pres",
          "pl": "Prasa śrubowa",
          "ru": "Винтовой пресс",
          "uk": "Гвинтовий прес",
          "ko": "압입식 조임 기계",
          "zh": "螺旋压榨机",
          "ja": "ねじプレス"
        },
        {
          "id": "ShaperObject",
          "en": "Shaper",
          "fr": "Étau limeur",
          "es": "Modelador (m.) Modeladora (f.)",
          "de": "Fräsmaschine",
          "pt": "Niveladora",
          "it": "Plasmatrice",
          "tr": "Vargel",
          "pl": "Strugarka",
          "ru": "Строгальный станок",
          "uk": "Стругальний верстат",
          "ko": "형삭반",
          "zh": "刨床",
          "ja": "形削り盤"
        },
        {
          "id": "ToolBenchObject",
          "en": "Tool Bench",
          "fr": "Établi d\u0027outillage",
          "es": "Mesa de herramientas",
          "de": "Werkzeugtisch",
          "pt": "Bancada de ferramentas",
          "it": "Banco degli Attrezzi",
          "tr": "Alet Tezgahı",
          "pl": "Stół narzędziowy",
          "ru": "Стол для инструментов",
          "uk": "Стіл для інструментів",
          "ko": "도구 작업대",
          "zh": "工具台",
          "ja": "ツール制作台"
        },
        {
          "id": "StampMillObject",
          "en": "Stamp Mill",
          "fr": "Concasseur à percussions",
          "es": "Molino de pisón",
          "de": "Pochwerk",
          "pt": "Moinho de carimbo",
          "it": "Mulino a Stampo",
          "tr": "Maden Değirmeni",
          "pl": "Kruszarka",
          "ru": "Штамповочная мельница",
          "uk": "Штамповий млин",
          "ko": "쇄광기",
          "zh": "捣矿机",
          "ja": "砕鉱機"
        },
        {
          "id": "SensorBasedBeltSorterObject",
          "en": "Sensor Based Belt Sorter",
          "fr": "Rampe de tri à détecteurs",
          "es": "Cinta organizadora con sensores",
          "de": "Sensorenbasierter Gürtelsortierer",
          "pt": "Classificador com correia baseado em sensor",
          "it": "Selezionatore A Nastro Basata sul Sensore",
          "tr": "Sensörlere Dayalı Kemer Sınıflandırıcı",
          "pl": "Sorter taśmowy oparty na czujnikach",
          "ru": "Сенсорный конвейерный сортировщик",
          "uk": "Сенсорний сортувальник конвеєрної лінії",
          "ko": "감지기 기반 자동 분류기",
          "zh": "基于传感器的皮带分拣机",
          "ja": "センサー式ベルト選別機"
        },
        {
          "id": "ScreeningMachineObject",
          "en": "Screening Machine",
          "fr": "Machine de criblage",
          "es": "Máquina de escaneo",
          "de": "Siebmaschine",
          "pt": "Máquina de peneiramento",
          "it": "Vaglio Meccanico",
          "tr": "Elek Makinesi",
          "pl": "Maszyna do Przesiewania",
          "ru": "Вибрационный сортировщик",
          "uk": "Просіювальна машина",
          "ko": "건식 정광 기계",
          "zh": "筛选机",
          "ja": "選別機"
        },
        {
          "id": "RockerBoxObject",
          "en": "Rocker Box",
          "fr": "Rampe de lavage",
          "es": "Caja de balancines",
          "de": "Bergbau-Waschtisch",
          "pt": "Caixa de garimpo",
          "it": "Scatola Bilanciere",
          "tr": "Rocker Kutusu",
          "pl": "Sito kołyskowe",
          "ru": "Вашгерд",
          "uk": "Накопичувач руди",
          "ko": "로커 박스",
          "zh": "摇臂箱",
          "ja": "ロッカーボックス"
        },
        {
          "id": "JawCrusherObject",
          "en": "Jaw Crusher",
          "fr": "Concasseur à mâchoires",
          "es": "Trituradora",
          "de": "Kieferbrecher",
          "pt": "Britador de mandíbulas",
          "it": "Frantoio a Mascelle",
          "tr": "Çeneli Konkasör",
          "pl": "Kruszarka szczękowa",
          "ru": "Щековая дробилка",
          "uk": "Щокова дробарка",
          "ko": "암석 파쇄기",
          "zh": "颚式破碎机",
          "ja": "破砕機"
        },
        {
          "id": "FrothFloatationCellObject",
          "en": "Froth Floatation Cell",
          "fr": "Cellule de flottation",
          "es": "Celda de espuma flotante",
          "de": "Schaumschwimmzelle",
          "pt": "Célula de flotação de espuma",
          "it": "Cella di Flottazione della Schiuma",
          "tr": "Köpük Yüzdürme Hücresi",
          "pl": "Pianka pływacka",
          "ru": "Флотатор",
          "uk": "Флотатор",
          "ko": "거품 부유 분별기",
          "zh": "泡沫浮选池",
          "ja": "泡沫浮選機"
        },
        {
          "id": "ArrastraObject",
          "en": "Arrastra",
          "fr": "Concasseur à meules",
          "es": "Arrastra",
          "de": "Bergbau-Pochmühle",
          "pt": "Arrastra",
          "it": "Arrastra",
          "tr": "Arrastra",
          "pl": "Kamienny młyn",
          "ru": "Аррастра",
          "uk": "Аррастра",
          "ko": "돌 맷돌",
          "zh": "碎金研磨机",
          "ja": "アラストラ"
        },
        {
          "id": "AdvancedMasonryTableObject",
          "en": "Advanced Masonry Table",
          "fr": "Établi de maçonnerie avancé",
          "es": "Mesa de mampostería avanzada",
          "de": "Verbesserter Steinmetztisch",
          "pt": "Mesa de alvenaria avançada",
          "it": "Tavolo da Muratura Avanzato",
          "tr": "Gelişmiş Duvarcılık Masası",
          "pl": "Zaawansowany stół kamieniarski",
          "ru": "Продвинутый верстак каменщика",
          "uk": "Покращенний верстак муляра",
          "ko": "고급 석공 작업대",
          "zh": "高级石工台",
          "ja": "高度な石工作業台"
        },
        {
          "id": "AdvancedCarpentryTableObject",
          "en": "Advanced Carpentry Table",
          "fr": "Établi de menuiserie avancé",
          "es": "Mesa de carpintería avanzada",
          "de": "Verbesserter Schreinerhandwerkstisch",
          "pt": "Mesa de carpintaria avançada",
          "it": "Banco da Carpenteria Avanzato",
          "tr": "Gelişmiş Marangoz Masası",
          "pl": "Zaawansowany stół stolarski",
          "ru": "Продвинутый верстак плотника",
          "uk": "Розширений теслярський стіл",
          "ko": "고급 목공 작업대",
          "zh": "高级木工桌",
          "ja": "高度な木工作業台"
        },
        {
          "id": "SpinMelterObject",
          "en": "Spin Melter",
          "fr": "Extrudeuse",
          "es": "Torno de fusión",
          "de": "Schmelzschleuderer",
          "pt": "Máquina de fiação",
          "it": "Tornio A Fusione",
          "tr": "Spin Melter",
          "pl": "Spin Melter",
          "ru": "Прядильная машина",
          "uk": "Spin Melter",
          "ko": "용융 방사기",
          "zh": "旋转熔炉",
          "ja": "Spin Melter"
        },
        {
          "id": "PrintingPressObject",
          "en": "Printing Press",
          "fr": "Presse à imprimer",
          "es": "Imprenta",
          "de": "Druckerpresse",
          "pt": "Máquina de Impressão",
          "it": "Stampante",
          "tr": "Printing Press",
          "pl": "Printing Press",
          "ru": "Печатный станок",
          "uk": "Printing Press",
          "ko": "인쇄기",
          "zh": "印刷机",
          "ja": "Printing Press"
        },
        {
          "id": "LoomObject",
          "en": "Loom",
          "fr": "Métier à tisser",
          "es": "Telar",
          "de": "Webstuhl",
          "pt": "Tear",
          "it": "Telaio",
          "tr": "Loom",
          "pl": "Krosno tkackie",
          "ru": "Ткацкий станок",
          "uk": "Loom",
          "ko": "직조기",
          "zh": "织布机",
          "ja": "織機"
        },
        {
          "id": "InjectionMoldMachineObject",
          "en": "Injection Mold Machine",
          "fr": "Presse à injection",
          "es": "Máquina de moldeo por inyección",
          "de": "Spritzgußmaschine",
          "pt": "Máquina de Moldagem por Injeção",
          "it": "Macchina di Iniezione Muffa",
          "tr": "Injection Mold Machine",
          "pl": "Injection Mold Machine",
          "ru": "Термопластавтомат",
          "uk": "Injection Mold Machine",
          "ko": "사출 금형 기계",
          "zh": "模具注塑机",
          "ja": "Injection Mold Machine"
        },
        {
          "id": "AutomaticLoomObject",
          "en": "Automatic Loom",
          "fr": "Métier à tisser automatique",
          "es": "Telar mecánico",
          "de": "Automatischer Webstuhl",
          "pt": "Tear automático",
          "it": "Impilatore Automatico",
          "tr": "Automatic Loom",
          "pl": "Zautomatyzowane Krosno tkackie",
          "ru": "Автоматический ткацкий станок",
          "uk": "Automatic Loom",
          "ko": "자동 직조기",
          "zh": "自动织布机",
          "ja": "自動織機"
        },
        {
          "id": "AdvancedTailoringTableObject",
          "en": "Advanced Tailoring Table",
          "fr": "Établi de couture avancé",
          "es": "Mesa de sastrería avanzada",
          "de": "Verbesserter Schneidertisch",
          "pt": "Mesa de alfaiataria avançada",
          "it": "Banco di Sartoria Avanzato",
          "tr": "Advanced Tailoring Table",
          "pl": "Zaawansowany stół krawiecki",
          "ru": "Продвинутый Стол Портного",
          "uk": "Advanced Tailoring Table",
          "ko": "고급 재단 작업대",
          "zh": "高级裁缝台",
          "ja": "Advanced Tailoring Table"
        },
        {
          "id": "PotteryTableObject",
          "en": "Pottery Table",
          "fr": "Table de poterie",
          "es": "Mesa del té",
          "de": "Töpfertisch",
          "pt": "Mesa de Cerâmica",
          "it": "Tavolo in Ceramica",
          "tr": "Pottery Table",
          "pl": "Stół garncarski",
          "ru": "Гончарный круг",
          "uk": "Pottery Table",
          "ko": "도자기 테이블",
          "zh": "制陶工作台",
          "ja": "Pottery Table"
        },
        {
          "id": "FiberScutchingStationObject",
          "en": "Fiber Scutching Station",
          "fr": "Établi de teillage de fibres",
          "es": "Estación de espaldillado de fibras",
          "de": "Flachsschwinge",
          "pt": "Estação de corte de fibra",
          "it": "Stazione di gramolatura delle fibre",
          "tr": "Fiber Scutching Station",
          "pl": "Fiber Scutching Station",
          "ru": "Прядильный станок",
          "uk": "Fiber Scutching Station",
          "ko": "섬유 타면기",
          "zh": "纤维脱胶台",
          "ja": "Fiber Scutching Station"
        },
        {
          "id": "GlassworksObject",
          "en": "Glassworks",
          "fr": "Fourneau de verrerie",
          "es": "Materiales de vidrio",
          "de": "Glasfabrik",
          "pt": "Forno de vidro",
          "it": "Vetreria",
          "tr": "Glassworks",
          "pl": "Glassworks",
          "ru": "Стекольная мастерская",
          "uk": "Glassworks",
          "ko": "유리 제작용 가마",
          "zh": "Glassworks",
          "ja": "Glassworks"
        },
        {
          "id": "MediumShipyardObject",
          "en": "Medium Shipyard",
          "fr": "Chantier naval de taille moyenne",
          "es": "Astillero mediano",
          "de": "Mittelgroße Werft",
          "pt": "Medium Shipyard",
          "it": "Cantiere navale medio",
          "tr": "Medium Shipyard",
          "pl": "Średnia Stocznia",
          "ru": "Средняя Верфь",
          "uk": "Середня корабельня",
          "ko": "중형 조선소",
          "zh": "中型船坞",
          "ja": "Medium Shipyard"
        },
        {
          "id": "FishRackObject",
          "en": "Fish Rack",
          "fr": "Séchoir à poissons",
          "es": "Fish Rack",
          "de": "Fischregal",
          "pt": "Fish Rack",
          "it": "Scaffale per pesci",
          "tr": "Fish Rack",
          "pl": "Fish Rack",
          "ru": "Стойка для рыбы",
          "uk": "Рибна стійка",
          "ko": "건조용 생선 걸개",
          "zh": "Fish Rack",
          "ja": "Fish Rack"
        },
        {
          "id": "SmallPaperMachineObject",
          "en": "Small Paper Machine",
          "fr": "Petite machine à papier",
          "es": "Small Paper Machine",
          "de": "Kleine Papiermaschine",
          "pt": "Small Paper Machine",
          "it": "Piccola macchina per la carta",
          "tr": "Small Paper Machine",
          "pl": "Mała maszyna do papieru",
          "ru": "Маленькая бумагоделательная машина",
          "uk": "Small Paper Machine",
          "ko": "소형 제지 기계",
          "zh": "Small Paper Machine",
          "ja": "Small Paper Machine"
        },
        {
          "id": "SmallShipyardObject",
          "en": "Small Shipyard",
          "fr": "Petit chantier naval",
          "es": "Astillero pequeño",
          "de": "Kleine Werft",
          "pt": "Small Shipyard",
          "it": "Piccolo cantiere",
          "tr": "Small Shipyard",
          "pl": "Mała stocznia",
          "ru": "Маленькая верфь",
          "uk": "Мала корабельня",
          "ko": "소형 조선소",
          "zh": "小型船坞",
          "ja": "Small Shipyard"
        },
        {
          "id": "SettlementCraftingTableObject",
          "en": "Settlement Crafting Table",
          "fr": "Établi de la colonie",
          "es": "Settlement Crafting Table",
          "de": "Settlement Crafting Table",
          "pt": "Settlement Crafting Table",
          "it": "Banco da lavoro dell\u0027insediamento",
          "tr": "Settlement Crafting Table",
          "pl": "Settlement Crafting Table",
          "ru": "Стол создания поселения",
          "uk": "Settlement Crafting Table",
          "ko": "Settlement Crafting Table",
          "zh": "定居点工作台",
          "ja": "Settlement Crafting Table"
        },
        {
          "id": "BlacksmithTableObject",
          "en": "Blacksmith Table",
          "fr": "Établi de forgeron",
          "es": "Blacksmith Table",
          "de": "Blacksmith Table",
          "pt": "Blacksmith Table",
          "it": "Blacksmith Table",
          "tr": "Blacksmith Table",
          "pl": "Blacksmith Table",
          "ru": "Кузнечный стол",
          "uk": "Blacksmith Table",
          "ko": "Blacksmith Table",
          "zh": "Blacksmith Table",
          "ja": "Blacksmith Table"
        },
        {
          "id": "ExtruderObject",
          "en": "Extruder",
          "fr": "Extrudeur",
          "es": "Extruder",
          "de": "Extruder",
          "pt": "Extruder",
          "it": "Extruder",
          "tr": "Extruder",
          "pl": "Extruder",
          "ru": "Extruder",
          "uk": "Extruder",
          "ko": "Extruder",
          "zh": "Extruder",
          "ja": "Extruder"
        },
        {
          "id": "FletchingTableObject",
          "en": "Fletching Table",
          "fr": "Établi d\u0027empennage",
          "es": "Fletching Table",
          "de": "Fletching Table",
          "pt": "Fletching Table",
          "it": "Fletching Table",
          "tr": "Fletching Table",
          "pl": "Fletching Table",
          "ru": "Fletching Table",
          "uk": "Fletching Table",
          "ko": "Fletching Table",
          "zh": "Fletching Table",
          "ja": "Fletching Table"
        },
        {
          "id": "GrindstoneObject",
          "en": "Grindstone",
          "fr": "Meule d\u0027affûtage",
          "es": "Grindstone",
          "de": "Grindstone",
          "pt": "Grindstone",
          "it": "Grindstone",
          "tr": "Grindstone",
          "pl": "Grindstone",
          "ru": "Grindstone",
          "uk": "Grindstone",
          "ko": "Grindstone",
          "zh": "Grindstone",
          "ja": "Grindstone"
        },
        {
          "id": "PowerHammerObject",
          "en": "Power Hammer",
          "fr": "Marteau-pilon",
          "es": "Power Hammer",
          "de": "Power Hammer",
          "pt": "Power Hammer",
          "it": "Power Hammer",
          "tr": "Power Hammer",
          "pl": "Power Hammer",
          "ru": "Power Hammer",
          "uk": "Power Hammer",
          "ko": "Power Hammer",
          "zh": "Power Hammer",
          "ja": "Power Hammer"
        }
      ]
    },
    {
      "type": "upgrades",
      "entries": [
        {
          "id": "ModernUpgrade5",
          "en": "Modern Upgrade 5",
          "fr": "Amélioration moderne nv. 5",
          "es": "Mejora moderna 5",
          "de": "Modernes Upgrade 5",
          "pt": "Melhoria Moderna 5",
          "it": "Aggiornamento Moderno 5",
          "tr": "Modern Geliştirme 5",
          "pl": "Nowoczesne ulepszenie 5",
          "ru": "Современное улучшение 5",
          "uk": "Новітнє покращення 5",
          "ko": "현대식 업그레이드 5",
          "zh": "现代升级5",
          "ja": "近代アップグレード5"
        },
        {
          "id": "ModernUpgrade4",
          "en": "Modern Upgrade 4",
          "fr": "Amélioration moderne nv. 4",
          "es": "Mejora moderna 4",
          "de": "Modernes Upgrade 4",
          "pt": "Melhoria Moderna 4",
          "it": "Aggiornamento Moderno 4",
          "tr": "Modern Geliştirme 4",
          "pl": "Nowoczesne ulepszenie 4",
          "ru": "Современное улучшение 4",
          "uk": "Новітнє покращення 4",
          "ko": "현대식 업그레이드 4",
          "zh": "现代升级4",
          "ja": "近代アップグレード4"
        },
        {
          "id": "ModernUpgrade3",
          "en": "Modern Upgrade 3",
          "fr": "Amélioration moderne nv. 3",
          "es": "Mejora moderna 3",
          "de": "Modernes Upgrade 3",
          "pt": "Melhoria Moderna 3",
          "it": "Aggiornamento Moderno 3",
          "tr": "Modern Geliştirme 3",
          "pl": "Nowoczesne ulepszenie 3",
          "ru": "Современное улучшение 3",
          "uk": "Новітнє покращення 3",
          "ko": "현대식 업그레이드 3",
          "zh": "现代升级3",
          "ja": "近代アップグレード3"
        },
        {
          "id": "ModernUpgrade2",
          "en": "Modern Upgrade 2",
          "fr": "Amélioration moderne nv. 2",
          "es": "Mejora moderna 2",
          "de": "Modernes Upgrade 2",
          "pt": "Melhoria Moderna 2",
          "it": "Aggiornamento Moderno 2",
          "tr": "Modern Geliştirme 2",
          "pl": "Nowoczesne ulepszenie 2",
          "ru": "Современное улучшение 2",
          "uk": "Новітнє покращення 2",
          "ko": "현대식 업그레이드 2",
          "zh": "现代升级2",
          "ja": "近代アップグレード2"
        },
        {
          "id": "ModernUpgrade1",
          "en": "Modern Upgrade 1",
          "fr": "Amélioration moderne nv. 1",
          "es": "Mejora moderna 1",
          "de": "Modernes Upgrade 1",
          "pt": "Melhoria Moderna 1",
          "it": "Aggiornamento Moderno 1",
          "tr": "Modern Geliştirme 1",
          "pl": "Nowoczesne ulepszenie 1",
          "ru": "Современное улучшение 1",
          "uk": "Новітнє покращення 1",
          "ko": "현대식 업그레이드 1",
          "zh": "现代升级1",
          "ja": "近代アップグレード1"
        },
        {
          "id": "BasicUpgrade5",
          "en": "Basic Upgrade 5",
          "fr": "Amélioration basique nv. 5",
          "es": "Mejora básica 5",
          "de": "Grundlegendes Upgrade 5",
          "pt": "Melhoria Básica 5",
          "it": "Aggiornamento Base 5",
          "tr": "Temel Geliştirme 5",
          "pl": "Podstawowe ulepszenie 5",
          "ru": "Базовое улучшение 5",
          "uk": "Базове покращення 5",
          "ko": "기초 업그레이드 5",
          "zh": "基础升级5",
          "ja": "基礎アップグレード5"
        },
        {
          "id": "BasicUpgrade4",
          "en": "Basic Upgrade 4",
          "fr": "Amélioration basique nv. 4",
          "es": "Mejora básica 4",
          "de": "Grundlegendes Upgrade 4",
          "pt": "Melhoria Básica 4",
          "it": "Aggiornamento Base 4",
          "tr": "Temel Geliştirme 4",
          "pl": "Podstawowe ulepszenie 4",
          "ru": "Базовое улучшение 4",
          "uk": "Базове покращення 4",
          "ko": "기초 업그레이드 4",
          "zh": "基础升级4",
          "ja": "基礎アップグレード4"
        },
        {
          "id": "BasicUpgrade3",
          "en": "Basic Upgrade 3",
          "fr": "Amélioration basique nv. 3",
          "es": "Mejora básica 3",
          "de": "Grundlegendes Upgrade 3",
          "pt": "Melhoria Básica 3",
          "it": "Aggiornamento Base 3",
          "tr": "Temel Geliştirme 3",
          "pl": "Podstawowe ulepszenie 3",
          "ru": "Базовое улучшение 3",
          "uk": "Базове покращення 3",
          "ko": "기초 업그레이드 3",
          "zh": "基础升级3",
          "ja": "基礎アップグレード3"
        },
        {
          "id": "BasicUpgrade2",
          "en": "Basic Upgrade 2",
          "fr": "Amélioration basique nv. 2",
          "es": "Mejora básica 2",
          "de": "Grundlegendes Upgrade 2",
          "pt": "Melhoria Básica 2",
          "it": "Aggiornamento Base 2",
          "tr": "Temel Geliştirme 2",
          "pl": "Podstawowe ulepszenie 2",
          "ru": "Базовое улучшение 2",
          "uk": "Базове покращення 2",
          "ko": "기초 업그레이드 2",
          "zh": "基础升级2",
          "ja": "基礎アップグレード2"
        },
        {
          "id": "BasicUpgrade1",
          "en": "Basic Upgrade 1",
          "fr": "Amélioration basique nv. 1",
          "es": "Mejora básica 1",
          "de": "Grundlegendes Upgrade 1",
          "pt": "Melhoria Básica 1",
          "it": "Aggiornamento Base 1",
          "tr": "Temel Geliştirme 1",
          "pl": "Podstawowe ulepszenie 1",
          "ru": "Базовое улучшение 1",
          "uk": "Базове покращення 1",
          "ko": "기초 업그레이드 1",
          "zh": "基础升级1",
          "ja": "基礎アップグレード1"
        },
        {
          "id": "AdvancedUpgrade5",
          "en": "Advanced Upgrade 5",
          "fr": "Amélioration avancée nv. 5",
          "es": "Mejora avanzada 5",
          "de": "Fortschrittliches Upgrade 5",
          "pt": "Melhoria Avançada 5",
          "it": "Aggiornamento Avanzato 5",
          "tr": "İleri Seviye Geliştirme 5",
          "pl": "Zaawansowane ulepszenie 5",
          "ru": "Продвинутое улучшение 5",
          "uk": "Просунуте покращення 5",
          "ko": "고급 업그레이드 5",
          "zh": "高级升级5",
          "ja": "Advanced Upgrade 5"
        },
        {
          "id": "AdvancedUpgrade4",
          "en": "Advanced Upgrade 4",
          "fr": "Amélioration avancée nv. 4",
          "es": "Mejora avanzada 4",
          "de": "Fortschrittliches Upgrade 4",
          "pt": "Melhoria Avançada 4",
          "it": "Aggiornamento Avanzato 4",
          "tr": "İleri Seviye Geliştirme 4",
          "pl": "Zaawansowane ulepszenie 4",
          "ru": "Продвинутое улучшение 4",
          "uk": "Просунуте покращення 4",
          "ko": "고급 업그레이드 4",
          "zh": "高级升级4",
          "ja": "Advanced Upgrade 4"
        },
        {
          "id": "AdvancedUpgrade3",
          "en": "Advanced Upgrade 3",
          "fr": "Amélioration avancée nv. 3",
          "es": "Mejora avanzada 3",
          "de": "Fortschrittliches Upgrade 3",
          "pt": "Melhoria Avançada 3",
          "it": "Aggiornamento Avanzato 3",
          "tr": "İleri Seviye Geliştirme 3",
          "pl": "Zaawansowane ulepszenie 3",
          "ru": "Продвинутое улучшение 3",
          "uk": "Просунуте покращення 3",
          "ko": "고급 업그레이드 3",
          "zh": "高级升级3",
          "ja": "Advanced Upgrade 3"
        },
        {
          "id": "AdvancedUpgrade2",
          "en": "Advanced Upgrade 2",
          "fr": "Amélioration avancée nv. 2",
          "es": "Mejora avanzada 2",
          "de": "Fortschrittliches Upgrade 2",
          "pt": "Melhoria Avançada 2",
          "it": "Aggiornamento Avanzato 2",
          "tr": "İleri Seviye Geliştirme 2",
          "pl": "Zaawansowane ulepszenie 2",
          "ru": "Продвинутое улучшение 2",
          "uk": "Просунуте покращення 2",
          "ko": "고급 업그레이드 2",
          "zh": "高级升级2",
          "ja": "Advanced Upgrade 2"
        },
        {
          "id": "AdvancedUpgrade1",
          "en": "Advanced Upgrade 1",
          "fr": "Amélioration avancée nv. 1",
          "es": "Mejora avanzada 1",
          "de": "Fortschrittliches Upgrade 1",
          "pt": "Melhoria Avançada 1",
          "it": "Aggiornamento Avanzato 1",
          "tr": "İleri Seviye Geliştirme 1",
          "pl": "Zaawansowane ulepszenie 1",
          "ru": "Продвинутое улучшение 1",
          "uk": "Просунуте покращення 1",
          "ko": "고급 업그레이드 1",
          "zh": "高级升级1",
          "ja": "Advanced Upgrade 1"
        }
      ]
    }
  ];
